function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;
    /******/
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/exports: {},
      /******/id: moduleId,
      /******/loaded: false
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.loaded = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(0);
  /******/
}
/************************************************************************/
/******/([/* 0 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Action = undefined;
  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _debug = __webpack_require__(1);
  var _debug2 = _interopRequireDefault(_debug);
  var _bluebird = __webpack_require__(5);
  var _bluebird2 = _interopRequireDefault(_bluebird);
  var _IFrame = __webpack_require__(43);
  var _IFrame2 = _interopRequireDefault(_IFrame);
  var _underscore = __webpack_require__(178);
  var _events = __webpack_require__(44);
  var _events2 = _interopRequireDefault(_events);
  var _TwoWayTreeMirror = __webpack_require__(179);
  var _TwoWayTreeMirror2 = _interopRequireDefault(_TwoWayTreeMirror);
  var _AssetProxy = __webpack_require__(184);
  var _AssetProxy2 = _interopRequireDefault(_AssetProxy);
  var _uuid = __webpack_require__(248);
  var _uuid2 = _interopRequireDefault(_uuid);
  var _replayBrowserEvents = __webpack_require__(45);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new _bluebird2.default(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            return _bluebird2.default.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }
        return step("next");
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var debug = (0, _debug2.default)('ssb:ServerBrowserApi');
  var listenerSymbol = Symbol('listener-installed');
  var devtoolsPath = 'http://s3.amazonaws.com/chromium-remote-devtools-frontend/front_end/inspector.html?window-message=1';

  /**
   * Class representing a real time interface to the Server Side Browser
   */

  var ServerBrowserApi = function (_EventEmitter) {
    _inherits(ServerBrowserApi, _EventEmitter);

    /**
     * Create an instance of ServerSideBrowser
     * @param {HTMLIFrameElement} frame - A reference to an iframe in which the server side browser will be mirrored into.
     * @param {String} serverUrl - The WebSocket url to connect to
     * @param {Object} [options]
     * @param {Number} [options.activityTimeout] - The browser will disconnect after activityTimeout ms have passed without a message being sent. -1 will disable the timeout.
     */
    function ServerBrowserApi(frame) {
      var serverUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ws://localhost:8081/';
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, ServerBrowserApi);
      var _this = _possibleConstructorReturn(this, (ServerBrowserApi.__proto__ || Object.getPrototypeOf(ServerBrowserApi)).call(this));
      _this.sendQueueTail = _bluebird2.default.resolve();
      _this.messageCallbacks = {};
      _this.RECONNECT_TIMEOUT = 15000;
      _this.captchaSupport = options.captcha;
      var privateSession = options.privateSession,
        virtualBrowserId = options.virtualBrowserId,
        activityTimeout = options.activityTimeout,
        _apikey = options._apikey,
        proxyType = options.proxyType,
        country = options.country;

      // These are the keys from "options" which will be used as query params, for now all are being used.

      var queryParams = {
        privateSession: privateSession,
        virtualBrowserId: virtualBrowserId,
        activityTimeout: activityTimeout,
        _apikey: _apikey,
        proxyType: proxyType,
        country: country,
        captchaSupport: options.captcha
      };
      var queryString = [];
      Object.entries(queryParams).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var addToQueryString = false;
        if (value) {
          addToQueryString = true;
          if (key === 'privateSession') {
            key = 'private';
            value = '1';
          }
        }
        if (addToQueryString) {
          var prefix = queryString.length > 0 || serverUrl.includes('?') ? '&' : '?';
          queryString.push('' + prefix + key + '=' + value);
        }
      });
      if (queryString.length) {
        serverUrl += queryString.join('');
      }
      _this.serverUrl = serverUrl;
      _this.iframe = new _IFrame2.default(frame);
      _this.iframe.on('resize', (0, _underscore.debounce)(function (_ref3) {
        var scrollWidth = _ref3.scrollWidth,
          scrollHeight = _ref3.scrollHeight;
        _this.queuedSend({
          method: 'viewport',
          params: [scrollWidth, scrollHeight]
        });
      }, _this.constructor.DEBOUNCE_WAIT));
      _this.iframe.on('scroll', (0, _underscore.debounce)(function (_ref4) {
        var scrollX = _ref4.scrollX,
          scrollY = _ref4.scrollY;
        _this.send({
          method: 'scrollTo',
          params: [scrollY, scrollX]
        });
      }, _this.constructor.DEBOUNCE_WAIT));
      _this.assetProxy = new _AssetProxy2.default(_this.iframe, _this);
      _this.assetProxy.on('asset-proxying-counter', function (val) {
        return _this.emit('asset-proxying-counter', val);
      });
      _this.connect(serverUrl);
      _this.recordInitiated = false;
      _this.record();
      return _this;
    }
    /**
     * Make the WebSocket connection to the server and listen for messages
     * @param {String} serverUrl - The WebSocket url to connect to
     */

    _createClass(ServerBrowserApi, [{
      key: 'connect',
      value: function connect() {
        var _this2 = this;
        var serverUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.serverUrl;
        if (this.ws) {
          this.disconnect();
        }
        this.treeMirror = null;
        this.subFrames = {};
        this.ws = new WebSocket(serverUrl);
        this.waitingForSlotTimeoutId = setTimeout(function () {
          _this2.reconnect();
        }, this.RECONNECT_TIMEOUT);
        this.ws.onopen = function (ev) {
          return _this2.emit('open', ev);
        };
        this.ws.onclose = this.handleCloseMessage.bind(this);
        this.ws.onmessage = function (ev) {
          return _this2.onmessage(JSON.parse(ev.data));
        };
        this.networkLogs = {};
      }

      /**
       * Disconnect the from the ServerSideBrowser
       */
    }, {
      key: 'disconnect',
      value: function disconnect() {
        if (this.ws) {
          this.ws.close();
        }
      }
    }, {
      key: 'clearSlotTimeout',
      value: function clearSlotTimeout() {
        clearTimeout(this.waitingForSlotTimeoutId);
        this.waitingForSlotTimeoutId = undefined;
      }

      /**
       * Navigate to the given url
       * @param   {String} url - The url to go to
       * @returns {Promise}      Resolves if the page was successfully obtained, or rejects with error details if it wasn't.
       */
    }, {
      key: 'goto',
      value: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
          var _this3 = this;
          var actionList, data;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  actionList = [{
                    actionId: (0, _uuid2.default)(),
                    action: new _replayBrowserEvents.actions.GotoAction(null, {
                      url: url,
                      css_enabled: true,
                      load_all_resources: true,
                      images_enabled: true
                    })
                  }, {
                    actionId: (0, _uuid2.default)(),
                    action: new _replayBrowserEvents.actions.ViewportAction(null, this.iframe.iframe.scrollWidth, this.iframe.iframe.scrollHeight)
                  }, {
                    actionId: (0, _uuid2.default)(),
                    action: new _replayBrowserEvents.actions.WaitLoadingAction()
                  }];
                  _context.prev = 1;
                  this.iframe.url = url;
                  actionList.forEach(function (_ref6) {
                    var action = _ref6.action,
                      actionId = _ref6.actionId;
                    return _this3.emit('new-control-action-initiated', action, actionId);
                  });
                  data = [{
                    method: 'playAction',
                    params: [actionList[0].action]
                  }, {
                    method: 'viewport',
                    params: [this.iframe.iframe.scrollWidth, this.iframe.iframe.scrollHeight]
                  }];
                  _context.next = 7;
                  return this.queuedSend(data);
                case 7:
                  this.controlActions.push(actionList[2].action);
                  actionList.forEach(function (_ref7) {
                    var action = _ref7.action,
                      actionId = _ref7.actionId;
                    return _this3.emit('new-control-action', action, actionId);
                  });
                  this.shouldHandleDidNavigate = true;
                  this.emit('initial-load-complete');
                  _context.next = 18;
                  break;
                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](1);
                  this.emit('initial-load-failed');
                  actionList.forEach(function (_ref8) {
                    var action = _ref8.action,
                      actionId = _ref8.actionId;
                    return _this3.emit('new-control-action-failed', action, actionId);
                  });
                  throw _context.t0;
                case 18:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 13]]);
        }));
        function goto(_x4) {
          return _ref5.apply(this, arguments);
        }
        return goto;
      }()
    }, {
      key: 'getDataForPage',
      value: function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
          var resource;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return this.renderUrl(options);
                case 3:
                  resource = _context2.sent;
                  return _context2.abrupt('return', resource);
                case 7:
                  _context2.prev = 7;
                  _context2.t0 = _context2['catch'](0);
                  throw _context2.t0;
                case 10:
                  _context2.prev = 10;
                  _context2.next = 13;
                  return this.disconnectAfterAssetsFinishes();
                case 13:
                  return _context2.finish(10);
                case 14:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[0, 7, 10, 14]]);
        }));
        function getDataForPage(_x5) {
          return _ref9.apply(this, arguments);
        }
        return getDataForPage;
      }()
    }, {
      key: 'disconnectAfterAssetsFinishes',
      value: function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var _this4 = this;
          var disconnectTimeout, disconnect, disconnectHandler;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  disconnectTimeout = null;
                  disconnect = function disconnect() {
                    _this4.disconnect();
                    _this4.removeListener('asset-proxying-counter', disconnectHandler);
                  };
                  disconnectHandler = function disconnectHandler(val) {
                    if (disconnectTimeout) {
                      clearTimeout(disconnectTimeout);
                      disconnectTimeout = null;
                    }
                    if (val === 0) {
                      disconnectTimeout = setTimeout(disconnect, 2000);
                    }
                  };
                  this.on('asset-proxying-counter', disconnectHandler);
                  disconnectTimeout = setTimeout(disconnect, 2000);
                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function disconnectAfterAssetsFinishes() {
          return _ref10.apply(this, arguments);
        }
        return disconnectAfterAssetsFinishes;
      }()
    }, {
      key: 'renderUrl',
      value: function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
          var _options$replaceAsset, replaceAssets, rest, rendered, html;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _options$replaceAsset = options.replaceAssets, replaceAssets = _options$replaceAsset === undefined ? false : _options$replaceAsset, rest = _objectWithoutProperties(options, ['replaceAssets']);
                  _context4.next = 4;
                  return this.render(rest);
                case 4:
                  rendered = _context4.sent;
                  this.emit('initial-load-complete', rendered);
                  _context4.next = 8;
                  return this.getHtml({
                    replaceAssets: replaceAssets
                  });
                case 8:
                  html = _context4.sent;
                  return _context4.abrupt('return', {
                    url: rendered.url,
                    statusCode: rendered.statusCode,
                    timestamp: Date.now(),
                    resourceId: rendered.tracerId,
                    html: html,
                    content: html
                  });
                case 12:
                  _context4.prev = 12;
                  _context4.t0 = _context4['catch'](0);
                  this.emit('initial-load-failed');
                  throw _context4.t0;
                case 16:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[0, 12]]);
        }));
        function renderUrl(_x6) {
          return _ref11.apply(this, arguments);
        }
        return renderUrl;
      }()

      /**
       * use http_api logic to render the page. Will return a promise that resolves if request was successful, or rejects with error if not.
       * @param {String|Object} url|params same as http_api endpoint
       * @returns {Promise}      Resolves if the page was successfully obtained, or rejects with error details if it wasn't.
       */
    }, {
      key: 'render',
      value: function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (typeof options === 'string') {
                    options = {
                      url: options
                    };
                  }
                  return _context5.abrupt('return', this.queuedSend({
                    method: 'render',
                    params: [options]
                  }));
                case 2:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function render(_x7) {
          return _ref12.apply(this, arguments);
        }
        return render;
      }()

      /**
       * Send a command to suggest data from the currently rendered page.
       */
    }, {
      key: 'suggestData',
      value: function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt('return', this.queuedSend({
                    method: 'suggestData'
                  }));
                case 1:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function suggestData() {
          return _ref13.apply(this, arguments);
        }
        return suggestData;
      }()

      /**
       * Send a refresh command to the server side browser
       * @returns {Promise}      Resolves if the page was successfully obtained, or rejects with error details if it wasn't.
       */
    }, {
      key: 'refresh',
      value: function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt('return', this.queuedSend({
                    method: 'refresh'
                  }));
                case 1:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function refresh() {
          return _ref14.apply(this, arguments);
        }
        return refresh;
      }()

      /**
       * Sends given data to the server side browser and be notifies when a that message recieves a response
       * @param {Object|Array} data - Single Action or multiple Actions that should be executed by server.
       * @return {Promise} return a Promise that resolves if all actions are successful, or rejects if at least one action failed.
       */
    }, {
      key: 'send',
      value: function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
          var _this5 = this;
          var promise;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (this.ws) {
                    _context8.next = 2;
                    break;
                  }
                  return _context8.abrupt('return');
                case 2:
                  if (!(0, _underscore.isArray)(data)) {
                    data = [data];
                  }
                  promise = _bluebird2.default.all(data.map(function (message) {
                    if ((0, _underscore.isUndefined)(message.id)) {
                      message.id = (0, _uuid2.default)();
                    }
                    return new _bluebird2.default(function (resolve, reject) {
                      _this5.messageCallbacks[message.id] = function (message) {
                        message.error ? reject(message.error) : resolve(message.result);
                      };
                    });
                  })).then(function (responses) {
                    return responses.length === 1 ? responses[0] : responses;
                  });
                  this.ws.send(JSON.stringify(data));
                  return _context8.abrupt('return', promise);
                case 6:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function send(_x8) {
          return _ref15.apply(this, arguments);
        }
        return send;
      }()

      /**
       * send(data) but queued
       */
    }, {
      key: 'queuedSend',
      value: function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(data) {
          var _this6 = this;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.abrupt('return', this.sendQueueTail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.prev = 0;
                            _context9.next = 3;
                            return _this6.sendQueueTail;
                          case 3:
                            _context9.next = 7;
                            break;
                          case 5:
                            _context9.prev = 5;
                            _context9.t0 = _context9['catch'](0);
                          case 7:
                            return _context9.abrupt('return', _this6.send(data));
                          case 8:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this6, [[0, 5]]);
                  }))());
                case 1:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
        function queuedSend(_x9) {
          return _ref16.apply(this, arguments);
        }
        return queuedSend;
      }()
    }, {
      key: 'initializeRecorder',
      value: function initializeRecorder() {
        var _this7 = this;
        if (this.recorder) {
          this.recorder.stopRecord();
        }
        this.recorder = new _replayBrowserEvents.BrowserRecorder(this.iframe.document);
        this.recorder.on('newaction', function (action) {
          if (action.replayable) {
            var actionId = (0, _uuid2.default)();
            _this7.emit('new-user-action-initiated', actionId, action);
            _this7.queuedSend({
              id: actionId,
              method: 'playAction',
              // Don't jsonify action before previous action finished
              // previous action may change the className of next action element, which will cause
              // cannot find the element error
              params: [action]
            }).then(function () {
              _this7.emit('new-user-action-finished', actionId, action);
            }).catch(function (error) {
              _this7.emit('new-user-action-failed', actionId, action, error);
            });
          } else {
            var _actionId = (0, _uuid2.default)();
            _this7.controlActions.push(action);
            _this7.emit('new-control-action', action, _actionId);
          }
        });
        this.recorder.recordEvents();
      }

      /**
       * Intializes tree mirror between the server side browser and the iframe
       * @param {IFrame} iframe - the frame tree mirror attached to
       * @param {String} url - The url to be mirrored
       */
    }, {
      key: 'attachTreeMirror',
      value: function attachTreeMirror(iframe, url) {
        var _this8 = this;
        var mainFrame = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        iframe.clearPage();
        iframe.url = url;
        var document = iframe.window.document;
        var treeMirror = new _TwoWayTreeMirror2.default(document, {
          url: url,
          mainFrame: mainFrame,
          captchaSupport: mainFrame && this.captchaSupport,
          addFrameOverlay: iframe.addFrameOverlay,
          deserializeNode: function deserializeNode(nodeData, parent) {
            if (parent && parent.tagName === 'STYLE') {
              _this8.assetProxy.registerStyleElementHandler(parent, nodeData);
            }
          },
          frameAttached: function frameAttached(node, parent) {
            if (!parent) return;
            if (!node.hasAttribute('_ioframeid')) return;
            var frameId = node.getAttribute('_ioframeid');
            if (_this8.subFrames[frameId]) return;
            var frame = new _IFrame2.default(node);
            if (mainFrame) frame.addFrameOverlay = true; // add frame overlay for first level sub frames
            _this8.subFrames[frameId] = frame;
            _this8.emit('frameAttached', {
              frameId: frameId,
              frame: frame
            });
            _this8.emit('frameAttached-' + frameId, {
              frameId: frameId,
              frame: frame
            });
          },
          nodeRemoved: function nodeRemoved(node) {
            if ((node.tagName == 'IFRAME' || node.tagName == 'FRAME') && node.hasAttribute('_ioframeid')) {
              var frameId = node.getAttribute('_ioframeid');
              var frame = _this8.subFrames[frameId];
              if (frame) {
                delete _this8.subFrames[frameId];
              }
            }
          },
          setAttribute: function setAttribute(node, name, value) {
            try {
              node.setAttribute(name, value);
              if (node.tagName === 'IMG' && name === 'src') {
                _this8.assetProxy.registerUrlHandler(node, name, value);
              }
              if (node.tagName === 'LINK' && name === 'href') {
                node.removeAttribute(name);
                setTimeout(function () {
                  var attr = node.getAttribute('rel');
                  if (attr) attr = attr.toLowerCase();
                  if (attr === 'stylesheet') {
                    _this8.assetProxy.registerUrlHandler(node, name, value);
                  } else {
                    node.setAttribute(name, value);
                  }
                }, 0);
              }
              if (name === 'style') {
                _this8.assetProxy.registerStyleAttributeHandler(node, name, value);
              }
            } catch (error) {
              // Some webpages have invlaid markup and could cause setAttribute to fail
              // For example gap.com has class="nav--header_dark" aria-label=Account &amp; Stores
              // Chrome will turn it into aria-label="Account" &amp;="" stores="" but &amp; is not
              // a valid attribute name so we suppress this error to ignore the invalid attributes
            }
            return node;
          }
        });
        if (!document[listenerSymbol]) {
          document[listenerSymbol] = true;
          document.addEventListener('click', function (ev) {
            ev.preventDefault();
          });
        }
        return treeMirror;
      }

      /**
       * Called whenever a message is received on the WebSocket connection
       * @param {Object} message - The message received from the server
       */
    }, {
      key: 'onmessage',
      value: function onmessage(message) {
        this.handleMessage(message);
        if ((0, _underscore.isFunction)(this.messageCallbacks[message.id])) {
          this.messageCallbacks[message.id](message);
          delete this.messageCallbacks[message.id];
        }
      }
    }, {
      key: 'handleMessage',
      value: function handleMessage(message) {
        var type = message.type,
          data = message.data,
          error = message.error,
          ready = message.ready;
        switch (type) {
          case 'output-validation-result':
            return this.handleOutputValidationResult(data);
          case 'website-console-updated':
            return this.handleWebsiteConsoleUpdatedMessage(data);
          case 'memory-updated':
            return this.handleMemoryUpdatedMessage(data);
          case 'virtual-browser-updated':
            return this.handleVirtualBrowserMessage(data);
          case 'tree-mirror':
            return this.handleTreeMirrorMessage(data);
          case 'remote-debug':
            return this.handleRemoteDebugMessage(data);
          case 'network-monitor':
            return this.handleNetworkMonitorMessage(data);
          case 'event':
            debug(type, data.event, message);
            return this.handleEventMessage(data);
          case 'close':
            return this.handleCloseMessage(data, error);
          case 'allow-popup-prompt':
            return this.handlePopupPromptMessage(message);
          default:
            ready && this.handleReadyMessage(message);
        }
      }
    }, {
      key: 'handleOutputValidationResult',
      value: function handleOutputValidationResult(data) {
        if (data && data.errors) {
          this.emit('output-validation-result', data.errors);
        }
      }
    }, {
      key: 'handleWebsiteConsoleUpdatedMessage',
      value: function handleWebsiteConsoleUpdatedMessage(data) {
        if (data && data.args) {
          this.emit('website-console-updated', data.args);
        }
      }
    }, {
      key: 'handleMemoryUpdatedMessage',
      value: function handleMemoryUpdatedMessage(data) {
        if (data && data.memory) {
          this.emit('memory-updated', data.memory);
        }
      }
    }, {
      key: 'handleVirtualBrowserMessage',
      value: function handleVirtualBrowserMessage(data) {
        if (data && data.virtualBrowser) {
          this.emit('virtual-browser-updated', data.virtualBrowser);
        }
      }
    }, {
      key: 'handlePopupPromptMessage',
      value: function handlePopupPromptMessage(message) {
        this.emit('allow-popup-prompt', message.url, message.actionName);
      }
    }, {
      key: 'handleTreeMirrorMessage',
      value: function handleTreeMirrorMessage(data) {
        var _this9 = this;
        var frame = data.frameId ? this.subFrames[data.frameId] : this.iframe;
        if (!frame) {
          debug('WARNING: frame not found', data.frameId);
          return this.once('frameAttached-' + data.frameId, function () {
            return _this9.handleTreeMirrorMessage(data);
          });
        }
        if (data.f === 'initialize') {
          debug('initializeTreeMirror', data.frameId, frame);
          frame.frameId = data.frameId;
          if (!frame.ready) {
            debug('WARNING: frame not ready', data.frameId);
            // return frame.once('ready', () => this.handleTreeMirrorMessage(data));
          }

          frame.treeMirror = this.attachTreeMirror(frame, data.url, !data.frameId); // enable captcha only for main frame
          if (!data.frameId) this.initializeRecorder();
        }
        frame.treeMirror[data.f].apply(frame.treeMirror, data.args);
      }
    }, {
      key: 'handleRemoteDebugMessage',
      value: function handleRemoteDebugMessage(data) {
        if (this.devtools_window) {
          this.devtools_window.postMessage(data, '*');
        }
      }
    }, {
      key: 'handleNetworkMonitorMessage',
      value: function handleNetworkMonitorMessage(data) {
        if (!data.details) {
          return;
        }
        this.networkLogs[data.details.id] = data;
        this.emit('network-monitor', {
          pendingRequests: this.pendingRequests,
          finishedRequests: this.finishedRequests
        });
      }
    }, {
      key: 'handleEventMessage',
      value: function handleEventMessage(data) {
        if (data.event === 'did-navigate') {
          this.networkLogs = {};
        }
        this.emit.apply(this, [data.event].concat(_toConsumableArray(data.args)));
      }
    }, {
      key: 'handleCloseMessage',
      value: function handleCloseMessage(data, error) {
        var _this10 = this;
        this.clearSlotTimeout();

        // Removing all eventhandlers first, to avoid calling this handler twice.
        this.ws.onopen = undefined;
        this.ws.onmessage = undefined;
        this.ws.onclose = undefined;
        this.ws = null;

        // Close devtools if it is open.
        if (this.devtools_window) {
          this.devtools_window.postMessage({
            event: 'close'
          }, '*');
        }

        // Cleanup all pending callbacks
        Object.keys(this.messageCallbacks).forEach(function (key) {
          _this10.messageCallbacks[key]({
            error: {
              code: -1,
              message: 'Server connection got closed.',
              data: data,
              error: error
            }
          });
          delete _this10.messageCallbacks[key];
        });
        this.emit('close', data, error);
      }
    }, {
      key: 'handleReadyMessage',
      value: function handleReadyMessage(message) {
        this.clearSlotTimeout();
        this.waitingForSlotTimeoutId = undefined;
        this.emit('ready', message);
      }

      /**
       * All actions will start to be emitted
       */
    }, {
      key: 'record',
      value: function record() {
        var _this11 = this;
        if (this.recorder) {
          this.recorder.takeRecords();
        }
        this.controlActions = [];
        this.recording = true;
        if (!this.recordInitiated) {
          this.on('new-user-action-finished', function (actionId, action) {
            if (!_this11.recording) {
              return;
            }
            _this11.controlActions.push(action);
            _this11.emit('new-control-action', action, actionId);
          });
          this.on('new-user-action-initiated', function (actionId, action) {
            if (!_this11.recording) {
              return;
            }
            _this11.emit('new-control-action-initiated', action, actionId);
          });
          this.on('new-user-action-failed', function (actionId, action) {
            if (!_this11.recording) {
              return;
            }
            _this11.emit('new-control-action-failed', action, actionId);
          });
          var waitLoadingActionCreator = function waitLoadingActionCreator() {
            if (!_this11.recording || !_this11.shouldHandleDidNavigate) {
              return;
            }
            var lastAction = null;
            if (_this11.controlActions.length && (lastAction = _this11.controlActions[_this11.controlActions.length - 1]) && lastAction.constructor.name === 'WaitLoadingAction') {
              return;
            }
            var action = new _replayBrowserEvents.actions.WaitLoadingAction();
            var actionId = (0, _uuid2.default)();
            _this11.controlActions.push(action);
            _this11.emit('new-control-action', action, actionId);
          };
          this.on('did-navigate', waitLoadingActionCreator);
          this.on('did-navigate-in-page', waitLoadingActionCreator);
          this.recordInitiated = true;
        }
      }

      /**
       * Stop recording and emitting actions
       */
    }, {
      key: 'stopRecord',
      value: function stopRecord() {
        this.recording = false;
        return this.recorder && this.recorder.takeRecords();
      }

      /**
       * Play actions on server side browser
       * @param {Object} action - A single action to be played
       * @param {Object} [input] - The input dict of variables
       * @return {Promise} return a Promise that resolves if all actions are successful, or rejects if at least one action failed.
       */
    }, {
      key: 'play',
      value: function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(action, input, options) {
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (!(0, _underscore.isArray)(_replayBrowserEvents.actions)) {
                    _context11.next = 2;
                    break;
                  }
                  throw new Error('Can only play a single action.');
                case 2:
                  return _context11.abrupt('return', this.send({
                    method: 'playAction',
                    params: [action, input, options]
                  }));
                case 3:
                case 'end':
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
        function play(_x11, _x12, _x13) {
          return _ref18.apply(this, arguments);
        }
        return play;
      }()

      /**
       * Play actions in iframe
       * @param {Array|Object} actions - An array of actions or single action to be played
       * @return {Promise} return a Promise that resolves if all actions are successful, or rejects if at least one action failed.
       */
    }, {
      key: 'playInFrame',
      value: function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(actions) {
          var _this12 = this;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  if (!(0, _underscore.isArray)(actions)) {
                    actions = [actions];
                  }
                  return _context13.abrupt('return', _bluebird2.default.each(actions, function () {
                    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(action) {
                      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                        while (1) {
                          switch (_context12.prev = _context12.next) {
                            case 0:
                              return _context12.abrupt('return', _this12.iframe.play(action));
                            case 1:
                            case 'end':
                              return _context12.stop();
                          }
                        }
                      }, _callee12, _this12);
                    }));
                    return function (_x15) {
                      return _ref20.apply(this, arguments);
                    };
                  }()));
                case 2:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
        function playInFrame(_x14) {
          return _ref19.apply(this, arguments);
        }
        return playInFrame;
      }()

      /**
       * Convert a given list of actions to a JSON string that can be played back as a single FlowControlAction
       * @param {Array} actionList - An array of actions
       */
    }, {
      key: 'actionListToJsonString',
      value: function actionListToJsonString(actionList) {
        return new _replayBrowserEvents.actions.FlowControlAction(this.iframe.document, actionList).toJSON();
      }

      /**
       * Returns a promise that will contain the HTML of the server side browser
       * @returns {Promise} A promise with the HTML value
       */
    }, {
      key: 'getHtml',
      value: function getHtml(options) {
        return this.send({
          method: 'getHTML',
          params: options ? [options] : null
        });
      }

      /**
       * Returns a promise that will contain the data based on the given extractor
       * @param {Object} runtimeConfig The extractor runtime config
       * @returns {Promise} A promise with the data
       */
    }, {
      key: 'extractData',
      value: function extractData(runtimeConfig) {
        var action = new _replayBrowserEvents.actions.ExtractDataAction(null, runtimeConfig);
        return this.play(action);
      }

      /**
       * Returns an ExtractDataAction
       * @returns {actions.ExtractDataAction}
       */
    }, {
      key: 'makeExtractDataAction',
      value: function makeExtractDataAction() {
        var action = new _replayBrowserEvents.actions.ExtractDataAction();
        action.variables.runtimeConfig.variable = true;
        action.variables.runtimeConfig.name = '_runtimeConfig';
        return action;
      }
    }, {
      key: 'makeOpenNextPopupAction',
      value: function makeOpenNextPopupAction() {
        return new _replayBrowserEvents.actions.OpenNextNewWindowInCurrentTabAction();
      }

      /**
       * When we make a WebSocket connection the load balancer connects us to a server and then we wait for a slot on that server.
       * A reconnect will let us try again and hopefully get balanced to a server with an available slot.
       */
    }, {
      key: 'reconnect',
      value: function reconnect() {
        var _this13 = this;
        if (this.ws) {
          this.disconnect();
          this.once('close', function () {
            _this13.connect();
          });
        } else {
          this.connect();
        }
      }

      /**
       * open devtools
       */
    }, {
      key: 'devtools',
      value: function devtools() {
        var _this14 = this;
        if (this.devtools_window && !this.devtools_window.closed) {
          this.devtools_window.close();
          onclose();
        }
        function onclose() {
          // devtools closed
          clearInterval(checkWindowClose);
          this.devtools_window = null;
          window.removeEventListener('message', onmessage);
          this.send({
            method: 'closeDevTools'
          });
        }
        var lastPosition = null;
        var checkWindowClose = setInterval(function () {
          if (_this14.devtools_window) {
            if (_this14.devtools_window.closed) {
              onclose.apply(_this14);
            } else if (window.localStorage) {
              var pos = 'height=' + _this14.devtools_window.innerHeight + ',width=' + _this14.devtools_window.innerWidth + ',left=' + _this14.devtools_window.screenLeft + ',top=' + _this14.devtools_window.screenTop + ',location=false';
              if (pos != lastPosition) {
                localStorage.devtoolsPosition = lastPosition = pos;
              }
            }
          }
        }, 500);
        function onmessage(event) {
          var _this15 = this;
          if (event.data && event.data.type == 'remoteDebugSendCommand') {
            this.send({
              method: 'remoteDebugSendCommand',
              params: [event.data]
            }).then(function (data) {
              return _this15.devtools_window.postMessage(data, '*');
            });
          }
        }
        this.devtools_window = window.open(devtoolsPath, 'devtools', window.localStorage && window.localStorage.devtoolsPosition || 'height=600,width=800,location=false');
        window.addEventListener('beforeunload', function () {
          return _this14.devtools_window.close();
        });
        window.addEventListener('message', onmessage.bind(this));
        this.send({
          method: 'remoteDebug'
        });
      }
    }, {
      key: 'pendingRequests',
      get: function get() {
        return Object.values(this.networkLogs).filter(function (data) {
          return data.event === 'onBeforeRequest';
        }).length;
      }
    }, {
      key: 'finishedRequests',
      get: function get() {
        return Object.values(this.networkLogs).filter(function (data) {
          return data.event !== 'onBeforeRequest';
        }).length;
      }
    }]);
    return ServerBrowserApi;
  }(_events2.default);
  ServerBrowserApi.DEBOUNCE_WAIT = 500;
  exports.default = ServerBrowserApi;
  exports.Action = _replayBrowserEvents.Action;

  /***/
}, /* 1 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    /**
    * This is the web browser implementation of `debug()`.
    *
    * Expose `debug()` as the module.
    */

    exports = module.exports = __webpack_require__(3);
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

    /**
     * Colors.
     */

    exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];

    /**
     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
     * and the Firebug extension (any Firefox version) are known
     * to support "%c" CSS customizations.
     *
     * TODO: add a `localStorage` variable to explicitly enable/disable colors
     */

    function useColors() {
      // NB: In an Electron preload script, document will be defined but not fully
      // initialized. Since we know we're in Chrome, we'll just detect this case
      // explicitly
      if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
        return true;
      }

      // is webkit? http://stackoverflow.com/a/16459606/376773
      // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
      return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
      // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
      // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
      // double check webkit in userAgent just in case we are in a worker
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }

    /**
     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
     */

    exports.formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
      }
    };

    /**
     * Colorize log arguments if enabled.
     *
     * @api public
     */

    function formatArgs(args) {
      var useColors = this.useColors;
      args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
      if (!useColors) return;
      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit');

      // the final "%c" is somewhat tricky, because there could be other
      // arguments passed either before or after the %c, so we need to
      // figure out the correct index to insert the CSS into
      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function (match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) {
          // we only are interested in the *last* %c
          // (the user may have provided their own)
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }

    /**
     * Invokes `console.log()` when available.
     * No-op when `console.log` is not a "function".
     *
     * @api public
     */

    function log() {
      // this hackery is required for IE8/9, where
      // the `console.log` function doesn't have 'apply'
      return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }

    /**
     * Save `namespaces`.
     *
     * @param {String} namespaces
     * @api private
     */

    function save(namespaces) {
      try {
        if (null == namespaces) {
          exports.storage.removeItem('debug');
        } else {
          exports.storage.debug = namespaces;
        }
      } catch (e) {}
    }

    /**
     * Load `namespaces`.
     *
     * @return {String} returns the previously persisted debug modes
     * @api private
     */

    function load() {
      var r;
      try {
        r = exports.storage.debug;
      } catch (e) {}

      // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }
      return r;
    }

    /**
     * Enable namespaces listed in `localStorage.debug` initially.
     */

    exports.enable(load());

    /**
     * Localstorage attempts to return the localstorage.
     *
     * This is necessary because safari throws
     * when a user disables cookies/localstorage
     * and you attempt to access it.
     *
     * @return {LocalStorage}
     * @api private
     */

    function localstorage() {
      try {
        return window.localStorage;
      } catch (e) {}
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 2 */
/***/function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {};

  // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;
  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }
  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }
    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();
  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }
  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }
  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  };

  // v8 likes predictible objects
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues
  process.versions = {};
  function noop() {}
  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;
  process.listeners = function (name) {
    return [];
  };
  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };
  process.cwd = function () {
    return '/';
  };
  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };
  process.umask = function () {
    return 0;
  };

  /***/
}, /* 3 */
/***/function (module, exports, __webpack_require__) {
  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = __webpack_require__(4);

  /**
   * The currently active debug mode names, and names to skip.
   */

  exports.names = [];
  exports.skips = [];

  /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */

  exports.formatters = {};

  /**
   * Previous log timestamp.
   */

  var prevTime;

  /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */

  function selectColor(namespace) {
    var hash = 0,
      i;
    for (i in namespace) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return exports.colors[Math.abs(hash) % exports.colors.length];
  }

  /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */

  function createDebug(namespace) {
    function debug() {
      // disabled?
      if (!debug.enabled) return;
      var self = debug;

      // set `diff` timestamp
      var curr = +new Date();
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;

      // turn the `arguments` into a proper Array
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      args[0] = exports.coerce(args[0]);
      if ('string' !== typeof args[0]) {
        // anything else let's inspect with %O
        args.unshift('%O');
      }

      // apply any `formatters` transformations
      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // if we encounter an escaped % then don't increase the array index
        if (match === '%%') return match;
        index++;
        var formatter = exports.formatters[format];
        if ('function' === typeof formatter) {
          var val = args[index];
          match = formatter.call(self, val);

          // now we need to remove `args[index]` since it's inlined in the `format`
          args.splice(index, 1);
          index--;
        }
        return match;
      });

      // apply env-specific formatting (colors, etc.)
      exports.formatArgs.call(self, args);
      var logFn = debug.log || exports.log || console.log.bind(console);
      logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);

    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) {
      exports.init(debug);
    }
    return debug;
  }

  /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */

  function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for (var i = 0; i < len; i++) {
      if (!split[i]) continue; // ignore empty strings
      namespaces = split[i].replace(/\*/g, '.*?');
      if (namespaces[0] === '-') {
        exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        exports.names.push(new RegExp('^' + namespaces + '$'));
      }
    }
  }

  /**
   * Disable debug output.
   *
   * @api public
   */

  function disable() {
    exports.enable('');
  }

  /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */

  function enabled(name) {
    var i, len;
    for (i = 0, len = exports.skips.length; i < len; i++) {
      if (exports.skips[i].test(name)) {
        return false;
      }
    }
    for (i = 0, len = exports.names.length; i < len; i++) {
      if (exports.names[i].test(name)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */

  function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
  }

  /***/
}, /* 4 */
/***/function (module, exports) {
  /**
   * Helpers.
   */

  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var y = d * 365.25;

  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  module.exports = function (val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) {
      return parse(val);
    } else if (type === 'number' && isNaN(val) === false) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
  };

  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */

  function parse(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;
      case 'days':
      case 'day':
      case 'd':
        return n * d;
      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;
      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;
      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;
      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;
      default:
        return undefined;
    }
  }

  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtShort(ms) {
    if (ms >= d) {
      return Math.round(ms / d) + 'd';
    }
    if (ms >= h) {
      return Math.round(ms / h) + 'h';
    }
    if (ms >= m) {
      return Math.round(ms / m) + 'm';
    }
    if (ms >= s) {
      return Math.round(ms / s) + 's';
    }
    return ms + 'ms';
  }

  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtLong(ms) {
    return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
  }

  /**
   * Pluralization helper.
   */

  function plural(ms, n, name) {
    if (ms < n) {
      return;
    }
    if (ms < n * 1.5) {
      return Math.floor(ms / n) + ' ' + name;
    }
    return Math.ceil(ms / n) + ' ' + name + 's';
  }

  /***/
}, /* 5 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var old;
  if (typeof Promise !== "undefined") old = Promise;
  function noConflict() {
    try {
      if (Promise === bluebird) Promise = old;
    } catch (e) {}
    return bluebird;
  }
  var bluebird = __webpack_require__(6)();
  bluebird.noConflict = noConflict;
  module.exports = bluebird;

  /***/
}, /* 6 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    "use strict";

    module.exports = function () {
      var makeSelfResolutionError = function makeSelfResolutionError() {
        return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
      };
      var reflectHandler = function reflectHandler() {
        return new Promise.PromiseInspection(this._target());
      };
      var apiRejection = function apiRejection(msg) {
        return Promise.reject(new TypeError(msg));
      };
      function Proxyable() {}
      var UNDEFINED_BINDING = {};
      var util = __webpack_require__(7);
      var getDomain;
      if (util.isNode) {
        getDomain = function getDomain() {
          var ret = process.domain;
          if (ret === undefined) ret = null;
          return ret;
        };
      } else {
        getDomain = function getDomain() {
          return null;
        };
      }
      util.notEnumerableProp(Promise, "_getDomain", getDomain);
      var es5 = __webpack_require__(8);
      var Async = __webpack_require__(9);
      var async = new Async();
      es5.defineProperty(Promise, "_async", {
        value: async
      });
      var errors = __webpack_require__(14);
      var TypeError = Promise.TypeError = errors.TypeError;
      Promise.RangeError = errors.RangeError;
      var CancellationError = Promise.CancellationError = errors.CancellationError;
      Promise.TimeoutError = errors.TimeoutError;
      Promise.OperationalError = errors.OperationalError;
      Promise.RejectionError = errors.OperationalError;
      Promise.AggregateError = errors.AggregateError;
      var INTERNAL = function INTERNAL() {};
      var APPLY = {};
      var NEXT_FILTER = {};
      var tryConvertToPromise = __webpack_require__(15)(Promise, INTERNAL);
      var PromiseArray = __webpack_require__(16)(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
      var Context = __webpack_require__(17)(Promise);
      /*jshint unused:false*/
      var createContext = Context.create;
      var debug = __webpack_require__(18)(Promise, Context);
      var CapturedTrace = debug.CapturedTrace;
      var PassThroughHandlerContext = __webpack_require__(19)(Promise, tryConvertToPromise, NEXT_FILTER);
      var catchFilter = __webpack_require__(20)(NEXT_FILTER);
      var nodebackForPromise = __webpack_require__(21);
      var errorObj = util.errorObj;
      var tryCatch = util.tryCatch;
      function check(self, executor) {
        if (self == null || self.constructor !== Promise) {
          throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
        }
        if (typeof executor !== "function") {
          throw new TypeError("expecting a function but got " + util.classString(executor));
        }
      }
      function Promise(executor) {
        if (executor !== INTERNAL) {
          check(this, executor);
        }
        this._bitField = 0;
        this._fulfillmentHandler0 = undefined;
        this._rejectionHandler0 = undefined;
        this._promise0 = undefined;
        this._receiver0 = undefined;
        this._resolveFromExecutor(executor);
        this._promiseCreated();
        this._fireEvent("promiseCreated", this);
      }
      Promise.prototype.toString = function () {
        return "[object Promise]";
      };
      Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
        var len = arguments.length;
        if (len > 1) {
          var catchInstances = new Array(len - 1),
            j = 0,
            i;
          for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
              catchInstances[j++] = item;
            } else {
              return apiRejection("Catch statement predicate: " + "expecting an object but got " + util.classString(item));
            }
          }
          catchInstances.length = j;
          fn = arguments[i];
          return this.then(undefined, catchFilter(catchInstances, fn, this));
        }
        return this.then(undefined, fn);
      };
      Promise.prototype.reflect = function () {
        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
      };
      Promise.prototype.then = function (didFulfill, didReject) {
        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
          var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
          if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
          }
          this._warn(msg);
        }
        return this._then(didFulfill, didReject, undefined, undefined, undefined);
      };
      Promise.prototype.done = function (didFulfill, didReject) {
        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
        promise._setIsFinal();
      };
      Promise.prototype.spread = function (fn) {
        if (typeof fn !== "function") {
          return apiRejection("expecting a function but got " + util.classString(fn));
        }
        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
      };
      Promise.prototype.toJSON = function () {
        var ret = {
          isFulfilled: false,
          isRejected: false,
          fulfillmentValue: undefined,
          rejectionReason: undefined
        };
        if (this.isFulfilled()) {
          ret.fulfillmentValue = this.value();
          ret.isFulfilled = true;
        } else if (this.isRejected()) {
          ret.rejectionReason = this.reason();
          ret.isRejected = true;
        }
        return ret;
      };
      Promise.prototype.all = function () {
        if (arguments.length > 0) {
          this._warn(".all() was passed arguments but it does not take any");
        }
        return new PromiseArray(this).promise();
      };
      Promise.prototype.error = function (fn) {
        return this.caught(util.originatesFromRejection, fn);
      };
      Promise.getNewLibraryCopy = module.exports;
      Promise.is = function (val) {
        return val instanceof Promise;
      };
      Promise.fromNode = Promise.fromCallback = function (fn) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
        if (result === errorObj) {
          ret._rejectCallback(result.e, true);
        }
        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
        return ret;
      };
      Promise.all = function (promises) {
        return new PromiseArray(promises).promise();
      };
      Promise.cast = function (obj) {
        var ret = tryConvertToPromise(obj);
        if (!(ret instanceof Promise)) {
          ret = new Promise(INTERNAL);
          ret._captureStackTrace();
          ret._setFulfilled();
          ret._rejectionHandler0 = obj;
        }
        return ret;
      };
      Promise.resolve = Promise.fulfilled = Promise.cast;
      Promise.reject = Promise.rejected = function (reason) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._rejectCallback(reason, true);
        return ret;
      };
      Promise.setScheduler = function (fn) {
        if (typeof fn !== "function") {
          throw new TypeError("expecting a function but got " + util.classString(fn));
        }
        return async.setScheduler(fn);
      };
      Promise.prototype._then = function (didFulfill, didReject, _, receiver, internalData) {
        var haveInternalData = internalData !== undefined;
        var promise = haveInternalData ? internalData : new Promise(INTERNAL);
        var target = this._target();
        var bitField = target._bitField;
        if (!haveInternalData) {
          promise._propagateFrom(this, 3);
          promise._captureStackTrace();
          if (receiver === undefined && (this._bitField & 2097152) !== 0) {
            if (!((bitField & 50397184) === 0)) {
              receiver = this._boundValue();
            } else {
              receiver = target === this ? undefined : this._boundTo;
            }
          }
          this._fireEvent("promiseChained", this, promise);
        }
        var domain = getDomain();
        if (!((bitField & 50397184) === 0)) {
          var handler,
            value,
            settler = target._settlePromiseCtx;
          if ((bitField & 33554432) !== 0) {
            value = target._rejectionHandler0;
            handler = didFulfill;
          } else if ((bitField & 16777216) !== 0) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
          } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
          }
          async.invoke(settler, target, {
            handler: domain === null ? handler : typeof handler === "function" && util.domainBind(domain, handler),
            promise: promise,
            receiver: receiver,
            value: value
          });
        } else {
          target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
        }
        return promise;
      };
      Promise.prototype._length = function () {
        return this._bitField & 65535;
      };
      Promise.prototype._isFateSealed = function () {
        return (this._bitField & 117506048) !== 0;
      };
      Promise.prototype._isFollowing = function () {
        return (this._bitField & 67108864) === 67108864;
      };
      Promise.prototype._setLength = function (len) {
        this._bitField = this._bitField & -65536 | len & 65535;
      };
      Promise.prototype._setFulfilled = function () {
        this._bitField = this._bitField | 33554432;
        this._fireEvent("promiseFulfilled", this);
      };
      Promise.prototype._setRejected = function () {
        this._bitField = this._bitField | 16777216;
        this._fireEvent("promiseRejected", this);
      };
      Promise.prototype._setFollowing = function () {
        this._bitField = this._bitField | 67108864;
        this._fireEvent("promiseResolved", this);
      };
      Promise.prototype._setIsFinal = function () {
        this._bitField = this._bitField | 4194304;
      };
      Promise.prototype._isFinal = function () {
        return (this._bitField & 4194304) > 0;
      };
      Promise.prototype._unsetCancelled = function () {
        this._bitField = this._bitField & ~65536;
      };
      Promise.prototype._setCancelled = function () {
        this._bitField = this._bitField | 65536;
        this._fireEvent("promiseCancelled", this);
      };
      Promise.prototype._setWillBeCancelled = function () {
        this._bitField = this._bitField | 8388608;
      };
      Promise.prototype._setAsyncGuaranteed = function () {
        if (async.hasCustomScheduler()) return;
        this._bitField = this._bitField | 134217728;
      };
      Promise.prototype._receiverAt = function (index) {
        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
        if (ret === UNDEFINED_BINDING) {
          return undefined;
        } else if (ret === undefined && this._isBound()) {
          return this._boundValue();
        }
        return ret;
      };
      Promise.prototype._promiseAt = function (index) {
        return this[index * 4 - 4 + 2];
      };
      Promise.prototype._fulfillmentHandlerAt = function (index) {
        return this[index * 4 - 4 + 0];
      };
      Promise.prototype._rejectionHandlerAt = function (index) {
        return this[index * 4 - 4 + 1];
      };
      Promise.prototype._boundValue = function () {};
      Promise.prototype._migrateCallback0 = function (follower) {
        var bitField = follower._bitField;
        var fulfill = follower._fulfillmentHandler0;
        var reject = follower._rejectionHandler0;
        var promise = follower._promise0;
        var receiver = follower._receiverAt(0);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
      };
      Promise.prototype._migrateCallbackAt = function (follower, index) {
        var fulfill = follower._fulfillmentHandlerAt(index);
        var reject = follower._rejectionHandlerAt(index);
        var promise = follower._promiseAt(index);
        var receiver = follower._receiverAt(index);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
      };
      Promise.prototype._addCallbacks = function (fulfill, reject, promise, receiver, domain) {
        var index = this._length();
        if (index >= 65535 - 4) {
          index = 0;
          this._setLength(0);
        }
        if (index === 0) {
          this._promise0 = promise;
          this._receiver0 = receiver;
          if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = domain === null ? fulfill : util.domainBind(domain, fulfill);
          }
          if (typeof reject === "function") {
            this._rejectionHandler0 = domain === null ? reject : util.domainBind(domain, reject);
          }
        } else {
          var base = index * 4 - 4;
          this[base + 2] = promise;
          this[base + 3] = receiver;
          if (typeof fulfill === "function") {
            this[base + 0] = domain === null ? fulfill : util.domainBind(domain, fulfill);
          }
          if (typeof reject === "function") {
            this[base + 1] = domain === null ? reject : util.domainBind(domain, reject);
          }
        }
        this._setLength(index + 1);
        return index;
      };
      Promise.prototype._proxy = function (proxyable, arg) {
        this._addCallbacks(undefined, undefined, arg, proxyable, null);
      };
      Promise.prototype._resolveCallback = function (value, shouldBind) {
        if ((this._bitField & 117506048) !== 0) return;
        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
        var maybePromise = tryConvertToPromise(value, this);
        if (!(maybePromise instanceof Promise)) return this._fulfill(value);
        if (shouldBind) this._propagateFrom(maybePromise, 2);
        var promise = maybePromise._target();
        if (promise === this) {
          this._reject(makeSelfResolutionError());
          return;
        }
        var bitField = promise._bitField;
        if ((bitField & 50397184) === 0) {
          var len = this._length();
          if (len > 0) promise._migrateCallback0(this);
          for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
          }
          this._setFollowing();
          this._setLength(0);
          this._setFollowee(promise);
        } else if ((bitField & 33554432) !== 0) {
          this._fulfill(promise._value());
        } else if ((bitField & 16777216) !== 0) {
          this._reject(promise._reason());
        } else {
          var reason = new CancellationError("late cancellation observer");
          promise._attachExtraTrace(reason);
          this._reject(reason);
        }
      };
      Promise.prototype._rejectCallback = function (reason, synchronous, ignoreNonErrorWarnings) {
        var trace = util.ensureErrorObject(reason);
        var hasStack = trace === reason;
        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
          var message = "a promise was rejected with a non-error: " + util.classString(reason);
          this._warn(message, true);
        }
        this._attachExtraTrace(trace, synchronous ? hasStack : false);
        this._reject(reason);
      };
      Promise.prototype._resolveFromExecutor = function (executor) {
        if (executor === INTERNAL) return;
        var promise = this;
        this._captureStackTrace();
        this._pushContext();
        var synchronous = true;
        var r = this._execute(executor, function (value) {
          promise._resolveCallback(value);
        }, function (reason) {
          promise._rejectCallback(reason, synchronous);
        });
        synchronous = false;
        this._popContext();
        if (r !== undefined) {
          promise._rejectCallback(r, true);
        }
      };
      Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
        var bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        promise._pushContext();
        var x;
        if (receiver === APPLY) {
          if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
          } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
          }
        } else {
          x = tryCatch(handler).call(receiver, value);
        }
        var promiseCreated = promise._popContext();
        bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        if (x === NEXT_FILTER) {
          promise._reject(value);
        } else if (x === errorObj) {
          promise._rejectCallback(x.e, false);
        } else {
          debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
          promise._resolveCallback(x);
        }
      };
      Promise.prototype._target = function () {
        var ret = this;
        while (ret._isFollowing()) ret = ret._followee();
        return ret;
      };
      Promise.prototype._followee = function () {
        return this._rejectionHandler0;
      };
      Promise.prototype._setFollowee = function (promise) {
        this._rejectionHandler0 = promise;
      };
      Promise.prototype._settlePromise = function (promise, handler, receiver, value) {
        var isPromise = promise instanceof Promise;
        var bitField = this._bitField;
        var asyncGuaranteed = (bitField & 134217728) !== 0;
        if ((bitField & 65536) !== 0) {
          if (isPromise) promise._invokeInternalOnCancel();
          if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
              promise._reject(errorObj.e);
            }
          } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
          } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
          } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
          } else {
            receiver.cancel();
          }
        } else if (typeof handler === "function") {
          if (!isPromise) {
            handler.call(receiver, value, promise);
          } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
          }
        } else if (receiver instanceof Proxyable) {
          if (!receiver._isResolved()) {
            if ((bitField & 33554432) !== 0) {
              receiver._promiseFulfilled(value, promise);
            } else {
              receiver._promiseRejected(value, promise);
            }
          }
        } else if (isPromise) {
          if (asyncGuaranteed) promise._setAsyncGuaranteed();
          if ((bitField & 33554432) !== 0) {
            promise._fulfill(value);
          } else {
            promise._reject(value);
          }
        }
      };
      Promise.prototype._settlePromiseLateCancellationObserver = function (ctx) {
        var handler = ctx.handler;
        var promise = ctx.promise;
        var receiver = ctx.receiver;
        var value = ctx.value;
        if (typeof handler === "function") {
          if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
          } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
          }
        } else if (promise instanceof Promise) {
          promise._reject(value);
        }
      };
      Promise.prototype._settlePromiseCtx = function (ctx) {
        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
      };
      Promise.prototype._settlePromise0 = function (handler, value, bitField) {
        var promise = this._promise0;
        var receiver = this._receiverAt(0);
        this._promise0 = undefined;
        this._receiver0 = undefined;
        this._settlePromise(promise, handler, receiver, value);
      };
      Promise.prototype._clearCallbackDataAtIndex = function (index) {
        var base = index * 4 - 4;
        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
      };
      Promise.prototype._fulfill = function (value) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        if (value === this) {
          var err = makeSelfResolutionError();
          this._attachExtraTrace(err);
          return this._reject(err);
        }
        this._setFulfilled();
        this._rejectionHandler0 = value;
        if ((bitField & 65535) > 0) {
          if ((bitField & 134217728) !== 0) {
            this._settlePromises();
          } else {
            async.settlePromises(this);
          }
          this._dereferenceTrace();
        }
      };
      Promise.prototype._reject = function (reason) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        this._setRejected();
        this._fulfillmentHandler0 = reason;
        if (this._isFinal()) {
          return async.fatalError(reason, util.isNode);
        }
        if ((bitField & 65535) > 0) {
          async.settlePromises(this);
        } else {
          this._ensurePossibleRejectionHandled();
        }
      };
      Promise.prototype._fulfillPromises = function (len, value) {
        for (var i = 1; i < len; i++) {
          var handler = this._fulfillmentHandlerAt(i);
          var promise = this._promiseAt(i);
          var receiver = this._receiverAt(i);
          this._clearCallbackDataAtIndex(i);
          this._settlePromise(promise, handler, receiver, value);
        }
      };
      Promise.prototype._rejectPromises = function (len, reason) {
        for (var i = 1; i < len; i++) {
          var handler = this._rejectionHandlerAt(i);
          var promise = this._promiseAt(i);
          var receiver = this._receiverAt(i);
          this._clearCallbackDataAtIndex(i);
          this._settlePromise(promise, handler, receiver, reason);
        }
      };
      Promise.prototype._settlePromises = function () {
        var bitField = this._bitField;
        var len = bitField & 65535;
        if (len > 0) {
          if ((bitField & 16842752) !== 0) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
          } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
          }
          this._setLength(0);
        }
        this._clearCancellationData();
      };
      Promise.prototype._settledValue = function () {
        var bitField = this._bitField;
        if ((bitField & 33554432) !== 0) {
          return this._rejectionHandler0;
        } else if ((bitField & 16777216) !== 0) {
          return this._fulfillmentHandler0;
        }
      };
      function deferResolve(v) {
        this.promise._resolveCallback(v);
      }
      function deferReject(v) {
        this.promise._rejectCallback(v, false);
      }
      Promise.defer = Promise.pending = function () {
        debug.deprecated("Promise.defer", "new Promise");
        var promise = new Promise(INTERNAL);
        return {
          promise: promise,
          resolve: deferResolve,
          reject: deferReject
        };
      };
      util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
      __webpack_require__(22)(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
      __webpack_require__(23)(Promise, INTERNAL, tryConvertToPromise, debug);
      __webpack_require__(24)(Promise, PromiseArray, apiRejection, debug);
      __webpack_require__(25)(Promise);
      __webpack_require__(26)(Promise);
      __webpack_require__(27)(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
      Promise.Promise = Promise;
      Promise.version = "3.5.3";
      __webpack_require__(28)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
      __webpack_require__(29)(Promise);
      __webpack_require__(30)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
      __webpack_require__(31)(Promise, INTERNAL, debug);
      __webpack_require__(32)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
      __webpack_require__(33)(Promise);
      __webpack_require__(34)(Promise, INTERNAL);
      __webpack_require__(35)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
      __webpack_require__(36)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
      __webpack_require__(37)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
      __webpack_require__(38)(Promise, PromiseArray, debug);
      __webpack_require__(39)(Promise, PromiseArray, apiRejection);
      __webpack_require__(40)(Promise, INTERNAL);
      __webpack_require__(41)(Promise, INTERNAL);
      __webpack_require__(42)(Promise);
      util.toFastProperties(Promise);
      util.toFastProperties(Promise.prototype);
      function fillTypes(value) {
        var p = new Promise(INTERNAL);
        p._fulfillmentHandler0 = value;
        p._rejectionHandler0 = value;
        p._promise0 = value;
        p._receiver0 = value;
      }
      // Complete slack tracking, opt out of field-type tracking and           
      // stabilize map                                                         
      fillTypes({
        a: 1
      });
      fillTypes({
        b: 2
      });
      fillTypes({
        c: 3
      });
      fillTypes(1);
      fillTypes(function () {});
      fillTypes(undefined);
      fillTypes(false);
      fillTypes(new Promise(INTERNAL));
      debug.setBounds(Async.firstLineError, util.lastLineError);
      return Promise;
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 7 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, process) {
    "use strict";

    var es5 = __webpack_require__(8);
    var canEvaluate = typeof navigator == "undefined";
    var errorObj = {
      e: {}
    };
    var tryCatchTarget;
    var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== undefined ? this : null;
    function tryCatcher() {
      try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
      } catch (e) {
        errorObj.e = e;
        return errorObj;
      }
    }
    function tryCatch(fn) {
      tryCatchTarget = fn;
      return tryCatcher;
    }
    var inherits = function inherits(Child, Parent) {
      var hasProp = {}.hasOwnProperty;
      function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
          if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
            this[propertyName + "$"] = Parent.prototype[propertyName];
          }
        }
      }
      T.prototype = Parent.prototype;
      Child.prototype = new T();
      return Child.prototype;
    };
    function isPrimitive(val) {
      return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
    }
    function isObject(value) {
      return typeof value === "function" || typeof value === "object" && value !== null;
    }
    function maybeWrapAsError(maybeError) {
      if (!isPrimitive(maybeError)) return maybeError;
      return new Error(safeToString(maybeError));
    }
    function withAppended(target, appendee) {
      var len = target.length;
      var ret = new Array(len + 1);
      var i;
      for (i = 0; i < len; ++i) {
        ret[i] = target[i];
      }
      ret[i] = appendee;
      return ret;
    }
    function getDataPropertyOrDefault(obj, key, defaultValue) {
      if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) {
          return desc.get == null && desc.set == null ? desc.value : defaultValue;
        }
      } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
      }
    }
    function notEnumerableProp(obj, name, value) {
      if (isPrimitive(obj)) return obj;
      var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
      };
      es5.defineProperty(obj, name, descriptor);
      return obj;
    }
    function thrower(r) {
      throw r;
    }
    var inheritedDataKeys = function () {
      var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];
      var isExcludedProto = function isExcludedProto(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
          if (excludedPrototypes[i] === val) {
            return true;
          }
        }
        return false;
      };
      if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function (obj) {
          var ret = [];
          var visitedKeys = Object.create(null);
          while (obj != null && !isExcludedProto(obj)) {
            var keys;
            try {
              keys = getKeys(obj);
            } catch (e) {
              return ret;
            }
            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];
              if (visitedKeys[key]) continue;
              visitedKeys[key] = true;
              var desc = Object.getOwnPropertyDescriptor(obj, key);
              if (desc != null && desc.get == null && desc.set == null) {
                ret.push(key);
              }
            }
            obj = es5.getPrototypeOf(obj);
          }
          return ret;
        };
      } else {
        var hasProp = {}.hasOwnProperty;
        return function (obj) {
          if (isExcludedProto(obj)) return [];
          var ret = [];

          /*jshint forin:false */
          enumeration: for (var key in obj) {
            if (hasProp.call(obj, key)) {
              ret.push(key);
            } else {
              for (var i = 0; i < excludedPrototypes.length; ++i) {
                if (hasProp.call(excludedPrototypes[i], key)) {
                  continue enumeration;
                }
              }
              ret.push(key);
            }
          }
          return ret;
        };
      }
    }();
    var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
    function isClass(fn) {
      try {
        if (typeof fn === "function") {
          var keys = es5.names(fn.prototype);
          var hasMethods = es5.isES5 && keys.length > 1;
          var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
          var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
          if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
            return true;
          }
        }
        return false;
      } catch (e) {
        return false;
      }
    }
    function toFastProperties(obj) {
      /*jshint -W027,-W055,-W031*/
      function FakeConstructor() {}
      FakeConstructor.prototype = obj;
      var receiver = new FakeConstructor();
      function ic() {
        return typeof receiver.foo;
      }
      ic();
      ic();
      return obj;
      eval(obj);
    }
    var rident = /^[a-z$_][a-z$_0-9]*$/i;
    function isIdentifier(str) {
      return rident.test(str);
    }
    function filledRange(count, prefix, suffix) {
      var ret = new Array(count);
      for (var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
      }
      return ret;
    }
    function safeToString(obj) {
      try {
        return obj + "";
      } catch (e) {
        return "[no string representation]";
      }
    }
    function isError(obj) {
      return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
    }
    function markAsOriginatingFromRejection(e) {
      try {
        notEnumerableProp(e, "isOperational", true);
      } catch (ignore) {}
    }
    function originatesFromRejection(e) {
      if (e == null) return false;
      return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
    }
    function canAttachTrace(obj) {
      return isError(obj) && es5.propertyIsWritable(obj, "stack");
    }
    var ensureErrorObject = function () {
      if (!("stack" in new Error())) {
        return function (value) {
          if (canAttachTrace(value)) return value;
          try {
            throw new Error(safeToString(value));
          } catch (err) {
            return err;
          }
        };
      } else {
        return function (value) {
          if (canAttachTrace(value)) return value;
          return new Error(safeToString(value));
        };
      }
    }();
    function classString(obj) {
      return {}.toString.call(obj);
    }
    function copyDescriptors(from, to, filter) {
      var keys = es5.names(from);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
          try {
            es5.defineProperty(to, key, es5.getDescriptor(from, key));
          } catch (ignore) {}
        }
      }
    }
    var asArray = function asArray(v) {
      if (es5.isArray(v)) {
        return v;
      }
      return null;
    };
    if (typeof Symbol !== "undefined" && Symbol.iterator) {
      var ArrayFrom = typeof Array.from === "function" ? function (v) {
        return Array.from(v);
      } : function (v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!(itResult = it.next()).done) {
          ret.push(itResult.value);
        }
        return ret;
      };
      asArray = function asArray(v) {
        if (es5.isArray(v)) {
          return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
          return ArrayFrom(v);
        }
        return null;
      };
    }
    var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
    var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
    function env(key) {
      return hasEnvVariables ? process.env[key] : undefined;
    }
    function getNativePromise() {
      if (typeof Promise === "function") {
        try {
          var promise = new Promise(function () {});
          if ({}.toString.call(promise) === "[object Promise]") {
            return Promise;
          }
        } catch (e) {}
      }
    }
    function domainBind(self, cb) {
      return self.bind(cb);
    }
    var ret = {
      isClass: isClass,
      isIdentifier: isIdentifier,
      inheritedDataKeys: inheritedDataKeys,
      getDataPropertyOrDefault: getDataPropertyOrDefault,
      thrower: thrower,
      isArray: es5.isArray,
      asArray: asArray,
      notEnumerableProp: notEnumerableProp,
      isPrimitive: isPrimitive,
      isObject: isObject,
      isError: isError,
      canEvaluate: canEvaluate,
      errorObj: errorObj,
      tryCatch: tryCatch,
      inherits: inherits,
      withAppended: withAppended,
      maybeWrapAsError: maybeWrapAsError,
      toFastProperties: toFastProperties,
      filledRange: filledRange,
      toString: safeToString,
      canAttachTrace: canAttachTrace,
      ensureErrorObject: ensureErrorObject,
      originatesFromRejection: originatesFromRejection,
      markAsOriginatingFromRejection: markAsOriginatingFromRejection,
      classString: classString,
      copyDescriptors: copyDescriptors,
      hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
      isNode: isNode,
      hasEnvVariables: hasEnvVariables,
      env: env,
      global: globalObject,
      getNativePromise: getNativePromise,
      domainBind: domainBind
    };
    ret.isRecentNode = ret.isNode && function () {
      var version = process.versions.node.split(".").map(Number);
      return version[0] === 0 && version[1] > 10 || version[0] > 0;
    }();
    if (ret.isNode) ret.toFastProperties(process);
    try {
      throw new Error();
    } catch (e) {
      ret.lastLineError = e;
    }
    module.exports = ret;

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(2));

  /***/
}, /* 8 */
/***/function (module, exports) {
  var isES5 = function () {
    "use strict";

    return this === undefined;
  }();
  if (isES5) {
    module.exports = {
      freeze: Object.freeze,
      defineProperty: Object.defineProperty,
      getDescriptor: Object.getOwnPropertyDescriptor,
      keys: Object.keys,
      names: Object.getOwnPropertyNames,
      getPrototypeOf: Object.getPrototypeOf,
      isArray: Array.isArray,
      isES5: isES5,
      propertyIsWritable: function propertyIsWritable(obj, prop) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!(!descriptor || descriptor.writable || descriptor.set);
      }
    };
  } else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;
    var ObjectKeys = function ObjectKeys(o) {
      var ret = [];
      for (var key in o) {
        if (has.call(o, key)) {
          ret.push(key);
        }
      }
      return ret;
    };
    var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
      return {
        value: o[key]
      };
    };
    var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
      o[key] = desc.value;
      return o;
    };
    var ObjectFreeze = function ObjectFreeze(obj) {
      return obj;
    };
    var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
      try {
        return Object(obj).constructor.prototype;
      } catch (e) {
        return proto;
      }
    };
    var ArrayIsArray = function ArrayIsArray(obj) {
      try {
        return str.call(obj) === "[object Array]";
      } catch (e) {
        return false;
      }
    };
    module.exports = {
      isArray: ArrayIsArray,
      keys: ObjectKeys,
      names: ObjectKeys,
      defineProperty: ObjectDefineProperty,
      getDescriptor: ObjectGetDescriptor,
      freeze: ObjectFreeze,
      getPrototypeOf: ObjectGetPrototypeOf,
      isES5: isES5,
      propertyIsWritable: function propertyIsWritable() {
        return true;
      }
    };
  }

  /***/
}, /* 9 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    "use strict";

    var firstLineError;
    try {
      throw new Error();
    } catch (e) {
      firstLineError = e;
    }
    var schedule = __webpack_require__(10);
    var Queue = __webpack_require__(13);
    var util = __webpack_require__(7);
    function Async() {
      this._customScheduler = false;
      this._isTickUsed = false;
      this._lateQueue = new Queue(16);
      this._normalQueue = new Queue(16);
      this._haveDrainedQueues = false;
      this._trampolineEnabled = true;
      var self = this;
      this.drainQueues = function () {
        self._drainQueues();
      };
      this._schedule = schedule;
    }
    Async.prototype.setScheduler = function (fn) {
      var prev = this._schedule;
      this._schedule = fn;
      this._customScheduler = true;
      return prev;
    };
    Async.prototype.hasCustomScheduler = function () {
      return this._customScheduler;
    };
    Async.prototype.enableTrampoline = function () {
      this._trampolineEnabled = true;
    };
    Async.prototype.disableTrampolineIfNecessary = function () {
      if (util.hasDevTools) {
        this._trampolineEnabled = false;
      }
    };
    Async.prototype.haveItemsQueued = function () {
      return this._isTickUsed || this._haveDrainedQueues;
    };
    Async.prototype.fatalError = function (e, isNode) {
      if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
        process.exit(2);
      } else {
        this.throwLater(e);
      }
    };
    Async.prototype.throwLater = function (fn, arg) {
      if (arguments.length === 1) {
        arg = fn;
        fn = function fn() {
          throw arg;
        };
      }
      if (typeof setTimeout !== "undefined") {
        setTimeout(function () {
          fn(arg);
        }, 0);
      } else try {
        this._schedule(function () {
          fn(arg);
        });
      } catch (e) {
        throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
      }
    };
    function AsyncInvokeLater(fn, receiver, arg) {
      this._lateQueue.push(fn, receiver, arg);
      this._queueTick();
    }
    function AsyncInvoke(fn, receiver, arg) {
      this._normalQueue.push(fn, receiver, arg);
      this._queueTick();
    }
    function AsyncSettlePromises(promise) {
      this._normalQueue._pushOne(promise);
      this._queueTick();
    }
    if (!util.hasDevTools) {
      Async.prototype.invokeLater = AsyncInvokeLater;
      Async.prototype.invoke = AsyncInvoke;
      Async.prototype.settlePromises = AsyncSettlePromises;
    } else {
      Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
          AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
          this._schedule(function () {
            setTimeout(function () {
              fn.call(receiver, arg);
            }, 100);
          });
        }
      };
      Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
          AsyncInvoke.call(this, fn, receiver, arg);
        } else {
          this._schedule(function () {
            fn.call(receiver, arg);
          });
        }
      };
      Async.prototype.settlePromises = function (promise) {
        if (this._trampolineEnabled) {
          AsyncSettlePromises.call(this, promise);
        } else {
          this._schedule(function () {
            promise._settlePromises();
          });
        }
      };
    }
    function _drainQueue(queue) {
      while (queue.length() > 0) {
        _drainQueueStep(queue);
      }
    }
    function _drainQueueStep(queue) {
      var fn = queue.shift();
      if (typeof fn !== "function") {
        fn._settlePromises();
      } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
      }
    }
    Async.prototype._drainQueues = function () {
      _drainQueue(this._normalQueue);
      this._reset();
      this._haveDrainedQueues = true;
      _drainQueue(this._lateQueue);
    };
    Async.prototype._queueTick = function () {
      if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
      }
    };
    Async.prototype._reset = function () {
      this._isTickUsed = false;
    };
    module.exports = Async;
    module.exports.firstLineError = firstLineError;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 10 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, process, setImmediate) {
    "use strict";

    var util = __webpack_require__(7);
    var schedule;
    var noAsyncScheduler = function noAsyncScheduler() {
      throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
    };
    var NativePromise = util.getNativePromise();
    if (util.isNode && typeof MutationObserver === "undefined") {
      var GlobalSetImmediate = global.setImmediate;
      var ProcessNextTick = process.nextTick;
      schedule = util.isRecentNode ? function (fn) {
        GlobalSetImmediate.call(global, fn);
      } : function (fn) {
        ProcessNextTick.call(process, fn);
      };
    } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
      var nativePromise = NativePromise.resolve();
      schedule = function schedule(fn) {
        nativePromise.then(fn);
      };
    } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova))) {
      schedule = function () {
        var div = document.createElement("div");
        var opts = {
          attributes: true
        };
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function () {
          div.classList.toggle("foo");
          toggleScheduled = false;
        });
        o2.observe(div2, opts);
        var scheduleToggle = function scheduleToggle() {
          if (toggleScheduled) return;
          toggleScheduled = true;
          div2.classList.toggle("foo");
        };
        return function schedule(fn) {
          var o = new MutationObserver(function () {
            o.disconnect();
            fn();
          });
          o.observe(div, opts);
          scheduleToggle();
        };
      }();
    } else if (typeof setImmediate !== "undefined") {
      schedule = function schedule(fn) {
        setImmediate(fn);
      };
    } else if (typeof setTimeout !== "undefined") {
      schedule = function schedule(fn) {
        setTimeout(fn, 0);
      };
    } else {
      schedule = noAsyncScheduler;
    }
    module.exports = schedule;

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(2), __webpack_require__(11).setImmediate);

  /***/
}, /* 11 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
    var apply = Function.prototype.apply;

    // DOM APIs, for completeness

    exports.setTimeout = function () {
      return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
    };
    exports.setInterval = function () {
      return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
    };
    exports.clearTimeout = exports.clearInterval = function (timeout) {
      if (timeout) {
        timeout.close();
      }
    };
    function Timeout(id, clearFn) {
      this._id = id;
      this._clearFn = clearFn;
    }
    Timeout.prototype.unref = Timeout.prototype.ref = function () {};
    Timeout.prototype.close = function () {
      this._clearFn.call(scope, this._id);
    };

    // Does not start the time, just sets up the members needed.
    exports.enroll = function (item, msecs) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = msecs;
    };
    exports.unenroll = function (item) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = -1;
    };
    exports._unrefActive = exports.active = function (item) {
      clearTimeout(item._idleTimeoutId);
      var msecs = item._idleTimeout;
      if (msecs >= 0) {
        item._idleTimeoutId = setTimeout(function onTimeout() {
          if (item._onTimeout) item._onTimeout();
        }, msecs);
      }
    };

    // setimmediate attaches itself to the global object
    __webpack_require__(12);
    // On some exotic environments, it's not clear which object `setimmediate` was
    // able to install onto.  Search each possibility in the same order as the
    // `setimmediate` library.
    exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
    exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }());

  /***/
}, /* 12 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, process) {
    (function (global, undefined) {
      "use strict";

      if (global.setImmediate) {
        return;
      }
      var nextHandle = 1; // Spec says greater than zero
      var tasksByHandle = {};
      var currentlyRunningATask = false;
      var doc = global.document;
      var registerImmediate;
      function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
          callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = {
          callback: callback,
          args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
      }
      function clearImmediate(handle) {
        delete tasksByHandle[handle];
      }
      function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
          case 0:
            callback();
            break;
          case 1:
            callback(args[0]);
            break;
          case 2:
            callback(args[0], args[1]);
            break;
          case 3:
            callback(args[0], args[1], args[2]);
            break;
          default:
            callback.apply(undefined, args);
            break;
        }
      }
      function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
          // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
          // "too much recursion" error.
          setTimeout(runIfPresent, 0, handle);
        } else {
          var task = tasksByHandle[handle];
          if (task) {
            currentlyRunningATask = true;
            try {
              run(task);
            } finally {
              clearImmediate(handle);
              currentlyRunningATask = false;
            }
          }
        }
      }
      function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
          process.nextTick(function () {
            runIfPresent(handle);
          });
        };
      }
      function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
          var postMessageIsAsynchronous = true;
          var oldOnMessage = global.onmessage;
          global.onmessage = function () {
            postMessageIsAsynchronous = false;
          };
          global.postMessage("", "*");
          global.onmessage = oldOnMessage;
          return postMessageIsAsynchronous;
        }
      }
      function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
          if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
            runIfPresent(+event.data.slice(messagePrefix.length));
          }
        };
        if (global.addEventListener) {
          global.addEventListener("message", onGlobalMessage, false);
        } else {
          global.attachEvent("onmessage", onGlobalMessage);
        }
        registerImmediate = function registerImmediate(handle) {
          global.postMessage(messagePrefix + handle, "*");
        };
      }
      function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
          var handle = event.data;
          runIfPresent(handle);
        };
        registerImmediate = function registerImmediate(handle) {
          channel.port2.postMessage(handle);
        };
      }
      function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
          // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
          // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
          var script = doc.createElement("script");
          script.onreadystatechange = function () {
            runIfPresent(handle);
            script.onreadystatechange = null;
            html.removeChild(script);
            script = null;
          };
          html.appendChild(script);
        };
      }
      function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
          setTimeout(runIfPresent, 0, handle);
        };
      }

      // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
      var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
      attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

      // Don't get fooled by e.g. browserify environments.
      if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
      } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
      } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
      } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
      } else {
        // For older browsers
        installSetTimeoutImplementation();
      }
      attachTo.setImmediate = setImmediate;
      attachTo.clearImmediate = clearImmediate;
    })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(2));

  /***/
}, /* 13 */
/***/function (module, exports) {
  "use strict";

  function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
      dst[j + dstIndex] = src[j + srcIndex];
      src[j + srcIndex] = void 0;
    }
  }
  function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
  }
  Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
  };
  Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = this._front + length & this._capacity - 1;
    this[i] = arg;
    this._length = length + 1;
  };
  Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
      this._pushOne(fn);
      this._pushOne(receiver);
      this._pushOne(arg);
      return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[j + 0 & wrapMask] = fn;
    this[j + 1 & wrapMask] = receiver;
    this[j + 2 & wrapMask] = arg;
    this._length = length;
  };
  Queue.prototype.shift = function () {
    var front = this._front,
      ret = this[front];
    this[front] = undefined;
    this._front = front + 1 & this._capacity - 1;
    this._length--;
    return ret;
  };
  Queue.prototype.length = function () {
    return this._length;
  };
  Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
      this._resizeTo(this._capacity << 1);
    }
  };
  Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = front + length & oldCapacity - 1;
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
  };
  module.exports = Queue;

  /***/
}, /* 14 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var es5 = __webpack_require__(8);
  var Objectfreeze = es5.freeze;
  var util = __webpack_require__(7);
  var inherits = util.inherits;
  var notEnumerableProp = util.notEnumerableProp;
  function subError(nameProperty, defaultMessage) {
    function SubError(message) {
      if (!(this instanceof SubError)) return new SubError(message);
      notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
      notEnumerableProp(this, "name", nameProperty);
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      } else {
        Error.call(this);
      }
    }
    inherits(SubError, Error);
    return SubError;
  }
  var _TypeError, _RangeError;
  var Warning = subError("Warning", "warning");
  var CancellationError = subError("CancellationError", "cancellation error");
  var TimeoutError = subError("TimeoutError", "timeout error");
  var AggregateError = subError("AggregateError", "aggregate error");
  try {
    _TypeError = TypeError;
    _RangeError = RangeError;
  } catch (e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
  }
  var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
  for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
      AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
  }
  es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
  });
  AggregateError.prototype["isOperational"] = true;
  var level = 0;
  AggregateError.prototype.toString = function () {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
      var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
      var lines = str.split("\n");
      for (var j = 0; j < lines.length; ++j) {
        lines[j] = indent + lines[j];
      }
      str = lines.join("\n");
      ret += str + "\n";
    }
    level--;
    return ret;
  };
  function OperationalError(message) {
    if (!(this instanceof OperationalError)) return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;
    if (message instanceof Error) {
      notEnumerableProp(this, "message", message.message);
      notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  inherits(OperationalError, Error);
  var errorTypes = Error["__BluebirdErrorTypes__"];
  if (!errorTypes) {
    errorTypes = Objectfreeze({
      CancellationError: CancellationError,
      TimeoutError: TimeoutError,
      OperationalError: OperationalError,
      RejectionError: OperationalError,
      AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
      value: errorTypes,
      writable: false,
      enumerable: false,
      configurable: false
    });
  }
  module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
  };

  /***/
}, /* 15 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL) {
    var util = __webpack_require__(7);
    var errorObj = util.errorObj;
    var isObject = util.isObject;
    function tryConvertToPromise(obj, context) {
      if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
          if (context) context._pushContext();
          var ret = Promise.reject(then.e);
          if (context) context._popContext();
          return ret;
        } else if (typeof then === "function") {
          if (isAnyBluebirdPromise(obj)) {
            var ret = new Promise(INTERNAL);
            obj._then(ret._fulfill, ret._reject, undefined, ret, null);
            return ret;
          }
          return doThenable(obj, then, context);
        }
      }
      return obj;
    }
    function doGetThen(obj) {
      return obj.then;
    }
    function getThen(obj) {
      try {
        return doGetThen(obj);
      } catch (e) {
        errorObj.e = e;
        return errorObj;
      }
    }
    var hasProp = {}.hasOwnProperty;
    function isAnyBluebirdPromise(obj) {
      try {
        return hasProp.call(obj, "_promise0");
      } catch (e) {
        return false;
      }
    }
    function doThenable(x, then, context) {
      var promise = new Promise(INTERNAL);
      var ret = promise;
      if (context) context._pushContext();
      promise._captureStackTrace();
      if (context) context._popContext();
      var synchronous = true;
      var result = util.tryCatch(then).call(x, resolve, reject);
      synchronous = false;
      if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
      }
      function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
      }
      function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
      }
      return ret;
    }
    return tryConvertToPromise;
  };

  /***/
}, /* 16 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
    var util = __webpack_require__(7);
    var isArray = util.isArray;
    function toResolutionValue(val) {
      switch (val) {
        case -2:
          return [];
        case -3:
          return {};
        case -6:
          return new Map();
      }
    }
    function PromiseArray(values) {
      var promise = this._promise = new Promise(INTERNAL);
      if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
      }
      promise._setOnCancel(this);
      this._values = values;
      this._length = 0;
      this._totalResolved = 0;
      this._init(undefined, -2);
    }
    util.inherits(PromiseArray, Proxyable);
    PromiseArray.prototype.length = function () {
      return this._length;
    };
    PromiseArray.prototype.promise = function () {
      return this._promise;
    };
    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
      var values = tryConvertToPromise(this._values, this._promise);
      if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;
        if ((bitField & 50397184) === 0) {
          this._promise._setAsyncGuaranteed();
          return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
        } else if ((bitField & 33554432) !== 0) {
          values = values._value();
        } else if ((bitField & 16777216) !== 0) {
          return this._reject(values._reason());
        } else {
          return this._cancel();
        }
      }
      values = util.asArray(values);
      if (values === null) {
        var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
      }
      if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
          this._resolveEmptyArray();
        } else {
          this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
      }
      this._iterate(values);
    };
    PromiseArray.prototype._iterate = function (values) {
      var len = this.getActualLength(values.length);
      this._length = len;
      this._values = this.shouldCopyValues() ? new Array(len) : this._values;
      var result = this._promise;
      var isResolved = false;
      var bitField = null;
      for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);
        if (maybePromise instanceof Promise) {
          maybePromise = maybePromise._target();
          bitField = maybePromise._bitField;
        } else {
          bitField = null;
        }
        if (isResolved) {
          if (bitField !== null) {
            maybePromise.suppressUnhandledRejections();
          }
        } else if (bitField !== null) {
          if ((bitField & 50397184) === 0) {
            maybePromise._proxy(this, i);
            this._values[i] = maybePromise;
          } else if ((bitField & 33554432) !== 0) {
            isResolved = this._promiseFulfilled(maybePromise._value(), i);
          } else if ((bitField & 16777216) !== 0) {
            isResolved = this._promiseRejected(maybePromise._reason(), i);
          } else {
            isResolved = this._promiseCancelled(i);
          }
        } else {
          isResolved = this._promiseFulfilled(maybePromise, i);
        }
      }
      if (!isResolved) result._setAsyncGuaranteed();
    };
    PromiseArray.prototype._isResolved = function () {
      return this._values === null;
    };
    PromiseArray.prototype._resolve = function (value) {
      this._values = null;
      this._promise._fulfill(value);
    };
    PromiseArray.prototype._cancel = function () {
      if (this._isResolved() || !this._promise._isCancellable()) return;
      this._values = null;
      this._promise._cancel();
    };
    PromiseArray.prototype._reject = function (reason) {
      this._values = null;
      this._promise._rejectCallback(reason, false);
    };
    PromiseArray.prototype._promiseFulfilled = function (value, index) {
      this._values[index] = value;
      var totalResolved = ++this._totalResolved;
      if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
      }
      return false;
    };
    PromiseArray.prototype._promiseCancelled = function () {
      this._cancel();
      return true;
    };
    PromiseArray.prototype._promiseRejected = function (reason) {
      this._totalResolved++;
      this._reject(reason);
      return true;
    };
    PromiseArray.prototype._resultCancelled = function () {
      if (this._isResolved()) return;
      var values = this._values;
      this._cancel();
      if (values instanceof Promise) {
        values.cancel();
      } else {
        for (var i = 0; i < values.length; ++i) {
          if (values[i] instanceof Promise) {
            values[i].cancel();
          }
        }
      }
    };
    PromiseArray.prototype.shouldCopyValues = function () {
      return true;
    };
    PromiseArray.prototype.getActualLength = function (len) {
      return len;
    };
    return PromiseArray;
  };

  /***/
}, /* 17 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise) {
    var longStackTraces = false;
    var contextStack = [];
    Promise.prototype._promiseCreated = function () {};
    Promise.prototype._pushContext = function () {};
    Promise.prototype._popContext = function () {
      return null;
    };
    Promise._peekContext = Promise.prototype._peekContext = function () {};
    function Context() {
      this._trace = new Context.CapturedTrace(peekContext());
    }
    Context.prototype._pushContext = function () {
      if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
      }
    };
    Context.prototype._popContext = function () {
      if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
      }
      return null;
    };
    function createContext() {
      if (longStackTraces) return new Context();
    }
    function peekContext() {
      var lastIndex = contextStack.length - 1;
      if (lastIndex >= 0) {
        return contextStack[lastIndex];
      }
      return undefined;
    }
    Context.CapturedTrace = null;
    Context.create = createContext;
    Context.deactivateLongStackTraces = function () {};
    Context.activateLongStackTraces = function () {
      var Promise_pushContext = Promise.prototype._pushContext;
      var Promise_popContext = Promise.prototype._popContext;
      var Promise_PeekContext = Promise._peekContext;
      var Promise_peekContext = Promise.prototype._peekContext;
      var Promise_promiseCreated = Promise.prototype._promiseCreated;
      Context.deactivateLongStackTraces = function () {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
      };
      longStackTraces = true;
      Promise.prototype._pushContext = Context.prototype._pushContext;
      Promise.prototype._popContext = Context.prototype._popContext;
      Promise._peekContext = Promise.prototype._peekContext = peekContext;
      Promise.prototype._promiseCreated = function () {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
      };
    };
    return Context;
  };

  /***/
}, /* 18 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    "use strict";

    module.exports = function (Promise, Context) {
      var getDomain = Promise._getDomain;
      var async = Promise._async;
      var Warning = __webpack_require__(14).Warning;
      var util = __webpack_require__(7);
      var es5 = __webpack_require__(8);
      var canAttachTrace = util.canAttachTrace;
      var unhandledRejectionHandled;
      var possiblyUnhandledRejection;
      var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
      var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
      var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
      var stackFramePattern = null;
      var formatStack = null;
      var indentStackFrames = false;
      var printWarning;
      var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (false || util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
      var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
      var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
      var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
      Promise.prototype.suppressUnhandledRejections = function () {
        var target = this._target();
        target._bitField = target._bitField & ~1048576 | 524288;
      };
      Promise.prototype._ensurePossibleRejectionHandled = function () {
        if ((this._bitField & 524288) !== 0) return;
        this._setRejectionIsUnhandled();
        var self = this;
        setTimeout(function () {
          self._notifyUnhandledRejection();
        }, 1);
      };
      Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
      };
      Promise.prototype._setReturnedNonUndefined = function () {
        this._bitField = this._bitField | 268435456;
      };
      Promise.prototype._returnedNonUndefined = function () {
        return (this._bitField & 268435456) !== 0;
      };
      Promise.prototype._notifyUnhandledRejection = function () {
        if (this._isRejectionUnhandled()) {
          var reason = this._settledValue();
          this._setUnhandledRejectionIsNotified();
          fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
        }
      };
      Promise.prototype._setUnhandledRejectionIsNotified = function () {
        this._bitField = this._bitField | 262144;
      };
      Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
        this._bitField = this._bitField & ~262144;
      };
      Promise.prototype._isUnhandledRejectionNotified = function () {
        return (this._bitField & 262144) > 0;
      };
      Promise.prototype._setRejectionIsUnhandled = function () {
        this._bitField = this._bitField | 1048576;
      };
      Promise.prototype._unsetRejectionIsUnhandled = function () {
        this._bitField = this._bitField & ~1048576;
        if (this._isUnhandledRejectionNotified()) {
          this._unsetUnhandledRejectionIsNotified();
          this._notifyUnhandledRejectionIsHandled();
        }
      };
      Promise.prototype._isRejectionUnhandled = function () {
        return (this._bitField & 1048576) > 0;
      };
      Promise.prototype._warn = function (message, shouldUseOwnTrace, promise) {
        return warn(message, shouldUseOwnTrace, promise || this);
      };
      Promise.onPossiblyUnhandledRejection = function (fn) {
        var domain = getDomain();
        possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
      };
      Promise.onUnhandledRejectionHandled = function (fn) {
        var domain = getDomain();
        unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
      };
      var disableLongStackTraces = function disableLongStackTraces() {};
      Promise.longStackTraces = function () {
        if (async.haveItemsQueued() && !config.longStackTraces) {
          throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
        }
        if (!config.longStackTraces && longStackTracesIsSupported()) {
          var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
          var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
          var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
          config.longStackTraces = true;
          disableLongStackTraces = function disableLongStackTraces() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
              throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
          };
          Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
          Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
          Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
          Context.activateLongStackTraces();
          async.disableTrampolineIfNecessary();
        }
      };
      Promise.hasLongStackTraces = function () {
        return config.longStackTraces && longStackTracesIsSupported();
      };
      var fireDomEvent = function () {
        try {
          if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function (name, event) {
              var eventData = {
                detail: event,
                cancelable: true
              };
              es5.defineProperty(eventData, "promise", {
                value: event.promise
              });
              es5.defineProperty(eventData, "reason", {
                value: event.reason
              });
              var domEvent = new CustomEvent(name.toLowerCase(), eventData);
              return !util.global.dispatchEvent(domEvent);
            };
          } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function (name, event) {
              var domEvent = new Event(name.toLowerCase(), {
                cancelable: true
              });
              domEvent.detail = event;
              es5.defineProperty(domEvent, "promise", {
                value: event.promise
              });
              es5.defineProperty(domEvent, "reason", {
                value: event.reason
              });
              return !util.global.dispatchEvent(domEvent);
            };
          } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function (name, event) {
              var domEvent = document.createEvent("CustomEvent");
              domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
              return !util.global.dispatchEvent(domEvent);
            };
          }
        } catch (e) {}
        return function () {
          return false;
        };
      }();
      var fireGlobalEvent = function () {
        if (util.isNode) {
          return function () {
            return process.emit.apply(process, arguments);
          };
        } else {
          if (!util.global) {
            return function () {
              return false;
            };
          }
          return function (name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
          };
        }
      }();
      function generatePromiseLifecycleEventObject(name, promise) {
        return {
          promise: promise
        };
      }
      var eventToObjectGenerator = {
        promiseCreated: generatePromiseLifecycleEventObject,
        promiseFulfilled: generatePromiseLifecycleEventObject,
        promiseRejected: generatePromiseLifecycleEventObject,
        promiseResolved: generatePromiseLifecycleEventObject,
        promiseCancelled: generatePromiseLifecycleEventObject,
        promiseChained: function promiseChained(name, promise, child) {
          return {
            promise: promise,
            child: child
          };
        },
        warning: function warning(name, _warning) {
          return {
            warning: _warning
          };
        },
        unhandledRejection: function unhandledRejection(name, reason, promise) {
          return {
            reason: reason,
            promise: promise
          };
        },
        rejectionHandled: generatePromiseLifecycleEventObject
      };
      var activeFireEvent = function activeFireEvent(name) {
        var globalEventFired = false;
        try {
          globalEventFired = fireGlobalEvent.apply(null, arguments);
        } catch (e) {
          async.throwLater(e);
          globalEventFired = true;
        }
        var domEventFired = false;
        try {
          domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
        } catch (e) {
          async.throwLater(e);
          domEventFired = true;
        }
        return domEventFired || globalEventFired;
      };
      Promise.config = function (opts) {
        opts = Object(opts);
        if ("longStackTraces" in opts) {
          if (opts.longStackTraces) {
            Promise.longStackTraces();
          } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
          }
        }
        if ("warnings" in opts) {
          var warningsOption = opts.warnings;
          config.warnings = !!warningsOption;
          wForgottenReturn = config.warnings;
          if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
              wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
          }
        }
        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
          if (async.haveItemsQueued()) {
            throw new Error("cannot enable cancellation after promises are in use");
          }
          Promise.prototype._clearCancellationData = cancellationClearCancellationData;
          Promise.prototype._propagateFrom = cancellationPropagateFrom;
          Promise.prototype._onCancel = cancellationOnCancel;
          Promise.prototype._setOnCancel = cancellationSetOnCancel;
          Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
          Promise.prototype._execute = cancellationExecute;
          _propagateFromFunction = cancellationPropagateFrom;
          config.cancellation = true;
        }
        if ("monitoring" in opts) {
          if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
          } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
          }
        }
        return Promise;
      };
      function defaultFireEvent() {
        return false;
      }
      Promise.prototype._fireEvent = defaultFireEvent;
      Promise.prototype._execute = function (executor, resolve, reject) {
        try {
          executor(resolve, reject);
        } catch (e) {
          return e;
        }
      };
      Promise.prototype._onCancel = function () {};
      Promise.prototype._setOnCancel = function (handler) {
        ;
      };
      Promise.prototype._attachCancellationCallback = function (onCancel) {
        ;
      };
      Promise.prototype._captureStackTrace = function () {};
      Promise.prototype._attachExtraTrace = function () {};
      Promise.prototype._dereferenceTrace = function () {};
      Promise.prototype._clearCancellationData = function () {};
      Promise.prototype._propagateFrom = function (parent, flags) {
        ;
        ;
      };
      function cancellationExecute(executor, resolve, reject) {
        var promise = this;
        try {
          executor(resolve, reject, function (onCancel) {
            if (typeof onCancel !== "function") {
              throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
          });
        } catch (e) {
          return e;
        }
      }
      function cancellationAttachCancellationCallback(onCancel) {
        if (!this._isCancellable()) return this;
        var previousOnCancel = this._onCancel();
        if (previousOnCancel !== undefined) {
          if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
          } else {
            this._setOnCancel([previousOnCancel, onCancel]);
          }
        } else {
          this._setOnCancel(onCancel);
        }
      }
      function cancellationOnCancel() {
        return this._onCancelField;
      }
      function cancellationSetOnCancel(onCancel) {
        this._onCancelField = onCancel;
      }
      function cancellationClearCancellationData() {
        this._cancellationParent = undefined;
        this._onCancelField = undefined;
      }
      function cancellationPropagateFrom(parent, flags) {
        if ((flags & 1) !== 0) {
          this._cancellationParent = parent;
          var branchesRemainingToCancel = parent._branchesRemainingToCancel;
          if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
          }
          parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
        }
        if ((flags & 2) !== 0 && parent._isBound()) {
          this._setBoundTo(parent._boundTo);
        }
      }
      function bindingPropagateFrom(parent, flags) {
        if ((flags & 2) !== 0 && parent._isBound()) {
          this._setBoundTo(parent._boundTo);
        }
      }
      var _propagateFromFunction = bindingPropagateFrom;
      function _boundValueFunction() {
        var ret = this._boundTo;
        if (ret !== undefined) {
          if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
              return ret.value();
            } else {
              return undefined;
            }
          }
        }
        return ret;
      }
      function longStackTracesCaptureStackTrace() {
        this._trace = new CapturedTrace(this._peekContext());
      }
      function longStackTracesAttachExtraTrace(error, ignoreSelf) {
        if (canAttachTrace(error)) {
          var trace = this._trace;
          if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
          }
          if (trace !== undefined) {
            trace.attachExtraTrace(error);
          } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
          }
        }
      }
      function longStackTracesDereferenceTrace() {
        this._trace = undefined;
      }
      function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
          if (parent !== undefined && parent._returnedNonUndefined()) return;
          if ((promise._bitField & 65535) === 0) return;
          if (name) name = name + " ";
          var handlerLine = "";
          var creatorLine = "";
          if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
              var line = stack[i];
              if (!nodeFramePattern.test(line)) {
                var lineMatches = line.match(parseLinePattern);
                if (lineMatches) {
                  handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                }
                break;
              }
            }
            if (stack.length > 0) {
              var firstUserLine = stack[0];
              for (var i = 0; i < traceLines.length; ++i) {
                if (traceLines[i] === firstUserLine) {
                  if (i > 0) {
                    creatorLine = "\n" + traceLines[i - 1];
                  }
                  break;
                }
              }
            }
          }
          var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
          promise._warn(msg, true, promiseCreated);
        }
      }
      function deprecated(name, replacement) {
        var message = name + " is deprecated and will be removed in a future version.";
        if (replacement) message += " Use " + replacement + " instead.";
        return warn(message);
      }
      function warn(message, shouldUseOwnTrace, promise) {
        if (!config.warnings) return;
        var warning = new Warning(message);
        var ctx;
        if (shouldUseOwnTrace) {
          promise._attachExtraTrace(warning);
        } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
          ctx.attachExtraTrace(warning);
        } else {
          var parsed = parseStackAndMessage(warning);
          warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
        }
        if (!activeFireEvent("warning", warning)) {
          formatAndLogError(warning, "", true);
        }
      }
      function reconstructStack(message, stacks) {
        for (var i = 0; i < stacks.length - 1; ++i) {
          stacks[i].push("From previous event:");
          stacks[i] = stacks[i].join("\n");
        }
        if (i < stacks.length) {
          stacks[i] = stacks[i].join("\n");
        }
        return message + "\n" + stacks.join("\n");
      }
      function removeDuplicateOrEmptyJumps(stacks) {
        for (var i = 0; i < stacks.length; ++i) {
          if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
            stacks.splice(i, 1);
            i--;
          }
        }
      }
      function removeCommonRoots(stacks) {
        var current = stacks[0];
        for (var i = 1; i < stacks.length; ++i) {
          var prev = stacks[i];
          var currentLastIndex = current.length - 1;
          var currentLastLine = current[currentLastIndex];
          var commonRootMeetPoint = -1;
          for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
              commonRootMeetPoint = j;
              break;
            }
          }
          for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
              current.pop();
              currentLastIndex--;
            } else {
              break;
            }
          }
          current = prev;
        }
      }
      function cleanStack(stack) {
        var ret = [];
        for (var i = 0; i < stack.length; ++i) {
          var line = stack[i];
          var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
          var isInternalFrame = isTraceLine && shouldIgnore(line);
          if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
              line = "    " + line;
            }
            ret.push(line);
          }
        }
        return ret;
      }
      function stackFramesAsArray(error) {
        var stack = error.stack.replace(/\s+$/g, "").split("\n");
        for (var i = 0; i < stack.length; ++i) {
          var line = stack[i];
          if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
          }
        }
        if (i > 0 && error.name != "SyntaxError") {
          stack = stack.slice(i);
        }
        return stack;
      }
      function parseStackAndMessage(error) {
        var stack = error.stack;
        var message = error.toString();
        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
        return {
          message: message,
          stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
        };
      }
      function formatAndLogError(error, title, isSoft) {
        if (typeof console !== "undefined") {
          var message;
          if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
          } else {
            message = title + String(error);
          }
          if (typeof printWarning === "function") {
            printWarning(message, isSoft);
          } else if (typeof console.log === "function" || typeof console.log === "object") {
            console.log(message);
          }
        }
      }
      function fireRejectionEvent(name, localHandler, reason, promise) {
        var localEventFired = false;
        try {
          if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
              localHandler(promise);
            } else {
              localHandler(reason, promise);
            }
          }
        } catch (e) {
          async.throwLater(e);
        }
        if (name === "unhandledRejection") {
          if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
          }
        } else {
          activeFireEvent(name, promise);
        }
      }
      function formatNonError(obj) {
        var str;
        if (typeof obj === "function") {
          str = "[function " + (obj.name || "anonymous") + "]";
        } else {
          str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
          var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
          if (ruselessToString.test(str)) {
            try {
              var newStr = JSON.stringify(obj);
              str = newStr;
            } catch (e) {}
          }
          if (str.length === 0) {
            str = "(empty array)";
          }
        }
        return "(<" + snip(str) + ">, no stack trace)";
      }
      function snip(str) {
        var maxChars = 41;
        if (str.length < maxChars) {
          return str;
        }
        return str.substr(0, maxChars - 3) + "...";
      }
      function longStackTracesIsSupported() {
        return typeof captureStackTrace === "function";
      }
      var shouldIgnore = function shouldIgnore() {
        return false;
      };
      var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
      function parseLineInfo(line) {
        var matches = line.match(parseLineInfoRegex);
        if (matches) {
          return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
          };
        }
      }
      function setBounds(firstLineError, lastLineError) {
        if (!longStackTracesIsSupported()) return;
        var firstStackLines = firstLineError.stack.split("\n");
        var lastStackLines = lastLineError.stack.split("\n");
        var firstIndex = -1;
        var lastIndex = -1;
        var firstFileName;
        var lastFileName;
        for (var i = 0; i < firstStackLines.length; ++i) {
          var result = parseLineInfo(firstStackLines[i]);
          if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
          }
        }
        for (var i = 0; i < lastStackLines.length; ++i) {
          var result = parseLineInfo(lastStackLines[i]);
          if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
          }
        }
        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
          return;
        }
        shouldIgnore = function shouldIgnore(line) {
          if (bluebirdFramePattern.test(line)) return true;
          var info = parseLineInfo(line);
          if (info) {
            if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
              return true;
            }
          }
          return false;
        };
      }
      function CapturedTrace(parent) {
        this._parent = parent;
        this._promisesCreated = 0;
        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
        captureStackTrace(this, CapturedTrace);
        if (length > 32) this.uncycle();
      }
      util.inherits(CapturedTrace, Error);
      Context.CapturedTrace = CapturedTrace;
      CapturedTrace.prototype.uncycle = function () {
        var length = this._length;
        if (length < 2) return;
        var nodes = [];
        var stackToIndex = {};
        for (var i = 0, node = this; node !== undefined; ++i) {
          nodes.push(node);
          node = node._parent;
        }
        length = this._length = i;
        for (var i = length - 1; i >= 0; --i) {
          var stack = nodes[i].stack;
          if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
          }
        }
        for (var i = 0; i < length; ++i) {
          var currentStack = nodes[i].stack;
          var index = stackToIndex[currentStack];
          if (index !== undefined && index !== i) {
            if (index > 0) {
              nodes[index - 1]._parent = undefined;
              nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
            if (index < length - 1) {
              cycleEdgeNode._parent = nodes[index + 1];
              cycleEdgeNode._parent.uncycle();
              cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
            } else {
              cycleEdgeNode._parent = undefined;
              cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
              nodes[j]._length = currentChildLength;
              currentChildLength++;
            }
            return;
          }
        }
      };
      CapturedTrace.prototype.attachExtraTrace = function (error) {
        if (error.__stackCleaned__) return;
        this.uncycle();
        var parsed = parseStackAndMessage(error);
        var message = parsed.message;
        var stacks = [parsed.stack];
        var trace = this;
        while (trace !== undefined) {
          stacks.push(cleanStack(trace.stack.split("\n")));
          trace = trace._parent;
        }
        removeCommonRoots(stacks);
        removeDuplicateOrEmptyJumps(stacks);
        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
        util.notEnumerableProp(error, "__stackCleaned__", true);
      };
      var captureStackTrace = function stackDetection() {
        var v8stackFramePattern = /^\s*at\s*/;
        var v8stackFormatter = function v8stackFormatter(stack, error) {
          if (typeof stack === "string") return stack;
          if (error.name !== undefined && error.message !== undefined) {
            return error.toString();
          }
          return formatNonError(error);
        };
        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
          Error.stackTraceLimit += 6;
          stackFramePattern = v8stackFramePattern;
          formatStack = v8stackFormatter;
          var captureStackTrace = Error.captureStackTrace;
          shouldIgnore = function shouldIgnore(line) {
            return bluebirdFramePattern.test(line);
          };
          return function (receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
          };
        }
        var err = new Error();
        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
          stackFramePattern = /@/;
          formatStack = v8stackFormatter;
          indentStackFrames = true;
          return function captureStackTrace(o) {
            o.stack = new Error().stack;
          };
        }
        var hasStackAfterThrow;
        try {
          throw new Error();
        } catch (e) {
          hasStackAfterThrow = "stack" in e;
        }
        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
          stackFramePattern = v8stackFramePattern;
          formatStack = v8stackFormatter;
          return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try {
              throw new Error();
            } catch (e) {
              o.stack = e.stack;
            }
            Error.stackTraceLimit -= 6;
          };
        }
        formatStack = function formatStack(stack, error) {
          if (typeof stack === "string") return stack;
          if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
            return error.toString();
          }
          return formatNonError(error);
        };
        return null;
      }([]);
      if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
        printWarning = function printWarning(message) {
          console.warn(message);
        };
        if (util.isNode && process.stderr.isTTY) {
          printWarning = function printWarning(message, isSoft) {
            var color = isSoft ? "\x1B[33m" : "\x1B[31m";
            console.warn(color + message + "\x1B[0m\n");
          };
        } else if (!util.isNode && typeof new Error().stack === "string") {
          printWarning = function printWarning(message, isSoft) {
            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
          };
        }
      }
      var config = {
        warnings: warnings,
        longStackTraces: false,
        cancellation: false,
        monitoring: false
      };
      if (longStackTraces) Promise.longStackTraces();
      return {
        longStackTraces: function longStackTraces() {
          return config.longStackTraces;
        },
        warnings: function warnings() {
          return config.warnings;
        },
        cancellation: function cancellation() {
          return config.cancellation;
        },
        monitoring: function monitoring() {
          return config.monitoring;
        },
        propagateFromFunction: function propagateFromFunction() {
          return _propagateFromFunction;
        },
        boundValueFunction: function boundValueFunction() {
          return _boundValueFunction;
        },
        checkForgottenReturns: checkForgottenReturns,
        setBounds: setBounds,
        warn: warn,
        deprecated: deprecated,
        CapturedTrace: CapturedTrace,
        fireDomEvent: fireDomEvent,
        fireGlobalEvent: fireGlobalEvent
      };
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 19 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, tryConvertToPromise, NEXT_FILTER) {
    var util = __webpack_require__(7);
    var CancellationError = Promise.CancellationError;
    var errorObj = util.errorObj;
    var catchFilter = __webpack_require__(20)(NEXT_FILTER);
    function PassThroughHandlerContext(promise, type, handler) {
      this.promise = promise;
      this.type = type;
      this.handler = handler;
      this.called = false;
      this.cancelPromise = null;
    }
    PassThroughHandlerContext.prototype.isFinallyHandler = function () {
      return this.type === 0;
    };
    function FinallyHandlerCancelReaction(finallyHandler) {
      this.finallyHandler = finallyHandler;
    }
    FinallyHandlerCancelReaction.prototype._resultCancelled = function () {
      checkCancel(this.finallyHandler);
    };
    function checkCancel(ctx, reason) {
      if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
          ctx.cancelPromise._reject(reason);
        } else {
          ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
      }
      return false;
    }
    function succeed() {
      return finallyHandler.call(this, this.promise._target()._settledValue());
    }
    function fail(reason) {
      if (checkCancel(this, reason)) return;
      errorObj.e = reason;
      return errorObj;
    }
    function finallyHandler(reasonOrValue) {
      var promise = this.promise;
      var handler = this.handler;
      if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
          return ret;
        } else if (ret !== undefined) {
          promise._setReturnedNonUndefined();
          var maybePromise = tryConvertToPromise(ret, promise);
          if (maybePromise instanceof Promise) {
            if (this.cancelPromise != null) {
              if (maybePromise._isCancelled()) {
                var reason = new CancellationError("late cancellation observer");
                promise._attachExtraTrace(reason);
                errorObj.e = reason;
                return errorObj;
              } else if (maybePromise.isPending()) {
                maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
              }
            }
            return maybePromise._then(succeed, fail, undefined, this, undefined);
          }
        }
      }
      if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
      } else {
        checkCancel(this);
        return reasonOrValue;
      }
    }
    Promise.prototype._passThrough = function (handler, type, success, fail) {
      if (typeof handler !== "function") return this.then();
      return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
    };
    Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
      return this._passThrough(handler, 0, finallyHandler, finallyHandler);
    };
    Promise.prototype.tap = function (handler) {
      return this._passThrough(handler, 1, finallyHandler);
    };
    Promise.prototype.tapCatch = function (handlerOrPredicate) {
      var len = arguments.length;
      if (len === 1) {
        return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
      } else {
        var catchInstances = new Array(len - 1),
          j = 0,
          i;
        for (i = 0; i < len - 1; ++i) {
          var item = arguments[i];
          if (util.isObject(item)) {
            catchInstances[j++] = item;
          } else {
            return Promise.reject(new TypeError("tapCatch statement predicate: " + "expecting an object but got " + util.classString(item)));
          }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
      }
    };
    return PassThroughHandlerContext;
  };

  /***/
}, /* 20 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (NEXT_FILTER) {
    var util = __webpack_require__(7);
    var getKeys = __webpack_require__(8).keys;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function catchFilter(instances, cb, promise) {
      return function (e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
          var item = instances[i];
          if (item === Error || item != null && item.prototype instanceof Error) {
            if (e instanceof item) {
              return tryCatch(cb).call(boundTo, e);
            }
          } else if (typeof item === "function") {
            var matchesPredicate = tryCatch(item).call(boundTo, e);
            if (matchesPredicate === errorObj) {
              return matchesPredicate;
            } else if (matchesPredicate) {
              return tryCatch(cb).call(boundTo, e);
            }
          } else if (util.isObject(e)) {
            var keys = getKeys(item);
            for (var j = 0; j < keys.length; ++j) {
              var key = keys[j];
              if (item[key] != e[key]) {
                continue predicateLoop;
              }
            }
            return tryCatch(cb).call(boundTo, e);
          }
        }
        return NEXT_FILTER;
      };
    }
    return catchFilter;
  };

  /***/
}, /* 21 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var util = __webpack_require__(7);
  var maybeWrapAsError = util.maybeWrapAsError;
  var errors = __webpack_require__(14);
  var OperationalError = errors.OperationalError;
  var es5 = __webpack_require__(8);
  function isUntypedError(obj) {
    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
  }
  var rErrorKey = /^(?:name|message|stack|cause)$/;
  function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
      ret = new OperationalError(obj);
      ret.name = obj.name;
      ret.message = obj.message;
      ret.stack = obj.stack;
      var keys = es5.keys(obj);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (!rErrorKey.test(key)) {
          ret[key] = obj[key];
        }
      }
      return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
  }
  function nodebackForPromise(promise, multiArgs) {
    return function (err, value) {
      if (promise === null) return;
      if (err) {
        var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
        promise._attachExtraTrace(wrapped);
        promise._reject(wrapped);
      } else if (!multiArgs) {
        promise._fulfill(value);
      } else {
        var $_len = arguments.length;
        var args = new Array(Math.max($_len - 1, 0));
        for (var $_i = 1; $_i < $_len; ++$_i) {
          args[$_i - 1] = arguments[$_i];
        }
        ;
        promise._fulfill(args);
      }
      promise = null;
    };
  }
  module.exports = nodebackForPromise;

  /***/
}, /* 22 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
    var util = __webpack_require__(7);
    var tryCatch = util.tryCatch;
    Promise.method = function (fn) {
      if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
      }
      return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
      };
    };
    Promise.attempt = Promise["try"] = function (fn) {
      if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
      }
      var ret = new Promise(INTERNAL);
      ret._captureStackTrace();
      ret._pushContext();
      var value;
      if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
      } else {
        value = tryCatch(fn)();
      }
      var promiseCreated = ret._popContext();
      debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
      ret._resolveFromSyncValue(value);
      return ret;
    };
    Promise.prototype._resolveFromSyncValue = function (value) {
      if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
      } else {
        this._resolveCallback(value, true);
      }
    };
  };

  /***/
}, /* 23 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise, INTERNAL, tryConvertToPromise, debug) {
    var calledBind = false;
    var rejectThis = function rejectThis(_, e) {
      this._reject(e);
    };
    var targetRejected = function targetRejected(e, context) {
      context.promiseRejectionQueued = true;
      context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
    };
    var bindingResolved = function bindingResolved(thisArg, context) {
      if ((this._bitField & 50397184) === 0) {
        this._resolveCallback(context.target);
      }
    };
    var bindingRejected = function bindingRejected(e, context) {
      if (!context.promiseRejectionQueued) this._reject(e);
    };
    Promise.prototype.bind = function (thisArg) {
      if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
      }
      var maybePromise = tryConvertToPromise(thisArg);
      var ret = new Promise(INTERNAL);
      ret._propagateFrom(this, 1);
      var target = this._target();
      ret._setBoundTo(maybePromise);
      if (maybePromise instanceof Promise) {
        var context = {
          promiseRejectionQueued: false,
          promise: ret,
          target: target,
          bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
      } else {
        ret._resolveCallback(target);
      }
      return ret;
    };
    Promise.prototype._setBoundTo = function (obj) {
      if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
      } else {
        this._bitField = this._bitField & ~2097152;
      }
    };
    Promise.prototype._isBound = function () {
      return (this._bitField & 2097152) === 2097152;
    };
    Promise.bind = function (thisArg, value) {
      return Promise.resolve(value).bind(thisArg);
    };
  };

  /***/
}, /* 24 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, apiRejection, debug) {
    var util = __webpack_require__(7);
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    Promise.prototype["break"] = Promise.prototype.cancel = function () {
      if (!debug.cancellation()) return this._warn("cancellation is disabled");
      var promise = this;
      var child = promise;
      while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
          if (child._isFollowing()) {
            child._followee().cancel();
          } else {
            child._cancelBranched();
          }
          break;
        }
        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
          if (promise._isFollowing()) {
            promise._followee().cancel();
          } else {
            promise._cancelBranched();
          }
          break;
        } else {
          if (promise._isFollowing()) promise._followee().cancel();
          promise._setWillBeCancelled();
          child = promise;
          promise = parent;
        }
      }
    };
    Promise.prototype._branchHasCancelled = function () {
      this._branchesRemainingToCancel--;
    };
    Promise.prototype._enoughBranchesHaveCancelled = function () {
      return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
    };
    Promise.prototype._cancelBy = function (canceller) {
      if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
      } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
          this._invokeOnCancel();
          return true;
        }
      }
      return false;
    };
    Promise.prototype._cancelBranched = function () {
      if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
      }
    };
    Promise.prototype._cancel = function () {
      if (!this._isCancellable()) return;
      this._setCancelled();
      async.invoke(this._cancelPromises, this, undefined);
    };
    Promise.prototype._cancelPromises = function () {
      if (this._length() > 0) this._settlePromises();
    };
    Promise.prototype._unsetOnCancel = function () {
      this._onCancelField = undefined;
    };
    Promise.prototype._isCancellable = function () {
      return this.isPending() && !this._isCancelled();
    };
    Promise.prototype.isCancellable = function () {
      return this.isPending() && !this.isCancelled();
    };
    Promise.prototype._doInvokeOnCancel = function (onCancelCallback, internalOnly) {
      if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
          this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
      } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
          if (!internalOnly) {
            var e = tryCatch(onCancelCallback).call(this._boundValue());
            if (e === errorObj) {
              this._attachExtraTrace(e.e);
              async.throwLater(e.e);
            }
          }
        } else {
          onCancelCallback._resultCancelled(this);
        }
      }
    };
    Promise.prototype._invokeOnCancel = function () {
      var onCancelCallback = this._onCancel();
      this._unsetOnCancel();
      async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
    };
    Promise.prototype._invokeInternalOnCancel = function () {
      if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
      }
    };
    Promise.prototype._resultCancelled = function () {
      this.cancel();
    };
  };

  /***/
}, /* 25 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise) {
    function returner() {
      return this.value;
    }
    function thrower() {
      throw this.reason;
    }
    Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
      if (value instanceof Promise) value.suppressUnhandledRejections();
      return this._then(returner, undefined, undefined, {
        value: value
      }, undefined);
    };
    Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
      return this._then(thrower, undefined, undefined, {
        reason: reason
      }, undefined);
    };
    Promise.prototype.catchThrow = function (reason) {
      if (arguments.length <= 1) {
        return this._then(undefined, thrower, undefined, {
          reason: reason
        }, undefined);
      } else {
        var _reason = arguments[1];
        var handler = function handler() {
          throw _reason;
        };
        return this.caught(reason, handler);
      }
    };
    Promise.prototype.catchReturn = function (value) {
      if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(undefined, returner, undefined, {
          value: value
        }, undefined);
      } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function handler() {
          return _value;
        };
        return this.caught(value, handler);
      }
    };
  };

  /***/
}, /* 26 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise) {
    function PromiseInspection(promise) {
      if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
      } else {
        this._bitField = 0;
        this._settledValueField = undefined;
      }
    }
    PromiseInspection.prototype._settledValue = function () {
      return this._settledValueField;
    };
    var value = PromiseInspection.prototype.value = function () {
      if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
      }
      return this._settledValue();
    };
    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
      if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
      }
      return this._settledValue();
    };
    var isFulfilled = PromiseInspection.prototype.isFulfilled = function () {
      return (this._bitField & 33554432) !== 0;
    };
    var isRejected = PromiseInspection.prototype.isRejected = function () {
      return (this._bitField & 16777216) !== 0;
    };
    var isPending = PromiseInspection.prototype.isPending = function () {
      return (this._bitField & 50397184) === 0;
    };
    var isResolved = PromiseInspection.prototype.isResolved = function () {
      return (this._bitField & 50331648) !== 0;
    };
    PromiseInspection.prototype.isCancelled = function () {
      return (this._bitField & 8454144) !== 0;
    };
    Promise.prototype.__isCancelled = function () {
      return (this._bitField & 65536) === 65536;
    };
    Promise.prototype._isCancelled = function () {
      return this._target().__isCancelled();
    };
    Promise.prototype.isCancelled = function () {
      return (this._target()._bitField & 8454144) !== 0;
    };
    Promise.prototype.isPending = function () {
      return isPending.call(this._target());
    };
    Promise.prototype.isRejected = function () {
      return isRejected.call(this._target());
    };
    Promise.prototype.isFulfilled = function () {
      return isFulfilled.call(this._target());
    };
    Promise.prototype.isResolved = function () {
      return isResolved.call(this._target());
    };
    Promise.prototype.value = function () {
      return value.call(this._target());
    };
    Promise.prototype.reason = function () {
      var target = this._target();
      target._unsetRejectionIsUnhandled();
      return reason.call(target);
    };
    Promise.prototype._value = function () {
      return this._settledValue();
    };
    Promise.prototype._reason = function () {
      this._unsetRejectionIsUnhandled();
      return this._settledValue();
    };
    Promise.PromiseInspection = PromiseInspection;
  };

  /***/
}, /* 27 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain) {
    var util = __webpack_require__(7);
    var canEvaluate = util.canEvaluate;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var reject;
    if (true) {
      if (canEvaluate) {
        var thenCallback = function thenCallback(i) {
          return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
        };
        var promiseSetter = function promiseSetter(i) {
          return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
        };
        var generateHolderClass = function generateHolderClass(total) {
          var props = new Array(total);
          for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i + 1);
          }
          var assignment = props.join(" = ") + " = null;";
          var cancellationCode = "var promise;\n" + props.map(function (prop) {
            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
          }).join("\n");
          var passedArguments = props.join(", ");
          var name = "Holder$" + total;
          var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
          code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
          return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
        };
        var holderClasses = [];
        var thenCallbacks = [];
        var promiseSetters = [];
        for (var i = 0; i < 8; ++i) {
          holderClasses.push(generateHolderClass(i + 1));
          thenCallbacks.push(thenCallback(i + 1));
          promiseSetters.push(promiseSetter(i + 1));
        }
        reject = function reject(reason) {
          this._reject(reason);
        };
      }
    }
    Promise.join = function () {
      var last = arguments.length - 1;
      var fn;
      if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (true) {
          if (last <= 8 && canEvaluate) {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            var HolderClass = holderClasses[last - 1];
            var holder = new HolderClass(fn);
            var callbacks = thenCallbacks;
            for (var i = 0; i < last; ++i) {
              var maybePromise = tryConvertToPromise(arguments[i], ret);
              if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                ;
                if ((bitField & 50397184) === 0) {
                  maybePromise._then(callbacks[i], reject, undefined, ret, holder);
                  promiseSetters[i](maybePromise, holder);
                  holder.asyncNeeded = false;
                } else if ((bitField & 33554432) !== 0) {
                  callbacks[i].call(ret, maybePromise._value(), holder);
                } else if ((bitField & 16777216) !== 0) {
                  ret._reject(maybePromise._reason());
                } else {
                  ret._cancel();
                }
              } else {
                callbacks[i].call(ret, maybePromise, holder);
              }
            }
            if (!ret._isFateSealed()) {
              if (holder.asyncNeeded) {
                var domain = getDomain();
                if (domain !== null) {
                  holder.fn = util.domainBind(domain, holder.fn);
                }
              }
              ret._setAsyncGuaranteed();
              ret._setOnCancel(holder);
            }
            return ret;
          }
        }
      }
      var $_len = arguments.length;
      var args = new Array($_len);
      for (var $_i = 0; $_i < $_len; ++$_i) {
        args[$_i] = arguments[$_i];
      }
      ;
      if (fn) args.pop();
      var ret = new PromiseArray(args).promise();
      return fn !== undefined ? ret.spread(fn) : ret;
    };
  };

  /***/
}, /* 28 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = __webpack_require__(7);
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    function MappingPromiseArray(promises, fn, limit, _filter) {
      this.constructor$(promises);
      this._promise._captureStackTrace();
      var domain = getDomain();
      this._callback = domain === null ? fn : util.domainBind(domain, fn);
      this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
      this._limit = limit;
      this._inFlight = 0;
      this._queue = [];
      async.invoke(this._asyncInit, this, undefined);
    }
    util.inherits(MappingPromiseArray, PromiseArray);
    MappingPromiseArray.prototype._asyncInit = function () {
      this._init$(undefined, -2);
    };
    MappingPromiseArray.prototype._init = function () {};
    MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
      var values = this._values;
      var length = this.length();
      var preservedValues = this._preservedValues;
      var limit = this._limit;
      if (index < 0) {
        index = index * -1 - 1;
        values[index] = value;
        if (limit >= 1) {
          this._inFlight--;
          this._drainQueue();
          if (this._isResolved()) return true;
        }
      } else {
        if (limit >= 1 && this._inFlight >= limit) {
          values[index] = value;
          this._queue.push(index);
          return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;
        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
        if (ret === errorObj) {
          this._reject(ret.e);
          return true;
        }
        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
          maybePromise = maybePromise._target();
          var bitField = maybePromise._bitField;
          ;
          if ((bitField & 50397184) === 0) {
            if (limit >= 1) this._inFlight++;
            values[index] = maybePromise;
            maybePromise._proxy(this, (index + 1) * -1);
            return false;
          } else if ((bitField & 33554432) !== 0) {
            ret = maybePromise._value();
          } else if ((bitField & 16777216) !== 0) {
            this._reject(maybePromise._reason());
            return true;
          } else {
            this._cancel();
            return true;
          }
        }
        values[index] = ret;
      }
      var totalResolved = ++this._totalResolved;
      if (totalResolved >= length) {
        if (preservedValues !== null) {
          this._filter(values, preservedValues);
        } else {
          this._resolve(values);
        }
        return true;
      }
      return false;
    };
    MappingPromiseArray.prototype._drainQueue = function () {
      var queue = this._queue;
      var limit = this._limit;
      var values = this._values;
      while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
      }
    };
    MappingPromiseArray.prototype._filter = function (booleans, values) {
      var len = values.length;
      var ret = new Array(len);
      var j = 0;
      for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
      }
      ret.length = j;
      this._resolve(ret);
    };
    MappingPromiseArray.prototype.preservedValues = function () {
      return this._preservedValues;
    };
    function map(promises, fn, options, _filter) {
      if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
      }
      var limit = 0;
      if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
          if (typeof options.concurrency !== "number") {
            return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
          }
          limit = options.concurrency;
        } else {
          return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
        }
      }
      limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
      return new MappingPromiseArray(promises, fn, limit, _filter).promise();
    }
    Promise.prototype.map = function (fn, options) {
      return map(this, fn, options, null);
    };
    Promise.map = function (promises, fn, options, _filter) {
      return map(promises, fn, options, _filter);
    };
  };

  /***/
}, /* 29 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var cr = Object.create;
  if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
  }
  module.exports = function (Promise) {
    var util = __webpack_require__(7);
    var canEvaluate = util.canEvaluate;
    var isIdentifier = util.isIdentifier;
    var getMethodCaller;
    var getGetter;
    if (true) {
      var makeMethodCaller = function makeMethodCaller(methodName) {
        return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
      };
      var makeGetter = function makeGetter(propertyName) {
        return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
      };
      var getCompiled = function getCompiled(name, compiler, cache) {
        var ret = cache[name];
        if (typeof ret !== "function") {
          if (!isIdentifier(name)) {
            return null;
          }
          ret = compiler(name);
          cache[name] = ret;
          cache[" size"]++;
          if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
          }
        }
        return ret;
      };
      getMethodCaller = function getMethodCaller(name) {
        return getCompiled(name, makeMethodCaller, callerCache);
      };
      getGetter = function getGetter(name) {
        return getCompiled(name, makeGetter, getterCache);
      };
    }
    function ensureMethod(obj, methodName) {
      var fn;
      if (obj != null) fn = obj[methodName];
      if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
      }
      return fn;
    }
    function caller(obj) {
      var methodName = this.pop();
      var fn = ensureMethod(obj, methodName);
      return fn.apply(obj, this);
    }
    Promise.prototype.call = function (methodName) {
      var $_len = arguments.length;
      var args = new Array(Math.max($_len - 1, 0));
      for (var $_i = 1; $_i < $_len; ++$_i) {
        args[$_i - 1] = arguments[$_i];
      }
      ;
      if (true) {
        if (canEvaluate) {
          var maybeCaller = getMethodCaller(methodName);
          if (maybeCaller !== null) {
            return this._then(maybeCaller, undefined, undefined, args, undefined);
          }
        }
      }
      args.push(methodName);
      return this._then(caller, undefined, undefined, args, undefined);
    };
    function namedGetter(obj) {
      return obj[this];
    }
    function indexedGetter(obj) {
      var index = +this;
      if (index < 0) index = Math.max(0, index + obj.length);
      return obj[index];
    }
    Promise.prototype.get = function (propertyName) {
      var isIndex = typeof propertyName === "number";
      var getter;
      if (!isIndex) {
        if (canEvaluate) {
          var maybeGetter = getGetter(propertyName);
          getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
          getter = namedGetter;
        }
      } else {
        getter = indexedGetter;
      }
      return this._then(getter, undefined, undefined, propertyName, undefined);
    };
  };

  /***/
}, /* 30 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
    var util = __webpack_require__(7);
    var TypeError = __webpack_require__(14).TypeError;
    var inherits = __webpack_require__(7).inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};
    function thrower(e) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
    function castPreservingDisposable(thenable) {
      var maybePromise = tryConvertToPromise(thenable);
      if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
        maybePromise._setDisposable(thenable._getDisposer());
      }
      return maybePromise;
    }
    function dispose(resources, inspection) {
      var i = 0;
      var len = resources.length;
      var ret = new Promise(INTERNAL);
      function iterator() {
        if (i >= len) return ret._fulfill();
        var maybePromise = castPreservingDisposable(resources[i++]);
        if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
          try {
            maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
          } catch (e) {
            return thrower(e);
          }
          if (maybePromise instanceof Promise) {
            return maybePromise._then(iterator, thrower, null, null, null);
          }
        }
        iterator();
      }
      iterator();
      return ret;
    }
    function Disposer(data, promise, context) {
      this._data = data;
      this._promise = promise;
      this._context = context;
    }
    Disposer.prototype.data = function () {
      return this._data;
    };
    Disposer.prototype.promise = function () {
      return this._promise;
    };
    Disposer.prototype.resource = function () {
      if (this.promise().isFulfilled()) {
        return this.promise().value();
      }
      return NULL;
    };
    Disposer.prototype.tryDispose = function (inspection) {
      var resource = this.resource();
      var context = this._context;
      if (context !== undefined) context._pushContext();
      var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
      if (context !== undefined) context._popContext();
      this._promise._unsetDisposable();
      this._data = null;
      return ret;
    };
    Disposer.isDisposer = function (d) {
      return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
    };
    function FunctionDisposer(fn, promise, context) {
      this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);
    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
      var fn = this.data();
      return fn.call(resource, resource, inspection);
    };
    function maybeUnwrapDisposer(value) {
      if (Disposer.isDisposer(value)) {
        this.resources[this.index]._setDisposable(value);
        return value.promise();
      }
      return value;
    }
    function ResourceList(length) {
      this.length = length;
      this.promise = null;
      this[length - 1] = null;
    }
    ResourceList.prototype._resultCancelled = function () {
      var len = this.length;
      for (var i = 0; i < len; ++i) {
        var item = this[i];
        if (item instanceof Promise) {
          item.cancel();
        }
      }
    };
    Promise.using = function () {
      var len = arguments.length;
      if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
      var fn = arguments[len - 1];
      if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
      }
      var input;
      var spreadArgs = true;
      if (len === 2 && Array.isArray(arguments[0])) {
        input = arguments[0];
        len = input.length;
        spreadArgs = false;
      } else {
        input = arguments;
        len--;
      }
      var resources = new ResourceList(len);
      for (var i = 0; i < len; ++i) {
        var resource = input[i];
        if (Disposer.isDisposer(resource)) {
          var disposer = resource;
          resource = resource.promise();
          resource._setDisposable(disposer);
        } else {
          var maybePromise = tryConvertToPromise(resource);
          if (maybePromise instanceof Promise) {
            resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
              resources: resources,
              index: i
            }, undefined);
          }
        }
        resources[i] = resource;
      }
      var reflectedResources = new Array(resources.length);
      for (var i = 0; i < reflectedResources.length; ++i) {
        reflectedResources[i] = Promise.resolve(resources[i]).reflect();
      }
      var resultPromise = Promise.all(reflectedResources).then(function (inspections) {
        for (var i = 0; i < inspections.length; ++i) {
          var inspection = inspections[i];
          if (inspection.isRejected()) {
            errorObj.e = inspection.error();
            return errorObj;
          } else if (!inspection.isFulfilled()) {
            resultPromise.cancel();
            return;
          }
          inspections[i] = inspection.value();
        }
        promise._pushContext();
        fn = tryCatch(fn);
        var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
        return ret;
      });
      var promise = resultPromise.lastly(function () {
        var inspection = new Promise.PromiseInspection(resultPromise);
        return dispose(resources, inspection);
      });
      resources.promise = promise;
      promise._setOnCancel(resources);
      return promise;
    };
    Promise.prototype._setDisposable = function (disposer) {
      this._bitField = this._bitField | 131072;
      this._disposer = disposer;
    };
    Promise.prototype._isDisposable = function () {
      return (this._bitField & 131072) > 0;
    };
    Promise.prototype._getDisposer = function () {
      return this._disposer;
    };
    Promise.prototype._unsetDisposable = function () {
      this._bitField = this._bitField & ~131072;
      this._disposer = undefined;
    };
    Promise.prototype.disposer = function (fn) {
      if (typeof fn === "function") {
        return new FunctionDisposer(fn, this, createContext());
      }
      throw new TypeError();
    };
  };

  /***/
}, /* 31 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL, debug) {
    var util = __webpack_require__(7);
    var TimeoutError = Promise.TimeoutError;
    function HandleWrapper(handle) {
      this.handle = handle;
    }
    HandleWrapper.prototype._resultCancelled = function () {
      clearTimeout(this.handle);
    };
    var afterValue = function afterValue(value) {
      return delay(+this).thenReturn(value);
    };
    var delay = Promise.delay = function (ms, value) {
      var ret;
      var handle;
      if (value !== undefined) {
        ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
          ret._setOnCancel(value);
        }
      } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function () {
          ret._fulfill();
        }, +ms);
        if (debug.cancellation()) {
          ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
      }
      ret._setAsyncGuaranteed();
      return ret;
    };
    Promise.prototype.delay = function (ms) {
      return delay(ms, this);
    };
    var afterTimeout = function afterTimeout(promise, message, parent) {
      var err;
      if (typeof message !== "string") {
        if (message instanceof Error) {
          err = message;
        } else {
          err = new TimeoutError("operation timed out");
        }
      } else {
        err = new TimeoutError(message);
      }
      util.markAsOriginatingFromRejection(err);
      promise._attachExtraTrace(err);
      promise._reject(err);
      if (parent != null) {
        parent.cancel();
      }
    };
    function successClear(value) {
      clearTimeout(this.handle);
      return value;
    }
    function failureClear(reason) {
      clearTimeout(this.handle);
      throw reason;
    }
    Promise.prototype.timeout = function (ms, message) {
      ms = +ms;
      var ret, parent;
      var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
          afterTimeout(ret, message, parent);
        }
      }, ms));
      if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
      } else {
        ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
      }
      return ret;
    };
  };

  /***/
}, /* 32 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
    var errors = __webpack_require__(14);
    var TypeError = errors.TypeError;
    var util = __webpack_require__(7);
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var yieldHandlers = [];
    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
      for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
          traceParent._pushContext();
          var ret = Promise.reject(errorObj.e);
          traceParent._popContext();
          return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
      }
      return null;
    }
    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
      if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function () {
          return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
      } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
      }
      this._stack = stack;
      this._generatorFunction = generatorFunction;
      this._receiver = receiver;
      this._generator = undefined;
      this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
      this._yieldedPromise = null;
      this._cancellationPhase = false;
    }
    util.inherits(PromiseSpawn, Proxyable);
    PromiseSpawn.prototype._isResolved = function () {
      return this._promise === null;
    };
    PromiseSpawn.prototype._cleanup = function () {
      this._promise = this._generator = null;
      if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
      }
    };
    PromiseSpawn.prototype._promiseCancelled = function () {
      if (this._isResolved()) return;
      var implementsReturn = typeof this._generator["return"] !== "undefined";
      var result;
      if (!implementsReturn) {
        var reason = new Promise.CancellationError("generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator, reason);
        this._promise._popContext();
      } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator, undefined);
        this._promise._popContext();
      }
      this._cancellationPhase = true;
      this._yieldedPromise = null;
      this._continue(result);
    };
    PromiseSpawn.prototype._promiseFulfilled = function (value) {
      this._yieldedPromise = null;
      this._promise._pushContext();
      var result = tryCatch(this._generator.next).call(this._generator, value);
      this._promise._popContext();
      this._continue(result);
    };
    PromiseSpawn.prototype._promiseRejected = function (reason) {
      this._yieldedPromise = null;
      this._promise._attachExtraTrace(reason);
      this._promise._pushContext();
      var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
      this._promise._popContext();
      this._continue(result);
    };
    PromiseSpawn.prototype._resultCancelled = function () {
      if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
      }
    };
    PromiseSpawn.prototype.promise = function () {
      return this._promise;
    };
    PromiseSpawn.prototype._run = function () {
      this._generator = this._generatorFunction.call(this._receiver);
      this._receiver = this._generatorFunction = undefined;
      this._promiseFulfilled(undefined);
    };
    PromiseSpawn.prototype._continue = function (result) {
      var promise = this._promise;
      if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
          return promise.cancel();
        } else {
          return promise._rejectCallback(result.e, false);
        }
      }
      var value = result.value;
      if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
          return promise.cancel();
        } else {
          return promise._resolveCallback(value);
        }
      } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
          maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
          if (maybePromise === null) {
            this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
            return;
          }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if ((bitField & 50397184) === 0) {
          this._yieldedPromise = maybePromise;
          maybePromise._proxy(this, null);
        } else if ((bitField & 33554432) !== 0) {
          Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
        } else if ((bitField & 16777216) !== 0) {
          Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
        } else {
          this._promiseCancelled();
        }
      }
    };
    Promise.coroutine = function (generatorFunction, options) {
      if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
      }
      var yieldHandler = Object(options).yieldHandler;
      var PromiseSpawn$ = PromiseSpawn;
      var stack = new Error().stack;
      return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
      };
    };
    Promise.coroutine.addYieldHandler = function (fn) {
      if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
      }
      yieldHandlers.push(fn);
    };
    Promise.spawn = function (generatorFunction) {
      debug.deprecated("Promise.spawn()", "Promise.coroutine()");
      if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
      }
      var spawn = new PromiseSpawn(generatorFunction, this);
      var ret = spawn.promise();
      spawn._run(Promise.spawn);
      return ret;
    };
  };

  /***/
}, /* 33 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise) {
    var util = __webpack_require__(7);
    var async = Promise._async;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function spreadAdapter(val, nodeback) {
      var promise = this;
      if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
      var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
      if (ret === errorObj) {
        async.throwLater(ret.e);
      }
    }
    function successAdapter(val, nodeback) {
      var promise = this;
      var receiver = promise._boundValue();
      var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
      if (ret === errorObj) {
        async.throwLater(ret.e);
      }
    }
    function errorAdapter(reason, nodeback) {
      var promise = this;
      if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
      }
      var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
      if (ret === errorObj) {
        async.throwLater(ret.e);
      }
    }
    Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
      if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
          adapter = spreadAdapter;
        }
        this._then(adapter, errorAdapter, undefined, this, nodeback);
      }
      return this;
    };
  };

  /***/
}, /* 34 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL) {
    var THIS = {};
    var util = __webpack_require__(7);
    var nodebackForPromise = __webpack_require__(21);
    var withAppended = util.withAppended;
    var maybeWrapAsError = util.maybeWrapAsError;
    var canEvaluate = util.canEvaluate;
    var TypeError = __webpack_require__(14).TypeError;
    var defaultSuffix = "Async";
    var defaultPromisified = {
      __isPromisified__: true
    };
    var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
    var defaultFilter = function defaultFilter(name) {
      return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
    };
    function propsFilter(key) {
      return !noCopyPropsPattern.test(key);
    }
    function isPromisified(fn) {
      try {
        return fn.__isPromisified__ === true;
      } catch (e) {
        return false;
      }
    }
    function hasPromisified(obj, key, suffix) {
      var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
      return val ? isPromisified(val) : false;
    }
    function checkValid(ret, suffix, suffixRegexp) {
      for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
          var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
          for (var j = 0; j < ret.length; j += 2) {
            if (ret[j] === keyWithoutAsyncSuffix) {
              throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
            }
          }
        }
      }
    }
    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
      var keys = util.inheritedDataKeys(obj);
      var ret = [];
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
          ret.push(key, value);
        }
      }
      checkValid(ret, suffix, suffixRegexp);
      return ret;
    }
    var escapeIdentRegex = function escapeIdentRegex(str) {
      return str.replace(/([$])/, "\\$");
    };
    var makeNodePromisifiedEval;
    if (true) {
      var switchCaseArgumentOrder = function switchCaseArgumentOrder(likelyArgumentCount) {
        var ret = [likelyArgumentCount];
        var min = Math.max(0, likelyArgumentCount - 1 - 3);
        for (var i = likelyArgumentCount - 1; i >= min; --i) {
          ret.push(i);
        }
        for (var i = likelyArgumentCount + 1; i <= 3; ++i) {
          ret.push(i);
        }
        return ret;
      };
      var argumentSequence = function argumentSequence(argumentCount) {
        return util.filledRange(argumentCount, "_arg", "");
      };
      var parameterDeclaration = function parameterDeclaration(parameterCount) {
        return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
      };
      var parameterCount = function parameterCount(fn) {
        if (typeof fn.length === "number") {
          return Math.max(Math.min(fn.length, 1023 + 1), 0);
        }
        return 0;
      };
      makeNodePromisifiedEval = function makeNodePromisifiedEval(callback, receiver, originalName, fn, _, multiArgs) {
        var newParameterCount = Math.max(0, parameterCount(fn) - 1);
        var argumentOrder = switchCaseArgumentOrder(newParameterCount);
        var shouldProxyThis = typeof callback === "string" || receiver === THIS;
        function generateCallForArgumentCount(count) {
          var args = argumentSequence(count).join(", ");
          var comma = count > 0 ? ", " : "";
          var ret;
          if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
          } else {
            ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
          }
          return ret.replace("{{args}}", args).replace(", ", comma);
        }
        function generateArgumentSwitchCase() {
          var ret = "";
          for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
          }
          ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
          return ret;
        }
        var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
        var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
        body = body.replace("Parameters", parameterDeclaration(newParameterCount));
        return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
      };
    }
    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
      var defaultThis = function () {
        return this;
      }();
      var method = callback;
      if (typeof method === "string") {
        callback = fn;
      }
      function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
          cb.apply(_receiver, withAppended(arguments, fn));
        } catch (e) {
          promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
      }
      util.notEnumerableProp(promisified, "__isPromisified__", true);
      return promisified;
    }
    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
      var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
      var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
      for (var i = 0, len = methods.length; i < len; i += 2) {
        var key = methods[i];
        var fn = methods[i + 1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
          obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
          var promisified = promisifier(fn, function () {
            return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
          });
          util.notEnumerableProp(promisified, "__isPromisified__", true);
          obj[promisifiedKey] = promisified;
        }
      }
      util.toFastProperties(obj);
      return obj;
    }
    function promisify(callback, receiver, multiArgs) {
      return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
    }
    Promise.promisify = function (fn, options) {
      if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
      }
      if (isPromisified(fn)) {
        return fn;
      }
      options = Object(options);
      var receiver = options.context === undefined ? THIS : options.context;
      var multiArgs = !!options.multiArgs;
      var ret = promisify(fn, receiver, multiArgs);
      util.copyDescriptors(fn, ret, propsFilter);
      return ret;
    };
    Promise.promisifyAll = function (target, options) {
      if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
      }
      options = Object(options);
      var multiArgs = !!options.multiArgs;
      var suffix = options.suffix;
      if (typeof suffix !== "string") suffix = defaultSuffix;
      var filter = options.filter;
      if (typeof filter !== "function") filter = defaultFilter;
      var promisifier = options.promisifier;
      if (typeof promisifier !== "function") promisifier = makeNodePromisified;
      if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
      }
      var keys = util.inheritedDataKeys(target);
      for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" && util.isClass(value)) {
          promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
          promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
      }
      return promisifyAll(target, suffix, filter, promisifier, multiArgs);
    };
  };

  /***/
}, /* 35 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
    var util = __webpack_require__(7);
    var isObject = util.isObject;
    var es5 = __webpack_require__(8);
    var Es6Map;
    if (typeof Map === "function") Es6Map = Map;
    var mapToEntries = function () {
      var index = 0;
      var size = 0;
      function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
      }
      return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
      };
    }();
    var entriesToMap = function entriesToMap(entries) {
      var ret = new Es6Map();
      var length = entries.length / 2 | 0;
      for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
      }
      return ret;
    };
    function PropertiesPromiseArray(obj) {
      var isMap = false;
      var entries;
      if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
      } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
          var key = keys[i];
          entries[i] = obj[key];
          entries[i + len] = key;
        }
      }
      this.constructor$(entries);
      this._isMap = isMap;
      this._init$(undefined, isMap ? -6 : -3);
    }
    util.inherits(PropertiesPromiseArray, PromiseArray);
    PropertiesPromiseArray.prototype._init = function () {};
    PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
      this._values[index] = value;
      var totalResolved = ++this._totalResolved;
      if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
          val = entriesToMap(this._values);
        } else {
          val = {};
          var keyOffset = this.length();
          for (var i = 0, len = this.length(); i < len; ++i) {
            val[this._values[i + keyOffset]] = this._values[i];
          }
        }
        this._resolve(val);
        return true;
      }
      return false;
    };
    PropertiesPromiseArray.prototype.shouldCopyValues = function () {
      return false;
    };
    PropertiesPromiseArray.prototype.getActualLength = function (len) {
      return len >> 1;
    };
    function props(promises) {
      var ret;
      var castValue = tryConvertToPromise(promises);
      if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
      } else if (castValue instanceof Promise) {
        ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
      } else {
        ret = new PropertiesPromiseArray(castValue).promise();
      }
      if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
      }
      return ret;
    }
    Promise.prototype.props = function () {
      return props(this);
    };
    Promise.props = function (promises) {
      return props(promises);
    };
  };

  /***/
}, /* 36 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
    var util = __webpack_require__(7);
    var raceLater = function raceLater(promise) {
      return promise.then(function (array) {
        return race(array, promise);
      });
    };
    function race(promises, parent) {
      var maybePromise = tryConvertToPromise(promises);
      if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
      } else {
        promises = util.asArray(promises);
        if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
      }
      var ret = new Promise(INTERNAL);
      if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
      }
      var fulfill = ret._fulfill;
      var reject = ret._reject;
      for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];
        if (val === undefined && !(i in promises)) {
          continue;
        }
        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
      }
      return ret;
    }
    Promise.race = function (promises) {
      return race(promises, undefined);
    };
    Promise.prototype.race = function () {
      return race(this, undefined);
    };
  };

  /***/
}, /* 37 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = __webpack_require__(7);
    var tryCatch = util.tryCatch;
    function ReductionPromiseArray(promises, fn, initialValue, _each) {
      this.constructor$(promises);
      var domain = getDomain();
      this._fn = domain === null ? fn : util.domainBind(domain, fn);
      if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
      }
      this._initialValue = initialValue;
      this._currentCancellable = null;
      if (_each === INTERNAL) {
        this._eachValues = Array(this._length);
      } else if (_each === 0) {
        this._eachValues = null;
      } else {
        this._eachValues = undefined;
      }
      this._promise._captureStackTrace();
      this._init$(undefined, -5);
    }
    util.inherits(ReductionPromiseArray, PromiseArray);
    ReductionPromiseArray.prototype._gotAccum = function (accum) {
      if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) {
        this._eachValues.push(accum);
      }
    };
    ReductionPromiseArray.prototype._eachComplete = function (value) {
      if (this._eachValues !== null) {
        this._eachValues.push(value);
      }
      return this._eachValues;
    };
    ReductionPromiseArray.prototype._init = function () {};
    ReductionPromiseArray.prototype._resolveEmptyArray = function () {
      this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
    };
    ReductionPromiseArray.prototype.shouldCopyValues = function () {
      return false;
    };
    ReductionPromiseArray.prototype._resolve = function (value) {
      this._promise._resolveCallback(value);
      this._values = null;
    };
    ReductionPromiseArray.prototype._resultCancelled = function (sender) {
      if (sender === this._initialValue) return this._cancel();
      if (this._isResolved()) return;
      this._resultCancelled$();
      if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
      }
      if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
      }
    };
    ReductionPromiseArray.prototype._iterate = function (values) {
      this._values = values;
      var value;
      var i;
      var length = values.length;
      if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
      } else {
        value = Promise.resolve(values[0]);
        i = 1;
      }
      this._currentCancellable = value;
      if (!value.isRejected()) {
        for (; i < length; ++i) {
          var ctx = {
            accum: null,
            value: values[i],
            index: i,
            length: length,
            array: this
          };
          value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
      }
      if (this._eachValues !== undefined) {
        value = value._then(this._eachComplete, undefined, undefined, this, undefined);
      }
      value._then(completed, completed, undefined, value, this);
    };
    Promise.prototype.reduce = function (fn, initialValue) {
      return reduce(this, fn, initialValue, null);
    };
    Promise.reduce = function (promises, fn, initialValue, _each) {
      return reduce(promises, fn, initialValue, _each);
    };
    function completed(valueOrReason, array) {
      if (this.isFulfilled()) {
        array._resolve(valueOrReason);
      } else {
        array._reject(valueOrReason);
      }
    }
    function reduce(promises, fn, initialValue, _each) {
      if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
      }
      var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
      return array.promise();
    }
    function gotAccum(accum) {
      this.accum = accum;
      this.array._gotAccum(accum);
      var value = tryConvertToPromise(this.value, this.array._promise);
      if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
      } else {
        return gotValue.call(this, value);
      }
    }
    function gotValue(value) {
      var array = this.array;
      var promise = array._promise;
      var fn = tryCatch(array._fn);
      promise._pushContext();
      var ret;
      if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
      } else {
        ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
      }
      if (ret instanceof Promise) {
        array._currentCancellable = ret;
      }
      var promiseCreated = promise._popContext();
      debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
      return ret;
    }
  };

  /***/
}, /* 38 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, debug) {
    var PromiseInspection = Promise.PromiseInspection;
    var util = __webpack_require__(7);
    function SettledPromiseArray(values) {
      this.constructor$(values);
    }
    util.inherits(SettledPromiseArray, PromiseArray);
    SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
      this._values[index] = inspection;
      var totalResolved = ++this._totalResolved;
      if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
      }
      return false;
    };
    SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
      var ret = new PromiseInspection();
      ret._bitField = 33554432;
      ret._settledValueField = value;
      return this._promiseResolved(index, ret);
    };
    SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
      var ret = new PromiseInspection();
      ret._bitField = 16777216;
      ret._settledValueField = reason;
      return this._promiseResolved(index, ret);
    };
    Promise.settle = function (promises) {
      debug.deprecated(".settle()", ".reflect()");
      return new SettledPromiseArray(promises).promise();
    };
    Promise.prototype.settle = function () {
      return Promise.settle(this);
    };
  };

  /***/
}, /* 39 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function (Promise, PromiseArray, apiRejection) {
    var util = __webpack_require__(7);
    var RangeError = __webpack_require__(14).RangeError;
    var AggregateError = __webpack_require__(14).AggregateError;
    var isArray = util.isArray;
    var CANCELLATION = {};
    function SomePromiseArray(values) {
      this.constructor$(values);
      this._howMany = 0;
      this._unwrap = false;
      this._initialized = false;
    }
    util.inherits(SomePromiseArray, PromiseArray);
    SomePromiseArray.prototype._init = function () {
      if (!this._initialized) {
        return;
      }
      if (this._howMany === 0) {
        this._resolve([]);
        return;
      }
      this._init$(undefined, -5);
      var isArrayResolved = isArray(this._values);
      if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
      }
    };
    SomePromiseArray.prototype.init = function () {
      this._initialized = true;
      this._init();
    };
    SomePromiseArray.prototype.setUnwrap = function () {
      this._unwrap = true;
    };
    SomePromiseArray.prototype.howMany = function () {
      return this._howMany;
    };
    SomePromiseArray.prototype.setHowMany = function (count) {
      this._howMany = count;
    };
    SomePromiseArray.prototype._promiseFulfilled = function (value) {
      this._addFulfilled(value);
      if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
          this._resolve(this._values[0]);
        } else {
          this._resolve(this._values);
        }
        return true;
      }
      return false;
    };
    SomePromiseArray.prototype._promiseRejected = function (reason) {
      this._addRejected(reason);
      return this._checkOutcome();
    };
    SomePromiseArray.prototype._promiseCancelled = function () {
      if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
      }
      this._addRejected(CANCELLATION);
      return this._checkOutcome();
    };
    SomePromiseArray.prototype._checkOutcome = function () {
      if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
          if (this._values[i] !== CANCELLATION) {
            e.push(this._values[i]);
          }
        }
        if (e.length > 0) {
          this._reject(e);
        } else {
          this._cancel();
        }
        return true;
      }
      return false;
    };
    SomePromiseArray.prototype._fulfilled = function () {
      return this._totalResolved;
    };
    SomePromiseArray.prototype._rejected = function () {
      return this._values.length - this.length();
    };
    SomePromiseArray.prototype._addRejected = function (reason) {
      this._values.push(reason);
    };
    SomePromiseArray.prototype._addFulfilled = function (value) {
      this._values[this._totalResolved++] = value;
    };
    SomePromiseArray.prototype._canPossiblyFulfill = function () {
      return this.length() - this._rejected();
    };
    SomePromiseArray.prototype._getRangeError = function (count) {
      var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
      return new RangeError(message);
    };
    SomePromiseArray.prototype._resolveEmptyArray = function () {
      this._reject(this._getRangeError(0));
    };
    function some(promises, howMany) {
      if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
      }
      var ret = new SomePromiseArray(promises);
      var promise = ret.promise();
      ret.setHowMany(howMany);
      ret.init();
      return promise;
    }
    Promise.some = function (promises, howMany) {
      return some(promises, howMany);
    };
    Promise.prototype.some = function (howMany) {
      return some(this, howMany);
    };
    Promise._SomePromiseArray = SomePromiseArray;
  };

  /***/
}, /* 40 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise, INTERNAL) {
    var PromiseMap = Promise.map;
    Promise.prototype.filter = function (fn, options) {
      return PromiseMap(this, fn, options, INTERNAL);
    };
    Promise.filter = function (promises, fn, options) {
      return PromiseMap(promises, fn, options, INTERNAL);
    };
  };

  /***/
}, /* 41 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise, INTERNAL) {
    var PromiseReduce = Promise.reduce;
    var PromiseAll = Promise.all;
    function promiseAllThis() {
      return PromiseAll(this);
    }
    function PromiseMapSeries(promises, fn) {
      return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
    }
    Promise.prototype.each = function (fn) {
      return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
    };
    Promise.prototype.mapSeries = function (fn) {
      return PromiseReduce(this, fn, INTERNAL, INTERNAL);
    };
    Promise.each = function (promises, fn) {
      return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
    };
    Promise.mapSeries = PromiseMapSeries;
  };

  /***/
}, /* 42 */
/***/function (module, exports) {
  "use strict";

  module.exports = function (Promise) {
    var SomePromiseArray = Promise._SomePromiseArray;
    function any(promises) {
      var ret = new SomePromiseArray(promises);
      var promise = ret.promise();
      ret.setHowMany(1);
      ret.setUnwrap();
      ret.init();
      return promise;
    }
    Promise.any = function (promises) {
      return any(promises);
    };
    Promise.prototype.any = function () {
      return any(this);
    };
  };

  /***/
}, /* 43 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _debug = __webpack_require__(1);
  var _debug2 = _interopRequireDefault(_debug);
  var _events = __webpack_require__(44);
  var _events2 = _interopRequireDefault(_events);
  var _replayBrowserEvents = __webpack_require__(45);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var debug = (0, _debug2.default)('ssb:IFrame');
  var IFrame = function (_EventEmitter) {
    _inherits(IFrame, _EventEmitter);
    function IFrame(element) {
      _classCallCheck(this, IFrame);
      var _this = _possibleConstructorReturn(this, (IFrame.__proto__ || Object.getPrototypeOf(IFrame)).call(this));
      if (element.tagName === 'IFRAME' || element.tagName === 'FRAME') {
        _this.iframe = element;
      } else {
        var iframe = '<iframe sandbox="allow-same-origin allow-scripts" style="border: 0; width: 100%; height: 100%;" srcdoc="<!DOCTYPE html>"></iframe>';
        element.innerHTML = iframe;
        _this.iframe = element.firstChild;
      }
      _this.iframe.addEventListener('load', function () {
        _this.window.addEventListener('scroll', function (ev) {
          _this.emit('scroll', {
            scrollX: _this.window.scrollX,
            scrollY: _this.window.scrollY
          }, ev);
        });
        _this.window.addEventListener('resize', function (ev) {
          _this.emit('resize', {
            scrollWidth: _this.iframe.scrollWidth,
            scrollHeight: _this.iframe.scrollHeight
          }, ev);
        });
      });
      debug('attach IFrame to', _this.iframe, _this.window);
      return _this;
    }
    _createClass(IFrame, [{
      key: 'render',
      value: function render(html, base_url) {
        var _this2 = this;
        var block_script = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var block_iframe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        base_url = base_url || this.url;
        this.url = base_url;
        var _window = this.window,
          DOMParser = _window.DOMParser,
          document = _window.document;
        var dom = new DOMParser().parseFromString(html, 'text/html');
        if (base_url) {
          if (dom.querySelector('base')) {
            dom.querySelector('base').setAttribute('href', base_url);
          } else {
            var base = dom.createElement('base');
            base.setAttribute('href', base_url);
            dom.head.prepend(base);
          }
        }
        if (block_script) {
          [].concat(_toConsumableArray(dom.querySelectorAll('script'))).forEach(function (script) {
            script.setAttribute('type', 'text/plain');
          });
        }
        if (block_iframe) {
          [].concat(_toConsumableArray(dom.querySelectorAll('iframe[src]'))).forEach(function (frame) {
            frame.setAttribute('__src', frame.src);
            frame.setAttribute('src', encodeURI('data:text/html;,<h1>iframe blocked</h1>'));
          });
        }
        document.open();
        document.write(dom.documentElement.innerHTML);
        document.close();
        document.onreadystatechange = function (ev) {
          if (ev.target.readyState == 'complete') {
            _this2.emit('load', ev.target);
          }
        };
        return document;
      }
    }, {
      key: 'play',
      value: function play(action) {
        if (!(action instanceof _replayBrowserEvents.Action)) {
          action = _replayBrowserEvents.Action.fromJSON(this.document, action);
        }
        return action.play();
      }
    }, {
      key: 'executeJavaScript',
      value: function executeJavaScript(src) {
        var window = this.window; // eslint-disable-line 
        var document = this.window.document; // eslint-disable-line 

        return eval('(' + src + ')();');
      }
    }, {
      key: 'getElementByXpath',
      value: function getElementByXpath(path) {
        var _window2 = this.window,
          document = _window2.document,
          XPathResult = _window2.XPathResult;
        return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
      }
    }, {
      key: 'getElementsByXpath',
      value: function getElementsByXpath(path) {
        var _window3 = this.window,
          document = _window3.document,
          XPathResult = _window3.XPathResult;
        var result = [];
        var xpath_results = document.evaluate(path, document, null, XPathResult.ANY_TYPE, null).iterateNext();
        var xpath_result = xpath_results.iterateNext();
        while (xpath_result) {
          result.push(xpath_result);
          xpath_result = xpath_results.iterateNext();
        }
        return result;
      }
    }, {
      key: 'clearPage',
      value: function clearPage() {
        var document = this.window.document;
        while (document.firstChild) {
          document.removeChild(document.firstChild);
        }
      }
    }, {
      key: 'window',
      get: function get() {
        return this.iframe.contentWindow;
      }
    }, {
      key: 'document',
      get: function get() {
        return this.window.document;
      }
    }, {
      key: 'ready',
      get: function get() {
        return this.window && this.document;
      }
    }, {
      key: 'url',
      set: function set(url) {
        this._url = url;
      },
      get: function get() {
        return this._url;
      }
    }, {
      key: 'html',
      get: function get() {
        var document = this.window.document;
        return document.documentElement.outerHTML;
      }
    }]);
    return IFrame;
  }(_events2.default);
  exports.default = IFrame;

  /***/
}, /* 44 */
/***/function (module, exports) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  function EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
  }
  module.exports = EventEmitter;

  // Backwards-compat with node 0.10.x
  EventEmitter.EventEmitter = EventEmitter;
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined;

  // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.
  EventEmitter.defaultMaxListeners = 10;

  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.
  EventEmitter.prototype.setMaxListeners = function (n) {
    if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
  };
  EventEmitter.prototype.emit = function (type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};

    // If there is no 'error' event listener then throw.
    if (type === 'error') {
      if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
        er = arguments[1];
        if (er instanceof Error) {
          throw er; // Unhandled 'error' event
        } else {
          // At least give some kind of context to the user
          var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
          err.context = er;
          throw err;
        }
      }
    }
    handler = this._events[type];
    if (isUndefined(handler)) return false;
    if (isFunction(handler)) {
      switch (arguments.length) {
        // fast cases
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this, arguments[1]);
          break;
        case 3:
          handler.call(this, arguments[1], arguments[2]);
          break;
        // slower
        default:
          args = Array.prototype.slice.call(arguments, 1);
          handler.apply(this, args);
      }
    } else if (isObject(handler)) {
      args = Array.prototype.slice.call(arguments, 1);
      listeners = handler.slice();
      len = listeners.length;
      for (i = 0; i < len; i++) listeners[i].apply(this, args);
    }
    return true;
  };
  EventEmitter.prototype.addListener = function (type, listener) {
    var m;
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};

    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type])
      // Optimize the case of one listener. Don't need the extra array object.
      this._events[type] = listener;else if (isObject(this._events[type]))
      // If we've already got an array, just append.
      this._events[type].push(listener);else
      // Adding the second element, need to change to array.
      this._events[type] = [this._events[type], listener];

    // Check for listener leak
    if (isObject(this._events[type]) && !this._events[type].warned) {
      if (!isUndefined(this._maxListeners)) {
        m = this._maxListeners;
      } else {
        m = EventEmitter.defaultMaxListeners;
      }
      if (m && m > 0 && this._events[type].length > m) {
        this._events[type].warned = true;
        console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
        if (typeof console.trace === 'function') {
          // not supported in IE 10
          console.trace();
        }
      }
    }
    return this;
  };
  EventEmitter.prototype.on = EventEmitter.prototype.addListener;
  EventEmitter.prototype.once = function (type, listener) {
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
      this.removeListener(type, g);
      if (!fired) {
        fired = true;
        listener.apply(this, arguments);
      }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
  };

  // emits a 'removeListener' event iff the listener was removed
  EventEmitter.prototype.removeListener = function (type, listener) {
    var list, position, length, i;
    if (!isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || isFunction(list.listener) && list.listener === listener) {
      delete this._events[type];
      if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if (isObject(list)) {
      for (i = length; i-- > 0;) {
        if (list[i] === listener || list[i].listener && list[i].listener === listener) {
          position = i;
          break;
        }
      }
      if (position < 0) return this;
      if (list.length === 1) {
        list.length = 0;
        delete this._events[type];
      } else {
        list.splice(position, 1);
      }
      if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
  };
  EventEmitter.prototype.removeAllListeners = function (type) {
    var key, listeners;
    if (!this._events) return this;

    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
      if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
      return this;
    }

    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
      for (key in this._events) {
        if (key === 'removeListener') continue;
        this.removeAllListeners(key);
      }
      this.removeAllListeners('removeListener');
      this._events = {};
      return this;
    }
    listeners = this._events[type];
    if (isFunction(listeners)) {
      this.removeListener(type, listeners);
    } else if (listeners) {
      // LIFO order
      while (listeners.length) this.removeListener(type, listeners[listeners.length - 1]);
    }
    delete this._events[type];
    return this;
  };
  EventEmitter.prototype.listeners = function (type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
    return ret;
  };
  EventEmitter.prototype.listenerCount = function (type) {
    if (this._events) {
      var evlistener = this._events[type];
      if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
    }
    return 0;
  };
  EventEmitter.listenerCount = function (emitter, type) {
    return emitter.listenerCount(type);
  };
  function isFunction(arg) {
    return typeof arg === 'function';
  }
  function isNumber(arg) {
    return typeof arg === 'number';
  }
  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }
  function isUndefined(arg) {
    return arg === void 0;
  }

  /***/
}, /* 45 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.utils = exports.Variable = exports.Action = exports.actions = exports.BrowserReplay = exports.BrowserRecorder = undefined;
  var _BrowserRecorder = __webpack_require__(46);
  var _BrowserRecorder2 = _interopRequireDefault(_BrowserRecorder);
  var _BrowserReplay = __webpack_require__(177);
  var _BrowserReplay2 = _interopRequireDefault(_BrowserReplay);
  var _actions = __webpack_require__(59);
  var actions = _interopRequireWildcard(_actions);
  var _utils = __webpack_require__(65);
  var utils = _interopRequireWildcard(_utils);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.BrowserRecorder = _BrowserRecorder2.default;
  exports.BrowserReplay = _BrowserReplay2.default;
  exports.actions = actions;
  exports.Action = actions.default;
  exports.Variable = _utils.Variable;
  exports.utils = utils;

  /***/
}, /* 46 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _debounce2 = __webpack_require__(47);
  var _debounce3 = _interopRequireDefault(_debounce2);
  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _debug = __webpack_require__(1);
  var _debug2 = _interopRequireDefault(_debug);
  var _events = __webpack_require__(44);
  var _events2 = _interopRequireDefault(_events);
  var _actions = __webpack_require__(59);
  var _ActionMutationObserver = __webpack_require__(176);
  var _ActionMutationObserver2 = _interopRequireDefault(_ActionMutationObserver);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var record_log = (0, _debug2.default)('replay-browser-events:record');
  var event_log = (0, _debug2.default)('replay-browser-events:event');
  var INPUT_TARGET_NAMES = ['SELECT', 'OPTION', 'TEXTAREA'];
  var BrowserRecorder = function (_EventEmitter) {
    _inherits(BrowserRecorder, _EventEmitter);
    function BrowserRecorder(target) {
      _classCallCheck(this, BrowserRecorder);
      var _this = _possibleConstructorReturn(this, (BrowserRecorder.__proto__ || Object.getPrototypeOf(BrowserRecorder)).call(this));
      _this.debounceDetectRegionMutation = (0, _debounce3.default)(_this.detectRegionMutation.bind(_this), 500);
      _this.target = target;
      _this.document = _this.target.ownerDocument || _this.target;
      _this.installedListeners = [];
      _this.observer = null;
      _this.mutations = [];
      _this.actions = [];
      _this.lastMouseEvents = {};
      // Order of those events is important and taken from:
      // https://www.w3.org/TR/uievents/#events-mouseevent-event-order
      _this.mouseEvents = ['mouseout', 'mouseleave', 'mouseover', 'mouseenter', 'mousemove'];
      _this.on('newaction', function (action) {
        return _this.actions.push(action);
      });

      // capture the scroll event, emit before other new actions
      _this.lastScrollEvent = null;
      _this.on('before-newaction', function (action) {
        if (action && action.constructor.displayName !== 'ScrollAction' && _this.lastScrollEvent) {
          // directly emit newaction, to insert the ScrollAction before the action about to submit
          _this.emit('newaction', _actions.EventAction.fromEvent(_this.document, _this.lastScrollEvent));
          _this.lastScrollEvent = null;
        }
        // actions will emit through newaction after
        _this.emit('newaction', action);
      });
      return _this;
    }
    _createClass(BrowserRecorder, [{
      key: 'addEventListener',
      value: function addEventListener(target, event, listener) {
        var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        target.addEventListener(event, listener, useCapture);
        this.installedListeners.push([target, event, listener, useCapture]);
      }
    }, {
      key: 'clearListeners',
      value: function clearListeners() {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
          for (var _iterator = this.installedListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 4),
              target = _step$value[0],
              _event = _step$value[1],
              listener = _step$value[2],
              useCapture = _step$value[3];
            target.removeEventListener(_event, listener, useCapture);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        this.installedListeners = [];
      }
    }, {
      key: 'recordEvents',
      value: function recordEvents() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['click', 'scroll', 'change'];
        var mouseEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mouseEvents;
        var _this2 = this;
        var keyCodeFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [13];
        var mutationObserver = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          attributes: false,
          childList: true,
          characterData: false,
          subtree: true
        };
        record_log('start record', events, 'events');
        this.firstEvent = true;
        keyCodeFilter = new Set([].concat(_toConsumableArray(keyCodeFilter)));
        events && events.forEach(function (eventName) {
          if (eventName === 'change') {
            // contentEditable will not fire change event, use blur instead
            _this2.addEventListener(_this2.target, 'keyup', function (event) {
              if (!event.target.isContentEditable) return;
              if (event.target._oldContent !== undefined) return;
              event.target._oldContent = event.target.innerHTML;
              _this2.addEventListener(event.target, 'blur', function (event) {
                if (event.target.innerHTML != event.target._oldContent) {
                  event.target._oldContent = event.target.innerHTML;
                  _this2.onEvent('contentedit', event);
                }
              });
            });
            // trigger input change event if stop enter for 1 seconds
            _this2.addEventListener(_this2.target, 'keyup', (0, _debounce3.default)(function (event) {
              if (event.target !== (_this2.target.ownerDocument || _this2.target).activeElement) return;
              if (event.target.tagName === 'INPUT' || event.target.isContentEditable) {
                event.target.blur();
                event.target.focus();
              }
            }, 2000), true);
          }
          _this2.addEventListener(_this2.target, eventName, _this2.onEvent.bind(_this2, eventName), true);
        });
        mouseEvents && mouseEvents.forEach(function (eventName) {
          _this2.addEventListener(_this2.target, eventName, function (event) {
            return _this2.lastMouseEvents[eventName] = event;
          }, true);
        });
        if (keyCodeFilter && keyCodeFilter.size && !events.includes('keypress')) {
          this.addEventListener(this.target, 'keypress', function (event) {
            if (!keyCodeFilter.has(event.which)) return;
            // KeyAction might play on an input, sometimes it's fired before input change
            // setTimeout will postpone the action fired to wait for InputChangeAction
            setTimeout(function () {
              _this2.onEvent('key', event); // use a special eventName to dispatch a KeyAction instead of KeyboardAction
            }, 0);
          }, true);
        }
        this.observer = new _ActionMutationObserver2.default();
        this.observer.observe(this.target, mutationObserver);
        // blackList 1 seconds later for performance
        setTimeout(function () {
          if (_this2.firstEvent) _this2.observer.blackListRecords();
        }, 1000);
      }
    }, {
      key: 'stopRecord',
      value: function stopRecord() {
        var result = this.takeRecords();
        this.clearListeners();
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        return result;
      }
    }, {
      key: 'takeRecords',
      value: function takeRecords() {
        var result = null;
        if (this.actions.length) {
          result = new _actions.FlowControlAction(this.document, this.actions);
        }
        this.actions = [];
        return result;
      }
    }, {
      key: 'onEvent',
      value: function onEvent(eventName, event) {
        var _this3 = this;

        // Ignore click events for some input elements
        if (eventName === 'click' && INPUT_TARGET_NAMES.includes(event.target.tagName)) {
          return;
        }

        // keep update the last scroll event, and emit it when anyother event happened
        if (eventName === 'scroll') {
          this.debounceDetectRegionMutation(); // still need to detectRegionMutation triggered by scroll, but need debounce
          this.lastScrollEvent = event;
          return;
        }

        // onEvent is called before event actually triggered
        // detectRegionMutation will record the changes before current action
        this.detectRegionMutation();
        var action = void 0;

        // Handle click on captcha
        if (eventName === 'click' && [].concat(_toConsumableArray(event.target.classList)).includes('captcha-state-handler')) {
          action = _actions.CaptchaAction.fromClickEvent(this.document, event);
        } else if (eventName === 'contentedit') {
          action = new _actions.ContentEditAction(this.document, event);
        } else if (eventName === 'key') {
          // special KeyAction, combined with keydown + keypress + keyup
          action = new _actions.KeyAction(this.document, _actions.EventAction.fromEvent(this.document, event));
        } else {
          action = _actions.EventAction.fromEvent(this.document, event);
        }
        event_log('event', eventName, event, action);
        this.emit('before-newaction', action);

        // Observer might be null by now.
        setTimeout(function () {
          return _this3.observer && _this3.observer.takeRecords();
        }, 1); // dont' record immediately changes
      }

      /**
       * emit WaitRegionMutationAction if region changes detected
       * @return true if activeRegion detected
       */
    }, {
      key: 'detectRegionMutation',
      value: function detectRegionMutation() {
        // This function might be called in the debounced callback, where this.observer was already removed.
        // To prevent errors happening because of that, just checking if observer is available before making the call.
        if (this.observer) {
          if (this.firstEvent) {
            this.observer.blackListRecords();
            this.firstEvent = false;
          } else {
            var mutations = this.observer.takeRecords();
            var activeRegion = this.observer.getMostActiveRegion(mutations);
            if (activeRegion) {
              var action = new _actions.WaitRegionMutationAction(this.document, activeRegion, this.observer.options);
              event_log('mutation-event', action);
              this.emit('before-newaction', action);
              return true;
            }
          }
        }
      }
    }, {
      key: 'triggerHoverEvent',
      value: function triggerHoverEvent() {
        var _this4 = this;
        var eventName = '__hover__';
        this.detectRegionMutation();
        var eventActions = this.mouseEvents.map(function (eventName) {
          return _this4.lastMouseEvents[eventName];
        }).filter(function (event) {
          return event !== undefined;
        }).map(function (event) {
          return _actions.EventAction.fromEvent(_this4.document, event);
        });
        var flowControlAction = new _actions.HoverAction(this.document, eventActions);
        event_log('event', eventName, event, flowControlAction);
        this.emit('before-newaction', flowControlAction);
        this.lastMouseEvents = {};
        setTimeout(function () {
          return _this4.observer.takeRecords();
        }, 1); // dont' record immediately changes
      }
    }]);

    return BrowserRecorder;
  }(_events2.default);
  BrowserRecorder.displayName = 'BrowserRecorder';
  exports.default = BrowserRecorder;

  /***/
}, /* 47 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(48),
    now = __webpack_require__(49),
    toNumber = __webpack_require__(52);

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max,
    nativeMin = Math.min;

  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */
  function debounce(func, wait, options) {
    var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs,
        thisArg = lastThis;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time;
      // Start the timer for the trailing edge.
      timerId = setTimeout(timerExpired, wait);
      // Invoke the leading edge.
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // Restart the timer.
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = undefined;

      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return result;
    }
    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
      return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
      var time = now(),
        isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  module.exports = debounce;

  /***/
}, /* 48 */
/***/function (module, exports) {
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  module.exports = isObject;

  /***/
}, /* 49 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */
  var now = function now() {
    return root.Date.now();
  };
  module.exports = now;

  /***/
}, /* 50 */
/***/function (module, exports, __webpack_require__) {
  var freeGlobal = __webpack_require__(51);

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;

  /***/
}, /* 51 */
/***/function (module, exports) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }());

  /***/
}, /* 52 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(48),
    isSymbol = __webpack_require__(53);

  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  module.exports = toNumber;

  /***/
}, /* 53 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(54),
    isObjectLike = __webpack_require__(58);

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }
  module.exports = isSymbol;

  /***/
}, /* 54 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(55),
    getRawTag = __webpack_require__(56),
    objectToString = __webpack_require__(57);

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  module.exports = baseGetTag;

  /***/
}, /* 55 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Built-in value references. */
  var Symbol = root.Symbol;
  module.exports = Symbol;

  /***/
}, /* 56 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(55);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];
    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  module.exports = getRawTag;

  /***/
}, /* 57 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  module.exports = objectToString;

  /***/
}, /* 58 */
/***/function (module, exports) {
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  module.exports = isObjectLike;

  /***/
}, /* 59 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FunctionAction = exports.CodeAction = exports.ScreenCaptureAction = exports.RenderAction = exports.CaptchaAction = exports.ExtractDataAction = exports.ViewportAction = exports.GotoAction = exports.GetHTMLAction = exports.WaitLoadingAction = exports.OpenNextNewWindowInCurrentTabAction = exports.NightmareAction = exports.WaitRegionMutationAction = exports.WaitMutationAction = exports.WaitAction = exports.PaginationAction = exports.LoopAction = exports.KeyAction = exports.HoverAction = exports.FlowControlAction = exports.KeyboardAction = exports.ContentEditAction = exports.SelectChangeAction = exports.InputChangeAction = exports.ScrollAction = exports.ClickAction = exports.MouseAction = exports.EventAction = exports.FocusAction = exports.BrowserAction = exports.ReplayableAction = exports.NotImplementedError = undefined;
  var _isFunction2 = __webpack_require__(60);
  var _isFunction3 = _interopRequireDefault(_isFunction2);
  var _isNumber2 = __webpack_require__(61);
  var _isNumber3 = _interopRequireDefault(_isNumber2);
  var _isArray2 = __webpack_require__(62);
  var _isArray3 = _interopRequireDefault(_isArray2);
  var _debounce2 = __webpack_require__(47);
  var _debounce3 = _interopRequireDefault(_debounce2);
  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);
      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === undefined) {
        return undefined;
      }
      return getter.call(receiver);
    }
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _debug = __webpack_require__(1);
  var _debug2 = _interopRequireDefault(_debug);
  var _object = __webpack_require__(63);
  var _object2 = _interopRequireDefault(_object);
  var _utils = __webpack_require__(65);
  var utils = _interopRequireWildcard(_utils);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }
        return step("next");
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
  // Author: Kuan Huang<kuan.huang@import.io>
  // Created on 2016-11-30

  var play_log = (0, _debug2.default)('replay-browser-events:play');
  var NotImplementedError = exports.NotImplementedError = function (_Error) {
    _inherits(NotImplementedError, _Error);
    function NotImplementedError() {
      var _ref;
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NotImplementedError';
      _classCallCheck(this, NotImplementedError);
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return _possibleConstructorReturn(this, (_ref = NotImplementedError.__proto__ || Object.getPrototypeOf(NotImplementedError)).call.apply(_ref, [this, message].concat(args)));
    }
    return NotImplementedError;
  }(Error);
  NotImplementedError.displayName = 'NotImplementedError';
  var Action = function () {
    _createClass(Action, [{
      key: 'input',
      get: function get() {
        return this._input || {};
      }

      /**
       * define the  variables in the Action, for example
       * ```
       * static variables = {
       *   key: Variable,
       * }
       * ```
       * @param {String} key - the key will become an attribute to the Action instance
       * @param {Variable} Variable - must be Variable
       *
       * You can access to Variable instance via action.variables.key, for example, to mark a value in action
       * as variable: `action.variables.key.variable = true` (default false).
       *
       * You can also access the value of 'key' via action.key:
       * When GET action.key, you will get a live value when `action.input` changed.
       * When SET action.key, it will change the default value of the variable.
       */,

      set: function set(value) {
        this._input = value;
      }
    }]);
    function Action(document) {
      _classCallCheck(this, Action);
      this.replayable = false;
      this.checkBlocked = true;
      this.document = document;
      this.variables = {};
      for (var key in this.constructor.variables) {
        var variable = this.variables[key] = new this.constructor.variables[key]();
        Object.defineProperty(this, key, {
          enumerable: true,
          get: variable.get.bind(variable, this),
          set: variable.set.bind(variable, this)
        });
      }
    }
    _createClass(Action, [{
      key: 'play',
      value: function play() {
        // should return a promise, or use a done callback
        throw new NotImplementedError();
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return {
          constructor: this.constructor.displayName,
          optional: this.optional
        };
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        if (!this.actions[data.constructor] || !this.actions[data.constructor].fromJSON) {
          throw new NotImplementedError();
        }
        var newObj = void 0;
        if (this.actions[data.constructor].fromJSON === this.fromJSON) {
          newObj = new this.actions[data.constructor](document);
        } else {
          newObj = this.actions[data.constructor].fromJSON(document, data);
        }
        newObj.optional = data.optional;
        return newObj;
      }
    }]);
    return Action;
  }();

  // Actions that should replayed (send to server side) when captured in client side
  // Note: WaitRegionMutationAction is not replayable but it's a BrowserAction, because JS
  // doesn't support multi-inheritance, a variable is used to mark ReplayableAction
  // Idealy WaitRegionMutationAction should not inherit from ReplayableAction, the class
  // kept here for back compatible.

  Action.displayName = 'Action';
  Action.actions = module.exports;
  Action.variables = {};
  exports.default = Action;
  var ReplayableAction = exports.ReplayableAction = function (_Action) {
    _inherits(ReplayableAction, _Action);
    function ReplayableAction() {
      var _ref2;
      var _temp, _this2, _ret;
      _classCallCheck(this, ReplayableAction);
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ReplayableAction.__proto__ || Object.getPrototypeOf(ReplayableAction)).call.apply(_ref2, [this].concat(args))), _this2), _this2.replayable = true, _temp), _possibleConstructorReturn(_this2, _ret);
    }
    return ReplayableAction;
  }(Action);
  ReplayableAction.displayName = 'ReplayableAction';
  ;

  // Actions that should executed in browser

  var BrowserAction = exports.BrowserAction = function (_ReplayableAction) {
    _inherits(BrowserAction, _ReplayableAction);
    function BrowserAction() {
      _classCallCheck(this, BrowserAction);
      return _possibleConstructorReturn(this, (BrowserAction.__proto__ || Object.getPrototypeOf(BrowserAction)).apply(this, arguments));
    }
    return BrowserAction;
  }(ReplayableAction);
  BrowserAction.displayName = 'BrowserAction';
  ;
  var WaitForTarget = function WaitForTarget(Base) {
    return function (_Base) {
      _inherits(_class, _Base);
      function _class() {
        _classCallCheck(this, _class);
        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }
      _createClass(_class, [{
        key: 'waitForTarget',
        value: function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(target) {
            var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
            var targetCheckInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return utils.waitForTarget(target, timeout, targetCheckInterval, this.document);
                  case 2:
                    return _context.abrupt('return', _context.sent);
                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
          function waitForTarget(_x2) {
            return _ref3.apply(this, arguments);
          }
          return waitForTarget;
        }()
      }]);
      return _class;
    }(Base);
  };
  var FocusAction = exports.FocusAction = function (_WaitForTarget) {
    _inherits(FocusAction, _WaitForTarget);
    function FocusAction(document, target) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
      _classCallCheck(this, FocusAction);
      var _this5 = _possibleConstructorReturn(this, (FocusAction.__proto__ || Object.getPrototypeOf(FocusAction)).call(this, document));
      if (target.nodeName) {
        _this5.target = utils.serializeElement(target);
      } else {
        _this5.target = target;
      }
      _this5.timeout = timeout;
      return _this5;
    }
    _createClass(FocusAction, [{
      key: 'play',
      value: function play() {
        return this.waitForTarget(this.target, this.timeout).then(function (target) {
          target.focus();
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(FocusAction.prototype.__proto__ || Object.getPrototypeOf(FocusAction.prototype), 'toJSON', this).call(this), {
          target: this.target,
          timeout: this.timeout
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.target, data.timeout);
      }
    }]);
    return FocusAction;
  }(WaitForTarget(BrowserAction));
  FocusAction.displayName = 'FocusAction';
  var EventAction = exports.EventAction = function (_WaitForTarget2) {
    _inherits(EventAction, _WaitForTarget2);

    /**
     * @param {Number} timeout: timeout fof wait for target element exists
     */
    function EventAction(document, event) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
      _classCallCheck(this, EventAction);

      // lazy serialize, as DOM may not exists when object been created
      var _this6 = _possibleConstructorReturn(this, (EventAction.__proto__ || Object.getPrototypeOf(EventAction)).call(this, document, event));
      if (event && event.preventDefault) {
        _this6.trueEvent = event;
        Object.defineProperty(_this6, 'event', {
          configurable: true,
          get: _this6.getEvent.bind(_this6)
        });
      } else {
        _this6.event = event;
        Object.defineProperty(_this6, 'trueEvent', {
          configurable: true,
          get: _this6.getTrueEvent.bind(_this6)
        });
      }

      // Mark event as enumerable so lodash.deepClone will include them
      Object.defineProperty(_this6, 'event', {
        enumerable: true
      });

      // time of wait for target element exists
      _this6.timeout = timeout;
      return _this6;
    }
    _createClass(EventAction, [{
      key: 'getEvent',
      value: function getEvent() {
        if (this[EventAction.eventCache]) return this[EventAction.eventCache];
        return this[EventAction.eventCache] = utils.serializeEvent(this.trueEvent);
      }
    }, {
      key: 'getTrueEvent',
      value: function getTrueEvent() {
        if (this[EventAction.trueEventCache]) return this[EventAction.trueEventCache];
        return this[EventAction.trueEventCache] = utils.deserializeEvent(this.event, this.document);
      }
    }, {
      key: 'play',
      value: function play() {
        var _this7 = this;
        play_log(this.constructor.displayName + '.play ' + this.trueEvent.type + ' on "' + this.event.target.cssSelector + '"');
        return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
          target.dispatchEvent(_this7.trueEvent);
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(EventAction.prototype.__proto__ || Object.getPrototypeOf(EventAction.prototype), 'toJSON', this).call(this), {
          event: this.event,
          timeout: this.timeout
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.event, data.timeout);
      }
    }, {
      key: 'fromEvent',
      value: function fromEvent(document, event) {
        switch (event.type) {
          case 'click':
            return new ClickAction(document, event);
          case 'scroll':
            return new ScrollAction(document, event);
          case 'change':
            if (event.target.tagName == 'SELECT') {
              return new SelectChangeAction(document, event);
            } else {
              return new InputChangeAction(document, event);
            }
          case 'mouseleave':
          case 'mouseout':
          case 'mouseover':
          case 'mouseenter':
          case 'mousemove':
            return new MouseAction(document, event);
          case 'keydown':
          case 'keypress':
          case 'keyup':
            return new KeyboardAction(document, event);
          default:
            return new EventAction(document, event);
        }
      }
    }]);
    return EventAction;
  }(WaitForTarget(BrowserAction));
  EventAction.displayName = 'EventAction';
  EventAction.eventCache = Symbol('event');
  EventAction.trueEventCache = Symbol('trueEvent');
  EventAction.targetCheckInterval = 100;
  var MouseAction = exports.MouseAction = function (_EventAction) {
    _inherits(MouseAction, _EventAction);
    function MouseAction() {
      _classCallCheck(this, MouseAction);
      return _possibleConstructorReturn(this, (MouseAction.__proto__ || Object.getPrototypeOf(MouseAction)).apply(this, arguments));
    }
    return MouseAction;
  }(EventAction);
  MouseAction.displayName = 'MouseAction';
  var ClickAction = exports.ClickAction = function (_MouseAction) {
    _inherits(ClickAction, _MouseAction);
    function ClickAction() {
      _classCallCheck(this, ClickAction);
      return _possibleConstructorReturn(this, (ClickAction.__proto__ || Object.getPrototypeOf(ClickAction)).apply(this, arguments));
    }
    _createClass(ClickAction, [{
      key: 'play',
      value: function play() {
        var _this10 = this;

        // Focus on target with click
        return this.waitForTarget(this.event.target, this.timeout).then(function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(target) {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // blur original active element, focus to target
                    // if target is not focusable, blur will make sure focus to body
                    document.activeElement.blur();
                    _context2.next = 3;
                    return new Promise(function (r) {
                      return setTimeout(r, 1);
                    });
                  case 3:
                    // release runtime lock to let event dispatched
                    target.focus();
                    _context2.next = 6;
                    return new Promise(function (r) {
                      return setTimeout(r, 1);
                    });
                  case 6:
                    return _context2.abrupt('return', _get(ClickAction.prototype.__proto__ || Object.getPrototypeOf(ClickAction.prototype), 'play', _this10).call(_this10));
                  case 7:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this10);
          }));
          return function (_x7) {
            return _ref4.apply(this, arguments);
          };
        }());
      }

      // test if ClickAction looks like captcha and can be convert to CaptchaAction
    }, {
      key: 'maybeCaptcha',
      value: function maybeCaptcha() {
        var target = this.trueEvent.target;
        if (target.tagName !== 'IMG') return false;
        for (var i = 0; i < 3 && target; i++) {
          if (target.id && target.id.toLowerCase().includes('captcha')) return true;
          if (target.getAttribute('class') && target.getAttribute('class').toLowerCase().includes('captcha')) return true;
          if (target.getAttribute('alt') && target.getAttribute('alt').toLowerCase().includes('captcha')) return true;
          target = target.parentElement;
        }
        return false;
      }
    }, {
      key: 'toCaptchaAction',
      value: function toCaptchaAction() {
        return CaptchaAction.fromClickAction(this);
      }
    }]);
    return ClickAction;
  }(MouseAction);
  ClickAction.displayName = 'ClickAction';
  var ScrollAction = exports.ScrollAction = function (_EventAction2) {
    _inherits(ScrollAction, _EventAction2);
    function ScrollAction(document, event) {
      _classCallCheck(this, ScrollAction);

      // if it's original event
      var _this11 = _possibleConstructorReturn(this, (ScrollAction.__proto__ || Object.getPrototypeOf(ScrollAction)).call(this, document, event));
      if (event && event.preventDefault) {
        if (event.target.tagName) {
          _this11.x = event.target.scrollLeft;
          _this11.y = event.target.scrollTop;
        } else {
          // target = #document
          _this11.x = document.defaultView.scrollX;
          _this11.y = document.defaultView.scrollY;
        }
      }
      return _this11;
    }
    _createClass(ScrollAction, [{
      key: 'play',
      value: function play() {
        var _this12 = this;
        play_log(this.constructor.displayName + '.play scroll(' + this.x + ', ' + this.y + ')');
        // it's more practical to just scroll to end
        var x = (0, _isNumber3.default)(this.x) ? this.x : 0;
        var hasTarget = this.event && this.event.target && this.event.target.cssSelector;
        if (!hasTarget) {
          var y = (0, _isNumber3.default)(this.y) ? this.y : document.body.scrollHeight;
          this.document.defaultView.scrollTo(x, y);
        } else {
          return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
            var y = (0, _isNumber3.default)(_this12.y) ? _this12.y : target.scrollHeight;
            target.scrollLeft = x;
            target.scrollTop = y;
          });
        }
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(ScrollAction.prototype.__proto__ || Object.getPrototypeOf(ScrollAction.prototype), 'toJSON', this).call(this), {
          x: this.x,
          y: this.y
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        var self = _get(ScrollAction.__proto__ || Object.getPrototypeOf(ScrollAction), 'fromJSON', this).call(this, document, data);
        self.x = data.x;
        self.y = data.y;
        return self;
      }
    }]);
    return ScrollAction;
  }(EventAction);
  ScrollAction.displayName = 'ScrollAction';
  var InputChangeAction = exports.InputChangeAction = function (_EventAction3) {
    _inherits(InputChangeAction, _EventAction3);
    function InputChangeAction(document, event, timeout) {
      _classCallCheck(this, InputChangeAction);
      var _this13 = _possibleConstructorReturn(this, (InputChangeAction.__proto__ || Object.getPrototypeOf(InputChangeAction)).call(this, document, event, timeout));
      if (event.preventDefault) {
        _this13.value = event.target.value;
      } else {
        _this13.value = event.value;
      }
      return _this13;
    }
    _createClass(InputChangeAction, [{
      key: 'play',
      value: function play() {
        var _this14 = this;
        return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
          target.focus();
          target.value = _this14.value;
          return _get(InputChangeAction.prototype.__proto__ || Object.getPrototypeOf(InputChangeAction.prototype), 'play', _this14).call(_this14);
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        var json = _get(InputChangeAction.prototype.__proto__ || Object.getPrototypeOf(InputChangeAction.prototype), 'toJSON', this).call(this);
        json.event.value = this.variables.value;
        return json;
      }
    }]);
    return InputChangeAction;
  }(EventAction);

  /**
   * Action for select element which may allow multiple selection
   */

  InputChangeAction.displayName = 'InputChangeAction';
  InputChangeAction.variables = {
    value: _utils.Variable
  };
  var SelectChangeAction = exports.SelectChangeAction = function (_EventAction4) {
    _inherits(SelectChangeAction, _EventAction4);
    function SelectChangeAction(document, event, timeout) {
      _classCallCheck(this, SelectChangeAction);
      var _this15 = _possibleConstructorReturn(this, (SelectChangeAction.__proto__ || Object.getPrototypeOf(SelectChangeAction)).call(this, document, event, timeout));
      if (event.preventDefault) {
        _this15.values = [].concat(_toConsumableArray(event.target.options)).filter(function (o) {
          return o.selected;
        }).map(function (o) {
          return o.value || o.text;
        });
      } else {
        _this15.values = event.values;
      }
      return _this15;
    }
    _createClass(SelectChangeAction, [{
      key: 'play',
      value: function play() {
        var _this16 = this;
        return this.waitForTarget(this.event.target, this.timeout).then(function (target) {
          [].concat(_toConsumableArray(target.options)).forEach(function (o) {
            if (_this16.values.indexOf(o.value || o.text) != -1) {
              o.selected = true;
            } else {
              o.selected = false;
            }
          });
          return _get(SelectChangeAction.prototype.__proto__ || Object.getPrototypeOf(SelectChangeAction.prototype), 'play', _this16).call(_this16);
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        var json = _get(SelectChangeAction.prototype.__proto__ || Object.getPrototypeOf(SelectChangeAction.prototype), 'toJSON', this).call(this);
        json.event.values = this.variables.values;
        return json;
      }
    }]);
    return SelectChangeAction;
  }(EventAction);

  // contentEditable action

  SelectChangeAction.displayName = 'SelectChangeAction';
  SelectChangeAction.variables = {
    values: _utils.Variable
  };
  var ContentEditAction = exports.ContentEditAction = function (_EventAction5) {
    _inherits(ContentEditAction, _EventAction5);
    function ContentEditAction(document, event, timeout) {
      _classCallCheck(this, ContentEditAction);
      var _this17 = _possibleConstructorReturn(this, (ContentEditAction.__proto__ || Object.getPrototypeOf(ContentEditAction)).call(this, document, event, timeout));
      if (event.preventDefault) {
        _this17.content = event.target.innerHTML;
      } else {
        _this17.content = event.content;
      }
      return _this17;
    }
    _createClass(ContentEditAction, [{
      key: 'play',
      value: function play() {
        var _this18 = this;
        return this.waitForTarget(this.event.target, this.timeout).then(function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(target) {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    target.focus();
                    target.innerHTML = _this18.content;

                    // dispatch fake events
                    _context3.next = 4;
                    return new KeyboardAction(_this18.document, {
                      'constructor': 'KeyboardEvent',
                      'target': _this18.event.target,
                      'typeArg': 'keydown',
                      'eventInit': {
                        'bubbles': true,
                        'cancelable': true,
                        'detail': 0,
                        'key': 'v',
                        'code': 'KeyV',
                        'location': 0,
                        'ctrlKey': false,
                        'shiftKey': false,
                        'altKey': false,
                        'metaKey': true,
                        'repeat': false,
                        'charCode': 0,
                        'keyCode': 86,
                        'which': 86
                      }
                    }).play();
                  case 4:
                    _context3.next = 6;
                    return new EventAction(_this18.document, {
                      'constructor': 'InputEvent',
                      'target': _this18.event.target,
                      'typeArg': 'input',
                      'eventInit': {}
                    });
                  case 6:
                    _context3.next = 8;
                    return new KeyboardAction(_this18.document, {
                      'constructor': 'KeyboardEvent',
                      'target': _this18.event.target,
                      'typeArg': 'keyup',
                      'eventInit': {
                        'bubbles': true,
                        'cancelable': true,
                        'detail': 0,
                        'key': 'Meta',
                        'code': 'MetaLeft',
                        'location': 1,
                        'ctrlKey': false,
                        'shiftKey': false,
                        'altKey': false,
                        'metaKey': true,
                        'repeat': false,
                        'charCode': 0,
                        'keyCode': 91,
                        'which': 91
                      }
                    }).play();
                  case 8:
                    _context3.next = 10;
                    return _get(ContentEditAction.prototype.__proto__ || Object.getPrototypeOf(ContentEditAction.prototype), 'play', _this18).call(_this18);
                  case 10:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this18);
          }));
          return function (_x8) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        var json = _get(ContentEditAction.prototype.__proto__ || Object.getPrototypeOf(ContentEditAction.prototype), 'toJSON', this).call(this);
        json.event.content = this.variables.content;
        return json;
      }
    }]);
    return ContentEditAction;
  }(EventAction);
  ContentEditAction.displayName = 'ContentEditAction';
  ContentEditAction.variables = {
    content: _utils.Variable
  };
  var KeyboardAction = exports.KeyboardAction = function (_EventAction6) {
    _inherits(KeyboardAction, _EventAction6);
    function KeyboardAction() {
      _classCallCheck(this, KeyboardAction);
      return _possibleConstructorReturn(this, (KeyboardAction.__proto__ || Object.getPrototypeOf(KeyboardAction)).apply(this, arguments));
    }
    _createClass(KeyboardAction, [{
      key: 'getTrueEvent',
      value: function getTrueEvent() {
        var _this20 = this;
        if (this[EventAction.trueEventCache]) return this[EventAction.trueEventCache];
        var trueEvent = utils.deserializeEvent(this.event, this.document);
        ['charCode', 'keyCode', 'which'].forEach(function (hackAttr) {
          var self = _this20;
          Object.defineProperty(trueEvent, hackAttr, {
            get: function get() {
              return self.event.eventInit[hackAttr];
            }
          });
        });
        return this[EventAction.trueEventCache] = trueEvent;
      }
    }]);
    return KeyboardAction;
  }(EventAction);

  /* flow control actions */

  KeyboardAction.displayName = 'KeyboardAction';
  var FlowControlAction = exports.FlowControlAction = function (_ReplayableAction2) {
    _inherits(FlowControlAction, _ReplayableAction2);
    function FlowControlAction(document, actions, name) {
      _classCallCheck(this, FlowControlAction);
      var _this21 = _possibleConstructorReturn(this, (FlowControlAction.__proto__ || Object.getPrototypeOf(FlowControlAction)).call(this, document));
      _this21.actions = actions || [];
      _this21.name = name || '';
      return _this21;
    }
    _createClass(FlowControlAction, [{
      key: 'addAction',
      value: function addAction(action) {
        this.actions.push(action);
      }
    }, {
      key: 'removeAction',
      value: function removeAction(action) {
        // TODO: need test
        var index = -1;
        if ((index = this.actions.indexOf(action)) != -1) return this.actions.splice(index, 1);
        return false;
      }
    }, {
      key: 'play',
      value: function play() {
        var _this22 = this;
        play_log(this.constructor.displayName + '.play ' + this.actions.length + ' actions');
        var p = new Promise(function (resolve) {
          resolve();
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
          var _loop = function _loop() {
            var action = _step.value;
            action.input = _this22.input;
            p = p.then(function () {
              return action.play.apply(action, arguments);
            }).then(function () {
              for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }

              // to release js execute lock
              return new Promise(function (resolve) {
                return setTimeout(function () {
                  resolve.apply(undefined, args);
                }, 1);
              });
            });
          };
          for (var _iterator = this.actions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        return p;
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(FlowControlAction.prototype.__proto__ || Object.getPrototypeOf(FlowControlAction.prototype), 'toJSON', this).call(this), {
          actions: this.actions.map(function (action) {
            return action.toJSON();
          }),
          name: this.name
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        var _this23 = this;
        return new this(document, data.actions.map(function (action) {
          return _this23.BaseAction.fromJSON(document, action);
        }, data.name));
      }
    }]);
    return FlowControlAction;
  }(ReplayableAction);
  FlowControlAction.displayName = 'FlowControlAction';
  FlowControlAction.BaseAction = Action;
  var HoverAction = exports.HoverAction = function (_FlowControlAction) {
    _inherits(HoverAction, _FlowControlAction);
    function HoverAction() {
      _classCallCheck(this, HoverAction);
      return _possibleConstructorReturn(this, (HoverAction.__proto__ || Object.getPrototypeOf(HoverAction)).apply(this, arguments));
    }
    return HoverAction;
  }(FlowControlAction);
  HoverAction.displayName = 'HoverAction';
  ;

  /**
   * keydown + keypress + keyup
   * @param {Events|Action|Event|trueEvent} action - single action of keydown/keypress/keyup
   */

  var KeyAction = exports.KeyAction = function (_FlowControlAction2) {
    _inherits(KeyAction, _FlowControlAction2);
    function KeyAction(document, action) {
      _classCallCheck(this, KeyAction);
      if ((0, _isArray3.default)(action)) {
        var _this25 = _possibleConstructorReturn(this, (KeyAction.__proto__ || Object.getPrototypeOf(KeyAction)).call(this, document, action));
      } else {
        var _this25 = _possibleConstructorReturn(this, (KeyAction.__proto__ || Object.getPrototypeOf(KeyAction)).call(this, document));
        var event = action.event || action;
        if (event.preventDefault) {
          event = utils.serializeEvent(event);
        }
        _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
          typeArg: 'keydown'
        })));
        _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
          typeArg: 'keypress'
        })));
        _this25.addAction(new KeyboardAction(document, Object.assign({}, event, {
          typeArg: 'keyup'
        })));
      }
      return _possibleConstructorReturn(_this25);
    }
    return KeyAction;
  }(FlowControlAction);
  KeyAction.displayName = 'KeyAction';
  ;
  var LoopAction = exports.LoopAction = function (_FlowControlAction3) {
    _inherits(LoopAction, _FlowControlAction3);
    function LoopAction(document, actions, num, arr) {
      _classCallCheck(this, LoopAction);
      var _this26 = _possibleConstructorReturn(this, (LoopAction.__proto__ || Object.getPrototypeOf(LoopAction)).call(this, document, actions));
      _this26.num = num;
      _this26.arr = arr;
      return _this26;
    }
    _createClass(LoopAction, [{
      key: 'play',
      value: function play() {
        var _this27 = this;
        play_log(this.constructor.displayName + '.play ' + this.num + ' times with ' + this.actions.length + ' actions');
        var p = new Promise(function (resolve) {
          resolve();
        });
        if (this.num) {
          for (var i = 0; i < this.num; i++) {
            p = p.then(function () {
              var _get2;
              for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              return (_get2 = _get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'play', _this27)).call.apply(_get2, [_this27].concat(args));
            });
          }
          return p;
        }
        if (this.arr) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;
          try {
            for (var _iterator2 = this.arr[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var element = _step2.value;
              //eslint-disable-line no-unused-vars
              p = p.then(function () {
                var _get3;
                for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                return (_get3 = _get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'play', _this27)).call.apply(_get3, [_this27].concat(args));
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
          return p;
        }
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(LoopAction.prototype.__proto__ || Object.getPrototypeOf(LoopAction.prototype), 'toJSON', this).call(this), {
          num: this.variables.num,
          arr: this.variables.arr
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        var _this28 = this;
        return new this(document, data.actions.map(function (action) {
          return _this28.BaseAction.fromJSON(document, action);
        }), data.num, data.arr);
      }
    }]);
    return LoopAction;
  }(FlowControlAction);
  LoopAction.displayName = 'LoopAction';
  LoopAction.BaseAction = Action;
  LoopAction.variables = {
    num: _utils.Variable,
    arr: _utils.Variable
  };
  var PaginationAction = exports.PaginationAction = function (_LoopAction) {
    _inherits(PaginationAction, _LoopAction);
    function PaginationAction() {
      _classCallCheck(this, PaginationAction);
      return _possibleConstructorReturn(this, (PaginationAction.__proto__ || Object.getPrototypeOf(PaginationAction)).apply(this, arguments));
    }
    return PaginationAction;
  }(LoopAction);
  PaginationAction.displayName = 'PaginationAction';
  ;

  /* wait actions */

  var WaitAction = exports.WaitAction = function (_Action2) {
    _inherits(WaitAction, _Action2);
    function WaitAction(document) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      _classCallCheck(this, WaitAction);
      var _this30 = _possibleConstructorReturn(this, (WaitAction.__proto__ || Object.getPrototypeOf(WaitAction)).call(this, document));
      _this30.timeout = timeout;
      return _this30;
    }
    _createClass(WaitAction, [{
      key: 'play',
      value: function play() {
        var _this31 = this;
        play_log(this.constructor.displayName + '.wait ' + this.timeout + 'ms');
        return new Promise(function (resolve) {
          setTimeout(resolve, _this31.timeout);
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(WaitAction.prototype.__proto__ || Object.getPrototypeOf(WaitAction.prototype), 'toJSON', this).call(this), {
          timeout: this.timeout
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.timeout);
      }
    }]);
    return WaitAction;
  }(Action);
  WaitAction.displayName = 'WaitAction';
  var WaitMutationAction = exports.WaitMutationAction = function (_WaitForTarget3) {
    _inherits(WaitMutationAction, _WaitForTarget3);
    function WaitMutationAction(document, mutationRecord) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
      _classCallCheck(this, WaitMutationAction);
      var _this32 = _possibleConstructorReturn(this, (WaitMutationAction.__proto__ || Object.getPrototypeOf(WaitMutationAction)).call(this, document));
      _this32.replayable = false;
      _this32.type = mutationRecord.type;
      _this32.target = mutationRecord.target.nodeName ? utils.serializeElement(mutationRecord.target) : mutationRecord.target;
      _this32.attributeName = mutationRecord.attributeName;
      _this32.timeout = timeout;
      return _this32;
    }
    _createClass(WaitMutationAction, [{
      key: 'play',
      value: function play() {
        var _this33 = this;
        play_log(this.constructor.displayName + '.wait ' + this.type + ' change on "' + this.target.cssSelector + '"');
        return this.waitForTarget(this.target, this, timeout).then(function (target) {
          // eslint-disable-line no-undef
          return new Promise(function (resolve) {
            var timer = null;
            if (_this33.timeout) timer = setTimeout(function () {
              play_log(_this33.constructor.displayName + '.wait timeouted after ' + _this33.timeout + ' ms');
              rawClearup(resolve);
            }, _this33.timeout);
            var rawClearup = function rawClearup(callback) {
              if (timer) clearTimeout(timer);
              ob.disconnect();
              return callback();
            };
            var clearup = (0, _debounce3.default)(rawClearup);
            var ob = new MutationObserver(function (mutations) {
              if (_this33.type == 'attributes' && _this33.attributeName) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;
                try {
                  for (var _iterator3 = mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var m = _step3.value;
                    if (m.type == _this33.type && m.attributeName == _this33.attributeName) {
                      play_log(_this33.constructor.displayName + '.wait done');
                      clearup(resolve);
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              } else {
                play_log(_this33.constructor.displayName + '.wait done');
                clearup(resolve);
              }
            });
            var config = {};
            config[_this33.type] = true;
            ob.observe(target, config);
          });
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(WaitMutationAction.prototype.__proto__ || Object.getPrototypeOf(WaitMutationAction.prototype), 'toJSON', this).call(this), {
          mutationRecord: (0, _object2.default)(this, ['type', 'target', 'attributeName']),
          timeout: this.timeout
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.mutationRecord, data.timeout);
      }
    }]);
    return WaitMutationAction;
  }(WaitForTarget(BrowserAction));
  WaitMutationAction.displayName = 'WaitMutationAction';
  var WaitRegionMutationAction = exports.WaitRegionMutationAction = function (_WaitForTarget4) {
    _inherits(WaitRegionMutationAction, _WaitForTarget4);
    function WaitRegionMutationAction(document, target, options) {
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
      _classCallCheck(this, WaitRegionMutationAction);
      var _this34 = _possibleConstructorReturn(this, (WaitRegionMutationAction.__proto__ || Object.getPrototypeOf(WaitRegionMutationAction)).call(this, document));
      _this34.replayable = false;
      _this34.target = target.nodeName ? utils.serializeElement(target) : target;
      _this34.options = options;
      _this34.timeout = timeout;
      return _this34;
    }
    _createClass(WaitRegionMutationAction, [{
      key: 'play',
      value: function play() {
        var _this35 = this;
        play_log(this.constructor.displayName + '.wait mutation on "' + this.target.cssSelector + '"');
        return this.waitForTarget(this.target, this.timeout).then(function (target) {
          return new Promise(function (resolve) {
            var timer = null;
            if (_this35.timeout) timer = setTimeout(function () {
              play_log(_this35.constructor.displayName + '.wait timeouted after ' + _this35.timeout + ' ms');
              rawClearup(resolve);
            }, _this35.timeout);
            var rawClearup = function rawClearup(callback) {
              if (timer) clearTimeout(timer);
              ob.disconnect();
              return callback();
            };
            var clearup = (0, _debounce3.default)(rawClearup, 100);
            var ob = new MutationObserver(function () {
              clearup(resolve);
            });
            ob.observe(target, _this35.options);
          });
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(WaitRegionMutationAction.prototype.__proto__ || Object.getPrototypeOf(WaitRegionMutationAction.prototype), 'toJSON', this).call(this), {
          target: this.target,
          options: this.options,
          timeout: this.timeout
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.target, data.options, data.timeout);
      }
    }]);
    return WaitRegionMutationAction;
  }(WaitForTarget(BrowserAction));

  /* interface for nightmare actions */

  WaitRegionMutationAction.displayName = 'WaitRegionMutationAction';
  var NightmareAction = exports.NightmareAction = function (_Action3) {
    _inherits(NightmareAction, _Action3);
    function NightmareAction() {
      _classCallCheck(this, NightmareAction);
      return _possibleConstructorReturn(this, (NightmareAction.__proto__ || Object.getPrototypeOf(NightmareAction)).apply(this, arguments));
    }
    _createClass(NightmareAction, [{
      key: 'nightmare',
      get: function get() {
        return this.document;
      }
    }]);
    return NightmareAction;
  }(Action);
  NightmareAction.displayName = 'NightmareAction';
  var OpenNextNewWindowInCurrentTabAction = exports.OpenNextNewWindowInCurrentTabAction = function (_NightmareAction) {
    _inherits(OpenNextNewWindowInCurrentTabAction, _NightmareAction);
    function OpenNextNewWindowInCurrentTabAction() {
      _classCallCheck(this, OpenNextNewWindowInCurrentTabAction);
      return _possibleConstructorReturn(this, (OpenNextNewWindowInCurrentTabAction.__proto__ || Object.getPrototypeOf(OpenNextNewWindowInCurrentTabAction)).apply(this, arguments));
    }
    return OpenNextNewWindowInCurrentTabAction;
  }(NightmareAction);
  OpenNextNewWindowInCurrentTabAction.displayName = 'OpenNextNewWindowInCurrentTabAction';
  ;
  var WaitLoadingAction = exports.WaitLoadingAction = function (_NightmareAction2) {
    _inherits(WaitLoadingAction, _NightmareAction2);
    function WaitLoadingAction() {
      _classCallCheck(this, WaitLoadingAction);
      return _possibleConstructorReturn(this, (WaitLoadingAction.__proto__ || Object.getPrototypeOf(WaitLoadingAction)).apply(this, arguments));
    }
    _createClass(WaitLoadingAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(WaitLoadingAction.prototype.__proto__ || Object.getPrototypeOf(WaitLoadingAction.prototype), 'toJSON', this).call(this), {
          url: this.url
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        var self = new this(document, data);
        self.url = data.url;
        return self;
      }
    }]);
    return WaitLoadingAction;
  }(NightmareAction);
  WaitLoadingAction.displayName = 'WaitLoadingAction';
  var GetHTMLAction = exports.GetHTMLAction = function (_NightmareAction3) {
    _inherits(GetHTMLAction, _NightmareAction3);
    function GetHTMLAction() {
      _classCallCheck(this, GetHTMLAction);
      return _possibleConstructorReturn(this, (GetHTMLAction.__proto__ || Object.getPrototypeOf(GetHTMLAction)).apply(this, arguments));
    }
    return GetHTMLAction;
  }(NightmareAction);
  GetHTMLAction.displayName = 'GetHTMLAction';
  var GotoAction = exports.GotoAction = function (_NightmareAction4) {
    _inherits(GotoAction, _NightmareAction4);
    function GotoAction(document, url, options) {
      _classCallCheck(this, GotoAction);
      var _this40 = _possibleConstructorReturn(this, (GotoAction.__proto__ || Object.getPrototypeOf(GotoAction)).call(this, document));
      _this40.url = url;
      _this40.options = options;
      return _this40;
    }
    _createClass(GotoAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(GotoAction.prototype.__proto__ || Object.getPrototypeOf(GotoAction.prototype), 'toJSON', this).call(this), {
          url: this.variables.url,
          options: this.options
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.url, data.options);
      }
    }]);
    return GotoAction;
  }(NightmareAction);
  GotoAction.displayName = 'GotoAction';
  GotoAction.variables = {
    url: _utils.Variable
  };
  var ViewportAction = exports.ViewportAction = function (_NightmareAction5) {
    _inherits(ViewportAction, _NightmareAction5);
    function ViewportAction(document, width, height) {
      _classCallCheck(this, ViewportAction);
      var _this41 = _possibleConstructorReturn(this, (ViewportAction.__proto__ || Object.getPrototypeOf(ViewportAction)).call(this, document));
      _this41.width = width;
      _this41.height = height;
      return _this41;
    }
    _createClass(ViewportAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(ViewportAction.prototype.__proto__ || Object.getPrototypeOf(ViewportAction.prototype), 'toJSON', this).call(this), {
          width: this.variables.width,
          height: this.variables.height
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.width, data.height);
      }
    }]);
    return ViewportAction;
  }(NightmareAction);
  ViewportAction.displayName = 'ViewportAction';
  ViewportAction.variables = {
    width: _utils.Variable,
    height: _utils.Variable
  };
  var ExtractDataAction = exports.ExtractDataAction = function (_NightmareAction6) {
    _inherits(ExtractDataAction, _NightmareAction6);
    function ExtractDataAction(document, runtimeConfig) {
      _classCallCheck(this, ExtractDataAction);
      var _this42 = _possibleConstructorReturn(this, (ExtractDataAction.__proto__ || Object.getPrototypeOf(ExtractDataAction)).call(this, document));
      _this42.runtimeConfig = runtimeConfig;
      return _this42;
    }
    _createClass(ExtractDataAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(ExtractDataAction.prototype.__proto__ || Object.getPrototypeOf(ExtractDataAction.prototype), 'toJSON', this).call(this), {
          runtimeConfig: this.variables.runtimeConfig
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.runtimeConfig);
      }
    }]);
    return ExtractDataAction;
  }(NightmareAction);
  ExtractDataAction.displayName = 'ExtractDataAction';
  ExtractDataAction.variables = {
    runtimeConfig: _utils.Variable
  };
  var CaptchaAction = exports.CaptchaAction = function (_ReplayableAction3) {
    _inherits(CaptchaAction, _ReplayableAction3);
    function CaptchaAction(document, options) {
      _classCallCheck(this, CaptchaAction);

      /**
       * Options structure
       * {
       *   "type": "RECAPTCHA" || "FUNCAPTCHA" || "IMAGECAPTCHA", // Defines which type of captcha are we trying to solve.
       *   "inputElement": "<CSS_SELECTOR>", // If type is "RECAPTCHA" or "FUNCAPTCHA", this is a css selector for main HTML element containing those captchas
       *   Else for "IMAGECAPTCHA" this is a css selector to the textbox where captcha answer should be provided.
       *   "imageElement": "<CSS_SELECTOR>", // Required only if type is "IMAGECAPTCHA", it should contain css selector to the image element that contains the actual captcha.
       * }
       */

      var _this43 = _possibleConstructorReturn(this, (CaptchaAction.__proto__ || Object.getPrototypeOf(CaptchaAction)).call(this, document));
      switch (options.type) {
        case CaptchaAction.CAPTCHA_TYPES.RECAPTCHA:
        case CaptchaAction.CAPTCHA_TYPES.FUNCAPTCHA:
          if (!options.inputElement) throw new Error('Missing required property inputElement.');
          break;
        case CaptchaAction.CAPTCHA_TYPES.IMAGECAPTCHA:
          if (!options.inputElement) throw new Error('Missing required property inputElement.');
          if (!options.imageElement) throw new Error('Missing required property imageElement.');
          break;
        default:
          throw new Error('Incorrect value for type property. Allowed values are ' + Object.keys(CaptchaAction.CAPTCHA_TYPES) + '.');
      }
      _this43.options = options;
      return _this43;
    }
    _createClass(CaptchaAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(CaptchaAction.prototype.__proto__ || Object.getPrototypeOf(CaptchaAction.prototype), 'toJSON', this).call(this), {
          options: this.options
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.options);
      }
    }, {
      key: 'fromClickAction',
      value: function fromClickAction(action) {
        return this.fromClickEvent(action.document, action.trueEvent);
      }
    }, {
      key: 'fromClickEvent',
      value: function fromClickEvent(document, event) {
        var element = event.target;
        while (element && !element.hasAttribute('captchafound')) {
          element = element.parentElement;
        }
        if (element && element.getAttribute('captchatype')) {
          return new CaptchaAction(document, {
            type: element.getAttribute('captchatype'),
            inputElement: utils.serializeElement(element).cssSelector
          });
        } else if (event.target.tagName === 'IMG') {
          // find nearest input as inputElement
          var inputElement = utils.findNearestElement(event.target, 'input:not([type=hidden])');
          if (!inputElement) throw new Error('cannot find captcha input box.');
          return new CaptchaAction(document, {
            type: this.CAPTCHA_TYPES.IMAGECAPTCHA,
            inputElement: utils.serializeElement(inputElement).cssSelector,
            imageElement: utils.serializeElement(event.target).cssSelector
          });
        }
      }
    }]);
    return CaptchaAction;
  }(ReplayableAction);
  CaptchaAction.displayName = 'CaptchaAction';
  CaptchaAction.CAPTCHA_TYPES = {
    RECAPTCHA: 'RECAPTCHA',
    FUNCAPTCHA: 'FUNCAPTCHA',
    IMAGECAPTCHA: 'IMAGECAPTCHA'
  };
  var RenderAction = exports.RenderAction = function (_NightmareAction7) {
    _inherits(RenderAction, _NightmareAction7);
    function RenderAction(document, options) {
      _classCallCheck(this, RenderAction);
      var _this44 = _possibleConstructorReturn(this, (RenderAction.__proto__ || Object.getPrototypeOf(RenderAction)).call(this, document));
      _this44.options = options;
      return _this44;
    }
    _createClass(RenderAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(RenderAction.prototype.__proto__ || Object.getPrototypeOf(RenderAction.prototype), 'toJSON', this).call(this), {
          options: this.variables.options
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.options);
      }
    }]);
    return RenderAction;
  }(NightmareAction);
  RenderAction.displayName = 'RenderAction';
  RenderAction.variables = {
    options: _utils.Variable
  };
  var ScreenCaptureAction = exports.ScreenCaptureAction = function (_NightmareAction8) {
    _inherits(ScreenCaptureAction, _NightmareAction8);

    /**
     * @param {*} type pdf / png
     */
    function ScreenCaptureAction(document) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'png';
      _classCallCheck(this, ScreenCaptureAction);
      var _this45 = _possibleConstructorReturn(this, (ScreenCaptureAction.__proto__ || Object.getPrototypeOf(ScreenCaptureAction)).call(this, document));
      _this45.type = type;
      return _this45;
    }
    _createClass(ScreenCaptureAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(ScreenCaptureAction.prototype.__proto__ || Object.getPrototypeOf(ScreenCaptureAction.prototype), 'toJSON', this).call(this), {
          type: this.type
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.type);
      }
    }]);
    return ScreenCaptureAction;
  }(NightmareAction);
  ScreenCaptureAction.displayName = 'ScreenCaptureAction';
  var CodeAction = exports.CodeAction = function (_Action4) {
    _inherits(CodeAction, _Action4);
    function CodeAction(document, code) {
      var checkBlocked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      _classCallCheck(this, CodeAction);
      var _this46 = _possibleConstructorReturn(this, (CodeAction.__proto__ || Object.getPrototypeOf(CodeAction)).call(this, document));
      _this46.code = code;
      _this46.checkBlocked = checkBlocked;
      return _this46;
    }
    _createClass(CodeAction, [{
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(CodeAction.prototype.__proto__ || Object.getPrototypeOf(CodeAction.prototype), 'toJSON', this).call(this), {
          code: (0, _isFunction3.default)(this.code) ? this.code.toString() : this.code,
          checkBlocked: this.checkBlocked
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.code, data.checkBlocked);
      }
    }]);
    return CodeAction;
  }(Action);

  /**
   * WARNING: never eval callback within node.js / nightmare context
   */

  CodeAction.displayName = 'CodeAction';
  var FunctionAction = exports.FunctionAction = function (_Action5) {
    _inherits(FunctionAction, _Action5);
    function FunctionAction(document, callback, args, timeout, context) {
      _classCallCheck(this, FunctionAction);
      var _this47 = _possibleConstructorReturn(this, (FunctionAction.__proto__ || Object.getPrototypeOf(FunctionAction)).call(this, document));
      _this47.timeout = timeout;
      _this47.callback = callback;
      _this47.args = args;
      // User can execute js within iframe context by specify a css selector to the iframe
      // To switch into multiple level iframes, split the selectors with `|=>`
      // e.g.  iframe#level1 |=> iframe#level2
      _this47.context = context;
      return _this47;
    }
    _createClass(FunctionAction, [{
      key: 'play',
      value: function play() {
        play_log(this.constructor.displayName + '.play');
        var callback = this.callback;
        if (!(0, _isFunction3.default)(callback)) {
          callback = eval(callback);
        }
        var args = this.args;
        if (!(0, _isArray3.default)(this.args)) {
          args = [this.args];
        }
        return callback.apply(undefined, _toConsumableArray(args));
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return Object.assign(_get(FunctionAction.prototype.__proto__ || Object.getPrototypeOf(FunctionAction.prototype), 'toJSON', this).call(this), {
          args: this.variables.args,
          callback: (0, _isFunction3.default)(this.callback) ? this.callback.toString() : this.callback,
          timeout: this.variables.timeout,
          context: this.context
        });
      }
    }], [{
      key: 'fromJSON',
      value: function fromJSON(document, data) {
        return new this(document, data.callback, data.args, data.timeout, data.context);
      }
    }]);
    return FunctionAction;
  }(Action);
  FunctionAction.displayName = 'FunctionAction';
  FunctionAction.variables = {
    args: _utils.Variable,
    timeout: _utils.Variable
  };

  /***/
}, /* 60 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(54),
    isObject = __webpack_require__(48);

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  module.exports = isFunction;

  /***/
}, /* 61 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(54),
    isObjectLike = __webpack_require__(58);

  /** `Object#toString` result references. */
  var numberTag = '[object Number]';

  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */
  function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
  }
  module.exports = isNumber;

  /***/
}, /* 62 */
/***/function (module, exports) {
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  module.exports = isArray;

  /***/
}, /* 63 */
/***/function (module, exports, __webpack_require__) {
  /*!
   * object.pick <https://github.com/jonschlinkert/object.pick>
   *
   * Copyright (c) 2014-2015 Jon Schlinkert, contributors.
   * Licensed under the MIT License
   */

  'use strict';

  var isObject = __webpack_require__(64);
  module.exports = function pick(obj, keys) {
    if (!isObject(obj) && typeof obj !== 'function') {
      return {};
    }
    var res = {};
    if (typeof keys === 'string') {
      if (keys in obj) {
        res[keys] = obj[keys];
      }
      return res;
    }
    var len = keys.length;
    var idx = -1;
    while (++idx < len) {
      var key = keys[idx];
      if (key in obj) {
        res[key] = obj[key];
      }
    }
    return res;
  };

  /***/
}, /* 64 */
/***/function (module, exports) {
  /*!
   * isobject <https://github.com/jonschlinkert/isobject>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */

  'use strict';

  module.exports = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
  };

  /***/
}, /* 65 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.waitForTarget = exports.Variable = undefined;
  var _findLastIndex2 = __webpack_require__(66);
  var _findLastIndex3 = _interopRequireDefault(_findLastIndex2);
  var _findIndex2 = __webpack_require__(174);
  var _findIndex3 = _interopRequireDefault(_findIndex2);
  var _get2 = __webpack_require__(154);
  var _get3 = _interopRequireDefault(_get2);
  var _isObject2 = __webpack_require__(48);
  var _isObject3 = _interopRequireDefault(_isObject2);
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }(); // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
  // Author: Kuan Huang<kuan.huang@import.io>
  // Created on 2016-11-30

  /**
   * Wait for target element appear
   */
  var waitForTarget = exports.waitForTarget = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(target) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var targetCheckInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var base = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
      var startTime, trueTarget;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              startTime = new Date();
            case 1:
              if (!(Date.now() - startTime < timeout)) {
                _context.next = 11;
                break;
              }
              trueTarget = deserializeElement(target, base);
              if (!trueTarget) {
                _context.next = 7;
                break;
              }
              return _context.abrupt('return', trueTarget);
            case 7:
              _context.next = 9;
              return new Promise(function (r) {
                return setTimeout(r, targetCheckInterval);
              });
            case 9:
              _context.next = 1;
              break;
            case 11:
              throw new Error('cannot find target ' + target.cssSelector + ' after ' + timeout + 'ms');
            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return function waitForTarget(_x4) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * resolve variables value from input
   * @param {Action|JSON} object the action
   * @param {object} input input dict
   * @return json object of the action
   */

  exports.serializeEvent = serializeEvent;
  exports.deserializeEvent = deserializeEvent;
  exports.serializeElement = serializeElement;
  exports.deserializeElement = deserializeElement;
  exports.resolveVariables = resolveVariables;
  exports.findNearestElement = findNearestElement;
  var _object = __webpack_require__(63);
  var _object2 = _interopRequireDefault(_object);
  var _webExtractor = __webpack_require__(175);
  var _actions = __webpack_require__(59);
  var _actions2 = _interopRequireDefault(_actions);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }
        return step("next");
      });
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var EventInit = function () {
    function EventInit() {
      _classCallCheck(this, EventInit);
    }
    _createClass(EventInit, null, [{
      key: 'Event',
      get: function get() {
        return {
          bubbles: false,
          cancelable: false
          //scoped: false,
          //composed: false,
        };
      }
    }, {
      key: 'UIEvent',
      get: function get() {
        return Object.assign(this.Event, {
          detail: 0
          //view: null,
        });
      }
    }, {
      key: 'FocusEvent',
      get: function get() {
        return this.UIEvent;
      }
    }, {
      key: 'MouseEvent',
      get: function get() {
        return Object.assign(this.UIEvent, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          button: 0,
          buttons: 0,
          relatedTarget: null
        });
      }
    }, {
      key: 'KeyboardEvent',
      get: function get() {
        return Object.assign(this.UIEvent, {
          key: '',
          code: '',
          location: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          repeat: false,
          //isComposing: false,
          charCode: 0,
          keyCode: 0,
          which: 0
        });
      }
    }]);
    return EventInit;
  }();
  EventInit.displayName = 'EventInit';
  function serializeEvent(event) {
    if (!EventInit[event.constructor.name]) throw Error('not supported event type: ' + event.constructor.name);
    var eventInit = (0, _object2.default)(event, Object.keys(EventInit[event.constructor.name]));
    for (var key in eventInit) {
      if (eventInit[key] && eventInit[key].nodeName) {
        eventInit[key] = serializeElement(eventInit[key]);
      }
    }
    return {
      constructor: event.constructor.name,
      target: serializeElement(event.target),
      typeArg: event.type,
      eventInit: eventInit
    };
  }
  function deserializeEvent(event) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (!EventInit[event.constructor]) throw Error('not supported event type: ' + event.constructor);
    var eventInit = Object.assign({}, event.eventInit);
    for (var key in eventInit) {
      eventInit[key] = deserializeElement(eventInit[key], base);
    }
    return new base.defaultView[event.constructor](event.typeArg, eventInit);
  }
  function serializeElement(element) {
    return _serializeElement_webExtractor(element);
  }
  function _serializeElement_webExtractor(element) {
    var cssSelector = void 0;
    if (element && element.nodeName && element.nodeType != Node.DOCUMENT_NODE) {
      // web-extractor will cache the attributes for an element
      // adding this hack to clear the cache
      if (element.__path) {
        element.__path = undefined;
      }
      var elementSelector = (0, _webExtractor.getElementSelector)(element, getRootNode(element), false);
      if (elementSelector) cssSelector = (0, _webExtractor.toCssSelector)(elementSelector);
    }
    var label = void 0;
    if (element.tagName === 'INPUT' && element.labels && element.labels.length) {
      label = [].concat(_toConsumableArray(element.labels)).map(function (l) {
        return (l.innerText || '').trim();
      }).filter(function (x) {
        return x;
      })[0];
    }
    if (element.tagName === 'INPUT' && !label) {
      var prevElement = element.previousSibling || element.offsetParent;
      while (prevElement) {
        if (prevElement.nodeType === Node.TEXT_NODE && prevElement.textContent.trim()) {
          label = prevElement.textContent.trim();
          break;
        } else if (prevElement.innerText) {
          label = prevElement.innerText;
          break;
        }
        prevElement = prevElement.previousSibling || prevElement.offsetParent;
      }
    }
    if (label && label.length > 100) {
      label = undefined;
    }
    return {
      cssSelector: cssSelector || null,
      type: element.type,
      name: element.name,
      label: label
    };
  }
  function deserializeElement(element) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (element && element.cssSelector !== undefined) {
      if (!element.cssSelector) return base;
      return base.querySelector(element.cssSelector);
    }
    return element;
  }
  function getRootNode(node) {
    if (node.parentNode != null) {
      return getRootNode(node.parentNode);
    }
    return node;
  }

  /**
   * Mark variables in actions, accept input to change the variables used in actions
   *
   * @param {Boolean} variable=false mark as variable
   * @param {String} name name of variable
   * @param {ANY} defaultValue default value of variable
   */

  var Variable = exports.Variable = function () {
    _createClass(Variable, [{
      key: 'variable',
      get: function get() {
        return this['$variable$'];
      },
      set: function set(value) {
        return this['$variable$'] = value;
      }
    }]);
    function Variable() {
      var variable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var name = arguments[1];
      var defaultValue = arguments[2];
      _classCallCheck(this, Variable);
      this.variable = variable;
      this.name = name;
      this.defaultValue = defaultValue;
    }
    _createClass(Variable, [{
      key: 'toJSON',
      value: function toJSON() {
        if (this.variable && this.name) {
          return {
            '$variable$': this.variable,
            name: this.name,
            defaultValue: this.defaultValue
          };
        } else {
          return this.defaultValue;
        }
      }

      /**
       * get variable value
       * if it's a variable, try to pick up the value from obj.input, otherwise return defaultValue
       * @param {Action} obj instance of the variable
       * @return {ANY} value
       */
    }, {
      key: 'get',
      value: function get(obj) {
        if (this.variable && obj.input && this.name) {
          return (0, _get3.default)(obj.input, this.name, this.defaultValue);
        } else {
          return this.defaultValue;
        }
      }

      /**
       * set variable value
       * @param {Action} obj instance of the variable
       * @param {ANY} value value of variable
       */
    }, {
      key: 'set',
      value: function set(obj, value) {
        if (value && (value['$variable$'] || value instanceof Variable)) {
          this.variable = value['$variable$'];
          this.name = value.name;
          this.defaultValue = value.defaultValue;
        } else {
          this.defaultValue = value;
        }
      }
    }]);
    return Variable;
  }();
  Variable.displayName = 'Variable';
  function resolveVariables(object) {
    var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (object instanceof _actions2.default) {
      object = object.toJSON();
    }
    if ((0, _isObject3.default)(object) && object['$variable$']) {
      return (0, _get3.default)(input, object.name, object.defaultValue);
    } else if ((0, _isObject3.default)(object)) {
      for (var key in object) {
        object[key] = resolveVariables(object[key], input);
      }
    }
    return object;
  }
  function findNearestElement(element, cssSelector) {
    var elem = element;
    while (elem && !elem.querySelector(cssSelector)) {
      elem = elem.parentElement;
    }
    if (!elem) return;
    var matchedElements = new Set(elem.querySelectorAll(cssSelector));
    var elementList = [].concat(_toConsumableArray(elem.getElementsByTagName('*')));
    var targetIndex = elementList.indexOf(element);
    var preceding = elementList.slice(0, targetIndex);
    var precedingElemIndex = (0, _findLastIndex3.default)(preceding, function (e) {
      return matchedElements.has(e);
    });
    var following = elementList.slice(targetIndex + 1);
    var followingElemIndex = (0, _findIndex3.default)(following, function (e) {
      return matchedElements.has(e);
    });
    if (precedingElemIndex == -1) {
      return following[followingElemIndex];
    } else if (followingElemIndex == -1) {
      return preceding[precedingElemIndex];
    } else if (preceding.length - precedingElemIndex < followingElemIndex) {
      return preceding[precedingElemIndex];
    } else {
      return following[followingElemIndex];
    }
  }

  /***/
}, /* 66 */
/***/function (module, exports, __webpack_require__) {
  var baseFindIndex = __webpack_require__(67),
    baseIteratee = __webpack_require__(68),
    toInteger = __webpack_require__(172);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max,
    nativeMin = Math.min;

  /**
   * This method is like `_.findIndex` except that it iterates over elements
   * of `collection` from right to left.
   *
   * @static
   * @memberOf _
   * @since 2.0.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=array.length-1] The index to search from.
   * @returns {number} Returns the index of the found element, else `-1`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'active': true },
   *   { 'user': 'fred',    'active': false },
   *   { 'user': 'pebbles', 'active': false }
   * ];
   *
   * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
   * // => 2
   *
   * // The `_.matches` iteratee shorthand.
   * _.findLastIndex(users, { 'user': 'barney', 'active': true });
   * // => 0
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.findLastIndex(users, ['active', false]);
   * // => 2
   *
   * // The `_.property` iteratee shorthand.
   * _.findLastIndex(users, 'active');
   * // => 0
   */
  function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length - 1;
    if (fromIndex !== undefined) {
      index = toInteger(fromIndex);
      index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
  }
  module.exports = findLastIndex;

  /***/
}, /* 67 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }
  module.exports = baseFindIndex;

  /***/
}, /* 68 */
/***/function (module, exports, __webpack_require__) {
  var baseMatches = __webpack_require__(69),
    baseMatchesProperty = __webpack_require__(153),
    identity = __webpack_require__(168),
    isArray = __webpack_require__(62),
    property = __webpack_require__(169);

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  module.exports = baseIteratee;

  /***/
}, /* 69 */
/***/function (module, exports, __webpack_require__) {
  var baseIsMatch = __webpack_require__(70),
    getMatchData = __webpack_require__(150),
    matchesStrictComparable = __webpack_require__(152);

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  module.exports = baseMatches;

  /***/
}, /* 70 */
/***/function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(71),
    baseIsEqual = __webpack_require__(107);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
      length = index,
      noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
        objValue = object[key],
        srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  module.exports = baseIsMatch;

  /***/
}, /* 71 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(72),
    stackClear = __webpack_require__(80),
    stackDelete = __webpack_require__(81),
    stackGet = __webpack_require__(82),
    stackHas = __webpack_require__(83),
    stackSet = __webpack_require__(84);

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  module.exports = Stack;

  /***/
}, /* 72 */
/***/function (module, exports, __webpack_require__) {
  var listCacheClear = __webpack_require__(73),
    listCacheDelete = __webpack_require__(74),
    listCacheGet = __webpack_require__(77),
    listCacheHas = __webpack_require__(78),
    listCacheSet = __webpack_require__(79);

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  module.exports = ListCache;

  /***/
}, /* 73 */
/***/function (module, exports) {
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  module.exports = listCacheClear;

  /***/
}, /* 74 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(75);

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  module.exports = listCacheDelete;

  /***/
}, /* 75 */
/***/function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(76);

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  module.exports = assocIndexOf;

  /***/
}, /* 76 */
/***/function (module, exports) {
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  module.exports = eq;

  /***/
}, /* 77 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(75);

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  module.exports = listCacheGet;

  /***/
}, /* 78 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(75);

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  module.exports = listCacheHas;

  /***/
}, /* 79 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(75);

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  module.exports = listCacheSet;

  /***/
}, /* 80 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(72);

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  module.exports = stackClear;

  /***/
}, /* 81 */
/***/function (module, exports) {
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
      result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  module.exports = stackDelete;

  /***/
}, /* 82 */
/***/function (module, exports) {
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }
  module.exports = stackGet;

  /***/
}, /* 83 */
/***/function (module, exports) {
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }
  module.exports = stackHas;

  /***/
}, /* 84 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(72),
    Map = __webpack_require__(85),
    MapCache = __webpack_require__(92);

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  module.exports = stackSet;

  /***/
}, /* 85 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map');
  module.exports = Map;

  /***/
}, /* 86 */
/***/function (module, exports, __webpack_require__) {
  var baseIsNative = __webpack_require__(87),
    getValue = __webpack_require__(91);

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  module.exports = getNative;

  /***/
}, /* 87 */
/***/function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(60),
    isMasked = __webpack_require__(88),
    isObject = __webpack_require__(48),
    toSource = __webpack_require__(90);

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  module.exports = baseIsNative;

  /***/
}, /* 88 */
/***/function (module, exports, __webpack_require__) {
  var coreJsData = __webpack_require__(89);

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  module.exports = isMasked;

  /***/
}, /* 89 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];
  module.exports = coreJsData;

  /***/
}, /* 90 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }
  module.exports = toSource;

  /***/
}, /* 91 */
/***/function (module, exports) {
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  module.exports = getValue;

  /***/
}, /* 92 */
/***/function (module, exports, __webpack_require__) {
  var mapCacheClear = __webpack_require__(93),
    mapCacheDelete = __webpack_require__(101),
    mapCacheGet = __webpack_require__(104),
    mapCacheHas = __webpack_require__(105),
    mapCacheSet = __webpack_require__(106);

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  module.exports = MapCache;

  /***/
}, /* 93 */
/***/function (module, exports, __webpack_require__) {
  var Hash = __webpack_require__(94),
    ListCache = __webpack_require__(72),
    Map = __webpack_require__(85);

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  module.exports = mapCacheClear;

  /***/
}, /* 94 */
/***/function (module, exports, __webpack_require__) {
  var hashClear = __webpack_require__(95),
    hashDelete = __webpack_require__(97),
    hashGet = __webpack_require__(98),
    hashHas = __webpack_require__(99),
    hashSet = __webpack_require__(100);

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  module.exports = Hash;

  /***/
}, /* 95 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(96);

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  module.exports = hashClear;

  /***/
}, /* 96 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86);

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');
  module.exports = nativeCreate;

  /***/
}, /* 97 */
/***/function (module, exports) {
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  module.exports = hashDelete;

  /***/
}, /* 98 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(96);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  module.exports = hashGet;

  /***/
}, /* 99 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(96);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  module.exports = hashHas;

  /***/
}, /* 100 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(96);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }
  module.exports = hashSet;

  /***/
}, /* 101 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(102);

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  module.exports = mapCacheDelete;

  /***/
}, /* 102 */
/***/function (module, exports, __webpack_require__) {
  var isKeyable = __webpack_require__(103);

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  module.exports = getMapData;

  /***/
}, /* 103 */
/***/function (module, exports) {
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  module.exports = isKeyable;

  /***/
}, /* 104 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(102);

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  module.exports = mapCacheGet;

  /***/
}, /* 105 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(102);

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  module.exports = mapCacheHas;

  /***/
}, /* 106 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(102);

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
      size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  module.exports = mapCacheSet;

  /***/
}, /* 107 */
/***/function (module, exports, __webpack_require__) {
  var baseIsEqualDeep = __webpack_require__(108),
    isObjectLike = __webpack_require__(58);

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  module.exports = baseIsEqual;

  /***/
}, /* 108 */
/***/function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(71),
    equalArrays = __webpack_require__(109),
    equalByTag = __webpack_require__(115),
    equalObjects = __webpack_require__(119),
    getTag = __webpack_require__(145),
    isArray = __webpack_require__(62),
    isBuffer = __webpack_require__(131),
    isTypedArray = __webpack_require__(135);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  module.exports = baseIsEqualDeep;

  /***/
}, /* 109 */
/***/function (module, exports, __webpack_require__) {
  var SetCache = __webpack_require__(110),
    arraySome = __webpack_require__(113),
    cacheHas = __webpack_require__(114);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
        othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  module.exports = equalArrays;

  /***/
}, /* 110 */
/***/function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(92),
    setCacheAdd = __webpack_require__(111),
    setCacheHas = __webpack_require__(112);

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
      length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  module.exports = SetCache;

  /***/
}, /* 111 */
/***/function (module, exports) {
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  module.exports = setCacheAdd;

  /***/
}, /* 112 */
/***/function (module, exports) {
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  module.exports = setCacheHas;

  /***/
}, /* 113 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  module.exports = arraySome;

  /***/
}, /* 114 */
/***/function (module, exports) {
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  module.exports = cacheHas;

  /***/
}, /* 115 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(55),
    Uint8Array = __webpack_require__(116),
    eq = __webpack_require__(76),
    equalArrays = __webpack_require__(109),
    mapToArray = __webpack_require__(117),
    setToArray = __webpack_require__(118);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  module.exports = equalByTag;

  /***/
}, /* 116 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;
  module.exports = Uint8Array;

  /***/
}, /* 117 */
/***/function (module, exports) {
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
      result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  module.exports = mapToArray;

  /***/
}, /* 118 */
/***/function (module, exports) {
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
      result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  module.exports = setToArray;

  /***/
}, /* 119 */
/***/function (module, exports, __webpack_require__) {
  var getAllKeys = __webpack_require__(120);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
        othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
        othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  module.exports = equalObjects;

  /***/
}, /* 120 */
/***/function (module, exports, __webpack_require__) {
  var baseGetAllKeys = __webpack_require__(121),
    getSymbols = __webpack_require__(123),
    keys = __webpack_require__(126);

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  module.exports = getAllKeys;

  /***/
}, /* 121 */
/***/function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(122),
    isArray = __webpack_require__(62);

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  module.exports = baseGetAllKeys;

  /***/
}, /* 122 */
/***/function (module, exports) {
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
      length = values.length,
      offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  module.exports = arrayPush;

  /***/
}, /* 123 */
/***/function (module, exports, __webpack_require__) {
  var arrayFilter = __webpack_require__(124),
    stubArray = __webpack_require__(125);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  module.exports = getSymbols;

  /***/
}, /* 124 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  module.exports = arrayFilter;

  /***/
}, /* 125 */
/***/function (module, exports) {
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }
  module.exports = stubArray;

  /***/
}, /* 126 */
/***/function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(127),
    baseKeys = __webpack_require__(140),
    isArrayLike = __webpack_require__(144);

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  module.exports = keys;

  /***/
}, /* 127 */
/***/function (module, exports, __webpack_require__) {
  var baseTimes = __webpack_require__(128),
    isArguments = __webpack_require__(129),
    isArray = __webpack_require__(62),
    isBuffer = __webpack_require__(131),
    isIndex = __webpack_require__(134),
    isTypedArray = __webpack_require__(135);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = arrayLikeKeys;

  /***/
}, /* 128 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  module.exports = baseTimes;

  /***/
}, /* 129 */
/***/function (module, exports, __webpack_require__) {
  var baseIsArguments = __webpack_require__(130),
    isObjectLike = __webpack_require__(58);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  module.exports = isArguments;

  /***/
}, /* 130 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(54),
    isObjectLike = __webpack_require__(58);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  module.exports = baseIsArguments;

  /***/
}, /* 131 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    var root = __webpack_require__(50),
      stubFalse = __webpack_require__(133);

    /** Detect free variable `exports`. */
    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(132)(module));

  /***/
}, /* 132 */
/***/function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};
      module.paths = [];
      // module.parent = undefined by default
      module.children = [];
      module.webpackPolyfill = 1;
    }
    return module;
  };

  /***/
}, /* 133 */
/***/function (module, exports) {
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }
  module.exports = stubFalse;

  /***/
}, /* 134 */
/***/function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  module.exports = isIndex;

  /***/
}, /* 135 */
/***/function (module, exports, __webpack_require__) {
  var baseIsTypedArray = __webpack_require__(136),
    baseUnary = __webpack_require__(138),
    nodeUtil = __webpack_require__(139);

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  module.exports = isTypedArray;

  /***/
}, /* 136 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(54),
    isLength = __webpack_require__(137),
    isObjectLike = __webpack_require__(58);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  module.exports = baseIsTypedArray;

  /***/
}, /* 137 */
/***/function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  module.exports = isLength;

  /***/
}, /* 138 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  module.exports = baseUnary;

  /***/
}, /* 139 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    var freeGlobal = __webpack_require__(51);

    /** Detect free variable `exports`. */
    var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    module.exports = nodeUtil;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(132)(module));

  /***/
}, /* 140 */
/***/function (module, exports, __webpack_require__) {
  var isPrototype = __webpack_require__(141),
    nativeKeys = __webpack_require__(142);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = baseKeys;

  /***/
}, /* 141 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  module.exports = isPrototype;

  /***/
}, /* 142 */
/***/function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(143);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);
  module.exports = nativeKeys;

  /***/
}, /* 143 */
/***/function (module, exports) {
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  module.exports = overArg;

  /***/
}, /* 144 */
/***/function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(60),
    isLength = __webpack_require__(137);

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  module.exports = isArrayLike;

  /***/
}, /* 145 */
/***/function (module, exports, __webpack_require__) {
  var DataView = __webpack_require__(146),
    Map = __webpack_require__(85),
    Promise = __webpack_require__(147),
    Set = __webpack_require__(148),
    WeakMap = __webpack_require__(149),
    baseGetTag = __webpack_require__(54),
    toSource = __webpack_require__(90);

  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
  var dataViewTag = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  module.exports = getTag;

  /***/
}, /* 146 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root, 'DataView');
  module.exports = DataView;

  /***/
}, /* 147 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Promise = getNative(root, 'Promise');
  module.exports = Promise;

  /***/
}, /* 148 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Set = getNative(root, 'Set');
  module.exports = Set;

  /***/
}, /* 149 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(86),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var WeakMap = getNative(root, 'WeakMap');
  module.exports = WeakMap;

  /***/
}, /* 150 */
/***/function (module, exports, __webpack_require__) {
  var isStrictComparable = __webpack_require__(151),
    keys = __webpack_require__(126);

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys(object),
      length = result.length;
    while (length--) {
      var key = result[length],
        value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  module.exports = getMatchData;

  /***/
}, /* 151 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(48);

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }
  module.exports = isStrictComparable;

  /***/
}, /* 152 */
/***/function (module, exports) {
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }
  module.exports = matchesStrictComparable;

  /***/
}, /* 153 */
/***/function (module, exports, __webpack_require__) {
  var baseIsEqual = __webpack_require__(107),
    get = __webpack_require__(154),
    hasIn = __webpack_require__(165),
    isKey = __webpack_require__(157),
    isStrictComparable = __webpack_require__(151),
    matchesStrictComparable = __webpack_require__(152),
    toKey = __webpack_require__(164);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  module.exports = baseMatchesProperty;

  /***/
}, /* 154 */
/***/function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(155);

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }
  module.exports = get;

  /***/
}, /* 155 */
/***/function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(156),
    toKey = __webpack_require__(164);

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
      length = path.length;
    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return index && index == length ? object : undefined;
  }
  module.exports = baseGet;

  /***/
}, /* 156 */
/***/function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(62),
    isKey = __webpack_require__(157),
    stringToPath = __webpack_require__(158),
    toString = __webpack_require__(161);

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value, object) {
    if (isArray(value)) {
      return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
  }
  module.exports = castPath;

  /***/
}, /* 157 */
/***/function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(62),
    isSymbol = __webpack_require__(53);

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  module.exports = isKey;

  /***/
}, /* 158 */
/***/function (module, exports, __webpack_require__) {
  var memoizeCapped = __webpack_require__(159);

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoizeCapped(function (string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function (match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  module.exports = stringToPath;

  /***/
}, /* 159 */
/***/function (module, exports, __webpack_require__) {
  var memoize = __webpack_require__(160);

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }
  module.exports = memoizeCapped;

  /***/
}, /* 160 */
/***/function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(92);

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function memoized() {
      var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  }

  // Expose `MapCache`.
  memoize.Cache = MapCache;
  module.exports = memoize;

  /***/
}, /* 161 */
/***/function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(162);

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }
  module.exports = toString;

  /***/
}, /* 162 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(55),
    arrayMap = __webpack_require__(163),
    isArray = __webpack_require__(62),
    isSymbol = __webpack_require__(53);

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  module.exports = baseToString;

  /***/
}, /* 163 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  module.exports = arrayMap;

  /***/
}, /* 164 */
/***/function (module, exports, __webpack_require__) {
  var isSymbol = __webpack_require__(53);

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  module.exports = toKey;

  /***/
}, /* 165 */
/***/function (module, exports, __webpack_require__) {
  var baseHasIn = __webpack_require__(166),
    hasPath = __webpack_require__(167);

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  module.exports = hasIn;

  /***/
}, /* 166 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  module.exports = baseHasIn;

  /***/
}, /* 167 */
/***/function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(156),
    isArguments = __webpack_require__(129),
    isArray = __webpack_require__(62),
    isIndex = __webpack_require__(134),
    isLength = __webpack_require__(137),
    toKey = __webpack_require__(164);

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
      length = path.length,
      result = false;
    while (++index < length) {
      var key = toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }
  module.exports = hasPath;

  /***/
}, /* 168 */
/***/function (module, exports) {
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }
  module.exports = identity;

  /***/
}, /* 169 */
/***/function (module, exports, __webpack_require__) {
  var baseProperty = __webpack_require__(170),
    basePropertyDeep = __webpack_require__(171),
    isKey = __webpack_require__(157),
    toKey = __webpack_require__(164);

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  module.exports = property;

  /***/
}, /* 170 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }
  module.exports = baseProperty;

  /***/
}, /* 171 */
/***/function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(155);

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }
  module.exports = basePropertyDeep;

  /***/
}, /* 172 */
/***/function (module, exports, __webpack_require__) {
  var toFinite = __webpack_require__(173);

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  function toInteger(value) {
    var result = toFinite(value),
      remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }
  module.exports = toInteger;

  /***/
}, /* 173 */
/***/function (module, exports, __webpack_require__) {
  var toNumber = __webpack_require__(52);

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  module.exports = toFinite;

  /***/
}, /* 174 */
/***/function (module, exports, __webpack_require__) {
  var baseFindIndex = __webpack_require__(67),
    baseIteratee = __webpack_require__(68),
    toInteger = __webpack_require__(172);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * This method is like `_.find` except that it returns the index of the first
   * element `predicate` returns truthy for instead of the element itself.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the found element, else `-1`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'active': false },
   *   { 'user': 'fred',    'active': false },
   *   { 'user': 'pebbles', 'active': true }
   * ];
   *
   * _.findIndex(users, function(o) { return o.user == 'barney'; });
   * // => 0
   *
   * // The `_.matches` iteratee shorthand.
   * _.findIndex(users, { 'user': 'fred', 'active': false });
   * // => 1
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.findIndex(users, ['active', false]);
   * // => 0
   *
   * // The `_.property` iteratee shorthand.
   * _.findIndex(users, 'active');
   * // => 2
   */
  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
      index = nativeMax(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
  }
  module.exports = findIndex;

  /***/
}, /* 175 */
/***/function (module, exports) {
  module.exports = /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/
    __webpack_require__.i = function (value) {
      return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          /******/configurable: false,
          /******/enumerable: true,
          /******/get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 24);
    /******/
  }
  /************************************************************************/
  /******/([/* 0 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.toCssSelectorSection = undefined;
      exports.fullSelector = fullSelector;
      exports.fullXPath = fullXPath;
      exports.shortSelector = shortSelector;
      exports.getPath = getPath;
      exports.toMultiCssSelector = toMultiCssSelector;
      exports.toCssSelector = toCssSelector;
      exports.querySelectorAll = querySelectorAll;
      exports.getByFullXPath = getByFullXPath;
      exports.selectByXPath = selectByXPath;
      exports.selectNodes = selectNodes;
      exports.updatePathFormat = updatePathFormat;
      exports.compactSelector = compactSelector;
      exports.uniqueNode = uniqueNode;
      exports.selectNode = selectNode;
      exports.indexCondition = indexCondition;
      var _css = __webpack_require__(12);
      var _css2 = _interopRequireDefault(_css);
      var _utils = __webpack_require__(1);
      var _logger = __webpack_require__(4);
      var _logger2 = _interopRequireDefault(_logger);
      var _timer = __webpack_require__(5);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        } else {
          return Array.from(arr);
        }
      }

      // limit the number of nodes a user supplied xpath will return so it doesn't hang the browser
      var maximumXPathNodes = 1000;
      var nodejs = typeof global.window === 'undefined';

      // hyphen!
      var nwmatcher = nodejs ? __webpack_require__(34) : undefined;

      /**
       * Work out what index (reversed, to end) for nth-last-of-type
       * @param  {Element} e
       * @return {Integer}
       */
      var lastOfType = function lastOfType(e) {
        var pos = 0;
        for (var child = e.parentNode.lastChild; child; child = child.previousSibling) {
          if (e.nodeType === 3 && child.nodeType === 3 || e.nodeType === 1 && child.localName === e.localName) pos++;
          if (child === e) break;
        }
        return pos;
      };

      /**
       * Compute the full selector for the element
       * @param  {Element} el
       * @return {String}
       */
      function fullSelector(el) {
        if (el.__fullSelector) return el.__fullSelector;
        var names = [];
        while (el && el.parentNode && el.ownerDocument) {
          if (el === el.ownerDocument.documentElement) names.unshift(el.localName);else {
            var c = 1;
            for (var e = el.previousESibling; e; e = e.previousSibling) {
              if (e.localName === el.localName) c++;
            }
            var part = el.nodeType === 3 ? '#text' : el.localName;
            if (part !== 'html' && part !== 'body') part += ':nth-child(' + c + ')';
            names.unshift(part);
          }
          el = el.parentNode;
        }
        var sel = names.join(' > ');
        el.__fullSelector = sel;
        return sel;
      }
      ;

      /**
       * Compute the full xpath for the element (using just positions)
       * @param  {Element} el
       * @return {String}
       */
      function fullXPath(el) {
        var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var textName = forDisplay ? 'io-text' : 'text()';
        if (!forDisplay && useCache && el.__xpath) return el.__xpath;else if (forDisplay && useCache && el.__xpathDisplay) return el.__xpathDisplay;
        var start = el;
        if (el.parentNode && el.parentNode.localName === 'io-text') el = el.parentNode;
        var names = [];
        while (el && el.parentNode && el.ownerDocument) {
          var c = 1;
          for (var e = el.previousSibling; e; e = e.previousSibling) {
            if (e.localName === el.localName) c++;
          }
          var name = el.nodeType === 3 || el.localName === 'io-text' ? textName : el.localName;
          if (name !== 'html' && name !== 'body') name += '[' + c + ']';
          names.unshift(name);
          el = el.parentNode;
        }
        var xp = '/' + names.join('/');
        if (!forDisplay && useCache) start.__xpath = xp;else if (forDisplay && useCache) start.__xpathDisplay = xp;
        return xp;
      }
      ;

      /**
       * This is a workaround for element.classList sometimes
       * returning lower cased element names
       */
      function classList(element) {
        var className = typeof element.className === 'string' ? element.className : element.getAttribute('class');
        if (className) {
          var cl = element.className.trim();
          if (!cl) return [];
          return cl.split(/\s+/g);
        } else {
          return [];
        }
      }
      function shortSelector(element) {
        var document = element.ownerDocument;
        _logger2.default.debug('shortSelector', element);
        var selector = '';
        while (element.parentNode) {
          var sel = element.localName;
          if (element.id) {
            sel += '#' + element.id;
          }
          if (element.classList.length) {
            classList(element).forEach(function (x) {
              return sel += '.' + (0, _css2.default)(x);
            });
          }
          var newSelector = sel + ' ' + selector;
          if (document.querySelectorAll(newSelector).length == 1) {
            return newSelector;
          }
          selector = sel + ':nth-of-type(' + childOfType(element) + ') ' + selector;
          element = element.parentNode;
        }
        throw 'Couldn\'t form selector';
      }

      /**
       * Work out what index for nth-child-of-type
       * @param  {Element} e
       * @return {Integer}
       */
      var childOfType = function childOfType(e) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (useCache && e.__childOfType) return e.__childOfType;
        var pos = 0;
        for (var child = e.parentNode.firstChild; child; child = child.nextSibling) {
          if (e.nodeType === 3 && child.nodeType === 3 || e.nodeType === 1 && child.localName === e.localName) pos++;
          if (child === e) break;
        }
        if (useCache) e.__childOfType = pos;
        return pos;
      };
      function attributes(el) {
        var result = {};
        if (el.attributes) {
          for (var att, i = 0, atts = el.attributes, n = atts.length; i < n; i++) {
            att = atts[i];
            result[att.nodeName] = att.nodeValue;
          }
        }
        return result;
      }
      function getPath(e, forRegion) {
        var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (useCache && e.__path) return e.__path;
        var buffer = [];
        var x = e;
        var covers = true;
        while (x) {
          //allow text nodes to be wrapped in an io-text element
          var name = x.localName ? x.localName === 'io-text' ? '#text' : x.localName : x.nodeName;
          var pathSection = {
            name: name,
            childOfType: childOfType(x, useCache),
            lastOfType: lastOfType(x),
            attributes: attributes(x)
          };

          // Check if there is more than one element with the same ID. If there is, remove id attribute.
          if (pathSection.attributes && pathSection.attributes.id) {
            if (x.ownerDocument && querySelectorAll(x.ownerDocument, '#' + (0, _css2.default)(pathSection.attributes.id)).length > 1) {
              delete pathSection.attributes.id;
            }
          }
          if (x.nodeType === 1) {
            pathSection.classes = classList(x).filter(function (clazz) {
              return !/^_iohighlight-\w+$/.exec(clazz);
            });
          } else {
            pathSection.classes = [];
          }
          if (covers && e !== x) {
            if (e.tagName === 'IMG') {
              covers = false;
            } else {
              // work out if we've got a non-whitespace text node that's a child of this node
              for (var child = x.firstChild; child; child = child.nextSibling) {
                if (child !== e && !(0, _utils.isWhitespace)(child)) {
                  covers = false;
                  break;
                }
              }
            }
          }
          pathSection.covers = covers;
          if (covers) {
            if (forRegion) {
              covers = false;
            }
            // if we step outside of the link, consider it non-covering
            if (x.localName === 'a' && (0, _utils.validHref)(x.getAttribute('href'))) covers = false;
          }
          buffer.push(pathSection);
          if (x.localName && x.localName.toLowerCase() === 'html') break;
          x = x.parentNode;
        }
        if (useCache) e.__path = buffer;
        return buffer;
      }
      ;
      function toMultiCssSelector(paths) {
        var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return paths.map(function (x) {
          return toCssSelector(x, forDisplay);
        }).join(', ');
      }
      function toCssSelector(path) {
        var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var result = function () {
          if (Array.isArray(path[0])) {
            return toMultiCssSelector(path, forDisplay);
          }
          if (path.length == 0) {
            return ':this';
          }
          updatePathFormat(path);
          var temp = [];
          for (var i = 0; i < path.length; i++) {
            var useIdValue = i == path.length - 1;
            var skipIndex = false;
            temp.push(toCssSelectorSection(path[i], skipIndex, useIdValue, forDisplay));
          }
          temp.reverse();
          var result = temp.join(' > ');
          return result;
        }();
        _logger2.default.debug('Created CSS selector', result);
        return result;
      }
      ;
      function querySelectorAll(context, sel) {
        if (sel === ':this') return [context];
        if (!context.__querySelectorAll) context.__querySelectorAll = {};else {
          var cached = context.__querySelectorAll[sel];
          if (cached) {
            return cached;
          }
        }
        try {
          var result = void 0;
          if (nodejs) {
            // on server, use nwmatcher directly

            var document = context.ownerDocument || context;
            if (!document._nwmatcher) {
              document._nwmatcher = nwmatcher({
                document: document
              });
              document._nwmatcher.configure({
                UNIQUE_ID: false
              });
            }

            // caching useful for magic
            result = document._nwmatcher.select(sel, context);
          } else {
            result = Array.from(context.querySelectorAll(sel));
          }
          // useful to cache for magic
          context.__querySelectorAll[sel] = result;
          return result;
        } catch (e) {
          _logger2.default.error('ERROR: Cannot execute selector: ', sel, e.stack);
          return [];
        }
      }
      function querySelector(context, sel) {
        if (sel === ':this') return context;
        if (!context.__querySelector) context.__querySelector = {};else {
          var cached = context.__querySelector[sel];
          if (cached) {
            return cached;
          }
        }
        var result = void 0;
        if (nodejs) {
          // on server, use nwmatcher directly

          var document = context.ownerDocument || context;
          if (!document._nwmatcher) {
            document._nwmatcher = nwmatcher({
              document: document
            });
            document._nwmatcher.configure({
              UNIQUE_ID: false
            });
          }

          // useful to cache for magic
          result = document._nwmatcher.first(sel, context);
        } else {
          result = context.querySelector(sel);
        }
        context.__querySelector[sel] = result;
        return result;
      }
      function getByFullXPath(xpath, document) {
        if (!xpath) throw 'No xpath';

        // there is an edge case where we end up with xpaths like
        // /html/body[1]/form[1]/div[3]/div[4]/div[1]/div[1]/div[1]/div[1]/div[2]/div[1]/*[name()='tp:socialbuttonsandwidgets'][1]/*[name()='tp:socialbuttonsandwidgets'][1]/div[1]/div[1]/div[4]/div[1]/table[1]/tbody[1]/tr[11]/td[3]/a[1]
        // because 'tp:socialbuttonsandwidgets' is not a valid XML element name
        xpath = xpath.replace(/\*\[name\(\)='([^']+)'\]/g, '$1');
        var sections = xpath.split('/');
        var current = document.documentElement;
        for (var i = 2; i < sections.length; i++) {
          var section = sections[i];
          var idx = section.lastIndexOf('[');
          var name = void 0,
            index = void 0;
          if (idx === -1) {
            name = section;
            index = 1;
          } else {
            name = section.substring(0, idx);
            index = parseInt(section.substring(idx + 1, section.length - 1));
          }
          var type = name === 'text()' ? 3 : 1;
          var child = current.firstChild;
          var j = 0;
          while (child) {
            if (type === child.nodeType && (type === 3 || child.localName === name) || type === 3 && child.localName === 'io-text') j++;
            if (index === j) {
              current = child;
              break;
            }
            child = child.nextSibling;
          }
          if (!child) {
            _logger2.default.warn('FAIL getByFullXPath');
            return null;
          }
        }
        return current;
      }
      function compileXPath(document, xpath) {
        try {
          if (!document.__xpathExpressions) document.__xpathExpressions = {};
          var x = document.__xpathExpressions[xpath];
          if (!x) {
            x = document.createExpression(xpath, null);
            document.__xpathExpressions[xpath] = x;
          }
          return x;
        } catch (e) {
          _logger2.default.warn('Invalid xpath: ', xpath);
          return null;
        }
      }
      var enableXPathResultCache = !nodejs;
      function selectByXPath(xpath, context) {
        var forDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var ordered = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (enableXPathResultCache) {
          if (!context.__xpathResults) context.__xpathResults = {};else if (context.__xpathResults[xpath]) return context.__xpathResults[xpath];
        }
        var doc = context.ownerDocument || context;
        try {
          if (forDisplay) {
            xpath = xpath.replace(/text\(\)/g, 'io-text').replace(/@(style|class)/g, '@_$1');
          }
          xpath = xpath.replace('$childOfType', function () {
            return childOfType(context);
          });
          var compiled = compileXPath(doc, xpath);
          if (!compiled) return []; // bad xpath

          var iterator = compiled.evaluate(context, ordered ? 5 : 4, null);
          var result = [];
          var thisNode = iterator.iterateNext();
          var i = 0;
          while (thisNode && (!forDisplay || i < maximumXPathNodes)) {
            i++;
            result.push(thisNode);
            thisNode = iterator.iterateNext();
          }
          if (enableXPathResultCache) {
            context.__xpathResults[xpath] = result;
          }
          _logger2.default.debug('selectByXPath', context.tagName, xpath, result.length);
          return result;
        } catch (e) {
          _logger2.default.error('XPath error', e.stack);
          return [];
        }
      }
      function selectNodes(pathOrPathsOrField, context) {
        var forDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (!pathOrPathsOrField) return [];

        // Field Object with a manual xpath
        if (pathOrPathsOrField.xpath) {
          return selectByXPath(pathOrPathsOrField.xpath, context, forDisplay);
        }

        // is a Field object
        if (pathOrPathsOrField.id) {
          return selectNodes(pathOrPathsOrField.selector, context, forDisplay);
        }
        if (!Array.isArray(pathOrPathsOrField)) {
          throw new Error('Bad type in selectNodes: ', pathOrPathsOrField);
        }
        if (pathOrPathsOrField.length === 0) {
          return [];
        }

        // compact selector
        if (typeof pathOrPathsOrField[0][0] === 'string') {
          return getByCompactSelector(pathOrPathsOrField, context, forDisplay);
        }
        return getBySelector(pathOrPathsOrField, context, forDisplay);
      }
      var toSelector = function toSelector(x) {
        var sel = void 0;
        if (x[1] === null) sel = x[0];else if (x[1] === '*') sel = x[0] + ' > io-text';else sel = x[0] + ' > io-text:nth-of-type(' + x[1] + ')';
        return sel;
      };

      // TODO: this uniques in O(n^2) time, test if faster to sort elements array and then dedupe by removing where n == n-1
      function getByCompactSelector(selectors, context, forDisplay) {
        if (!selectors.length) return [];
        try {
          var notTextPaths = forDisplay ? selectors : selectors.filter(function (x) {
            return x[1] === null;
          });
          var elements = void 0;
          if (notTextPaths.length > 0) {
            if (notTextPaths.length === 1) {
              elements = querySelectorAll(context, toSelector(notTextPaths[0]));
            } else {
              elements = [];
              // more efficient not to run them with commas with nwmatcher
              notTextPaths.forEach(function (x) {
                var _elements;
                (_elements = elements).push.apply(_elements, _toConsumableArray(querySelectorAll(context, toSelector(x))));
              });
            }
            if (notTextPaths.length === selectors.length) {
              return Array.from(new Set(elements));
            }
          } else {
            elements = [];
          }
          var textPaths = selectors.filter(function (x) {
            return x[1] !== null;
          });
          textPaths.forEach(function (textPath) {
            var sel = textPath[0];
            _logger2.default.debug('Running', sel, ' with text=', textPath[0].childOfType);
            (0, _timer.time)(sel);
            var parentElements = querySelectorAll(context, sel);
            var pos = textPath[1];
            (0, _timer.timeEnd)(sel);
            parentElements.forEach(function (parent) {
              // TODO: better 2n+2 style extraction for text nodes?
              if (!pos) {
                elements.push(parent);
                return;
              }
              if (pos === '*') {
                for (var c = parent.firstChild; c; c = c.nextSibling) {
                  if (c.nodeType === 3) {
                    elements.push(c);
                  }
                }
              } else {
                var element = getText(pos, parent);
                if (element) {
                  elements.push(element);
                }
              }
            });
          });
          return Array.from(new Set(elements));
        } catch (e) {
          _logger2.default.error('ERROR: ', selectors, e);
          return [];
        }
      }
      ;
      function updatePathFormat(path) {
        // fix up old path format
        path.forEach(function (section) {
          if (!section.classes) section.classes = [];
          if (section.attributes) return;
          section.attributes = {};
          if (section.id !== undefined) section.attributes.id = section.id;
          if (section.style !== undefined) section.attributes.style = section.style;
          if (section.classAttribute !== undefined) section.attributes.class = section.classAttribute;
          delete section.class;
          delete section.id;
          delete section.style;
        });
      }
      function getBySelector(pathOrPaths, context, forDisplay) {
        var paths = (Array.isArray(pathOrPaths[0]) ? pathOrPaths : [pathOrPaths]).filter(function (x) {
          return x;
        });
        if (!paths.length) return [];
        paths.forEach(updatePathFormat);
        var notTextPaths = forDisplay ? paths : paths.filter(function (x) {
          return x.length === 0 || x[0].name !== '#text';
        });
        var elements = void 0;
        if (notTextPaths.length > 0) {
          var sel = toCssSelector(notTextPaths, forDisplay);
          (0, _timer.time)(sel);
          elements = querySelectorAll(context, sel);
          (0, _timer.timeEnd)(sel);
          if (notTextPaths.length === paths.length) {
            return elements;
          }
        } else {
          elements = [];
        }
        var textPaths = paths.filter(function (x) {
          return x[0].name === '#text';
        });
        textPaths.forEach(function (textPath) {
          var sel = toCssSelector(textPath.slice(1), forDisplay);
          (0, _timer.time)(sel);
          var parentElements = querySelectorAll(context, sel);
          (0, _timer.timeEnd)(sel);
          parentElements.forEach(function (parent) {
            var pos = textPath[0].childOfType;
            // TODO: better 2n+2 style extraction for text nodes?
            if (pos && !Array.isArray(pos)) {
              var element = getText(pos, parent);
              if (element && elements.indexOf(element) < 0) {
                elements.push(element);
              }
            } else {
              // all text nodes
              for (var c = parent.firstChild; c; c = c.nextSibling) {
                if (c.nodeType === 3 && elements.indexOf(c) < 0) {
                  elements.push(c);
                }
              }
            }
          });
        });
        return elements;
      }
      ;

      /**
       * Compact to the short form of a selector (uses CSS selectors)
       */
      function compactSelector(selectorOrSelectors) {
        if (!selectorOrSelectors) return null;

        // normal form is [ sel, textPos ]
        var selectors = (Array.isArray(selectorOrSelectors[0]) ? selectorOrSelectors : [selectorOrSelectors]).filter(function (x) {
          return x;
        });
        if (!selectors.length) return [];
        return selectors.map(function (path) {
          if (path.length === 0) {
            return [':this', null];
          }
          var text = void 0;
          if (path[0].name === '#text') {
            text = path[0];
            path = path.slice(1);
          }
          var sel = toCssSelector(path);
          if (!text) return [sel, null];
          var pos = text.childOfType;
          return [sel, pos && !Array.isArray(pos) ? pos : '*'];
        });
      }

      // TODO: work out if we can make this quicker
      function uniqueNode(path, context) {
        if (path[0].name !== '#text') {
          var _sel = toCssSelector(path);
          var result = querySelectorAll(context, _sel);
          (0, _timer.time)(_sel);
          return result.length === 1;
        }
        var sel = toCssSelector(path.slice(1));
        (0, _timer.time)(sel);
        var parents = querySelectorAll(context, sel);
        var seen = false;
        for (var i = 0; i < parents.length; i++) {
          var parent = parents[i];
          var pos = path[0].childOfType;
          if (pos) {
            var element = getText(pos, parent);
            if (element) {
              if (seen) return false;
              seen = true;
            }
          } else {
            // all text nodes
            for (var c = parent.firstChild; c; c = c.nextSibling) {
              if (c.nodeType === 3) {
                if (seen) return false;
                seen = true;
              }
            }
          }
        }
        return seen;
      }
      ;
      function selectNode(path, context) {
        if (path[0].name !== '#text') {
          var _sel2 = toCssSelector(path);
          (0, _timer.time)(_sel2);
          return querySelector(context, _sel2);
        }
        var sel = toCssSelector(path.slice(1));
        (0, _timer.time)(sel);
        var parent = querySelector(context, sel);
        (0, _timer.timeEnd)(sel);
        var pos = path[0].childOfType;
        if (pos) {
          var element = getText(pos, parent);
          if (element) {
            return element;
          }
        } else {
          // all text nodes
          for (var c = parent.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) {
              return c;
            }
          }
        }
      }
      ;
      var getText = function getText(pos, element) {
        if (!element || !pos) return element;
        var current = 0;
        for (var c = element.firstChild; c; c = c.nextSibling) {
          if (c.nodeType === 3) {
            current++;
            if (current == pos) return c;
          }
        }
        return null;
      };
      var toCssSelectorSection = exports.toCssSelectorSection = function toCssSelectorSection(pathSection, skipIdx, useIdValue, forDisplay) {
        var clazz = forDisplay ? '_class' : 'class';
        var style = forDisplay ? '_style' : 'style';

        // TODO: This could be improved to be not global to the section
        // TODO: Use this in the generation
        var skipNots = !pathSection.explicitNot;
        if (pathSection.name === 'body') {
          return 'body';
        }
        var result = '';

        // it is a good idea to ignore ID values when within multiple records, they tend to change depending on content
        if (hasValue(pathSection.attributes.id)) {
          if (Array.isArray(pathSection.attributes.id)) {
            if (pathSection.attributes.id.findIndex(function (i) {
              return !hasValue(i);
            }) < 0) {
              result += '[id]';
            }
            if (pathSection.attributes.id.findIndex(function (i) {
              return hasValue(i);
            }) < 0) {
              if (!skipNots) result += ':not([id])';
            }
          } else {
            if (useIdValue && pathSection.attributes.id) {
              var escaped = (0, _css2.default)(pathSection.attributes.id);
              result += escaped === pathSection.attributes.id ? '#' + pathSection.attributes.id : '[id="' + escaped + '"]';
            } else {
              result += '[id]';
            }
          }
        } else {
          if (!skipNots) result += ':not([id])';
        }
        if (result[0] === '#') return result;
        result = pathSectionTagName(pathSection, forDisplay) + result;
        if (hasValue(pathSection.attributes.style)) {
          if (Array.isArray(pathSection.attributes.style)) {
            if (pathSection.attributes.style.findIndex(function (i) {
              return !hasValue(i);
            }) < 0) {
              result += '[' + style + ']';
            }
            if (pathSection.attributes.style.findIndex(function (i) {
              return hasValue(i);
            }) < 0) {
              if (!skipNots) result += ':not([' + style + '])';
            }
          } else {
            result += '[' + style + ']';
          }
        } else {
          if (!skipNots) result += ':not([' + style + '])';
        }
        if (pathSection.classes && pathSection.classes.length) {
          pathSection.classes.forEach(function (c) {
            var escaped = (0, _css2.default)(c);
            result += escaped === c ? '.' + c : '[' + clazz + '~="' + escaped + '"]';
          });
        } else {
          if (hasValue(pathSection.attributes.class)) {
            if (Array.isArray(pathSection.attributes.class)) {
              if (pathSection.attributes.class.findIndex(function (i) {
                return i !== '';
              }) < 0) {
                result += '[' + clazz + '=\'\']';
              } else if (pathSection.attributes.class.findIndex(hasValue) < 0) {
                if (!skipNots) result += ':not([' + clazz + '])';
              }
            } else {
              // class with out values
              // TODO: what if it has whitespace?
              result += '[' + clazz + '=\'\']';
            }
          } else {
            if (!skipNots) result += ':not([' + clazz + '])';
          }
        }
        if (pathSection.not) {
          if (pathSection.not.classes) {
            pathSection.not.classes.forEach(function (c) {
              var escaped = (0, _css2.default)(c);
              result += ':not(' + (escaped === c ? '.' + c : '[' + clazz + '~="' + escaped + '"]') + ')';
            });
          }
        }
        ['itemprop', 'itemtype', 'typeof', 'property', 'name', 'type'].forEach(function (attr) {
          var val = pathSection.attributes[attr];
          if (hasValue(val)) {
            if (Array.isArray(val)) {
              if (val.findIndex(function (i) {
                return !hasValue(i);
              }) < 0) {
                result += '[' + attr + ']';
              }
            } else {
              var _escaped = (0, _css2.default)(val);
              result += '[' + attr + '="' + _escaped + '"]';
            }
          }
        });
        return result + indexCondition(pathSection);
      };
      var hasValue = function hasValue(s) {
        return s !== null && s !== undefined;
      };
      var pathSectionTagName = function pathSectionTagName(pathSection, forDisplay) {
        if (!pathSection.name) {
          throw 'No name for element: ' + JSON.stringify(pathSection);
        }
        if (pathSection.name === 'html' || pathSection.name === 'head' || pathSection.name === 'body') {
          return pathSection.name;
        }
        var name = forDisplay && pathSection.name === '#text' ? 'io-text' : pathSection.name;
        return name;
      };
      function indexCondition(pathSection) {
        // should only ever be one of each of these!
        if (pathSection.name === 'html' || pathSection.name === 'head' || pathSection.name === 'body') {
          return '';
        }

        // exact match from start
        if (pathSection.childOfType) {
          if (!Array.isArray(pathSection.childOfType)) {
            return ':nth-of-type(' + pathSection.childOfType + ')';
          }
          if (pathSection.childOfType.length === 1) {
            return ':nth-of-type(' + pathSection.childOfType[0] + ')';
          }
        }

        // exact match from end
        if (pathSection.lastOfType) {
          if (!Array.isArray(pathSection.lastOfType)) {
            return ':nth-last-of-type(' + pathSection.lastOfType + ')';
          }
          if (pathSection.lastOfType.length === 1) {
            return ':nth-last-of-type(' + pathSection.lastOfType[0] + ')';
          }
        }

        // not an exact match
        var result = '';
        if (pathSection.childOfType) {
          pathSection.childOfType.sort(function (a, b) {
            return a - b;
          });
          var diff = pathSection.childOfType.map(function (n, i) {
            return i == 0 ? pathSection.childOfType[1] - n : n - pathSection.childOfType[i - 1];
          });
          if (diff[0] != 1) {
            if (diff.every(function (n) {
              return n === diff[0];
            })) {
              result += ':nth-of-type(' + (diff[0] == 1 ? '' : diff[0]) + 'n+' + pathSection.childOfType[0] + ')';
            }
          } else {
            if (pathSection.childOfType[0] != 1) {
              result += ':nth-of-type(n+' + pathSection.childOfType[0] + ')';
            }
          }
        }

        // if we've already calculated that it's a distance form the front, don't bother for the back
        if (!result && pathSection.lastOfType) {
          pathSection.lastOfType.sort(function (a, b) {
            return a - b;
          });
          var _diff = pathSection.lastOfType.map(function (n, i) {
            return i == 0 ? pathSection.lastOfType[1] - n : n - pathSection.lastOfType[i - 1];
          });
          if (_diff[0] != 1) {
            if (_diff.every(function (n) {
              return n === _diff[0];
            })) {
              result += ':nth-last-of-type(' + (_diff[0] == 1 ? '' : _diff[0]) + 'n+' + pathSection.lastOfType[0] + ')';
            }
          }
        }
        if (pathSection.not && pathSection.not.childOfType) {
          var _childOfType = pathSection.childOfType || pathSection._childOfType;
          if (_childOfType) {
            var max = Math.max.apply(Math, _toConsumableArray(_childOfType));
            var countersAfter = pathSection.not.childOfType.filter(function (x) {
              return x > max;
            });
            if (countersAfter.length) {
              var upper = Math.min.apply(Math, _toConsumableArray(countersAfter));
              result += ':nth-child(-n+' + (upper - 1) + ')';
            }
            pathSection.not.childOfType.filter(function (x) {
              return x <= max;
            }).forEach(function (c) {
              result += ':not(:nth-of-type(' + c + '))';
            });
          } else {
            pathSection.not.childOfType.forEach(function (c) {
              result += ':not(:nth-of-type(' + c + '))';
            });
          }
        }
        return result;
      }
      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(6));

    /***/
  }, /* 1 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.stripSessionIds = stripSessionIds;
    exports.normalizeSpace = normalizeSpace;
    exports.isWhitespace = isWhitespace;
    exports.arraysEqual = arraysEqual;
    exports.validHref = validHref;
    exports.textContent = textContent;
    exports.getElementsByXPath = getElementsByXPath;
    exports.makeUrlAbsolute = makeUrlAbsolute;
    function isWhitespaceChar(ch) {
      return ch === 32 || ch === 9 || ch === 10 || ch === 11 || ch === 160;
    }
    function stripSessionIds(href) {
      href = href.replace(/(?:(\?)|[&;])(_?(l|j|bv_)?(phpsessid|sessionid)=.*?)([?#&;]|$)/i, '$1$5').replace('?&', '?').replace('?#', '#');
      if (href.endsWith('?')) href = href.slice(0, -1);
      return href;
    }
    function normalizeSpace(s) {
      if (!s) {
        return '';
      }
      var start = -1;
      var result = '';
      for (var i = 0; i < s.length; i++) {
        if (isWhitespaceChar(s.charCodeAt(i))) {
          if (start >= 0) {
            if (result) result += ' ';
            result += s.substring(start, i);
          }
          start = -1;
        } else {
          if (start < 0) start = i;
        }
      }
      if (start >= 0) {
        if (result) result += ' ';
        result += s.substring(start);
      }
      return result;
    }
    ;
    function isWhitespace(value) {
      if (value.constructor == String) {
        for (var i = 0; i < value.length; i++) {
          if (!isWhitespaceChar(value.charCodeAt(i))) {
            return false;
          }
        }
        return true;
      }
      // DOM node
      var node = value;
      if (node.nodeType === 2 || node.nodeType === undefined) {
        // Attr
        return isWhitespace(node.value);
      }
      if (node.nodeType == 3) {
        return isWhitespace(node.textContent);
      }
      for (var child = node.firstChild; child; child = child.nextSibling) {
        if (!isWhitespace(child)) {
          return false;
        }
      }
      return true;
    }
    ;

    /**
     * Check if arrays are equal (shallow, ===)
     * @param  {Array} a
     * @param  {Array} b
     * @return {Boolean}
     */
    function arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length != b.length) return false;
      // If you don't care about the order of the elements inside
      // the array, you should sort both arrays here.
      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
    ;
    function validHref(href) {
      return href && !/^\s*javascript\s*:/i.exec(href) && !/^\s*#/i.exec(href);
    }

    /**
     * Return human readable text content from a node.
     * @param  {Node} node
     * @return {String}
     */
    function textContent(node) {
      var b = '';
      if (node.nodeType === 2 || node.nodeType === undefined) {
        // Attr
        b = node.value;
      } else if (node.nodeType == 3) {
        // #text
        b = node.textContent;
      } else {
        var blockRegex = /^(address|blockquote|body|center|dir|div|dl|fieldset|form|h[1-6]|hr|isindex|menu|noframes|noscript|ol|p|pre|table|ul|dd|dt|frameset|li|tbody|td|tfoot|th|thead|tr|html)$/i;
        var content = function content(node) {
          for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
            if (childNode.nodeType == 3) {
              b += childNode.textContent.replace(/\s+/g, ' ');
              continue;
            }
            // some elements are 'whitespace'
            if (childNode.nodeType == 1) {
              switch (childNode.localName) {
                case 'script':
                case 'style':
                  // don't process script or style tags, or superscript
                  continue;
                case 'br':
                case 'hr':
                  // these elements render as whitespace visually
                  b += '\n';
                  break;
                default:
                  var isBlock = blockRegex.exec(childNode.localName);
                  if (isBlock) b += '\n';
                  content(childNode);
                  if (isBlock) b += '\n';
                  break;
              }
            }
          }
        };
        content(node);
      }
      return b.replace(/\n+/g, '\n').replace(/ +/g, ' ').trim();
    }

    /**
     *
     */
    function getElementsByXPath(xpath, context) {
      var results = [];
      var query = context.ownerDocument.evaluate(xpath, context, null, 7 /*XPathResult.ORDERED_NODE_SNAPSHOT_TYPE*/, null);
      for (var i = 0, length = query.snapshotLength; i < length; ++i) {
        results.push(query.snapshotItem(i));
      }
      return results;
    }
    ;
    function makeUrlAbsolute(base, relative) {
      if (/^(\w+:|\/\/)/.exec(relative)) {
        return relative;
      }
      var split = relative.split('?');
      relative = split[0];
      var stack = base.split('/');
      var parts = relative.split('/');
      if (relative[0] === '/') {
        stack = stack.slice(0, 3);
      } else if (stack.length > 3) {
        stack.pop();
      }
      if (!parts[0]) parts.shift();
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === '.') continue;
        if (parts[i] === '..') stack.pop();else stack.push(parts[i]);
      }
      if (stack.length === 3) stack.push('');
      var result = stack.join('/');
      if (split[1]) result += '?' + split[1];
      return result;
    }

    /***/
  }, /* 2 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    exports.makeExample = makeExample;
    exports.makeRegionExample = makeRegionExample;
    var _selector = __webpack_require__(0);
    var _uuid = __webpack_require__(8);
    var _uuid2 = _interopRequireDefault(_uuid);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var Example = function () {
      function Example(_ref) {
        var id = _ref.id,
          path = _ref.path,
          xpath = _ref.xpath,
          counterexample = _ref.counterexample;
        _classCallCheck(this, Example);
        this._id = id || _uuid2.default.v4();
        this._xpath = xpath;
        this._counterexample = counterexample;
        this._path = path;
        (0, _selector.updatePathFormat)(this._path);
      }
      _createClass(Example, [{
        key: 'toJSON',
        value: function toJSON() {
          return {
            id: this._id,
            xpath: this._xpath,
            path: this._path,
            counterexample: this._counterexample
          };
        }
      }, {
        key: 'xpath',
        get: function get() {
          return this._xpath;
        }
      }, {
        key: 'path',
        get: function get() {
          return this._path;
        }
      }, {
        key: 'id',
        get: function get() {
          return this._id;
        },
        set: function set(id) {
          this._id = id;
        }
      }, {
        key: 'counterexample',
        get: function get() {
          return this._counterexample;
        }
      }, {
        key: 'coversIndex',
        get: function get() {
          var idx = this._path.findIndex(function (x) {
            return !x.covers;
          });
          if (idx < 0) {
            return this._path.length;
          }
          return idx - 1;
        }
      }]);
      return Example;
    }();
    exports.default = Example;
    function makeExample(dom, xpath, counterexample) {
      var el = (0, _selector.getByFullXPath)(xpath, dom);
      if (!el) {
        throw 'XPath [' + xpath + '] doesn\'t match any node';
      }
      var path = (0, _selector.getPath)(el);
      return new Example({
        path: path,
        xpath: xpath,
        counterexample: counterexample
      });
    }
    function makeRegionExample(el, counterexample) {
      var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var path = (0, _selector.getPath)(el, true, useCache);
      return new Example({
        path: path,
        xpath: (0, _selector.fullXPath)(el, false, useCache),
        counterexample: counterexample
      });
    }

    /***/
  }, /* 3 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    exports.getFieldElements = getFieldElements;
    exports.extract = extract;
    exports.getRecordElements = getRecordElements;
    exports.getEnclosingLink = getEnclosingLink;
    var _group = __webpack_require__(10);
    var _selector = __webpack_require__(0);
    var _utils = __webpack_require__(1);
    var _timer = __webpack_require__(5);
    var _logger = __webpack_require__(4);
    var _logger2 = _interopRequireDefault(_logger);
    var _lazyimg = __webpack_require__(16);
    var _micro = __webpack_require__(17);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    var emitXPaths = false;
    function getMicroData(url, microPath, document) {
      var data = (0, _micro.getMainItem)(url, document, microPath.type);
      if (data) return data[microPath.id];
    }

    /**
     * Execpting re to be of the form { re, replace }
     */
    function applyRe(re, fieldName, text) {
      var m = text.match(re.re);
      if (m) {
        if (re.replace) {
          // can't find a better way to do this
          m = m.map(function (s) {
            return s.replace(re.re, re.replace);
          });
        }
        return m.map(function (text) {
          var o = {};
          o[fieldName] = text;
          return o;
        });
      }
    }
    function getFieldElements(record, fields) {
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // time('getFieldElements');
      fields.forEach(function (field) {
        var _result$field$name;
        if (!field.selector && !field.xpath) return;
        var nodes = (0, _selector.selectNodes)(field, record);
        if (!nodes || !nodes.length) return;
        if (!result[field.name]) {
          result[field.name] = nodes;
          return;
        }
        (_result$field$name = result[field.name]).push.apply(_result$field$name, _toConsumableArray(nodes));
      });
      // timeEnd('getFieldElements');
      return result;
    }
    function getXPathFieldElements(record, fields) {
      var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      fields.forEach(function (field) {
        // we want the result ordered
        result[field.name] = (0, _selector.selectByXPath)(field.xpath, record, false, true);
      });
      return result;
    }
    function toRecord(url, recordElement, fields, fieldRegexp, fieldElements, useIds) {
      var result = {};
      var added = 0;
      Object.keys(fieldElements).forEach(function (name) {
        if (name[0] === '_') return;
        var field = fields[name];
        var re = fieldRegexp[name];
        var elements = fieldElements[name];
        if (!Array.isArray(elements)) elements = [elements];else {
          elements.sort(function (a, b) {
            a = a.ownerElement || a;
            b = b.ownerElement || b;
            if (a === b || a.equals && a.equals(b)) return 0;
            return a.compareDocumentPosition(b) & 4 ? -1 : 1;
          });
        }
        var value = elements.reduce(function (arr, element) {
          var ret = null;
          if ((field.type === 'IMAGE' || field.type === 'AUTO') && element.tagName === 'IMG') {
            (0, _lazyimg.showLazyImage)(element);
            var src = element.getAttribute('src');
            if (!src) {
              return arr;
            }
            var absoluteSrc = element.src;
            if (!absoluteSrc) absoluteSrc = (0, _utils.makeUrlAbsolute)(url, src);
            var obj = {
              src: absoluteSrc
            };
            ['alt', 'title', 'aria-label'].forEach(function (attr) {
              if (element.hasAttribute(attr)) {
                obj[attr] = element.getAttribute(attr).replace(/\s+/g, ' ').trim();
                if (!obj[attr]) delete obj[attr];
              }
            });

            // sites often just duplicate the alt to other attrs
            ['title', 'aria-label'].forEach(function (attr) {
              if (obj[attr] === obj.alt) delete obj[attr];
            });
            if (!obj.alt && obj.title) obj.alt = obj.title;
            if (!obj.alt && obj['aria-label']) obj.alt = obj['aria-label'];
            ret = [obj];
          } else {
            var fieldName = field.type === 'IMAGE' ? 'alt' : 'text';
            var text = field.html ? element.outerHTML : (0, _utils.textContent)(element);
            if (!text) {
              return arr;
            }
            if (re) {
              // just take the first value
              ret = applyRe(re, fieldName, text);
            } else {
              ret = [{}];
              ret[0][fieldName] = text;
            }
          }
          if (ret) {
            if (emitXPaths) {
              var xpath = (0, _selector.fullXPath)(element);
              ret.forEach(function (o) {
                return o.xpath = xpath;
              });
            }
            if (field.captureLink) {
              var enclosingLink = getEnclosingLink(element, url);
              if (enclosingLink) {
                ret.forEach(function (o) {
                  return o.href = enclosingLink;
                });
              }
            }
          }
          if (ret) {
            arr.push.apply(arr, _toConsumableArray(ret));
          }
          return arr;
        }, []);
        if (value.length) {
          if (useIds) result[field.id] = value;else result[field.name] = value;
          added++;
        }
      });
      if (added > 0) {
        return result;
      }
    }
    function toGroup(url, fieldTypes, fieldRes, records, element, useIds) {
      var group = records.map(function (_ref) {
        var fields = _ref.fields,
          element = _ref.element;
        return toRecord(url, element, fieldTypes, fieldRes, fields, useIds);
      }).filter(function (x) {
        return x;
      });
      var result = {
        group: group
      };
      if (emitXPaths) result.xpath = (0, _selector.fullXPath)(element);
      return result;
    }

    /*
     * Apply filters to rows
     * required flag is deprecated by filters, but applied here for backward compatibility
     */
    function applyRowFilters(key, group, rowFiltersForField, required) {
      // Apply the deprecated required flag
      group = group.filter(function (result) {
        return !required.find(function (field) {
          return result[field[key]] === undefined;
        });
      });

      // Apply the regex filters
      if (rowFiltersForField.size) {
        group = group.filter(function (result) {
          var _loop = function _loop(fieldKey, regExps) {
            _logger2.default.info(rowFiltersForField);
            var data = result[fieldKey];
            if (data) {
              var passedFilter = data.find(function (d) {
                return d.text && !regExps.find(function (re) {
                  return !re.test(d.text);
                });
              });
              if (!passedFilter) {
                _logger2.default.info('Removing result row', result);
                return {
                  v: false
                };
              }
            }
            return {
              v: true
            };
          };
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;
          try {
            for (var _iterator = rowFiltersForField[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref2 = _step.value;
              var _ref3 = _slicedToArray(_ref2, 2);
              var fieldKey = _ref3[0];
              var regExps = _ref3[1];
              var _ret = _loop(fieldKey, regExps);
              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
          ;
        });
      }
      return group;
    }

    /*
     * Apply default values to empty fields.
     */
    function applyDefaultValues(key, group, defaults) {
      group.forEach(function (result) {
        defaults.forEach(function (field) {
          if (result[field[key]] === undefined) result[field[key]] = [{
            text: field.defaultValue
          }];
        });
      });
      return group;
    }

    /*
     * Apply default values to empty fields.
     * This includes values got from the microdata
     */
    function applyMicroDataValues(url, group, document, key, microPaths, fieldRes) {
      group.forEach(function (result) {
        microPaths.forEach(function (field) {
          if (result[field[key]] === undefined) {
            result[field[key]] = getMicroData(url, field.microPath, document);
            var re = fieldRes[field.name];
            if (re) {
              result[field[key]] = result[field[key]].reduce(function (acc, val) {
                var temp = applyRe(re, 'text', val.text);
                if (temp) acc.push.apply(acc, _toConsumableArray(temp));
                return acc;
              }, []);
            }
          }
        });
      });
      return group;
    }

    // useIds is a boolean flag indicating whether to key data by ids (as in chainsaw and
    // lightning moving forward) or names (as in lightning previously)
    function extract(runtimeConfig, document, url, useIds) {
      (0, _timer.time)('extract');
      if (document.head) {
        var base = Array.from(document.head.children).find(function (x) {
          return x.tagName === 'BASE';
        });
        if (base) {
          url = base.getAttribute('href');
        }
      }
      if (!url) url = document.location.href;

      // calculate the field types
      var fieldTypes = {};
      var fieldRes = {};
      runtimeConfig.fields.forEach(function (field) {
        fieldTypes[field.name] = field;
        if (field.regExp) {
          try {
            fieldRes[field.name] = {
              re: new RegExp(field.regExp, 'g'),
              replace: field.regExpReplace
            };
          } catch (e) {
            // bad regex
          }
        }
      });
      var formGroups = function formGroups() {
        var recordElements = getRecordElements(document, runtimeConfig);
        if (recordElements) {
          // we are using manual record selection

          if (!recordElements.length) return [];

          // TODO: we could extend this for other fields, i.e. we could have a boolean
          // that would allow us to remove the "data noise" that happens when you remove this from magic
          var manualXPathFields = runtimeConfig.fields.filter(function (x) {
            return x.xpath;
          });
          var manualXPathFieldElements = null;
          var fields = runtimeConfig.fields.filter(function (x) {
            return !x.microPath;
          });
          if (manualXPathFields.length) {
            // we have at least 1 field with a manual xpath

            // process the absolute xpaths
            var _fieldElements = getXPathFieldElements(document, manualXPathFields.filter(function (x) {
              return x.xpath.trim()[0] === '/';
            }));
            var relativeXPathsFields = manualXPathFields.filter(function (x) {
              return x.xpath.trim()[0] != '/';
            });

            // an array of elements to mix in with the non-manual elements
            manualXPathFieldElements = function () {
              var result = recordElements.map(function () {
                return {};
              });

              // loop over each field and partition the elements
              for (var i = 0; i < manualXPathFields.length; i++) {
                var field = manualXPathFields[i];
                var elements = _fieldElements[field.name];
                if (!elements) continue;
                var elIdx = 0;
                var recordIdx = 0;

                // partition each element - both fields and elements are ordered
                while (elIdx < elements.length && recordIdx < recordElements.length) {
                  var recordElement = recordElements[recordIdx];
                  var el = elements[elIdx];
                  var node = el.ownerElement ? el.ownerElement : el;
                  var comparison = null;
                  if (node === recordElement || (comparison = recordElement.compareDocumentPosition(node)) & 16) {
                    var arr = result[recordIdx][field.name];
                    if (!arr) {
                      arr = [];
                      result[recordIdx][field.name] = arr;
                    }
                    arr.push(el);
                    elIdx++;
                  } else {
                    if (comparison & 2) {
                      // we are binning this, it doesn't fit
                      elIdx++;
                    } else {
                      recordIdx++;
                    }
                  }
                }
              }

              // merge in all the relative xpath elts
              recordElements.forEach(function (recordElt, idx) {
                getXPathFieldElements(recordElt, relativeXPathsFields, result[idx]);
              });
              return result;
            }();
            fields = runtimeConfig.fields.filter(function (x) {
              return !x.xpath && !x.microPath;
            });
          }

          // This presumes that it's a list of siblings
          var recordFields = recordElements.map(function (element, i) {
            // these are the elements for this record
            var fieldElements = getFieldElements(element, fields);

            // mix in the manual xpath elements
            if (manualXPathFieldElements) {
              Object.assign(fieldElements, manualXPathFieldElements[i]);
            }

            // we need to merge out the fields here
            return {
              fields: fieldElements,
              element: element
            };
          });
          return [toGroup(url, fieldTypes, fieldRes, recordFields, document.documentElement, useIds)];
        }

        // no manual row definition
        var fieldElements = getFieldElements(document, runtimeConfig.fields);
        var groups = void 0;
        if (runtimeConfig.regionsSelector) {
          var regions = (0, _selector.selectNodes)(runtimeConfig.regionsSelector, document);
          groups = (0, _group.groupToRecords)(document, fieldElements, regions);
        } else {
          _logger2.default.warn('(deprecation) No predetermined regions, calculating on the fly');
          groups = (0, _group.calculateRegionsAndGroupToRecords)(document, fieldElements);
        }
        return groups.map(function (_ref4) {
          var records = _ref4.records,
            element = _ref4.element;
          return toGroup(url, fieldTypes, fieldRes, records, element, useIds);
        });
      };
      var groups = formGroups().filter(function (g) {
        return g.group.length;
      });

      // required is @deprecated by the rowFilter
      var required = runtimeConfig.fields.filter(function (f) {
        return f.required;
      });
      var defaults = runtimeConfig.fields.filter(function (f) {
        return f.defaultValue;
      });
      var microPaths = runtimeConfig.fields.filter(function (f) {
        return f.microPath;
      });

      // add in default values
      var key = useIds ? 'id' : 'name';
      var rowFiltersForField = new Map();
      runtimeConfig.fields.forEach(function (f) {
        if (f.rowFilters) {
          var rowFilterList = new Array();
          f.rowFilters.forEach(function (rowFilter) {
            try {
              rowFilterList.push(new RegExp(rowFilter.regExp));
            } catch (e) {
              _logger2.default.warn('bad regular expression for filter', e);
            }
            rowFiltersForField.set(f[key], rowFilterList);
          });
        }
      });
      if (microPaths.length) {
        if (groups.length === 0) {
          // we need to inject a bogus group
          groups.push({
            group: [{}]
          });
        }
        groups.forEach(function (g) {
          g.group = applyMicroDataValues(url, g.group, document, key, microPaths, fieldRes);
        });
        if (groups[0].group.length === 0) {
          groups.length = 0;
        }
      }
      groups.forEach(function (g) {
        g.group = applyRowFilters(key, g.group, rowFiltersForField, required);
        g.group = applyDefaultValues(key, g.group, defaults);
        g.group.forEach(function (result) {
          runtimeConfig.fields.forEach(function (field) {
            if (result[field[key]] && field.downloadContent) {
              result[field[key]].forEach(function (o) {
                return o.linkToDownload = o[field.downloadContent];
              });
            }
          });
        });
      });
      (0, _timer.timeEnd)('extract');
      return groups;
    }

    // TODO: move to selector.js
    function getRecordElements(document, runtimeConfig, forDisplay) {
      (0, _timer.time)('getRecordElements');
      try {
        if (runtimeConfig.singleRecord) {
          return [document.documentElement];
        }
        var records = void 0;
        if (runtimeConfig.recordXPath) {
          records = (0, _selector.selectByXPath)(runtimeConfig.recordXPath, document, forDisplay, true);
          if (records.length == 0) {
            _logger2.default.warn('WARNING no records for xpath so returning an empty set ', runtimeConfig.recordXPath);
          }
        }
        if (runtimeConfig.recordSelector) {
          // TODO: forDisplay transform
          records = Array.from(document.querySelectorAll(runtimeConfig.recordSelector));
          if (records.length == 0) {
            _logger2.default.warn('WARNING no records for selector so returning an empty set ', runtimeConfig.recordSelector);
          }
        }
        return records;
      } finally {
        (0, _timer.timeEnd)('getRecordElements');
      }
    }
    function getAnchor(element) {
      do {
        if (element.tagName === 'A') return element;
      } while (element = element.parentNode);
    }
    function getEnclosingLink(element, url) {
      var a = getAnchor(element);
      if (a) {
        var attr = a.getAttribute('href');
        if ((0, _utils.validHref)(attr)) {
          var href = void 0;
          if (!a.href) {
            // not sure why this sometimes happens in the browser
            href = (0, _utils.makeUrlAbsolute)(url, attr);
          } else {
            href = a.href;
          }
          // strip session identifiers
          href = (0, _utils.stripSessionIds)(href);
          return href;
        }
      }
    }

    /***/
  }, /* 4 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (process) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();
      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        } else {
          return Array.from(arr);
        }
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      var levels = exports.levels = ['debug', 'info', 'warn', 'error'];
      var _ref = 'undefined' !== typeof window ? window.env || {} : process.env,
        LOG_LEVEL = _ref.LOG_LEVEL;
      var Logger = function () {
        function Logger() {
          _classCallCheck(this, Logger);
          this.level = LOG_LEVEL ? LOG_LEVEL : 'info';
        }
        _createClass(Logger, [{
          key: 'log',
          value: function log() {
            var level = arguments[0];
            if (level >= this._level) {
              var _console;
              var args = [].concat(Array.prototype.slice.call(arguments)).map(function (x) {
                return typeof x === 'function' ? x() : x;
              });
              args[0] = '[' + levels[level] + ']';
              (_console = console).log.apply(_console, _toConsumableArray(args));
            }
          }
        }, {
          key: 'debug',
          value: function debug(msg) {
            for (var _len = arguments.length, attributes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              attributes[_key - 1] = arguments[_key];
            }
            this.log.apply(this, [0, msg].concat(attributes));
          }
        }, {
          key: 'info',
          value: function info(msg) {
            for (var _len2 = arguments.length, attributes = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              attributes[_key2 - 1] = arguments[_key2];
            }
            this.log.apply(this, [1, msg].concat(attributes));
          }
        }, {
          key: 'warn',
          value: function warn(msg) {
            for (var _len3 = arguments.length, attributes = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              attributes[_key3 - 1] = arguments[_key3];
            }
            this.log.apply(this, [2, msg].concat(attributes));
          }
        }, {
          key: 'error',
          value: function error(msg) {
            for (var _len4 = arguments.length, attributes = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              attributes[_key4 - 1] = arguments[_key4];
            }
            this.log.apply(this, [3, msg].concat(attributes));
          }
        }, {
          key: 'level',
          set: function set(level) {
            this._level = levels.indexOf(level);
          }
        }]);
        return Logger;
      }();
      exports.default = new Logger();
      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(35));

    /***/
  }, /* 5 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.setFilter = setFilter;
    exports.time = time;
    exports.timeEnd = timeEnd;
    var filter = null; // regexp, e.g. /findRegion/;

    function setFilter(val) {
      filter = val;
    }
    function time(msg) {
      if (filter && filter.exec(msg)) {
        console.time(msg);
      }
    }
    function timeEnd(msg) {
      if (filter && filter.exec(msg)) {
        console.timeEnd(msg);
      }
    }

    /***/
  }, /* 6 */
  /***/function (module, exports) {
    var g;

    // This works in non-strict mode
    g = function () {
      return this;
    }();
    try {
      // This works if eval is allowed (see CSP)
      g = g || Function("return this")() || (1, eval)("this");
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  }, /* 7 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _uuid = __webpack_require__(8);
    var _uuid2 = _interopRequireDefault(_uuid);
    var _selector = __webpack_require__(0);
    var _RowFilter = __webpack_require__(23);
    var _RowFilter2 = _interopRequireDefault(_RowFilter);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var Field = function () {
      function Field(_ref) {
        var id = _ref.id,
          name = _ref.name,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 'AUTO' : _ref$type,
          selector = _ref.selector,
          xpath = _ref.xpath,
          defaultValue = _ref.defaultValue,
          regExp = _ref.regExp,
          captureLink = _ref.captureLink,
          html = _ref.html,
          required = _ref.required,
          rowFilters = _ref.rowFilters,
          regExpReplace = _ref.regExpReplace,
          _ref$ranking = _ref.ranking,
          ranking = _ref$ranking === undefined ? 0 : _ref$ranking,
          _ref$downloadContent = _ref.downloadContent,
          downloadContent = _ref$downloadContent === undefined ? null : _ref$downloadContent,
          microPath = _ref.microPath;
        _classCallCheck(this, Field);
        this._id = id || _uuid2.default.v4();
        this.name = name;
        this._type = type;
        this._selector = selector;
        this._manualXPath = xpath;
        this._defaultValue = defaultValue;
        this._regExp = regExp;
        this._captureLink = captureLink;
        this._required = required;
        if (rowFilters) {
          this._rowFilters = rowFilters.map(function (filt) {
            return new _RowFilter2.default(filt);
          });
        }
        this._regExpReplace = regExpReplace;
        this._html = html;
        this._ranking = ranking;
        this._downloadContent = downloadContent;
        this._microPath = microPath;
      }
      _createClass(Field, [{
        key: 'toJSON',
        value: function toJSON() {
          return {
            id: this.id,
            name: this.name,
            type: this.type,
            selector: this.selector,
            xpath: this.xpath,
            defaultValue: this.defaultValue,
            regExp: this.regExp,
            regExpReplace: this.regExpReplace,
            captureLink: this.captureLink,
            html: this.html,
            required: this.required,
            ranking: this.ranking,
            downloadContent: this.downloadContent,
            microPath: this.microPath
          };
        }
      }, {
        key: 'cloneWithCompactSelector',
        value: function cloneWithCompactSelector() {
          var f = new Field(JSON.parse(JSON.stringify(this)));
          f.selector = (0, _selector.compactSelector)(this.selector);
          return f;
        }
      }, {
        key: 'xpath',
        get: function get() {
          return this._manualXPath;
        },
        set: function set(xpath) {
          this._manualXPath = xpath;
        }

        /*
         * @deprecated, use rowFilters instead
         */
      }, {
        key: 'required',
        get: function get() {
          return this._required;
        }

        /*
         * @deprecated, use rowFilters instead
         */,

        set: function set(required) {
          this._required = required;
        }
      }, {
        key: 'rowFilters',
        get: function get() {
          return this._rowFilters;
        },
        set: function set(rowFilters) {
          this._rowFilters = rowFilters;
        }
      }, {
        key: 'html',
        get: function get() {
          return this._html;
        },
        set: function set(html) {
          this._html = html;
        }
      }, {
        key: 'captureLink',
        get: function get() {
          return this._captureLink;
        },
        set: function set(captureLink) {
          this._captureLink = captureLink;
        }
      }, {
        key: 'id',
        get: function get() {
          return this._id;
        },
        set: function set(id) {
          this._id = id;
        }
      }, {
        key: 'type',
        get: function get() {
          return this.xpath ? 'AUTO' : this._type;
        },
        set: function set(type) {
          this._type = type;
        }
      }, {
        key: 'defaultValue',
        get: function get() {
          return this._defaultValue;
        },
        set: function set(defaultValue) {
          this._defaultValue = defaultValue;
        }
      }, {
        key: 'regExp',
        get: function get() {
          return this._regExp;
        },
        set: function set(regExp) {
          this._regExp = regExp;
        }
      }, {
        key: 'regExpReplace',
        get: function get() {
          return this._regExpReplace;
        },
        set: function set(regExpReplace) {
          this._regExpReplace = regExpReplace;
        }
      }, {
        key: 'name',
        get: function get() {
          return this._name;
        },
        set: function set(name) {
          this._name = name ? name.trim() : name;
        }
      }, {
        key: 'selector',
        set: function set(selector) {
          this._selector = selector;
        },
        get: function get() {
          return this._selector;
        }
      }, {
        key: 'ranking',
        set: function set(ranking) {
          this._ranking = ranking;
        },
        get: function get() {
          return this._ranking;
        }
      }, {
        key: 'downloadContent',
        set: function set(downloadContent) {
          this._downloadContent = downloadContent;
        },
        get: function get() {
          return this._downloadContent;
        }

        /**
          * Of the form {type, id}
          */
      }, {
        key: 'microPath',
        set: function set(microPath) {
          this._microPath = microPath;
        },
        get: function get() {
          return this._microPath;
        }
      }]);
      return Field;
    }();
    exports.default = Field;

    /***/
  }, /* 8 */
  /***/function (module, exports, __webpack_require__) {
    //     uuid.js
    //
    //     Copyright (c) 2010-2012 Robert Kieffer
    //     MIT License - http://opensource.org/licenses/mit-license.php

    // Unique ID creation requires a high quality random # generator.  We feature
    // detect to determine the best RNG source, normalizing to a function that
    // returns 128-bits of randomness, since that's what's usually required
    var _rng = __webpack_require__(36);

    // Maps for number <-> hex string conversion
    var _byteToHex = [];
    var _hexToByte = {};
    for (var i = 0; i < 256; i++) {
      _byteToHex[i] = (i + 0x100).toString(16).substr(1);
      _hexToByte[_byteToHex[i]] = i;
    }

    // **`parse()` - Parse a UUID into it's component bytes**
    function parse(s, buf, offset) {
      var i = buf && offset || 0,
        ii = 0;
      buf = buf || [];
      s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
        if (ii < 16) {
          // Don't overflow!
          buf[i + ii++] = _hexToByte[oct];
        }
      });

      // Zero out remaining bytes if string was short
      while (ii < 16) {
        buf[i + ii++] = 0;
      }
      return buf;
    }

    // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
    function unparse(buf, offset) {
      var i = offset || 0,
        bth = _byteToHex;
      return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
    }

    // **`v1()` - Generate time-based UUID**
    //
    // Inspired by https://github.com/LiosK/UUID.js
    // and http://docs.python.org/library/uuid.html

    // random #'s we need to init node and clockseq
    var _seedBytes = _rng();

    // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
    var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

    // Per 4.2.2, randomize (14 bit) clockseq
    var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

    // Previous uuid creation time
    var _lastMSecs = 0,
      _lastNSecs = 0;

    // See https://github.com/broofa/node-uuid for API details
    function v1(options, buf, offset) {
      var i = buf && offset || 0;
      var b = buf || [];
      options = options || {};
      var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

      // UUID timestamps are 100 nano-second units since the Gregorian epoch,
      // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
      // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
      // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
      var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

      // Per 4.2.1.2, use count of uuid's generated during the current clock
      // cycle to simulate higher resolution clock
      var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

      // Time since last uuid creation (in msecs)
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

      // Per 4.2.1.2, Bump clockseq on clock regression
      if (dt < 0 && options.clockseq === undefined) {
        clockseq = clockseq + 1 & 0x3fff;
      }

      // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
      // time interval
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
        nsecs = 0;
      }

      // Per 4.2.1.2 Throw error if too many uuids are requested
      if (nsecs >= 10000) {
        throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;

      // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
      msecs += 12219292800000;

      // `time_low`
      var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
      b[i++] = tl >>> 24 & 0xff;
      b[i++] = tl >>> 16 & 0xff;
      b[i++] = tl >>> 8 & 0xff;
      b[i++] = tl & 0xff;

      // `time_mid`
      var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
      b[i++] = tmh >>> 8 & 0xff;
      b[i++] = tmh & 0xff;

      // `time_high_and_version`
      b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
      b[i++] = tmh >>> 16 & 0xff;

      // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
      b[i++] = clockseq >>> 8 | 0x80;

      // `clock_seq_low`
      b[i++] = clockseq & 0xff;

      // `node`
      var node = options.node || _nodeId;
      for (var n = 0; n < 6; n++) {
        b[i + n] = node[n];
      }
      return buf ? buf : unparse(b);
    }

    // **`v4()` - Generate random UUID**

    // See https://github.com/broofa/node-uuid for API details
    function v4(options, buf, offset) {
      // Deprecated - 'format' argument, as supported in v1.2
      var i = buf && offset || 0;
      if (typeof options == 'string') {
        buf = options == 'binary' ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || _rng)();

      // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
      rnds[6] = rnds[6] & 0x0f | 0x40;
      rnds[8] = rnds[8] & 0x3f | 0x80;

      // Copy bytes to buffer, if provided
      if (buf) {
        for (var ii = 0; ii < 16; ii++) {
          buf[i + ii] = rnds[ii];
        }
      }
      return buf || unparse(rnds);
    }

    // Export public API
    var uuid = v4;
    uuid.v1 = v1;
    uuid.v4 = v4;
    uuid.parse = parse;
    uuid.unparse = unparse;
    module.exports = uuid;

    /***/
  }, /* 9 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _uuid = __webpack_require__(8);
    var _uuid2 = _interopRequireDefault(_uuid);
    var _Example = __webpack_require__(2);
    var _Example2 = _interopRequireDefault(_Example);
    var _htmlparser = __webpack_require__(15);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var nbspRe = new RegExp(String.fromCharCode(160) + '|&nbsp;', 'g');

    /**
     * Parses an HTML string into an HTMLDocument.
     * @param {string} HTML markup
     * @returns {HTMLDocument} Document object
     */
    function parseHTML(html) {
      var doc = document.implementation.createHTMLDocument('New Document Title');
      (0, _htmlparser.importIntoDocument)(html.replace(nbspRe, ' '), doc);
      return doc;
    }

    /**
     * Returns a sanitised DOM tree for a given page.
     * @param {Page} page Page.
     */
    function generateDOM(page, noscript) {
      var dom = parseHTML(noscript ? page.noscriptHtml : page.html);
      return dom;
    }

    /**
    * WebPage class.
    *
    * Represents a web page.
    *
    * @class Page
     */

    var Page = function () {
      /**
       * Creates a Page.
       * @param {Object} input the initial values for the page
       */
      function Page(input) {
        var _this = this;
        _classCallCheck(this, Page);
        this._id = _uuid2.default.v4();
        this._fieldExamples = {};
        if (input) {
          Object.assign(this, input);
          Object.keys(this._fieldExamples).forEach(function (k) {
            return _this._fieldExamples[k] = _this._fieldExamples[k].map(function (e) {
              return new _Example2.default(e);
            });
          });
          // These are cleared by setting the HTML properties
          this._noscriptDom = input._noscriptDom;
          this._scriptDom = input._scriptDom;
        }
        delete this._pageSet;
      }
      _createClass(Page, [{
        key: 'dom',
        /**
         * The document object that represents a sanitised version of the markup.
         * @type {HTMLDocument}
         * @readonly
         */
        value: function dom() {
          var noscript = this.pageSet && this.pageSet.noscriptAvailable && this.pageSet.noscript;
          return noscript ? this.noscriptDom() : this.scriptDom();
        }
      }, {
        key: 'scriptDom',
        value: function scriptDom() {
          return this._scriptDom || (this._scriptDom = generateDOM(this, false));
        }
      }, {
        key: 'noscriptDom',
        value: function noscriptDom() {
          return this._noscriptDom || (this._noscriptDom = generateDOM(this, true));
        }

        /**
         * Override the scripted dom
         * @type {HTMLDocument}
         */
      }, {
        key: 'overrideDom',
        value: function overrideDom(dom) {
          this._scriptDom = dom;
        }

        /**
         * Adds a known-good example of a field element.
         * @param {Field} name
         * @param {Example} fieldExample
         */
      }, {
        key: 'addFieldExample',
        value: function addFieldExample(field, fieldExample) {
          if (!this._fieldExamples[field.id]) {
            this._fieldExamples[field.id] = [];
          }
          this._fieldExamples[field.id].push(fieldExample);
        }

        /**
         * Returns all the known-good field examples for a given name.
         * @param {Field} field
         * @returns {Example[]}
         */
      }, {
        key: 'fieldExamplesFor',
        value: function fieldExamplesFor(field) {
          return this._fieldExamples[field.id] || [];
        }
      }, {
        key: 'toJSON',
        value: function toJSON() {
          return {
            id: this._id,
            url: this._url,
            resourceId: this._resourceId,
            html: this._html,
            noscriptHtml: this._noscriptHtml,
            fieldExamples: this._fieldExamples
          };
        }
      }, {
        key: 'pageSet',
        set: function set(pageSet) {
          this._pageSet = pageSet;
        },
        get: function get() {
          return this._pageSet;
        }

        /**
         * URL of the page.
         * @type {string}
         */
      }, {
        key: 'url',
        set: function set(url) {
          if (typeof url !== 'string') {
            throw TypeError('url must be a string');
          }
          this._url = url;
        },
        get: function get() {
          return this._url;
        }
      }, {
        key: 'id',
        get: function get() {
          return this._id;
        },
        set: function set(id) {
          this._id = id;
        }
      }, {
        key: 'resourceId',
        get: function get() {
          return this._resourceId;
        },
        set: function set(id) {
          this._resourceId = id;
        }
      }, {
        key: 'fieldExamples',
        set: function set(examples) {
          this._fieldExamples = examples;
        }

        /**
         * Document markup of the page.
         * @type {string}
         */
      }, {
        key: 'html',
        set: function set(html) {
          if (typeof html !== 'string') {
            throw TypeError('html must be a string');
          }
          this._scriptDom = undefined;
          this._html = html;
        },
        get: function get() {
          return this._html;
        }

        /**
         * Document markup of the page.
         * @type {string}
         */
      }, {
        key: 'noscriptHtml',
        set: function set(html) {
          if (typeof html !== 'string') {
            throw TypeError('html must be a string');
          }
          this._noscriptDom = undefined;
          this._noscriptHtml = html;
        },
        get: function get() {
          return this._noscriptHtml;
        }
      }]);
      return Page;
    }();
    exports.default = Page;

    /***/
  }, /* 10 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.enablePageCache = enablePageCache;
    exports.disablePageCache = disablePageCache;
    exports.getRegions = getRegions;
    exports.calculateRegionsAndGroupToRecords = calculateRegionsAndGroupToRecords;
    exports.groupToRecords = groupToRecords;
    var _utils = __webpack_require__(1);
    var _selector = __webpack_require__(0);
    var _timer = __webpack_require__(5);
    var _regiondetect = __webpack_require__(18);
    var _selectorcalculator = __webpack_require__(11);
    var _Example = __webpack_require__(2);
    var _logger = __webpack_require__(4);
    var _logger2 = _interopRequireDefault(_logger);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    var _cacheRegions = false;

    /**
     * Enable the caching of information for a dom,
     * possibly at a higher startup cost
     */
    function enablePageCache(dom) {
      _cacheRegions = true;
      findRegions(dom);
    }
    function disablePageCache() {
      _cacheRegions = false;
    }
    var childNode = function childNode(e) {
      var pos = 0;
      var children = e.parentNode.childNodes;
      for (var i = 0, j = children.length; i < j; i++) {
        var child = children[i];
        pos++;
        if (child === e) break;
      }
      return pos;
    };
    var getKey = function getKey(element) {
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!element.parentNode) return acc;
      var name = element.nodeType === 3 ? '#text' : element.localName;
      if (!acc) acc = name;else acc = name + ' ' + acc;
      return getKey(element.parentNode, acc);
    };
    var nodeDepth = function nodeDepth(el) {
      var depth = -1;
      do {
        depth++;
      } while (el = el.parentNode);
      return depth;
    };
    function partition(siblings) {
      var partitions = [];

      // work out sets of fields that each belong to
      siblings.forEach(function (record) {
        if (!record) {
          return;
        }
        var intersectionIndexes = partitions.map(function (partition, idx) {
          if (partition.find(function (field) {
            return record.__fields.indexOf(field) >= 0;
          })) {
            return idx;
          }
          return -1;
        }).filter(function (idx) {
          return idx >= 0;
        });
        if (intersectionIndexes.length == 0) {
          // no intersection with any partition
          var fields = record.__fields.slice();
          fields.__indexes = [record.__position];
          partitions.push(fields);
        } else {
          if (intersectionIndexes.length == 1 && (0, _utils.arraysEqual)(partitions[intersectionIndexes[0]], record.__fields)) {
            // do nothing, same partition
            partitions[intersectionIndexes[0]].__indexes.push(record.__position);
          } else {
            // swap the order around to remove them with same indexes
            intersectionIndexes.reverse();
            var _partition = [];
            _partition.__indexes = [];
            var addFields = function addFields(fields) {
              fields.forEach(function (field) {
                if (_partition.indexOf(field) < 0) {
                  _partition.push(field);
                }
              });
            };
            intersectionIndexes.forEach(function (idx) {
              var fields = partitions.splice(idx, 1)[0];
              _partition.__indexes = _partition.__indexes.concat(fields.__indexes);
              addFields(fields);
            });
            _partition.__indexes.push(record.__position);
            addFields(record.__fields);
            _partition.__indexes.sort(function (a, b) {
              return a - b;
            });
            _partition.sort();
            partitions.splice(intersectionIndexes[0], 0, _partition);
          }
        }
      });
      return partitions;
    }
    function findRegions(node) {
      (0, _timer.time)('findRegions');
      try {
        if (!_cacheRegions) {
          return (0, _regiondetect.findRegions)(node);
        }
        var document = node.ownerDocument ? node.ownerDocument : node;
        if (!document._regions) {
          document._regions = (0, _regiondetect.findRegions)(document);
        }
        if (node.tagName !== 'HTML') {
          var map = new Map();
          document._regions.forEach(function (v, k) {
            if (node === k || node.contains(k)) {
              map.set(k, v);
            }
          });
          return map;
        }
        return new Map(document._regions.entries());
      } finally {
        (0, _timer.timeEnd)('findRegions');
      }
    }
    ;
    var sum = function sum(arr) {
      return arr.reduce(function (p, c) {
        return p + c;
      }, 0);
    };

    /**
     * Group a set of records into areas on the page, and records.
     * @param  {Object} elementMap A map of name => element for fields
     * @return {Array<Array<Element>>}
     */
    // TODO: this needs refactoring, it's bcome messy
    function getRegions(document, elementMap) {
      (0, _timer.time)('getRegions');
      try {
        // group into siblings
        var ancestors = new Map();
        var ungroupedElements = new Set();
        var fieldNames = Object.keys(elementMap);

        // initially create a datastructure of the ancestors of the elements we have
        fieldNames.forEach(function (name) {
          var arr = elementMap[name];
          if (!Array.isArray(arr)) arr = Array.prototype.slice.apply(arr);
          arr.forEach(function (element) {
            ungroupedElements.add(element);
            if (!element.__fields) {
              element.__fields = [];
            }
            element.__fields.push(name);
            var initial = element;
            var el = element.ownerElement || element;
            var depth = nodeDepth(el);
            do {
              var a = ancestors.get(el);
              if (!a) {
                a = {
                  key: getKey(el),
                  element: el,
                  depth: depth,
                  elements: new Set()
                };
                ancestors.set(el, a);
              }
              a.elements.add(initial);
              depth--;
            } while (el = el.parentNode);
          });
        }); // end initializing data structure

        var allElements = new Set(ungroupedElements);
        var ancestorsArray = Array.from(ancestors.values());
        if (ancestorsArray.length === 0) return [document.documentElement];

        // sort the array such that the most elements underneath first
        ancestorsArray.sort(function (a, b) {
          var x = b.elements.size - a.elements.size;
          if (x != 0) return x;
          return b.depth - a.depth;
        });

        // the common ancestor must be first
        var commonAncestor = ancestorsArray[0].element;

        // only 1 element
        if (ancestorsArray[0].elements.size <= 1) {
          _logger2.default.info('Single element, setting region as its parent');
          return [commonAncestor.parentNode];
        }

        // look underneath this for lists regions using the "magic" style heuristics
        var listRegions = findRegions(commonAncestor);
        var uniqueFieldsForAncestor = function uniqueFieldsForAncestor(a) {
          var fields = new Set();
          a.elements.forEach(function (el) {
            el.__fields.forEach(function (name) {
              fields.add(name);
            });
          });
          return fields;
        };
        ancestors.forEach(function (a) {
          return a.fields = uniqueFieldsForAncestor(a);
        });

        // this will ensure that we pick up everything as a "catch all"
        if (!listRegions.has(commonAncestor)) {
          listRegions.set(commonAncestor, {
            node: commonAncestor,
            score: 0,
            linkedRegions: []
          });
        }

        // pick the "best" list regions until we fallback to grouping everything else in a single rows
        listRegions.forEach(function (region) {
          region.rows = Array.from(region.node.children).map(function (node) {
            return ancestors.get(node);
          }).filter(function (x) {
            return x;
          });
        });
        var rescore = function rescore() {
          listRegions.forEach(function (region) {
            // give each child a score
            region.partitions = partition(region.rows.map(function (c) {
              return {
                __position: childNode(c.element) - 1,
                __fields: Array.from(c.fields)
              };
            }));
            var scores = region.rows.map(function (a) {
              // how many ungrouped elements are beneath this ancestor
              var elementsBeneath = Math.max(1, a.elements.size);

              // how many unique fields are beneath this ancestor attached to ungrouped elements
              var uniqueFields = Math.max(1, a.fields.size);

              // how many elements on average per field are underneath this
              // a higher value of this should imply that we have multiple rows
              // underneath this point
              var elementsPerField = elementsBeneath / uniqueFields;

              // the higher this is the more chance it's a record
              // we don't want to match single fields
              var f = a.fields.values().next().value;
              var fieldNameRatio = uniqueFields / region.partitions.find(function (x) {
                return x.indexOf(f) >= 0;
              }).length;
              return fieldNameRatio / elementsPerField;
            });
            // this is a "quality" score for the list region
            region.rowQuality = sum(scores);

            // this scoring is a heuristic and probably needs tuning to get right
            region.quality = region.rows.length * region.score * region.rowQuality;
            region._originalQuality = region.quality;
          });

          // link the grid region quality
          (function () {
            var processed = new Set();
            listRegions.forEach(function (region) {
              if (processed.has(region)) return;
              var sum = 0;
              region.linkedRegions.forEach(function (region) {
                if (!region._originalQuality) return; // this region didn't actually make the cut of regions
                processed.add(region);
                if (region.rows.length > 1) {
                  // discount single rows so we don't grid a load of siblings
                  sum += region._originalQuality;
                }
              });
              region.linkedRegions.forEach(function (region) {
                if (!region._originalQuality) return; // this region didn't actually make the cut of regions
                region.quality = sum;
              });
            });
          })();
        };
        rescore();
        var regionsArray = Array.from(listRegions.values()).filter(function (x) {
          return x.rows.length > 1;
        }).sort(function (a, b) {
          return b.quality - a.quality;
        });
        if (regionsArray.length === 0) {
          return [commonAncestor];
        }
        var result = [];

        // TODO: use this to optimize rescoring
        var newlyGroupElements = [];
        var process = function process(region) {
          var ret = false;
          for (var i = 0; i < region.rows.length && ungroupedElements.size; i++) {
            var ungroupedElementsBefore = ungroupedElements.size;
            region.rows[i].elements.forEach(function (el) {
              if (!ungroupedElements.has(el)) {
                return;
              }
              ungroupedElements.delete(el);
              newlyGroupElements.push(el);
            });
            if (ungroupedElementsBefore === ungroupedElements.size) {
              continue;
            }
            ret = true;
          }
          if (!ret) return false;

          // TODO: this is currently unused because I can't work out how to use this information at runtime
          // perhaps it needs to be linked to the full xpath of the region?
          // region.siblingSpan = ( () => {
          //   const siblingPartition = [];
          //   region.partitions.forEach( (partition,partitionIndex) => partition.__indexes.forEach( siblingIndex => siblingPartition[siblingIndex] = partitionIndex) );
          //
          //
          //   const seen = new Set();
          //   const gaps = [];
          //   let start = 0;
          //   let i=0;
          //   for ( ; i<siblingPartition.length; i++ ) {
          //     const p = siblingPartition[i];
          //     if ( p === undefined ) continue;
          //     if ( seen.has(p) ) {
          //       // we are into a different row
          //       if ( seen.size == region.partitions.length ) {
          //         gaps.push(i-start);
          //       }
          //       seen.clear();
          //       start = i;
          //     }
          //     seen.add(p);
          //   }
          //
          //   if ( seen.size == region.partitions.length ) {
          //     // we can't bank on this because there may be nodes in between "rows" apart from at the end
          //     gaps.push( region.children.length - start );
          //   }
          //
          //   gaps.sort();
          //   // if there is one which is < 2*min take that as the effective maximum number of siblings for a result because there may be optional nodes
          //   for ( i=0; i < gaps.length && gaps[i+1] < 2*gaps[0]; i++ ) {
          //   }
          //   return gaps[i];
          // } ) ();

          return ret;
        };
        while (ancestors.size && regionsArray.length) {
          var region = regionsArray.shift();
          var regions = region.linkedRegions.length ? region.linkedRegions : [region];
          for (var i = 0; i < regions.length && ungroupedElements.size; i++) {
            var r = regions[i];
            if (process(r)) {
              result.push(r.node);
            }
          }

          // recalculate the scores
          rescore();
        }

        // reset the __fields for all the elements
        allElements.forEach(function (el) {
          return delete el.__fields;
        });
        return result;
      } catch (e) {
        _logger2.default.error(e.stack);
        throw e;
      } finally {
        (0, _timer.timeEnd)('getRegions');
      }
    }
    function calculateRegionsAndGroupToRecords(document, elementMap) {
      var regions = getRegions(document, elementMap);
      var regionSelector = (0, _selector.compactSelector)((0, _selectorcalculator.getRegionSelector)([new _selectorcalculator.DocumentExamples(document, regions.map(function (x) {
        return (0, _Example.makeRegionExample)(x);
      }))]));
      _logger2.default.debug('regionSelector', regionSelector);
      // re-select with the generated selectors
      regions = (0, _selector.selectNodes)(regionSelector, document);
      _logger2.default.debug('selected region nodes', regions);
      var g = groupToRecords(document, elementMap, regions);
      _logger2.default.debug('grouped', g);
      return g;
    }
    function groupToRecords(document, elementMap, regions) {
      (0, _timer.time)('groupToRecords');
      try {
        regions = Array.from(regions);

        // group into siblings
        var groups = [];
        var fieldNames = Object.keys(elementMap);
        var map = new Map();
        regions.forEach(function (region) {
          return map.set(region, new Map());
        });

        // initially create a datastructure of the ancestors of the elements we have
        fieldNames.forEach(function (name) {
          var arr = elementMap[name];
          if (!Array.isArray(arr)) arr = Array.prototype.slice.apply(arr);
          arr.forEach(function (element) {
            var e = element.ownerElement || element;
            do {
              // is the parent of this a region, i.e. is it a row?
              var i = regions.indexOf(e.parentNode);
              if (i >= 0) {
                // put it in a row
                var regionRecords = map.get(regions[i]);
                var record = regionRecords.get(e);
                if (!record) {
                  record = {};
                  record.__recordElement = e;
                  record.__position = childNode(e) - 1;
                  record.__fields = [];
                  regionRecords.set(e, record);
                }
                if (record[name]) {
                  if (!Array.isArray(record[name])) record[name] = [record[name]];
                  record[name].push(element);
                } else {
                  record[name] = element;
                  record.__fields.push(name);
                }
                return;
              }
            } while (e = e.parentNode);
            _logger2.default.warn('Cannot find a region for element');
          });
        }); // end initializing data structure

        var process = function process(region) {
          try {
            var records = [];
            var siblingMap = {};
            var siblingsArray = [];
            var regionRecords = map.get(region);
            var children = region.childNodes;
            for (var i = 0; i < children.length; i++) {
              var recordElement = children[i];
              var record = regionRecords.get(recordElement);
              if (!record) continue;

              // TODO: efore regions could have different records (grids) - still the case?
              var parentPath = (0, _selector.fullXPath)(record.__recordElement.parentNode);
              if (!siblingMap[parentPath]) {
                var newGroup = [];
                siblingMap[parentPath] = newGroup;
                newGroup.groupPath = parentPath;
                siblingsArray.push(newGroup);
              }
              siblingMap[parentPath][record.__position] = record;
            }
            siblingsArray.forEach(function (siblings) {
              var partitions = partition(siblings);
              var tryPartition = function tryPartition() {
                // this is the maximum number of siblings to consider grouping together
                // if we have:
                // 1 => a
                // 2 => [none]
                // 3 => [none]
                // 4 => b
                // 5 => a
                // 6 => b
                // The sibling span would be 2 because this is the maximum number of siblings to group together
                //
                // If we have:
                // 1 => a
                // 2 => a
                // 3 => a
                // 4 => b
                // 5 => a
                // 6 => a
                // 7 => b
                // The sibling span would also be 2
                //
                // We should consider the minimum distance it takes to do a cycle with all partitions

                var siblingSpan = function () {
                  var siblingPartition = [];
                  partitions.forEach(function (partition, partitionIndex) {
                    return partition.__indexes.forEach(function (siblingIndex) {
                      return siblingPartition[siblingIndex] = partitionIndex;
                    });
                  });
                  var seen = new Set();
                  var gaps = [];
                  var start = 0;
                  var i = 0;
                  for (; i < siblingPartition.length; i++) {
                    var p = siblingPartition[i];
                    if (p === undefined) continue;
                    if (seen.has(p)) {
                      // we are into a different row
                      if (seen.size == partitions.length) {
                        gaps.push(i - start);
                      }
                      seen.clear();
                      start = i;
                    }
                    seen.add(p);
                  }
                  if (seen.size == partitions.length) {
                    // we can't bank on this because there may be nodes in between "rows" apart from at the end
                    gaps.push(region.childNodes.length - start);
                  }
                  gaps.sort();
                  // if there is one which is < 2*min take that as the effective maximum number of siblings for a result because there may be optional nodes
                  for (i = 0; i < gaps.length && gaps[i + 1] < 2 * gaps[0]; i++) {}
                  return gaps[i];
                }();

                // if we cannot work out how many siblings constitutes a "row" don't group them
                if (siblingSpan === null) {
                  return false;
                }

                // bundle them together
                var partitionIdx = 0;
                var newRecord = null;
                var start = null;
                for (var _i = 0; _i < siblings.length;) {
                  var _record = siblings[_i];

                  // there is no next partition, save the record
                  if (start !== null && _i - start == siblingSpan || partitionIdx == partitions.length) {
                    partitionIdx = 0;
                    if (newRecord) {
                      records.push(newRecord);
                    }
                    newRecord = null;
                    start = _i;
                  }

                  // we are missing this sibling
                  // TODO: what to do?
                  if (!_record) {
                    _i++;
                    continue;
                  }

                  // is it the suspected partition number?
                  if (_record.__fields.every(function (field) {
                    return partitions[partitionIdx].indexOf(field) >= 0;
                  })) {
                    if (start === null) start = _i;

                    // copy values
                    if (!newRecord) {
                      newRecord = {};
                    }
                    Object.assign(newRecord, _record);
                    delete newRecord.__fields;
                    delete newRecord.__position;
                    partitionIdx++;
                    _i++;
                  } else {
                    // look at next partititon
                    partitionIdx++;
                  }
                }
                if (newRecord) {
                  records.push(newRecord);
                }
                return true;
              };
              if (partitions.length > 1 && tryPartition()) {
                // we've added successfully
              } else {
                siblings.forEach(function (s) {
                  return records.push(s);
                });
              }
            });
            if (records.length) {
              records = records.map(function (r) {
                // TODO: we could use objects elsewhere and make this unneccessary, it's a bit messy
                var res = {
                  fields: r,
                  element: r.__recordElement
                };
                delete r.__fields;
                delete r.__position;
                delete r.__recordElement;
                return res;
              });
              groups.push({
                records: records,
                element: region
              });
            }
          } catch (e) {
            _logger2.default.error(e.stack);
          }
        };
        regions.forEach(process);
        groups.sort(function (a, b) {
          a = a.records[0].element;
          b = b.records[0].element;
          if (a === b) return 0;
          return a.compareDocumentPosition(b) & 4 ? -1 : 1;
        });

        // ok so now we need to collapse any regions with only one field,
        // or with multiple fields with only one value together

        var collapseGroups = function collapseGroups() {
          groups.forEach(function (group) {
            if (group.records.length <= 1) return;

            // if the group is partitioned, merge the rows
            var mergedFields = {};
            var overlap = group.records.find(function (record) {
              return Object.keys(record.fields).find(function (fieldName) {
                if (mergedFields[fieldName]) {
                  return true;
                }
                mergedFields[fieldName] = record.fields[fieldName];
              });
            });
            if (!overlap) {
              // TODO: element
              group.records = [{
                element: document.documentElement,
                fields: mergedFields
              }];
            }
          });
          var onlySingleValuesOrOneField = function onlySingleValuesOrOneField(group) {
            // there's only one record, cool:
            if (group.records.length === 1) return true;

            // there is more than one record, we need to check that there is only one field
            return !group.records.find(function (record) {
              return Object.keys(record.fields).length > 1;
            });
          };

          // merge the groups together
          var toMerge = groups.filter(onlySingleValuesOrOneField);
          var mergeGroups = function mergeGroups() {
            var mergedFields = {};
            var overlap = toMerge.find(function (group) {
              // collapse the records
              var collapsed = {};
              group.records.forEach(function (record) {
                Object.keys(record.fields).forEach(function (fieldName) {
                  var _collapsed$fieldName;
                  if (!collapsed[fieldName]) collapsed[fieldName] = [];
                  var fields = record.fields[fieldName];
                  if (Array.isArray(fields)) (_collapsed$fieldName = collapsed[fieldName]).push.apply(_collapsed$fieldName, _toConsumableArray(fields));else collapsed[fieldName].push(fields);
                });
              });
              return Object.keys(collapsed).find(function (fieldName) {
                if (mergedFields[fieldName]) {
                  return true;
                }
                mergedFields[fieldName] = collapsed[fieldName];
              });
            });
            if (overlap) return null;
            return mergedFields;
          };
          var mergedFields = null;
          if (toMerge.length > 1 && (mergedFields = mergeGroups())) {
            // let's do the merge
          } else {
            toMerge = [];
          }

          // rebuild the groups
          var merged = false;
          var normalizedGroups = [];
          groups.forEach(function (group) {
            if (toMerge.indexOf(group) >= 0) {
              if (merged) return;
              merged = true;
              normalizedGroups.push({
                element: document.documentElement,
                records: [{
                  fields: mergedFields,
                  element: document.documentElement
                }]
              });
              return;
            }
            normalizedGroups.push(group);
          });

          // now merge groups who are direct sibilngs
          var mergedGroups = [];
          normalizedGroups.forEach(function (group) {
            if (!mergedGroups.length) {
              mergedGroups.push(group);
              return;
            }
            var last = mergedGroups[mergedGroups.length - 1];
            if (last.element.nextElementSibling === group.element) {
              var _last$records;
              last.merged = true;
              (_last$records = last.records).push.apply(_last$records, _toConsumableArray(group.records));
              last.element = group.element;
            } else {
              mergedGroups.push(group);
            }
          });
          mergedGroups.forEach(function (group) {
            if (!group.merged) return;
            group.element = group.element.parentNode;
            delete group.merged;
          });
          return mergedGroups;
        };
        var result = collapseGroups();
        return result;
      } catch (e) {
        _logger2.default.error(e.stack);
      } finally {
        (0, _timer.timeEnd)('groupToRecords');
      }
    }

    /***/
  }, /* 11 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.DocumentExamples = undefined;
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    exports.initializeEditorDocument = initializeEditorDocument;
    exports.getElementSelector = getElementSelector;
    exports.trainField = trainField;
    exports.suggestElements = suggestElements;
    exports.calculateAndSetFieldSelector = calculateAndSetFieldSelector;
    exports.calculateAndSetRegionsSelector = calculateAndSetRegionsSelector;
    exports.getRegionsSelector = getRegionsSelector;
    exports.exampleFromSelector = exampleFromSelector;
    exports.getSelector = getSelector;
    exports.getRegionSelector = getRegionSelector;
    var _utils = __webpack_require__(1);
    var _Example = __webpack_require__(2);
    var _selector2 = __webpack_require__(0);
    var _extractor = __webpack_require__(3);
    var _group = __webpack_require__(10);
    var _timer = __webpack_require__(5);
    var _logger = __webpack_require__(4);
    var _logger2 = _interopRequireDefault(_logger);
    var _css = __webpack_require__(12);
    var _css2 = _interopRequireDefault(_css);
    var _deepEqual = __webpack_require__(13);
    var _deepEqual2 = _interopRequireDefault(_deepEqual);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }

    /**
     * Initialize a document for editing
     */
    function initializeEditorDocument(document) {
      // cache the original class attribute value so we can mutate it later
      Array.prototype.slice.apply(document.querySelectorAll('[class]')).forEach(function (e) {
        e.setAttribute('_class', e.getAttribute('class'));
      });
      Array.prototype.slice.apply(document.querySelectorAll('[style]')).forEach(function (e) {
        e.setAttribute('_style', e.getAttribute('style'));
      });
      wrapTextNodes(document);
    }

    /**
     * Function used in page interaction to get a selector of an arbitrary element in the DOM.
     * @param  {Element} element HTML element node.
     * @param  {Element} dom     window.document node.
     * @return {Selector}        Selector object pointing to the element.
     */
    function getElementSelector(element, dom) {
      var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var example = (0, _Example.makeRegionExample)(element, null, useCache);
      var elementSelector = getSelector('html', [new DocumentExamples(dom, [example])]);
      return elementSelector;
    }

    /**
     * Add training to a field
     *
     * @param  {Page} page
     * @param  {Field} field
     * @param  {Element} clickedElement
     * @param  {Boolean} counterexample
     * @return {Boolean|Example}
     */
    function trainField(pageSet, page, field, clickedElement, counterexample) {
      // zoom in onto the text
      clickedElement = zoomIn(clickedElement);
      var xpath = (0, _selector2.fullXPath)(clickedElement);
      var example = (0, _Example.makeExample)(page.dom(), xpath, counterexample);
      page.addFieldExample(field, example);
      calculateAndSetFieldSelector(pageSet, field);
      return example;
    }

    /**
     * Suggest other similar elements to display
     *
     * @param  {Page} page
     * @param  {Field} field
     * @return {Array}          An array of xpaths
     */
    function suggestElements(page, field) {
      // try getting the selector and stripping out the nth-child

      // copy the selector
      // TODO: use a library
      var sel = JSON.parse(JSON.stringify(field.selector));
      sel.forEach(function (path) {
        return path.forEach(function (section) {
          section.childOfType = null;
          // generalize out the ids
          if (section.attributes.id) section.attributes.id = [0, 1];
        });
      });
      var elts = Array.prototype.slice.apply((0, _selector2.selectNodes)(sel, page.dom()));
      var current = page.fieldExamplesFor(field);
      var result = elts.map(function (e) {
        return (0, _selector2.fullXPath)(e, true);
      }).filter(function (xpath) {
        return !current.find(function (example) {
          return example.xpath === xpath;
        });
      });
      return result;
    }

    /**
     * Calculate and set the field selector for the PageSet
     * @param  {Field} field
     * @return {void}
     */
    function calculateAndSetFieldSelector(pageSet, field) {
      var fieldSelector = getSelector(pageSet, pageSet.pages.map(function (page) {
        return new DocumentExamples(page.dom(), page.fieldExamplesFor(field));
      }));
      _logger2.default.info('Setting selector for', field.name, 'to', function () {
        return (0, _selector2.toCssSelector)(fieldSelector);
      });
      pageSet.fieldWithId(field.id).selector = fieldSelector;
    }
    function calculateAndSetRegionsSelector(pageSet) {
      if (pageSet.recordSelector || pageSet.recordXPath || pageSet.singleRecord) {
        pageSet.regionsSelector = null;
        return;
      }
      // first we need to extract the data
      var regions = [];
      pageSet.pages.forEach(function (page) {
        var fieldElements = (0, _extractor.getFieldElements)(page.dom(), pageSet.runtimeConfig().fields);
        regions.push((0, _group.getRegions)(page.dom(), fieldElements));
      });
      pageSet.regionsSelector = getRegionsSelector(regions);
    }
    function getRegionsSelector(regions) {
      if (!Array.isArray(regions[0])) {
        regions = [regions];
      }
      regions = regions.filter(function (r) {
        return r.length;
      });
      if (!regions || regions.length == 0) {
        return null;
      }
      var selector = (0, _selector2.compactSelector)(getRegionSelector(regions.map(function (r) {
        return new DocumentExamples(r[0].ownerDocument, r.map(function (x) {
          return (0, _Example.makeRegionExample)(x);
        }));
      })));

      // TODO: fix this better
      selector.forEach(function (sel) {
        if (sel[0] === ':this') sel[0] = 'html';
      });
      return selector;
    }
    function wrapTextNodes(dom) {
      Array.from(dom.querySelectorAll('body *:not(script):not(style):not(tr):not(tbody):not(thead):not(table):not(tfoot):not(col):not(colgroup)')).forEach(function (tag) {
        var childNodes = Array.from(tag.childNodes).filter(function (c) {
          return c.nodeType === 3;
        });
        if (childNodes.every(function (n) {
          return (0, _utils.isWhitespace)(n);
        })) {
          // if all the siblings are whitespace don't bother
          // this should also (hopfeully) reduce the chance of CSS side-effects from this text wrapping, e.g. with li blocks
          return;
        }
        for (var i = 0; i < childNodes.length; i++) {
          var c = childNodes[i];
          var w = dom.createElement('io-text');
          tag.replaceChild(w, c);
          w.appendChild(c);
        }
      });
    }

    /**
     * Find a descendant with the same text content, if one exists.
     * Returns the element input if not.
     *
     * @param  {Element} element
     * @return {Element}
     */
    var zoomIn = function zoomIn(element) {
      if (element.children.length) {
        (function () {
          var text = (0, _utils.normalizeSpace)(element.textContent);
          while (element.children.length) {
            var newElement = Array.prototype.slice.call(element.children).find(function (e) {
              return (0, _utils.normalizeSpace)(e.textContent) == text;
            });
            if (newElement) {
              element = newElement;
            } else {
              break;
            }
          }
          if (element.firstChild && element.firstChild.nodeType == 3 && element.firstChild.textContent === element.textContent) {
            element = element.firstChild;
          }
        })();
      }
      return element;
    };

    /**
     * Get the intersection of two arrays
     * @param  {Array} arr1
     * @param  {Array} arr2
     * @return {Array}
     */
    var getIntersect = function getIntersect(arr1, arr2) {
      var temp = [];
      for (var i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) >= 0) {
          temp.push(arr1[i]);
        }
      }
      return temp;
    };
    var UNIQUE_CACHE_FIELD_NAME = 'hhfkdytweirelld';
    var getUniqueClass = function getUniqueClass(context, section) {
      return section.classes.find(function (clazz) {
        if (!context[UNIQUE_CACHE_FIELD_NAME]) context[UNIQUE_CACHE_FIELD_NAME] = {};else {
          var cached = context[UNIQUE_CACHE_FIELD_NAME][clazz];
          if (cached !== undefined) return cached;
        }
        var unique = (0, _selector2.querySelectorAll)(context, '.' + (0, _css2.default)(clazz)).length === 1;
        context[UNIQUE_CACHE_FIELD_NAME][clazz] = unique;
        if (unique) {
          _logger2.default.debug('Class', clazz, 'is unique');
          return true;
        }
        return false;
      });
    };
    var POSITION = 1;
    var NAME = 2;
    var ID = 4;
    var STYLE = 8;
    var CLASSES_EXACT = 16;
    var CLASSES_COVERED = 32;
    var CLASSES_INTERSECT = 64;
    var CLASSES_BOTH_UNIQUE = 128;
    var SAME_MICRODATA = 256;
    var COMPATIBLE = 512;
    var MICRO_ATTRS = ['itemprop', 'itemtype', 'typeof'];
    var compare = function compare(thisSection, otherSection, thisExample, otherExample) {
      var result = 0;
      if (otherSection.name === thisSection.name) result |= NAME;
      if (otherSection.attributes.id === thisSection.attributes.id) result |= ID;
      if (!!otherSection.attributes.style === !!thisSection.attributes.style) result |= STYLE;
      // exactly the same classes
      if ((0, _utils.arraysEqual)(otherSection.classes, thisSection.classes)) {
        result |= CLASSES_EXACT | CLASSES_COVERED | CLASSES_INTERSECT;
        // if all the other classes are in this one, i.e. less specific, it is covering
      } else if (otherSection.classes.every(function (x) {
        return thisSection.classes.indexOf(x) >= 0;
      })) {
        result |= CLASSES_COVERED | CLASSES_INTERSECT;
      } else if (getIntersect(thisSection.classes, otherSection.classes).length) {
        result |= CLASSES_INTERSECT;
      } else {
        // if the sections both have a unique class and nothing else, count it as an intersection
        if (thisSection.classes.length === 1 && otherSection.classes.length === 1 && getUniqueClass(thisExample.document, thisSection) && getUniqueClass(otherExample.document, otherSection)) {
          result |= CLASSES_BOTH_UNIQUE;
        }
      }
      if (otherSection.childOfType === thisSection.childOfType) result |= POSITION;
      if ((0, _deepEqual2.default)(MICRO_ATTRS.map(function (x) {
        return otherSection.attributes[x];
      }), MICRO_ATTRS.map(function (x) {
        return thisSection.attributes[x];
      }))) result |= SAME_MICRODATA;
      if (result & NAME && result & SAME_MICRODATA && result & CLASSES_INTERSECT | result & CLASSES_BOTH_UNIQUE) {
        result |= COMPATIBLE;
      }
      return result;
    };

    /**
     * Checks to see if two paths could be merged together
     */
    var arePathsCompatible = function arePathsCompatible(thisPath, otherPath, thisExample, otherExample) {
      if (thisPath.length !== otherPath.length) {
        return false;
      }
      var _loop = function _loop(k) {
        var otherSection = otherPath[k];
        var thisSection = thisPath[k];
        var comparison = compare(thisSection, otherSection, thisExample, otherExample);
        if (!(comparison & COMPATIBLE)) {
          _logger2.default.debug('Sections are incompatible', function () {
            return (0, _selector2.toCssSelectorSection)(thisSection);
          }, function () {
            return (0, _selector2.toCssSelectorSection)(otherSection);
          });
          return {
            v: false
          };
        }
      };
      for (var k = 0; k < otherPath.length; k++) {
        var _ret2 = _loop(k);
        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
      }
      return true;
    };

    /**
     * Reduces a set of examples by combining examples
     * which are COMPATIBLE
     */
    var reduce = function reduce(selector) {
      // copy the data before we mutate it
      // TODO: use a library
      var examples = JSON.parse(JSON.stringify(selector.paths));
      _logger2.default.debug('Trying to reduce', examples.length, 'selectors');
      var removed = [];
      examples = examples.filter(function (thisPath, index) {
        var _loop2 = function _loop2(i, j) {
          if (i === index) return 'continue';
          var otherPath = examples[i];
          // if it's already been removed it can't cover
          if (removed.indexOf(otherPath) >= 0) return 'continue';
          if (!arePathsCompatible(thisPath, otherPath, selector.examples[index], selector.examples[i])) return 'continue';
          _logger2.default.debug('Compatible selectors, will merge', function () {
            return (0, _selector2.toCssSelector)(thisPath);
          }, function () {
            return (0, _selector2.toCssSelector)(otherPath);
          });
          var _loop3 = function _loop3(k) {
            var otherSection = otherPath[k];
            var thisSection = thisPath[k];
            Object.keys(thisSection.attributes).map(function (x) {
              return '.' + x;
            }).concat(['childOfType', 'lastOfType', 'text', 'covers']).forEach(function (attr) {
              var attribute = attr[0] === '.';
              if (attribute) attr = attr.substr(1);
              var srcObj = attribute ? thisSection.attributes : thisSection;
              var destObj = attribute ? otherSection.attributes : otherSection;
              var source = srcObj[attr];
              var dest = destObj[attr];
              if (dest !== source) {
                if (!Array.isArray(dest)) {
                  destObj[attr] = [dest];
                  dest = destObj[attr];
                }
                var merge = function merge(x) {
                  if (dest.indexOf(x) < 0) {
                    dest.push(x);
                  }
                };
                if (Array.isArray(source)) {
                  source.forEach(merge);
                } else {
                  merge(source);
                }
              }
            });
            if (!otherSection.classLists) {
              otherSection.classLists = [otherSection.classes];
            }
            if (!thisSection.classLists) {
              thisSection.classLists = [thisSection.classes];
            }
            thisSection.classLists.forEach(function (toAdd) {
              if (!otherSection.classLists.find(function (arr) {
                return (0, _utils.arraysEqual)(arr, toAdd);
              })) {
                otherSection.classLists.push(toAdd);
              }
            });
            otherSection.classes = getIntersect(thisSection.classes, otherSection.classes);
          };
          for (var k = 0; k < otherPath.length; k++) {
            _loop3(k);
          }
          removed.push(thisPath);
          _logger2.default.debug('Merged path', function () {
            return (0, _selector2.toCssSelector)(otherPath);
          });
          return {
            v: false
          };
        };
        for (var i = 0, j = examples.length; i < j; i++) {
          var _ret3 = _loop2(i, j);
          switch (_ret3) {
            case 'continue':
              continue;
            default:
              if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
          }
        }

        // we couldn't find any other one to merge with
        return true;
      });
      _logger2.default.debug('Reduced to', examples.length, 'selectors');
      examples.forEach(function (path) {
        return path.forEach(function (section) {
          if (!section.classLists) section.classLists = [section.classes];
        });
      });
      return examples;
    };
    var getKey = function getKey(path, record) {
      return path.map(function (x, idx) {
        if (!record || idx !== path.length - 1) return x.name;
        if (x.attributes.id) return x.name + '#' + x.attributes.id;
        var uniqueClass = getUniqueClass(record, x);
        if (uniqueClass) return x.name + '#' + uniqueClass;
        return x.name;
      }).join(' ');
    };
    var createSelectorLookup = function createSelectorLookup(examples, counterexampleLookup) {
      var lookup = {};
      var nonUnique = {};
      examples.forEach(function (recordExample) {
        var example = recordExample.example;
        example.path.forEach(function (b, idx) {
          for (var i = 0, j = example.coversIndex; i <= j && i <= recordExample.recordAncestor; i++) {
            var path = example.path.slice(i, idx + 1);
            if (path.length == 0) break;
            var textNode = path[0].name === '#text';
            // can't just select a text node
            if (path.length == 1 && textNode) continue;
            // if the text node has same text content as element above, ignore
            if (example.coversIndex > 0 && textNode) continue;

            // for coutner examples we just use a plain key as later we compare with merged keys
            var key = getKey(path, counterexampleLookup ? recordExample.record : undefined);
            if (counterexampleLookup && nonUnique[key]) {
              // don't use counter examples
              _logger2.default.debug('Ignoring path as not unique for another: ', key);
              continue;
            }
            if (!(0, _selector2.uniqueNode)(path, recordExample.record)) {
              _logger2.default.debug('Ignoring path as not unique', key);
              if (counterexampleLookup) {
                nonUnique[key] = true;
                delete lookup[key];
              }
              return;
            }
            if (lookup[key] === undefined) {
              _logger2.default.debug('New counterxample @', key);
              var _selector = {
                path: key,
                count: 0,
                examples: [],
                paths: [],
                depth: path.length,
                textNode: textNode
              };
              lookup[key] = _selector;
            }
            var selector = lookup[key];
            selector.count++;
            selector.examples.push(recordExample);
            selector.paths.push(path);
            selector.topScope |= recordExample.recordAncestor === i;
          }
        });
      });
      return lookup;
    };

    /**
     * Calculates a selector given the examples and counterexamples
     */
    var _calcSelector = function _calcSelector(examples, counterexamples) {
      if (examples.find(function (x) {
        return x.example.coversIndex >= x.recordAncestor;
      })) {
        return [[]];
      }
      var result = [];
      _logger2.default.debug('There are', examples.length, 'examples');
      _logger2.default.debug('There are', counterexamples.length, 'counterexamples');
      var counterLookup = createSelectorLookup(counterexamples);
      _logger2.default.debug('******', 'Counterexample paths:', function () {
        return Object.values(counterLookup).map(function (s) {
          return s.path + ' (' + s.count + ')';
        }).join(', ');
      });

      // reduce down the counter lookup
      Object.keys(counterLookup).forEach(function (key) {
        return counterLookup[key] = reduce(counterLookup[key]);
      });
      var lookup = createSelectorLookup(examples, counterLookup);
      var selectors = Object.values(lookup);

      // sort to order with the most hits first, followed by least length
      var sortSelectors = function sortSelectors() {
        selectors.sort(function (a, b) {
          if (b.count == a.count) {
            if (a.depth == b.depth) {
              if (a.textNode && b.textNode) return 0;
              if (a.textNode) return 1;
              return -1;
            }
            return a.depth - b.depth;
          }
          return b.count - a.count;
        });
      };
      sortSelectors();
      _logger2.default.debug('******', 'First pass selector paths:', function () {
        return selectors.map(function (s) {
          return s.path + ' (' + s.count + ')';
        }).join(', ');
      });
      var ungroupedExamples = [].concat(_toConsumableArray(examples));
      var chooseSelectors = function chooseSelectors(excludeIgnore) {
        var _loop4 = function _loop4(_idx) {
          // the next best....
          var best = selectors[_idx];
          if (best.examples.length === 0) {
            // no examples left in this option
            return 'continue';
          }

          // if it's the topmose element, that's all it can be.
          if (best.topScope) {
            return {
              v: ':this'
            };
          }
          _logger2.default.debug('Reducing', best.length, 'paths into a consistent selector');
          var selector = reduce(best);
          _logger2.default.debug('Reduced to', function () {
            return (0, _selector2.toCssSelector)(selector);
          });

          // currently we just look at the classes for negation
          _logger2.default.debug('Checking counter-examples');
          selector.forEach(function (path) {
            var key = getKey(path);
            _logger2.default.debug('Got key', key);
            var counterPaths = counterLookup[key];
            if (!counterPaths) return;
            var _loop5 = function _loop5(i) {
              var section = path[i];
              var classes = [];
              var childOfType = [];
              counterPaths.forEach(function (counterPath) {
                var before = classes.length;
                counterPath[i].classLists.forEach(function (arr) {
                  return arr.forEach(function (clazz) {
                    if (classes.indexOf(section) < 0 && !section.classLists.find(function (arr) {
                      return arr.indexOf(clazz) >= 0;
                    })) {
                      // it is enough to just exclude it on one other class
                      classes.push(clazz);
                      return;
                    }
                  });
                });
                // it is enough to just exclude it on one other class, don't need position as well
                if (before !== classes.length) {
                  return;
                }
                var positions = counterPath[i].childOfType;
                if (!Array.isArray(positions)) positions = [positions];
                positions.forEach(function (c) {
                  if ((Array.isArray(section.childOfType) && section.childOfType.indexOf(c) < 0 || !Array.isArray(section.childOfType) && section.childOfType !== c) && childOfType.indexOf(c) < 0) {
                    childOfType.push(c);
                  }
                });
              });
              section.not = {
                classes: classes,
                childOfType: childOfType
              };
            };
            for (var i = 0; i < path.length; i++) {
              _loop5(i);
            }
          });

          // TODO: this could be more efficient
          var matchesCounterExample = function matchesCounterExample() {
            return counterexamples.find(function (recordExample) {
              var matches = Array.from((0, _selector2.selectNodes)(selector, recordExample.record));
              return matches.find(function (x) {
                return recordExample.ancestors.find(function (y) {
                  return y === x;
                });
              });
            });
          };
          if (!excludeIgnore) {
            if (matchesCounterExample()) {
              _logger2.default.debug('Not using', best.path, 'as matches a counterexample');
              return 'continue';
            }
          }
          selector = selector.map(function (path) {
            _logger2.default.debug('Trying to simplify selector', function () {
              return (0, _selector2.compactSelector)(path);
            });

            // When multiple examples have same record, e.g. repeated items in one row
            // only examine alternativeOk over uniq record. code equal to:
            // const expected = examples.map( recordExample => Array.from(selectNodes(path, recordExample.record)) );
            var uniq_records = new Set(examples.map(function (_ref) {
              var record = _ref.record;
              return record;
            }));
            var expected = Array.from(uniq_records).map(function (record) {
              return {
                elements: Array.from((0, _selector2.selectNodes)(path, record)),
                record: record
              };
            });
            var alternativeOk = function alternativeOk(alternative) {
              return !expected.find(function (_ref2) {
                var elements = _ref2.elements,
                  record = _ref2.record;
                var matches = Array.from((0, _selector2.selectNodes)(alternative, record));
                return !(0, _utils.arraysEqual)(matches, elements);
              });
            };
            var tryWithoutPositionAndId = function tryWithoutPositionAndId(slice, idx) {
              var input = path;
              if (slice) input = input.slice(0, slice);
              var alternative = JSON.parse(JSON.stringify(input));
              if (idx === undefined) idx = alternative.length - 1;
              var section = alternative[idx];

              // don't go all the way up to <head/>
              if (input.length == 1 && section.name === 'head') {
                return false;
              }
              if (!slice && !section.childOfType && !section.attributes.id) {
                return true;
              }
              section._childOfType = section.childOfType;
              section._lastOfType = section.lastOfType;
              section.attributes._id = section.attributes.id;
              delete section.childOfType;
              delete section.lastOfType;
              delete section.attributes.id;
              var ok = alternativeOk(alternative);
              _logger2.default.debug('Checking if alternative ok', function () {
                return (0, _selector2.compactSelector)(alternative);
              }, ok);
              if (ok) {
                if (slice) {
                  path = alternative;
                } else {
                  path[idx] = alternative[idx];
                }
              }
              return ok;
            };

            // take a copy of the path and kill all the positions/ids
            // optimization for the common case
            var opt = JSON.parse(JSON.stringify(path));
            opt.forEach(function (section) {
              section._childOfType = section.childOfType;
              section._lastOfType = section.lastOfType;
              section.attributes._id = section.attributes.id;
              delete section.childOfType;
              delete section.lastOfType;
              delete section.attributes.id;
            });
            var noIdOrPos = alternativeOk(opt);
            if (noIdOrPos) {
              _logger2.default.debug('Can remove id and positions', function () {
                return (0, _selector2.compactSelector)(opt);
              });
              path = opt;
            }
            for (var i = 1, j = path.length; i < j; i++) {
              // try shortest first
              if (tryWithoutPositionAndId(i)) {
                break;
              }
            }
            if (!noIdOrPos) {
              for (var _i = 0, _j = path.length; _i < _j; _i++) {
                // try removing any remaining
                tryWithoutPositionAndId(null, _i);
              }
            }
            return path;
          });
          selector.forEach(function (x) {
            return result.push(x);
          });
          ungroupedExamples = ungroupedExamples.filter(function (g) {
            return best.examples.indexOf(g) < 0;
          });
          _logger2.default.debug('Examples left to merge: ', ungroupedExamples.length);

          // remove this selector, resort
          selectors.splice(_idx, 1);
          _idx = -1;
          selectors.forEach(function (sel) {
            best.examples.forEach(function (e) {
              var i = sel.examples.indexOf(e);
              if (i < 0) return;
              sel.examples.splice(i, 1);
              sel.paths.splice(i, 1);
              sel.count--;
            });
          });

          // resort
          sortSelectors();
          idx = _idx;
        };
        for (var idx = 0; idx < selectors.length && ungroupedExamples.length; idx++) {
          var _ret5 = _loop4(idx);
          switch (_ret5) {
            case 'continue':
              continue;
            default:
              if ((typeof _ret5 === 'undefined' ? 'undefined' : _typeof(_ret5)) === "object") return _ret5.v;
          }
        }
      };
      chooseSelectors();
      if (ungroupedExamples.length) {
        // remove counterexample restrictions
        chooseSelectors(true);
      }
      return result;
    };
    var getRow = function getRow(e, records) {
      return records.find(function (row) {
        return row === e || row.contains(e);
      });
    };
    function exampleFromSelector(dom, selector, counterexample) {
      var xpath = (0, _selector2.fullXPath)(dom.querySelector(selector));
      return (0, _Example.makeExample)(dom, xpath, counterexample);
    }
    var DocumentExamples = exports.DocumentExamples = function () {
      function DocumentExamples(document, examples) {
        _classCallCheck(this, DocumentExamples);
        this._document = document;
        this._examples = examples;
      }
      _createClass(DocumentExamples, [{
        key: 'document',
        get: function get() {
          return this._document;
        }
      }, {
        key: 'examples',
        get: function get() {
          return this._examples;
        }
      }]);
      return DocumentExamples;
    }();

    // TODO: use a class for record examples

    var toRecordExample = function toRecordExample(document, example, records) {
      var element = (0, _selector2.getByFullXPath)(example.xpath, document);
      if (!element) return;
      var record = getRow(element, records);
      if (!record) return;
      var ancestors = [];
      var e = element;
      var recordAncestor = -1;
      do {
        if (e === record) {
          recordAncestor = ancestors.length;
        }
        ancestors.push(e);
      } while (e = e.parentNode);
      return {
        document: document,
        record: record,
        example: example,
        element: element,
        ancestors: ancestors,
        recordAncestor: recordAncestor
      };
    };
    function getSelector(pageSet, documentExamplesArray) {
      if (documentExamplesArray.length === 0) {
        return null;
      }
      var examples = [];
      var counterexamples = [];
      documentExamplesArray.forEach(function (documentExamples) {
        var doc = documentExamples.document;
        // these are what we are calculating the selector relative to
        var records = (0, _extractor.getRecordElements)(doc, pageSet);
        if (!records) records = [doc.documentElement];
        documentExamples.examples.forEach(function (example) {
          var x = toRecordExample(doc, example, records);
          if (!x) {
            return;
          }
          if (example.counterexample) {
            counterexamples.push(x);
          } else {
            examples.push(x);
          }
        });
      });
      if (examples.length == 0) {
        return null;
      }

      // get a selector for the clicked element
      var selector = calcSelector(examples, counterexamples);
      _logger2.default.info('Calculated selector as', JSON.stringify((0, _selector2.compactSelector)(selector)));
      return selector;
    }
    ;
    function getRegionSelector(documentExamplesArray) {
      if (documentExamplesArray.length === 0) {
        return null;
      }
      var examples = [];
      var counterexamples = [];
      documentExamplesArray.forEach(function (documentExamples) {
        var doc = documentExamples.document;
        if (!doc || !doc.documentElement) throw Error('No document element');

        // these are what we are calculating the selector relative to
        var records = [doc];
        documentExamples.examples.forEach(function (example) {
          var x = toRecordExample(doc, example, records);
          if (!x) {
            return;
          }
          if (example.counterexample) {
            counterexamples.push(x);
          } else {
            examples.push(x);
          }
        });
      });
      if (examples.length == 0) {
        return null;
      }

      // get a selector for the clicked element
      var selector = calcSelector(examples, counterexamples);
      _logger2.default.info('Calculated region selector as', JSON.stringify((0, _selector2.compactSelector)(selector)));
      return selector;
    }
    ;
    var calcSelector = function calcSelector(examples, counterexamples) {
      (0, _timer.time)('calcSelector');
      try {
        return _calcSelector(examples, counterexamples);
      } finally {
        (0, _timer.timeEnd)('calcSelector');
      }
    };

    /***/
  }, /* 12 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */
      ;
      (function (root, factory) {
        // https://github.com/umdjs/umd/blob/master/returnExports.js
        if (true) {
          // For Node.js.
          module.exports = factory(root);
        } else if (typeof define == 'function' && define.amd) {
          // For AMD. Register as an anonymous module.
          define([], factory.bind(root, root));
        } else {
          // For browser globals (not exposing the function separately).
          factory(root);
        }
      })(typeof global != 'undefined' ? global : this, function (root) {
        if (root.CSS && root.CSS.escape) {
          return root.CSS.escape;
        }

        // https://drafts.csswg.org/cssom/#serialize-an-identifier
        var cssEscape = function cssEscape(value) {
          if (arguments.length == 0) {
            throw new TypeError('`CSS.escape` requires an argument.');
          }
          var string = String(value);
          var length = string.length;
          var index = -1;
          var codeUnit;
          var result = '';
          var firstCodeUnit = string.charCodeAt(0);
          while (++index < length) {
            codeUnit = string.charCodeAt(index);
            // Note: there’s no need to special-case astral symbols, surrogate
            // pairs, or lone surrogates.

            // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER
            // (U+FFFD).
            if (codeUnit == 0x0000) {
              result += "\uFFFD";
              continue;
            }
            if (
            // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
            // U+007F, […]
            codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
            // If the character is the first character and is in the range [0-9]
            // (U+0030 to U+0039), […]
            index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
            // If the character is the second character and is in the range [0-9]
            // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]

            index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
              // https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
              result += '\\' + codeUnit.toString(16) + ' ';
              continue;
            }
            if (
            // If the character is the first character and is a `-` (U+002D), and
            // there is no second character, […]
            index == 0 && length == 1 && codeUnit == 0x002D) {
              result += '\\' + string.charAt(index);
              continue;
            }

            // If the character is not handled by one of the above rules and is
            // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
            // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
            // U+005A), or [a-z] (U+0061 to U+007A), […]
            if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
              // the character itself
              result += string.charAt(index);
              continue;
            }

            // Otherwise, the escaped character.
            // https://drafts.csswg.org/cssom/#escape-a-character
            result += '\\' + string.charAt(index);
          }
          return result;
        };
        if (!root.CSS) {
          root.CSS = {};
        }
        root.CSS.escape = cssEscape;
        return cssEscape;
      });

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(6));

    /***/
  }, /* 13 */
  /***/function (module, exports, __webpack_require__) {
    var pSlice = Array.prototype.slice;
    var objectKeys = __webpack_require__(26);
    var isArguments = __webpack_require__(25);
    var deepEqual = module.exports = function (actual, expected, opts) {
      if (!opts) opts = {};
      // 7.1. All identical values are equivalent, as determined by ===.
      if (actual === expected) {
        return true;
      } else if (actual instanceof Date && expected instanceof Date) {
        return actual.getTime() === expected.getTime();

        // 7.3. Other pairs that do not both pass typeof value == 'object',
        // equivalence is determined by ==.
      } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
        return opts.strict ? actual === expected : actual == expected;

        // 7.4. For all other Object pairs, including Array objects, equivalence is
        // determined by having the same number of owned properties (as verified
        // with Object.prototype.hasOwnProperty.call), the same set of keys
        // (although not necessarily the same order), equivalent values for every
        // corresponding key, and an identical 'prototype' property. Note: this
        // accounts for both named and indexed properties on Arrays.
      } else {
        return objEquiv(actual, expected, opts);
      }
    };
    function isUndefinedOrNull(value) {
      return value === null || value === undefined;
    }
    function isBuffer(x) {
      if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
      if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
        return false;
      }
      if (x.length > 0 && typeof x[0] !== 'number') return false;
      return true;
    }
    function objEquiv(a, b, opts) {
      var i, key;
      if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
      // an identical 'prototype' property.
      if (a.prototype !== b.prototype) return false;
      //~~~I've managed to break Object.keys through screwy arguments passing.
      //   Converting to array solves the problem.
      if (isArguments(a)) {
        if (!isArguments(b)) {
          return false;
        }
        a = pSlice.call(a);
        b = pSlice.call(b);
        return deepEqual(a, b, opts);
      }
      if (isBuffer(a)) {
        if (!isBuffer(b)) {
          return false;
        }
        if (a.length !== b.length) return false;
        for (i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) return false;
        }
        return true;
      }
      try {
        var ka = objectKeys(a),
          kb = objectKeys(b);
      } catch (e) {
        //happens when one is a string literal and the other isn't
        return false;
      }
      // having the same number of owned properties (keys incorporates
      // hasOwnProperty)
      if (ka.length != kb.length) return false;
      //the same set of keys (although not necessarily the same order),
      ka.sort();
      kb.sort();
      //~~~cheap key test
      for (i = ka.length - 1; i >= 0; i--) {
        if (ka[i] != kb[i]) return false;
      }
      //equivalent values for every corresponding key, and
      //~~~possibly expensive deep test
      for (i = ka.length - 1; i >= 0; i--) {
        key = ka[i];
        if (!deepEqual(a[key], b[key], opts)) return false;
      }
      return typeof a === typeof b;
    }

    /***/
  }, /* 14 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _Page = __webpack_require__(9);
    var _Page2 = _interopRequireDefault(_Page);
    var _Field = __webpack_require__(7);
    var _Field2 = _interopRequireDefault(_Field);
    var _extractor = __webpack_require__(3);
    var _deepEqual = __webpack_require__(13);
    var _deepEqual2 = _interopRequireDefault(_deepEqual);
    var _uuid = __webpack_require__(8);
    var _uuid2 = _interopRequireDefault(_uuid);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var PageSet = function () {
      function PageSet(data) {
        _classCallCheck(this, PageSet);
        this._id = _uuid2.default.v4();
        this._pages = [];
        this._fields = [];
        this._recordSelector = null;
        this.load(data);
        this._noscript = !!this._noscript;
      }
      _createClass(PageSet, [{
        key: 'load',
        value: function load(data) {
          var _this = this;
          if (data) {
            Object.assign(this, data);
            this._fields = data.fields.map(function (o) {
              return new _Field2.default(o);
            });
            this._pages = [];
            data.pages.forEach(function (o) {
              return _this.addPage(new _Page2.default(o));
            });
          }
        }
      }, {
        key: 'addPage',
        value: function addPage(page) {
          this._pages.push(page);
          page.pageSet = this;
        }
      }, {
        key: 'addField',
        value: function addField(field, position) {
          if (position) {
            this._fields.splice(position, 0, field);
          } else {
            this._fields.push(field);
          }
        }
      }, {
        key: 'getRuntimeConfigWithNoscriptDetect',
        /**
         * deprecated
         */
        value: function getRuntimeConfigWithNoscriptDetect() {
          return this.getOptimizedRuntimeConfig();
        }
      }, {
        key: 'getOptimizedRuntimeConfig',
        value: function getOptimizedRuntimeConfig() {
          var runtimeConfig = this.runtimeConfig();
          return this.optimize(runtimeConfig);
        }
      }, {
        key: 'optimize',
        value: function optimize(runtimeConfig) {
          // manually set js off?
          if (!runtimeConfig.noscript && this.noscriptAvailable) {
            // if we can find one where
            var differentResultsWithoutScripts = this.pages.find(function (page) {
              var scripted = (0, _extractor.extract)(runtimeConfig, page.scriptDom(), page.url);
              var noscripted = (0, _extractor.extract)(runtimeConfig, page.noscriptDom(), page.url);
              return !(0, _deepEqual2.default)(scripted, noscripted);
            });
            if (!differentResultsWithoutScripts) {
              // they are all the same
              runtimeConfig.noscript = true;
            }
          }
          var moreThanOneRow = this.pages.find(function (page) {
            var groupsArray = (0, _extractor.extract)(runtimeConfig, page.scriptDom(), page.url);
            return groupsArray.length > 1 || groupsArray[0].group.length > 1;
          });
          if (!moreThanOneRow) {
            runtimeConfig.singleRecord = true;
            runtimeConfig.regionsSelector = undefined;
          }
          return runtimeConfig;
        }
      }, {
        key: 'fieldWithId',
        value: function fieldWithId(id) {
          return this._fields.find(function (e) {
            return e.id === id;
          });
        }
      }, {
        key: 'toJSON',
        value: function toJSON() {
          return {
            fields: this.fields,
            recordSelector: this._recordSelector,
            recordXPath: this._recordXPath,
            pages: this.pages,
            singleRecord: this.singleRecord,
            regionsSelector: this.regionsSelector,
            noscript: this.noscript,
            screenCapture: !!this.screenCapture
          };
        }
      }, {
        key: 'runtimeConfig',
        value: function runtimeConfig() {
          return {
            fields: this._fields.map(function (f) {
              return f.cloneWithCompactSelector();
            }),
            recordSelector: this._recordSelector,
            recordXPath: this.recordXPath,
            regionsSelector: this.regionsSelector,
            singleRecord: !!this.singleRecord,
            noscript: !!this.noscript,
            screenCapture: !!this.screenCapture
          };
        }
      }, {
        key: 'pages',
        get: function get() {
          return this._pages;
        },
        set: function set(pages) {
          this._pages = pages;
        }
      }, {
        key: 'autoDetectRecords',
        get: function get() {
          return !this._recordSelector && !this._recordXPath && !this._singleRecord;
        }
      }, {
        key: 'recordXPath',
        set: function set(xpath) {
          this._recordXPath = xpath;
        },
        get: function get() {
          return this._recordXPath;
        }
      }, {
        key: 'recordSelector',
        set: function set(selector) {
          this._recordSelector = selector;
        },
        get: function get() {
          return this._recordSelector;
        }
      }, {
        key: 'fields',
        get: function get() {
          return this._fields;
        },
        set: function set(fields) {
          this._fields = fields;
        }
      }, {
        key: 'singleRecord',
        get: function get() {
          return this._singleRecord;
        },
        set: function set(singleRecord) {
          this._singleRecord = singleRecord;
        }
      }, {
        key: 'regionsSelector',
        get: function get() {
          return this._regionsSelector;
        },
        set: function set(regionsSelector) {
          this._regionsSelector = regionsSelector;
        }
      }, {
        key: 'noscript',
        get: function get() {
          return this._noscript;
        },
        set: function set(noscript) {
          this._noscript = !!noscript;
        }
      }, {
        key: 'screenCapture',
        get: function get() {
          return this._screenCapture;
        },
        set: function set(screenCapture) {
          this._screenCapture = !!screenCapture;
        }
      }, {
        key: 'noscriptAvailable',
        get: function get() {
          return !this.pages.find(function (page) {
            return !page.noscriptHtml;
          });
        }
      }]);
      return PageSet;
    }();
    exports.default = PageSet;

    /***/
  }, /* 15 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CDATA = exports.COMMENT = exports.TEXT = exports.END_ELEMENT = exports.SELF_CLOSING_ELEMENT = exports.START_ELEMENT = exports.VOID_ELEMENT = undefined;
      exports.parse = parse;
      exports.importIntoDocument = importIntoDocument;
      var _he = __webpack_require__(33);
      var _he2 = _interopRequireDefault(_he);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      var nodejs = typeof global.window === 'undefined';
      var VOID_ELTS = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
      var VOID_ELEMENT = exports.VOID_ELEMENT = 0;
      var START_ELEMENT = exports.START_ELEMENT = 1;
      var SELF_CLOSING_ELEMENT = exports.SELF_CLOSING_ELEMENT = 2;
      var END_ELEMENT = exports.END_ELEMENT = 3;
      var TEXT = exports.TEXT = 4;
      var COMMENT = exports.COMMENT = 5;
      var CDATA = exports.CDATA = 6;
      var EVENT_NAMES = ['VOID_ELEMENT', 'START_ELEMENT', 'SELF_CLOSING_ELEMENT', 'END_ELEMENT', 'TEXT', 'COMMENT', 'CDATA'];
      var BANG = 0x0021;
      var DASH = 0x002d;
      var OPEN_TAG = 0x003c;
      var EQUALS = 0x003d;
      var CLOSE_TAG = 0x003e;
      var SLASH = 0x002f;
      var SINGLE_QUOTE = 0x0027;
      var DOUBLE_QUOTE = 0x0022;
      var LEFT_SQUARE_BRACKET = 0x005b;
      function parse(html, emit) {
        function isWhitespace(ch) {
          return ch === 0x0020 || ch === 0x0009 || ch === 0x000A || ch === 0x000C || ch === 0x000D;
        }
        var i = 0;
        var c = html.charCodeAt(i);
        var max = function () {
          var max = html.length;
          while (isWhitespace(html.charCodeAt(max - 1))) {
            max--;
          }
          return max;
        }();
        function decodeHtml(html) {
          return _he2.default.decode(html);
        }
        function next() {
          i++;
          c = html.charCodeAt(i);
        }
        function skip(j) {
          i += j;
          c = html.charCodeAt(i);
        }
        function goto(j) {
          if (j < i) {
            throw Error('Cannot go backwards');
          }
          i = j;
          c = html.charCodeAt(i);
        }
        function peek() {
          return html.charCodeAt(i + 1);
        }
        function skipWhitespace() {
          while (isWhitespace(c)) {
            next();
          }
        }
        function skipPast(ch) {
          while (i < max && c !== ch) {
            next();
          }
          next();
        }
        function consumeElementName() {
          var start = i;
          while (c !== CLOSE_TAG && c !== SLASH && !isWhitespace(c)) {
            next();
          }
          return html.substring(start, i);
        }
        function consumeAttributeName() {
          var start = i;
          while (c !== CLOSE_TAG && c !== SLASH && c !== EQUALS && !isWhitespace(c)) {
            next();
          }
          if (i === start) return undefined;
          return html.substring(start, i);
        }
        function consumeAttributeValue(delim) {
          var start = i;
          while (c !== delim) {
            next();
          }
          var result = html.substring(start, i);
          next();
          return result;
        }
        function consumeAttributes() {
          var attributes = [];
          while (true) {
            skipWhitespace();
            var name = consumeAttributeName();
            var value = undefined;
            if (!name) break;
            var _next = peek();
            if (_next === DOUBLE_QUOTE || _next === SINGLE_QUOTE) {
              skip(2);
              value = decodeHtml(consumeAttributeValue(_next));
            }
            attributes.push(name, value);
          }
          return attributes;
        }
        function consumeScriptStyle(name) {
          // State machine implemented below is based on this description:
          // http://stackoverflow.com/questions/14574471/how-do-browsers-parse-a-script-tag-exactly/14577094#14577094

          var start = i;
          var state = 1;
          // we need to ignore comments within the script tag, i.e. if the </script is within a comment
          var openTagStr = '<' + name;
          var closeTagStr = '</' + name + '>';
          var openComment = function openComment() {
            return {
              action: 'openComment',
              position: html.indexOf('<!--', i)
            };
          };
          var closeComment = function closeComment() {
            return {
              action: 'closeComment',
              position: html.indexOf('-->', i)
            };
          };
          var openTag = function openTag() {
            var from = i;
            var next = function next() {
              var pos = html.indexOf(openTagStr, from);
              if (pos === -1) {
                return {
                  action: 'openTag',
                  position: -1
                };
              }
              var ch = html.charCodeAt(pos + openTagStr.length);
              if (isWhitespace(ch) || ch === CLOSE_TAG) {
                return {
                  action: 'openTag',
                  position: pos
                };
              }
              from = pos + 1;
              return next();
            };
            return next();
          };
          var closeTag = function closeTag() {
            return {
              action: 'closeTag',
              position: html.indexOf(closeTagStr, i)
            };
          };
          var finders = [{
            name: 'openComment',
            fn: openComment
          }, {
            name: 'closeComment',
            fn: closeComment
          }, {
            name: 'openTag',
            fn: openTag
          }, {
            name: 'closeTag',
            fn: closeTag
          }];
          var transitions = {
            // DEFAULT START STATE
            1: {
              closeTag: function closeTag(iPos) {
                // we are done
                state = 0;
                i = iPos;
              },
              openComment: function openComment(iPos) {
                state = 2;
                i = iPos + 1;
              },
              closeComment: function closeComment(iPos) {
                state = 1;
                i = iPos + 1;
              },
              possibleActions: ['closeTag', 'openComment', 'closeComment']
            },
            // OPEN COMMENT STATE
            2: {
              closeTag: function closeTag(iPos) {
                // we are done
                state = 0;
                i = iPos;
              },
              openTag: function openTag(iPos) {
                state = 3;
                i = iPos + 1;
                skipPast(CLOSE_TAG);
              },
              closeComment: function closeComment(iPos) {
                state = 1;
                i = iPos + 1;
              },
              possibleActions: ['closeTag', 'openTag', 'closeComment']
            },
            // INNER TAG STATE
            3: {
              closeComment: function closeComment(iPos) {
                state = 1;
                i = iPos + 1;
              },
              closeTag: function closeTag(iPos) {
                state = 2;
                i = iPos + 1;
                skipPast(CLOSE_TAG);
              },
              possibleActions: ['closeTag', 'closeComment']
            }
          };
          while (state !== 0) {
            var nextAction = finders.filter(function (act) {
              return transitions[state].possibleActions.indexOf(act.name) !== -1;
            }).map(function (f) {
              return f.fn();
            }).filter(function (res) {
              return res.position !== -1;
            }).sort(function (a, b) {
              return a.position - b.position;
            })[0];
            if (!nextAction) {
              i = html.length;
              // No possible next tag was found, probably we searched till the end of file.
              break;
            }
            transitions[state][nextAction.action](nextAction.position);
          }
          emit({
            type: TEXT,
            value: html.substring(start, i)
          });
          skipPast(CLOSE_TAG);
          emit({
            type: END_ELEMENT,
            name: name
          });
        }
        function consumeText() {
          var start = i;
          while (c !== OPEN_TAG) {
            next();
          }
          if (start === i) return undefined;
          return decodeHtml(html.substring(start, i));
        }
        function consumeElement() {
          while (i < max) {
            if (c !== OPEN_TAG) {
              var text = consumeText();
              if (text) {
                emit({
                  type: TEXT,
                  value: text
                });
              }
              continue;
            }
            // we're at a <
            next();
            if (c === SLASH) {
              next();
              var _event = {
                type: END_ELEMENT,
                name: consumeElementName()
              };
              skipPast(CLOSE_TAG);
              if (VOID_ELTS.indexOf(_event.name) < 0) {
                emit(_event);
              }
              continue;
            }
            if (c === BANG) {
              if (peek() == DASH) {
                // <!-- .... -->)
                skip(3);
                var end = html.indexOf('-->', i);
                if (end < 0) {
                  emit({
                    type: COMMENT,
                    value: html.substring(i)
                  });
                  i = max;
                  break;
                }
                var _event2 = {
                  type: COMMENT,
                  value: decodeHtml(html.substring(i, end))
                };
                goto(end + 3);
                emit(_event2);
                continue;
              }
              if (peek() == LEFT_SQUARE_BRACKET) {
                // <![CDATA[ ... ]]>
                skip(8);
                var _end = html.indexOf(']]>', i);
                if (_end < 0) {
                  emit({
                    type: CDATA,
                    value: html.substring(i)
                  });
                  i = max;
                  break;
                }
                var _event3 = {
                  type: CDATA,
                  value: decodeHtml(html.substring(i, _end))
                };
                goto(_end + 3);
                emit(_event3);
                continue;
              }
              // doctype
              skipPast(CLOSE_TAG);
              continue;
            }
            var event = {};
            event.name = consumeElementName(); // already lower case
            event.attributes = consumeAttributes();
            if (c === SLASH) {
              event.type = SELF_CLOSING_ELEMENT;
              skipPast(CLOSE_TAG);
              emit(event);
              continue;
            }
            if (VOID_ELTS.indexOf(event.name) >= 0) {
              event.type = VOID_ELEMENT;
              skipPast(CLOSE_TAG);
              emit(event);
              continue;
            }
            event.type = START_ELEMENT;
            skipPast(CLOSE_TAG);
            emit(event);
            if (event.name === 'script' || event.name == 'style') {
              consumeScriptStyle(event.name);
            }
          }
        }
        consumeElement();
      }
      var DEBUG = false;
      function importIntoDocument(html, document) {
        var stack = [];
        var current = undefined;
        var documentElement = undefined;
        function toDoc(event) {
          if (DEBUG) {
            console.log('parent=' + (current ? current.localName : null) + ' ' + EVENT_NAMES[event.type] + ' ' + JSON.stringify(event));
          }
          if (event.type === START_ELEMENT || event.type === SELF_CLOSING_ELEMENT || event.type === VOID_ELEMENT) {
            var elt = void 0;
            try {
              elt = document.createElement(event.name);
            } catch (e) {
              // webkit can produce names that are invalid
              elt = document.createElement(event.name.replace(/[^a-z0-9\-_:\.]/g, ''));
            }
            for (var i = 0; i < event.attributes.length; i += 2) {
              try {
                var value = event.attributes[i + 1];
                elt.setAttribute(event.attributes[i], /\S/.test(value) ? value : '');
              } catch (e) {
                // webkit can produce names that are invalid
              }
            }
            if (!nodejs) {
              // weird hack to make elt.classList keep the correct case
              var cn = elt.className.trim();
              if (cn && cn.replace(/\s+/g, ' ') !== Array.from(elt.classList).join(' ')) {
                console.warn('Potential DOM issue: className does not tally with classList');
              }
            }
            if (current) {
              current.appendChild(elt);
            } else {
              if (documentElement) {
                throw Error('Redefining document element');
              }
              documentElement = elt;
            }
            if (event.type === START_ELEMENT) {
              stack.push(current);
              if (event.name === 'template') {
                try {
                  elt.content = document.createDocumentFragment();
                } catch (e) {
                  // jsdom only has a getter
                  elt._templateContents = document.createDocumentFragment();
                }
                current = elt.content;
              } else {
                current = elt;
              }
            }
            return;
          }
          if (event.type === END_ELEMENT) {
            current = stack.pop();
            return;
          }
          if (event.type === TEXT || event.type === CDATA) {
            if (current) {
              // ignore text that is unrooted before the do elt
              var node = document.createTextNode(event.value);
              current.appendChild(node);
            }
            return;
          }
          if (event.type === COMMENT) {
            if (current) {
              // ignore comments that are unrooted before the do elt
              var _node = document.createComment(event.value);
              current.appendChild(_node);
            }
            return;
          }
        }
        parse(html, toDoc);
        document.replaceChild(documentElement, document.documentElement);
      }
      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(6));

    /***/
  }, /* 16 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.showLazyImage = showLazyImage;
    exports.showLazyImages = showLazyImages;
    var PROCESSED_ATTRIBUTE = 'processed-for-lazy-images';
    var ALLOWED_LAZY_SRC_ATTRIBUTES = /src(?!set)|lazy|thumb|original|url/i;
    function showLazyImage(el) {
      if (el[PROCESSED_ATTRIBUTE]) return;
      el[PROCESSED_ATTRIBUTE] = true;
      if (!('getAttribute' in el) || el.tagName !== 'IMG') {
        return;
      }
      for (var i = 0; i < el.attributes.length; i++) {
        var attrib = el.attributes[i];
        if (attrib.name === 'srcset' || attrib.name === 'src') continue;

        /*
         We want to check for either 'src', 'original' or 'lazy' in the attribute name
         This is a rough heuristic and we could replace with something better in
        future where we are trying to determine which images are lazy load by
        looking at the # of instances of an image with each src, and assuming
        that any with more than a certain amount of hits are lazy.
         This is more deterministic and will work with known sites on the flip side.
         'datasrc', // BBC
        'data-src', // SOURCEBUG-487
        'original-src', // SOURCEBUG-397
        'data-original', // shop.nordstrom.com
        'data-lazy-src', // realtor.com
        'image-src', // alibaba.com
        'lazysrc', //snapdeal.com
        'lazy-src', // http://www.dinobulk.com/mens-dress-shoes/
        'data-lazyload-src', //producthunt
         */

        // check the name is a candidate
        // perhaps this isn't necessary, not sure how many edge cases there are
        if (ALLOWED_LAZY_SRC_ATTRIBUTES.test(attrib.name)) {
          // check for an absolute URL
          if (attrib.value.startsWith('http:') || attrib.value.startsWith('https:')) {
            el.setAttribute('src', attrib.value);
            return;
          }
        }
      }
    }

    /**
     * Adds a <base> tag to the document with the base path of the given URL.
     * @param {HTMLDocument} doc Document
     * @param {string} url Document URL
     */
    function showLazyImages(doc) {
      Array.from(doc.querySelectorAll('img')).forEach(showLazyImage);
    }

    /***/
  }, /* 17 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    exports.toLabel = toLabel;
    exports.getData = getData;
    exports.getMainItemRuntimeConfig = getMainItemRuntimeConfig;
    exports.getMainItem = getMainItem;
    var _utils = __webpack_require__(1);
    var _extractor = __webpack_require__(3);
    var _entities = __webpack_require__(27);
    var _entities2 = _interopRequireDefault(_entities);
    var _Field = __webpack_require__(7);
    var _Field2 = _interopRequireDefault(_Field);
    var _deepEqual = __webpack_require__(13);
    var _deepEqual2 = _interopRequireDefault(_deepEqual);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    var DEFAULT_WORD_SET_SIMILARITY = 0.8;

    // This doesn't actually use the information from schema.org as the moment
    var isImage = function isImage(label) {
      return /(^|\b|_)(image|thumbnail|logo)(\.?(secure_)?url\b|$)/i.test(label);
    };
    var NO_TEXT_LINK = '(link)';

    /**
     * Convert a dot format data name into a Human Name
     */
    function toLabel(key) {
      var last = void 0;
      var label = key.replace(/^([A-Z][A-Za-z]*\.)+/, '').replace(/[A-Z]{2,}/g, function (x) {
        return x[0] + x.substring(1).toLowerCase();
      }).split(/[\s.]|(?=[A-Z]+)/g).filter(function (x) {
        return x;
      }).map(function (x) {
        if (!x) return x;
        var temp = x[0].toUpperCase() + x.substring(1).toLowerCase();
        if (last == temp) return;
        last = temp;
        return temp;
      }).filter(function (x) {
        return x;
      }).join(' ').replace(/ (Name|Value|Same As)$/, '').replace(/(Offer|Item|Detail|Address|Aggregate)s? /g, '');
      return label;
    }

    /**
     * Add a value into a row for a key
     */
    var add = function add(fieldNames, row, key, value) {
      // don't want these related lists
      if (/(\.|^)(?:reviews?|isSimilarTo|isRelatedTo|suggestedAnswer)\./i.test(key)) {
        return;
      }
      if (!key) return;
      if (!value.text && !value.src) {
        if (value.href) value.text = NO_TEXT_LINK;else return;
      }

      // fix bad nesting
      key = key.replace(/(^|\.)(\w+\.)\1\./g, '$1$2');
      // remove array modifiers .X.
      key = key.replace(/\.\d+/g, '');
      key = key.replace(/URL/g, 'Url');
      if (!row[key]) row[key] = [];else if (key === 'name' && row[key].length === 1) return;
      fieldNames.add(key);

      // protect against
      if (value.text) {
        var re = /^(?:https?:)?\/\/(schema|data-vocabulary).org\//i;
        if (/(^|\.)(item)?(availability|condition)$/i.test(key) || re.test(value.text)) {
          value.text = value.text.replace('_', ' ').replace(re, '').replace(/(\S)([A-Z])/g, '$1 $2').trim().split(/\s+/g).map(function (x) {
            return x[0].toUpperCase() + x.substring(1);
          }).join(' ');
        }
      }
      if (value.src) {
        // bad data cleaning, e.g. https://www.purplle.com/product/maybelline-lasting-drama-gel-liner-black-2-5-g
        value.src = value.src.replace(/^https?:\/\/(https?):\/\//, '$1://');
      }
      row[key].push(value);
    };
    var isUrl = function isUrl(key, value) {
      return isImage(key) || key.endsWith('url') || /^\s*(https?:)?\/\//.test(value) && !/^(?:https?:)?\/\/schema.org\//.test(value);
    };
    var decodeHtml = function decodeHtml(html) {
      return _entities2.default.decodeHTML(html);
    };
    function getData(url, document) {
      if (!document.__extractedMicroData) document.__extractedMicroData = {};else if (document.__extractedMicroData[url]) return document.__extractedMicroData[url];
      var table = {};
      processSchemaDotOrgLDJSON(url, document, table);
      processSchemaDotOrgMicrodata(url, document, table);

      // squash down dupes that
      var types = Object.keys(table);
      types.forEach(function (t) {
        if (!table[t] || !table[t].fieldNames.size) {
          delete table[t];
          return;
        }
        table[t] = dedupe(table[t]);
      });
      processMeta(document, table);
      document.__extractedMicroData[url] = table;
      return table;
    }

    /**
     * Normalize text to UPPER CASE and only word characters
     * Doesn't support unicode
     */
    var norm = function norm(text) {
      return text.replace(/(?:[\0-\x08\x0E-\x1F!-\/:-@\[-\^`\{-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
    };
    function merge(from, to) {
      Object.keys(from).forEach(function (k) {
        if (!to[k]) to[k] = from[k];
      });
    }
    var sw = '\n\nthe\nof\nin\na\nand\nis\nto\nwas\nit\nfor\nthat\nare\nas\nhe\non\nby\nwith\nfrom\nor\nthis\nthey\nbe\nan\nat\nhis\nnot\nalso\nhas\nwere\nwhich\nhave\none\ncan\nbut\nthere\nother\ntheir\nwhen\nhad\nwho\nused\nabout\nsome\nafter\nits\nif\nthem\nup\nthan\nso\nsuch\nthen\ndetails\n';
    var stopWords = new Set(sw.split(/\n/g).map(function (x) {
      return x.trim().toUpperCase();
    }).filter(function (x) {
      return x;
    }));

    /**
     * Word set similarity as a % of input
     * Takes word sets as inputs
     */
    var similarity = function similarity(input, title) {
      var intersection = new Set(Array.from(input).filter(function (x) {
        return title.has(x);
      }));
      return intersection.size / input.size;
    };

    /**
     * 80% similarity required
     * Takes word sets as inputs
     */
    var isSimilar = function isSimilar(input, title) {
      var pct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_WORD_SET_SIMILARITY;

      // require 80% of the words in the microdata to be in the page title
      return similarity(input, title) >= pct;
    };

    /**
     * Convert text to a word set with an optional maximum size
     */
    var toWordSet = function toWordSet(text, size) {
      var split = norm(text).split(/\s+/g).filter(function (x) {
        return !stopWords.has(x);
      });
      if (size) split = split.slice(0, size);
      return new Set(split);
    };

    /**
     * Dedupe a list of rows based on their name.
     * Name isn't always exactly the same in microdata vs ld-json (god knows why)
     * so we use the similarity measure of >= 90% of words being the same
     * TODO: check key values don't differ, like price? Outside chance of false positives
     */
    function dedupe(typedRows) {
      if (!typedRows || !typedRows.rows || typedRows.rows.length <= 1) return typedRows;
      var result = [];
      typedRows.rows.forEach(function (item) {
        if (result.length === 0 || !item.name || !item.name[0].text) {
          result.push(item);
          return;
        }
        var itemName = toWordSet(item.name[0].text);
        for (var i = 0; i < result.length; i++) {
          var comp = result[i];
          if (!comp.name || !comp.name[0].text) continue;
          var compName = toWordSet(comp.name[0].text);
          if (isSimilar(itemName, compName, 0.9)) {
            merge(item, comp);
            return;
          }
        }
        result.push(item);
      });
      return {
        fieldNames: typedRows.fieldNames,
        rows: result
      };
    }

    /**
     * Resolve the name for a row
     */
    function getName(obj) {
      if (obj.name && obj.name.length === 1 && obj.name[0].text && NO_TEXT_LINK !== obj.name[0].text) return obj.name[0].text;
      if (obj.headline && obj.headline.length === 1 && obj.headline[0].text && obj.headline[0].text != NO_TEXT_LINK) return obj.headline[0].text;
    }
    var columnOrder = ['Sku', 'Image', 'Name', 'Description', 'Price', 'Price Currency', 'Availability', 'Rating', 'Rating Count', 'Category'];

    /**
     * Generate a runtime config for the main item on this page.
     * If type is not supplied we guess the type.
     */
    function getMainItemRuntimeConfig(document, type) {
      var item = getMainItem(undefined, document, type);
      if (!item) return;
      type = item['@type'];
      var labels = {},
        map = {};
      var fields = Object.keys(item).map(function (id) {
        if (id[0] === '@' || !item[id] || !item[id].length) return;
        var field = {};
        field.microPath = {
          type: type,
          id: id
        };
        var label = toLabel(id);
        if (!labels[label]) {
          labels[label] = 1;
        } else {
          // if this is the same as the first one we saw - simple dedupe
          if ((0, _deepEqual2.default)(item[id], item[map[label]])) {
            return;
          }
          labels[label]++;
          label += ' (' + labels[label] + ')';
        }
        map[label] = id;
        field.name = label;
        field.type = item[id][0].text ? 'TEXT' : 'IMAGE';
        field.captureLink = !!item[id][0].href;
        return new _Field2.default(field);
      }).filter(function (x) {
        return x;
      }).sort(function (a, b) {
        var iA = columnOrder.indexOf(a.name);
        var iB = columnOrder.indexOf(b.name);
        if (iA < 0) {
          if (iB < 0) {
            return a.name.localeCompare(b.name);
          }
          return 1;
        }
        // iA > 0
        if (iB < 0) {
          return -1;
        }
        return iA - iB;
      });
      return {
        fields: fields,
        singleRecord: true
      };
    }

    /**
     * Generate data for the main item on this page.
     * If type is not supplied we guess the type.
     */
    function getMainItem(url, document, type) {
      if (!document.__extractedMicroDataTypes) {
        document.__extractedMicroDataTypes = {};
      } else {
        if (document.__extractedMicroDataTypes[type] !== undefined) {
          return document.__extractedMicroDataTypes[type];
        }
      }

      // TODO: we could optimize this to not get all the microdata but pre-filter?
      var data = getData(url, document);

      // collapse the data into a single array
      var objects = [];
      Object.keys(data).forEach(function (k) {
        if (type && type !== k || ['meta', 'Breadcrumb', 'BreadcrumbList'].indexOf(k) >= 0) return;
        data[k].rows.forEach(function (row) {
          if (row._descriptor = getName(row)) {
            row['@type'] = k;
            objects.push(row);
          }
        });
      });
      if (objects.length === 0) return;
      var mainItem = function () {
        // If we've only got one of something return that
        if (type && objects.length === 1) return objects[0];

        // Look at opengraph / twitter / page title
        var attrs = ['meta.og.title', 'meta.twitter.title', 'meta.title'];
        var wordsToConsider = 5;
        var _loop = function _loop(i) {
          objects.forEach(function (obj) {
            obj._similarity = 0;
            obj._intersection = 0;
            obj._descriptor = undefined;
          });
          var attrName = attrs[i];
          var attr = data.meta.rows[0][attrName];
          if (!attr) return 'continue';
          var titleText = attr[0].text;
          var title = toWordSet(titleText, wordsToConsider);

          // pick the thing whose name is most similar to the title
          objects.forEach(function (obj) {
            obj._descriptor = getName(obj);
            var ws = toWordSet(obj._descriptor, wordsToConsider);
            obj._similarity = similarity(ws, title) || 0;
            if (titleText.indexOf(obj._descriptor) >= 0) obj._similarity *= 2;
            obj._intersection = ws.size * obj._similarity;
          });
          objects.sort(function (a, b) {
            if (b._intersection !== a._intersection || !a._descriptor) return b._intersection - a._intersection;
            return a._descriptor.length - b._descriptor.length;
          });

          // console.log(JSON.stringify(objects, null, '  '));

          var bestMatch = objects[0];
          if (bestMatch && bestMatch._similarity >= DEFAULT_WORD_SET_SIMILARITY) {
            return {
              v: bestMatch
            };
          }
        };
        for (var i = 0; i < attrs.length; i++) {
          var _ret = _loop(i);
          switch (_ret) {
            case 'continue':
              continue;
            default:
              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
          }
        }
      }();
      objects.forEach(function (obj) {
        delete obj._descriptor;
        delete obj._similarity;
        delete obj._intersection;
      });
      if (mainItem) {
        // specical case here where we want to inject Breadcrumbs into category
        var category = [];
        if (data.BreadcrumbList) {
          category = data.BreadcrumbList.rows.reduce(function (acc, row) {
            if (row['itemListElement.item.name']) acc.push.apply(acc, _toConsumableArray(row['itemListElement.item.name']));
            return acc;
          }, []);
        }
        if (category.length === 0 && data.Breadcrumb) {
          category = data.Breadcrumb.rows.reduce(function (acc, row) {
            if (row.name) acc.push.apply(acc, _toConsumableArray(row.name));
            return acc;
          }, []);
        }
        if (category.length > 0) {
          mainItem.category = category;
        }
      } else {
        mainItem = null;
      }
      document.__extractedMicroDataTypes[type] = mainItem;
      return mainItem;
    }

    /**
     * Adds microdata from the ld-json into the microdata table
     */
    var processSchemaDotOrgLDJSON = function processSchemaDotOrgLDJSON(url, document, table) {
      var ldjson = Array.from(document.querySelectorAll('script[type="application/ld+json"]'));
      ldjson = ldjson.map(function (j) {
        var json = j.innerHTML.trim();
        try {
          return JSON.parse(json);
        } catch (e) {
          try {
            // try to fix stupid inch measurements wrongly encoded (dabs.com) and newlines inside strings
            json = json.replace(/(\d+\s*)"(?!,|\s*[\]}])/g, '$1\\"').replace(/\n/g, ' ');
            return JSON.parse(json);
          } catch (e) {
            console.error('Malformed ld-json found in page, discarding :(');
          }
        }
      }).filter(function (x) {
        return x;
      });
      addToTable(url, table, ldjson);
    };
    var addToTable = function addToTable(url, table, objects) {
      objects.forEach(function (json) {
        var thisRow = {};
        var type = json['@type'];
        if (/^BreadcrumbList$/i.test(type)) {
          try {
            var items = json.itemListElement.map(function (x) {
              return x.item;
            });
            items.forEach(function (item) {
              return item['@type'] = 'Breadcrumb';
            });
            addToTable(url, table, items);
          } catch (e) {
            console.error(e);
          }
          return;
        }
        flattenSingleItemLdJson(url, json, thisRow, fieldNames);
        if (!table[type]) table[type] = {
          rows: [],
          fieldNames: new Set()
        };
        var fieldNames = table[type].fieldNames;
        table[type].rows.push(thisRow);
        Object.keys(thisRow).forEach(function (key) {
          return fieldNames.add(key);
        });
      });
    };

    /**
     * Flatten the ld-json into a 2D table
     */
    var flattenSingleItemLdJson = function flattenSingleItemLdJson(url, item, row, fieldNames, ctx) {
      fieldNames = fieldNames || new Set();
      row = row || {};
      Object.keys(item).forEach(function (key) {
        var array = item[key];
        if (!array) return;
        if (!Array.isArray(array)) array = [array];
        if (key === '@id') {
          if (item.name || !isUrl(key, array[0])) {
            return;
          }
          key = 'url';
        }
        if (key[0] === '@' || key === 'position') return;
        key = ctx ? ctx + '.' + key : key;
        array.forEach(function (value) {
          var href = void 0,
            alt = void 0,
            imageElt = void 0;
          if (value.localName) {
            // is an element
            href = (0, _extractor.getEnclosingLink)(value, url);
            if (value.tagName === 'IMG') {
              imageElt = true;
              alt = value.getAttribute('alt');
            }
            value = toText(url, key, value);
          }
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            // recurse into the item
            flattenSingleItemLdJson(url, value, row, fieldNames, key);
            return;
          }
          var obj = {};
          if (imageElt || isUrl(key, value)) {
            if (url) {
              value = (0, _utils.makeUrlAbsolute)(url, value);
            }
            if (imageElt || isImage(key)) {
              obj.src = value;
              if (alt) obj.alt = alt;
            } else {
              obj.href = value;
            }
          } else {
            obj.text = decodeHtml(value);
            if (key === 'name' && isUrl('@id', item['@id'])) {
              obj.href = item['@id'];
            }
          }
          if (!obj.hef && href) {
            obj.href = href;
          }
          add(fieldNames, row, key, obj);
        });
      });
      return {
        fieldNames: Array.from(fieldNames),
        row: row
      };
    };
    var ELEMENT_TEXT_PROP = {
      meta: 'content',
      audio: 'src',
      embed: 'src',
      iframe: 'src',
      img: 'src',
      source: 'src',
      video: 'src',
      object: 'data',
      time: 'datetime'
    };

    /**
     * Convert an element that has microdata to the text for the microdata
     */
    var toText = function toText(url, name, elem) {
      var attr = elem.hasAttribute('content') ? 'content' : ELEMENT_TEXT_PROP[elem.localName];
      if (!attr) return (0, _utils.textContent)(elem);
      var val = elem[attr] || elem.getAttribute(attr);
      if (val == null) {
        val = '';
      }
      if (val) val = val.replace(/\s+/, ' ').trim();
      if (url && (isUrl(name) || attr === 'src' || attr === 'href')) {
        val = (0, _utils.makeUrlAbsolute)(url, val);
      }
      return val;
    };
    var processSchemaDotOrgMicrodata = function processSchemaDotOrgMicrodata(url, document, table) {
      function microdata(scope) {
        scope = scope || document.documentElement;

        // pick something that either has:

        // (1) @itemtype and @itemprop="mainEntity" or "mainEntityOfPage" - these get wrongly used seemingly
        // (2) @itemtype and not @itemprop - top level entity, not an attribute of another entity
        // (3) @itemtype and @itemprop but no @itemscope above it, excluding the body element

        var candidates = (0, _utils.getElementsByXPath)('//*[@itemtype and ( @itemprop="mainEntity" or @itemprop="mainEntityOfPage" or not(@itemprop) or not(ancestor::*[@itemscope][local-name()!="body"]) ) ]', document.documentElement),
          arr = [];

        // for things which are https://schema.org/ItemList, expand them out into the items
        var elems = [];
        candidates.forEach(function (candidate) {
          var type = candidate.getAttribute('itemtype');
          if (/(?:https?:)?\/\/schema.org\/ListItem/i.test(type)) return;
          if (/(?:https?:)?\/\/schema.org\/BreadcrumbList/i.test(type)) {
            var items = (0, _utils.getElementsByXPath)('.//*[@itemprop="itemListElement"]//*[@itemprop="item"]', candidate);
            items.forEach(function (item) {
              return item.setAttribute('itemtype', 'Breadcrumb');
            });
            elems.push.apply(elems, _toConsumableArray(items));
            return;
          }
          elems.push(candidate);
        });
        for (var i = 0, len = elems.length; i < len; i++) {
          arr.push(extract(elems[i]));
        }
        return arr;
      }
      function extract(scope) {
        var type = scope.getAttribute('itemtype');
        if (type) type = type.trim().replace(/^(?:https?:)?\/\/(schema|data-vocabulary).org\//, '');
        var obj = {
            '@type': type
          },
          elems = Array.from(scope.children);
        var elem = void 0,
          key = void 0;
        while (elem = elems.shift()) {
          if (key = elem.getAttribute('itemprop')) {
            add(obj, key, value(elem));
          }
          // if element is not an itemprop but is an itemscope it's some other "thing"
          if (elem.getAttribute('itemscope') === null) {
            elems.unshift.apply(elems, _toConsumableArray(elem.children));
          }
        }
        return obj;
      }
      function add(obj, key, val) {
        if (!val) return;
        var prop = obj[key];
        if (!prop) obj[key] = val;else if (Array.isArray(prop)) prop.push(val);else obj[key] = [prop, val];
      }
      function value(elem) {
        if (elem.getAttribute('itemscope') !== null) {
          return extract(elem);
        }
        return elem;
      }
      var data = microdata();
      addToTable(url, table, data);
    };
    var processMeta = function processMeta(document, table) {
      var row = {};
      var fieldNames = new Set();
      var addMeta = function addMeta(meta) {
        var oname = meta.getAttribute('name');
        if (!oname) oname = meta.getAttribute('property');
        if (!oname) return;
        var name = 'meta.' + oname.replace(/:/g, '.').toLowerCase();
        var value = meta.getAttribute('content');
        if (value) value = value.replace(/\s+/g, ' ').trim();
        if (!value) return;
        var obj = {};
        if (isUrl(name, value)) {
          if (isImage(name)) {
            obj.src = value;
          } else {
            obj.href = value;
          }
        } else {
          obj.text = value;
        }
        add(fieldNames, row, name, obj);
      };
      var metas = Array.from(document.querySelectorAll('meta[name],meta[property]'));
      metas.forEach(addMeta);
      var title = document.querySelector('title');
      if (title && !row['meta.title']) {
        add(fieldNames, row, 'meta.title', {
          text: title.textContent.trim()
        });
      }
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        add(fieldNames, row, 'link.canonical', {
          href: canonical.getAttribute('href')
        });
      }
      if (fieldNames.size) table.meta = {
        rows: [row],
        fieldNames: fieldNames
      };
    };

    /***/
  }, /* 18 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.findRegions = findRegions;
    exports.getContainingList = getContainingList;
    var _timer = __webpack_require__(5);
    var _utils = __webpack_require__(1);
    var STOP = {
      'IFRAME': 1,
      'PARAM': 1,
      'U': 1,
      'OBJECT': 1,
      'SELECT': 1,
      'STYLE': 1,
      'STRONG': 1,
      'B': 1,
      'SCRIPT': 1,
      'LINK': 1,
      'META': 1,
      'INPUT': 1,
      'OPTION': 1,
      'BR': 1,
      'BUTTON': 1,
      'LABEL': 1
    };
    var getKey = function getKey(element) {
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!element.parentNode) return acc;
      var name = element.nodeType === 3 ? '#text' : element.localName;
      if (!acc) acc = name;else acc = name + ' ' + acc;
      return getKey(element.parentNode, acc);
    };

    // MultiMap<String,Integer>.put
    function addTo(o, s, n) {
      o[s] = n == null ? 1 : (o[s] || 0) + n;
    }
    ;

    // MultiMap<String,Integer>.putAll
    function addAllTo(o, m) {
      for (var s in m) {
        addTo(o, s, m[s]);
      }
    }
    ;

    // (Map|Set|Object).size()
    function sizeOf(o) {
      return Object.keys(o).length;
    }
    ;

    // MultiMap.size()
    function sumOf(o) {
      var c = 0;
      for (var k in o) {
        c += o[k];
      }
      return c;
    }
    ;

    /**
     * Whether or not two styles produced by the region detector are similar
     * enough to be considered the same template
     */
    function similarStyles(s1, s2) {
      var keys = [];
      var count = 0;
      for (var i in s1) {
        if (i === 'size') {
          continue;
        }
        if (i in s2) {
          keys.push(i);
        }
        count++;
      }

      // cache the object sizes
      // TODO: consider using new Map()
      if (s1.size === undefined) s1.size = count;
      if (s2.size === undefined) {
        count = 0;
        for (var _i in s2) {
          if (_i !== 'size') count++;
        } // eslint-disable-line
        s2.size = count;
      }

      // require a 75% match in "styles"
      var required = Math.floor(0.75 * Math.min(s1.size, s2.size));
      var result = keys.length >= required;
      return result;
    }
    var mappedAttributes = new Set(['style', 'itemprop', 'itemscope', 'itemtype', 'typeof', 'property']);

    // qualifying a node by it's environment: level, parent, name, classes, style
    function styleOf(node, level) {
      var style = {};
      if (node.nodeType != 1) return style;
      addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ':');
      for (var i = 0; i < node.attributes.length; i++) {
        var a = node.attributes.item(i);
        if (a.nodeName == 'class') {
          var cs = a.nodeValue.split(/ /);
          for (var c = 0; c < cs.length; c++) {
            if (cs[c].length > 0) {
              addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ': ' + a.nodeName + '=' + cs[c]);
            }
          }
        } else if (mappedAttributes.has(a.nodeName)) {
          addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ': ' + a.nodeName + '=' + a.nodeValue);
        }
      }
      return style;
    }
    ;
    function processRegion(regions, node, level, childTreeStyles) {
      // MultiMap<String,Integer>
      var nodeTreeStyle = {};
      // put all child styles into the bag
      for (var i = 0; i < childTreeStyles.length; i++) {
        addAllTo(nodeTreeStyle, childTreeStyles[i]);
      }
      var region = {
        node: node,
        style: {},
        score: 0
      };
      // remove repeated styles and put them into region.style
      for (var s in nodeTreeStyle) {
        var v = nodeTreeStyle[s];
        if (v > 1) {
          region.style[s] = v;
          delete nodeTreeStyle[s];
        }
      }
      // put back repeated styles as (singular) 'grid' styles, so that repeated grid styles can fire up a region at a higher level
      for (var _s in region.style) {
        addTo(nodeTreeStyle, _s + ' G', 1);
      }
      // remember region if it is a branch (having at least 2 children)
      // score: number of styles * number of occurrence (it's a better score then only one of those)
      // note: this is heuristical. for better scoring we should process text nodes. not sure how slow that would be
      if (childTreeStyles.length >= 1) {
        region.score = sizeOf(region.style) * sumOf(region.style);
        regions.push(region);
      }

      // we only processed the children so far, so also add styles of this node to process in parent levels
      addAllTo(nodeTreeStyle, styleOf(node, level));
      return nodeTreeStyle;
    }
    ;

    // collect to style information top down
    function collectRegions(regions, node, level) {
      var childTreeStyles = [];
      if (!node || STOP[node.tagName]) return {};
      for (var child = node.firstChild; child; child = child.nextSibling) {
        childTreeStyles.push(collectRegions(regions, child, level + 1));
      }
      return processRegion(regions, node, level, childTreeStyles);
    }
    ;
    function findRegions(node) {
      var detectGrids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /*
         The algorithm here is building up a list of "styles"
         {
          "L10 TD A: class=mw-redirect": 256,
          "L10 TD A: G": 512,
          "L10 TD A: class=external G": 505,
          "L10 TD A: class=text G": 505,
          "L9 TR TD: G": 505,
          "L8 TBODY TR:": 505,
          "L10 TD A: class=mw-redirect G": 100,
          "L10 TD A: class=new": 3,
          "L11 SUP A:": 3,
          "L10 TD SUP:": 3,
          "L10 TD SUP: class=reference": 3
        }
         These styles are effectively the repeating structure of the
        HTML below the node.
         The more signals repeat, the more likely it is that we have
        a repeating structure.
         We score the regions by taking the number of repeated styles (N)
        multiplied by the sum of the repeated styles (S)
         Therefore if there are more children the repeated N would be constant
        but S would be linear with the number of children.
         If there is the same number of children but richer similarity S would
        increase.
         We are also interested in the child of the parent node having "similar"
        children. We can judge similarity by the intersection of the styles.
         If no two children of a region have similar styles we should discount
        that region.
         Finally we optionally detect whether or not it looks like there is a
        grid structure on the page and wieth the scores with the square of the total
        number of matching rows.
       */
      var regionNodes = [];
      collectRegions(regionNodes, node.body ? node.body : node, 1);
      if (regionNodes.length === 0) {
        return new Map();
      }
      (0, _timer.time)('findRegions - postprocess');
      regionNodes.sort(function (a, b) {
        return b.score - a.score;
      });

      // TODO: we could put this in collectRegions
      var children = new Map();
      regionNodes.forEach(function (region) {
        var arr = children.get(region.node.parentNode);
        if (!arr) {
          arr = [];
          children.set(region.node.parentNode, arr);
        }
        arr.push(region);
      });
      regionNodes.forEach(function (region) {
        region.children = children.get(region.node) || [];
      });
      // ENDTODO

      // Filter out any regions with a poor score
      var maxScore = regionNodes.reduce(function (max, val) {
        return max < val.score ? val.score : max;
      }, 0);
      var minScore = maxScore < 100 ? 0 : 10;
      regionNodes = regionNodes.filter(function (region) {
        return region.score > minScore;
      });
      // console.log(regionNodes.map( x => x.node.tagName ));

      // Filter out any regions where no children look similar in styles
      var twoSimilar = function twoSimilar(arr) {
        if (arr.length > 50) arr = arr.slice(0, 50);
        return arr.find(function (x) {
          return arr.find(function (y) {
            if (x === y) return false;
            if (y.node.localName !== x.node.localName) return false;
            if (similarStyles(x.style, y.style)) {
              return true;
            }
          });
        });
      };
      regionNodes = regionNodes.filter(function (a) {
        return a.children.length && twoSimilar(a.children);
      });
      // console.log(regionNodes);

      if (detectGrids) {
        // do a grid detection to bind in all the similar regions into a cumulative score

        // partition regionNodes by xpath without positions, e.g. /div/div/div
        var lookup = {};
        regionNodes.forEach(function (region) {
          var key = getKey(region.node);
          if (!lookup[key]) lookup[key] = [];
          lookup[key].push(region);
        });
        var adjustScoreWithoutGridRegions = function adjustScoreWithoutGridRegions(region) {
          region.score *= region.children.length * region.children.length;
          region.linkedRegions = [region];
        };

        // for each set of region nodes in a partition...
        Object.keys(lookup).forEach(function (key) {
          var regions = lookup[key];

          // if there's only one thing in the partition
          if (regions.length === 1) {
            adjustScoreWithoutGridRegions(regions[0]);
            return;
          }

          // partition again, this time based on if the styles are "similar"
          // that would imply that the regions look similar in structure
          var partitions = [];
          regions.forEach(function (region) {
            for (var i = 0; i < partitions.length; i++) {
              var p = partitions[i];
              if (similarStyles(p[0].style, region.style)) {
                p.push(region);
                return;
              }
            }
            partitions.push([region]);
          });
          var gridBoost = 2;
          partitions.forEach(function (partition) {
            // if there's only one partition treat it the same
            if (partition.length == 1) {
              adjustScoreWithoutGridRegions(partition[0]);
              return;
            }

            // adjust score for grid
            var totalScore = partition.reduce(function (sum, region) {
              return sum + region.score;
            }, 0) * gridBoost;
            var totalRows = partition.reduce(function (sum, region) {
              return sum + region.children.length;
            }, 0);
            var score = totalScore * totalRows * totalRows;
            partition.forEach(function (region) {
              region.score = score;
              region.rows = totalRows;
              region.linkedRegions = partition;
            });
          });
        });
      }

      // console.log(regionNodes);

      var map = new Map();
      regionNodes.forEach(function (r) {
        map.set(r.node, r);
      });
      (0, _timer.timeEnd)('findRegions - postprocess');
      return map;
    }
    ;
    function structuralXPath(element, relativeTo) {
      var names = [];
      var el = element;
      while (el !== relativeTo) {
        if (el === el.ownerDocument.documentElement) names.unshift(el.localName);else {
          var c = 1;
          for (var e = el.previousSibling; e; e = e.previousSibling) {
            if (e.localName === el.localName) c++;
          }
          var part = el.localName;
          if (part.indexOf(':') > 0) part = '*[local-name()=\'' + part + '\']';
          // we want the first not to be tied to a position
          if (el.parentNode !== relativeTo) part += '[' + c + ']';
          names.unshift(part);
        }
        el = el.parentNode;
      }
      var sel = './' + names.join('/');
      return sel;
    }
    ;

    /**
     * Return what list element (if any) we think the node is within.
     * We assume that what is clicked is repeated in multiple "rows"
     */
    function getContainingList(clickedElement) {
      var document = clickedElement.ownerDocument;

      // get all the regions on the page
      var regions = findRegions(document, false);

      // initially
      var potentialRegions = [];
      var n = clickedElement.parentNode;
      do {
        var region = regions.get(n);
        if (region) potentialRegions.push(region);
      } while ((n = n.parentNode) !== document.documentElement);

      // sort, best score first
      potentialRegions = potentialRegions.sort(function (a, b) {
        return b.score - a.score;
      });

      // calculate what the xpath is for the clicked element relative to the potential region
      // but generalise it on the first position, i.e. get the xpath for that data element
      // in each list item
      potentialRegions.forEach(function (r) {
        return r.xpath = structuralXPath(clickedElement, r.node);
      });

      // filter the regions such that we only have ones where it looks like more tryWithoutPositionAndId
      // one data points corresponding to the clicked data point exist
      potentialRegions = potentialRegions.filter(function (r) {
        return (0, _utils.getElementsByXPath)(r.xpath, r.node).length > 1;
      });
      if (!potentialRegions.length) return undefined;
      var tbody = potentialRegions.find(function (r) {
        return r.node.tagName === 'TBODY';
      });
      if (tbody) return tbody.node;
      return potentialRegions[0].node;
    }

    /***/
  }, /* 19 */
  /***/function (module, exports) {
    module.exports = {
      "Aacute": "Á",
      "aacute": "á",
      "Abreve": "Ă",
      "abreve": "ă",
      "ac": "∾",
      "acd": "∿",
      "acE": "∾̳",
      "Acirc": "Â",
      "acirc": "â",
      "acute": "´",
      "Acy": "А",
      "acy": "а",
      "AElig": "Æ",
      "aelig": "æ",
      "af": "⁡",
      "Afr": "𝔄",
      "afr": "𝔞",
      "Agrave": "À",
      "agrave": "à",
      "alefsym": "ℵ",
      "aleph": "ℵ",
      "Alpha": "Α",
      "alpha": "α",
      "Amacr": "Ā",
      "amacr": "ā",
      "amalg": "⨿",
      "amp": "&",
      "AMP": "&",
      "andand": "⩕",
      "And": "⩓",
      "and": "∧",
      "andd": "⩜",
      "andslope": "⩘",
      "andv": "⩚",
      "ang": "∠",
      "ange": "⦤",
      "angle": "∠",
      "angmsdaa": "⦨",
      "angmsdab": "⦩",
      "angmsdac": "⦪",
      "angmsdad": "⦫",
      "angmsdae": "⦬",
      "angmsdaf": "⦭",
      "angmsdag": "⦮",
      "angmsdah": "⦯",
      "angmsd": "∡",
      "angrt": "∟",
      "angrtvb": "⊾",
      "angrtvbd": "⦝",
      "angsph": "∢",
      "angst": "Å",
      "angzarr": "⍼",
      "Aogon": "Ą",
      "aogon": "ą",
      "Aopf": "𝔸",
      "aopf": "𝕒",
      "apacir": "⩯",
      "ap": "≈",
      "apE": "⩰",
      "ape": "≊",
      "apid": "≋",
      "apos": "'",
      "ApplyFunction": "⁡",
      "approx": "≈",
      "approxeq": "≊",
      "Aring": "Å",
      "aring": "å",
      "Ascr": "𝒜",
      "ascr": "𝒶",
      "Assign": "≔",
      "ast": "*",
      "asymp": "≈",
      "asympeq": "≍",
      "Atilde": "Ã",
      "atilde": "ã",
      "Auml": "Ä",
      "auml": "ä",
      "awconint": "∳",
      "awint": "⨑",
      "backcong": "≌",
      "backepsilon": "϶",
      "backprime": "‵",
      "backsim": "∽",
      "backsimeq": "⋍",
      "Backslash": "∖",
      "Barv": "⫧",
      "barvee": "⊽",
      "barwed": "⌅",
      "Barwed": "⌆",
      "barwedge": "⌅",
      "bbrk": "⎵",
      "bbrktbrk": "⎶",
      "bcong": "≌",
      "Bcy": "Б",
      "bcy": "б",
      "bdquo": "„",
      "becaus": "∵",
      "because": "∵",
      "Because": "∵",
      "bemptyv": "⦰",
      "bepsi": "϶",
      "bernou": "ℬ",
      "Bernoullis": "ℬ",
      "Beta": "Β",
      "beta": "β",
      "beth": "ℶ",
      "between": "≬",
      "Bfr": "𝔅",
      "bfr": "𝔟",
      "bigcap": "⋂",
      "bigcirc": "◯",
      "bigcup": "⋃",
      "bigodot": "⨀",
      "bigoplus": "⨁",
      "bigotimes": "⨂",
      "bigsqcup": "⨆",
      "bigstar": "★",
      "bigtriangledown": "▽",
      "bigtriangleup": "△",
      "biguplus": "⨄",
      "bigvee": "⋁",
      "bigwedge": "⋀",
      "bkarow": "⤍",
      "blacklozenge": "⧫",
      "blacksquare": "▪",
      "blacktriangle": "▴",
      "blacktriangledown": "▾",
      "blacktriangleleft": "◂",
      "blacktriangleright": "▸",
      "blank": "␣",
      "blk12": "▒",
      "blk14": "░",
      "blk34": "▓",
      "block": "█",
      "bne": "=⃥",
      "bnequiv": "≡⃥",
      "bNot": "⫭",
      "bnot": "⌐",
      "Bopf": "𝔹",
      "bopf": "𝕓",
      "bot": "⊥",
      "bottom": "⊥",
      "bowtie": "⋈",
      "boxbox": "⧉",
      "boxdl": "┐",
      "boxdL": "╕",
      "boxDl": "╖",
      "boxDL": "╗",
      "boxdr": "┌",
      "boxdR": "╒",
      "boxDr": "╓",
      "boxDR": "╔",
      "boxh": "─",
      "boxH": "═",
      "boxhd": "┬",
      "boxHd": "╤",
      "boxhD": "╥",
      "boxHD": "╦",
      "boxhu": "┴",
      "boxHu": "╧",
      "boxhU": "╨",
      "boxHU": "╩",
      "boxminus": "⊟",
      "boxplus": "⊞",
      "boxtimes": "⊠",
      "boxul": "┘",
      "boxuL": "╛",
      "boxUl": "╜",
      "boxUL": "╝",
      "boxur": "└",
      "boxuR": "╘",
      "boxUr": "╙",
      "boxUR": "╚",
      "boxv": "│",
      "boxV": "║",
      "boxvh": "┼",
      "boxvH": "╪",
      "boxVh": "╫",
      "boxVH": "╬",
      "boxvl": "┤",
      "boxvL": "╡",
      "boxVl": "╢",
      "boxVL": "╣",
      "boxvr": "├",
      "boxvR": "╞",
      "boxVr": "╟",
      "boxVR": "╠",
      "bprime": "‵",
      "breve": "˘",
      "Breve": "˘",
      "brvbar": "¦",
      "bscr": "𝒷",
      "Bscr": "ℬ",
      "bsemi": "⁏",
      "bsim": "∽",
      "bsime": "⋍",
      "bsolb": "⧅",
      "bsol": "\\",
      "bsolhsub": "⟈",
      "bull": "•",
      "bullet": "•",
      "bump": "≎",
      "bumpE": "⪮",
      "bumpe": "≏",
      "Bumpeq": "≎",
      "bumpeq": "≏",
      "Cacute": "Ć",
      "cacute": "ć",
      "capand": "⩄",
      "capbrcup": "⩉",
      "capcap": "⩋",
      "cap": "∩",
      "Cap": "⋒",
      "capcup": "⩇",
      "capdot": "⩀",
      "CapitalDifferentialD": "ⅅ",
      "caps": "∩︀",
      "caret": "⁁",
      "caron": "ˇ",
      "Cayleys": "ℭ",
      "ccaps": "⩍",
      "Ccaron": "Č",
      "ccaron": "č",
      "Ccedil": "Ç",
      "ccedil": "ç",
      "Ccirc": "Ĉ",
      "ccirc": "ĉ",
      "Cconint": "∰",
      "ccups": "⩌",
      "ccupssm": "⩐",
      "Cdot": "Ċ",
      "cdot": "ċ",
      "cedil": "¸",
      "Cedilla": "¸",
      "cemptyv": "⦲",
      "cent": "¢",
      "centerdot": "·",
      "CenterDot": "·",
      "cfr": "𝔠",
      "Cfr": "ℭ",
      "CHcy": "Ч",
      "chcy": "ч",
      "check": "✓",
      "checkmark": "✓",
      "Chi": "Χ",
      "chi": "χ",
      "circ": "ˆ",
      "circeq": "≗",
      "circlearrowleft": "↺",
      "circlearrowright": "↻",
      "circledast": "⊛",
      "circledcirc": "⊚",
      "circleddash": "⊝",
      "CircleDot": "⊙",
      "circledR": "®",
      "circledS": "Ⓢ",
      "CircleMinus": "⊖",
      "CirclePlus": "⊕",
      "CircleTimes": "⊗",
      "cir": "○",
      "cirE": "⧃",
      "cire": "≗",
      "cirfnint": "⨐",
      "cirmid": "⫯",
      "cirscir": "⧂",
      "ClockwiseContourIntegral": "∲",
      "CloseCurlyDoubleQuote": "”",
      "CloseCurlyQuote": "’",
      "clubs": "♣",
      "clubsuit": "♣",
      "colon": ":",
      "Colon": "∷",
      "Colone": "⩴",
      "colone": "≔",
      "coloneq": "≔",
      "comma": ",",
      "commat": "@",
      "comp": "∁",
      "compfn": "∘",
      "complement": "∁",
      "complexes": "ℂ",
      "cong": "≅",
      "congdot": "⩭",
      "Congruent": "≡",
      "conint": "∮",
      "Conint": "∯",
      "ContourIntegral": "∮",
      "copf": "𝕔",
      "Copf": "ℂ",
      "coprod": "∐",
      "Coproduct": "∐",
      "copy": "©",
      "COPY": "©",
      "copysr": "℗",
      "CounterClockwiseContourIntegral": "∳",
      "crarr": "↵",
      "cross": "✗",
      "Cross": "⨯",
      "Cscr": "𝒞",
      "cscr": "𝒸",
      "csub": "⫏",
      "csube": "⫑",
      "csup": "⫐",
      "csupe": "⫒",
      "ctdot": "⋯",
      "cudarrl": "⤸",
      "cudarrr": "⤵",
      "cuepr": "⋞",
      "cuesc": "⋟",
      "cularr": "↶",
      "cularrp": "⤽",
      "cupbrcap": "⩈",
      "cupcap": "⩆",
      "CupCap": "≍",
      "cup": "∪",
      "Cup": "⋓",
      "cupcup": "⩊",
      "cupdot": "⊍",
      "cupor": "⩅",
      "cups": "∪︀",
      "curarr": "↷",
      "curarrm": "⤼",
      "curlyeqprec": "⋞",
      "curlyeqsucc": "⋟",
      "curlyvee": "⋎",
      "curlywedge": "⋏",
      "curren": "¤",
      "curvearrowleft": "↶",
      "curvearrowright": "↷",
      "cuvee": "⋎",
      "cuwed": "⋏",
      "cwconint": "∲",
      "cwint": "∱",
      "cylcty": "⌭",
      "dagger": "†",
      "Dagger": "‡",
      "daleth": "ℸ",
      "darr": "↓",
      "Darr": "↡",
      "dArr": "⇓",
      "dash": "‐",
      "Dashv": "⫤",
      "dashv": "⊣",
      "dbkarow": "⤏",
      "dblac": "˝",
      "Dcaron": "Ď",
      "dcaron": "ď",
      "Dcy": "Д",
      "dcy": "д",
      "ddagger": "‡",
      "ddarr": "⇊",
      "DD": "ⅅ",
      "dd": "ⅆ",
      "DDotrahd": "⤑",
      "ddotseq": "⩷",
      "deg": "°",
      "Del": "∇",
      "Delta": "Δ",
      "delta": "δ",
      "demptyv": "⦱",
      "dfisht": "⥿",
      "Dfr": "𝔇",
      "dfr": "𝔡",
      "dHar": "⥥",
      "dharl": "⇃",
      "dharr": "⇂",
      "DiacriticalAcute": "´",
      "DiacriticalDot": "˙",
      "DiacriticalDoubleAcute": "˝",
      "DiacriticalGrave": "`",
      "DiacriticalTilde": "˜",
      "diam": "⋄",
      "diamond": "⋄",
      "Diamond": "⋄",
      "diamondsuit": "♦",
      "diams": "♦",
      "die": "¨",
      "DifferentialD": "ⅆ",
      "digamma": "ϝ",
      "disin": "⋲",
      "div": "÷",
      "divide": "÷",
      "divideontimes": "⋇",
      "divonx": "⋇",
      "DJcy": "Ђ",
      "djcy": "ђ",
      "dlcorn": "⌞",
      "dlcrop": "⌍",
      "dollar": "$",
      "Dopf": "𝔻",
      "dopf": "𝕕",
      "Dot": "¨",
      "dot": "˙",
      "DotDot": "⃜",
      "doteq": "≐",
      "doteqdot": "≑",
      "DotEqual": "≐",
      "dotminus": "∸",
      "dotplus": "∔",
      "dotsquare": "⊡",
      "doublebarwedge": "⌆",
      "DoubleContourIntegral": "∯",
      "DoubleDot": "¨",
      "DoubleDownArrow": "⇓",
      "DoubleLeftArrow": "⇐",
      "DoubleLeftRightArrow": "⇔",
      "DoubleLeftTee": "⫤",
      "DoubleLongLeftArrow": "⟸",
      "DoubleLongLeftRightArrow": "⟺",
      "DoubleLongRightArrow": "⟹",
      "DoubleRightArrow": "⇒",
      "DoubleRightTee": "⊨",
      "DoubleUpArrow": "⇑",
      "DoubleUpDownArrow": "⇕",
      "DoubleVerticalBar": "∥",
      "DownArrowBar": "⤓",
      "downarrow": "↓",
      "DownArrow": "↓",
      "Downarrow": "⇓",
      "DownArrowUpArrow": "⇵",
      "DownBreve": "̑",
      "downdownarrows": "⇊",
      "downharpoonleft": "⇃",
      "downharpoonright": "⇂",
      "DownLeftRightVector": "⥐",
      "DownLeftTeeVector": "⥞",
      "DownLeftVectorBar": "⥖",
      "DownLeftVector": "↽",
      "DownRightTeeVector": "⥟",
      "DownRightVectorBar": "⥗",
      "DownRightVector": "⇁",
      "DownTeeArrow": "↧",
      "DownTee": "⊤",
      "drbkarow": "⤐",
      "drcorn": "⌟",
      "drcrop": "⌌",
      "Dscr": "𝒟",
      "dscr": "𝒹",
      "DScy": "Ѕ",
      "dscy": "ѕ",
      "dsol": "⧶",
      "Dstrok": "Đ",
      "dstrok": "đ",
      "dtdot": "⋱",
      "dtri": "▿",
      "dtrif": "▾",
      "duarr": "⇵",
      "duhar": "⥯",
      "dwangle": "⦦",
      "DZcy": "Џ",
      "dzcy": "џ",
      "dzigrarr": "⟿",
      "Eacute": "É",
      "eacute": "é",
      "easter": "⩮",
      "Ecaron": "Ě",
      "ecaron": "ě",
      "Ecirc": "Ê",
      "ecirc": "ê",
      "ecir": "≖",
      "ecolon": "≕",
      "Ecy": "Э",
      "ecy": "э",
      "eDDot": "⩷",
      "Edot": "Ė",
      "edot": "ė",
      "eDot": "≑",
      "ee": "ⅇ",
      "efDot": "≒",
      "Efr": "𝔈",
      "efr": "𝔢",
      "eg": "⪚",
      "Egrave": "È",
      "egrave": "è",
      "egs": "⪖",
      "egsdot": "⪘",
      "el": "⪙",
      "Element": "∈",
      "elinters": "⏧",
      "ell": "ℓ",
      "els": "⪕",
      "elsdot": "⪗",
      "Emacr": "Ē",
      "emacr": "ē",
      "empty": "∅",
      "emptyset": "∅",
      "EmptySmallSquare": "◻",
      "emptyv": "∅",
      "EmptyVerySmallSquare": "▫",
      "emsp13": " ",
      "emsp14": " ",
      "emsp": " ",
      "ENG": "Ŋ",
      "eng": "ŋ",
      "ensp": " ",
      "Eogon": "Ę",
      "eogon": "ę",
      "Eopf": "𝔼",
      "eopf": "𝕖",
      "epar": "⋕",
      "eparsl": "⧣",
      "eplus": "⩱",
      "epsi": "ε",
      "Epsilon": "Ε",
      "epsilon": "ε",
      "epsiv": "ϵ",
      "eqcirc": "≖",
      "eqcolon": "≕",
      "eqsim": "≂",
      "eqslantgtr": "⪖",
      "eqslantless": "⪕",
      "Equal": "⩵",
      "equals": "=",
      "EqualTilde": "≂",
      "equest": "≟",
      "Equilibrium": "⇌",
      "equiv": "≡",
      "equivDD": "⩸",
      "eqvparsl": "⧥",
      "erarr": "⥱",
      "erDot": "≓",
      "escr": "ℯ",
      "Escr": "ℰ",
      "esdot": "≐",
      "Esim": "⩳",
      "esim": "≂",
      "Eta": "Η",
      "eta": "η",
      "ETH": "Ð",
      "eth": "ð",
      "Euml": "Ë",
      "euml": "ë",
      "euro": "€",
      "excl": "!",
      "exist": "∃",
      "Exists": "∃",
      "expectation": "ℰ",
      "exponentiale": "ⅇ",
      "ExponentialE": "ⅇ",
      "fallingdotseq": "≒",
      "Fcy": "Ф",
      "fcy": "ф",
      "female": "♀",
      "ffilig": "ﬃ",
      "fflig": "ﬀ",
      "ffllig": "ﬄ",
      "Ffr": "𝔉",
      "ffr": "𝔣",
      "filig": "ﬁ",
      "FilledSmallSquare": "◼",
      "FilledVerySmallSquare": "▪",
      "fjlig": "fj",
      "flat": "♭",
      "fllig": "ﬂ",
      "fltns": "▱",
      "fnof": "ƒ",
      "Fopf": "𝔽",
      "fopf": "𝕗",
      "forall": "∀",
      "ForAll": "∀",
      "fork": "⋔",
      "forkv": "⫙",
      "Fouriertrf": "ℱ",
      "fpartint": "⨍",
      "frac12": "½",
      "frac13": "⅓",
      "frac14": "¼",
      "frac15": "⅕",
      "frac16": "⅙",
      "frac18": "⅛",
      "frac23": "⅔",
      "frac25": "⅖",
      "frac34": "¾",
      "frac35": "⅗",
      "frac38": "⅜",
      "frac45": "⅘",
      "frac56": "⅚",
      "frac58": "⅝",
      "frac78": "⅞",
      "frasl": "⁄",
      "frown": "⌢",
      "fscr": "𝒻",
      "Fscr": "ℱ",
      "gacute": "ǵ",
      "Gamma": "Γ",
      "gamma": "γ",
      "Gammad": "Ϝ",
      "gammad": "ϝ",
      "gap": "⪆",
      "Gbreve": "Ğ",
      "gbreve": "ğ",
      "Gcedil": "Ģ",
      "Gcirc": "Ĝ",
      "gcirc": "ĝ",
      "Gcy": "Г",
      "gcy": "г",
      "Gdot": "Ġ",
      "gdot": "ġ",
      "ge": "≥",
      "gE": "≧",
      "gEl": "⪌",
      "gel": "⋛",
      "geq": "≥",
      "geqq": "≧",
      "geqslant": "⩾",
      "gescc": "⪩",
      "ges": "⩾",
      "gesdot": "⪀",
      "gesdoto": "⪂",
      "gesdotol": "⪄",
      "gesl": "⋛︀",
      "gesles": "⪔",
      "Gfr": "𝔊",
      "gfr": "𝔤",
      "gg": "≫",
      "Gg": "⋙",
      "ggg": "⋙",
      "gimel": "ℷ",
      "GJcy": "Ѓ",
      "gjcy": "ѓ",
      "gla": "⪥",
      "gl": "≷",
      "glE": "⪒",
      "glj": "⪤",
      "gnap": "⪊",
      "gnapprox": "⪊",
      "gne": "⪈",
      "gnE": "≩",
      "gneq": "⪈",
      "gneqq": "≩",
      "gnsim": "⋧",
      "Gopf": "𝔾",
      "gopf": "𝕘",
      "grave": "`",
      "GreaterEqual": "≥",
      "GreaterEqualLess": "⋛",
      "GreaterFullEqual": "≧",
      "GreaterGreater": "⪢",
      "GreaterLess": "≷",
      "GreaterSlantEqual": "⩾",
      "GreaterTilde": "≳",
      "Gscr": "𝒢",
      "gscr": "ℊ",
      "gsim": "≳",
      "gsime": "⪎",
      "gsiml": "⪐",
      "gtcc": "⪧",
      "gtcir": "⩺",
      "gt": ">",
      "GT": ">",
      "Gt": "≫",
      "gtdot": "⋗",
      "gtlPar": "⦕",
      "gtquest": "⩼",
      "gtrapprox": "⪆",
      "gtrarr": "⥸",
      "gtrdot": "⋗",
      "gtreqless": "⋛",
      "gtreqqless": "⪌",
      "gtrless": "≷",
      "gtrsim": "≳",
      "gvertneqq": "≩︀",
      "gvnE": "≩︀",
      "Hacek": "ˇ",
      "hairsp": " ",
      "half": "½",
      "hamilt": "ℋ",
      "HARDcy": "Ъ",
      "hardcy": "ъ",
      "harrcir": "⥈",
      "harr": "↔",
      "hArr": "⇔",
      "harrw": "↭",
      "Hat": "^",
      "hbar": "ℏ",
      "Hcirc": "Ĥ",
      "hcirc": "ĥ",
      "hearts": "♥",
      "heartsuit": "♥",
      "hellip": "…",
      "hercon": "⊹",
      "hfr": "𝔥",
      "Hfr": "ℌ",
      "HilbertSpace": "ℋ",
      "hksearow": "⤥",
      "hkswarow": "⤦",
      "hoarr": "⇿",
      "homtht": "∻",
      "hookleftarrow": "↩",
      "hookrightarrow": "↪",
      "hopf": "𝕙",
      "Hopf": "ℍ",
      "horbar": "―",
      "HorizontalLine": "─",
      "hscr": "𝒽",
      "Hscr": "ℋ",
      "hslash": "ℏ",
      "Hstrok": "Ħ",
      "hstrok": "ħ",
      "HumpDownHump": "≎",
      "HumpEqual": "≏",
      "hybull": "⁃",
      "hyphen": "‐",
      "Iacute": "Í",
      "iacute": "í",
      "ic": "⁣",
      "Icirc": "Î",
      "icirc": "î",
      "Icy": "И",
      "icy": "и",
      "Idot": "İ",
      "IEcy": "Е",
      "iecy": "е",
      "iexcl": "¡",
      "iff": "⇔",
      "ifr": "𝔦",
      "Ifr": "ℑ",
      "Igrave": "Ì",
      "igrave": "ì",
      "ii": "ⅈ",
      "iiiint": "⨌",
      "iiint": "∭",
      "iinfin": "⧜",
      "iiota": "℩",
      "IJlig": "Ĳ",
      "ijlig": "ĳ",
      "Imacr": "Ī",
      "imacr": "ī",
      "image": "ℑ",
      "ImaginaryI": "ⅈ",
      "imagline": "ℐ",
      "imagpart": "ℑ",
      "imath": "ı",
      "Im": "ℑ",
      "imof": "⊷",
      "imped": "Ƶ",
      "Implies": "⇒",
      "incare": "℅",
      "in": "∈",
      "infin": "∞",
      "infintie": "⧝",
      "inodot": "ı",
      "intcal": "⊺",
      "int": "∫",
      "Int": "∬",
      "integers": "ℤ",
      "Integral": "∫",
      "intercal": "⊺",
      "Intersection": "⋂",
      "intlarhk": "⨗",
      "intprod": "⨼",
      "InvisibleComma": "⁣",
      "InvisibleTimes": "⁢",
      "IOcy": "Ё",
      "iocy": "ё",
      "Iogon": "Į",
      "iogon": "į",
      "Iopf": "𝕀",
      "iopf": "𝕚",
      "Iota": "Ι",
      "iota": "ι",
      "iprod": "⨼",
      "iquest": "¿",
      "iscr": "𝒾",
      "Iscr": "ℐ",
      "isin": "∈",
      "isindot": "⋵",
      "isinE": "⋹",
      "isins": "⋴",
      "isinsv": "⋳",
      "isinv": "∈",
      "it": "⁢",
      "Itilde": "Ĩ",
      "itilde": "ĩ",
      "Iukcy": "І",
      "iukcy": "і",
      "Iuml": "Ï",
      "iuml": "ï",
      "Jcirc": "Ĵ",
      "jcirc": "ĵ",
      "Jcy": "Й",
      "jcy": "й",
      "Jfr": "𝔍",
      "jfr": "𝔧",
      "jmath": "ȷ",
      "Jopf": "𝕁",
      "jopf": "𝕛",
      "Jscr": "𝒥",
      "jscr": "𝒿",
      "Jsercy": "Ј",
      "jsercy": "ј",
      "Jukcy": "Є",
      "jukcy": "є",
      "Kappa": "Κ",
      "kappa": "κ",
      "kappav": "ϰ",
      "Kcedil": "Ķ",
      "kcedil": "ķ",
      "Kcy": "К",
      "kcy": "к",
      "Kfr": "𝔎",
      "kfr": "𝔨",
      "kgreen": "ĸ",
      "KHcy": "Х",
      "khcy": "х",
      "KJcy": "Ќ",
      "kjcy": "ќ",
      "Kopf": "𝕂",
      "kopf": "𝕜",
      "Kscr": "𝒦",
      "kscr": "𝓀",
      "lAarr": "⇚",
      "Lacute": "Ĺ",
      "lacute": "ĺ",
      "laemptyv": "⦴",
      "lagran": "ℒ",
      "Lambda": "Λ",
      "lambda": "λ",
      "lang": "⟨",
      "Lang": "⟪",
      "langd": "⦑",
      "langle": "⟨",
      "lap": "⪅",
      "Laplacetrf": "ℒ",
      "laquo": "«",
      "larrb": "⇤",
      "larrbfs": "⤟",
      "larr": "←",
      "Larr": "↞",
      "lArr": "⇐",
      "larrfs": "⤝",
      "larrhk": "↩",
      "larrlp": "↫",
      "larrpl": "⤹",
      "larrsim": "⥳",
      "larrtl": "↢",
      "latail": "⤙",
      "lAtail": "⤛",
      "lat": "⪫",
      "late": "⪭",
      "lates": "⪭︀",
      "lbarr": "⤌",
      "lBarr": "⤎",
      "lbbrk": "❲",
      "lbrace": "{",
      "lbrack": "[",
      "lbrke": "⦋",
      "lbrksld": "⦏",
      "lbrkslu": "⦍",
      "Lcaron": "Ľ",
      "lcaron": "ľ",
      "Lcedil": "Ļ",
      "lcedil": "ļ",
      "lceil": "⌈",
      "lcub": "{",
      "Lcy": "Л",
      "lcy": "л",
      "ldca": "⤶",
      "ldquo": "“",
      "ldquor": "„",
      "ldrdhar": "⥧",
      "ldrushar": "⥋",
      "ldsh": "↲",
      "le": "≤",
      "lE": "≦",
      "LeftAngleBracket": "⟨",
      "LeftArrowBar": "⇤",
      "leftarrow": "←",
      "LeftArrow": "←",
      "Leftarrow": "⇐",
      "LeftArrowRightArrow": "⇆",
      "leftarrowtail": "↢",
      "LeftCeiling": "⌈",
      "LeftDoubleBracket": "⟦",
      "LeftDownTeeVector": "⥡",
      "LeftDownVectorBar": "⥙",
      "LeftDownVector": "⇃",
      "LeftFloor": "⌊",
      "leftharpoondown": "↽",
      "leftharpoonup": "↼",
      "leftleftarrows": "⇇",
      "leftrightarrow": "↔",
      "LeftRightArrow": "↔",
      "Leftrightarrow": "⇔",
      "leftrightarrows": "⇆",
      "leftrightharpoons": "⇋",
      "leftrightsquigarrow": "↭",
      "LeftRightVector": "⥎",
      "LeftTeeArrow": "↤",
      "LeftTee": "⊣",
      "LeftTeeVector": "⥚",
      "leftthreetimes": "⋋",
      "LeftTriangleBar": "⧏",
      "LeftTriangle": "⊲",
      "LeftTriangleEqual": "⊴",
      "LeftUpDownVector": "⥑",
      "LeftUpTeeVector": "⥠",
      "LeftUpVectorBar": "⥘",
      "LeftUpVector": "↿",
      "LeftVectorBar": "⥒",
      "LeftVector": "↼",
      "lEg": "⪋",
      "leg": "⋚",
      "leq": "≤",
      "leqq": "≦",
      "leqslant": "⩽",
      "lescc": "⪨",
      "les": "⩽",
      "lesdot": "⩿",
      "lesdoto": "⪁",
      "lesdotor": "⪃",
      "lesg": "⋚︀",
      "lesges": "⪓",
      "lessapprox": "⪅",
      "lessdot": "⋖",
      "lesseqgtr": "⋚",
      "lesseqqgtr": "⪋",
      "LessEqualGreater": "⋚",
      "LessFullEqual": "≦",
      "LessGreater": "≶",
      "lessgtr": "≶",
      "LessLess": "⪡",
      "lesssim": "≲",
      "LessSlantEqual": "⩽",
      "LessTilde": "≲",
      "lfisht": "⥼",
      "lfloor": "⌊",
      "Lfr": "𝔏",
      "lfr": "𝔩",
      "lg": "≶",
      "lgE": "⪑",
      "lHar": "⥢",
      "lhard": "↽",
      "lharu": "↼",
      "lharul": "⥪",
      "lhblk": "▄",
      "LJcy": "Љ",
      "ljcy": "љ",
      "llarr": "⇇",
      "ll": "≪",
      "Ll": "⋘",
      "llcorner": "⌞",
      "Lleftarrow": "⇚",
      "llhard": "⥫",
      "lltri": "◺",
      "Lmidot": "Ŀ",
      "lmidot": "ŀ",
      "lmoustache": "⎰",
      "lmoust": "⎰",
      "lnap": "⪉",
      "lnapprox": "⪉",
      "lne": "⪇",
      "lnE": "≨",
      "lneq": "⪇",
      "lneqq": "≨",
      "lnsim": "⋦",
      "loang": "⟬",
      "loarr": "⇽",
      "lobrk": "⟦",
      "longleftarrow": "⟵",
      "LongLeftArrow": "⟵",
      "Longleftarrow": "⟸",
      "longleftrightarrow": "⟷",
      "LongLeftRightArrow": "⟷",
      "Longleftrightarrow": "⟺",
      "longmapsto": "⟼",
      "longrightarrow": "⟶",
      "LongRightArrow": "⟶",
      "Longrightarrow": "⟹",
      "looparrowleft": "↫",
      "looparrowright": "↬",
      "lopar": "⦅",
      "Lopf": "𝕃",
      "lopf": "𝕝",
      "loplus": "⨭",
      "lotimes": "⨴",
      "lowast": "∗",
      "lowbar": "_",
      "LowerLeftArrow": "↙",
      "LowerRightArrow": "↘",
      "loz": "◊",
      "lozenge": "◊",
      "lozf": "⧫",
      "lpar": "(",
      "lparlt": "⦓",
      "lrarr": "⇆",
      "lrcorner": "⌟",
      "lrhar": "⇋",
      "lrhard": "⥭",
      "lrm": "‎",
      "lrtri": "⊿",
      "lsaquo": "‹",
      "lscr": "𝓁",
      "Lscr": "ℒ",
      "lsh": "↰",
      "Lsh": "↰",
      "lsim": "≲",
      "lsime": "⪍",
      "lsimg": "⪏",
      "lsqb": "[",
      "lsquo": "‘",
      "lsquor": "‚",
      "Lstrok": "Ł",
      "lstrok": "ł",
      "ltcc": "⪦",
      "ltcir": "⩹",
      "lt": "<",
      "LT": "<",
      "Lt": "≪",
      "ltdot": "⋖",
      "lthree": "⋋",
      "ltimes": "⋉",
      "ltlarr": "⥶",
      "ltquest": "⩻",
      "ltri": "◃",
      "ltrie": "⊴",
      "ltrif": "◂",
      "ltrPar": "⦖",
      "lurdshar": "⥊",
      "luruhar": "⥦",
      "lvertneqq": "≨︀",
      "lvnE": "≨︀",
      "macr": "¯",
      "male": "♂",
      "malt": "✠",
      "maltese": "✠",
      "Map": "⤅",
      "map": "↦",
      "mapsto": "↦",
      "mapstodown": "↧",
      "mapstoleft": "↤",
      "mapstoup": "↥",
      "marker": "▮",
      "mcomma": "⨩",
      "Mcy": "М",
      "mcy": "м",
      "mdash": "—",
      "mDDot": "∺",
      "measuredangle": "∡",
      "MediumSpace": " ",
      "Mellintrf": "ℳ",
      "Mfr": "𝔐",
      "mfr": "𝔪",
      "mho": "℧",
      "micro": "µ",
      "midast": "*",
      "midcir": "⫰",
      "mid": "∣",
      "middot": "·",
      "minusb": "⊟",
      "minus": "−",
      "minusd": "∸",
      "minusdu": "⨪",
      "MinusPlus": "∓",
      "mlcp": "⫛",
      "mldr": "…",
      "mnplus": "∓",
      "models": "⊧",
      "Mopf": "𝕄",
      "mopf": "𝕞",
      "mp": "∓",
      "mscr": "𝓂",
      "Mscr": "ℳ",
      "mstpos": "∾",
      "Mu": "Μ",
      "mu": "μ",
      "multimap": "⊸",
      "mumap": "⊸",
      "nabla": "∇",
      "Nacute": "Ń",
      "nacute": "ń",
      "nang": "∠⃒",
      "nap": "≉",
      "napE": "⩰̸",
      "napid": "≋̸",
      "napos": "ŉ",
      "napprox": "≉",
      "natural": "♮",
      "naturals": "ℕ",
      "natur": "♮",
      "nbsp": " ",
      "nbump": "≎̸",
      "nbumpe": "≏̸",
      "ncap": "⩃",
      "Ncaron": "Ň",
      "ncaron": "ň",
      "Ncedil": "Ņ",
      "ncedil": "ņ",
      "ncong": "≇",
      "ncongdot": "⩭̸",
      "ncup": "⩂",
      "Ncy": "Н",
      "ncy": "н",
      "ndash": "–",
      "nearhk": "⤤",
      "nearr": "↗",
      "neArr": "⇗",
      "nearrow": "↗",
      "ne": "≠",
      "nedot": "≐̸",
      "NegativeMediumSpace": "​",
      "NegativeThickSpace": "​",
      "NegativeThinSpace": "​",
      "NegativeVeryThinSpace": "​",
      "nequiv": "≢",
      "nesear": "⤨",
      "nesim": "≂̸",
      "NestedGreaterGreater": "≫",
      "NestedLessLess": "≪",
      "NewLine": "\n",
      "nexist": "∄",
      "nexists": "∄",
      "Nfr": "𝔑",
      "nfr": "𝔫",
      "ngE": "≧̸",
      "nge": "≱",
      "ngeq": "≱",
      "ngeqq": "≧̸",
      "ngeqslant": "⩾̸",
      "nges": "⩾̸",
      "nGg": "⋙̸",
      "ngsim": "≵",
      "nGt": "≫⃒",
      "ngt": "≯",
      "ngtr": "≯",
      "nGtv": "≫̸",
      "nharr": "↮",
      "nhArr": "⇎",
      "nhpar": "⫲",
      "ni": "∋",
      "nis": "⋼",
      "nisd": "⋺",
      "niv": "∋",
      "NJcy": "Њ",
      "njcy": "њ",
      "nlarr": "↚",
      "nlArr": "⇍",
      "nldr": "‥",
      "nlE": "≦̸",
      "nle": "≰",
      "nleftarrow": "↚",
      "nLeftarrow": "⇍",
      "nleftrightarrow": "↮",
      "nLeftrightarrow": "⇎",
      "nleq": "≰",
      "nleqq": "≦̸",
      "nleqslant": "⩽̸",
      "nles": "⩽̸",
      "nless": "≮",
      "nLl": "⋘̸",
      "nlsim": "≴",
      "nLt": "≪⃒",
      "nlt": "≮",
      "nltri": "⋪",
      "nltrie": "⋬",
      "nLtv": "≪̸",
      "nmid": "∤",
      "NoBreak": "⁠",
      "NonBreakingSpace": " ",
      "nopf": "𝕟",
      "Nopf": "ℕ",
      "Not": "⫬",
      "not": "¬",
      "NotCongruent": "≢",
      "NotCupCap": "≭",
      "NotDoubleVerticalBar": "∦",
      "NotElement": "∉",
      "NotEqual": "≠",
      "NotEqualTilde": "≂̸",
      "NotExists": "∄",
      "NotGreater": "≯",
      "NotGreaterEqual": "≱",
      "NotGreaterFullEqual": "≧̸",
      "NotGreaterGreater": "≫̸",
      "NotGreaterLess": "≹",
      "NotGreaterSlantEqual": "⩾̸",
      "NotGreaterTilde": "≵",
      "NotHumpDownHump": "≎̸",
      "NotHumpEqual": "≏̸",
      "notin": "∉",
      "notindot": "⋵̸",
      "notinE": "⋹̸",
      "notinva": "∉",
      "notinvb": "⋷",
      "notinvc": "⋶",
      "NotLeftTriangleBar": "⧏̸",
      "NotLeftTriangle": "⋪",
      "NotLeftTriangleEqual": "⋬",
      "NotLess": "≮",
      "NotLessEqual": "≰",
      "NotLessGreater": "≸",
      "NotLessLess": "≪̸",
      "NotLessSlantEqual": "⩽̸",
      "NotLessTilde": "≴",
      "NotNestedGreaterGreater": "⪢̸",
      "NotNestedLessLess": "⪡̸",
      "notni": "∌",
      "notniva": "∌",
      "notnivb": "⋾",
      "notnivc": "⋽",
      "NotPrecedes": "⊀",
      "NotPrecedesEqual": "⪯̸",
      "NotPrecedesSlantEqual": "⋠",
      "NotReverseElement": "∌",
      "NotRightTriangleBar": "⧐̸",
      "NotRightTriangle": "⋫",
      "NotRightTriangleEqual": "⋭",
      "NotSquareSubset": "⊏̸",
      "NotSquareSubsetEqual": "⋢",
      "NotSquareSuperset": "⊐̸",
      "NotSquareSupersetEqual": "⋣",
      "NotSubset": "⊂⃒",
      "NotSubsetEqual": "⊈",
      "NotSucceeds": "⊁",
      "NotSucceedsEqual": "⪰̸",
      "NotSucceedsSlantEqual": "⋡",
      "NotSucceedsTilde": "≿̸",
      "NotSuperset": "⊃⃒",
      "NotSupersetEqual": "⊉",
      "NotTilde": "≁",
      "NotTildeEqual": "≄",
      "NotTildeFullEqual": "≇",
      "NotTildeTilde": "≉",
      "NotVerticalBar": "∤",
      "nparallel": "∦",
      "npar": "∦",
      "nparsl": "⫽⃥",
      "npart": "∂̸",
      "npolint": "⨔",
      "npr": "⊀",
      "nprcue": "⋠",
      "nprec": "⊀",
      "npreceq": "⪯̸",
      "npre": "⪯̸",
      "nrarrc": "⤳̸",
      "nrarr": "↛",
      "nrArr": "⇏",
      "nrarrw": "↝̸",
      "nrightarrow": "↛",
      "nRightarrow": "⇏",
      "nrtri": "⋫",
      "nrtrie": "⋭",
      "nsc": "⊁",
      "nsccue": "⋡",
      "nsce": "⪰̸",
      "Nscr": "𝒩",
      "nscr": "𝓃",
      "nshortmid": "∤",
      "nshortparallel": "∦",
      "nsim": "≁",
      "nsime": "≄",
      "nsimeq": "≄",
      "nsmid": "∤",
      "nspar": "∦",
      "nsqsube": "⋢",
      "nsqsupe": "⋣",
      "nsub": "⊄",
      "nsubE": "⫅̸",
      "nsube": "⊈",
      "nsubset": "⊂⃒",
      "nsubseteq": "⊈",
      "nsubseteqq": "⫅̸",
      "nsucc": "⊁",
      "nsucceq": "⪰̸",
      "nsup": "⊅",
      "nsupE": "⫆̸",
      "nsupe": "⊉",
      "nsupset": "⊃⃒",
      "nsupseteq": "⊉",
      "nsupseteqq": "⫆̸",
      "ntgl": "≹",
      "Ntilde": "Ñ",
      "ntilde": "ñ",
      "ntlg": "≸",
      "ntriangleleft": "⋪",
      "ntrianglelefteq": "⋬",
      "ntriangleright": "⋫",
      "ntrianglerighteq": "⋭",
      "Nu": "Ν",
      "nu": "ν",
      "num": "#",
      "numero": "№",
      "numsp": " ",
      "nvap": "≍⃒",
      "nvdash": "⊬",
      "nvDash": "⊭",
      "nVdash": "⊮",
      "nVDash": "⊯",
      "nvge": "≥⃒",
      "nvgt": ">⃒",
      "nvHarr": "⤄",
      "nvinfin": "⧞",
      "nvlArr": "⤂",
      "nvle": "≤⃒",
      "nvlt": "<⃒",
      "nvltrie": "⊴⃒",
      "nvrArr": "⤃",
      "nvrtrie": "⊵⃒",
      "nvsim": "∼⃒",
      "nwarhk": "⤣",
      "nwarr": "↖",
      "nwArr": "⇖",
      "nwarrow": "↖",
      "nwnear": "⤧",
      "Oacute": "Ó",
      "oacute": "ó",
      "oast": "⊛",
      "Ocirc": "Ô",
      "ocirc": "ô",
      "ocir": "⊚",
      "Ocy": "О",
      "ocy": "о",
      "odash": "⊝",
      "Odblac": "Ő",
      "odblac": "ő",
      "odiv": "⨸",
      "odot": "⊙",
      "odsold": "⦼",
      "OElig": "Œ",
      "oelig": "œ",
      "ofcir": "⦿",
      "Ofr": "𝔒",
      "ofr": "𝔬",
      "ogon": "˛",
      "Ograve": "Ò",
      "ograve": "ò",
      "ogt": "⧁",
      "ohbar": "⦵",
      "ohm": "Ω",
      "oint": "∮",
      "olarr": "↺",
      "olcir": "⦾",
      "olcross": "⦻",
      "oline": "‾",
      "olt": "⧀",
      "Omacr": "Ō",
      "omacr": "ō",
      "Omega": "Ω",
      "omega": "ω",
      "Omicron": "Ο",
      "omicron": "ο",
      "omid": "⦶",
      "ominus": "⊖",
      "Oopf": "𝕆",
      "oopf": "𝕠",
      "opar": "⦷",
      "OpenCurlyDoubleQuote": "“",
      "OpenCurlyQuote": "‘",
      "operp": "⦹",
      "oplus": "⊕",
      "orarr": "↻",
      "Or": "⩔",
      "or": "∨",
      "ord": "⩝",
      "order": "ℴ",
      "orderof": "ℴ",
      "ordf": "ª",
      "ordm": "º",
      "origof": "⊶",
      "oror": "⩖",
      "orslope": "⩗",
      "orv": "⩛",
      "oS": "Ⓢ",
      "Oscr": "𝒪",
      "oscr": "ℴ",
      "Oslash": "Ø",
      "oslash": "ø",
      "osol": "⊘",
      "Otilde": "Õ",
      "otilde": "õ",
      "otimesas": "⨶",
      "Otimes": "⨷",
      "otimes": "⊗",
      "Ouml": "Ö",
      "ouml": "ö",
      "ovbar": "⌽",
      "OverBar": "‾",
      "OverBrace": "⏞",
      "OverBracket": "⎴",
      "OverParenthesis": "⏜",
      "para": "¶",
      "parallel": "∥",
      "par": "∥",
      "parsim": "⫳",
      "parsl": "⫽",
      "part": "∂",
      "PartialD": "∂",
      "Pcy": "П",
      "pcy": "п",
      "percnt": "%",
      "period": ".",
      "permil": "‰",
      "perp": "⊥",
      "pertenk": "‱",
      "Pfr": "𝔓",
      "pfr": "𝔭",
      "Phi": "Φ",
      "phi": "φ",
      "phiv": "ϕ",
      "phmmat": "ℳ",
      "phone": "☎",
      "Pi": "Π",
      "pi": "π",
      "pitchfork": "⋔",
      "piv": "ϖ",
      "planck": "ℏ",
      "planckh": "ℎ",
      "plankv": "ℏ",
      "plusacir": "⨣",
      "plusb": "⊞",
      "pluscir": "⨢",
      "plus": "+",
      "plusdo": "∔",
      "plusdu": "⨥",
      "pluse": "⩲",
      "PlusMinus": "±",
      "plusmn": "±",
      "plussim": "⨦",
      "plustwo": "⨧",
      "pm": "±",
      "Poincareplane": "ℌ",
      "pointint": "⨕",
      "popf": "𝕡",
      "Popf": "ℙ",
      "pound": "£",
      "prap": "⪷",
      "Pr": "⪻",
      "pr": "≺",
      "prcue": "≼",
      "precapprox": "⪷",
      "prec": "≺",
      "preccurlyeq": "≼",
      "Precedes": "≺",
      "PrecedesEqual": "⪯",
      "PrecedesSlantEqual": "≼",
      "PrecedesTilde": "≾",
      "preceq": "⪯",
      "precnapprox": "⪹",
      "precneqq": "⪵",
      "precnsim": "⋨",
      "pre": "⪯",
      "prE": "⪳",
      "precsim": "≾",
      "prime": "′",
      "Prime": "″",
      "primes": "ℙ",
      "prnap": "⪹",
      "prnE": "⪵",
      "prnsim": "⋨",
      "prod": "∏",
      "Product": "∏",
      "profalar": "⌮",
      "profline": "⌒",
      "profsurf": "⌓",
      "prop": "∝",
      "Proportional": "∝",
      "Proportion": "∷",
      "propto": "∝",
      "prsim": "≾",
      "prurel": "⊰",
      "Pscr": "𝒫",
      "pscr": "𝓅",
      "Psi": "Ψ",
      "psi": "ψ",
      "puncsp": " ",
      "Qfr": "𝔔",
      "qfr": "𝔮",
      "qint": "⨌",
      "qopf": "𝕢",
      "Qopf": "ℚ",
      "qprime": "⁗",
      "Qscr": "𝒬",
      "qscr": "𝓆",
      "quaternions": "ℍ",
      "quatint": "⨖",
      "quest": "?",
      "questeq": "≟",
      "quot": "\"",
      "QUOT": "\"",
      "rAarr": "⇛",
      "race": "∽̱",
      "Racute": "Ŕ",
      "racute": "ŕ",
      "radic": "√",
      "raemptyv": "⦳",
      "rang": "⟩",
      "Rang": "⟫",
      "rangd": "⦒",
      "range": "⦥",
      "rangle": "⟩",
      "raquo": "»",
      "rarrap": "⥵",
      "rarrb": "⇥",
      "rarrbfs": "⤠",
      "rarrc": "⤳",
      "rarr": "→",
      "Rarr": "↠",
      "rArr": "⇒",
      "rarrfs": "⤞",
      "rarrhk": "↪",
      "rarrlp": "↬",
      "rarrpl": "⥅",
      "rarrsim": "⥴",
      "Rarrtl": "⤖",
      "rarrtl": "↣",
      "rarrw": "↝",
      "ratail": "⤚",
      "rAtail": "⤜",
      "ratio": "∶",
      "rationals": "ℚ",
      "rbarr": "⤍",
      "rBarr": "⤏",
      "RBarr": "⤐",
      "rbbrk": "❳",
      "rbrace": "}",
      "rbrack": "]",
      "rbrke": "⦌",
      "rbrksld": "⦎",
      "rbrkslu": "⦐",
      "Rcaron": "Ř",
      "rcaron": "ř",
      "Rcedil": "Ŗ",
      "rcedil": "ŗ",
      "rceil": "⌉",
      "rcub": "}",
      "Rcy": "Р",
      "rcy": "р",
      "rdca": "⤷",
      "rdldhar": "⥩",
      "rdquo": "”",
      "rdquor": "”",
      "rdsh": "↳",
      "real": "ℜ",
      "realine": "ℛ",
      "realpart": "ℜ",
      "reals": "ℝ",
      "Re": "ℜ",
      "rect": "▭",
      "reg": "®",
      "REG": "®",
      "ReverseElement": "∋",
      "ReverseEquilibrium": "⇋",
      "ReverseUpEquilibrium": "⥯",
      "rfisht": "⥽",
      "rfloor": "⌋",
      "rfr": "𝔯",
      "Rfr": "ℜ",
      "rHar": "⥤",
      "rhard": "⇁",
      "rharu": "⇀",
      "rharul": "⥬",
      "Rho": "Ρ",
      "rho": "ρ",
      "rhov": "ϱ",
      "RightAngleBracket": "⟩",
      "RightArrowBar": "⇥",
      "rightarrow": "→",
      "RightArrow": "→",
      "Rightarrow": "⇒",
      "RightArrowLeftArrow": "⇄",
      "rightarrowtail": "↣",
      "RightCeiling": "⌉",
      "RightDoubleBracket": "⟧",
      "RightDownTeeVector": "⥝",
      "RightDownVectorBar": "⥕",
      "RightDownVector": "⇂",
      "RightFloor": "⌋",
      "rightharpoondown": "⇁",
      "rightharpoonup": "⇀",
      "rightleftarrows": "⇄",
      "rightleftharpoons": "⇌",
      "rightrightarrows": "⇉",
      "rightsquigarrow": "↝",
      "RightTeeArrow": "↦",
      "RightTee": "⊢",
      "RightTeeVector": "⥛",
      "rightthreetimes": "⋌",
      "RightTriangleBar": "⧐",
      "RightTriangle": "⊳",
      "RightTriangleEqual": "⊵",
      "RightUpDownVector": "⥏",
      "RightUpTeeVector": "⥜",
      "RightUpVectorBar": "⥔",
      "RightUpVector": "↾",
      "RightVectorBar": "⥓",
      "RightVector": "⇀",
      "ring": "˚",
      "risingdotseq": "≓",
      "rlarr": "⇄",
      "rlhar": "⇌",
      "rlm": "‏",
      "rmoustache": "⎱",
      "rmoust": "⎱",
      "rnmid": "⫮",
      "roang": "⟭",
      "roarr": "⇾",
      "robrk": "⟧",
      "ropar": "⦆",
      "ropf": "𝕣",
      "Ropf": "ℝ",
      "roplus": "⨮",
      "rotimes": "⨵",
      "RoundImplies": "⥰",
      "rpar": ")",
      "rpargt": "⦔",
      "rppolint": "⨒",
      "rrarr": "⇉",
      "Rrightarrow": "⇛",
      "rsaquo": "›",
      "rscr": "𝓇",
      "Rscr": "ℛ",
      "rsh": "↱",
      "Rsh": "↱",
      "rsqb": "]",
      "rsquo": "’",
      "rsquor": "’",
      "rthree": "⋌",
      "rtimes": "⋊",
      "rtri": "▹",
      "rtrie": "⊵",
      "rtrif": "▸",
      "rtriltri": "⧎",
      "RuleDelayed": "⧴",
      "ruluhar": "⥨",
      "rx": "℞",
      "Sacute": "Ś",
      "sacute": "ś",
      "sbquo": "‚",
      "scap": "⪸",
      "Scaron": "Š",
      "scaron": "š",
      "Sc": "⪼",
      "sc": "≻",
      "sccue": "≽",
      "sce": "⪰",
      "scE": "⪴",
      "Scedil": "Ş",
      "scedil": "ş",
      "Scirc": "Ŝ",
      "scirc": "ŝ",
      "scnap": "⪺",
      "scnE": "⪶",
      "scnsim": "⋩",
      "scpolint": "⨓",
      "scsim": "≿",
      "Scy": "С",
      "scy": "с",
      "sdotb": "⊡",
      "sdot": "⋅",
      "sdote": "⩦",
      "searhk": "⤥",
      "searr": "↘",
      "seArr": "⇘",
      "searrow": "↘",
      "sect": "§",
      "semi": ";",
      "seswar": "⤩",
      "setminus": "∖",
      "setmn": "∖",
      "sext": "✶",
      "Sfr": "𝔖",
      "sfr": "𝔰",
      "sfrown": "⌢",
      "sharp": "♯",
      "SHCHcy": "Щ",
      "shchcy": "щ",
      "SHcy": "Ш",
      "shcy": "ш",
      "ShortDownArrow": "↓",
      "ShortLeftArrow": "←",
      "shortmid": "∣",
      "shortparallel": "∥",
      "ShortRightArrow": "→",
      "ShortUpArrow": "↑",
      "shy": "­",
      "Sigma": "Σ",
      "sigma": "σ",
      "sigmaf": "ς",
      "sigmav": "ς",
      "sim": "∼",
      "simdot": "⩪",
      "sime": "≃",
      "simeq": "≃",
      "simg": "⪞",
      "simgE": "⪠",
      "siml": "⪝",
      "simlE": "⪟",
      "simne": "≆",
      "simplus": "⨤",
      "simrarr": "⥲",
      "slarr": "←",
      "SmallCircle": "∘",
      "smallsetminus": "∖",
      "smashp": "⨳",
      "smeparsl": "⧤",
      "smid": "∣",
      "smile": "⌣",
      "smt": "⪪",
      "smte": "⪬",
      "smtes": "⪬︀",
      "SOFTcy": "Ь",
      "softcy": "ь",
      "solbar": "⌿",
      "solb": "⧄",
      "sol": "/",
      "Sopf": "𝕊",
      "sopf": "𝕤",
      "spades": "♠",
      "spadesuit": "♠",
      "spar": "∥",
      "sqcap": "⊓",
      "sqcaps": "⊓︀",
      "sqcup": "⊔",
      "sqcups": "⊔︀",
      "Sqrt": "√",
      "sqsub": "⊏",
      "sqsube": "⊑",
      "sqsubset": "⊏",
      "sqsubseteq": "⊑",
      "sqsup": "⊐",
      "sqsupe": "⊒",
      "sqsupset": "⊐",
      "sqsupseteq": "⊒",
      "square": "□",
      "Square": "□",
      "SquareIntersection": "⊓",
      "SquareSubset": "⊏",
      "SquareSubsetEqual": "⊑",
      "SquareSuperset": "⊐",
      "SquareSupersetEqual": "⊒",
      "SquareUnion": "⊔",
      "squarf": "▪",
      "squ": "□",
      "squf": "▪",
      "srarr": "→",
      "Sscr": "𝒮",
      "sscr": "𝓈",
      "ssetmn": "∖",
      "ssmile": "⌣",
      "sstarf": "⋆",
      "Star": "⋆",
      "star": "☆",
      "starf": "★",
      "straightepsilon": "ϵ",
      "straightphi": "ϕ",
      "strns": "¯",
      "sub": "⊂",
      "Sub": "⋐",
      "subdot": "⪽",
      "subE": "⫅",
      "sube": "⊆",
      "subedot": "⫃",
      "submult": "⫁",
      "subnE": "⫋",
      "subne": "⊊",
      "subplus": "⪿",
      "subrarr": "⥹",
      "subset": "⊂",
      "Subset": "⋐",
      "subseteq": "⊆",
      "subseteqq": "⫅",
      "SubsetEqual": "⊆",
      "subsetneq": "⊊",
      "subsetneqq": "⫋",
      "subsim": "⫇",
      "subsub": "⫕",
      "subsup": "⫓",
      "succapprox": "⪸",
      "succ": "≻",
      "succcurlyeq": "≽",
      "Succeeds": "≻",
      "SucceedsEqual": "⪰",
      "SucceedsSlantEqual": "≽",
      "SucceedsTilde": "≿",
      "succeq": "⪰",
      "succnapprox": "⪺",
      "succneqq": "⪶",
      "succnsim": "⋩",
      "succsim": "≿",
      "SuchThat": "∋",
      "sum": "∑",
      "Sum": "∑",
      "sung": "♪",
      "sup1": "¹",
      "sup2": "²",
      "sup3": "³",
      "sup": "⊃",
      "Sup": "⋑",
      "supdot": "⪾",
      "supdsub": "⫘",
      "supE": "⫆",
      "supe": "⊇",
      "supedot": "⫄",
      "Superset": "⊃",
      "SupersetEqual": "⊇",
      "suphsol": "⟉",
      "suphsub": "⫗",
      "suplarr": "⥻",
      "supmult": "⫂",
      "supnE": "⫌",
      "supne": "⊋",
      "supplus": "⫀",
      "supset": "⊃",
      "Supset": "⋑",
      "supseteq": "⊇",
      "supseteqq": "⫆",
      "supsetneq": "⊋",
      "supsetneqq": "⫌",
      "supsim": "⫈",
      "supsub": "⫔",
      "supsup": "⫖",
      "swarhk": "⤦",
      "swarr": "↙",
      "swArr": "⇙",
      "swarrow": "↙",
      "swnwar": "⤪",
      "szlig": "ß",
      "Tab": "\t",
      "target": "⌖",
      "Tau": "Τ",
      "tau": "τ",
      "tbrk": "⎴",
      "Tcaron": "Ť",
      "tcaron": "ť",
      "Tcedil": "Ţ",
      "tcedil": "ţ",
      "Tcy": "Т",
      "tcy": "т",
      "tdot": "⃛",
      "telrec": "⌕",
      "Tfr": "𝔗",
      "tfr": "𝔱",
      "there4": "∴",
      "therefore": "∴",
      "Therefore": "∴",
      "Theta": "Θ",
      "theta": "θ",
      "thetasym": "ϑ",
      "thetav": "ϑ",
      "thickapprox": "≈",
      "thicksim": "∼",
      "ThickSpace": "  ",
      "ThinSpace": " ",
      "thinsp": " ",
      "thkap": "≈",
      "thksim": "∼",
      "THORN": "Þ",
      "thorn": "þ",
      "tilde": "˜",
      "Tilde": "∼",
      "TildeEqual": "≃",
      "TildeFullEqual": "≅",
      "TildeTilde": "≈",
      "timesbar": "⨱",
      "timesb": "⊠",
      "times": "×",
      "timesd": "⨰",
      "tint": "∭",
      "toea": "⤨",
      "topbot": "⌶",
      "topcir": "⫱",
      "top": "⊤",
      "Topf": "𝕋",
      "topf": "𝕥",
      "topfork": "⫚",
      "tosa": "⤩",
      "tprime": "‴",
      "trade": "™",
      "TRADE": "™",
      "triangle": "▵",
      "triangledown": "▿",
      "triangleleft": "◃",
      "trianglelefteq": "⊴",
      "triangleq": "≜",
      "triangleright": "▹",
      "trianglerighteq": "⊵",
      "tridot": "◬",
      "trie": "≜",
      "triminus": "⨺",
      "TripleDot": "⃛",
      "triplus": "⨹",
      "trisb": "⧍",
      "tritime": "⨻",
      "trpezium": "⏢",
      "Tscr": "𝒯",
      "tscr": "𝓉",
      "TScy": "Ц",
      "tscy": "ц",
      "TSHcy": "Ћ",
      "tshcy": "ћ",
      "Tstrok": "Ŧ",
      "tstrok": "ŧ",
      "twixt": "≬",
      "twoheadleftarrow": "↞",
      "twoheadrightarrow": "↠",
      "Uacute": "Ú",
      "uacute": "ú",
      "uarr": "↑",
      "Uarr": "↟",
      "uArr": "⇑",
      "Uarrocir": "⥉",
      "Ubrcy": "Ў",
      "ubrcy": "ў",
      "Ubreve": "Ŭ",
      "ubreve": "ŭ",
      "Ucirc": "Û",
      "ucirc": "û",
      "Ucy": "У",
      "ucy": "у",
      "udarr": "⇅",
      "Udblac": "Ű",
      "udblac": "ű",
      "udhar": "⥮",
      "ufisht": "⥾",
      "Ufr": "𝔘",
      "ufr": "𝔲",
      "Ugrave": "Ù",
      "ugrave": "ù",
      "uHar": "⥣",
      "uharl": "↿",
      "uharr": "↾",
      "uhblk": "▀",
      "ulcorn": "⌜",
      "ulcorner": "⌜",
      "ulcrop": "⌏",
      "ultri": "◸",
      "Umacr": "Ū",
      "umacr": "ū",
      "uml": "¨",
      "UnderBar": "_",
      "UnderBrace": "⏟",
      "UnderBracket": "⎵",
      "UnderParenthesis": "⏝",
      "Union": "⋃",
      "UnionPlus": "⊎",
      "Uogon": "Ų",
      "uogon": "ų",
      "Uopf": "𝕌",
      "uopf": "𝕦",
      "UpArrowBar": "⤒",
      "uparrow": "↑",
      "UpArrow": "↑",
      "Uparrow": "⇑",
      "UpArrowDownArrow": "⇅",
      "updownarrow": "↕",
      "UpDownArrow": "↕",
      "Updownarrow": "⇕",
      "UpEquilibrium": "⥮",
      "upharpoonleft": "↿",
      "upharpoonright": "↾",
      "uplus": "⊎",
      "UpperLeftArrow": "↖",
      "UpperRightArrow": "↗",
      "upsi": "υ",
      "Upsi": "ϒ",
      "upsih": "ϒ",
      "Upsilon": "Υ",
      "upsilon": "υ",
      "UpTeeArrow": "↥",
      "UpTee": "⊥",
      "upuparrows": "⇈",
      "urcorn": "⌝",
      "urcorner": "⌝",
      "urcrop": "⌎",
      "Uring": "Ů",
      "uring": "ů",
      "urtri": "◹",
      "Uscr": "𝒰",
      "uscr": "𝓊",
      "utdot": "⋰",
      "Utilde": "Ũ",
      "utilde": "ũ",
      "utri": "▵",
      "utrif": "▴",
      "uuarr": "⇈",
      "Uuml": "Ü",
      "uuml": "ü",
      "uwangle": "⦧",
      "vangrt": "⦜",
      "varepsilon": "ϵ",
      "varkappa": "ϰ",
      "varnothing": "∅",
      "varphi": "ϕ",
      "varpi": "ϖ",
      "varpropto": "∝",
      "varr": "↕",
      "vArr": "⇕",
      "varrho": "ϱ",
      "varsigma": "ς",
      "varsubsetneq": "⊊︀",
      "varsubsetneqq": "⫋︀",
      "varsupsetneq": "⊋︀",
      "varsupsetneqq": "⫌︀",
      "vartheta": "ϑ",
      "vartriangleleft": "⊲",
      "vartriangleright": "⊳",
      "vBar": "⫨",
      "Vbar": "⫫",
      "vBarv": "⫩",
      "Vcy": "В",
      "vcy": "в",
      "vdash": "⊢",
      "vDash": "⊨",
      "Vdash": "⊩",
      "VDash": "⊫",
      "Vdashl": "⫦",
      "veebar": "⊻",
      "vee": "∨",
      "Vee": "⋁",
      "veeeq": "≚",
      "vellip": "⋮",
      "verbar": "|",
      "Verbar": "‖",
      "vert": "|",
      "Vert": "‖",
      "VerticalBar": "∣",
      "VerticalLine": "|",
      "VerticalSeparator": "❘",
      "VerticalTilde": "≀",
      "VeryThinSpace": " ",
      "Vfr": "𝔙",
      "vfr": "𝔳",
      "vltri": "⊲",
      "vnsub": "⊂⃒",
      "vnsup": "⊃⃒",
      "Vopf": "𝕍",
      "vopf": "𝕧",
      "vprop": "∝",
      "vrtri": "⊳",
      "Vscr": "𝒱",
      "vscr": "𝓋",
      "vsubnE": "⫋︀",
      "vsubne": "⊊︀",
      "vsupnE": "⫌︀",
      "vsupne": "⊋︀",
      "Vvdash": "⊪",
      "vzigzag": "⦚",
      "Wcirc": "Ŵ",
      "wcirc": "ŵ",
      "wedbar": "⩟",
      "wedge": "∧",
      "Wedge": "⋀",
      "wedgeq": "≙",
      "weierp": "℘",
      "Wfr": "𝔚",
      "wfr": "𝔴",
      "Wopf": "𝕎",
      "wopf": "𝕨",
      "wp": "℘",
      "wr": "≀",
      "wreath": "≀",
      "Wscr": "𝒲",
      "wscr": "𝓌",
      "xcap": "⋂",
      "xcirc": "◯",
      "xcup": "⋃",
      "xdtri": "▽",
      "Xfr": "𝔛",
      "xfr": "𝔵",
      "xharr": "⟷",
      "xhArr": "⟺",
      "Xi": "Ξ",
      "xi": "ξ",
      "xlarr": "⟵",
      "xlArr": "⟸",
      "xmap": "⟼",
      "xnis": "⋻",
      "xodot": "⨀",
      "Xopf": "𝕏",
      "xopf": "𝕩",
      "xoplus": "⨁",
      "xotime": "⨂",
      "xrarr": "⟶",
      "xrArr": "⟹",
      "Xscr": "𝒳",
      "xscr": "𝓍",
      "xsqcup": "⨆",
      "xuplus": "⨄",
      "xutri": "△",
      "xvee": "⋁",
      "xwedge": "⋀",
      "Yacute": "Ý",
      "yacute": "ý",
      "YAcy": "Я",
      "yacy": "я",
      "Ycirc": "Ŷ",
      "ycirc": "ŷ",
      "Ycy": "Ы",
      "ycy": "ы",
      "yen": "¥",
      "Yfr": "𝔜",
      "yfr": "𝔶",
      "YIcy": "Ї",
      "yicy": "ї",
      "Yopf": "𝕐",
      "yopf": "𝕪",
      "Yscr": "𝒴",
      "yscr": "𝓎",
      "YUcy": "Ю",
      "yucy": "ю",
      "yuml": "ÿ",
      "Yuml": "Ÿ",
      "Zacute": "Ź",
      "zacute": "ź",
      "Zcaron": "Ž",
      "zcaron": "ž",
      "Zcy": "З",
      "zcy": "з",
      "Zdot": "Ż",
      "zdot": "ż",
      "zeetrf": "ℨ",
      "ZeroWidthSpace": "​",
      "Zeta": "Ζ",
      "zeta": "ζ",
      "zfr": "𝔷",
      "Zfr": "ℨ",
      "ZHcy": "Ж",
      "zhcy": "ж",
      "zigrarr": "⇝",
      "zopf": "𝕫",
      "Zopf": "ℤ",
      "Zscr": "𝒵",
      "zscr": "𝓏",
      "zwj": "‍",
      "zwnj": "‌"
    };

    /***/
  }, /* 20 */
  /***/function (module, exports) {
    module.exports = {
      "amp": "&",
      "apos": "'",
      "gt": ">",
      "lt": "<",
      "quot": "\""
    };

    /***/
  }, /* 21 */
  /***/function (module, exports) {
    module.exports = function (module) {
      if (!module.webpackPolyfill) {
        module.deprecate = function () {};
        module.paths = [];
        // module.parent = undefined by default
        if (!module.children) module.children = [];
        Object.defineProperty(module, "loaded", {
          enumerable: true,
          get: function get() {
            return module.l;
          }
        });
        Object.defineProperty(module, "id", {
          enumerable: true,
          get: function get() {
            return module.i;
          }
        });
        module.webpackPolyfill = 1;
      }
      return module;
    };

    /***/
  }, /* 22 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = handleEvent;
    var _selector = __webpack_require__(0);
    var _selectorcalculator = __webpack_require__(11);
    var _extractor = __webpack_require__(3);
    __webpack_require__(12);
    var _PageSet = __webpack_require__(14);
    var _PageSet2 = _interopRequireDefault(_PageSet);
    var _Field = __webpack_require__(7);
    var _Field2 = _interopRequireDefault(_Field);
    var _Page = __webpack_require__(9);
    var _Page2 = _interopRequireDefault(_Page);
    var _Example = __webpack_require__(2);
    var _Example2 = _interopRequireDefault(_Example);
    var _logger = __webpack_require__(4);
    var _logger2 = _interopRequireDefault(_logger);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function handleEvent(doc, event, useIds) {
      var maxItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      // for backwards compatibility
      if (useIds === undefined) {
        useIds = false;
      }
      if (event.magicConfig) {
        var configs = void 0;
        try {
          configs = event.magicConfig.slice(0, maxItems);
        } catch (e) {
          _logger2.default.error('Cannot call slice on event.magicConfig: ', JSON.stringify(event.magicConfig));
          return [];
        }
        return configs.map(function (magicConfig) {
          var pageSet = new _PageSet2.default();
          var page = new _Page2.default();
          page.resourceId = event.resourceId;
          pageSet.addPage(page);
          page.url = event.url;
          page.overrideDom(doc);
          var xpath = magicConfig.resolvedXPath ? magicConfig.resolvedXPath : magicConfig.rowXPath;
          importTraining(pageSet, page, xpath, magicConfig.fields);
          var runtimeConfig = pageSet.runtimeConfig();
          var fields = runtimeConfig.fields.map(function (a) {
            return {
              name: a.name,
              type: a.type
            };
          });
          var result = {
            config: pageSet,
            fields: fields
          };
          if (event.extractData) {
            result.data = (0, _extractor.extract)(runtimeConfig, doc, page.url, useIds);
          }
          return result;
        });
      }
      return {
        url: event.url,
        resourceId: event.resourceId,
        data: (0, _extractor.extract)(event.runtimeConfig, doc, null, useIds)
      };
    }
    ;

    /**
     * Import training from magic (or elsewhere)
     * @param  {Page} page
     * @param  {Array} training [ { name, xpaths: [...] },... ]
     * @return {void}
     */
    function importTraining(pageSet, page, rowXPath, training) {
      pageSet.recordXPath = rowXPath;
      training.forEach(function (importedField) {
        var type = importedField.type === 'IMAGE' ? importedField.type : 'TEXT';
        var field = new _Field2.default({
          name: importedField.name,
          type: type,
          ranking: importedField.ranking || 0
        });
        // import the id as well, if present
        if (importedField.id !== undefined) field.id = importedField.id;
        var captureLink = importedField.type === 'URL';
        pageSet.addField(field);
        importedField.xpaths.forEach(function (xpath) {
          try {
            var el = (0, _selector.getByFullXPath)(xpath, page.dom());
            if (!el) {
              throw 'XPath [' + xpath + '] doesn\'t match any node';
            }
            if (!captureLink) captureLink = containedByLink(el);
            var path = (0, _selector.getPath)(el);
            var example = new _Example2.default({
              path: path,
              xpath: xpath
            });
            page.addFieldExample(field, example);
          } catch (e) {
            _logger2.default.error('Couldn\'t import field', e);
          }
        });
        field.captureLink = captureLink;
        (0, _selectorcalculator.calculateAndSetFieldSelector)(pageSet, field);
      });
    }
    function containedByLink(el) {
      var a = getAnchor(el);
      if (!a) return false;
      var href = a.getAttribute('href');
      return href && !/^\s*javascript:/i.exec(href);
    }
    function getAnchor(element) {
      do {
        if (element.tagName === 'A') return element;
      } while (element = element.parentNode);
    }

    /***/
  }, /* 23 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var RowFilter = function () {
      function RowFilter(_ref) {
        var ruleName = _ref.ruleName,
          regExp = _ref.regExp;
        _classCallCheck(this, RowFilter);
        this._ruleName = ruleName;
        this._regExp = regExp;
      }
      _createClass(RowFilter, [{
        key: "toJSON",
        value: function toJSON() {
          return {
            ruleName: this.ruleName,
            regExp: this.regExp
          };
        }
      }, {
        key: "ruleName",
        get: function get() {
          return this._ruleName;
        },
        set: function set(ruleName) {
          this._ruleName = ruleName;
        }
      }, {
        key: "regExp",
        get: function get() {
          return this._regExp;
        },
        set: function set(regExp) {
          this._regExp = regExp;
        }
      }]);
      return RowFilter;
    }();
    exports.default = RowFilter;

    /***/
  }, /* 24 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _extractor = __webpack_require__(3);
    Object.defineProperty(exports, 'default', {
      enumerable: true,
      get: function get() {
        return _extractor.extract;
      }
    });
    Object.defineProperty(exports, 'extract', {
      enumerable: true,
      get: function get() {
        return _extractor.extract;
      }
    });
    Object.defineProperty(exports, 'getRecordElements', {
      enumerable: true,
      get: function get() {
        return _extractor.getRecordElements;
      }
    });
    var _Page = __webpack_require__(9);
    Object.defineProperty(exports, 'Page', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Page).default;
      }
    });
    var _Field = __webpack_require__(7);
    Object.defineProperty(exports, 'Field', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Field).default;
      }
    });
    var _PageSet = __webpack_require__(14);
    Object.defineProperty(exports, 'PageSet', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_PageSet).default;
      }
    });
    var _selectorcalculator = __webpack_require__(11);
    Object.defineProperty(exports, 'initializeEditorDocument', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.initializeEditorDocument;
      }
    });
    Object.defineProperty(exports, 'calculateAndSetFieldSelector', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.calculateAndSetFieldSelector;
      }
    });
    Object.defineProperty(exports, 'calculateAndSetRegionsSelector', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.calculateAndSetRegionsSelector;
      }
    });
    Object.defineProperty(exports, 'suggestElements', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.suggestElements;
      }
    });
    Object.defineProperty(exports, 'trainField', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.trainField;
      }
    });
    Object.defineProperty(exports, 'getElementSelector', {
      enumerable: true,
      get: function get() {
        return _selectorcalculator.getElementSelector;
      }
    });
    var _Example = __webpack_require__(2);
    Object.defineProperty(exports, 'Example', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Example).default;
      }
    });
    Object.defineProperty(exports, 'makeExample', {
      enumerable: true,
      get: function get() {
        return _Example.makeExample;
      }
    });
    var _selector = __webpack_require__(0);
    Object.defineProperty(exports, 'selectNodes', {
      enumerable: true,
      get: function get() {
        return _selector.selectNodes;
      }
    });
    Object.defineProperty(exports, 'getByFullXPath', {
      enumerable: true,
      get: function get() {
        return _selector.getByFullXPath;
      }
    });
    Object.defineProperty(exports, 'toCssSelector', {
      enumerable: true,
      get: function get() {
        return _selector.toCssSelector;
      }
    });
    Object.defineProperty(exports, 'fullXPath', {
      enumerable: true,
      get: function get() {
        return _selector.fullXPath;
      }
    });
    var _lazyimg = __webpack_require__(16);
    Object.defineProperty(exports, 'showLazyImages', {
      enumerable: true,
      get: function get() {
        return _lazyimg.showLazyImages;
      }
    });
    var _utils = __webpack_require__(1);
    Object.defineProperty(exports, 'isWhitespace', {
      enumerable: true,
      get: function get() {
        return _utils.isWhitespace;
      }
    });
    Object.defineProperty(exports, 'validHref', {
      enumerable: true,
      get: function get() {
        return _utils.validHref;
      }
    });
    Object.defineProperty(exports, 'stripSessionIds', {
      enumerable: true,
      get: function get() {
        return _utils.stripSessionIds;
      }
    });
    Object.defineProperty(exports, 'textContent', {
      enumerable: true,
      get: function get() {
        return _utils.textContent;
      }
    });
    Object.defineProperty(exports, 'getElementsByXPath', {
      enumerable: true,
      get: function get() {
        return _utils.getElementsByXPath;
      }
    });
    Object.defineProperty(exports, 'makeUrlAbsolute', {
      enumerable: true,
      get: function get() {
        return _utils.makeUrlAbsolute;
      }
    });
    var _group = __webpack_require__(10);
    Object.defineProperty(exports, 'enableExtractionCache', {
      enumerable: true,
      get: function get() {
        return _group.enablePageCache;
      }
    });
    var _eventhandler = __webpack_require__(22);
    Object.defineProperty(exports, 'handleEvent', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_eventhandler).default;
      }
    });
    var _htmlparser = __webpack_require__(15);
    Object.defineProperty(exports, 'importIntoDocument', {
      enumerable: true,
      get: function get() {
        return _htmlparser.importIntoDocument;
      }
    });
    var _regiondetect = __webpack_require__(18);
    Object.defineProperty(exports, 'findRegions', {
      enumerable: true,
      get: function get() {
        return _regiondetect.findRegions;
      }
    });
    Object.defineProperty(exports, 'getContainingList', {
      enumerable: true,
      get: function get() {
        return _regiondetect.getContainingList;
      }
    });
    var _micro = __webpack_require__(17);
    Object.defineProperty(exports, 'getMainItemMicrodataRuntimeConfig', {
      enumerable: true,
      get: function get() {
        return _micro.getMainItemRuntimeConfig;
      }
    });
    Object.defineProperty(exports, 'getMainItemMicrodata', {
      enumerable: true,
      get: function get() {
        return _micro.getMainItem;
      }
    });
    Object.defineProperty(exports, 'getMicrodata', {
      enumerable: true,
      get: function get() {
        return _micro.getData;
      }
    });
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    /***/
  }, /* 25 */
  /***/function (module, exports) {
    var supportsArgumentsClass = function () {
      return Object.prototype.toString.call(arguments);
    }() == '[object Arguments]';
    exports = module.exports = supportsArgumentsClass ? supported : unsupported;
    exports.supported = supported;
    function supported(object) {
      return Object.prototype.toString.call(object) == '[object Arguments]';
    }
    ;
    exports.unsupported = unsupported;
    function unsupported(object) {
      return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
    }
    ;

    /***/
  }, /* 26 */
  /***/function (module, exports) {
    exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
    exports.shim = shim;
    function shim(obj) {
      var keys = [];
      for (var key in obj) keys.push(key);
      return keys;
    }

    /***/
  }, /* 27 */
  /***/function (module, exports, __webpack_require__) {
    var encode = __webpack_require__(30),
      decode = __webpack_require__(28);
    exports.decode = function (data, level) {
      return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
    };
    exports.decodeStrict = function (data, level) {
      return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
    };
    exports.encode = function (data, level) {
      return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
    };
    exports.encodeXML = encode.XML;
    exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
    exports.decodeXML = exports.decodeXMLStrict = decode.XML;
    exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
    exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
    exports.escape = encode.escape;

    /***/
  }, /* 28 */
  /***/function (module, exports, __webpack_require__) {
    var entityMap = __webpack_require__(19),
      legacyMap = __webpack_require__(32),
      xmlMap = __webpack_require__(20),
      decodeCodePoint = __webpack_require__(29);
    var decodeXMLStrict = getStrictDecoder(xmlMap),
      decodeHTMLStrict = getStrictDecoder(entityMap);
    function getStrictDecoder(map) {
      var keys = Object.keys(map).join("|"),
        replace = getReplacer(map);
      keys += "|#[xX][\\da-fA-F]+|#\\d+";
      var re = new RegExp("&(?:" + keys + ");", "g");
      return function (str) {
        return String(str).replace(re, replace);
      };
    }
    var decodeHTML = function () {
      var legacy = Object.keys(legacyMap).sort(sorter);
      var keys = Object.keys(entityMap).sort(sorter);
      for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
          keys[i] += ";?";
          j++;
        } else {
          keys[i] += ";";
        }
      }
      var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
        replace = getReplacer(entityMap);
      function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
      }

      //TODO consider creating a merged map
      return function (str) {
        return String(str).replace(re, replacer);
      };
    }();
    function sorter(a, b) {
      return a < b ? 1 : -1;
    }
    function getReplacer(map) {
      return function replace(str) {
        if (str.charAt(1) === "#") {
          if (str.charAt(2) === "X" || str.charAt(2) === "x") {
            return decodeCodePoint(parseInt(str.substr(3), 16));
          }
          return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
      };
    }
    module.exports = {
      XML: decodeXMLStrict,
      HTML: decodeHTML,
      HTMLStrict: decodeHTMLStrict
    };

    /***/
  }, /* 29 */
  /***/function (module, exports, __webpack_require__) {
    var decodeMap = __webpack_require__(31);
    module.exports = decodeCodePoint;

    // modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
    function decodeCodePoint(codePoint) {
      if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
        return "\uFFFD";
      }
      if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
      }
      var output = "";
      if (codePoint > 0xFFFF) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }
      output += String.fromCharCode(codePoint);
      return output;
    }

    /***/
  }, /* 30 */
  /***/function (module, exports, __webpack_require__) {
    var inverseXML = getInverseObj(__webpack_require__(20)),
      xmlReplacer = getInverseReplacer(inverseXML);
    exports.XML = getInverse(inverseXML, xmlReplacer);
    var inverseHTML = getInverseObj(__webpack_require__(19)),
      htmlReplacer = getInverseReplacer(inverseHTML);
    exports.HTML = getInverse(inverseHTML, htmlReplacer);
    function getInverseObj(obj) {
      return Object.keys(obj).sort().reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
      }, {});
    }
    function getInverseReplacer(inverse) {
      var single = [],
        multiple = [];
      Object.keys(inverse).forEach(function (k) {
        if (k.length === 1) {
          single.push("\\" + k);
        } else {
          multiple.push(k);
        }
      });

      //TODO add ranges
      multiple.unshift("[" + single.join("") + "]");
      return new RegExp(multiple.join("|"), "g");
    }
    var re_nonASCII = /[^\0-\x7F]/g,
      re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    function singleCharReplacer(c) {
      return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
    }
    function astralReplacer(c) {
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      var high = c.charCodeAt(0);
      var low = c.charCodeAt(1);
      var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
      return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    }
    function getInverse(inverse, re) {
      function func(name) {
        return inverse[name];
      }
      return function (data) {
        return data.replace(re, func).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
      };
    }
    var re_xmlChars = getInverseReplacer(inverseXML);
    function escapeXML(data) {
      return data.replace(re_xmlChars, singleCharReplacer).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
    }
    exports.escape = escapeXML;

    /***/
  }, /* 31 */
  /***/function (module, exports) {
    module.exports = {
      "0": 65533,
      "128": 8364,
      "130": 8218,
      "131": 402,
      "132": 8222,
      "133": 8230,
      "134": 8224,
      "135": 8225,
      "136": 710,
      "137": 8240,
      "138": 352,
      "139": 8249,
      "140": 338,
      "142": 381,
      "145": 8216,
      "146": 8217,
      "147": 8220,
      "148": 8221,
      "149": 8226,
      "150": 8211,
      "151": 8212,
      "152": 732,
      "153": 8482,
      "154": 353,
      "155": 8250,
      "156": 339,
      "158": 382,
      "159": 376
    };

    /***/
  }, /* 32 */
  /***/function (module, exports) {
    module.exports = {
      "Aacute": "Á",
      "aacute": "á",
      "Acirc": "Â",
      "acirc": "â",
      "acute": "´",
      "AElig": "Æ",
      "aelig": "æ",
      "Agrave": "À",
      "agrave": "à",
      "amp": "&",
      "AMP": "&",
      "Aring": "Å",
      "aring": "å",
      "Atilde": "Ã",
      "atilde": "ã",
      "Auml": "Ä",
      "auml": "ä",
      "brvbar": "¦",
      "Ccedil": "Ç",
      "ccedil": "ç",
      "cedil": "¸",
      "cent": "¢",
      "copy": "©",
      "COPY": "©",
      "curren": "¤",
      "deg": "°",
      "divide": "÷",
      "Eacute": "É",
      "eacute": "é",
      "Ecirc": "Ê",
      "ecirc": "ê",
      "Egrave": "È",
      "egrave": "è",
      "ETH": "Ð",
      "eth": "ð",
      "Euml": "Ë",
      "euml": "ë",
      "frac12": "½",
      "frac14": "¼",
      "frac34": "¾",
      "gt": ">",
      "GT": ">",
      "Iacute": "Í",
      "iacute": "í",
      "Icirc": "Î",
      "icirc": "î",
      "iexcl": "¡",
      "Igrave": "Ì",
      "igrave": "ì",
      "iquest": "¿",
      "Iuml": "Ï",
      "iuml": "ï",
      "laquo": "«",
      "lt": "<",
      "LT": "<",
      "macr": "¯",
      "micro": "µ",
      "middot": "·",
      "nbsp": " ",
      "not": "¬",
      "Ntilde": "Ñ",
      "ntilde": "ñ",
      "Oacute": "Ó",
      "oacute": "ó",
      "Ocirc": "Ô",
      "ocirc": "ô",
      "Ograve": "Ò",
      "ograve": "ò",
      "ordf": "ª",
      "ordm": "º",
      "Oslash": "Ø",
      "oslash": "ø",
      "Otilde": "Õ",
      "otilde": "õ",
      "Ouml": "Ö",
      "ouml": "ö",
      "para": "¶",
      "plusmn": "±",
      "pound": "£",
      "quot": "\"",
      "QUOT": "\"",
      "raquo": "»",
      "reg": "®",
      "REG": "®",
      "sect": "§",
      "shy": "­",
      "sup1": "¹",
      "sup2": "²",
      "sup3": "³",
      "szlig": "ß",
      "THORN": "Þ",
      "thorn": "þ",
      "times": "×",
      "Uacute": "Ú",
      "uacute": "ú",
      "Ucirc": "Û",
      "ucirc": "û",
      "Ugrave": "Ù",
      "ugrave": "ù",
      "uml": "¨",
      "Uuml": "Ü",
      "uuml": "ü",
      "Yacute": "Ý",
      "yacute": "ý",
      "yen": "¥",
      "yuml": "ÿ"
    };

    /***/
  }, /* 33 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module, global) {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/he v1.1.1 by @mathias | MIT license */
      ;
      (function (root) {
        // Detect free variables `exports`.
        var freeExports = typeof exports == 'object' && exports;

        // Detect free variable `module`.
        var freeModule = typeof module == 'object' && module && module.exports == freeExports && module;

        // Detect free variable `global`, from Node.js or Browserified code,
        // and use it as `root`.
        var freeGlobal = typeof global == 'object' && global;
        if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
          root = freeGlobal;
        }

        /*--------------------------------------------------------------------------*/

        // All astral symbols.
        var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        // All ASCII symbols (not just printable ASCII) except those listed in the
        // first column of the overrides table.
        // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
        var regexAsciiWhitelist = /[\x01-\x7F]/g;
        // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
        // code points listed in the first column of the overrides table on
        // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
        var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
        var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
        var encodeMap = {
          '\xAD': 'shy',
          "\u200C": 'zwnj',
          "\u200D": 'zwj',
          "\u200E": 'lrm',
          "\u2063": 'ic',
          "\u2062": 'it',
          "\u2061": 'af',
          "\u200F": 'rlm',
          "\u200B": 'ZeroWidthSpace',
          "\u2060": 'NoBreak',
          "\u0311": 'DownBreve',
          "\u20DB": 'tdot',
          "\u20DC": 'DotDot',
          '\t': 'Tab',
          '\n': 'NewLine',
          "\u2008": 'puncsp',
          "\u205F": 'MediumSpace',
          "\u2009": 'thinsp',
          "\u200A": 'hairsp',
          "\u2004": 'emsp13',
          "\u2002": 'ensp',
          "\u2005": 'emsp14',
          "\u2003": 'emsp',
          "\u2007": 'numsp',
          '\xA0': 'nbsp',
          "\u205F\u200A": 'ThickSpace',
          "\u203E": 'oline',
          '_': 'lowbar',
          "\u2010": 'dash',
          "\u2013": 'ndash',
          "\u2014": 'mdash',
          "\u2015": 'horbar',
          ',': 'comma',
          ';': 'semi',
          "\u204F": 'bsemi',
          ':': 'colon',
          "\u2A74": 'Colone',
          '!': 'excl',
          '\xA1': 'iexcl',
          '?': 'quest',
          '\xBF': 'iquest',
          '.': 'period',
          "\u2025": 'nldr',
          "\u2026": 'mldr',
          '\xB7': 'middot',
          '\'': 'apos',
          "\u2018": 'lsquo',
          "\u2019": 'rsquo',
          "\u201A": 'sbquo',
          "\u2039": 'lsaquo',
          "\u203A": 'rsaquo',
          '"': 'quot',
          "\u201C": 'ldquo',
          "\u201D": 'rdquo',
          "\u201E": 'bdquo',
          '\xAB': 'laquo',
          '\xBB': 'raquo',
          '(': 'lpar',
          ')': 'rpar',
          '[': 'lsqb',
          ']': 'rsqb',
          '{': 'lcub',
          '}': 'rcub',
          "\u2308": 'lceil',
          "\u2309": 'rceil',
          "\u230A": 'lfloor',
          "\u230B": 'rfloor',
          "\u2985": 'lopar',
          "\u2986": 'ropar',
          "\u298B": 'lbrke',
          "\u298C": 'rbrke',
          "\u298D": 'lbrkslu',
          "\u298E": 'rbrksld',
          "\u298F": 'lbrksld',
          "\u2990": 'rbrkslu',
          "\u2991": 'langd',
          "\u2992": 'rangd',
          "\u2993": 'lparlt',
          "\u2994": 'rpargt',
          "\u2995": 'gtlPar',
          "\u2996": 'ltrPar',
          "\u27E6": 'lobrk',
          "\u27E7": 'robrk',
          "\u27E8": 'lang',
          "\u27E9": 'rang',
          "\u27EA": 'Lang',
          "\u27EB": 'Rang',
          "\u27EC": 'loang',
          "\u27ED": 'roang',
          "\u2772": 'lbbrk',
          "\u2773": 'rbbrk',
          "\u2016": 'Vert',
          '\xA7': 'sect',
          '\xB6': 'para',
          '@': 'commat',
          '*': 'ast',
          '/': 'sol',
          'undefined': null,
          '&': 'amp',
          '#': 'num',
          '%': 'percnt',
          "\u2030": 'permil',
          "\u2031": 'pertenk',
          "\u2020": 'dagger',
          "\u2021": 'Dagger',
          "\u2022": 'bull',
          "\u2043": 'hybull',
          "\u2032": 'prime',
          "\u2033": 'Prime',
          "\u2034": 'tprime',
          "\u2057": 'qprime',
          "\u2035": 'bprime',
          "\u2041": 'caret',
          '`': 'grave',
          '\xB4': 'acute',
          "\u02DC": 'tilde',
          '^': 'Hat',
          '\xAF': 'macr',
          "\u02D8": 'breve',
          "\u02D9": 'dot',
          '\xA8': 'die',
          "\u02DA": 'ring',
          "\u02DD": 'dblac',
          '\xB8': 'cedil',
          "\u02DB": 'ogon',
          "\u02C6": 'circ',
          "\u02C7": 'caron',
          '\xB0': 'deg',
          '\xA9': 'copy',
          '\xAE': 'reg',
          "\u2117": 'copysr',
          "\u2118": 'wp',
          "\u211E": 'rx',
          "\u2127": 'mho',
          "\u2129": 'iiota',
          "\u2190": 'larr',
          "\u219A": 'nlarr',
          "\u2192": 'rarr',
          "\u219B": 'nrarr',
          "\u2191": 'uarr',
          "\u2193": 'darr',
          "\u2194": 'harr',
          "\u21AE": 'nharr',
          "\u2195": 'varr',
          "\u2196": 'nwarr',
          "\u2197": 'nearr',
          "\u2198": 'searr',
          "\u2199": 'swarr',
          "\u219D": 'rarrw',
          "\u219D\u0338": 'nrarrw',
          "\u219E": 'Larr',
          "\u219F": 'Uarr',
          "\u21A0": 'Rarr',
          "\u21A1": 'Darr',
          "\u21A2": 'larrtl',
          "\u21A3": 'rarrtl',
          "\u21A4": 'mapstoleft',
          "\u21A5": 'mapstoup',
          "\u21A6": 'map',
          "\u21A7": 'mapstodown',
          "\u21A9": 'larrhk',
          "\u21AA": 'rarrhk',
          "\u21AB": 'larrlp',
          "\u21AC": 'rarrlp',
          "\u21AD": 'harrw',
          "\u21B0": 'lsh',
          "\u21B1": 'rsh',
          "\u21B2": 'ldsh',
          "\u21B3": 'rdsh',
          "\u21B5": 'crarr',
          "\u21B6": 'cularr',
          "\u21B7": 'curarr',
          "\u21BA": 'olarr',
          "\u21BB": 'orarr',
          "\u21BC": 'lharu',
          "\u21BD": 'lhard',
          "\u21BE": 'uharr',
          "\u21BF": 'uharl',
          "\u21C0": 'rharu',
          "\u21C1": 'rhard',
          "\u21C2": 'dharr',
          "\u21C3": 'dharl',
          "\u21C4": 'rlarr',
          "\u21C5": 'udarr',
          "\u21C6": 'lrarr',
          "\u21C7": 'llarr',
          "\u21C8": 'uuarr',
          "\u21C9": 'rrarr',
          "\u21CA": 'ddarr',
          "\u21CB": 'lrhar',
          "\u21CC": 'rlhar',
          "\u21D0": 'lArr',
          "\u21CD": 'nlArr',
          "\u21D1": 'uArr',
          "\u21D2": 'rArr',
          "\u21CF": 'nrArr',
          "\u21D3": 'dArr',
          "\u21D4": 'iff',
          "\u21CE": 'nhArr',
          "\u21D5": 'vArr',
          "\u21D6": 'nwArr',
          "\u21D7": 'neArr',
          "\u21D8": 'seArr',
          "\u21D9": 'swArr',
          "\u21DA": 'lAarr',
          "\u21DB": 'rAarr',
          "\u21DD": 'zigrarr',
          "\u21E4": 'larrb',
          "\u21E5": 'rarrb',
          "\u21F5": 'duarr',
          "\u21FD": 'loarr',
          "\u21FE": 'roarr',
          "\u21FF": 'hoarr',
          "\u2200": 'forall',
          "\u2201": 'comp',
          "\u2202": 'part',
          "\u2202\u0338": 'npart',
          "\u2203": 'exist',
          "\u2204": 'nexist',
          "\u2205": 'empty',
          "\u2207": 'Del',
          "\u2208": 'in',
          "\u2209": 'notin',
          "\u220B": 'ni',
          "\u220C": 'notni',
          "\u03F6": 'bepsi',
          "\u220F": 'prod',
          "\u2210": 'coprod',
          "\u2211": 'sum',
          '+': 'plus',
          '\xB1': 'pm',
          '\xF7': 'div',
          '\xD7': 'times',
          '<': 'lt',
          "\u226E": 'nlt',
          "<\u20D2": 'nvlt',
          '=': 'equals',
          "\u2260": 'ne',
          "=\u20E5": 'bne',
          "\u2A75": 'Equal',
          '>': 'gt',
          "\u226F": 'ngt',
          ">\u20D2": 'nvgt',
          '\xAC': 'not',
          '|': 'vert',
          '\xA6': 'brvbar',
          "\u2212": 'minus',
          "\u2213": 'mp',
          "\u2214": 'plusdo',
          "\u2044": 'frasl',
          "\u2216": 'setmn',
          "\u2217": 'lowast',
          "\u2218": 'compfn',
          "\u221A": 'Sqrt',
          "\u221D": 'prop',
          "\u221E": 'infin',
          "\u221F": 'angrt',
          "\u2220": 'ang',
          "\u2220\u20D2": 'nang',
          "\u2221": 'angmsd',
          "\u2222": 'angsph',
          "\u2223": 'mid',
          "\u2224": 'nmid',
          "\u2225": 'par',
          "\u2226": 'npar',
          "\u2227": 'and',
          "\u2228": 'or',
          "\u2229": 'cap',
          "\u2229\uFE00": 'caps',
          "\u222A": 'cup',
          "\u222A\uFE00": 'cups',
          "\u222B": 'int',
          "\u222C": 'Int',
          "\u222D": 'tint',
          "\u2A0C": 'qint',
          "\u222E": 'oint',
          "\u222F": 'Conint',
          "\u2230": 'Cconint',
          "\u2231": 'cwint',
          "\u2232": 'cwconint',
          "\u2233": 'awconint',
          "\u2234": 'there4',
          "\u2235": 'becaus',
          "\u2236": 'ratio',
          "\u2237": 'Colon',
          "\u2238": 'minusd',
          "\u223A": 'mDDot',
          "\u223B": 'homtht',
          "\u223C": 'sim',
          "\u2241": 'nsim',
          "\u223C\u20D2": 'nvsim',
          "\u223D": 'bsim',
          "\u223D\u0331": 'race',
          "\u223E": 'ac',
          "\u223E\u0333": 'acE',
          "\u223F": 'acd',
          "\u2240": 'wr',
          "\u2242": 'esim',
          "\u2242\u0338": 'nesim',
          "\u2243": 'sime',
          "\u2244": 'nsime',
          "\u2245": 'cong',
          "\u2247": 'ncong',
          "\u2246": 'simne',
          "\u2248": 'ap',
          "\u2249": 'nap',
          "\u224A": 'ape',
          "\u224B": 'apid',
          "\u224B\u0338": 'napid',
          "\u224C": 'bcong',
          "\u224D": 'CupCap',
          "\u226D": 'NotCupCap',
          "\u224D\u20D2": 'nvap',
          "\u224E": 'bump',
          "\u224E\u0338": 'nbump',
          "\u224F": 'bumpe',
          "\u224F\u0338": 'nbumpe',
          "\u2250": 'doteq',
          "\u2250\u0338": 'nedot',
          "\u2251": 'eDot',
          "\u2252": 'efDot',
          "\u2253": 'erDot',
          "\u2254": 'colone',
          "\u2255": 'ecolon',
          "\u2256": 'ecir',
          "\u2257": 'cire',
          "\u2259": 'wedgeq',
          "\u225A": 'veeeq',
          "\u225C": 'trie',
          "\u225F": 'equest',
          "\u2261": 'equiv',
          "\u2262": 'nequiv',
          "\u2261\u20E5": 'bnequiv',
          "\u2264": 'le',
          "\u2270": 'nle',
          "\u2264\u20D2": 'nvle',
          "\u2265": 'ge',
          "\u2271": 'nge',
          "\u2265\u20D2": 'nvge',
          "\u2266": 'lE',
          "\u2266\u0338": 'nlE',
          "\u2267": 'gE',
          "\u2267\u0338": 'ngE',
          "\u2268\uFE00": 'lvnE',
          "\u2268": 'lnE',
          "\u2269": 'gnE',
          "\u2269\uFE00": 'gvnE',
          "\u226A": 'll',
          "\u226A\u0338": 'nLtv',
          "\u226A\u20D2": 'nLt',
          "\u226B": 'gg',
          "\u226B\u0338": 'nGtv',
          "\u226B\u20D2": 'nGt',
          "\u226C": 'twixt',
          "\u2272": 'lsim',
          "\u2274": 'nlsim',
          "\u2273": 'gsim',
          "\u2275": 'ngsim',
          "\u2276": 'lg',
          "\u2278": 'ntlg',
          "\u2277": 'gl',
          "\u2279": 'ntgl',
          "\u227A": 'pr',
          "\u2280": 'npr',
          "\u227B": 'sc',
          "\u2281": 'nsc',
          "\u227C": 'prcue',
          "\u22E0": 'nprcue',
          "\u227D": 'sccue',
          "\u22E1": 'nsccue',
          "\u227E": 'prsim',
          "\u227F": 'scsim',
          "\u227F\u0338": 'NotSucceedsTilde',
          "\u2282": 'sub',
          "\u2284": 'nsub',
          "\u2282\u20D2": 'vnsub',
          "\u2283": 'sup',
          "\u2285": 'nsup',
          "\u2283\u20D2": 'vnsup',
          "\u2286": 'sube',
          "\u2288": 'nsube',
          "\u2287": 'supe',
          "\u2289": 'nsupe',
          "\u228A\uFE00": 'vsubne',
          "\u228A": 'subne',
          "\u228B\uFE00": 'vsupne',
          "\u228B": 'supne',
          "\u228D": 'cupdot',
          "\u228E": 'uplus',
          "\u228F": 'sqsub',
          "\u228F\u0338": 'NotSquareSubset',
          "\u2290": 'sqsup',
          "\u2290\u0338": 'NotSquareSuperset',
          "\u2291": 'sqsube',
          "\u22E2": 'nsqsube',
          "\u2292": 'sqsupe',
          "\u22E3": 'nsqsupe',
          "\u2293": 'sqcap',
          "\u2293\uFE00": 'sqcaps',
          "\u2294": 'sqcup',
          "\u2294\uFE00": 'sqcups',
          "\u2295": 'oplus',
          "\u2296": 'ominus',
          "\u2297": 'otimes',
          "\u2298": 'osol',
          "\u2299": 'odot',
          "\u229A": 'ocir',
          "\u229B": 'oast',
          "\u229D": 'odash',
          "\u229E": 'plusb',
          "\u229F": 'minusb',
          "\u22A0": 'timesb',
          "\u22A1": 'sdotb',
          "\u22A2": 'vdash',
          "\u22AC": 'nvdash',
          "\u22A3": 'dashv',
          "\u22A4": 'top',
          "\u22A5": 'bot',
          "\u22A7": 'models',
          "\u22A8": 'vDash',
          "\u22AD": 'nvDash',
          "\u22A9": 'Vdash',
          "\u22AE": 'nVdash',
          "\u22AA": 'Vvdash',
          "\u22AB": 'VDash',
          "\u22AF": 'nVDash',
          "\u22B0": 'prurel',
          "\u22B2": 'vltri',
          "\u22EA": 'nltri',
          "\u22B3": 'vrtri',
          "\u22EB": 'nrtri',
          "\u22B4": 'ltrie',
          "\u22EC": 'nltrie',
          "\u22B4\u20D2": 'nvltrie',
          "\u22B5": 'rtrie',
          "\u22ED": 'nrtrie',
          "\u22B5\u20D2": 'nvrtrie',
          "\u22B6": 'origof',
          "\u22B7": 'imof',
          "\u22B8": 'mumap',
          "\u22B9": 'hercon',
          "\u22BA": 'intcal',
          "\u22BB": 'veebar',
          "\u22BD": 'barvee',
          "\u22BE": 'angrtvb',
          "\u22BF": 'lrtri',
          "\u22C0": 'Wedge',
          "\u22C1": 'Vee',
          "\u22C2": 'xcap',
          "\u22C3": 'xcup',
          "\u22C4": 'diam',
          "\u22C5": 'sdot',
          "\u22C6": 'Star',
          "\u22C7": 'divonx',
          "\u22C8": 'bowtie',
          "\u22C9": 'ltimes',
          "\u22CA": 'rtimes',
          "\u22CB": 'lthree',
          "\u22CC": 'rthree',
          "\u22CD": 'bsime',
          "\u22CE": 'cuvee',
          "\u22CF": 'cuwed',
          "\u22D0": 'Sub',
          "\u22D1": 'Sup',
          "\u22D2": 'Cap',
          "\u22D3": 'Cup',
          "\u22D4": 'fork',
          "\u22D5": 'epar',
          "\u22D6": 'ltdot',
          "\u22D7": 'gtdot',
          "\u22D8": 'Ll',
          "\u22D8\u0338": 'nLl',
          "\u22D9": 'Gg',
          "\u22D9\u0338": 'nGg',
          "\u22DA\uFE00": 'lesg',
          "\u22DA": 'leg',
          "\u22DB": 'gel',
          "\u22DB\uFE00": 'gesl',
          "\u22DE": 'cuepr',
          "\u22DF": 'cuesc',
          "\u22E6": 'lnsim',
          "\u22E7": 'gnsim',
          "\u22E8": 'prnsim',
          "\u22E9": 'scnsim',
          "\u22EE": 'vellip',
          "\u22EF": 'ctdot',
          "\u22F0": 'utdot',
          "\u22F1": 'dtdot',
          "\u22F2": 'disin',
          "\u22F3": 'isinsv',
          "\u22F4": 'isins',
          "\u22F5": 'isindot',
          "\u22F5\u0338": 'notindot',
          "\u22F6": 'notinvc',
          "\u22F7": 'notinvb',
          "\u22F9": 'isinE',
          "\u22F9\u0338": 'notinE',
          "\u22FA": 'nisd',
          "\u22FB": 'xnis',
          "\u22FC": 'nis',
          "\u22FD": 'notnivc',
          "\u22FE": 'notnivb',
          "\u2305": 'barwed',
          "\u2306": 'Barwed',
          "\u230C": 'drcrop',
          "\u230D": 'dlcrop',
          "\u230E": 'urcrop',
          "\u230F": 'ulcrop',
          "\u2310": 'bnot',
          "\u2312": 'profline',
          "\u2313": 'profsurf',
          "\u2315": 'telrec',
          "\u2316": 'target',
          "\u231C": 'ulcorn',
          "\u231D": 'urcorn',
          "\u231E": 'dlcorn',
          "\u231F": 'drcorn',
          "\u2322": 'frown',
          "\u2323": 'smile',
          "\u232D": 'cylcty',
          "\u232E": 'profalar',
          "\u2336": 'topbot',
          "\u233D": 'ovbar',
          "\u233F": 'solbar',
          "\u237C": 'angzarr',
          "\u23B0": 'lmoust',
          "\u23B1": 'rmoust',
          "\u23B4": 'tbrk',
          "\u23B5": 'bbrk',
          "\u23B6": 'bbrktbrk',
          "\u23DC": 'OverParenthesis',
          "\u23DD": 'UnderParenthesis',
          "\u23DE": 'OverBrace',
          "\u23DF": 'UnderBrace',
          "\u23E2": 'trpezium',
          "\u23E7": 'elinters',
          "\u2423": 'blank',
          "\u2500": 'boxh',
          "\u2502": 'boxv',
          "\u250C": 'boxdr',
          "\u2510": 'boxdl',
          "\u2514": 'boxur',
          "\u2518": 'boxul',
          "\u251C": 'boxvr',
          "\u2524": 'boxvl',
          "\u252C": 'boxhd',
          "\u2534": 'boxhu',
          "\u253C": 'boxvh',
          "\u2550": 'boxH',
          "\u2551": 'boxV',
          "\u2552": 'boxdR',
          "\u2553": 'boxDr',
          "\u2554": 'boxDR',
          "\u2555": 'boxdL',
          "\u2556": 'boxDl',
          "\u2557": 'boxDL',
          "\u2558": 'boxuR',
          "\u2559": 'boxUr',
          "\u255A": 'boxUR',
          "\u255B": 'boxuL',
          "\u255C": 'boxUl',
          "\u255D": 'boxUL',
          "\u255E": 'boxvR',
          "\u255F": 'boxVr',
          "\u2560": 'boxVR',
          "\u2561": 'boxvL',
          "\u2562": 'boxVl',
          "\u2563": 'boxVL',
          "\u2564": 'boxHd',
          "\u2565": 'boxhD',
          "\u2566": 'boxHD',
          "\u2567": 'boxHu',
          "\u2568": 'boxhU',
          "\u2569": 'boxHU',
          "\u256A": 'boxvH',
          "\u256B": 'boxVh',
          "\u256C": 'boxVH',
          "\u2580": 'uhblk',
          "\u2584": 'lhblk',
          "\u2588": 'block',
          "\u2591": 'blk14',
          "\u2592": 'blk12',
          "\u2593": 'blk34',
          "\u25A1": 'squ',
          "\u25AA": 'squf',
          "\u25AB": 'EmptyVerySmallSquare',
          "\u25AD": 'rect',
          "\u25AE": 'marker',
          "\u25B1": 'fltns',
          "\u25B3": 'xutri',
          "\u25B4": 'utrif',
          "\u25B5": 'utri',
          "\u25B8": 'rtrif',
          "\u25B9": 'rtri',
          "\u25BD": 'xdtri',
          "\u25BE": 'dtrif',
          "\u25BF": 'dtri',
          "\u25C2": 'ltrif',
          "\u25C3": 'ltri',
          "\u25CA": 'loz',
          "\u25CB": 'cir',
          "\u25EC": 'tridot',
          "\u25EF": 'xcirc',
          "\u25F8": 'ultri',
          "\u25F9": 'urtri',
          "\u25FA": 'lltri',
          "\u25FB": 'EmptySmallSquare',
          "\u25FC": 'FilledSmallSquare',
          "\u2605": 'starf',
          "\u2606": 'star',
          "\u260E": 'phone',
          "\u2640": 'female',
          "\u2642": 'male',
          "\u2660": 'spades',
          "\u2663": 'clubs',
          "\u2665": 'hearts',
          "\u2666": 'diams',
          "\u266A": 'sung',
          "\u2713": 'check',
          "\u2717": 'cross',
          "\u2720": 'malt',
          "\u2736": 'sext',
          "\u2758": 'VerticalSeparator',
          "\u27C8": 'bsolhsub',
          "\u27C9": 'suphsol',
          "\u27F5": 'xlarr',
          "\u27F6": 'xrarr',
          "\u27F7": 'xharr',
          "\u27F8": 'xlArr',
          "\u27F9": 'xrArr',
          "\u27FA": 'xhArr',
          "\u27FC": 'xmap',
          "\u27FF": 'dzigrarr',
          "\u2902": 'nvlArr',
          "\u2903": 'nvrArr',
          "\u2904": 'nvHarr',
          "\u2905": 'Map',
          "\u290C": 'lbarr',
          "\u290D": 'rbarr',
          "\u290E": 'lBarr',
          "\u290F": 'rBarr',
          "\u2910": 'RBarr',
          "\u2911": 'DDotrahd',
          "\u2912": 'UpArrowBar',
          "\u2913": 'DownArrowBar',
          "\u2916": 'Rarrtl',
          "\u2919": 'latail',
          "\u291A": 'ratail',
          "\u291B": 'lAtail',
          "\u291C": 'rAtail',
          "\u291D": 'larrfs',
          "\u291E": 'rarrfs',
          "\u291F": 'larrbfs',
          "\u2920": 'rarrbfs',
          "\u2923": 'nwarhk',
          "\u2924": 'nearhk',
          "\u2925": 'searhk',
          "\u2926": 'swarhk',
          "\u2927": 'nwnear',
          "\u2928": 'toea',
          "\u2929": 'tosa',
          "\u292A": 'swnwar',
          "\u2933": 'rarrc',
          "\u2933\u0338": 'nrarrc',
          "\u2935": 'cudarrr',
          "\u2936": 'ldca',
          "\u2937": 'rdca',
          "\u2938": 'cudarrl',
          "\u2939": 'larrpl',
          "\u293C": 'curarrm',
          "\u293D": 'cularrp',
          "\u2945": 'rarrpl',
          "\u2948": 'harrcir',
          "\u2949": 'Uarrocir',
          "\u294A": 'lurdshar',
          "\u294B": 'ldrushar',
          "\u294E": 'LeftRightVector',
          "\u294F": 'RightUpDownVector',
          "\u2950": 'DownLeftRightVector',
          "\u2951": 'LeftUpDownVector',
          "\u2952": 'LeftVectorBar',
          "\u2953": 'RightVectorBar',
          "\u2954": 'RightUpVectorBar',
          "\u2955": 'RightDownVectorBar',
          "\u2956": 'DownLeftVectorBar',
          "\u2957": 'DownRightVectorBar',
          "\u2958": 'LeftUpVectorBar',
          "\u2959": 'LeftDownVectorBar',
          "\u295A": 'LeftTeeVector',
          "\u295B": 'RightTeeVector',
          "\u295C": 'RightUpTeeVector',
          "\u295D": 'RightDownTeeVector',
          "\u295E": 'DownLeftTeeVector',
          "\u295F": 'DownRightTeeVector',
          "\u2960": 'LeftUpTeeVector',
          "\u2961": 'LeftDownTeeVector',
          "\u2962": 'lHar',
          "\u2963": 'uHar',
          "\u2964": 'rHar',
          "\u2965": 'dHar',
          "\u2966": 'luruhar',
          "\u2967": 'ldrdhar',
          "\u2968": 'ruluhar',
          "\u2969": 'rdldhar',
          "\u296A": 'lharul',
          "\u296B": 'llhard',
          "\u296C": 'rharul',
          "\u296D": 'lrhard',
          "\u296E": 'udhar',
          "\u296F": 'duhar',
          "\u2970": 'RoundImplies',
          "\u2971": 'erarr',
          "\u2972": 'simrarr',
          "\u2973": 'larrsim',
          "\u2974": 'rarrsim',
          "\u2975": 'rarrap',
          "\u2976": 'ltlarr',
          "\u2978": 'gtrarr',
          "\u2979": 'subrarr',
          "\u297B": 'suplarr',
          "\u297C": 'lfisht',
          "\u297D": 'rfisht',
          "\u297E": 'ufisht',
          "\u297F": 'dfisht',
          "\u299A": 'vzigzag',
          "\u299C": 'vangrt',
          "\u299D": 'angrtvbd',
          "\u29A4": 'ange',
          "\u29A5": 'range',
          "\u29A6": 'dwangle',
          "\u29A7": 'uwangle',
          "\u29A8": 'angmsdaa',
          "\u29A9": 'angmsdab',
          "\u29AA": 'angmsdac',
          "\u29AB": 'angmsdad',
          "\u29AC": 'angmsdae',
          "\u29AD": 'angmsdaf',
          "\u29AE": 'angmsdag',
          "\u29AF": 'angmsdah',
          "\u29B0": 'bemptyv',
          "\u29B1": 'demptyv',
          "\u29B2": 'cemptyv',
          "\u29B3": 'raemptyv',
          "\u29B4": 'laemptyv',
          "\u29B5": 'ohbar',
          "\u29B6": 'omid',
          "\u29B7": 'opar',
          "\u29B9": 'operp',
          "\u29BB": 'olcross',
          "\u29BC": 'odsold',
          "\u29BE": 'olcir',
          "\u29BF": 'ofcir',
          "\u29C0": 'olt',
          "\u29C1": 'ogt',
          "\u29C2": 'cirscir',
          "\u29C3": 'cirE',
          "\u29C4": 'solb',
          "\u29C5": 'bsolb',
          "\u29C9": 'boxbox',
          "\u29CD": 'trisb',
          "\u29CE": 'rtriltri',
          "\u29CF": 'LeftTriangleBar',
          "\u29CF\u0338": 'NotLeftTriangleBar',
          "\u29D0": 'RightTriangleBar',
          "\u29D0\u0338": 'NotRightTriangleBar',
          "\u29DC": 'iinfin',
          "\u29DD": 'infintie',
          "\u29DE": 'nvinfin',
          "\u29E3": 'eparsl',
          "\u29E4": 'smeparsl',
          "\u29E5": 'eqvparsl',
          "\u29EB": 'lozf',
          "\u29F4": 'RuleDelayed',
          "\u29F6": 'dsol',
          "\u2A00": 'xodot',
          "\u2A01": 'xoplus',
          "\u2A02": 'xotime',
          "\u2A04": 'xuplus',
          "\u2A06": 'xsqcup',
          "\u2A0D": 'fpartint',
          "\u2A10": 'cirfnint',
          "\u2A11": 'awint',
          "\u2A12": 'rppolint',
          "\u2A13": 'scpolint',
          "\u2A14": 'npolint',
          "\u2A15": 'pointint',
          "\u2A16": 'quatint',
          "\u2A17": 'intlarhk',
          "\u2A22": 'pluscir',
          "\u2A23": 'plusacir',
          "\u2A24": 'simplus',
          "\u2A25": 'plusdu',
          "\u2A26": 'plussim',
          "\u2A27": 'plustwo',
          "\u2A29": 'mcomma',
          "\u2A2A": 'minusdu',
          "\u2A2D": 'loplus',
          "\u2A2E": 'roplus',
          "\u2A2F": 'Cross',
          "\u2A30": 'timesd',
          "\u2A31": 'timesbar',
          "\u2A33": 'smashp',
          "\u2A34": 'lotimes',
          "\u2A35": 'rotimes',
          "\u2A36": 'otimesas',
          "\u2A37": 'Otimes',
          "\u2A38": 'odiv',
          "\u2A39": 'triplus',
          "\u2A3A": 'triminus',
          "\u2A3B": 'tritime',
          "\u2A3C": 'iprod',
          "\u2A3F": 'amalg',
          "\u2A40": 'capdot',
          "\u2A42": 'ncup',
          "\u2A43": 'ncap',
          "\u2A44": 'capand',
          "\u2A45": 'cupor',
          "\u2A46": 'cupcap',
          "\u2A47": 'capcup',
          "\u2A48": 'cupbrcap',
          "\u2A49": 'capbrcup',
          "\u2A4A": 'cupcup',
          "\u2A4B": 'capcap',
          "\u2A4C": 'ccups',
          "\u2A4D": 'ccaps',
          "\u2A50": 'ccupssm',
          "\u2A53": 'And',
          "\u2A54": 'Or',
          "\u2A55": 'andand',
          "\u2A56": 'oror',
          "\u2A57": 'orslope',
          "\u2A58": 'andslope',
          "\u2A5A": 'andv',
          "\u2A5B": 'orv',
          "\u2A5C": 'andd',
          "\u2A5D": 'ord',
          "\u2A5F": 'wedbar',
          "\u2A66": 'sdote',
          "\u2A6A": 'simdot',
          "\u2A6D": 'congdot',
          "\u2A6D\u0338": 'ncongdot',
          "\u2A6E": 'easter',
          "\u2A6F": 'apacir',
          "\u2A70": 'apE',
          "\u2A70\u0338": 'napE',
          "\u2A71": 'eplus',
          "\u2A72": 'pluse',
          "\u2A73": 'Esim',
          "\u2A77": 'eDDot',
          "\u2A78": 'equivDD',
          "\u2A79": 'ltcir',
          "\u2A7A": 'gtcir',
          "\u2A7B": 'ltquest',
          "\u2A7C": 'gtquest',
          "\u2A7D": 'les',
          "\u2A7D\u0338": 'nles',
          "\u2A7E": 'ges',
          "\u2A7E\u0338": 'nges',
          "\u2A7F": 'lesdot',
          "\u2A80": 'gesdot',
          "\u2A81": 'lesdoto',
          "\u2A82": 'gesdoto',
          "\u2A83": 'lesdotor',
          "\u2A84": 'gesdotol',
          "\u2A85": 'lap',
          "\u2A86": 'gap',
          "\u2A87": 'lne',
          "\u2A88": 'gne',
          "\u2A89": 'lnap',
          "\u2A8A": 'gnap',
          "\u2A8B": 'lEg',
          "\u2A8C": 'gEl',
          "\u2A8D": 'lsime',
          "\u2A8E": 'gsime',
          "\u2A8F": 'lsimg',
          "\u2A90": 'gsiml',
          "\u2A91": 'lgE',
          "\u2A92": 'glE',
          "\u2A93": 'lesges',
          "\u2A94": 'gesles',
          "\u2A95": 'els',
          "\u2A96": 'egs',
          "\u2A97": 'elsdot',
          "\u2A98": 'egsdot',
          "\u2A99": 'el',
          "\u2A9A": 'eg',
          "\u2A9D": 'siml',
          "\u2A9E": 'simg',
          "\u2A9F": 'simlE',
          "\u2AA0": 'simgE',
          "\u2AA1": 'LessLess',
          "\u2AA1\u0338": 'NotNestedLessLess',
          "\u2AA2": 'GreaterGreater',
          "\u2AA2\u0338": 'NotNestedGreaterGreater',
          "\u2AA4": 'glj',
          "\u2AA5": 'gla',
          "\u2AA6": 'ltcc',
          "\u2AA7": 'gtcc',
          "\u2AA8": 'lescc',
          "\u2AA9": 'gescc',
          "\u2AAA": 'smt',
          "\u2AAB": 'lat',
          "\u2AAC": 'smte',
          "\u2AAC\uFE00": 'smtes',
          "\u2AAD": 'late',
          "\u2AAD\uFE00": 'lates',
          "\u2AAE": 'bumpE',
          "\u2AAF": 'pre',
          "\u2AAF\u0338": 'npre',
          "\u2AB0": 'sce',
          "\u2AB0\u0338": 'nsce',
          "\u2AB3": 'prE',
          "\u2AB4": 'scE',
          "\u2AB5": 'prnE',
          "\u2AB6": 'scnE',
          "\u2AB7": 'prap',
          "\u2AB8": 'scap',
          "\u2AB9": 'prnap',
          "\u2ABA": 'scnap',
          "\u2ABB": 'Pr',
          "\u2ABC": 'Sc',
          "\u2ABD": 'subdot',
          "\u2ABE": 'supdot',
          "\u2ABF": 'subplus',
          "\u2AC0": 'supplus',
          "\u2AC1": 'submult',
          "\u2AC2": 'supmult',
          "\u2AC3": 'subedot',
          "\u2AC4": 'supedot',
          "\u2AC5": 'subE',
          "\u2AC5\u0338": 'nsubE',
          "\u2AC6": 'supE',
          "\u2AC6\u0338": 'nsupE',
          "\u2AC7": 'subsim',
          "\u2AC8": 'supsim',
          "\u2ACB\uFE00": 'vsubnE',
          "\u2ACB": 'subnE',
          "\u2ACC\uFE00": 'vsupnE',
          "\u2ACC": 'supnE',
          "\u2ACF": 'csub',
          "\u2AD0": 'csup',
          "\u2AD1": 'csube',
          "\u2AD2": 'csupe',
          "\u2AD3": 'subsup',
          "\u2AD4": 'supsub',
          "\u2AD5": 'subsub',
          "\u2AD6": 'supsup',
          "\u2AD7": 'suphsub',
          "\u2AD8": 'supdsub',
          "\u2AD9": 'forkv',
          "\u2ADA": 'topfork',
          "\u2ADB": 'mlcp',
          "\u2AE4": 'Dashv',
          "\u2AE6": 'Vdashl',
          "\u2AE7": 'Barv',
          "\u2AE8": 'vBar',
          "\u2AE9": 'vBarv',
          "\u2AEB": 'Vbar',
          "\u2AEC": 'Not',
          "\u2AED": 'bNot',
          "\u2AEE": 'rnmid',
          "\u2AEF": 'cirmid',
          "\u2AF0": 'midcir',
          "\u2AF1": 'topcir',
          "\u2AF2": 'nhpar',
          "\u2AF3": 'parsim',
          "\u2AFD": 'parsl',
          "\u2AFD\u20E5": 'nparsl',
          "\u266D": 'flat',
          "\u266E": 'natur',
          "\u266F": 'sharp',
          '\xA4': 'curren',
          '\xA2': 'cent',
          '$': 'dollar',
          '\xA3': 'pound',
          '\xA5': 'yen',
          "\u20AC": 'euro',
          '\xB9': 'sup1',
          '\xBD': 'half',
          "\u2153": 'frac13',
          '\xBC': 'frac14',
          "\u2155": 'frac15',
          "\u2159": 'frac16',
          "\u215B": 'frac18',
          '\xB2': 'sup2',
          "\u2154": 'frac23',
          "\u2156": 'frac25',
          '\xB3': 'sup3',
          '\xBE': 'frac34',
          "\u2157": 'frac35',
          "\u215C": 'frac38',
          "\u2158": 'frac45',
          "\u215A": 'frac56',
          "\u215D": 'frac58',
          "\u215E": 'frac78',
          "\uD835\uDCB6": 'ascr',
          "\uD835\uDD52": 'aopf',
          "\uD835\uDD1E": 'afr',
          "\uD835\uDD38": 'Aopf',
          "\uD835\uDD04": 'Afr',
          "\uD835\uDC9C": 'Ascr',
          '\xAA': 'ordf',
          '\xE1': 'aacute',
          '\xC1': 'Aacute',
          '\xE0': 'agrave',
          '\xC0': 'Agrave',
          "\u0103": 'abreve',
          "\u0102": 'Abreve',
          '\xE2': 'acirc',
          '\xC2': 'Acirc',
          '\xE5': 'aring',
          '\xC5': 'angst',
          '\xE4': 'auml',
          '\xC4': 'Auml',
          '\xE3': 'atilde',
          '\xC3': 'Atilde',
          "\u0105": 'aogon',
          "\u0104": 'Aogon',
          "\u0101": 'amacr',
          "\u0100": 'Amacr',
          '\xE6': 'aelig',
          '\xC6': 'AElig',
          "\uD835\uDCB7": 'bscr',
          "\uD835\uDD53": 'bopf',
          "\uD835\uDD1F": 'bfr',
          "\uD835\uDD39": 'Bopf',
          "\u212C": 'Bscr',
          "\uD835\uDD05": 'Bfr',
          "\uD835\uDD20": 'cfr',
          "\uD835\uDCB8": 'cscr',
          "\uD835\uDD54": 'copf',
          "\u212D": 'Cfr',
          "\uD835\uDC9E": 'Cscr',
          "\u2102": 'Copf',
          "\u0107": 'cacute',
          "\u0106": 'Cacute',
          "\u0109": 'ccirc',
          "\u0108": 'Ccirc',
          "\u010D": 'ccaron',
          "\u010C": 'Ccaron',
          "\u010B": 'cdot',
          "\u010A": 'Cdot',
          '\xE7': 'ccedil',
          '\xC7': 'Ccedil',
          "\u2105": 'incare',
          "\uD835\uDD21": 'dfr',
          "\u2146": 'dd',
          "\uD835\uDD55": 'dopf',
          "\uD835\uDCB9": 'dscr',
          "\uD835\uDC9F": 'Dscr',
          "\uD835\uDD07": 'Dfr',
          "\u2145": 'DD',
          "\uD835\uDD3B": 'Dopf',
          "\u010F": 'dcaron',
          "\u010E": 'Dcaron',
          "\u0111": 'dstrok',
          "\u0110": 'Dstrok',
          '\xF0': 'eth',
          '\xD0': 'ETH',
          "\u2147": 'ee',
          "\u212F": 'escr',
          "\uD835\uDD22": 'efr',
          "\uD835\uDD56": 'eopf',
          "\u2130": 'Escr',
          "\uD835\uDD08": 'Efr',
          "\uD835\uDD3C": 'Eopf',
          '\xE9': 'eacute',
          '\xC9': 'Eacute',
          '\xE8': 'egrave',
          '\xC8': 'Egrave',
          '\xEA': 'ecirc',
          '\xCA': 'Ecirc',
          "\u011B": 'ecaron',
          "\u011A": 'Ecaron',
          '\xEB': 'euml',
          '\xCB': 'Euml',
          "\u0117": 'edot',
          "\u0116": 'Edot',
          "\u0119": 'eogon',
          "\u0118": 'Eogon',
          "\u0113": 'emacr',
          "\u0112": 'Emacr',
          "\uD835\uDD23": 'ffr',
          "\uD835\uDD57": 'fopf',
          "\uD835\uDCBB": 'fscr',
          "\uD835\uDD09": 'Ffr',
          "\uD835\uDD3D": 'Fopf',
          "\u2131": 'Fscr',
          "\uFB00": 'fflig',
          "\uFB03": 'ffilig',
          "\uFB04": 'ffllig',
          "\uFB01": 'filig',
          'fj': 'fjlig',
          "\uFB02": 'fllig',
          "\u0192": 'fnof',
          "\u210A": 'gscr',
          "\uD835\uDD58": 'gopf',
          "\uD835\uDD24": 'gfr',
          "\uD835\uDCA2": 'Gscr',
          "\uD835\uDD3E": 'Gopf',
          "\uD835\uDD0A": 'Gfr',
          "\u01F5": 'gacute',
          "\u011F": 'gbreve',
          "\u011E": 'Gbreve',
          "\u011D": 'gcirc',
          "\u011C": 'Gcirc',
          "\u0121": 'gdot',
          "\u0120": 'Gdot',
          "\u0122": 'Gcedil',
          "\uD835\uDD25": 'hfr',
          "\u210E": 'planckh',
          "\uD835\uDCBD": 'hscr',
          "\uD835\uDD59": 'hopf',
          "\u210B": 'Hscr',
          "\u210C": 'Hfr',
          "\u210D": 'Hopf',
          "\u0125": 'hcirc',
          "\u0124": 'Hcirc',
          "\u210F": 'hbar',
          "\u0127": 'hstrok',
          "\u0126": 'Hstrok',
          "\uD835\uDD5A": 'iopf',
          "\uD835\uDD26": 'ifr',
          "\uD835\uDCBE": 'iscr',
          "\u2148": 'ii',
          "\uD835\uDD40": 'Iopf',
          "\u2110": 'Iscr',
          "\u2111": 'Im',
          '\xED': 'iacute',
          '\xCD': 'Iacute',
          '\xEC': 'igrave',
          '\xCC': 'Igrave',
          '\xEE': 'icirc',
          '\xCE': 'Icirc',
          '\xEF': 'iuml',
          '\xCF': 'Iuml',
          "\u0129": 'itilde',
          "\u0128": 'Itilde',
          "\u0130": 'Idot',
          "\u012F": 'iogon',
          "\u012E": 'Iogon',
          "\u012B": 'imacr',
          "\u012A": 'Imacr',
          "\u0133": 'ijlig',
          "\u0132": 'IJlig',
          "\u0131": 'imath',
          "\uD835\uDCBF": 'jscr',
          "\uD835\uDD5B": 'jopf',
          "\uD835\uDD27": 'jfr',
          "\uD835\uDCA5": 'Jscr',
          "\uD835\uDD0D": 'Jfr',
          "\uD835\uDD41": 'Jopf',
          "\u0135": 'jcirc',
          "\u0134": 'Jcirc',
          "\u0237": 'jmath',
          "\uD835\uDD5C": 'kopf',
          "\uD835\uDCC0": 'kscr',
          "\uD835\uDD28": 'kfr',
          "\uD835\uDCA6": 'Kscr',
          "\uD835\uDD42": 'Kopf',
          "\uD835\uDD0E": 'Kfr',
          "\u0137": 'kcedil',
          "\u0136": 'Kcedil',
          "\uD835\uDD29": 'lfr',
          "\uD835\uDCC1": 'lscr',
          "\u2113": 'ell',
          "\uD835\uDD5D": 'lopf',
          "\u2112": 'Lscr',
          "\uD835\uDD0F": 'Lfr',
          "\uD835\uDD43": 'Lopf',
          "\u013A": 'lacute',
          "\u0139": 'Lacute',
          "\u013E": 'lcaron',
          "\u013D": 'Lcaron',
          "\u013C": 'lcedil',
          "\u013B": 'Lcedil',
          "\u0142": 'lstrok',
          "\u0141": 'Lstrok',
          "\u0140": 'lmidot',
          "\u013F": 'Lmidot',
          "\uD835\uDD2A": 'mfr',
          "\uD835\uDD5E": 'mopf',
          "\uD835\uDCC2": 'mscr',
          "\uD835\uDD10": 'Mfr',
          "\uD835\uDD44": 'Mopf',
          "\u2133": 'Mscr',
          "\uD835\uDD2B": 'nfr',
          "\uD835\uDD5F": 'nopf',
          "\uD835\uDCC3": 'nscr',
          "\u2115": 'Nopf',
          "\uD835\uDCA9": 'Nscr',
          "\uD835\uDD11": 'Nfr',
          "\u0144": 'nacute',
          "\u0143": 'Nacute',
          "\u0148": 'ncaron',
          "\u0147": 'Ncaron',
          '\xF1': 'ntilde',
          '\xD1': 'Ntilde',
          "\u0146": 'ncedil',
          "\u0145": 'Ncedil',
          "\u2116": 'numero',
          "\u014B": 'eng',
          "\u014A": 'ENG',
          "\uD835\uDD60": 'oopf',
          "\uD835\uDD2C": 'ofr',
          "\u2134": 'oscr',
          "\uD835\uDCAA": 'Oscr',
          "\uD835\uDD12": 'Ofr',
          "\uD835\uDD46": 'Oopf',
          '\xBA': 'ordm',
          '\xF3': 'oacute',
          '\xD3': 'Oacute',
          '\xF2': 'ograve',
          '\xD2': 'Ograve',
          '\xF4': 'ocirc',
          '\xD4': 'Ocirc',
          '\xF6': 'ouml',
          '\xD6': 'Ouml',
          "\u0151": 'odblac',
          "\u0150": 'Odblac',
          '\xF5': 'otilde',
          '\xD5': 'Otilde',
          '\xF8': 'oslash',
          '\xD8': 'Oslash',
          "\u014D": 'omacr',
          "\u014C": 'Omacr',
          "\u0153": 'oelig',
          "\u0152": 'OElig',
          "\uD835\uDD2D": 'pfr',
          "\uD835\uDCC5": 'pscr',
          "\uD835\uDD61": 'popf',
          "\u2119": 'Popf',
          "\uD835\uDD13": 'Pfr',
          "\uD835\uDCAB": 'Pscr',
          "\uD835\uDD62": 'qopf',
          "\uD835\uDD2E": 'qfr',
          "\uD835\uDCC6": 'qscr',
          "\uD835\uDCAC": 'Qscr',
          "\uD835\uDD14": 'Qfr',
          "\u211A": 'Qopf',
          "\u0138": 'kgreen',
          "\uD835\uDD2F": 'rfr',
          "\uD835\uDD63": 'ropf',
          "\uD835\uDCC7": 'rscr',
          "\u211B": 'Rscr',
          "\u211C": 'Re',
          "\u211D": 'Ropf',
          "\u0155": 'racute',
          "\u0154": 'Racute',
          "\u0159": 'rcaron',
          "\u0158": 'Rcaron',
          "\u0157": 'rcedil',
          "\u0156": 'Rcedil',
          "\uD835\uDD64": 'sopf',
          "\uD835\uDCC8": 'sscr',
          "\uD835\uDD30": 'sfr',
          "\uD835\uDD4A": 'Sopf',
          "\uD835\uDD16": 'Sfr',
          "\uD835\uDCAE": 'Sscr',
          "\u24C8": 'oS',
          "\u015B": 'sacute',
          "\u015A": 'Sacute',
          "\u015D": 'scirc',
          "\u015C": 'Scirc',
          "\u0161": 'scaron',
          "\u0160": 'Scaron',
          "\u015F": 'scedil',
          "\u015E": 'Scedil',
          '\xDF': 'szlig',
          "\uD835\uDD31": 'tfr',
          "\uD835\uDCC9": 'tscr',
          "\uD835\uDD65": 'topf',
          "\uD835\uDCAF": 'Tscr',
          "\uD835\uDD17": 'Tfr',
          "\uD835\uDD4B": 'Topf',
          "\u0165": 'tcaron',
          "\u0164": 'Tcaron',
          "\u0163": 'tcedil',
          "\u0162": 'Tcedil',
          "\u2122": 'trade',
          "\u0167": 'tstrok',
          "\u0166": 'Tstrok',
          "\uD835\uDCCA": 'uscr',
          "\uD835\uDD66": 'uopf',
          "\uD835\uDD32": 'ufr',
          "\uD835\uDD4C": 'Uopf',
          "\uD835\uDD18": 'Ufr',
          "\uD835\uDCB0": 'Uscr',
          '\xFA': 'uacute',
          '\xDA': 'Uacute',
          '\xF9': 'ugrave',
          '\xD9': 'Ugrave',
          "\u016D": 'ubreve',
          "\u016C": 'Ubreve',
          '\xFB': 'ucirc',
          '\xDB': 'Ucirc',
          "\u016F": 'uring',
          "\u016E": 'Uring',
          '\xFC': 'uuml',
          '\xDC': 'Uuml',
          "\u0171": 'udblac',
          "\u0170": 'Udblac',
          "\u0169": 'utilde',
          "\u0168": 'Utilde',
          "\u0173": 'uogon',
          "\u0172": 'Uogon',
          "\u016B": 'umacr',
          "\u016A": 'Umacr',
          "\uD835\uDD33": 'vfr',
          "\uD835\uDD67": 'vopf',
          "\uD835\uDCCB": 'vscr',
          "\uD835\uDD19": 'Vfr',
          "\uD835\uDD4D": 'Vopf',
          "\uD835\uDCB1": 'Vscr',
          "\uD835\uDD68": 'wopf',
          "\uD835\uDCCC": 'wscr',
          "\uD835\uDD34": 'wfr',
          "\uD835\uDCB2": 'Wscr',
          "\uD835\uDD4E": 'Wopf',
          "\uD835\uDD1A": 'Wfr',
          "\u0175": 'wcirc',
          "\u0174": 'Wcirc',
          "\uD835\uDD35": 'xfr',
          "\uD835\uDCCD": 'xscr',
          "\uD835\uDD69": 'xopf',
          "\uD835\uDD4F": 'Xopf',
          "\uD835\uDD1B": 'Xfr',
          "\uD835\uDCB3": 'Xscr',
          "\uD835\uDD36": 'yfr',
          "\uD835\uDCCE": 'yscr',
          "\uD835\uDD6A": 'yopf',
          "\uD835\uDCB4": 'Yscr',
          "\uD835\uDD1C": 'Yfr',
          "\uD835\uDD50": 'Yopf',
          '\xFD': 'yacute',
          '\xDD': 'Yacute',
          "\u0177": 'ycirc',
          "\u0176": 'Ycirc',
          '\xFF': 'yuml',
          "\u0178": 'Yuml',
          "\uD835\uDCCF": 'zscr',
          "\uD835\uDD37": 'zfr',
          "\uD835\uDD6B": 'zopf',
          "\u2128": 'Zfr',
          "\u2124": 'Zopf',
          "\uD835\uDCB5": 'Zscr',
          "\u017A": 'zacute',
          "\u0179": 'Zacute',
          "\u017E": 'zcaron',
          "\u017D": 'Zcaron',
          "\u017C": 'zdot',
          "\u017B": 'Zdot',
          "\u01B5": 'imped',
          '\xFE': 'thorn',
          '\xDE': 'THORN',
          "\u0149": 'napos',
          "\u03B1": 'alpha',
          "\u0391": 'Alpha',
          "\u03B2": 'beta',
          "\u0392": 'Beta',
          "\u03B3": 'gamma',
          "\u0393": 'Gamma',
          "\u03B4": 'delta',
          "\u0394": 'Delta',
          "\u03B5": 'epsi',
          "\u03F5": 'epsiv',
          "\u0395": 'Epsilon',
          "\u03DD": 'gammad',
          "\u03DC": 'Gammad',
          "\u03B6": 'zeta',
          "\u0396": 'Zeta',
          "\u03B7": 'eta',
          "\u0397": 'Eta',
          "\u03B8": 'theta',
          "\u03D1": 'thetav',
          "\u0398": 'Theta',
          "\u03B9": 'iota',
          "\u0399": 'Iota',
          "\u03BA": 'kappa',
          "\u03F0": 'kappav',
          "\u039A": 'Kappa',
          "\u03BB": 'lambda',
          "\u039B": 'Lambda',
          "\u03BC": 'mu',
          '\xB5': 'micro',
          "\u039C": 'Mu',
          "\u03BD": 'nu',
          "\u039D": 'Nu',
          "\u03BE": 'xi',
          "\u039E": 'Xi',
          "\u03BF": 'omicron',
          "\u039F": 'Omicron',
          "\u03C0": 'pi',
          "\u03D6": 'piv',
          "\u03A0": 'Pi',
          "\u03C1": 'rho',
          "\u03F1": 'rhov',
          "\u03A1": 'Rho',
          "\u03C3": 'sigma',
          "\u03A3": 'Sigma',
          "\u03C2": 'sigmaf',
          "\u03C4": 'tau',
          "\u03A4": 'Tau',
          "\u03C5": 'upsi',
          "\u03A5": 'Upsilon',
          "\u03D2": 'Upsi',
          "\u03C6": 'phi',
          "\u03D5": 'phiv',
          "\u03A6": 'Phi',
          "\u03C7": 'chi',
          "\u03A7": 'Chi',
          "\u03C8": 'psi',
          "\u03A8": 'Psi',
          "\u03C9": 'omega',
          "\u03A9": 'ohm',
          "\u0430": 'acy',
          "\u0410": 'Acy',
          "\u0431": 'bcy',
          "\u0411": 'Bcy',
          "\u0432": 'vcy',
          "\u0412": 'Vcy',
          "\u0433": 'gcy',
          "\u0413": 'Gcy',
          "\u0453": 'gjcy',
          "\u0403": 'GJcy',
          "\u0434": 'dcy',
          "\u0414": 'Dcy',
          "\u0452": 'djcy',
          "\u0402": 'DJcy',
          "\u0435": 'iecy',
          "\u0415": 'IEcy',
          "\u0451": 'iocy',
          "\u0401": 'IOcy',
          "\u0454": 'jukcy',
          "\u0404": 'Jukcy',
          "\u0436": 'zhcy',
          "\u0416": 'ZHcy',
          "\u0437": 'zcy',
          "\u0417": 'Zcy',
          "\u0455": 'dscy',
          "\u0405": 'DScy',
          "\u0438": 'icy',
          "\u0418": 'Icy',
          "\u0456": 'iukcy',
          "\u0406": 'Iukcy',
          "\u0457": 'yicy',
          "\u0407": 'YIcy',
          "\u0439": 'jcy',
          "\u0419": 'Jcy',
          "\u0458": 'jsercy',
          "\u0408": 'Jsercy',
          "\u043A": 'kcy',
          "\u041A": 'Kcy',
          "\u045C": 'kjcy',
          "\u040C": 'KJcy',
          "\u043B": 'lcy',
          "\u041B": 'Lcy',
          "\u0459": 'ljcy',
          "\u0409": 'LJcy',
          "\u043C": 'mcy',
          "\u041C": 'Mcy',
          "\u043D": 'ncy',
          "\u041D": 'Ncy',
          "\u045A": 'njcy',
          "\u040A": 'NJcy',
          "\u043E": 'ocy',
          "\u041E": 'Ocy',
          "\u043F": 'pcy',
          "\u041F": 'Pcy',
          "\u0440": 'rcy',
          "\u0420": 'Rcy',
          "\u0441": 'scy',
          "\u0421": 'Scy',
          "\u0442": 'tcy',
          "\u0422": 'Tcy',
          "\u045B": 'tshcy',
          "\u040B": 'TSHcy',
          "\u0443": 'ucy',
          "\u0423": 'Ucy',
          "\u045E": 'ubrcy',
          "\u040E": 'Ubrcy',
          "\u0444": 'fcy',
          "\u0424": 'Fcy',
          "\u0445": 'khcy',
          "\u0425": 'KHcy',
          "\u0446": 'tscy',
          "\u0426": 'TScy',
          "\u0447": 'chcy',
          "\u0427": 'CHcy',
          "\u045F": 'dzcy',
          "\u040F": 'DZcy',
          "\u0448": 'shcy',
          "\u0428": 'SHcy',
          "\u0449": 'shchcy',
          "\u0429": 'SHCHcy',
          "\u044A": 'hardcy',
          "\u042A": 'HARDcy',
          "\u044B": 'ycy',
          "\u042B": 'Ycy',
          "\u044C": 'softcy',
          "\u042C": 'SOFTcy',
          "\u044D": 'ecy',
          "\u042D": 'Ecy',
          "\u044E": 'yucy',
          "\u042E": 'YUcy',
          "\u044F": 'yacy',
          "\u042F": 'YAcy',
          "\u2135": 'aleph',
          "\u2136": 'beth',
          "\u2137": 'gimel',
          "\u2138": 'daleth'
        };
        var regexEscape = /["&'<>`]/g;
        var escapeMap = {
          '"': '&quot;',
          '&': '&amp;',
          '\'': '&#x27;',
          '<': '&lt;',
          // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
          // following is not strictly necessary unless it’s part of a tag or an
          // unquoted attribute value. We’re only escaping it to support those
          // situations, and for XML support.
          '>': '&gt;',
          // In Internet Explorer ≤ 8, the backtick character can be used
          // to break out of (un)quoted attribute values or HTML comments.
          // See http://html5sec.org/#102, http://html5sec.org/#108, and
          // http://html5sec.org/#133.
          '`': '&#x60;'
        };
        var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
        var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
        var regexDecode = /&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)([=a-zA-Z0-9])?/g;
        var decodeMap = {
          'aacute': '\xE1',
          'Aacute': '\xC1',
          'abreve': "\u0103",
          'Abreve': "\u0102",
          'ac': "\u223E",
          'acd': "\u223F",
          'acE': "\u223E\u0333",
          'acirc': '\xE2',
          'Acirc': '\xC2',
          'acute': '\xB4',
          'acy': "\u0430",
          'Acy': "\u0410",
          'aelig': '\xE6',
          'AElig': '\xC6',
          'af': "\u2061",
          'afr': "\uD835\uDD1E",
          'Afr': "\uD835\uDD04",
          'agrave': '\xE0',
          'Agrave': '\xC0',
          'alefsym': "\u2135",
          'aleph': "\u2135",
          'alpha': "\u03B1",
          'Alpha': "\u0391",
          'amacr': "\u0101",
          'Amacr': "\u0100",
          'amalg': "\u2A3F",
          'amp': '&',
          'AMP': '&',
          'and': "\u2227",
          'And': "\u2A53",
          'andand': "\u2A55",
          'andd': "\u2A5C",
          'andslope': "\u2A58",
          'andv': "\u2A5A",
          'ang': "\u2220",
          'ange': "\u29A4",
          'angle': "\u2220",
          'angmsd': "\u2221",
          'angmsdaa': "\u29A8",
          'angmsdab': "\u29A9",
          'angmsdac': "\u29AA",
          'angmsdad': "\u29AB",
          'angmsdae': "\u29AC",
          'angmsdaf': "\u29AD",
          'angmsdag': "\u29AE",
          'angmsdah': "\u29AF",
          'angrt': "\u221F",
          'angrtvb': "\u22BE",
          'angrtvbd': "\u299D",
          'angsph': "\u2222",
          'angst': '\xC5',
          'angzarr': "\u237C",
          'aogon': "\u0105",
          'Aogon': "\u0104",
          'aopf': "\uD835\uDD52",
          'Aopf': "\uD835\uDD38",
          'ap': "\u2248",
          'apacir': "\u2A6F",
          'ape': "\u224A",
          'apE': "\u2A70",
          'apid': "\u224B",
          'apos': '\'',
          'ApplyFunction': "\u2061",
          'approx': "\u2248",
          'approxeq': "\u224A",
          'aring': '\xE5',
          'Aring': '\xC5',
          'ascr': "\uD835\uDCB6",
          'Ascr': "\uD835\uDC9C",
          'Assign': "\u2254",
          'ast': '*',
          'asymp': "\u2248",
          'asympeq': "\u224D",
          'atilde': '\xE3',
          'Atilde': '\xC3',
          'auml': '\xE4',
          'Auml': '\xC4',
          'awconint': "\u2233",
          'awint': "\u2A11",
          'backcong': "\u224C",
          'backepsilon': "\u03F6",
          'backprime': "\u2035",
          'backsim': "\u223D",
          'backsimeq': "\u22CD",
          'Backslash': "\u2216",
          'Barv': "\u2AE7",
          'barvee': "\u22BD",
          'barwed': "\u2305",
          'Barwed': "\u2306",
          'barwedge': "\u2305",
          'bbrk': "\u23B5",
          'bbrktbrk': "\u23B6",
          'bcong': "\u224C",
          'bcy': "\u0431",
          'Bcy': "\u0411",
          'bdquo': "\u201E",
          'becaus': "\u2235",
          'because': "\u2235",
          'Because': "\u2235",
          'bemptyv': "\u29B0",
          'bepsi': "\u03F6",
          'bernou': "\u212C",
          'Bernoullis': "\u212C",
          'beta': "\u03B2",
          'Beta': "\u0392",
          'beth': "\u2136",
          'between': "\u226C",
          'bfr': "\uD835\uDD1F",
          'Bfr': "\uD835\uDD05",
          'bigcap': "\u22C2",
          'bigcirc': "\u25EF",
          'bigcup': "\u22C3",
          'bigodot': "\u2A00",
          'bigoplus': "\u2A01",
          'bigotimes': "\u2A02",
          'bigsqcup': "\u2A06",
          'bigstar': "\u2605",
          'bigtriangledown': "\u25BD",
          'bigtriangleup': "\u25B3",
          'biguplus': "\u2A04",
          'bigvee': "\u22C1",
          'bigwedge': "\u22C0",
          'bkarow': "\u290D",
          'blacklozenge': "\u29EB",
          'blacksquare': "\u25AA",
          'blacktriangle': "\u25B4",
          'blacktriangledown': "\u25BE",
          'blacktriangleleft': "\u25C2",
          'blacktriangleright': "\u25B8",
          'blank': "\u2423",
          'blk12': "\u2592",
          'blk14': "\u2591",
          'blk34': "\u2593",
          'block': "\u2588",
          'bne': "=\u20E5",
          'bnequiv': "\u2261\u20E5",
          'bnot': "\u2310",
          'bNot': "\u2AED",
          'bopf': "\uD835\uDD53",
          'Bopf': "\uD835\uDD39",
          'bot': "\u22A5",
          'bottom': "\u22A5",
          'bowtie': "\u22C8",
          'boxbox': "\u29C9",
          'boxdl': "\u2510",
          'boxdL': "\u2555",
          'boxDl': "\u2556",
          'boxDL': "\u2557",
          'boxdr': "\u250C",
          'boxdR': "\u2552",
          'boxDr': "\u2553",
          'boxDR': "\u2554",
          'boxh': "\u2500",
          'boxH': "\u2550",
          'boxhd': "\u252C",
          'boxhD': "\u2565",
          'boxHd': "\u2564",
          'boxHD': "\u2566",
          'boxhu': "\u2534",
          'boxhU': "\u2568",
          'boxHu': "\u2567",
          'boxHU': "\u2569",
          'boxminus': "\u229F",
          'boxplus': "\u229E",
          'boxtimes': "\u22A0",
          'boxul': "\u2518",
          'boxuL': "\u255B",
          'boxUl': "\u255C",
          'boxUL': "\u255D",
          'boxur': "\u2514",
          'boxuR': "\u2558",
          'boxUr': "\u2559",
          'boxUR': "\u255A",
          'boxv': "\u2502",
          'boxV': "\u2551",
          'boxvh': "\u253C",
          'boxvH': "\u256A",
          'boxVh': "\u256B",
          'boxVH': "\u256C",
          'boxvl': "\u2524",
          'boxvL': "\u2561",
          'boxVl': "\u2562",
          'boxVL': "\u2563",
          'boxvr': "\u251C",
          'boxvR': "\u255E",
          'boxVr': "\u255F",
          'boxVR': "\u2560",
          'bprime': "\u2035",
          'breve': "\u02D8",
          'Breve': "\u02D8",
          'brvbar': '\xA6',
          'bscr': "\uD835\uDCB7",
          'Bscr': "\u212C",
          'bsemi': "\u204F",
          'bsim': "\u223D",
          'bsime': "\u22CD",
          'bsol': '\\',
          'bsolb': "\u29C5",
          'bsolhsub': "\u27C8",
          'bull': "\u2022",
          'bullet': "\u2022",
          'bump': "\u224E",
          'bumpe': "\u224F",
          'bumpE': "\u2AAE",
          'bumpeq': "\u224F",
          'Bumpeq': "\u224E",
          'cacute': "\u0107",
          'Cacute': "\u0106",
          'cap': "\u2229",
          'Cap': "\u22D2",
          'capand': "\u2A44",
          'capbrcup': "\u2A49",
          'capcap': "\u2A4B",
          'capcup': "\u2A47",
          'capdot': "\u2A40",
          'CapitalDifferentialD': "\u2145",
          'caps': "\u2229\uFE00",
          'caret': "\u2041",
          'caron': "\u02C7",
          'Cayleys': "\u212D",
          'ccaps': "\u2A4D",
          'ccaron': "\u010D",
          'Ccaron': "\u010C",
          'ccedil': '\xE7',
          'Ccedil': '\xC7',
          'ccirc': "\u0109",
          'Ccirc': "\u0108",
          'Cconint': "\u2230",
          'ccups': "\u2A4C",
          'ccupssm': "\u2A50",
          'cdot': "\u010B",
          'Cdot': "\u010A",
          'cedil': '\xB8',
          'Cedilla': '\xB8',
          'cemptyv': "\u29B2",
          'cent': '\xA2',
          'centerdot': '\xB7',
          'CenterDot': '\xB7',
          'cfr': "\uD835\uDD20",
          'Cfr': "\u212D",
          'chcy': "\u0447",
          'CHcy': "\u0427",
          'check': "\u2713",
          'checkmark': "\u2713",
          'chi': "\u03C7",
          'Chi': "\u03A7",
          'cir': "\u25CB",
          'circ': "\u02C6",
          'circeq': "\u2257",
          'circlearrowleft': "\u21BA",
          'circlearrowright': "\u21BB",
          'circledast': "\u229B",
          'circledcirc': "\u229A",
          'circleddash': "\u229D",
          'CircleDot': "\u2299",
          'circledR': '\xAE',
          'circledS': "\u24C8",
          'CircleMinus': "\u2296",
          'CirclePlus': "\u2295",
          'CircleTimes': "\u2297",
          'cire': "\u2257",
          'cirE': "\u29C3",
          'cirfnint': "\u2A10",
          'cirmid': "\u2AEF",
          'cirscir': "\u29C2",
          'ClockwiseContourIntegral': "\u2232",
          'CloseCurlyDoubleQuote': "\u201D",
          'CloseCurlyQuote': "\u2019",
          'clubs': "\u2663",
          'clubsuit': "\u2663",
          'colon': ':',
          'Colon': "\u2237",
          'colone': "\u2254",
          'Colone': "\u2A74",
          'coloneq': "\u2254",
          'comma': ',',
          'commat': '@',
          'comp': "\u2201",
          'compfn': "\u2218",
          'complement': "\u2201",
          'complexes': "\u2102",
          'cong': "\u2245",
          'congdot': "\u2A6D",
          'Congruent': "\u2261",
          'conint': "\u222E",
          'Conint': "\u222F",
          'ContourIntegral': "\u222E",
          'copf': "\uD835\uDD54",
          'Copf': "\u2102",
          'coprod': "\u2210",
          'Coproduct': "\u2210",
          'copy': '\xA9',
          'COPY': '\xA9',
          'copysr': "\u2117",
          'CounterClockwiseContourIntegral': "\u2233",
          'crarr': "\u21B5",
          'cross': "\u2717",
          'Cross': "\u2A2F",
          'cscr': "\uD835\uDCB8",
          'Cscr': "\uD835\uDC9E",
          'csub': "\u2ACF",
          'csube': "\u2AD1",
          'csup': "\u2AD0",
          'csupe': "\u2AD2",
          'ctdot': "\u22EF",
          'cudarrl': "\u2938",
          'cudarrr': "\u2935",
          'cuepr': "\u22DE",
          'cuesc': "\u22DF",
          'cularr': "\u21B6",
          'cularrp': "\u293D",
          'cup': "\u222A",
          'Cup': "\u22D3",
          'cupbrcap': "\u2A48",
          'cupcap': "\u2A46",
          'CupCap': "\u224D",
          'cupcup': "\u2A4A",
          'cupdot': "\u228D",
          'cupor': "\u2A45",
          'cups': "\u222A\uFE00",
          'curarr': "\u21B7",
          'curarrm': "\u293C",
          'curlyeqprec': "\u22DE",
          'curlyeqsucc': "\u22DF",
          'curlyvee': "\u22CE",
          'curlywedge': "\u22CF",
          'curren': '\xA4',
          'curvearrowleft': "\u21B6",
          'curvearrowright': "\u21B7",
          'cuvee': "\u22CE",
          'cuwed': "\u22CF",
          'cwconint': "\u2232",
          'cwint': "\u2231",
          'cylcty': "\u232D",
          'dagger': "\u2020",
          'Dagger': "\u2021",
          'daleth': "\u2138",
          'darr': "\u2193",
          'dArr': "\u21D3",
          'Darr': "\u21A1",
          'dash': "\u2010",
          'dashv': "\u22A3",
          'Dashv': "\u2AE4",
          'dbkarow': "\u290F",
          'dblac': "\u02DD",
          'dcaron': "\u010F",
          'Dcaron': "\u010E",
          'dcy': "\u0434",
          'Dcy': "\u0414",
          'dd': "\u2146",
          'DD': "\u2145",
          'ddagger': "\u2021",
          'ddarr': "\u21CA",
          'DDotrahd': "\u2911",
          'ddotseq': "\u2A77",
          'deg': '\xB0',
          'Del': "\u2207",
          'delta': "\u03B4",
          'Delta': "\u0394",
          'demptyv': "\u29B1",
          'dfisht': "\u297F",
          'dfr': "\uD835\uDD21",
          'Dfr': "\uD835\uDD07",
          'dHar': "\u2965",
          'dharl': "\u21C3",
          'dharr': "\u21C2",
          'DiacriticalAcute': '\xB4',
          'DiacriticalDot': "\u02D9",
          'DiacriticalDoubleAcute': "\u02DD",
          'DiacriticalGrave': '`',
          'DiacriticalTilde': "\u02DC",
          'diam': "\u22C4",
          'diamond': "\u22C4",
          'Diamond': "\u22C4",
          'diamondsuit': "\u2666",
          'diams': "\u2666",
          'die': '\xA8',
          'DifferentialD': "\u2146",
          'digamma': "\u03DD",
          'disin': "\u22F2",
          'div': '\xF7',
          'divide': '\xF7',
          'divideontimes': "\u22C7",
          'divonx': "\u22C7",
          'djcy': "\u0452",
          'DJcy': "\u0402",
          'dlcorn': "\u231E",
          'dlcrop': "\u230D",
          'dollar': '$',
          'dopf': "\uD835\uDD55",
          'Dopf': "\uD835\uDD3B",
          'dot': "\u02D9",
          'Dot': '\xA8',
          'DotDot': "\u20DC",
          'doteq': "\u2250",
          'doteqdot': "\u2251",
          'DotEqual': "\u2250",
          'dotminus': "\u2238",
          'dotplus': "\u2214",
          'dotsquare': "\u22A1",
          'doublebarwedge': "\u2306",
          'DoubleContourIntegral': "\u222F",
          'DoubleDot': '\xA8',
          'DoubleDownArrow': "\u21D3",
          'DoubleLeftArrow': "\u21D0",
          'DoubleLeftRightArrow': "\u21D4",
          'DoubleLeftTee': "\u2AE4",
          'DoubleLongLeftArrow': "\u27F8",
          'DoubleLongLeftRightArrow': "\u27FA",
          'DoubleLongRightArrow': "\u27F9",
          'DoubleRightArrow': "\u21D2",
          'DoubleRightTee': "\u22A8",
          'DoubleUpArrow': "\u21D1",
          'DoubleUpDownArrow': "\u21D5",
          'DoubleVerticalBar': "\u2225",
          'downarrow': "\u2193",
          'Downarrow': "\u21D3",
          'DownArrow': "\u2193",
          'DownArrowBar': "\u2913",
          'DownArrowUpArrow': "\u21F5",
          'DownBreve': "\u0311",
          'downdownarrows': "\u21CA",
          'downharpoonleft': "\u21C3",
          'downharpoonright': "\u21C2",
          'DownLeftRightVector': "\u2950",
          'DownLeftTeeVector': "\u295E",
          'DownLeftVector': "\u21BD",
          'DownLeftVectorBar': "\u2956",
          'DownRightTeeVector': "\u295F",
          'DownRightVector': "\u21C1",
          'DownRightVectorBar': "\u2957",
          'DownTee': "\u22A4",
          'DownTeeArrow': "\u21A7",
          'drbkarow': "\u2910",
          'drcorn': "\u231F",
          'drcrop': "\u230C",
          'dscr': "\uD835\uDCB9",
          'Dscr': "\uD835\uDC9F",
          'dscy': "\u0455",
          'DScy': "\u0405",
          'dsol': "\u29F6",
          'dstrok': "\u0111",
          'Dstrok': "\u0110",
          'dtdot': "\u22F1",
          'dtri': "\u25BF",
          'dtrif': "\u25BE",
          'duarr': "\u21F5",
          'duhar': "\u296F",
          'dwangle': "\u29A6",
          'dzcy': "\u045F",
          'DZcy': "\u040F",
          'dzigrarr': "\u27FF",
          'eacute': '\xE9',
          'Eacute': '\xC9',
          'easter': "\u2A6E",
          'ecaron': "\u011B",
          'Ecaron': "\u011A",
          'ecir': "\u2256",
          'ecirc': '\xEA',
          'Ecirc': '\xCA',
          'ecolon': "\u2255",
          'ecy': "\u044D",
          'Ecy': "\u042D",
          'eDDot': "\u2A77",
          'edot': "\u0117",
          'eDot': "\u2251",
          'Edot': "\u0116",
          'ee': "\u2147",
          'efDot': "\u2252",
          'efr': "\uD835\uDD22",
          'Efr': "\uD835\uDD08",
          'eg': "\u2A9A",
          'egrave': '\xE8',
          'Egrave': '\xC8',
          'egs': "\u2A96",
          'egsdot': "\u2A98",
          'el': "\u2A99",
          'Element': "\u2208",
          'elinters': "\u23E7",
          'ell': "\u2113",
          'els': "\u2A95",
          'elsdot': "\u2A97",
          'emacr': "\u0113",
          'Emacr': "\u0112",
          'empty': "\u2205",
          'emptyset': "\u2205",
          'EmptySmallSquare': "\u25FB",
          'emptyv': "\u2205",
          'EmptyVerySmallSquare': "\u25AB",
          'emsp': "\u2003",
          'emsp13': "\u2004",
          'emsp14': "\u2005",
          'eng': "\u014B",
          'ENG': "\u014A",
          'ensp': "\u2002",
          'eogon': "\u0119",
          'Eogon': "\u0118",
          'eopf': "\uD835\uDD56",
          'Eopf': "\uD835\uDD3C",
          'epar': "\u22D5",
          'eparsl': "\u29E3",
          'eplus': "\u2A71",
          'epsi': "\u03B5",
          'epsilon': "\u03B5",
          'Epsilon': "\u0395",
          'epsiv': "\u03F5",
          'eqcirc': "\u2256",
          'eqcolon': "\u2255",
          'eqsim': "\u2242",
          'eqslantgtr': "\u2A96",
          'eqslantless': "\u2A95",
          'Equal': "\u2A75",
          'equals': '=',
          'EqualTilde': "\u2242",
          'equest': "\u225F",
          'Equilibrium': "\u21CC",
          'equiv': "\u2261",
          'equivDD': "\u2A78",
          'eqvparsl': "\u29E5",
          'erarr': "\u2971",
          'erDot': "\u2253",
          'escr': "\u212F",
          'Escr': "\u2130",
          'esdot': "\u2250",
          'esim': "\u2242",
          'Esim': "\u2A73",
          'eta': "\u03B7",
          'Eta': "\u0397",
          'eth': '\xF0',
          'ETH': '\xD0',
          'euml': '\xEB',
          'Euml': '\xCB',
          'euro': "\u20AC",
          'excl': '!',
          'exist': "\u2203",
          'Exists': "\u2203",
          'expectation': "\u2130",
          'exponentiale': "\u2147",
          'ExponentialE': "\u2147",
          'fallingdotseq': "\u2252",
          'fcy': "\u0444",
          'Fcy': "\u0424",
          'female': "\u2640",
          'ffilig': "\uFB03",
          'fflig': "\uFB00",
          'ffllig': "\uFB04",
          'ffr': "\uD835\uDD23",
          'Ffr': "\uD835\uDD09",
          'filig': "\uFB01",
          'FilledSmallSquare': "\u25FC",
          'FilledVerySmallSquare': "\u25AA",
          'fjlig': 'fj',
          'flat': "\u266D",
          'fllig': "\uFB02",
          'fltns': "\u25B1",
          'fnof': "\u0192",
          'fopf': "\uD835\uDD57",
          'Fopf': "\uD835\uDD3D",
          'forall': "\u2200",
          'ForAll': "\u2200",
          'fork': "\u22D4",
          'forkv': "\u2AD9",
          'Fouriertrf': "\u2131",
          'fpartint': "\u2A0D",
          'frac12': '\xBD',
          'frac13': "\u2153",
          'frac14': '\xBC',
          'frac15': "\u2155",
          'frac16': "\u2159",
          'frac18': "\u215B",
          'frac23': "\u2154",
          'frac25': "\u2156",
          'frac34': '\xBE',
          'frac35': "\u2157",
          'frac38': "\u215C",
          'frac45': "\u2158",
          'frac56': "\u215A",
          'frac58': "\u215D",
          'frac78': "\u215E",
          'frasl': "\u2044",
          'frown': "\u2322",
          'fscr': "\uD835\uDCBB",
          'Fscr': "\u2131",
          'gacute': "\u01F5",
          'gamma': "\u03B3",
          'Gamma': "\u0393",
          'gammad': "\u03DD",
          'Gammad': "\u03DC",
          'gap': "\u2A86",
          'gbreve': "\u011F",
          'Gbreve': "\u011E",
          'Gcedil': "\u0122",
          'gcirc': "\u011D",
          'Gcirc': "\u011C",
          'gcy': "\u0433",
          'Gcy': "\u0413",
          'gdot': "\u0121",
          'Gdot': "\u0120",
          'ge': "\u2265",
          'gE': "\u2267",
          'gel': "\u22DB",
          'gEl': "\u2A8C",
          'geq': "\u2265",
          'geqq': "\u2267",
          'geqslant': "\u2A7E",
          'ges': "\u2A7E",
          'gescc': "\u2AA9",
          'gesdot': "\u2A80",
          'gesdoto': "\u2A82",
          'gesdotol': "\u2A84",
          'gesl': "\u22DB\uFE00",
          'gesles': "\u2A94",
          'gfr': "\uD835\uDD24",
          'Gfr': "\uD835\uDD0A",
          'gg': "\u226B",
          'Gg': "\u22D9",
          'ggg': "\u22D9",
          'gimel': "\u2137",
          'gjcy': "\u0453",
          'GJcy': "\u0403",
          'gl': "\u2277",
          'gla': "\u2AA5",
          'glE': "\u2A92",
          'glj': "\u2AA4",
          'gnap': "\u2A8A",
          'gnapprox': "\u2A8A",
          'gne': "\u2A88",
          'gnE': "\u2269",
          'gneq': "\u2A88",
          'gneqq': "\u2269",
          'gnsim': "\u22E7",
          'gopf': "\uD835\uDD58",
          'Gopf': "\uD835\uDD3E",
          'grave': '`',
          'GreaterEqual': "\u2265",
          'GreaterEqualLess': "\u22DB",
          'GreaterFullEqual': "\u2267",
          'GreaterGreater': "\u2AA2",
          'GreaterLess': "\u2277",
          'GreaterSlantEqual': "\u2A7E",
          'GreaterTilde': "\u2273",
          'gscr': "\u210A",
          'Gscr': "\uD835\uDCA2",
          'gsim': "\u2273",
          'gsime': "\u2A8E",
          'gsiml': "\u2A90",
          'gt': '>',
          'Gt': "\u226B",
          'GT': '>',
          'gtcc': "\u2AA7",
          'gtcir': "\u2A7A",
          'gtdot': "\u22D7",
          'gtlPar': "\u2995",
          'gtquest': "\u2A7C",
          'gtrapprox': "\u2A86",
          'gtrarr': "\u2978",
          'gtrdot': "\u22D7",
          'gtreqless': "\u22DB",
          'gtreqqless': "\u2A8C",
          'gtrless': "\u2277",
          'gtrsim': "\u2273",
          'gvertneqq': "\u2269\uFE00",
          'gvnE': "\u2269\uFE00",
          'Hacek': "\u02C7",
          'hairsp': "\u200A",
          'half': '\xBD',
          'hamilt': "\u210B",
          'hardcy': "\u044A",
          'HARDcy': "\u042A",
          'harr': "\u2194",
          'hArr': "\u21D4",
          'harrcir': "\u2948",
          'harrw': "\u21AD",
          'Hat': '^',
          'hbar': "\u210F",
          'hcirc': "\u0125",
          'Hcirc': "\u0124",
          'hearts': "\u2665",
          'heartsuit': "\u2665",
          'hellip': "\u2026",
          'hercon': "\u22B9",
          'hfr': "\uD835\uDD25",
          'Hfr': "\u210C",
          'HilbertSpace': "\u210B",
          'hksearow': "\u2925",
          'hkswarow': "\u2926",
          'hoarr': "\u21FF",
          'homtht': "\u223B",
          'hookleftarrow': "\u21A9",
          'hookrightarrow': "\u21AA",
          'hopf': "\uD835\uDD59",
          'Hopf': "\u210D",
          'horbar': "\u2015",
          'HorizontalLine': "\u2500",
          'hscr': "\uD835\uDCBD",
          'Hscr': "\u210B",
          'hslash': "\u210F",
          'hstrok': "\u0127",
          'Hstrok': "\u0126",
          'HumpDownHump': "\u224E",
          'HumpEqual': "\u224F",
          'hybull': "\u2043",
          'hyphen': "\u2010",
          'iacute': '\xED',
          'Iacute': '\xCD',
          'ic': "\u2063",
          'icirc': '\xEE',
          'Icirc': '\xCE',
          'icy': "\u0438",
          'Icy': "\u0418",
          'Idot': "\u0130",
          'iecy': "\u0435",
          'IEcy': "\u0415",
          'iexcl': '\xA1',
          'iff': "\u21D4",
          'ifr': "\uD835\uDD26",
          'Ifr': "\u2111",
          'igrave': '\xEC',
          'Igrave': '\xCC',
          'ii': "\u2148",
          'iiiint': "\u2A0C",
          'iiint': "\u222D",
          'iinfin': "\u29DC",
          'iiota': "\u2129",
          'ijlig': "\u0133",
          'IJlig': "\u0132",
          'Im': "\u2111",
          'imacr': "\u012B",
          'Imacr': "\u012A",
          'image': "\u2111",
          'ImaginaryI': "\u2148",
          'imagline': "\u2110",
          'imagpart': "\u2111",
          'imath': "\u0131",
          'imof': "\u22B7",
          'imped': "\u01B5",
          'Implies': "\u21D2",
          'in': "\u2208",
          'incare': "\u2105",
          'infin': "\u221E",
          'infintie': "\u29DD",
          'inodot': "\u0131",
          'int': "\u222B",
          'Int': "\u222C",
          'intcal': "\u22BA",
          'integers': "\u2124",
          'Integral': "\u222B",
          'intercal': "\u22BA",
          'Intersection': "\u22C2",
          'intlarhk': "\u2A17",
          'intprod': "\u2A3C",
          'InvisibleComma': "\u2063",
          'InvisibleTimes': "\u2062",
          'iocy': "\u0451",
          'IOcy': "\u0401",
          'iogon': "\u012F",
          'Iogon': "\u012E",
          'iopf': "\uD835\uDD5A",
          'Iopf': "\uD835\uDD40",
          'iota': "\u03B9",
          'Iota': "\u0399",
          'iprod': "\u2A3C",
          'iquest': '\xBF',
          'iscr': "\uD835\uDCBE",
          'Iscr': "\u2110",
          'isin': "\u2208",
          'isindot': "\u22F5",
          'isinE': "\u22F9",
          'isins': "\u22F4",
          'isinsv': "\u22F3",
          'isinv': "\u2208",
          'it': "\u2062",
          'itilde': "\u0129",
          'Itilde': "\u0128",
          'iukcy': "\u0456",
          'Iukcy': "\u0406",
          'iuml': '\xEF',
          'Iuml': '\xCF',
          'jcirc': "\u0135",
          'Jcirc': "\u0134",
          'jcy': "\u0439",
          'Jcy': "\u0419",
          'jfr': "\uD835\uDD27",
          'Jfr': "\uD835\uDD0D",
          'jmath': "\u0237",
          'jopf': "\uD835\uDD5B",
          'Jopf': "\uD835\uDD41",
          'jscr': "\uD835\uDCBF",
          'Jscr': "\uD835\uDCA5",
          'jsercy': "\u0458",
          'Jsercy': "\u0408",
          'jukcy': "\u0454",
          'Jukcy': "\u0404",
          'kappa': "\u03BA",
          'Kappa': "\u039A",
          'kappav': "\u03F0",
          'kcedil': "\u0137",
          'Kcedil': "\u0136",
          'kcy': "\u043A",
          'Kcy': "\u041A",
          'kfr': "\uD835\uDD28",
          'Kfr': "\uD835\uDD0E",
          'kgreen': "\u0138",
          'khcy': "\u0445",
          'KHcy': "\u0425",
          'kjcy': "\u045C",
          'KJcy': "\u040C",
          'kopf': "\uD835\uDD5C",
          'Kopf': "\uD835\uDD42",
          'kscr': "\uD835\uDCC0",
          'Kscr': "\uD835\uDCA6",
          'lAarr': "\u21DA",
          'lacute': "\u013A",
          'Lacute': "\u0139",
          'laemptyv': "\u29B4",
          'lagran': "\u2112",
          'lambda': "\u03BB",
          'Lambda': "\u039B",
          'lang': "\u27E8",
          'Lang': "\u27EA",
          'langd': "\u2991",
          'langle': "\u27E8",
          'lap': "\u2A85",
          'Laplacetrf': "\u2112",
          'laquo': '\xAB',
          'larr': "\u2190",
          'lArr': "\u21D0",
          'Larr': "\u219E",
          'larrb': "\u21E4",
          'larrbfs': "\u291F",
          'larrfs': "\u291D",
          'larrhk': "\u21A9",
          'larrlp': "\u21AB",
          'larrpl': "\u2939",
          'larrsim': "\u2973",
          'larrtl': "\u21A2",
          'lat': "\u2AAB",
          'latail': "\u2919",
          'lAtail': "\u291B",
          'late': "\u2AAD",
          'lates': "\u2AAD\uFE00",
          'lbarr': "\u290C",
          'lBarr': "\u290E",
          'lbbrk': "\u2772",
          'lbrace': '{',
          'lbrack': '[',
          'lbrke': "\u298B",
          'lbrksld': "\u298F",
          'lbrkslu': "\u298D",
          'lcaron': "\u013E",
          'Lcaron': "\u013D",
          'lcedil': "\u013C",
          'Lcedil': "\u013B",
          'lceil': "\u2308",
          'lcub': '{',
          'lcy': "\u043B",
          'Lcy': "\u041B",
          'ldca': "\u2936",
          'ldquo': "\u201C",
          'ldquor': "\u201E",
          'ldrdhar': "\u2967",
          'ldrushar': "\u294B",
          'ldsh': "\u21B2",
          'le': "\u2264",
          'lE': "\u2266",
          'LeftAngleBracket': "\u27E8",
          'leftarrow': "\u2190",
          'Leftarrow': "\u21D0",
          'LeftArrow': "\u2190",
          'LeftArrowBar': "\u21E4",
          'LeftArrowRightArrow': "\u21C6",
          'leftarrowtail': "\u21A2",
          'LeftCeiling': "\u2308",
          'LeftDoubleBracket': "\u27E6",
          'LeftDownTeeVector': "\u2961",
          'LeftDownVector': "\u21C3",
          'LeftDownVectorBar': "\u2959",
          'LeftFloor': "\u230A",
          'leftharpoondown': "\u21BD",
          'leftharpoonup': "\u21BC",
          'leftleftarrows': "\u21C7",
          'leftrightarrow': "\u2194",
          'Leftrightarrow': "\u21D4",
          'LeftRightArrow': "\u2194",
          'leftrightarrows': "\u21C6",
          'leftrightharpoons': "\u21CB",
          'leftrightsquigarrow': "\u21AD",
          'LeftRightVector': "\u294E",
          'LeftTee': "\u22A3",
          'LeftTeeArrow': "\u21A4",
          'LeftTeeVector': "\u295A",
          'leftthreetimes': "\u22CB",
          'LeftTriangle': "\u22B2",
          'LeftTriangleBar': "\u29CF",
          'LeftTriangleEqual': "\u22B4",
          'LeftUpDownVector': "\u2951",
          'LeftUpTeeVector': "\u2960",
          'LeftUpVector': "\u21BF",
          'LeftUpVectorBar': "\u2958",
          'LeftVector': "\u21BC",
          'LeftVectorBar': "\u2952",
          'leg': "\u22DA",
          'lEg': "\u2A8B",
          'leq': "\u2264",
          'leqq': "\u2266",
          'leqslant': "\u2A7D",
          'les': "\u2A7D",
          'lescc': "\u2AA8",
          'lesdot': "\u2A7F",
          'lesdoto': "\u2A81",
          'lesdotor': "\u2A83",
          'lesg': "\u22DA\uFE00",
          'lesges': "\u2A93",
          'lessapprox': "\u2A85",
          'lessdot': "\u22D6",
          'lesseqgtr': "\u22DA",
          'lesseqqgtr': "\u2A8B",
          'LessEqualGreater': "\u22DA",
          'LessFullEqual': "\u2266",
          'LessGreater': "\u2276",
          'lessgtr': "\u2276",
          'LessLess': "\u2AA1",
          'lesssim': "\u2272",
          'LessSlantEqual': "\u2A7D",
          'LessTilde': "\u2272",
          'lfisht': "\u297C",
          'lfloor': "\u230A",
          'lfr': "\uD835\uDD29",
          'Lfr': "\uD835\uDD0F",
          'lg': "\u2276",
          'lgE': "\u2A91",
          'lHar': "\u2962",
          'lhard': "\u21BD",
          'lharu': "\u21BC",
          'lharul': "\u296A",
          'lhblk': "\u2584",
          'ljcy': "\u0459",
          'LJcy': "\u0409",
          'll': "\u226A",
          'Ll': "\u22D8",
          'llarr': "\u21C7",
          'llcorner': "\u231E",
          'Lleftarrow': "\u21DA",
          'llhard': "\u296B",
          'lltri': "\u25FA",
          'lmidot': "\u0140",
          'Lmidot': "\u013F",
          'lmoust': "\u23B0",
          'lmoustache': "\u23B0",
          'lnap': "\u2A89",
          'lnapprox': "\u2A89",
          'lne': "\u2A87",
          'lnE': "\u2268",
          'lneq': "\u2A87",
          'lneqq': "\u2268",
          'lnsim': "\u22E6",
          'loang': "\u27EC",
          'loarr': "\u21FD",
          'lobrk': "\u27E6",
          'longleftarrow': "\u27F5",
          'Longleftarrow': "\u27F8",
          'LongLeftArrow': "\u27F5",
          'longleftrightarrow': "\u27F7",
          'Longleftrightarrow': "\u27FA",
          'LongLeftRightArrow': "\u27F7",
          'longmapsto': "\u27FC",
          'longrightarrow': "\u27F6",
          'Longrightarrow': "\u27F9",
          'LongRightArrow': "\u27F6",
          'looparrowleft': "\u21AB",
          'looparrowright': "\u21AC",
          'lopar': "\u2985",
          'lopf': "\uD835\uDD5D",
          'Lopf': "\uD835\uDD43",
          'loplus': "\u2A2D",
          'lotimes': "\u2A34",
          'lowast': "\u2217",
          'lowbar': '_',
          'LowerLeftArrow': "\u2199",
          'LowerRightArrow': "\u2198",
          'loz': "\u25CA",
          'lozenge': "\u25CA",
          'lozf': "\u29EB",
          'lpar': '(',
          'lparlt': "\u2993",
          'lrarr': "\u21C6",
          'lrcorner': "\u231F",
          'lrhar': "\u21CB",
          'lrhard': "\u296D",
          'lrm': "\u200E",
          'lrtri': "\u22BF",
          'lsaquo': "\u2039",
          'lscr': "\uD835\uDCC1",
          'Lscr': "\u2112",
          'lsh': "\u21B0",
          'Lsh': "\u21B0",
          'lsim': "\u2272",
          'lsime': "\u2A8D",
          'lsimg': "\u2A8F",
          'lsqb': '[',
          'lsquo': "\u2018",
          'lsquor': "\u201A",
          'lstrok': "\u0142",
          'Lstrok': "\u0141",
          'lt': '<',
          'Lt': "\u226A",
          'LT': '<',
          'ltcc': "\u2AA6",
          'ltcir': "\u2A79",
          'ltdot': "\u22D6",
          'lthree': "\u22CB",
          'ltimes': "\u22C9",
          'ltlarr': "\u2976",
          'ltquest': "\u2A7B",
          'ltri': "\u25C3",
          'ltrie': "\u22B4",
          'ltrif': "\u25C2",
          'ltrPar': "\u2996",
          'lurdshar': "\u294A",
          'luruhar': "\u2966",
          'lvertneqq': "\u2268\uFE00",
          'lvnE': "\u2268\uFE00",
          'macr': '\xAF',
          'male': "\u2642",
          'malt': "\u2720",
          'maltese': "\u2720",
          'map': "\u21A6",
          'Map': "\u2905",
          'mapsto': "\u21A6",
          'mapstodown': "\u21A7",
          'mapstoleft': "\u21A4",
          'mapstoup': "\u21A5",
          'marker': "\u25AE",
          'mcomma': "\u2A29",
          'mcy': "\u043C",
          'Mcy': "\u041C",
          'mdash': "\u2014",
          'mDDot': "\u223A",
          'measuredangle': "\u2221",
          'MediumSpace': "\u205F",
          'Mellintrf': "\u2133",
          'mfr': "\uD835\uDD2A",
          'Mfr': "\uD835\uDD10",
          'mho': "\u2127",
          'micro': '\xB5',
          'mid': "\u2223",
          'midast': '*',
          'midcir': "\u2AF0",
          'middot': '\xB7',
          'minus': "\u2212",
          'minusb': "\u229F",
          'minusd': "\u2238",
          'minusdu': "\u2A2A",
          'MinusPlus': "\u2213",
          'mlcp': "\u2ADB",
          'mldr': "\u2026",
          'mnplus': "\u2213",
          'models': "\u22A7",
          'mopf': "\uD835\uDD5E",
          'Mopf': "\uD835\uDD44",
          'mp': "\u2213",
          'mscr': "\uD835\uDCC2",
          'Mscr': "\u2133",
          'mstpos': "\u223E",
          'mu': "\u03BC",
          'Mu': "\u039C",
          'multimap': "\u22B8",
          'mumap': "\u22B8",
          'nabla': "\u2207",
          'nacute': "\u0144",
          'Nacute': "\u0143",
          'nang': "\u2220\u20D2",
          'nap': "\u2249",
          'napE': "\u2A70\u0338",
          'napid': "\u224B\u0338",
          'napos': "\u0149",
          'napprox': "\u2249",
          'natur': "\u266E",
          'natural': "\u266E",
          'naturals': "\u2115",
          'nbsp': '\xA0',
          'nbump': "\u224E\u0338",
          'nbumpe': "\u224F\u0338",
          'ncap': "\u2A43",
          'ncaron': "\u0148",
          'Ncaron': "\u0147",
          'ncedil': "\u0146",
          'Ncedil': "\u0145",
          'ncong': "\u2247",
          'ncongdot': "\u2A6D\u0338",
          'ncup': "\u2A42",
          'ncy': "\u043D",
          'Ncy': "\u041D",
          'ndash': "\u2013",
          'ne': "\u2260",
          'nearhk': "\u2924",
          'nearr': "\u2197",
          'neArr': "\u21D7",
          'nearrow': "\u2197",
          'nedot': "\u2250\u0338",
          'NegativeMediumSpace': "\u200B",
          'NegativeThickSpace': "\u200B",
          'NegativeThinSpace': "\u200B",
          'NegativeVeryThinSpace': "\u200B",
          'nequiv': "\u2262",
          'nesear': "\u2928",
          'nesim': "\u2242\u0338",
          'NestedGreaterGreater': "\u226B",
          'NestedLessLess': "\u226A",
          'NewLine': '\n',
          'nexist': "\u2204",
          'nexists': "\u2204",
          'nfr': "\uD835\uDD2B",
          'Nfr': "\uD835\uDD11",
          'nge': "\u2271",
          'ngE': "\u2267\u0338",
          'ngeq': "\u2271",
          'ngeqq': "\u2267\u0338",
          'ngeqslant': "\u2A7E\u0338",
          'nges': "\u2A7E\u0338",
          'nGg': "\u22D9\u0338",
          'ngsim': "\u2275",
          'ngt': "\u226F",
          'nGt': "\u226B\u20D2",
          'ngtr': "\u226F",
          'nGtv': "\u226B\u0338",
          'nharr': "\u21AE",
          'nhArr': "\u21CE",
          'nhpar': "\u2AF2",
          'ni': "\u220B",
          'nis': "\u22FC",
          'nisd': "\u22FA",
          'niv': "\u220B",
          'njcy': "\u045A",
          'NJcy': "\u040A",
          'nlarr': "\u219A",
          'nlArr': "\u21CD",
          'nldr': "\u2025",
          'nle': "\u2270",
          'nlE': "\u2266\u0338",
          'nleftarrow': "\u219A",
          'nLeftarrow': "\u21CD",
          'nleftrightarrow': "\u21AE",
          'nLeftrightarrow': "\u21CE",
          'nleq': "\u2270",
          'nleqq': "\u2266\u0338",
          'nleqslant': "\u2A7D\u0338",
          'nles': "\u2A7D\u0338",
          'nless': "\u226E",
          'nLl': "\u22D8\u0338",
          'nlsim': "\u2274",
          'nlt': "\u226E",
          'nLt': "\u226A\u20D2",
          'nltri': "\u22EA",
          'nltrie': "\u22EC",
          'nLtv': "\u226A\u0338",
          'nmid': "\u2224",
          'NoBreak': "\u2060",
          'NonBreakingSpace': '\xA0',
          'nopf': "\uD835\uDD5F",
          'Nopf': "\u2115",
          'not': '\xAC',
          'Not': "\u2AEC",
          'NotCongruent': "\u2262",
          'NotCupCap': "\u226D",
          'NotDoubleVerticalBar': "\u2226",
          'NotElement': "\u2209",
          'NotEqual': "\u2260",
          'NotEqualTilde': "\u2242\u0338",
          'NotExists': "\u2204",
          'NotGreater': "\u226F",
          'NotGreaterEqual': "\u2271",
          'NotGreaterFullEqual': "\u2267\u0338",
          'NotGreaterGreater': "\u226B\u0338",
          'NotGreaterLess': "\u2279",
          'NotGreaterSlantEqual': "\u2A7E\u0338",
          'NotGreaterTilde': "\u2275",
          'NotHumpDownHump': "\u224E\u0338",
          'NotHumpEqual': "\u224F\u0338",
          'notin': "\u2209",
          'notindot': "\u22F5\u0338",
          'notinE': "\u22F9\u0338",
          'notinva': "\u2209",
          'notinvb': "\u22F7",
          'notinvc': "\u22F6",
          'NotLeftTriangle': "\u22EA",
          'NotLeftTriangleBar': "\u29CF\u0338",
          'NotLeftTriangleEqual': "\u22EC",
          'NotLess': "\u226E",
          'NotLessEqual': "\u2270",
          'NotLessGreater': "\u2278",
          'NotLessLess': "\u226A\u0338",
          'NotLessSlantEqual': "\u2A7D\u0338",
          'NotLessTilde': "\u2274",
          'NotNestedGreaterGreater': "\u2AA2\u0338",
          'NotNestedLessLess': "\u2AA1\u0338",
          'notni': "\u220C",
          'notniva': "\u220C",
          'notnivb': "\u22FE",
          'notnivc': "\u22FD",
          'NotPrecedes': "\u2280",
          'NotPrecedesEqual': "\u2AAF\u0338",
          'NotPrecedesSlantEqual': "\u22E0",
          'NotReverseElement': "\u220C",
          'NotRightTriangle': "\u22EB",
          'NotRightTriangleBar': "\u29D0\u0338",
          'NotRightTriangleEqual': "\u22ED",
          'NotSquareSubset': "\u228F\u0338",
          'NotSquareSubsetEqual': "\u22E2",
          'NotSquareSuperset': "\u2290\u0338",
          'NotSquareSupersetEqual': "\u22E3",
          'NotSubset': "\u2282\u20D2",
          'NotSubsetEqual': "\u2288",
          'NotSucceeds': "\u2281",
          'NotSucceedsEqual': "\u2AB0\u0338",
          'NotSucceedsSlantEqual': "\u22E1",
          'NotSucceedsTilde': "\u227F\u0338",
          'NotSuperset': "\u2283\u20D2",
          'NotSupersetEqual': "\u2289",
          'NotTilde': "\u2241",
          'NotTildeEqual': "\u2244",
          'NotTildeFullEqual': "\u2247",
          'NotTildeTilde': "\u2249",
          'NotVerticalBar': "\u2224",
          'npar': "\u2226",
          'nparallel': "\u2226",
          'nparsl': "\u2AFD\u20E5",
          'npart': "\u2202\u0338",
          'npolint': "\u2A14",
          'npr': "\u2280",
          'nprcue': "\u22E0",
          'npre': "\u2AAF\u0338",
          'nprec': "\u2280",
          'npreceq': "\u2AAF\u0338",
          'nrarr': "\u219B",
          'nrArr': "\u21CF",
          'nrarrc': "\u2933\u0338",
          'nrarrw': "\u219D\u0338",
          'nrightarrow': "\u219B",
          'nRightarrow': "\u21CF",
          'nrtri': "\u22EB",
          'nrtrie': "\u22ED",
          'nsc': "\u2281",
          'nsccue': "\u22E1",
          'nsce': "\u2AB0\u0338",
          'nscr': "\uD835\uDCC3",
          'Nscr': "\uD835\uDCA9",
          'nshortmid': "\u2224",
          'nshortparallel': "\u2226",
          'nsim': "\u2241",
          'nsime': "\u2244",
          'nsimeq': "\u2244",
          'nsmid': "\u2224",
          'nspar': "\u2226",
          'nsqsube': "\u22E2",
          'nsqsupe': "\u22E3",
          'nsub': "\u2284",
          'nsube': "\u2288",
          'nsubE': "\u2AC5\u0338",
          'nsubset': "\u2282\u20D2",
          'nsubseteq': "\u2288",
          'nsubseteqq': "\u2AC5\u0338",
          'nsucc': "\u2281",
          'nsucceq': "\u2AB0\u0338",
          'nsup': "\u2285",
          'nsupe': "\u2289",
          'nsupE': "\u2AC6\u0338",
          'nsupset': "\u2283\u20D2",
          'nsupseteq': "\u2289",
          'nsupseteqq': "\u2AC6\u0338",
          'ntgl': "\u2279",
          'ntilde': '\xF1',
          'Ntilde': '\xD1',
          'ntlg': "\u2278",
          'ntriangleleft': "\u22EA",
          'ntrianglelefteq': "\u22EC",
          'ntriangleright': "\u22EB",
          'ntrianglerighteq': "\u22ED",
          'nu': "\u03BD",
          'Nu': "\u039D",
          'num': '#',
          'numero': "\u2116",
          'numsp': "\u2007",
          'nvap': "\u224D\u20D2",
          'nvdash': "\u22AC",
          'nvDash': "\u22AD",
          'nVdash': "\u22AE",
          'nVDash': "\u22AF",
          'nvge': "\u2265\u20D2",
          'nvgt': ">\u20D2",
          'nvHarr': "\u2904",
          'nvinfin': "\u29DE",
          'nvlArr': "\u2902",
          'nvle': "\u2264\u20D2",
          'nvlt': "<\u20D2",
          'nvltrie': "\u22B4\u20D2",
          'nvrArr': "\u2903",
          'nvrtrie': "\u22B5\u20D2",
          'nvsim': "\u223C\u20D2",
          'nwarhk': "\u2923",
          'nwarr': "\u2196",
          'nwArr': "\u21D6",
          'nwarrow': "\u2196",
          'nwnear': "\u2927",
          'oacute': '\xF3',
          'Oacute': '\xD3',
          'oast': "\u229B",
          'ocir': "\u229A",
          'ocirc': '\xF4',
          'Ocirc': '\xD4',
          'ocy': "\u043E",
          'Ocy': "\u041E",
          'odash': "\u229D",
          'odblac': "\u0151",
          'Odblac': "\u0150",
          'odiv': "\u2A38",
          'odot': "\u2299",
          'odsold': "\u29BC",
          'oelig': "\u0153",
          'OElig': "\u0152",
          'ofcir': "\u29BF",
          'ofr': "\uD835\uDD2C",
          'Ofr': "\uD835\uDD12",
          'ogon': "\u02DB",
          'ograve': '\xF2',
          'Ograve': '\xD2',
          'ogt': "\u29C1",
          'ohbar': "\u29B5",
          'ohm': "\u03A9",
          'oint': "\u222E",
          'olarr': "\u21BA",
          'olcir': "\u29BE",
          'olcross': "\u29BB",
          'oline': "\u203E",
          'olt': "\u29C0",
          'omacr': "\u014D",
          'Omacr': "\u014C",
          'omega': "\u03C9",
          'Omega': "\u03A9",
          'omicron': "\u03BF",
          'Omicron': "\u039F",
          'omid': "\u29B6",
          'ominus': "\u2296",
          'oopf': "\uD835\uDD60",
          'Oopf': "\uD835\uDD46",
          'opar': "\u29B7",
          'OpenCurlyDoubleQuote': "\u201C",
          'OpenCurlyQuote': "\u2018",
          'operp': "\u29B9",
          'oplus': "\u2295",
          'or': "\u2228",
          'Or': "\u2A54",
          'orarr': "\u21BB",
          'ord': "\u2A5D",
          'order': "\u2134",
          'orderof': "\u2134",
          'ordf': '\xAA',
          'ordm': '\xBA',
          'origof': "\u22B6",
          'oror': "\u2A56",
          'orslope': "\u2A57",
          'orv': "\u2A5B",
          'oS': "\u24C8",
          'oscr': "\u2134",
          'Oscr': "\uD835\uDCAA",
          'oslash': '\xF8',
          'Oslash': '\xD8',
          'osol': "\u2298",
          'otilde': '\xF5',
          'Otilde': '\xD5',
          'otimes': "\u2297",
          'Otimes': "\u2A37",
          'otimesas': "\u2A36",
          'ouml': '\xF6',
          'Ouml': '\xD6',
          'ovbar': "\u233D",
          'OverBar': "\u203E",
          'OverBrace': "\u23DE",
          'OverBracket': "\u23B4",
          'OverParenthesis': "\u23DC",
          'par': "\u2225",
          'para': '\xB6',
          'parallel': "\u2225",
          'parsim': "\u2AF3",
          'parsl': "\u2AFD",
          'part': "\u2202",
          'PartialD': "\u2202",
          'pcy': "\u043F",
          'Pcy': "\u041F",
          'percnt': '%',
          'period': '.',
          'permil': "\u2030",
          'perp': "\u22A5",
          'pertenk': "\u2031",
          'pfr': "\uD835\uDD2D",
          'Pfr': "\uD835\uDD13",
          'phi': "\u03C6",
          'Phi': "\u03A6",
          'phiv': "\u03D5",
          'phmmat': "\u2133",
          'phone': "\u260E",
          'pi': "\u03C0",
          'Pi': "\u03A0",
          'pitchfork': "\u22D4",
          'piv': "\u03D6",
          'planck': "\u210F",
          'planckh': "\u210E",
          'plankv': "\u210F",
          'plus': '+',
          'plusacir': "\u2A23",
          'plusb': "\u229E",
          'pluscir': "\u2A22",
          'plusdo': "\u2214",
          'plusdu': "\u2A25",
          'pluse': "\u2A72",
          'PlusMinus': '\xB1',
          'plusmn': '\xB1',
          'plussim': "\u2A26",
          'plustwo': "\u2A27",
          'pm': '\xB1',
          'Poincareplane': "\u210C",
          'pointint': "\u2A15",
          'popf': "\uD835\uDD61",
          'Popf': "\u2119",
          'pound': '\xA3',
          'pr': "\u227A",
          'Pr': "\u2ABB",
          'prap': "\u2AB7",
          'prcue': "\u227C",
          'pre': "\u2AAF",
          'prE': "\u2AB3",
          'prec': "\u227A",
          'precapprox': "\u2AB7",
          'preccurlyeq': "\u227C",
          'Precedes': "\u227A",
          'PrecedesEqual': "\u2AAF",
          'PrecedesSlantEqual': "\u227C",
          'PrecedesTilde': "\u227E",
          'preceq': "\u2AAF",
          'precnapprox': "\u2AB9",
          'precneqq': "\u2AB5",
          'precnsim': "\u22E8",
          'precsim': "\u227E",
          'prime': "\u2032",
          'Prime': "\u2033",
          'primes': "\u2119",
          'prnap': "\u2AB9",
          'prnE': "\u2AB5",
          'prnsim': "\u22E8",
          'prod': "\u220F",
          'Product': "\u220F",
          'profalar': "\u232E",
          'profline': "\u2312",
          'profsurf': "\u2313",
          'prop': "\u221D",
          'Proportion': "\u2237",
          'Proportional': "\u221D",
          'propto': "\u221D",
          'prsim': "\u227E",
          'prurel': "\u22B0",
          'pscr': "\uD835\uDCC5",
          'Pscr': "\uD835\uDCAB",
          'psi': "\u03C8",
          'Psi': "\u03A8",
          'puncsp': "\u2008",
          'qfr': "\uD835\uDD2E",
          'Qfr': "\uD835\uDD14",
          'qint': "\u2A0C",
          'qopf': "\uD835\uDD62",
          'Qopf': "\u211A",
          'qprime': "\u2057",
          'qscr': "\uD835\uDCC6",
          'Qscr': "\uD835\uDCAC",
          'quaternions': "\u210D",
          'quatint': "\u2A16",
          'quest': '?',
          'questeq': "\u225F",
          'quot': '"',
          'QUOT': '"',
          'rAarr': "\u21DB",
          'race': "\u223D\u0331",
          'racute': "\u0155",
          'Racute': "\u0154",
          'radic': "\u221A",
          'raemptyv': "\u29B3",
          'rang': "\u27E9",
          'Rang': "\u27EB",
          'rangd': "\u2992",
          'range': "\u29A5",
          'rangle': "\u27E9",
          'raquo': '\xBB',
          'rarr': "\u2192",
          'rArr': "\u21D2",
          'Rarr': "\u21A0",
          'rarrap': "\u2975",
          'rarrb': "\u21E5",
          'rarrbfs': "\u2920",
          'rarrc': "\u2933",
          'rarrfs': "\u291E",
          'rarrhk': "\u21AA",
          'rarrlp': "\u21AC",
          'rarrpl': "\u2945",
          'rarrsim': "\u2974",
          'rarrtl': "\u21A3",
          'Rarrtl': "\u2916",
          'rarrw': "\u219D",
          'ratail': "\u291A",
          'rAtail': "\u291C",
          'ratio': "\u2236",
          'rationals': "\u211A",
          'rbarr': "\u290D",
          'rBarr': "\u290F",
          'RBarr': "\u2910",
          'rbbrk': "\u2773",
          'rbrace': '}',
          'rbrack': ']',
          'rbrke': "\u298C",
          'rbrksld': "\u298E",
          'rbrkslu': "\u2990",
          'rcaron': "\u0159",
          'Rcaron': "\u0158",
          'rcedil': "\u0157",
          'Rcedil': "\u0156",
          'rceil': "\u2309",
          'rcub': '}',
          'rcy': "\u0440",
          'Rcy': "\u0420",
          'rdca': "\u2937",
          'rdldhar': "\u2969",
          'rdquo': "\u201D",
          'rdquor': "\u201D",
          'rdsh': "\u21B3",
          'Re': "\u211C",
          'real': "\u211C",
          'realine': "\u211B",
          'realpart': "\u211C",
          'reals': "\u211D",
          'rect': "\u25AD",
          'reg': '\xAE',
          'REG': '\xAE',
          'ReverseElement': "\u220B",
          'ReverseEquilibrium': "\u21CB",
          'ReverseUpEquilibrium': "\u296F",
          'rfisht': "\u297D",
          'rfloor': "\u230B",
          'rfr': "\uD835\uDD2F",
          'Rfr': "\u211C",
          'rHar': "\u2964",
          'rhard': "\u21C1",
          'rharu': "\u21C0",
          'rharul': "\u296C",
          'rho': "\u03C1",
          'Rho': "\u03A1",
          'rhov': "\u03F1",
          'RightAngleBracket': "\u27E9",
          'rightarrow': "\u2192",
          'Rightarrow': "\u21D2",
          'RightArrow': "\u2192",
          'RightArrowBar': "\u21E5",
          'RightArrowLeftArrow': "\u21C4",
          'rightarrowtail': "\u21A3",
          'RightCeiling': "\u2309",
          'RightDoubleBracket': "\u27E7",
          'RightDownTeeVector': "\u295D",
          'RightDownVector': "\u21C2",
          'RightDownVectorBar': "\u2955",
          'RightFloor': "\u230B",
          'rightharpoondown': "\u21C1",
          'rightharpoonup': "\u21C0",
          'rightleftarrows': "\u21C4",
          'rightleftharpoons': "\u21CC",
          'rightrightarrows': "\u21C9",
          'rightsquigarrow': "\u219D",
          'RightTee': "\u22A2",
          'RightTeeArrow': "\u21A6",
          'RightTeeVector': "\u295B",
          'rightthreetimes': "\u22CC",
          'RightTriangle': "\u22B3",
          'RightTriangleBar': "\u29D0",
          'RightTriangleEqual': "\u22B5",
          'RightUpDownVector': "\u294F",
          'RightUpTeeVector': "\u295C",
          'RightUpVector': "\u21BE",
          'RightUpVectorBar': "\u2954",
          'RightVector': "\u21C0",
          'RightVectorBar': "\u2953",
          'ring': "\u02DA",
          'risingdotseq': "\u2253",
          'rlarr': "\u21C4",
          'rlhar': "\u21CC",
          'rlm': "\u200F",
          'rmoust': "\u23B1",
          'rmoustache': "\u23B1",
          'rnmid': "\u2AEE",
          'roang': "\u27ED",
          'roarr': "\u21FE",
          'robrk': "\u27E7",
          'ropar': "\u2986",
          'ropf': "\uD835\uDD63",
          'Ropf': "\u211D",
          'roplus': "\u2A2E",
          'rotimes': "\u2A35",
          'RoundImplies': "\u2970",
          'rpar': ')',
          'rpargt': "\u2994",
          'rppolint': "\u2A12",
          'rrarr': "\u21C9",
          'Rrightarrow': "\u21DB",
          'rsaquo': "\u203A",
          'rscr': "\uD835\uDCC7",
          'Rscr': "\u211B",
          'rsh': "\u21B1",
          'Rsh': "\u21B1",
          'rsqb': ']',
          'rsquo': "\u2019",
          'rsquor': "\u2019",
          'rthree': "\u22CC",
          'rtimes': "\u22CA",
          'rtri': "\u25B9",
          'rtrie': "\u22B5",
          'rtrif': "\u25B8",
          'rtriltri': "\u29CE",
          'RuleDelayed': "\u29F4",
          'ruluhar': "\u2968",
          'rx': "\u211E",
          'sacute': "\u015B",
          'Sacute': "\u015A",
          'sbquo': "\u201A",
          'sc': "\u227B",
          'Sc': "\u2ABC",
          'scap': "\u2AB8",
          'scaron': "\u0161",
          'Scaron': "\u0160",
          'sccue': "\u227D",
          'sce': "\u2AB0",
          'scE': "\u2AB4",
          'scedil': "\u015F",
          'Scedil': "\u015E",
          'scirc': "\u015D",
          'Scirc': "\u015C",
          'scnap': "\u2ABA",
          'scnE': "\u2AB6",
          'scnsim': "\u22E9",
          'scpolint': "\u2A13",
          'scsim': "\u227F",
          'scy': "\u0441",
          'Scy': "\u0421",
          'sdot': "\u22C5",
          'sdotb': "\u22A1",
          'sdote': "\u2A66",
          'searhk': "\u2925",
          'searr': "\u2198",
          'seArr': "\u21D8",
          'searrow': "\u2198",
          'sect': '\xA7',
          'semi': ';',
          'seswar': "\u2929",
          'setminus': "\u2216",
          'setmn': "\u2216",
          'sext': "\u2736",
          'sfr': "\uD835\uDD30",
          'Sfr': "\uD835\uDD16",
          'sfrown': "\u2322",
          'sharp': "\u266F",
          'shchcy': "\u0449",
          'SHCHcy': "\u0429",
          'shcy': "\u0448",
          'SHcy': "\u0428",
          'ShortDownArrow': "\u2193",
          'ShortLeftArrow': "\u2190",
          'shortmid': "\u2223",
          'shortparallel': "\u2225",
          'ShortRightArrow': "\u2192",
          'ShortUpArrow': "\u2191",
          'shy': '\xAD',
          'sigma': "\u03C3",
          'Sigma': "\u03A3",
          'sigmaf': "\u03C2",
          'sigmav': "\u03C2",
          'sim': "\u223C",
          'simdot': "\u2A6A",
          'sime': "\u2243",
          'simeq': "\u2243",
          'simg': "\u2A9E",
          'simgE': "\u2AA0",
          'siml': "\u2A9D",
          'simlE': "\u2A9F",
          'simne': "\u2246",
          'simplus': "\u2A24",
          'simrarr': "\u2972",
          'slarr': "\u2190",
          'SmallCircle': "\u2218",
          'smallsetminus': "\u2216",
          'smashp': "\u2A33",
          'smeparsl': "\u29E4",
          'smid': "\u2223",
          'smile': "\u2323",
          'smt': "\u2AAA",
          'smte': "\u2AAC",
          'smtes': "\u2AAC\uFE00",
          'softcy': "\u044C",
          'SOFTcy': "\u042C",
          'sol': '/',
          'solb': "\u29C4",
          'solbar': "\u233F",
          'sopf': "\uD835\uDD64",
          'Sopf': "\uD835\uDD4A",
          'spades': "\u2660",
          'spadesuit': "\u2660",
          'spar': "\u2225",
          'sqcap': "\u2293",
          'sqcaps': "\u2293\uFE00",
          'sqcup': "\u2294",
          'sqcups': "\u2294\uFE00",
          'Sqrt': "\u221A",
          'sqsub': "\u228F",
          'sqsube': "\u2291",
          'sqsubset': "\u228F",
          'sqsubseteq': "\u2291",
          'sqsup': "\u2290",
          'sqsupe': "\u2292",
          'sqsupset': "\u2290",
          'sqsupseteq': "\u2292",
          'squ': "\u25A1",
          'square': "\u25A1",
          'Square': "\u25A1",
          'SquareIntersection': "\u2293",
          'SquareSubset': "\u228F",
          'SquareSubsetEqual': "\u2291",
          'SquareSuperset': "\u2290",
          'SquareSupersetEqual': "\u2292",
          'SquareUnion': "\u2294",
          'squarf': "\u25AA",
          'squf': "\u25AA",
          'srarr': "\u2192",
          'sscr': "\uD835\uDCC8",
          'Sscr': "\uD835\uDCAE",
          'ssetmn': "\u2216",
          'ssmile': "\u2323",
          'sstarf': "\u22C6",
          'star': "\u2606",
          'Star': "\u22C6",
          'starf': "\u2605",
          'straightepsilon': "\u03F5",
          'straightphi': "\u03D5",
          'strns': '\xAF',
          'sub': "\u2282",
          'Sub': "\u22D0",
          'subdot': "\u2ABD",
          'sube': "\u2286",
          'subE': "\u2AC5",
          'subedot': "\u2AC3",
          'submult': "\u2AC1",
          'subne': "\u228A",
          'subnE': "\u2ACB",
          'subplus': "\u2ABF",
          'subrarr': "\u2979",
          'subset': "\u2282",
          'Subset': "\u22D0",
          'subseteq': "\u2286",
          'subseteqq': "\u2AC5",
          'SubsetEqual': "\u2286",
          'subsetneq': "\u228A",
          'subsetneqq': "\u2ACB",
          'subsim': "\u2AC7",
          'subsub': "\u2AD5",
          'subsup': "\u2AD3",
          'succ': "\u227B",
          'succapprox': "\u2AB8",
          'succcurlyeq': "\u227D",
          'Succeeds': "\u227B",
          'SucceedsEqual': "\u2AB0",
          'SucceedsSlantEqual': "\u227D",
          'SucceedsTilde': "\u227F",
          'succeq': "\u2AB0",
          'succnapprox': "\u2ABA",
          'succneqq': "\u2AB6",
          'succnsim': "\u22E9",
          'succsim': "\u227F",
          'SuchThat': "\u220B",
          'sum': "\u2211",
          'Sum': "\u2211",
          'sung': "\u266A",
          'sup': "\u2283",
          'Sup': "\u22D1",
          'sup1': '\xB9',
          'sup2': '\xB2',
          'sup3': '\xB3',
          'supdot': "\u2ABE",
          'supdsub': "\u2AD8",
          'supe': "\u2287",
          'supE': "\u2AC6",
          'supedot': "\u2AC4",
          'Superset': "\u2283",
          'SupersetEqual': "\u2287",
          'suphsol': "\u27C9",
          'suphsub': "\u2AD7",
          'suplarr': "\u297B",
          'supmult': "\u2AC2",
          'supne': "\u228B",
          'supnE': "\u2ACC",
          'supplus': "\u2AC0",
          'supset': "\u2283",
          'Supset': "\u22D1",
          'supseteq': "\u2287",
          'supseteqq': "\u2AC6",
          'supsetneq': "\u228B",
          'supsetneqq': "\u2ACC",
          'supsim': "\u2AC8",
          'supsub': "\u2AD4",
          'supsup': "\u2AD6",
          'swarhk': "\u2926",
          'swarr': "\u2199",
          'swArr': "\u21D9",
          'swarrow': "\u2199",
          'swnwar': "\u292A",
          'szlig': '\xDF',
          'Tab': '\t',
          'target': "\u2316",
          'tau': "\u03C4",
          'Tau': "\u03A4",
          'tbrk': "\u23B4",
          'tcaron': "\u0165",
          'Tcaron': "\u0164",
          'tcedil': "\u0163",
          'Tcedil': "\u0162",
          'tcy': "\u0442",
          'Tcy': "\u0422",
          'tdot': "\u20DB",
          'telrec': "\u2315",
          'tfr': "\uD835\uDD31",
          'Tfr': "\uD835\uDD17",
          'there4': "\u2234",
          'therefore': "\u2234",
          'Therefore': "\u2234",
          'theta': "\u03B8",
          'Theta': "\u0398",
          'thetasym': "\u03D1",
          'thetav': "\u03D1",
          'thickapprox': "\u2248",
          'thicksim': "\u223C",
          'ThickSpace': "\u205F\u200A",
          'thinsp': "\u2009",
          'ThinSpace': "\u2009",
          'thkap': "\u2248",
          'thksim': "\u223C",
          'thorn': '\xFE',
          'THORN': '\xDE',
          'tilde': "\u02DC",
          'Tilde': "\u223C",
          'TildeEqual': "\u2243",
          'TildeFullEqual': "\u2245",
          'TildeTilde': "\u2248",
          'times': '\xD7',
          'timesb': "\u22A0",
          'timesbar': "\u2A31",
          'timesd': "\u2A30",
          'tint': "\u222D",
          'toea': "\u2928",
          'top': "\u22A4",
          'topbot': "\u2336",
          'topcir': "\u2AF1",
          'topf': "\uD835\uDD65",
          'Topf': "\uD835\uDD4B",
          'topfork': "\u2ADA",
          'tosa': "\u2929",
          'tprime': "\u2034",
          'trade': "\u2122",
          'TRADE': "\u2122",
          'triangle': "\u25B5",
          'triangledown': "\u25BF",
          'triangleleft': "\u25C3",
          'trianglelefteq': "\u22B4",
          'triangleq': "\u225C",
          'triangleright': "\u25B9",
          'trianglerighteq': "\u22B5",
          'tridot': "\u25EC",
          'trie': "\u225C",
          'triminus': "\u2A3A",
          'TripleDot': "\u20DB",
          'triplus': "\u2A39",
          'trisb': "\u29CD",
          'tritime': "\u2A3B",
          'trpezium': "\u23E2",
          'tscr': "\uD835\uDCC9",
          'Tscr': "\uD835\uDCAF",
          'tscy': "\u0446",
          'TScy': "\u0426",
          'tshcy': "\u045B",
          'TSHcy': "\u040B",
          'tstrok': "\u0167",
          'Tstrok': "\u0166",
          'twixt': "\u226C",
          'twoheadleftarrow': "\u219E",
          'twoheadrightarrow': "\u21A0",
          'uacute': '\xFA',
          'Uacute': '\xDA',
          'uarr': "\u2191",
          'uArr': "\u21D1",
          'Uarr': "\u219F",
          'Uarrocir': "\u2949",
          'ubrcy': "\u045E",
          'Ubrcy': "\u040E",
          'ubreve': "\u016D",
          'Ubreve': "\u016C",
          'ucirc': '\xFB',
          'Ucirc': '\xDB',
          'ucy': "\u0443",
          'Ucy': "\u0423",
          'udarr': "\u21C5",
          'udblac': "\u0171",
          'Udblac': "\u0170",
          'udhar': "\u296E",
          'ufisht': "\u297E",
          'ufr': "\uD835\uDD32",
          'Ufr': "\uD835\uDD18",
          'ugrave': '\xF9',
          'Ugrave': '\xD9',
          'uHar': "\u2963",
          'uharl': "\u21BF",
          'uharr': "\u21BE",
          'uhblk': "\u2580",
          'ulcorn': "\u231C",
          'ulcorner': "\u231C",
          'ulcrop': "\u230F",
          'ultri': "\u25F8",
          'umacr': "\u016B",
          'Umacr': "\u016A",
          'uml': '\xA8',
          'UnderBar': '_',
          'UnderBrace': "\u23DF",
          'UnderBracket': "\u23B5",
          'UnderParenthesis': "\u23DD",
          'Union': "\u22C3",
          'UnionPlus': "\u228E",
          'uogon': "\u0173",
          'Uogon': "\u0172",
          'uopf': "\uD835\uDD66",
          'Uopf': "\uD835\uDD4C",
          'uparrow': "\u2191",
          'Uparrow': "\u21D1",
          'UpArrow': "\u2191",
          'UpArrowBar': "\u2912",
          'UpArrowDownArrow': "\u21C5",
          'updownarrow': "\u2195",
          'Updownarrow': "\u21D5",
          'UpDownArrow': "\u2195",
          'UpEquilibrium': "\u296E",
          'upharpoonleft': "\u21BF",
          'upharpoonright': "\u21BE",
          'uplus': "\u228E",
          'UpperLeftArrow': "\u2196",
          'UpperRightArrow': "\u2197",
          'upsi': "\u03C5",
          'Upsi': "\u03D2",
          'upsih': "\u03D2",
          'upsilon': "\u03C5",
          'Upsilon': "\u03A5",
          'UpTee': "\u22A5",
          'UpTeeArrow': "\u21A5",
          'upuparrows': "\u21C8",
          'urcorn': "\u231D",
          'urcorner': "\u231D",
          'urcrop': "\u230E",
          'uring': "\u016F",
          'Uring': "\u016E",
          'urtri': "\u25F9",
          'uscr': "\uD835\uDCCA",
          'Uscr': "\uD835\uDCB0",
          'utdot': "\u22F0",
          'utilde': "\u0169",
          'Utilde': "\u0168",
          'utri': "\u25B5",
          'utrif': "\u25B4",
          'uuarr': "\u21C8",
          'uuml': '\xFC',
          'Uuml': '\xDC',
          'uwangle': "\u29A7",
          'vangrt': "\u299C",
          'varepsilon': "\u03F5",
          'varkappa': "\u03F0",
          'varnothing': "\u2205",
          'varphi': "\u03D5",
          'varpi': "\u03D6",
          'varpropto': "\u221D",
          'varr': "\u2195",
          'vArr': "\u21D5",
          'varrho': "\u03F1",
          'varsigma': "\u03C2",
          'varsubsetneq': "\u228A\uFE00",
          'varsubsetneqq': "\u2ACB\uFE00",
          'varsupsetneq': "\u228B\uFE00",
          'varsupsetneqq': "\u2ACC\uFE00",
          'vartheta': "\u03D1",
          'vartriangleleft': "\u22B2",
          'vartriangleright': "\u22B3",
          'vBar': "\u2AE8",
          'Vbar': "\u2AEB",
          'vBarv': "\u2AE9",
          'vcy': "\u0432",
          'Vcy': "\u0412",
          'vdash': "\u22A2",
          'vDash': "\u22A8",
          'Vdash': "\u22A9",
          'VDash': "\u22AB",
          'Vdashl': "\u2AE6",
          'vee': "\u2228",
          'Vee': "\u22C1",
          'veebar': "\u22BB",
          'veeeq': "\u225A",
          'vellip': "\u22EE",
          'verbar': '|',
          'Verbar': "\u2016",
          'vert': '|',
          'Vert': "\u2016",
          'VerticalBar': "\u2223",
          'VerticalLine': '|',
          'VerticalSeparator': "\u2758",
          'VerticalTilde': "\u2240",
          'VeryThinSpace': "\u200A",
          'vfr': "\uD835\uDD33",
          'Vfr': "\uD835\uDD19",
          'vltri': "\u22B2",
          'vnsub': "\u2282\u20D2",
          'vnsup': "\u2283\u20D2",
          'vopf': "\uD835\uDD67",
          'Vopf': "\uD835\uDD4D",
          'vprop': "\u221D",
          'vrtri': "\u22B3",
          'vscr': "\uD835\uDCCB",
          'Vscr': "\uD835\uDCB1",
          'vsubne': "\u228A\uFE00",
          'vsubnE': "\u2ACB\uFE00",
          'vsupne': "\u228B\uFE00",
          'vsupnE': "\u2ACC\uFE00",
          'Vvdash': "\u22AA",
          'vzigzag': "\u299A",
          'wcirc': "\u0175",
          'Wcirc': "\u0174",
          'wedbar': "\u2A5F",
          'wedge': "\u2227",
          'Wedge': "\u22C0",
          'wedgeq': "\u2259",
          'weierp': "\u2118",
          'wfr': "\uD835\uDD34",
          'Wfr': "\uD835\uDD1A",
          'wopf': "\uD835\uDD68",
          'Wopf': "\uD835\uDD4E",
          'wp': "\u2118",
          'wr': "\u2240",
          'wreath': "\u2240",
          'wscr': "\uD835\uDCCC",
          'Wscr': "\uD835\uDCB2",
          'xcap': "\u22C2",
          'xcirc': "\u25EF",
          'xcup': "\u22C3",
          'xdtri': "\u25BD",
          'xfr': "\uD835\uDD35",
          'Xfr': "\uD835\uDD1B",
          'xharr': "\u27F7",
          'xhArr': "\u27FA",
          'xi': "\u03BE",
          'Xi': "\u039E",
          'xlarr': "\u27F5",
          'xlArr': "\u27F8",
          'xmap': "\u27FC",
          'xnis': "\u22FB",
          'xodot': "\u2A00",
          'xopf': "\uD835\uDD69",
          'Xopf': "\uD835\uDD4F",
          'xoplus': "\u2A01",
          'xotime': "\u2A02",
          'xrarr': "\u27F6",
          'xrArr': "\u27F9",
          'xscr': "\uD835\uDCCD",
          'Xscr': "\uD835\uDCB3",
          'xsqcup': "\u2A06",
          'xuplus': "\u2A04",
          'xutri': "\u25B3",
          'xvee': "\u22C1",
          'xwedge': "\u22C0",
          'yacute': '\xFD',
          'Yacute': '\xDD',
          'yacy': "\u044F",
          'YAcy': "\u042F",
          'ycirc': "\u0177",
          'Ycirc': "\u0176",
          'ycy': "\u044B",
          'Ycy': "\u042B",
          'yen': '\xA5',
          'yfr': "\uD835\uDD36",
          'Yfr': "\uD835\uDD1C",
          'yicy': "\u0457",
          'YIcy': "\u0407",
          'yopf': "\uD835\uDD6A",
          'Yopf': "\uD835\uDD50",
          'yscr': "\uD835\uDCCE",
          'Yscr': "\uD835\uDCB4",
          'yucy': "\u044E",
          'YUcy': "\u042E",
          'yuml': '\xFF',
          'Yuml': "\u0178",
          'zacute': "\u017A",
          'Zacute': "\u0179",
          'zcaron': "\u017E",
          'Zcaron': "\u017D",
          'zcy': "\u0437",
          'Zcy': "\u0417",
          'zdot': "\u017C",
          'Zdot': "\u017B",
          'zeetrf': "\u2128",
          'ZeroWidthSpace': "\u200B",
          'zeta': "\u03B6",
          'Zeta': "\u0396",
          'zfr': "\uD835\uDD37",
          'Zfr': "\u2128",
          'zhcy': "\u0436",
          'ZHcy': "\u0416",
          'zigrarr': "\u21DD",
          'zopf': "\uD835\uDD6B",
          'Zopf': "\u2124",
          'zscr': "\uD835\uDCCF",
          'Zscr': "\uD835\uDCB5",
          'zwj': "\u200D",
          'zwnj': "\u200C"
        };
        var decodeMapLegacy = {
          'aacute': '\xE1',
          'Aacute': '\xC1',
          'acirc': '\xE2',
          'Acirc': '\xC2',
          'acute': '\xB4',
          'aelig': '\xE6',
          'AElig': '\xC6',
          'agrave': '\xE0',
          'Agrave': '\xC0',
          'amp': '&',
          'AMP': '&',
          'aring': '\xE5',
          'Aring': '\xC5',
          'atilde': '\xE3',
          'Atilde': '\xC3',
          'auml': '\xE4',
          'Auml': '\xC4',
          'brvbar': '\xA6',
          'ccedil': '\xE7',
          'Ccedil': '\xC7',
          'cedil': '\xB8',
          'cent': '\xA2',
          'copy': '\xA9',
          'COPY': '\xA9',
          'curren': '\xA4',
          'deg': '\xB0',
          'divide': '\xF7',
          'eacute': '\xE9',
          'Eacute': '\xC9',
          'ecirc': '\xEA',
          'Ecirc': '\xCA',
          'egrave': '\xE8',
          'Egrave': '\xC8',
          'eth': '\xF0',
          'ETH': '\xD0',
          'euml': '\xEB',
          'Euml': '\xCB',
          'frac12': '\xBD',
          'frac14': '\xBC',
          'frac34': '\xBE',
          'gt': '>',
          'GT': '>',
          'iacute': '\xED',
          'Iacute': '\xCD',
          'icirc': '\xEE',
          'Icirc': '\xCE',
          'iexcl': '\xA1',
          'igrave': '\xEC',
          'Igrave': '\xCC',
          'iquest': '\xBF',
          'iuml': '\xEF',
          'Iuml': '\xCF',
          'laquo': '\xAB',
          'lt': '<',
          'LT': '<',
          'macr': '\xAF',
          'micro': '\xB5',
          'middot': '\xB7',
          'nbsp': '\xA0',
          'not': '\xAC',
          'ntilde': '\xF1',
          'Ntilde': '\xD1',
          'oacute': '\xF3',
          'Oacute': '\xD3',
          'ocirc': '\xF4',
          'Ocirc': '\xD4',
          'ograve': '\xF2',
          'Ograve': '\xD2',
          'ordf': '\xAA',
          'ordm': '\xBA',
          'oslash': '\xF8',
          'Oslash': '\xD8',
          'otilde': '\xF5',
          'Otilde': '\xD5',
          'ouml': '\xF6',
          'Ouml': '\xD6',
          'para': '\xB6',
          'plusmn': '\xB1',
          'pound': '\xA3',
          'quot': '"',
          'QUOT': '"',
          'raquo': '\xBB',
          'reg': '\xAE',
          'REG': '\xAE',
          'sect': '\xA7',
          'shy': '\xAD',
          'sup1': '\xB9',
          'sup2': '\xB2',
          'sup3': '\xB3',
          'szlig': '\xDF',
          'thorn': '\xFE',
          'THORN': '\xDE',
          'times': '\xD7',
          'uacute': '\xFA',
          'Uacute': '\xDA',
          'ucirc': '\xFB',
          'Ucirc': '\xDB',
          'ugrave': '\xF9',
          'Ugrave': '\xD9',
          'uml': '\xA8',
          'uuml': '\xFC',
          'Uuml': '\xDC',
          'yacute': '\xFD',
          'Yacute': '\xDD',
          'yen': '\xA5',
          'yuml': '\xFF'
        };
        var decodeMapNumeric = {
          '0': "\uFFFD",
          '128': "\u20AC",
          '130': "\u201A",
          '131': "\u0192",
          '132': "\u201E",
          '133': "\u2026",
          '134': "\u2020",
          '135': "\u2021",
          '136': "\u02C6",
          '137': "\u2030",
          '138': "\u0160",
          '139': "\u2039",
          '140': "\u0152",
          '142': "\u017D",
          '145': "\u2018",
          '146': "\u2019",
          '147': "\u201C",
          '148': "\u201D",
          '149': "\u2022",
          '150': "\u2013",
          '151': "\u2014",
          '152': "\u02DC",
          '153': "\u2122",
          '154': "\u0161",
          '155': "\u203A",
          '156': "\u0153",
          '158': "\u017E",
          '159': "\u0178"
        };
        var invalidReferenceCodePoints = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65000, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];

        /*--------------------------------------------------------------------------*/

        var stringFromCharCode = String.fromCharCode;
        var object = {};
        var hasOwnProperty = object.hasOwnProperty;
        var has = function has(object, propertyName) {
          return hasOwnProperty.call(object, propertyName);
        };
        var contains = function contains(array, value) {
          var index = -1;
          var length = array.length;
          while (++index < length) {
            if (array[index] == value) {
              return true;
            }
          }
          return false;
        };
        var merge = function merge(options, defaults) {
          if (!options) {
            return defaults;
          }
          var result = {};
          var key;
          for (key in defaults) {
            // A `hasOwnProperty` check is not needed here, since only recognized
            // option names are used anyway. Any others are ignored.
            result[key] = has(options, key) ? options[key] : defaults[key];
          }
          return result;
        };

        // Modified version of `ucs2encode`; see https://mths.be/punycode.
        var codePointToSymbol = function codePointToSymbol(codePoint, strict) {
          var output = '';
          if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) {
              parseError('character reference outside the permissible Unicode range');
            }
            return "\uFFFD";
          }
          if (has(decodeMapNumeric, codePoint)) {
            if (strict) {
              parseError('disallowed character reference');
            }
            return decodeMapNumeric[codePoint];
          }
          if (strict && contains(invalidReferenceCodePoints, codePoint)) {
            parseError('disallowed character reference');
          }
          if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
          }
          output += stringFromCharCode(codePoint);
          return output;
        };
        var hexEscape = function hexEscape(codePoint) {
          return '&#x' + codePoint.toString(16).toUpperCase() + ';';
        };
        var decEscape = function decEscape(codePoint) {
          return '&#' + codePoint + ';';
        };
        var parseError = function parseError(message) {
          throw Error('Parse error: ' + message);
        };

        /*--------------------------------------------------------------------------*/

        var encode = function encode(string, options) {
          options = merge(options, encode.options);
          var strict = options.strict;
          if (strict && regexInvalidRawCodePoint.test(string)) {
            parseError('forbidden code point');
          }
          var encodeEverything = options.encodeEverything;
          var useNamedReferences = options.useNamedReferences;
          var allowUnsafeSymbols = options.allowUnsafeSymbols;
          var escapeCodePoint = options.decimal ? decEscape : hexEscape;
          var escapeBmpSymbol = function escapeBmpSymbol(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
          };
          if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function (symbol) {
              // Use named references if requested & possible.
              if (useNamedReferences && has(encodeMap, symbol)) {
                return '&' + encodeMap[symbol] + ';';
              }
              return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) {
              string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
            }
            // Encode non-ASCII symbols.
            if (useNamedReferences) {
              // Encode non-ASCII symbols that can be replaced with a named reference.
              string = string.replace(regexEncodeNonAscii, function (string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
              });
            }
            // Note: any remaining non-ASCII symbols are handled outside of the `if`.
          } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) {
              string = string.replace(regexEscape, function (string) {
                return '&' + encodeMap[string] + ';'; // no need to check `has()` here
              });
            }
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function (string) {
              // Note: there is no need to check `has(encodeMap, string)` here.
              return '&' + encodeMap[string] + ';';
            });
          } else if (!allowUnsafeSymbols) {
            // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
            // using named character references.
            string = string.replace(regexEscape, escapeBmpSymbol);
          }
          return string
          // Encode astral symbols.
          .replace(regexAstralSymbols, function ($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
          })
          // Encode any remaining BMP symbols that are not printable ASCII symbols
          // using a hexadecimal escape.
          .replace(regexBmpWhitelist, escapeBmpSymbol);
        };
        // Expose default options (so they can be overridden globally).
        encode.options = {
          'allowUnsafeSymbols': false,
          'encodeEverything': false,
          'strict': false,
          'useNamedReferences': false,
          'decimal': false
        };
        var decode = function decode(html, options) {
          options = merge(options, decode.options);
          var strict = options.strict;
          if (strict && regexInvalidEntity.test(html)) {
            parseError('malformed character reference');
          }
          return html.replace(regexDecode, function ($0, $1, $2, $3, $4, $5, $6, $7) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
              // Decode decimal escapes, e.g. `&#119558;`.
              decDigits = $1;
              semicolon = $2;
              if (strict && !semicolon) {
                parseError('character reference was not terminated by a semicolon');
              }
              codePoint = parseInt(decDigits, 10);
              return codePointToSymbol(codePoint, strict);
            }
            if ($3) {
              // Decode hexadecimal escapes, e.g. `&#x1D306;`.
              hexDigits = $3;
              semicolon = $4;
              if (strict && !semicolon) {
                parseError('character reference was not terminated by a semicolon');
              }
              codePoint = parseInt(hexDigits, 16);
              return codePointToSymbol(codePoint, strict);
            }
            if ($5) {
              // Decode named character references with trailing `;`, e.g. `&copy;`.
              reference = $5;
              if (has(decodeMap, reference)) {
                return decodeMap[reference];
              } else {
                // Ambiguous ampersand. https://mths.be/notes/ambiguous-ampersands
                if (strict) {
                  parseError('named character reference was not terminated by a semicolon');
                }
                return $0;
              }
            }
            // If we’re still here, it’s a legacy reference for sure. No need for an
            // extra `if` check.
            // Decode named character references without trailing `;`, e.g. `&amp`
            // This is only a parse error if it gets converted to `&`, or if it is
            // followed by `=` in an attribute context.
            reference = $6;
            next = $7;
            if (next && options.isAttributeValue) {
              if (strict && next == '=') {
                parseError('`&` did not start a character reference');
              }
              return $0;
            } else {
              if (strict) {
                parseError('named character reference was not terminated by a semicolon');
              }
              // Note: there is no need to check `has(decodeMapLegacy, reference)`.
              return decodeMapLegacy[reference] + (next || '');
            }
          });
        };
        // Expose default options (so they can be overridden globally).
        decode.options = {
          'isAttributeValue': false,
          'strict': false
        };
        var escape = function escape(string) {
          return string.replace(regexEscape, function ($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
          });
        };

        /*--------------------------------------------------------------------------*/

        var he = {
          'version': '1.1.1',
          'encode': encode,
          'decode': decode,
          'escape': escape,
          'unescape': decode
        };

        // Some AMD build optimizers, like r.js, check for specific condition patterns
        // like the following:
        if (true) {
          !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return he;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (freeExports && !freeExports.nodeType) {
          if (freeModule) {
            // in Node.js, io.js, or RingoJS v0.8.0+
            freeModule.exports = he;
          } else {
            // in Narwhal or RingoJS v0.7.0-
            for (var key in he) {
              has(he, key) && (freeExports[key] = he[key]);
            }
          }
        } else {
          // in Rhino or a web browser
          root.he = he;
        }
      })(this);

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(21)(module), __webpack_require__(6));

    /***/
  }, /* 34 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      /*
      * Copyright (C) 2007-2015 Diego Perini
      * All rights reserved.
      *
      * nwmatcher-noqsa.js - A fast CSS selector engine and matcher
      *
      * Author: Diego Perini <diego.perini at gmail com>
      * Version: 1.3.7
      * Created: 20070722
      * Release: 20151120
      *
      * License:
      *  http://javascript.nwbox.com/NWMatcher/MIT-LICENSE
      * Download:
      *  http://javascript.nwbox.com/NWMatcher/nwmatcher.js
      */

      (function (global, factory) {
        if (true) {
          module.exports = function (browserGlobal) {
            // passed global does not contain
            // references to native objects
            browserGlobal.console = console;
            browserGlobal.parseInt = parseInt;
            browserGlobal.Function = Function;
            browserGlobal.Boolean = Boolean;
            browserGlobal.Number = Number;
            browserGlobal.RegExp = RegExp;
            browserGlobal.String = String;
            browserGlobal.Object = Object;
            browserGlobal.Array = Array;
            browserGlobal.Error = Error;
            browserGlobal.Date = Date;
            browserGlobal.Math = Math;
            var exports = browserGlobal.Object();
            factory(browserGlobal, exports);
            return exports;
          };
          module.factory = factory;
        } else {
          factory(global, (global.NW || (global.NW = global.Object())) && (global.NW.Dom || (global.NW.Dom = global.Object())));
          global.NW.Dom.factory = factory;
        }
      })(this, function (global, exports) {
        var version = 'nwmatcher-1.3.7',
          Dom = exports,
          doc = global.document,
          root = doc.documentElement,
          isSingleMatch,
          isSingleSelect,
          lastSlice,
          lastContext,
          lastPosition,
          lastMatcher,
          lastSelector,
          lastPartsMatch,
          lastPartsSelect,
          operators = '([~*^$|!]?={1})',
          combinators = '[\\s]|[>+~](?=[^>+~])',
          pseudoparms = '(?:[-+]?\\d*n)?[-+]?\\d*',
          quotedvalue = '"[^"\\\\]*(?:\\\\.[^"\\\\]*)*"' + "|'[^'\\\\]*(?:\\\\.[^'\\\\]*)*'",
          skipgroup = '\\[.*\\]|\\(.*\\)|\\{.*\\}',
          encoding = '(?:[-\\w]|[^\\x00-\\xa0]|\\\\.)',
          identifier = '(?:-?[_a-zA-Z]{1}[-\\w]*|[^\\x00-\\xa0]+|\\\\.+)+',
          attrcheck = '(' + quotedvalue + '|' + identifier + ')',
          attributes = '\\s*(' + encoding + '*:?' + encoding + '+)\\s*(?:' + operators + '\\s*' + attrcheck + ')?\\s*',
          attrmatcher = attributes.replace(attrcheck, '([\\x22\\x27]*)((?:\\\\?.)*?)\\3'),
          pseudoclass = '((?:' + pseudoparms + '|' + quotedvalue + '|' + '[#.:]?|' + encoding + '+|' + '\\[' + attributes + '\\]|' + '\\(.+\\)|\\s*|' + ',)+)',
          extensions = '.+',
          standardValidator = '(?=\\s*[^>+~(){}<>])' + '(' + '\\*' + '|(?:[#.:]?' + identifier + ')' + '|' + combinators + '|\\[' + attributes + '\\]' + '|\\(' + pseudoclass + '\\)' + '|\\{' + extensions + '\\}' + '|(?:,|\\s*)' + ')+',
          extendedValidator = standardValidator.replace(pseudoclass, '.*'),
          reValidator = global.RegExp(standardValidator),
          reTrimSpaces = /^\s*|\s*$/g,
          reSimpleNot = global.RegExp('^(' + '(?!:not)' + '([#.:]?' + '|' + identifier + '|\\([^()]*\\))+' + '|\\[' + attributes + '\\]' + ')$'),
          reSplitGroup = /([^,\\()[\]]+|\[[^[\]]*\]|\[.*\]|\([^()]+\)|\(.*\)|\{[^{}]+\}|\{.*\}|\\.)+/g,
          reSplitToken = global.RegExp('(' + '\\[' + attributes + '\\]|' + '\\(' + pseudoclass + '\\)|' + '\\:(?:link|visited|target|active|focus|hover|checked|disabled|enabled|selected|lang\\((?:[-\\w]{2,})\\)|not\\(\\s*(?::nth(?:-last)?(?:-child|-of-type)\\(\\s*(?:even|odd|(?:[-+]{0,1}\\d*n\\s*)?[-+]{0,1}\\s*\\d*)\\s*\\)|[^()]*)\\s*\\))?|' + '\\\\.|[^\\s>+~])+', 'g'),
          reOptimizeSelector = global.RegExp(identifier + '|^$'),
          QUIRKS_MODE,
          XML_DOCUMENT,
          GEBTN = ('getElementsByTagName' in doc),
          GEBCN = ('getElementsByClassName' in doc),
          LINK_NODES = global.Object({
            a: 1,
            A: 1,
            area: 1,
            AREA: 1,
            link: 1,
            LINK: 1
          }),
          ATTR_BOOLEAN = global.Object({
            checked: 1,
            disabled: 1,
            ismap: 1,
            multiple: 1,
            readonly: 1,
            selected: 1
          }),
          ATTR_DEFAULT = global.Object({
            value: 'defaultValue',
            checked: 'defaultChecked',
            selected: 'defaultSelected'
          }),
          ATTR_URIDATA = global.Object({
            action: 2,
            cite: 2,
            codebase: 2,
            data: 2,
            href: 2,
            longdesc: 2,
            lowsrc: 2,
            src: 2,
            usemap: 2
          }),
          Selectors = global.Object({}),
          Operators = global.Object({
            '=': "n=='%m'",
            '^=': "n.indexOf('%m')==0",
            '*=': "n.indexOf('%m')>-1",
            '|=': "(n+'-').indexOf('%m-')==0",
            '~=': "(' '+n+' ').indexOf(' %m ')>-1",
            '$=': "n.substr(n.length-'%m'.length)=='%m'"
          }),
          Optimize = global.Object({
            ID: global.RegExp('^\\*?#(' + encoding + '+)|' + skipgroup),
            TAG: global.RegExp('^(' + encoding + '+)|' + skipgroup),
            CLASS: global.RegExp('^\\*?\\.(' + encoding + '+$)|' + skipgroup)
          }),
          Patterns = global.Object({
            spseudos: /^\:(root|empty|(?:first|last|only)(?:-child|-of-type)|nth(?:-last)?(?:-child|-of-type)\(\s*(even|odd|(?:[-+]{0,1}\d*n\s*)?[-+]{0,1}\s*\d*)\s*\))?(.*)/i,
            dpseudos: /^\:(link|visited|target|active|focus|hover|checked|disabled|enabled|selected|lang\(([-\w]{2,})\)|not\(\s*(:nth(?:-last)?(?:-child|-of-type)\(\s*(?:even|odd|(?:[-+]{0,1}\d*n\s*)?[-+]{0,1}\s*\d*)\s*\)|[^()]*)\s*\))?(.*)/i,
            attribute: global.RegExp('^\\[' + attrmatcher + '\\](.*)'),
            children: /^\s*\>\s*(.*)/,
            adjacent: /^\s*\+\s*(.*)/,
            relative: /^\s*\~\s*(.*)/,
            ancestor: /^\s+(.*)/,
            universal: /^\*(.*)/,
            id: global.RegExp('^#(' + encoding + '+)(.*)'),
            tagName: global.RegExp('^(' + encoding + '+)(.*)'),
            className: global.RegExp('^\\.(' + encoding + '+)(.*)')
          }),
          concatCall = function concatCall(data, elements, callback) {
            var i = -1,
              element;
            while (element = elements[++i]) {
              if (false === callback(data[data.length] = element)) {
                break;
              }
            }
            return data;
          },
          switchContext = function switchContext(from, force) {
            var oldDoc = doc;
            lastContext = from;
            doc = from.ownerDocument || from;
            if (force || oldDoc !== doc) {
              root = doc.documentElement;
              XML_DOCUMENT = doc.createElement('DiV').nodeName == 'DiV';
              QUIRKS_MODE = !XML_DOCUMENT && typeof doc.compatMode == 'string' ? doc.compatMode.indexOf('CSS') < 0 : function () {
                var style = doc.createElement('div').style;
                return style && (style.width = 1) && style.width == '1px';
              }();
              Config.CACHING && Dom.setCache(true, doc);
            }
          },
          convertEscapes = function convertEscapes(str) {
            return str.replace(/\\([0-9a-fA-F]{1,6}\x20?|.)|([\x22\x27])/g, function (substring, p1, p2) {
              var codePoint, highHex, highSurrogate, lowHex, lowSurrogate;
              if (p2) {
                return '\\' + p2;
              }
              if (/^[0-9a-fA-F]/.test(p1)) {
                codePoint = parseInt(p1, 16);
                if (codePoint < 0 || codePoint > 0x10ffff) {
                  return "\\ufffd";
                }
                if (codePoint <= 0xffff) {
                  lowHex = '000' + codePoint.toString(16);
                  return "\\u" + lowHex.substr(lowHex.length - 4);
                }
                codePoint -= 0x10000;
                highSurrogate = (codePoint >> 10) + 0xd800;
                lowSurrogate = codePoint % 0x400 + 0xdc00;
                highHex = '000' + highSurrogate.toString(16);
                lowHex = '000' + lowSurrogate.toString(16);
                return "\\u" + highHex.substr(highHex.length - 4) + "\\u" + lowHex.substr(lowHex.length - 4);
              }
              if (/^[\\\x22\x27]/.test(p1)) {
                return substring;
              }
              return p1;
            });
          },
          byIdRaw = function byIdRaw(id, elements) {
            var i = -1,
              element = null;
            while (element = elements[++i]) {
              if (element.getAttribute('id') == id) {
                break;
              }
            }
            return element;
          },
          _byId = !('fileSize' in doc) ? function (id, from) {
            id = id.replace(/\\([^\\]{1})/g, '$1');
            return from.getElementById && from.getElementById(id) || byIdRaw(id, from.getElementsByTagName('*'));
          } : function (id, from) {
            var element = null;
            id = id.replace(/\\([^\\]{1})/g, '$1');
            if (XML_DOCUMENT || from.nodeType != 9) {
              return byIdRaw(id, from.getElementsByTagName('*'));
            }
            if ((element = from.getElementById(id)) && element.name == id && from.getElementsByName) {
              return byIdRaw(id, from.getElementsByName(id));
            }
            return element;
          },
          byId = function byId(id, from) {
            from || (from = doc);
            if (lastContext !== from) {
              switchContext(from);
            }
            return _byId(id, from);
          },
          byTagRaw = function byTagRaw(tag, from) {
            var any = tag == '*',
              element = from,
              elements = global.Array(),
              next = element.firstChild;
            any || (tag = tag.toUpperCase());
            while (element = next) {
              if (element.tagName > '@' && (any || element.tagName.toUpperCase() == tag)) {
                elements[elements.length] = element;
              }
              if (next = element.firstChild || element.nextSibling) continue;
              while (!next && (element = element.parentNode) && element !== from) {
                next = element.nextSibling;
              }
            }
            return elements;
          },
          contains = 'compareDocumentPosition' in root ? function (container, element) {
            return (container.compareDocumentPosition(element) & 16) == 16;
          } : 'contains' in root ? function (container, element) {
            return element.nodeType == 1 && container.contains(element);
          } : function (container, element) {
            while ((element = element.parentNode) && element.nodeType == 1) {
              if (element === container) return true;
            }
            return false;
          },
          getAttribute = function getAttribute(node, attribute) {
            attribute = attribute.toLowerCase();
            if (typeof node[attribute] == 'object') {
              return node.attributes[attribute] && node.attributes[attribute].value;
            }
            return attribute == 'type' ? node.getAttribute(attribute) : ATTR_URIDATA[attribute] ? node.getAttribute(attribute, 2) : ATTR_BOOLEAN[attribute] ? node.getAttribute(attribute) ? attribute : 'false' : (node = node.getAttributeNode(attribute)) && node.value;
          },
          hasAttribute = root.hasAttribute ? function (node, attribute) {
            return node.hasAttribute(attribute);
          } : function (node, attribute) {
            var obj = node.getAttributeNode(attribute = attribute.toLowerCase());
            return ATTR_DEFAULT[attribute] && attribute != 'value' ? node[ATTR_DEFAULT[attribute]] : obj && obj.specified;
          },
          isLink = function isLink(element) {
            return element.getAttribute('href') && LINK_NODES[element.nodeName];
          },
          isEmpty = function isEmpty(node) {
            node = node.firstChild;
            while (node) {
              if (node.nodeType == 3 || node.nodeName > '@') return false;
              node = node.nextSibling;
            }
            return true;
          },
          nthElement = function nthElement(element, last) {
            var count = 1,
              succ = last ? 'nextSibling' : 'previousSibling';
            while (element = element[succ]) {
              if (element.nodeName > '@') ++count;
            }
            return count;
          },
          nthOfType = function nthOfType(element, last) {
            var count = 1,
              succ = last ? 'nextSibling' : 'previousSibling',
              type = element.nodeName;
            while (element = element[succ]) {
              if (element.nodeName == type) ++count;
            }
            return count;
          },
          configure = function configure(option) {
            if (typeof option == 'string') {
              return Config[option] || Config;
            }
            if (typeof option != 'object') {
              return false;
            }
            for (var i in option) {
              Config[i] = !!option[i];
              if (i == 'SIMPLENOT') {
                matchContexts = global.Object();
                matchResolvers = global.Object();
                selectContexts = global.Object();
                selectResolvers = global.Object();
              }
            }
            reValidator = global.RegExp(Config.SIMPLENOT ? standardValidator : extendedValidator);
            return true;
          },
          emit = function emit(message) {
            if (Config.VERBOSITY) {
              throw global.Error(message);
            }
            if (global.console && global.console.log) {
              global.console.log(message);
            }
          },
          Config = global.Object({
            CACHING: false,
            SIMPLENOT: true,
            UNIQUE_ID: true,
            USE_HTML5: true,
            VERBOSITY: true
          }),
          IE_LT_9 = typeof doc.addEventListener != 'function',
          INSENSITIVE_MAP = global.Object({
            href: 1,
            lang: 1,
            src: 1,
            style: 1,
            title: 1,
            type: 1,
            xmlns: 1,
            'xml:lang': 1,
            'xml:space': 1
          }),
          TO_UPPER_CASE = IE_LT_9 ? '.toUpperCase()' : '',
          ACCEPT_NODE = 'r[r.length]=c[k];if(f&&false===f(c[k]))break main;else continue main;',
          REJECT_NODE = IE_LT_9 ? 'if(e.nodeName<"A")continue;' : '',
          compile = function compile(selector, source, mode) {
            var parts = typeof selector == 'string' ? selector.match(reSplitGroup) : selector;
            typeof source == 'string' || (source = '');
            if (parts.length == 1) {
              source += compileSelector(parts[0], mode ? ACCEPT_NODE : 'f&&f(k);return true;', mode);
            } else {
              var i = -1,
                seen = global.Object(),
                token;
              while (token = parts[++i]) {
                token = token.replace(reTrimSpaces, '');
                if (!seen[token] && (seen[token] = true)) {
                  source += compileSelector(token, mode ? ACCEPT_NODE : 'f&&f(k);return true;', mode);
                }
              }
            }
            if (mode) {
              return global.Function('c,s,r,d,h,g,f,v', 'var N,n,x=0,k=-1,e;main:while((e=c[++k])){' + source + '}return r;');
            } else {
              return global.Function('e,s,r,d,h,g,f,v', 'var N,n,x=0,k=e;' + source + 'return false;');
            }
          },
          FILTER = 'var z=v[@]||(v[@]=[]),l=z.length-1;' + 'while(l>=0&&z[l]!==e)--l;' + 'if(l!==-1){break;}' + 'z[z.length]=e;',
          compileSelector = function compileSelector(selector, source, mode) {
            var a,
              b,
              n,
              k = 0,
              expr,
              match,
              name,
              result,
              status,
              test,
              type;
            while (selector) {
              k++;
              if (match = selector.match(Patterns.universal)) {
                expr = '';
              } else if (match = selector.match(Patterns.id)) {
                source = 'if(' + (XML_DOCUMENT ? 's.getAttribute(e,"id")' : '(e.submit?s.getAttribute(e,"id"):e.id)') + '=="' + match[1] + '"' + '){' + source + '}';
              } else if (match = selector.match(Patterns.tagName)) {
                source = 'if(e.nodeName' + (XML_DOCUMENT ? '=="' + match[1] + '"' : TO_UPPER_CASE + '=="' + match[1].toUpperCase() + '"') + '){' + source + '}';
              } else if (match = selector.match(Patterns.className)) {
                source = 'if((n=' + (XML_DOCUMENT ? 'e.getAttribute("class")' : 'e.className') + ')&&n.length&&(" "+' + (QUIRKS_MODE ? 'n.toLowerCase()' : 'n') + '.replace(/\\s+/g," ")+" ").indexOf(" ' + (QUIRKS_MODE ? match[1].toLowerCase() : match[1]) + ' ")>-1' + '){' + source + '}';
              } else if (match = selector.match(Patterns.attribute)) {
                if (match[2] && !Operators[match[2]]) {
                  emit('Unsupported operator in attribute selectors "' + selector + '"');
                  return '';
                }
                test = 'false';
                if (match[2] && match[4] && (test = Operators[match[2]])) {
                  match[4] = convertEscapes(match[4]);
                  type = INSENSITIVE_MAP[match[1].toLowerCase()];
                  test = test.replace(/\%m/g, type ? match[4].toLowerCase() : match[4]);
                } else if (match[2] == '!=' || match[2] == '=') {
                  test = 'n' + match[2] + '=""';
                }
                source = 'if(n=s.hasAttribute(e,"' + match[1] + '")){' + (match[2] ? 'n=s.getAttribute(e,"' + match[1] + '")' : '') + (type && match[2] ? '.toLowerCase();' : ';') + 'if(' + (match[2] ? test : 'n') + '){' + source + '}}';
              } else if (match = selector.match(Patterns.adjacent)) {
                source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
                source = 'var N' + k + '=e;while(e&&(e=e.previousSibling)){if(e.nodeName>"@"){' + source + 'break;}}e=N' + k + ';';
              } else if (match = selector.match(Patterns.relative)) {
                source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
                source = 'var N' + k + '=e;e=e.parentNode.firstChild;while(e&&e!==N' + k + '){if(e.nodeName>"@"){' + source + '}e=e.nextSibling;}e=N' + k + ';';
              } else if (match = selector.match(Patterns.children)) {
                source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
                source = 'var N' + k + '=e;while(e&&e!==h&&e!==g&&(e=e.parentNode)){' + source + 'break;}e=N' + k + ';';
              } else if (match = selector.match(Patterns.ancestor)) {
                source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
                source = 'var N' + k + '=e;while(e&&e!==h&&e!==g&&(e=e.parentNode)){' + source + '}e=N' + k + ';';
              } else if ((match = selector.match(Patterns.spseudos)) && match[1]) {
                switch (match[1]) {
                  case 'root':
                    if (match[3]) {
                      source = 'if(e===h||s.contains(h,e)){' + source + '}';
                    } else {
                      source = 'if(e===h){' + source + '}';
                    }
                    break;
                  case 'empty':
                    source = 'if(s.isEmpty(e)){' + source + '}';
                    break;
                  default:
                    if (match[1] && match[2]) {
                      if (match[2] == 'n') {
                        source = 'if(e!==h){' + source + '}';
                        break;
                      } else if (match[2] == 'even') {
                        a = 2;
                        b = 0;
                      } else if (match[2] == 'odd') {
                        a = 2;
                        b = 1;
                      } else {
                        b = (n = match[2].match(/(-?\d+)$/)) ? global.parseInt(n[1], 10) : 0;
                        a = (n = match[2].match(/(-?\d*)n/i)) ? global.parseInt(n[1], 10) : 0;
                        if (n && n[1] == '-') a = -1;
                      }
                      test = a > 1 ? /last/i.test(match[1]) ? '(n-(' + b + '))%' + a + '==0' : 'n>=' + b + '&&(n-(' + b + '))%' + a + '==0' : a < -1 ? /last/i.test(match[1]) ? '(n-(' + b + '))%' + a + '==0' : 'n<=' + b + '&&(n-(' + b + '))%' + a + '==0' : a === 0 ? 'n==' + b : a == -1 ? 'n<=' + b : 'n>=' + b;
                      source = 'if(e!==h){' + 'n=s[' + (/-of-type/i.test(match[1]) ? '"nthOfType"' : '"nthElement"') + ']' + '(e,' + (/last/i.test(match[1]) ? 'true' : 'false') + ');' + 'if(' + test + '){' + source + '}' + '}';
                    } else {
                      a = /first/i.test(match[1]) ? 'previous' : 'next';
                      n = /only/i.test(match[1]) ? 'previous' : 'next';
                      b = /first|last/i.test(match[1]);
                      type = /-of-type/i.test(match[1]) ? '&&n.nodeName!=e.nodeName' : '&&n.nodeName<"@"';
                      source = 'if(e!==h){' + ('n=e;while((n=n.' + a + 'Sibling)' + type + ');if(!n){' + (b ? source : 'n=e;while((n=n.' + n + 'Sibling)' + type + ');if(!n){' + source + '}') + '}') + '}';
                    }
                    break;
                }
              } else if ((match = selector.match(Patterns.dpseudos)) && match[1]) {
                switch (match[1].match(/^\w+/)[0]) {
                  case 'not':
                    expr = match[3].replace(reTrimSpaces, '');
                    if (Config.SIMPLENOT && !reSimpleNot.test(expr)) {
                      emit('Negation pseudo-class only accepts simple selectors "' + match.join('') + '"');
                      return '';
                    } else {
                      if ('compatMode' in doc) {
                        source = 'if(!' + compile(expr, '', false) + '(e,s,r,d,h,g)){' + source + '}';
                      } else {
                        source = 'if(!s.match(e, "' + expr.replace(/\x22/g, '\\"') + '",g)){' + source + '}';
                      }
                    }
                    break;
                  case 'checked':
                    source = 'if((typeof e.form!=="undefined"&&(/^(?:radio|checkbox)$/i).test(e.type)&&e.checked)' + (Config.USE_HTML5 ? '||(/^option$/i.test(e.nodeName)&&(e.selected||e.checked))' : '') + '){' + source + '}';
                    break;
                  case 'disabled':
                    source = 'if(((typeof e.form!=="undefined"' + (Config.USE_HTML5 ? '' : '&&!(/^hidden$/i).test(e.type)') + ')||s.isLink(e))&&e.disabled===true){' + source + '}';
                    break;
                  case 'enabled':
                    source = 'if(((typeof e.form!=="undefined"' + (Config.USE_HTML5 ? '' : '&&!(/^hidden$/i).test(e.type)') + ')||s.isLink(e))&&e.disabled===false){' + source + '}';
                    break;
                  case 'lang':
                    test = '';
                    if (match[2]) test = match[2].substr(0, 2) + '-';
                    source = 'do{(n=e.lang||"").toLowerCase();' + 'if((n==""&&h.lang=="' + match[2].toLowerCase() + '")||' + '(n&&(n=="' + match[2].toLowerCase() + '"||n.substr(0,3)=="' + test.toLowerCase() + '")))' + '{' + source + 'break;}}while((e=e.parentNode)&&e!==g);';
                    break;
                  case 'target':
                    source = 'if(e.id==d.location.hash.slice(1)){' + source + '}';
                    break;
                  case 'link':
                    source = 'if(s.isLink(e)&&!e.visited){' + source + '}';
                    break;
                  case 'visited':
                    source = 'if(s.isLink(e)&&e.visited){' + source + '}';
                    break;
                  case 'active':
                    source = 'if(e===d.activeElement){' + source + '}';
                    break;
                  case 'hover':
                    source = 'if(e===d.hoverElement){' + source + '}';
                    break;
                  case 'focus':
                    source = 'hasFocus' in doc ? 'if(e===d.activeElement&&d.hasFocus()&&(e.type||e.href||typeof e.tabIndex=="number")){' + source + '}' : 'if(e===d.activeElement&&(e.type||e.href)){' + source + '}';
                    break;
                  case 'selected':
                    source = 'if(/^option$/i.test(e.nodeName)&&(e.selected||e.checked)){' + source + '}';
                    break;
                  default:
                    break;
                }
              } else {
                expr = false;
                status = false;
                for (expr in Selectors) {
                  if ((match = selector.match(Selectors[expr].Expression)) && match[1]) {
                    result = Selectors[expr].Callback(match, source);
                    source = result.source;
                    status = result.status;
                    if (status) {
                      break;
                    }
                  }
                }
                if (!status) {
                  emit('Unknown pseudo-class selector "' + selector + '"');
                  return '';
                }
                if (!expr) {
                  emit('Unknown token in selector "' + selector + '"');
                  return '';
                }
              }
              if (!match) {
                emit('Invalid syntax in selector "' + selector + '"');
                return '';
              }
              selector = match && match[match.length - 1];
            }
            return source;
          },
          match = function match(element, selector, from, callback) {
            var parts;
            if (!(element && element.nodeType == 1)) {
              emit('Invalid element argument');
              return false;
            } else if (typeof selector != 'string') {
              emit('Invalid selector argument');
              return false;
            } else if (lastContext !== from) {
              switchContext(from || (from = element.ownerDocument));
            }
            selector = selector.replace(reTrimSpaces, '');
            Config.SHORTCUTS && (selector = Dom.shortcuts(selector, element, from));
            if (lastMatcher != selector) {
              if ((parts = selector.match(reValidator)) && parts[0] == selector) {
                isSingleMatch = (parts = selector.match(reSplitGroup)).length < 2;
                lastMatcher = selector;
                lastPartsMatch = parts;
              } else {
                emit('The string "' + selector + '", is not a valid CSS selector');
                return false;
              }
            } else parts = lastPartsMatch;
            if (!matchResolvers[selector] || matchContexts[selector] !== from) {
              matchResolvers[selector] = compile(isSingleMatch ? [selector] : parts, '', false);
              matchContexts[selector] = from;
            }
            return matchResolvers[selector](element, Snapshot, [], doc, root, from, callback, {});
          },
          first = function first(selector, from) {
            return select(selector, from, function () {
              return false;
            })[0] || null;
          },
          select = function select(selector, from, callback) {
            var i,
              changed,
              element,
              elements,
              parts,
              token,
              original = selector;
            if (arguments.length === 0) {
              emit('Not enough arguments');
              return [];
            } else if (typeof selector != 'string') {
              return [];
            } else if (from && !/1|9|11/.test(from.nodeType)) {
              emit('Invalid or illegal context element');
              return [];
            } else if (lastContext !== from) {
              switchContext(from || (from = doc));
            }
            if (Config.CACHING && (elements = Dom.loadResults(original, from, doc, root))) {
              return callback ? concatCall([], elements, callback) : elements;
            }
            selector = selector.replace(reTrimSpaces, '');
            Config.SHORTCUTS && (selector = Dom.shortcuts(selector, from));
            if (changed = lastSelector != selector) {
              if ((parts = selector.match(reValidator)) && parts[0] == selector) {
                isSingleSelect = (parts = selector.match(reSplitGroup)).length < 2;
                lastSelector = selector;
                lastPartsSelect = parts;
              } else {
                emit('The string "' + selector + '", is not a valid CSS selector');
                return [];
              }
            } else parts = lastPartsSelect;
            if (from.nodeType == 11) {
              elements = byTagRaw('*', from);
            } else if (isSingleSelect) {
              if (changed) {
                parts = selector.match(reSplitToken);
                token = parts[parts.length - 1];
                lastSlice = token.split(':not')[0];
                lastPosition = selector.length - token.length;
              }
              if (Config.UNIQUE_ID && (parts = lastSlice.match(Optimize.ID)) && (token = parts[1])) {
                if (element = _byId(token, from)) {
                  if (match(element, selector)) {
                    callback && callback(element);
                    elements = global.Array(element);
                  } else elements = global.Array();
                }
              } else if (Config.UNIQUE_ID && (parts = selector.match(Optimize.ID)) && (token = parts[1])) {
                if (element = _byId(token, doc)) {
                  if ('#' + token == selector) {
                    callback && callback(element);
                    elements = global.Array(element);
                  } else if (/[>+~]/.test(selector)) {
                    from = element.parentNode;
                  } else {
                    from = element;
                  }
                } else elements = global.Array();
              }
              if (elements) {
                Config.CACHING && Dom.saveResults(original, from, doc, elements);
                return elements;
              }
              if (!XML_DOCUMENT && GEBTN && (parts = lastSlice.match(Optimize.TAG)) && (token = parts[1])) {
                if ((elements = from.getElementsByTagName(token)).length === 0) {
                  return [];
                }
                selector = selector.slice(0, lastPosition) + selector.slice(lastPosition).replace(token, '*');
              } else if (!XML_DOCUMENT && GEBCN && (parts = lastSlice.match(Optimize.CLASS)) && (token = parts[1])) {
                if ((elements = from.getElementsByClassName(token.replace(/\\([^\\]{1})/g, '$1'))).length === 0) {
                  return [];
                }
                selector = selector.slice(0, lastPosition) + selector.slice(lastPosition).replace('.' + token, reOptimizeSelector.test(selector.charAt(selector.indexOf(token) - 1)) ? '' : '*');
              }
            }
            if (!elements) {
              if (IE_LT_9) {
                elements = /^(?:applet|object)$/i.test(from.nodeName) ? from.childNodes : from.all;
              } else {
                elements = from.getElementsByTagName('*');
              }
            }
            if (!selectResolvers[selector] || selectContexts[selector] !== from) {
              selectResolvers[selector] = compile(isSingleSelect ? [selector] : parts, REJECT_NODE, true);
              selectContexts[selector] = from;
            }
            elements = selectResolvers[selector](elements, Snapshot, [], doc, root, from, callback, {});
            Config.CACHING && Dom.saveResults(original, from, doc, elements);
            return elements;
          },
          FN = function FN(x) {
            return x;
          },
          matchContexts = global.Object(),
          matchResolvers = global.Object(),
          selectContexts = global.Object(),
          selectResolvers = global.Object(),
          Snapshot = global.Object({
            byId: _byId,
            match: match,
            select: select,
            isLink: isLink,
            isEmpty: isEmpty,
            contains: contains,
            nthOfType: nthOfType,
            nthElement: nthElement,
            getAttribute: getAttribute,
            hasAttribute: hasAttribute
          });
        Dom.ACCEPT_NODE = ACCEPT_NODE;
        Dom.byId = byId;
        Dom.match = match;
        Dom.first = first;
        Dom.select = select;
        Dom.compile = compile;
        Dom.contains = contains;
        Dom.configure = configure;
        Dom.getAttribute = getAttribute;
        Dom.hasAttribute = hasAttribute;
        Dom.setCache = FN;
        Dom.shortcuts = FN;
        Dom.loadResults = FN;
        Dom.saveResults = FN;
        Dom.emit = emit;
        Dom.Config = Config;
        Dom.Snapshot = Snapshot;
        Dom.Operators = Operators;
        Dom.Selectors = Selectors;
        Dom.Version = version;
        Dom.registerOperator = function (symbol, resolver) {
          Operators[symbol] || (Operators[symbol] = resolver);
        };
        Dom.registerSelector = function (name, rexp, func) {
          Selectors[name] || (Selectors[name] = global.Object({
            Expression: rexp,
            Callback: func
          }));
        };
        switchContext(doc, true);
      });

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(21)(module));

    /***/
  }, /* 35 */
  /***/function (module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;
    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }
    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }
    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    function noop() {}
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    process.listeners = function (name) {
      return [];
    };
    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };
    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };

    /***/
  }, /* 36 */
  /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      var rng;
      var crypto = global.crypto || global.msCrypto; // for IE 11
      if (crypto && crypto.getRandomValues) {
        // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
        // Moderately fast, high quality
        var _rnds8 = new Uint8Array(16);
        rng = function whatwgRNG() {
          crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
      }
      if (!rng) {
        // Math.random()-based (RNG)
        //
        // If all else fails, use Math.random().  It's fast, but is of unspecified
        // quality.
        var _rnds = new Array(16);
        rng = function rng() {
          for (var i = 0, r; i < 16; i++) {
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
          }
          return _rnds;
        };
      }
      module.exports = rng;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __webpack_require__(6));

    /***/
  }
  /******/]);

  /***/
}, /* 176 */
/***/function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
  // Author: Kuan Huang<kuan.huang@import.io>
  // Created on 2016-12-01

  var ActionMutationObserver = function () {
    function ActionMutationObserver() {
      _classCallCheck(this, ActionMutationObserver);
      this.document = null;
      this.observer = null;
      this.mutations = [];
      this._blackList = {
        attributes: new Set(),
        characterData: new Set(),
        childList: new Set()
      };
    }
    _createClass(ActionMutationObserver, [{
      key: 'observe',
      value: function observe(target, options) {
        var _this = this;
        if (this.observer) {
          this.disconnect();
        }
        this.target = target;
        this.options = options;
        this.document = this.target.ownerDocument || this.target;
        this.observer = new this.document.defaultView.MutationObserver(function (mutations) {
          var _mutations;
          (_mutations = _this.mutations).push.apply(_mutations, _toConsumableArray(mutations.filter(function (m) {
            return !_this.isBlackList(m);
          })));
        });
        this.observer.observe(target, options);
      }
    }, {
      key: 'disconnect',
      value: function disconnect() {
        this.observer.disconnect();
        this.observer = null;
        this.document = null;
        this.target = null;
      }
    }, {
      key: 'takeRecords',
      value: function takeRecords() {
        var mutations = this.mutations;
        this.mutations = [];
        return mutations;
      }
    }, {
      key: 'blackListRecords',
      value: function blackListRecords(mutations) {
        var _this2 = this;
        if (mutations === undefined) {
          mutations = this.mutations;
        }
        mutations.forEach(function (mutation) {
          _this2._blackList[mutation.type].add(mutation.target);
        });
      }
    }, {
      key: 'isBlackList',
      value: function isBlackList(mutation) {
        return this._blackList[mutation.type].has(mutation.target);
      }

      /**
       * grouping mutation targets and find actively mutate common parent of targets
       *
       * @param {MutationRecords} mutations
       * @return {Element} most active region
       */
    }, {
      key: 'getMostActiveRegion',
      value: function getMostActiveRegion(mutations) {
        var _this3 = this;
        var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.6;
        if (mutations.length == 0) return;
        var containedMutations = Symbol('mutations');
        var toCleanElements = [];
        mutations.forEach(function (mutation) {
          var parent = mutation.target;
          if (parent.nodeType != Node.ELEMENT_NODE) {
            parent = mutation.parentElement;
          }
          while (parent) {
            if (parent[containedMutations] === undefined) {
              parent[containedMutations] = [];
              toCleanElements.push(parent);
            }
            parent[containedMutations].push(mutation);
            if (parent === _this3.target) {
              break;
            }
            parent = parent.parentElement;
          }
        });
        var base = this.target.nodeType == Node.DOCUMENT_NODE ? this.target.body : this.target;
        if (!base || !base[containedMutations]) return;
        var mostActiveRegion = base;
        var changed = true;
        while (mostActiveRegion && changed) {
          changed = false;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;
          try {
            for (var _iterator = mostActiveRegion.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var child = _step.value;
              if (child[containedMutations] && child[containedMutations].length > threshold * base[containedMutations].length && child[containedMutations].length >= mostActiveRegion[containedMutations].length) {
                mostActiveRegion = child;
                changed = true;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        // clean
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
          for (var _iterator2 = toCleanElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var element = _step2.value;
            delete element[containedMutations];
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
        return mostActiveRegion;
      }
    }]);
    return ActionMutationObserver;
  }();
  ActionMutationObserver.displayName = 'ActionMutationObserver';
  exports.default = ActionMutationObserver;

  /***/
}, /* 177 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _actions = __webpack_require__(59);
  var _actions2 = _interopRequireDefault(_actions);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var BrowserReplay = function () {
    function BrowserReplay() {
      _classCallCheck(this, BrowserReplay);
    }
    _createClass(BrowserReplay, null, [{
      key: 'playEvents',
      value: function playEvents() {
        if (!localStorage.recordedAction) console.error('no saved actions found');
        var action = _actions2.default.fromJSON(document, JSON.parse(localStorage.recordedAction));
        console.log('play action', action);
        action.play().then(function () {
          return console.log('done');
        }, console.error);
      }
    }]);
    return BrowserReplay;
  }();
  BrowserReplay.displayName = 'BrowserReplay';
  exports.default = BrowserReplay;

  /***/
}, /* 178 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /* WEBPACK VAR INJECTION */
  (function (global, module) {
    //     Underscore.js 1.9.1
    //     http://underscorejs.org
    //     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    //     Underscore may be freely distributed under the MIT license.

    (function () {
      // Baseline setup
      // --------------

      // Establish the root object, `window` (`self`) in the browser, `global`
      // on the server, or `this` in some virtual machines. We use `self`
      // instead of `window` for `WebWorker` support.
      var root = typeof self == 'object' && self.self === self && self || typeof global == 'object' && global.global === global && global || this || {};

      // Save the previous value of the `_` variable.
      var previousUnderscore = root._;

      // Save bytes in the minified (but not gzipped) version:
      var ArrayProto = Array.prototype,
        ObjProto = Object.prototype;
      var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

      // Create quick reference variables for speed access to core prototypes.
      var push = ArrayProto.push,
        slice = ArrayProto.slice,
        toString = ObjProto.toString,
        hasOwnProperty = ObjProto.hasOwnProperty;

      // All **ECMAScript 5** native function implementations that we hope to use
      // are declared here.
      var nativeIsArray = Array.isArray,
        nativeKeys = Object.keys,
        nativeCreate = Object.create;

      // Naked function reference for surrogate-prototype-swapping.
      var Ctor = function Ctor() {};

      // Create a safe reference to the Underscore object for use below.
      var _ = function _(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
      };

      // Export the Underscore object for **Node.js**, with
      // backwards-compatibility for their old module API. If we're in
      // the browser, add `_` as a global object.
      // (`nodeType` is checked to ensure that `module`
      // and `exports` are not HTML elements.)
      if (typeof exports != 'undefined' && !exports.nodeType) {
        if (typeof module != 'undefined' && !module.nodeType && module.exports) {
          exports = module.exports = _;
        }
        exports._ = _;
      } else {
        root._ = _;
      }

      // Current version.
      _.VERSION = '1.9.1';

      // Internal function that returns an efficient (for current engines) version
      // of the passed-in callback, to be repeatedly applied in other Underscore
      // functions.
      var optimizeCb = function optimizeCb(func, context, argCount) {
        if (context === void 0) return func;
        switch (argCount == null ? 3 : argCount) {
          case 1:
            return function (value) {
              return func.call(context, value);
            };
          // The 2-argument case is omitted because we’re not using it.
          case 3:
            return function (value, index, collection) {
              return func.call(context, value, index, collection);
            };
          case 4:
            return function (accumulator, value, index, collection) {
              return func.call(context, accumulator, value, index, collection);
            };
        }
        return function () {
          return func.apply(context, arguments);
        };
      };
      var builtinIteratee;

      // An internal function to generate callbacks that can be applied to each
      // element in a collection, returning the desired result — either `identity`,
      // an arbitrary callback, a property matcher, or a property accessor.
      var cb = function cb(value, context, argCount) {
        if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
        if (value == null) return _.identity;
        if (_.isFunction(value)) return optimizeCb(value, context, argCount);
        if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
        return _.property(value);
      };

      // External wrapper for our callback generator. Users may customize
      // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
      // This abstraction hides the internal-only argCount argument.
      _.iteratee = builtinIteratee = function builtinIteratee(value, context) {
        return cb(value, context, Infinity);
      };

      // Some functions take a variable number of arguments, or a few expected
      // arguments at the beginning and then a variable number of values to operate
      // on. This helper accumulates all remaining arguments past the function’s
      // argument length (or an explicit `startIndex`), into an array that becomes
      // the last argument. Similar to ES6’s "rest parameter".
      var restArguments = function restArguments(func, startIndex) {
        startIndex = startIndex == null ? func.length - 1 : +startIndex;
        return function () {
          var length = Math.max(arguments.length - startIndex, 0),
            rest = Array(length),
            index = 0;
          for (; index < length; index++) {
            rest[index] = arguments[index + startIndex];
          }
          switch (startIndex) {
            case 0:
              return func.call(this, rest);
            case 1:
              return func.call(this, arguments[0], rest);
            case 2:
              return func.call(this, arguments[0], arguments[1], rest);
          }
          var args = Array(startIndex + 1);
          for (index = 0; index < startIndex; index++) {
            args[index] = arguments[index];
          }
          args[startIndex] = rest;
          return func.apply(this, args);
        };
      };

      // An internal function for creating a new object that inherits from another.
      var baseCreate = function baseCreate(prototype) {
        if (!_.isObject(prototype)) return {};
        if (nativeCreate) return nativeCreate(prototype);
        Ctor.prototype = prototype;
        var result = new Ctor();
        Ctor.prototype = null;
        return result;
      };
      var shallowProperty = function shallowProperty(key) {
        return function (obj) {
          return obj == null ? void 0 : obj[key];
        };
      };
      var has = function has(obj, path) {
        return obj != null && hasOwnProperty.call(obj, path);
      };
      var deepGet = function deepGet(obj, path) {
        var length = path.length;
        for (var i = 0; i < length; i++) {
          if (obj == null) return void 0;
          obj = obj[path[i]];
        }
        return length ? obj : void 0;
      };

      // Helper for collection methods to determine whether a collection
      // should be iterated as an array or as an object.
      // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
      // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
      var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
      var getLength = shallowProperty('length');
      var isArrayLike = function isArrayLike(collection) {
        var length = getLength(collection);
        return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
      };

      // Collection Functions
      // --------------------

      // The cornerstone, an `each` implementation, aka `forEach`.
      // Handles raw objects in addition to array-likes. Treats all
      // sparse array-likes as if they were dense.
      _.each = _.forEach = function (obj, iteratee, context) {
        iteratee = optimizeCb(iteratee, context);
        var i, length;
        if (isArrayLike(obj)) {
          for (i = 0, length = obj.length; i < length; i++) {
            iteratee(obj[i], i, obj);
          }
        } else {
          var keys = _.keys(obj);
          for (i = 0, length = keys.length; i < length; i++) {
            iteratee(obj[keys[i]], keys[i], obj);
          }
        }
        return obj;
      };

      // Return the results of applying the iteratee to each element.
      _.map = _.collect = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          results = Array(length);
        for (var index = 0; index < length; index++) {
          var currentKey = keys ? keys[index] : index;
          results[index] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
      };

      // Create a reducing function iterating left or right.
      var createReduce = function createReduce(dir) {
        // Wrap code that reassigns argument variables in a separate function than
        // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
        var reducer = function reducer(obj, iteratee, memo, initial) {
          var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length,
            index = dir > 0 ? 0 : length - 1;
          if (!initial) {
            memo = obj[keys ? keys[index] : index];
            index += dir;
          }
          for (; index >= 0 && index < length; index += dir) {
            var currentKey = keys ? keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
          }
          return memo;
        };
        return function (obj, iteratee, memo, context) {
          var initial = arguments.length >= 3;
          return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
        };
      };

      // **Reduce** builds up a single result from a list of values, aka `inject`,
      // or `foldl`.
      _.reduce = _.foldl = _.inject = createReduce(1);

      // The right-associative version of reduce, also known as `foldr`.
      _.reduceRight = _.foldr = createReduce(-1);

      // Return the first value which passes a truth test. Aliased as `detect`.
      _.find = _.detect = function (obj, predicate, context) {
        var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
        var key = keyFinder(obj, predicate, context);
        if (key !== void 0 && key !== -1) return obj[key];
      };

      // Return all the elements that pass a truth test.
      // Aliased as `select`.
      _.filter = _.select = function (obj, predicate, context) {
        var results = [];
        predicate = cb(predicate, context);
        _.each(obj, function (value, index, list) {
          if (predicate(value, index, list)) results.push(value);
        });
        return results;
      };

      // Return all the elements for which a truth test fails.
      _.reject = function (obj, predicate, context) {
        return _.filter(obj, _.negate(cb(predicate)), context);
      };

      // Determine whether all of the elements match a truth test.
      // Aliased as `all`.
      _.every = _.all = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
          var currentKey = keys ? keys[index] : index;
          if (!predicate(obj[currentKey], currentKey, obj)) return false;
        }
        return true;
      };

      // Determine if at least one element in the object matches a truth test.
      // Aliased as `any`.
      _.some = _.any = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
          var currentKey = keys ? keys[index] : index;
          if (predicate(obj[currentKey], currentKey, obj)) return true;
        }
        return false;
      };

      // Determine if the array or object contains a given item (using `===`).
      // Aliased as `includes` and `include`.
      _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
        if (!isArrayLike(obj)) obj = _.values(obj);
        if (typeof fromIndex != 'number' || guard) fromIndex = 0;
        return _.indexOf(obj, item, fromIndex) >= 0;
      };

      // Invoke a method (with arguments) on every item in a collection.
      _.invoke = restArguments(function (obj, path, args) {
        var contextPath, func;
        if (_.isFunction(path)) {
          func = path;
        } else if (_.isArray(path)) {
          contextPath = path.slice(0, -1);
          path = path[path.length - 1];
        }
        return _.map(obj, function (context) {
          var method = func;
          if (!method) {
            if (contextPath && contextPath.length) {
              context = deepGet(context, contextPath);
            }
            if (context == null) return void 0;
            method = context[path];
          }
          return method == null ? method : method.apply(context, args);
        });
      });

      // Convenience version of a common use case of `map`: fetching a property.
      _.pluck = function (obj, key) {
        return _.map(obj, _.property(key));
      };

      // Convenience version of a common use case of `filter`: selecting only objects
      // containing specific `key:value` pairs.
      _.where = function (obj, attrs) {
        return _.filter(obj, _.matcher(attrs));
      };

      // Convenience version of a common use case of `find`: getting the first object
      // containing specific `key:value` pairs.
      _.findWhere = function (obj, attrs) {
        return _.find(obj, _.matcher(attrs));
      };

      // Return the maximum element (or element-based computation).
      _.max = function (obj, iteratee, context) {
        var result = -Infinity,
          lastComputed = -Infinity,
          value,
          computed;
        if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
          obj = isArrayLike(obj) ? obj : _.values(obj);
          for (var i = 0, length = obj.length; i < length; i++) {
            value = obj[i];
            if (value != null && value > result) {
              result = value;
            }
          }
        } else {
          iteratee = cb(iteratee, context);
          _.each(obj, function (v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
              result = v;
              lastComputed = computed;
            }
          });
        }
        return result;
      };

      // Return the minimum element (or element-based computation).
      _.min = function (obj, iteratee, context) {
        var result = Infinity,
          lastComputed = Infinity,
          value,
          computed;
        if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
          obj = isArrayLike(obj) ? obj : _.values(obj);
          for (var i = 0, length = obj.length; i < length; i++) {
            value = obj[i];
            if (value != null && value < result) {
              result = value;
            }
          }
        } else {
          iteratee = cb(iteratee, context);
          _.each(obj, function (v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
              result = v;
              lastComputed = computed;
            }
          });
        }
        return result;
      };

      // Shuffle a collection.
      _.shuffle = function (obj) {
        return _.sample(obj, Infinity);
      };

      // Sample **n** random values from a collection using the modern version of the
      // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
      // If **n** is not specified, returns a single random element.
      // The internal `guard` argument allows it to work with `map`.
      _.sample = function (obj, n, guard) {
        if (n == null || guard) {
          if (!isArrayLike(obj)) obj = _.values(obj);
          return obj[_.random(obj.length - 1)];
        }
        var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
        var length = getLength(sample);
        n = Math.max(Math.min(n, length), 0);
        var last = length - 1;
        for (var index = 0; index < n; index++) {
          var rand = _.random(index, last);
          var temp = sample[index];
          sample[index] = sample[rand];
          sample[rand] = temp;
        }
        return sample.slice(0, n);
      };

      // Sort the object's values by a criterion produced by an iteratee.
      _.sortBy = function (obj, iteratee, context) {
        var index = 0;
        iteratee = cb(iteratee, context);
        return _.pluck(_.map(obj, function (value, key, list) {
          return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
          };
        }).sort(function (left, right) {
          var a = left.criteria;
          var b = right.criteria;
          if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
          }
          return left.index - right.index;
        }), 'value');
      };

      // An internal function used for aggregate "group by" operations.
      var group = function group(behavior, partition) {
        return function (obj, iteratee, context) {
          var result = partition ? [[], []] : {};
          iteratee = cb(iteratee, context);
          _.each(obj, function (value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
          });
          return result;
        };
      };

      // Groups the object's values by a criterion. Pass either a string attribute
      // to group by, or a function that returns the criterion.
      _.groupBy = group(function (result, value, key) {
        if (has(result, key)) result[key].push(value);else result[key] = [value];
      });

      // Indexes the object's values by a criterion, similar to `groupBy`, but for
      // when you know that your index values will be unique.
      _.indexBy = group(function (result, value, key) {
        result[key] = value;
      });

      // Counts instances of an object that group by a certain criterion. Pass
      // either a string attribute to count by, or a function that returns the
      // criterion.
      _.countBy = group(function (result, value, key) {
        if (has(result, key)) result[key]++;else result[key] = 1;
      });
      var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
      // Safely create a real, live array from anything iterable.
      _.toArray = function (obj) {
        if (!obj) return [];
        if (_.isArray(obj)) return slice.call(obj);
        if (_.isString(obj)) {
          // Keep surrogate pair characters together
          return obj.match(reStrSymbol);
        }
        if (isArrayLike(obj)) return _.map(obj, _.identity);
        return _.values(obj);
      };

      // Return the number of elements in an object.
      _.size = function (obj) {
        if (obj == null) return 0;
        return isArrayLike(obj) ? obj.length : _.keys(obj).length;
      };

      // Split a collection into two arrays: one whose elements all satisfy the given
      // predicate, and one whose elements all do not satisfy the predicate.
      _.partition = group(function (result, value, pass) {
        result[pass ? 0 : 1].push(value);
      }, true);

      // Array Functions
      // ---------------

      // Get the first element of an array. Passing **n** will return the first N
      // values in the array. Aliased as `head` and `take`. The **guard** check
      // allows it to work with `_.map`.
      _.first = _.head = _.take = function (array, n, guard) {
        if (array == null || array.length < 1) return n == null ? void 0 : [];
        if (n == null || guard) return array[0];
        return _.initial(array, array.length - n);
      };

      // Returns everything but the last entry of the array. Especially useful on
      // the arguments object. Passing **n** will return all the values in
      // the array, excluding the last N.
      _.initial = function (array, n, guard) {
        return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
      };

      // Get the last element of an array. Passing **n** will return the last N
      // values in the array.
      _.last = function (array, n, guard) {
        if (array == null || array.length < 1) return n == null ? void 0 : [];
        if (n == null || guard) return array[array.length - 1];
        return _.rest(array, Math.max(0, array.length - n));
      };

      // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
      // Especially useful on the arguments object. Passing an **n** will return
      // the rest N values in the array.
      _.rest = _.tail = _.drop = function (array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
      };

      // Trim out all falsy values from an array.
      _.compact = function (array) {
        return _.filter(array, Boolean);
      };

      // Internal implementation of a recursive `flatten` function.
      var flatten = function flatten(input, shallow, strict, output) {
        output = output || [];
        var idx = output.length;
        for (var i = 0, length = getLength(input); i < length; i++) {
          var value = input[i];
          if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
            // Flatten current level of array or arguments object.
            if (shallow) {
              var j = 0,
                len = value.length;
              while (j < len) output[idx++] = value[j++];
            } else {
              flatten(value, shallow, strict, output);
              idx = output.length;
            }
          } else if (!strict) {
            output[idx++] = value;
          }
        }
        return output;
      };

      // Flatten out an array, either recursively (by default), or just one level.
      _.flatten = function (array, shallow) {
        return flatten(array, shallow, false);
      };

      // Return a version of the array that does not contain the specified value(s).
      _.without = restArguments(function (array, otherArrays) {
        return _.difference(array, otherArrays);
      });

      // Produce a duplicate-free version of the array. If the array has already
      // been sorted, you have the option of using a faster algorithm.
      // The faster algorithm will not work with an iteratee if the iteratee
      // is not a one-to-one function, so providing an iteratee will disable
      // the faster algorithm.
      // Aliased as `unique`.
      _.uniq = _.unique = function (array, isSorted, iteratee, context) {
        if (!_.isBoolean(isSorted)) {
          context = iteratee;
          iteratee = isSorted;
          isSorted = false;
        }
        if (iteratee != null) iteratee = cb(iteratee, context);
        var result = [];
        var seen = [];
        for (var i = 0, length = getLength(array); i < length; i++) {
          var value = array[i],
            computed = iteratee ? iteratee(value, i, array) : value;
          if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
          } else if (iteratee) {
            if (!_.contains(seen, computed)) {
              seen.push(computed);
              result.push(value);
            }
          } else if (!_.contains(result, value)) {
            result.push(value);
          }
        }
        return result;
      };

      // Produce an array that contains the union: each distinct element from all of
      // the passed-in arrays.
      _.union = restArguments(function (arrays) {
        return _.uniq(flatten(arrays, true, true));
      });

      // Produce an array that contains every item shared between all the
      // passed-in arrays.
      _.intersection = function (array) {
        var result = [];
        var argsLength = arguments.length;
        for (var i = 0, length = getLength(array); i < length; i++) {
          var item = array[i];
          if (_.contains(result, item)) continue;
          var j;
          for (j = 1; j < argsLength; j++) {
            if (!_.contains(arguments[j], item)) break;
          }
          if (j === argsLength) result.push(item);
        }
        return result;
      };

      // Take the difference between one array and a number of other arrays.
      // Only the elements present in just the first array will remain.
      _.difference = restArguments(function (array, rest) {
        rest = flatten(rest, true, true);
        return _.filter(array, function (value) {
          return !_.contains(rest, value);
        });
      });

      // Complement of _.zip. Unzip accepts an array of arrays and groups
      // each array's elements on shared indices.
      _.unzip = function (array) {
        var length = array && _.max(array, getLength).length || 0;
        var result = Array(length);
        for (var index = 0; index < length; index++) {
          result[index] = _.pluck(array, index);
        }
        return result;
      };

      // Zip together multiple lists into a single array -- elements that share
      // an index go together.
      _.zip = restArguments(_.unzip);

      // Converts lists into objects. Pass either a single array of `[key, value]`
      // pairs, or two parallel arrays of the same length -- one of keys, and one of
      // the corresponding values. Passing by pairs is the reverse of _.pairs.
      _.object = function (list, values) {
        var result = {};
        for (var i = 0, length = getLength(list); i < length; i++) {
          if (values) {
            result[list[i]] = values[i];
          } else {
            result[list[i][0]] = list[i][1];
          }
        }
        return result;
      };

      // Generator function to create the findIndex and findLastIndex functions.
      var createPredicateIndexFinder = function createPredicateIndexFinder(dir) {
        return function (array, predicate, context) {
          predicate = cb(predicate, context);
          var length = getLength(array);
          var index = dir > 0 ? 0 : length - 1;
          for (; index >= 0 && index < length; index += dir) {
            if (predicate(array[index], index, array)) return index;
          }
          return -1;
        };
      };

      // Returns the first index on an array-like that passes a predicate test.
      _.findIndex = createPredicateIndexFinder(1);
      _.findLastIndex = createPredicateIndexFinder(-1);

      // Use a comparator function to figure out the smallest index at which
      // an object should be inserted so as to maintain order. Uses binary search.
      _.sortedIndex = function (array, obj, iteratee, context) {
        iteratee = cb(iteratee, context, 1);
        var value = iteratee(obj);
        var low = 0,
          high = getLength(array);
        while (low < high) {
          var mid = Math.floor((low + high) / 2);
          if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
        }
        return low;
      };

      // Generator function to create the indexOf and lastIndexOf functions.
      var createIndexFinder = function createIndexFinder(dir, predicateFind, sortedIndex) {
        return function (array, item, idx) {
          var i = 0,
            length = getLength(array);
          if (typeof idx == 'number') {
            if (dir > 0) {
              i = idx >= 0 ? idx : Math.max(idx + length, i);
            } else {
              length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
            }
          } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
          }
          if (item !== item) {
            idx = predicateFind(slice.call(array, i, length), _.isNaN);
            return idx >= 0 ? idx + i : -1;
          }
          for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
            if (array[idx] === item) return idx;
          }
          return -1;
        };
      };

      // Return the position of the first occurrence of an item in an array,
      // or -1 if the item is not included in the array.
      // If the array is large and already in sort order, pass `true`
      // for **isSorted** to use binary search.
      _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
      _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

      // Generate an integer Array containing an arithmetic progression. A port of
      // the native Python `range()` function. See
      // [the Python documentation](http://docs.python.org/library/functions.html#range).
      _.range = function (start, stop, step) {
        if (stop == null) {
          stop = start || 0;
          start = 0;
        }
        if (!step) {
          step = stop < start ? -1 : 1;
        }
        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var range = Array(length);
        for (var idx = 0; idx < length; idx++, start += step) {
          range[idx] = start;
        }
        return range;
      };

      // Chunk a single array into multiple arrays, each containing `count` or fewer
      // items.
      _.chunk = function (array, count) {
        if (count == null || count < 1) return [];
        var result = [];
        var i = 0,
          length = array.length;
        while (i < length) {
          result.push(slice.call(array, i, i += count));
        }
        return result;
      };

      // Function (ahem) Functions
      // ------------------

      // Determines whether to execute a function as a constructor
      // or a normal function with the provided arguments.
      var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
        if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
        var self = baseCreate(sourceFunc.prototype);
        var result = sourceFunc.apply(self, args);
        if (_.isObject(result)) return result;
        return self;
      };

      // Create a function bound to a given object (assigning `this`, and arguments,
      // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
      // available.
      _.bind = restArguments(function (func, context, args) {
        if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
        var bound = restArguments(function (callArgs) {
          return executeBound(func, bound, context, this, args.concat(callArgs));
        });
        return bound;
      });

      // Partially apply a function by creating a version that has had some of its
      // arguments pre-filled, without changing its dynamic `this` context. _ acts
      // as a placeholder by default, allowing any combination of arguments to be
      // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
      _.partial = restArguments(function (func, boundArgs) {
        var placeholder = _.partial.placeholder;
        var bound = function bound() {
          var position = 0,
            length = boundArgs.length;
          var args = Array(length);
          for (var i = 0; i < length; i++) {
            args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
          }
          while (position < arguments.length) args.push(arguments[position++]);
          return executeBound(func, bound, this, this, args);
        };
        return bound;
      });
      _.partial.placeholder = _;

      // Bind a number of an object's methods to that object. Remaining arguments
      // are the method names to be bound. Useful for ensuring that all callbacks
      // defined on an object belong to it.
      _.bindAll = restArguments(function (obj, keys) {
        keys = flatten(keys, false, false);
        var index = keys.length;
        if (index < 1) throw new Error('bindAll must be passed function names');
        while (index--) {
          var key = keys[index];
          obj[key] = _.bind(obj[key], obj);
        }
      });

      // Memoize an expensive function by storing its results.
      _.memoize = function (func, hasher) {
        var memoize = function memoize(key) {
          var cache = memoize.cache;
          var address = '' + (hasher ? hasher.apply(this, arguments) : key);
          if (!has(cache, address)) cache[address] = func.apply(this, arguments);
          return cache[address];
        };
        memoize.cache = {};
        return memoize;
      };

      // Delays a function for the given number of milliseconds, and then calls
      // it with the arguments supplied.
      _.delay = restArguments(function (func, wait, args) {
        return setTimeout(function () {
          return func.apply(null, args);
        }, wait);
      });

      // Defers a function, scheduling it to run after the current call stack has
      // cleared.
      _.defer = _.partial(_.delay, _, 1);

      // Returns a function, that, when invoked, will only be triggered at most once
      // during a given window of time. Normally, the throttled function will run
      // as much as it can, without ever going more than once per `wait` duration;
      // but if you'd like to disable the execution on the leading edge, pass
      // `{leading: false}`. To disable execution on the trailing edge, ditto.
      _.throttle = function (func, wait, options) {
        var timeout, context, args, result;
        var previous = 0;
        if (!options) options = {};
        var later = function later() {
          previous = options.leading === false ? 0 : _.now();
          timeout = null;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        };
        var throttled = function throttled() {
          var now = _.now();
          if (!previous && options.leading === false) previous = now;
          var remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0 || remaining > wait) {
            if (timeout) {
              clearTimeout(timeout);
              timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
        throttled.cancel = function () {
          clearTimeout(timeout);
          previous = 0;
          timeout = context = args = null;
        };
        return throttled;
      };

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.
      _.debounce = function (func, wait, immediate) {
        var timeout, result;
        var later = function later(context, args) {
          timeout = null;
          if (args) result = func.apply(context, args);
        };
        var debounced = restArguments(function (args) {
          if (timeout) clearTimeout(timeout);
          if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(later, wait);
            if (callNow) result = func.apply(this, args);
          } else {
            timeout = _.delay(later, wait, this, args);
          }
          return result;
        });
        debounced.cancel = function () {
          clearTimeout(timeout);
          timeout = null;
        };
        return debounced;
      };

      // Returns the first function passed as an argument to the second,
      // allowing you to adjust arguments, run code before and after, and
      // conditionally execute the original function.
      _.wrap = function (func, wrapper) {
        return _.partial(wrapper, func);
      };

      // Returns a negated version of the passed-in predicate.
      _.negate = function (predicate) {
        return function () {
          return !predicate.apply(this, arguments);
        };
      };

      // Returns a function that is the composition of a list of functions, each
      // consuming the return value of the function that follows.
      _.compose = function () {
        var args = arguments;
        var start = args.length - 1;
        return function () {
          var i = start;
          var result = args[start].apply(this, arguments);
          while (i--) result = args[i].call(this, result);
          return result;
        };
      };

      // Returns a function that will only be executed on and after the Nth call.
      _.after = function (times, func) {
        return function () {
          if (--times < 1) {
            return func.apply(this, arguments);
          }
        };
      };

      // Returns a function that will only be executed up to (but not including) the Nth call.
      _.before = function (times, func) {
        var memo;
        return function () {
          if (--times > 0) {
            memo = func.apply(this, arguments);
          }
          if (times <= 1) func = null;
          return memo;
        };
      };

      // Returns a function that will be executed at most one time, no matter how
      // often you call it. Useful for lazy initialization.
      _.once = _.partial(_.before, 2);
      _.restArguments = restArguments;

      // Object Functions
      // ----------------

      // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
      var hasEnumBug = !{
        toString: null
      }.propertyIsEnumerable('toString');
      var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
      var collectNonEnumProps = function collectNonEnumProps(obj, keys) {
        var nonEnumIdx = nonEnumerableProps.length;
        var constructor = obj.constructor;
        var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

        // Constructor is a special case.
        var prop = 'constructor';
        if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
        while (nonEnumIdx--) {
          prop = nonEnumerableProps[nonEnumIdx];
          if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
            keys.push(prop);
          }
        }
      };

      // Retrieve the names of an object's own properties.
      // Delegates to **ECMAScript 5**'s native `Object.keys`.
      _.keys = function (obj) {
        if (!_.isObject(obj)) return [];
        if (nativeKeys) return nativeKeys(obj);
        var keys = [];
        for (var key in obj) if (has(obj, key)) keys.push(key);
        // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
      };

      // Retrieve all the property names of an object.
      _.allKeys = function (obj) {
        if (!_.isObject(obj)) return [];
        var keys = [];
        for (var key in obj) keys.push(key);
        // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
      };

      // Retrieve the values of an object's properties.
      _.values = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = Array(length);
        for (var i = 0; i < length; i++) {
          values[i] = obj[keys[i]];
        }
        return values;
      };

      // Returns the results of applying the iteratee to each element of the object.
      // In contrast to _.map it returns an object.
      _.mapObject = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = _.keys(obj),
          length = keys.length,
          results = {};
        for (var index = 0; index < length; index++) {
          var currentKey = keys[index];
          results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
      };

      // Convert an object into a list of `[key, value]` pairs.
      // The opposite of _.object.
      _.pairs = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = Array(length);
        for (var i = 0; i < length; i++) {
          pairs[i] = [keys[i], obj[keys[i]]];
        }
        return pairs;
      };

      // Invert the keys and values of an object. The values must be serializable.
      _.invert = function (obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
          result[obj[keys[i]]] = keys[i];
        }
        return result;
      };

      // Return a sorted list of the function names available on the object.
      // Aliased as `methods`.
      _.functions = _.methods = function (obj) {
        var names = [];
        for (var key in obj) {
          if (_.isFunction(obj[key])) names.push(key);
        }
        return names.sort();
      };

      // An internal function for creating assigner functions.
      var createAssigner = function createAssigner(keysFunc, defaults) {
        return function (obj) {
          var length = arguments.length;
          if (defaults) obj = Object(obj);
          if (length < 2 || obj == null) return obj;
          for (var index = 1; index < length; index++) {
            var source = arguments[index],
              keys = keysFunc(source),
              l = keys.length;
            for (var i = 0; i < l; i++) {
              var key = keys[i];
              if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
          }
          return obj;
        };
      };

      // Extend a given object with all the properties in passed-in object(s).
      _.extend = createAssigner(_.allKeys);

      // Assigns a given object with all the own properties in the passed-in object(s).
      // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
      _.extendOwn = _.assign = createAssigner(_.keys);

      // Returns the first key on an object that passes a predicate test.
      _.findKey = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = _.keys(obj),
          key;
        for (var i = 0, length = keys.length; i < length; i++) {
          key = keys[i];
          if (predicate(obj[key], key, obj)) return key;
        }
      };

      // Internal pick helper function to determine if `obj` has key `key`.
      var keyInObj = function keyInObj(value, key, obj) {
        return key in obj;
      };

      // Return a copy of the object only containing the whitelisted properties.
      _.pick = restArguments(function (obj, keys) {
        var result = {},
          iteratee = keys[0];
        if (obj == null) return result;
        if (_.isFunction(iteratee)) {
          if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
          keys = _.allKeys(obj);
        } else {
          iteratee = keyInObj;
          keys = flatten(keys, false, false);
          obj = Object(obj);
        }
        for (var i = 0, length = keys.length; i < length; i++) {
          var key = keys[i];
          var value = obj[key];
          if (iteratee(value, key, obj)) result[key] = value;
        }
        return result;
      });

      // Return a copy of the object without the blacklisted properties.
      _.omit = restArguments(function (obj, keys) {
        var iteratee = keys[0],
          context;
        if (_.isFunction(iteratee)) {
          iteratee = _.negate(iteratee);
          if (keys.length > 1) context = keys[1];
        } else {
          keys = _.map(flatten(keys, false, false), String);
          iteratee = function iteratee(value, key) {
            return !_.contains(keys, key);
          };
        }
        return _.pick(obj, iteratee, context);
      });

      // Fill in a given object with default properties.
      _.defaults = createAssigner(_.allKeys, true);

      // Creates an object that inherits from the given prototype object.
      // If additional properties are provided then they will be added to the
      // created object.
      _.create = function (prototype, props) {
        var result = baseCreate(prototype);
        if (props) _.extendOwn(result, props);
        return result;
      };

      // Create a (shallow-cloned) duplicate of an object.
      _.clone = function (obj) {
        if (!_.isObject(obj)) return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
      };

      // Invokes interceptor with the obj, and then returns obj.
      // The primary purpose of this method is to "tap into" a method chain, in
      // order to perform operations on intermediate results within the chain.
      _.tap = function (obj, interceptor) {
        interceptor(obj);
        return obj;
      };

      // Returns whether an object has a given set of `key:value` pairs.
      _.isMatch = function (object, attrs) {
        var keys = _.keys(attrs),
          length = keys.length;
        if (object == null) return !length;
        var obj = Object(object);
        for (var i = 0; i < length; i++) {
          var key = keys[i];
          if (attrs[key] !== obj[key] || !(key in obj)) return false;
        }
        return true;
      };

      // Internal recursive comparison function for `isEqual`.
      var eq, deepEq;
      eq = function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) return b !== b;
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
        return deepEq(a, b, aStack, bStack);
      };

      // Internal recursive comparison function for `isEqual`.
      deepEq = function deepEq(a, b, aStack, bStack) {
        // Unwrap any wrapped objects.
        if (a instanceof _) a = a._wrapped;
        if (b instanceof _) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = toString.call(a);
        if (className !== toString.call(b)) return false;
        switch (className) {
          // Strings, numbers, regular expressions, dates, and booleans are compared by value.
          case '[object RegExp]':
          // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
          case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return '' + a === '' + b;
          case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
          case '[object Date]':
          case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
          case '[object Symbol]':
            return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
        }
        var areArrays = className === '[object Array]';
        if (!areArrays) {
          if (typeof a != 'object' || typeof b != 'object') return false;

          // Objects with different constructors are not equivalent, but `Object`s or `Array`s
          // from different frames are.
          var aCtor = a.constructor,
            bCtor = b.constructor;
          if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
            return false;
          }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
          // Linear search. Performance is inversely proportional to the number of
          // unique nested structures.
          if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
          // Compare array lengths to determine if a deep comparison is necessary.
          length = a.length;
          if (length !== b.length) return false;
          // Deep compare the contents, ignoring non-numeric properties.
          while (length--) {
            if (!eq(a[length], b[length], aStack, bStack)) return false;
          }
        } else {
          // Deep compare objects.
          var keys = _.keys(a),
            key;
          length = keys.length;
          // Ensure that both objects contain the same number of properties before comparing deep equality.
          if (_.keys(b).length !== length) return false;
          while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
          }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
      };

      // Perform a deep comparison to check if two objects are equal.
      _.isEqual = function (a, b) {
        return eq(a, b);
      };

      // Is a given array, string, or object empty?
      // An "empty" object has no enumerable own-properties.
      _.isEmpty = function (obj) {
        if (obj == null) return true;
        if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
        return _.keys(obj).length === 0;
      };

      // Is a given value a DOM element?
      _.isElement = function (obj) {
        return !!(obj && obj.nodeType === 1);
      };

      // Is a given value an array?
      // Delegates to ECMA5's native Array.isArray
      _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) === '[object Array]';
      };

      // Is a given variable an object?
      _.isObject = function (obj) {
        var type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
      };

      // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
      _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function (name) {
        _['is' + name] = function (obj) {
          return toString.call(obj) === '[object ' + name + ']';
        };
      });

      // Define a fallback version of the method in browsers (ahem, IE < 9), where
      // there isn't any inspectable "Arguments" type.
      if (!_.isArguments(arguments)) {
        _.isArguments = function (obj) {
          return has(obj, 'callee');
        };
      }

      // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
      // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
      var nodelist = root.document && root.document.childNodes;
      if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
        _.isFunction = function (obj) {
          return typeof obj == 'function' || false;
        };
      }

      // Is a given object a finite number?
      _.isFinite = function (obj) {
        return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
      };

      // Is the given value `NaN`?
      _.isNaN = function (obj) {
        return _.isNumber(obj) && isNaN(obj);
      };

      // Is a given value a boolean?
      _.isBoolean = function (obj) {
        return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
      };

      // Is a given value equal to null?
      _.isNull = function (obj) {
        return obj === null;
      };

      // Is a given variable undefined?
      _.isUndefined = function (obj) {
        return obj === void 0;
      };

      // Shortcut function for checking if an object has a given property directly
      // on itself (in other words, not on a prototype).
      _.has = function (obj, path) {
        if (!_.isArray(path)) {
          return has(obj, path);
        }
        var length = path.length;
        for (var i = 0; i < length; i++) {
          var key = path[i];
          if (obj == null || !hasOwnProperty.call(obj, key)) {
            return false;
          }
          obj = obj[key];
        }
        return !!length;
      };

      // Utility Functions
      // -----------------

      // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
      // previous owner. Returns a reference to the Underscore object.
      _.noConflict = function () {
        root._ = previousUnderscore;
        return this;
      };

      // Keep the identity function around for default iteratees.
      _.identity = function (value) {
        return value;
      };

      // Predicate-generating functions. Often useful outside of Underscore.
      _.constant = function (value) {
        return function () {
          return value;
        };
      };
      _.noop = function () {};

      // Creates a function that, when passed an object, will traverse that object’s
      // properties down the given `path`, specified as an array of keys or indexes.
      _.property = function (path) {
        if (!_.isArray(path)) {
          return shallowProperty(path);
        }
        return function (obj) {
          return deepGet(obj, path);
        };
      };

      // Generates a function for a given object that returns a given property.
      _.propertyOf = function (obj) {
        if (obj == null) {
          return function () {};
        }
        return function (path) {
          return !_.isArray(path) ? obj[path] : deepGet(obj, path);
        };
      };

      // Returns a predicate for checking whether an object has a given set of
      // `key:value` pairs.
      _.matcher = _.matches = function (attrs) {
        attrs = _.extendOwn({}, attrs);
        return function (obj) {
          return _.isMatch(obj, attrs);
        };
      };

      // Run a function **n** times.
      _.times = function (n, iteratee, context) {
        var accum = Array(Math.max(0, n));
        iteratee = optimizeCb(iteratee, context, 1);
        for (var i = 0; i < n; i++) accum[i] = iteratee(i);
        return accum;
      };

      // Return a random integer between min and max (inclusive).
      _.random = function (min, max) {
        if (max == null) {
          max = min;
          min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
      };

      // A (possibly faster) way to get the current timestamp as an integer.
      _.now = Date.now || function () {
        return new Date().getTime();
      };

      // List of HTML entities for escaping.
      var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
      };
      var unescapeMap = _.invert(escapeMap);

      // Functions for escaping and unescaping strings to/from HTML interpolation.
      var createEscaper = function createEscaper(map) {
        var escaper = function escaper(match) {
          return map[match];
        };
        // Regexes for identifying a key that needs to be escaped.
        var source = '(?:' + _.keys(map).join('|') + ')';
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, 'g');
        return function (string) {
          string = string == null ? '' : '' + string;
          return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
        };
      };
      _.escape = createEscaper(escapeMap);
      _.unescape = createEscaper(unescapeMap);

      // Traverses the children of `obj` along `path`. If a child is a function, it
      // is invoked with its parent as context. Returns the value of the final
      // child, or `fallback` if any child is undefined.
      _.result = function (obj, path, fallback) {
        if (!_.isArray(path)) path = [path];
        var length = path.length;
        if (!length) {
          return _.isFunction(fallback) ? fallback.call(obj) : fallback;
        }
        for (var i = 0; i < length; i++) {
          var prop = obj == null ? void 0 : obj[path[i]];
          if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
          }

          obj = _.isFunction(prop) ? prop.call(obj) : prop;
        }
        return obj;
      };

      // Generate a unique integer id (unique within the entire client session).
      // Useful for temporary DOM ids.
      var idCounter = 0;
      _.uniqueId = function (prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
      };

      // By default, Underscore uses ERB-style template delimiters, change the
      // following template settings to use alternative delimiters.
      _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };

      // When customizing `templateSettings`, if you don't want to define an
      // interpolation, evaluation or escaping regex, we need one that is
      // guaranteed not to match.
      var noMatch = /(.)^/;

      // Certain characters need to be escaped so that they can be put into a
      // string literal.
      var escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        "\u2028": 'u2028',
        "\u2029": 'u2029'
      };
      var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
      var escapeChar = function escapeChar(match) {
        return '\\' + escapes[match];
      };

      // JavaScript micro-templating, similar to John Resig's implementation.
      // Underscore templating handles arbitrary delimiters, preserves whitespace,
      // and correctly escapes quotes within interpolated code.
      // NB: `oldSettings` only exists for backwards compatibility.
      _.template = function (text, settings, oldSettings) {
        if (!settings && oldSettings) settings = oldSettings;
        settings = _.defaults({}, settings, _.templateSettings);

        // Combine delimiters into one regular expression via alternation.
        var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
          source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
          index = offset + match.length;
          if (escape) {
            source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
          } else if (interpolate) {
            source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
          } else if (evaluate) {
            source += "';\n" + evaluate + "\n__p+='";
          }

          // Adobe VMs need the match returned to produce the correct offset.
          return match;
        });
        source += "';\n";

        // If a variable is not specified, place data values in local scope.
        if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
        var render;
        try {
          render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
          e.source = source;
          throw e;
        }
        var template = function template(data) {
          return render.call(this, data, _);
        };

        // Provide the compiled source as a convenience for precompilation.
        var argument = settings.variable || 'obj';
        template.source = 'function(' + argument + '){\n' + source + '}';
        return template;
      };

      // Add a "chain" function. Start chaining a wrapped Underscore object.
      _.chain = function (obj) {
        var instance = _(obj);
        instance._chain = true;
        return instance;
      };

      // OOP
      // ---------------
      // If Underscore is called as a function, it returns a wrapped object that
      // can be used OO-style. This wrapper holds altered versions of all the
      // underscore functions. Wrapped objects may be chained.

      // Helper function to continue chaining intermediate results.
      var chainResult = function chainResult(instance, obj) {
        return instance._chain ? _(obj).chain() : obj;
      };

      // Add your own custom functions to the Underscore object.
      _.mixin = function (obj) {
        _.each(_.functions(obj), function (name) {
          var func = _[name] = obj[name];
          _.prototype[name] = function () {
            var args = [this._wrapped];
            push.apply(args, arguments);
            return chainResult(this, func.apply(_, args));
          };
        });
        return _;
      };

      // Add all of the Underscore functions to the wrapper object.
      _.mixin(_);

      // Add all mutator Array functions to the wrapper.
      _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
          var obj = this._wrapped;
          method.apply(obj, arguments);
          if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
          return chainResult(this, obj);
        };
      });

      // Add all accessor Array functions to the wrapper.
      _.each(['concat', 'join', 'slice'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
          return chainResult(this, method.apply(this._wrapped, arguments));
        };
      });

      // Extracts the result from a wrapped and chained object.
      _.prototype.value = function () {
        return this._wrapped;
      };

      // Provide unwrapping proxy for some methods used in engine operations
      // such as arithmetic and JSON stringification.
      _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
      _.prototype.toString = function () {
        return String(this._wrapped);
      };

      // AMD registration happens at the end for compatibility with AMD loaders
      // that may not enforce next-turn semantics on modules. Even though general
      // practice for AMD registration is to be anonymous, underscore registers
      // as a named module because, like jQuery, it is a base library that is
      // popular enough to be bundled in a third party lib, but not be part of
      // an AMD load request. Those cases could generate an error when an
      // anonymous define() is called outside of a loader request.
      if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return _;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      }
    })();

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(132)(module));

  /***/
}, /* 179 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);
      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === undefined) {
        return undefined;
      }
      return getter.call(receiver);
    }
  };
  var _treeMirror = __webpack_require__(180);
  var _mutationSummary = __webpack_require__(182);
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var frameReplaceContent = '<!DOCTYPE html>Frame Blocked';
  function insertCaptchaHandler(iframeNode, captchaType) {
    if (!iframeNode) return;
    if (!captchaType) return;
    // const iframeRect = iframeNode.getBoundingClientRect();
    // some captcha now show from the beginning
    // eg. https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search
    // TODO: need a better way to make handler size correct
    // if (iframeRect.width == 0 || iframeRect.height == 0) return;

    var container = iframeNode.parentElement;
    // container must containing input
    while (container && !container.querySelector('input,textarea')) {
      container = container.parentElement;
    }
    // container should have some id to locate it
    while (container) {
      if (container.id) break;
      if (container.getAttribute('data-pkey')) break;
      if (container.getAttribute('data-sitekey')) break;
      if (container.className) break;
      container = container.parentElement;
    }
    if (!container) return;
    if (container.tagName === 'BODY') return; // recaptcha use iframe to request tracing api
    if (container.getAttribute('captchafound')) return;
    // const containerRect = container.getBoundingClientRect();

    var document = container.ownerDocument;
    var newDiv = document.createElement('div');
    newDiv.className = 'captcha-state-handler';
    // newDiv.style.top = `${iframeRect.top - containerRect.top}px`;
    // newDiv.style.left = `${iframeRect.left - containerRect.left}px`;
    // newDiv.style.height = `${iframeRect.height}px`;
    // newDiv.style.width = `${iframeRect.width}px`;
    container.prepend(newDiv);
    container.setAttribute('captchafound', 'true');
    container.setAttribute('captchatype', captchaType);
    if (!document.querySelector('style[captcha]')) {
      var style = document.createElement('style');
      style.setAttribute('captcha', '');
      style.innerHTML = '\n      [captchafound] { position: relative !important }\n      [captchafound] .captcha-state-handler {\n        position: absolute !important;\n        background-color: #6e99e6 !important;\n        z-index: 99999 !important;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n      }\n\n      [captchafound] .captcha-state-handler::after {\n        content: "Click here to resolve this captcha.";\n        position: relative !important;\n        float: left !important;\n        top: 50% !important;\n        left: 50% !important;\n        transform: translate(-50%, -50%) !important;\n        color: black !important;\n      }\n      [captchafound][captchastatus=solving] .captcha-state-handler::after {\n        content: "Solving captcha, please wait for solution...";\n      }\n      [captchafound][captchastatus=ok] .captcha-state-handler {\n        background-color: #8bc34a !important;\n      }\n      [captchafound][captchastatus=ok] .captcha-state-handler::after {\n        content: "Captcha solved, You can submit the form now ;)";\n      }\n      [captchafound][captchastatus=fail] .captcha-state-handler {\n        background-color: #ec6060 !important;\n      }\n      [captchafound][captchastatus=fail] .captcha-state-handler::after {\n        content: "Captcha solver has failed.";\n      }\n    ';
      var elem = document.head ? document.head : document.firstElementChild.firstElementChild;
      elem.insertBefore(style, elem.firstChild);
    }
  }
  var TwoWayTreeMirror = function (_TreeMirror) {
    _inherits(TwoWayTreeMirror, _TreeMirror);
    function TwoWayTreeMirror() {
      var _ref;
      _classCallCheck(this, TwoWayTreeMirror);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var _this = _possibleConstructorReturn(this, (_ref = TwoWayTreeMirror.__proto__ || Object.getPrototypeOf(TwoWayTreeMirror)).call.apply(_ref, [this].concat(args)));
      _this.knownNodes = new _mutationSummary.MutationSummary.NodeMap();
      return _this;
    }
    _createClass(TwoWayTreeMirror, [{
      key: 'deserializeNode',
      value: function deserializeNode(nodeData, parent) {
        var _delegate,
          _get2,
          _this2 = this;

        // fix for http://www.carrier.com/residential/en/us/find-a-dealer/
        if (nodeData && nodeData.name === '' && nodeData.nodeType === Node.DOCUMENT_TYPE_NODE) {
          nodeData.name = 'html';
        }
        if (nodeData && nodeData.nodeType == Node.ELEMENT_NODE && (nodeData.tagName == 'IFRAME' || nodeData.tagName == 'FRAME')) {
          if (nodeData.attributes && nodeData.attributes.src) {
            nodeData.attributes['_src'] = nodeData.attributes.src;
            delete nodeData.attributes['src'];
          }
          if (nodeData.attributes && nodeData.attributes.sandbox) {
            nodeData.attributes['_sandbox'] = nodeData.attributes.sandbox;
            delete nodeData.attributes['sandbox'];
          }
          if (nodeData.attributes && nodeData.attributes.srcdoc) {
            nodeData.attributes['_srcdoc'] = nodeData.attributes.doc;
          }
          nodeData.attributes['srcdoc'] = frameReplaceContent;
        }
        if (nodeData && nodeData.tagName === 'META' && nodeData.attributes && nodeData.attributes['http-equiv'] && nodeData.attributes['http-equiv'].toLowerCase() === 'content-security-policy') {
          nodeData.attributes['http-equiv'] = 'DISABLE-Content-Security-Policy';
        }
        if (nodeData && nodeData.tagName === 'META' && nodeData.attributes && nodeData.attributes['http-equiv'] && nodeData.attributes['http-equiv'].toLowerCase() === 'refresh') {
          nodeData.attributes['http-equiv'] = 'DISABLE-refresh';
        }
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }
        this.delegate.deserializeNode && (_delegate = this.delegate).deserializeNode.apply(_delegate, [nodeData, parent].concat(args));
        var node = (_get2 = _get(TwoWayTreeMirror.prototype.__proto__ || Object.getPrototypeOf(TwoWayTreeMirror.prototype), 'deserializeNode', this)).call.apply(_get2, [this, nodeData, parent].concat(args));
        if (node) this.knownNodes.set(node, nodeData.id);
        if (nodeData && nodeData.nodeType == Node.ELEMENT_NODE && (nodeData.tagName == 'IFRAME' || nodeData.tagName == 'FRAME')) {
          var nodeSrc = node.getAttribute('_src') || '';
          // make sure node had attached to it's parent, node may add to DOM here:
          // https://github.com/import-io/page-interaction-sdk/blob/master/lib/tree-mirror.js#L35
          setTimeout(function () {
            var _parent = nodeData.parentNode && _this2.deserializeNode(nodeData.parentNode);
            _this2.delegate.frameAttached && _this2.delegate.frameAttached(node, parent || _parent);
          });

          // search for recaptcha / funcaptcha container
          var captchaType = null;
          if (nodeSrc.match(/^https?:\/\/funcaptcha\.com.+&pk=[\w-]+/)) {
            captchaType = 'FUNCAPTCHA';
          } else if (nodeSrc.match(/^https:\/\/www\.google\.com\/recaptcha.+&k=[\w-]+/)) {
            captchaType = 'RECAPTCHA';
          }
          if (captchaType && this.delegate.captchaSupport) {
            setTimeout(function () {
              insertCaptchaHandler(node, captchaType);
            }, 0);
          }
        }

        // if parent is contenteditable, the nodes may added by client, which will cause conflict
        if (nodeData && nodeData.nodeType && nodeData.parentNode && node) {
          var _parent2 = this.deserializeNode(nodeData.parentNode);
          if (_parent2 && _parent2.isContentEditable) {
            var removed = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;
            try {
              for (var _iterator = _parent2.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _node = _step.value;
                if (_node.hasAttributes('sub-frame-overlay')) continue;
                if (this.knownNodes.get(_node) === undefined) {
                  removed = true;
                  _parent2.removeChild(_node);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
            if (removed) {
              // move selector to end
              setTimeout(function () {
                var selector = node.ownerDocument.defaultView.getSelection();
                selector.collapse(node, node.length);
              }, 0);
            }
          }
        }

        // Removing all potential DOM event handlers so they wouldn't be executed in the iframe.
        if (node && node.hasAttributes && node.hasAttributes()) {
          Array.from(node.attributes).map(function (attr) {
            return attr.name;
          }).filter(function (name) {
            return name.length >= 2 && name[0] === 'o' && name[1] === 'n';
          }).forEach(function (name) {
            var attr = node.getAttribute(name);
            node.setAttribute('_' + name, attr.value);
            node.removeAttribute(name);
          });
        }
        return node;
      }
    }, {
      key: 'serializeNode',
      value: function serializeNode(node) {
        if (node === null) return null;
        var id = this.knownNodes.get(node);
        if (id !== undefined) {
          return {
            id: id
          };
        }
      }
    }, {
      key: 'changeValue',
      value: function changeValue(nodeData, attrs) {
        var node = this.deserializeNode(nodeData);
        if (!node) {
          return;
        }
        if (attrs.values) {
          [].concat(_toConsumableArray(node.options)).forEach(function (o) {
            if (attrs.values.indexOf(o.value || o.text) != -1) {
              o.selected = true;
            } else {
              o.selected = false;
            }
          });
        } else {
          Object.assign(node, attrs);
        }
      }
    }, {
      key: 'createElement',
      value: function createElement(tagName) {
        if (tagName === 'SCRIPT') {
          var node = document.createElement('NO-SCRIPT');
          node.style.display = 'none';
          return node;
        }
        if (tagName === 'HEAD' && this.delegate.url) {
          var _node2 = document.createElement('HEAD');
          _node2.appendChild(document.createElement('BASE'));
          _node2.firstChild.href = this.delegate.url;
          return _node2;
        }
        if (tagName === 'BODY') {
          var _node3 = document.createElement('BODY');
          if (!this.delegate.addFrameOverlay) return _node3;
          if (!document.querySelector('style[sub-frame-overlay]')) {
            var style = document.createElement('style');
            style.setAttribute('sub-frame-overlay', '');
            style.innerHTML = '\n        div[sub-frame-overlay] {\n          position: absolute !important;\n          background-color: #9e9e9e22 !important;\n          z-index: 99999 !important;\n          cursor: url(data:image/png;base64,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) 0 0, auto !important;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n        }\n        div[sub-frame-overlay]::after {\n          content: \'Frame\';\n          font-size: 48px;\n          position: relative !important;\n          float: right !important;\n          padding: 0 10px;\n          color: #cecece66 !important;\n        }\n        ';
            _node3.appendChild(style);
          }
          var newDiv = document.createElement('DIV');
          newDiv.setAttribute('title', "We don't support frames at the moment.");
          newDiv.setAttribute('sub-frame-overlay', '');
          _node3.appendChild(newDiv);
          return _node3;
        }

        // if tagName is not a work, test if it can be created via createElement,
        // if not, create via innertHTML instead. it's a fallback for tagName like
        // 'LINK REL="NEXT"' (note: it's not [space] in string) found in http://www.theknowledgeonline.com/search/Camera_Operators
        if (!/^\w+$/.test(tagName)) {
          try {
            document.createElement(tagName);
          } catch (error) {
            var div = document.createElement('div');
            div.innerHTML = '<' + tagName + '>';
            return div.firstChild;
          }
        }
      }
    }]);
    return TwoWayTreeMirror;
  }(_treeMirror.TreeMirror);
  exports.default = TwoWayTreeMirror;

  /***/
}, /* 180 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TreeMirror = exports.TreeMirrorClient = undefined;
  var _treeMirror = __webpack_require__(181);
  exports.TreeMirrorClient = _treeMirror.TreeMirrorClient;
  exports.TreeMirror = _treeMirror.TreeMirror;

  /***/
}, /* 181 */
/***/function (module, exports, __webpack_require__) {
  /*** IMPORTS FROM imports-loader ***/
  var ms = __webpack_require__(182);
  var MutationSummary = ms.MutationSummary;

  ///<reference path='../src/mutation-summary.ts'/>
  var TreeMirror = function () {
    function TreeMirror(root, delegate) {
      this.root = root;
      this.delegate = delegate;
      this.idMap = {};
    }
    TreeMirror.prototype.initialize = function (rootId, children) {
      this.idMap[rootId] = this.root;
      for (var i = 0; i < children.length; i++) this.deserializeNode(children[i], this.root);
    };
    TreeMirror.prototype.applyChanged = function (removed, addedOrMoved, attributes, text) {
      var _this = this;
      // NOTE: Applying the changes can result in an attempting to add a child
      // to a parent which is presently an ancestor of the parent. This can occur
      // based on random ordering of moves. The way we handle this is to first
      // remove all changed nodes from their parents, then apply.
      addedOrMoved.forEach(function (data) {
        var node = _this.deserializeNode(data);
        var parent = _this.deserializeNode(data.parentNode);
        var previous = _this.deserializeNode(data.previousSibling);
        if (node.parentNode) node.parentNode.removeChild(node);
      });
      removed.forEach(function (data) {
        var node = _this.deserializeNode(data);
        if (node.parentNode) node.parentNode.removeChild(node);
        _this.delegate.nodeRemoved && _this.delegate.nodeRemoved(node);
        _this.nodeRemoved && _this.nodeRemoved(node);
      });
      addedOrMoved.forEach(function (data) {
        var newNode = !_this.idMap[data.id];
        var node = _this.deserializeNode(data);
        var parent = _this.deserializeNode(data.parentNode);
        var previous = _this.deserializeNode(data.previousSibling);
        parent.insertBefore(node, previous ? previous.nextSibling : parent.firstChild);
        if (newNode) {
          _this.delegate.nodeAdded && _this.delegate.nodeAdded(node);
          _this.nodeAdded && _this.nodeAdded(node);
        } else {
          _this.nodeMoved && _this.nodeMoved(node);
        }
      });
      attributes.forEach(function (data) {
        var node = _this.deserializeNode(data);
        Object.keys(data.attributes).forEach(function (attrName) {
          var newVal = data.attributes[attrName];
          if (newVal === null) {
            node.removeAttribute(attrName);
          } else {
            if (_this.delegate && _this.delegate.setAttribute && _this.delegate.setAttribute(node, attrName, newVal)) {} else if (_this.setAttribute && _this.setAttribute(node, attrName, newVal)) {} else {
              node.setAttribute(attrName, newVal);
            }
          }
        });
      });
      text.forEach(function (data) {
        var node = _this.deserializeNode(data);
        node.textContent = data.textContent;
      });
      removed.forEach(function (node) {
        delete _this.idMap[node.id];
      });
    };
    TreeMirror.prototype.getParentNs = function (parent) {
      if (!parent || !parent.getAttribute) {
        return undefined;
      }
      if (parent.tagName === 'HTML') {
        return undefined;
      }
      var ns = parent.getAttribute('xmlns');
      if (ns) {
        return ns;
      }
      if (!parent.parentElement) {
        return undefined;
      }
      return this.getParentNs(parent.parentElement);
    };
    TreeMirror.prototype.deserializeNode = function (nodeData, parent) {
      var _this = this;
      if (nodeData === null) return null;
      var node = this.idMap[nodeData.id];
      if (node) return node;
      var doc = this.root.ownerDocument;
      if (doc === null) doc = this.root;
      switch (nodeData.nodeType) {
        case Node.COMMENT_NODE:
          node = doc.createComment(nodeData.textContent);
          break;
        case Node.TEXT_NODE:
          node = doc.createTextNode(nodeData.textContent);
          break;
        case Node.DOCUMENT_TYPE_NODE:
          node = doc.implementation.createDocumentType(nodeData.name, nodeData.publicId, nodeData.systemId);
          break;
        case Node.ELEMENT_NODE:
          if (this.delegate && this.delegate.createElement) node = this.delegate.createElement(nodeData.tagName);
          if (!node && this.createElement) node = this.createElement(nodeData.tagName);
          if (!node) {
            var ns = nodeData.attributes.xmlns;
            if (!ns) ns = this.getParentNs(parent);
            if (ns) {
              node = doc.createElementNS(ns, nodeData.tagName);
            } else {
              node = doc.createElement(nodeData.tagName);
            }
          }
          Object.keys(nodeData.attributes).forEach(function (name) {
            if (_this.delegate && _this.delegate.setAttribute && _this.delegate.setAttribute(node, name, nodeData.attributes[name])) {} else if (_this.setAttribute && _this.setAttribute(node, name, nodeData.attributes[name])) {} else {
              node.setAttribute(name, nodeData.attributes[name]);
            }
          });
          break;
      }
      if (!node) throw "ouch";
      this.idMap[nodeData.id] = node;
      if (parent) {
        parent.appendChild(node);
        this.delegate.nodeAdded && this.delegate.nodeAdded(node);
        this.nodeAdded && this.nodeAdded(node);
      }
      if (nodeData.childNodes) {
        for (var i = 0; i < nodeData.childNodes.length; i++) this.deserializeNode(nodeData.childNodes[i], node);
      }
      return node;
    };
    return TreeMirror;
  }();
  var TreeMirrorClient = function () {
    function TreeMirrorClient(target, mirror, testingQueries) {
      var _this = this;
      this.target = target;
      this.mirror = mirror;
      this.nextId = 1;
      this.knownNodes = new MutationSummary.NodeMap();
      var rootId = this.serializeNode(target).id;
      var children = [];
      for (var child = target.firstChild; child; child = child.nextSibling) children.push(this.serializeNode(child, true));
      this.mirror.initialize(rootId, children);
      var self = this;
      var queries = [{
        all: true
      }];
      if (testingQueries) queries = queries.concat(testingQueries);
      this.mutationSummary = new MutationSummary({
        rootNode: target,
        callback: function callback(summaries) {
          _this.applyChanged(summaries);
        },
        queries: queries
      });
    }
    TreeMirrorClient.prototype.disconnect = function () {
      if (this.mutationSummary) {
        this.mutationSummary.disconnect();
        this.mutationSummary = undefined;
      }
    };
    TreeMirrorClient.prototype.rememberNode = function (node) {
      var id = this.nextId++;
      this.knownNodes.set(node, id);
      return id;
    };
    TreeMirrorClient.prototype.forgetNode = function (node) {
      this.knownNodes.delete(node);
    };
    TreeMirrorClient.prototype.serializeNode = function (node, recursive) {
      if (node === null) return null;
      var id = this.knownNodes.get(node);
      if (id !== undefined) {
        return {
          id: id
        };
      }
      var data = {
        nodeType: node.nodeType,
        id: this.rememberNode(node)
      };
      switch (data.nodeType) {
        case Node.DOCUMENT_TYPE_NODE:
          var docType = node;
          data.name = docType.name;
          data.publicId = docType.publicId;
          data.systemId = docType.systemId;
          break;
        case Node.COMMENT_NODE:
        case Node.TEXT_NODE:
          data.textContent = node.textContent;
          break;
        case Node.ELEMENT_NODE:
          var elm = node;
          data.tagName = elm.tagName;
          data.attributes = {};
          for (var i = 0; i < elm.attributes.length; i++) {
            var attr = elm.attributes[i];
            data.attributes[attr.name] = attr.value;
          }
          if (recursive && elm.childNodes.length) {
            data.childNodes = [];
            for (var child = elm.firstChild; child; child = child.nextSibling) data.childNodes.push(this.serializeNode(child, true));
          }
          break;
      }
      return data;
    };
    TreeMirrorClient.prototype.serializeAddedAndMoved = function (added, reparented, reordered) {
      var _this = this;
      var all = added.concat(reparented).concat(reordered);
      var parentMap = new MutationSummary.NodeMap();
      all.forEach(function (node) {
        var parent = node.parentNode;
        var children = parentMap.get(parent);
        if (!children) {
          children = new MutationSummary.NodeMap();
          parentMap.set(parent, children);
        }
        children.set(node, true);
      });
      var moved = [];
      parentMap.keys().forEach(function (parent) {
        var children = parentMap.get(parent);
        var keys = children.keys();
        while (keys.length) {
          var node = keys[0];
          while (node.previousSibling && children.has(node.previousSibling)) node = node.previousSibling;
          while (node && children.has(node)) {
            var data = _this.serializeNode(node);
            data.previousSibling = _this.serializeNode(node.previousSibling);
            data.parentNode = _this.serializeNode(node.parentNode);
            moved.push(data);
            children.delete(node);
            node = node.nextSibling;
          }
          var keys = children.keys();
        }
      });
      return moved;
    };
    TreeMirrorClient.prototype.serializeAttributeChanges = function (attributeChanged) {
      var _this = this;
      var map = new MutationSummary.NodeMap();
      Object.keys(attributeChanged).forEach(function (attrName) {
        attributeChanged[attrName].forEach(function (element) {
          var record = map.get(element);
          if (!record) {
            record = _this.serializeNode(element);
            record.attributes = {};
            map.set(element, record);
          }
          record.attributes[attrName] = element.getAttribute(attrName);
        });
      });
      return map.keys().map(function (node) {
        return map.get(node);
      });
    };
    TreeMirrorClient.prototype.applyChanged = function (summaries) {
      var _this = this;
      var summary = summaries[0];
      var removed = summary.removed.map(function (node) {
        return _this.serializeNode(node);
      });
      var moved = this.serializeAddedAndMoved(summary.added, summary.reparented, summary.reordered);
      var attributes = this.serializeAttributeChanges(summary.attributeChanged);
      var text = summary.characterDataChanged.map(function (node) {
        var data = _this.serializeNode(node);
        data.textContent = node.textContent;
        return data;
      });
      this.mirror.applyChanged(removed, moved, attributes, text);
      summary.removed.forEach(function (node) {
        _this.forgetNode(node);
      });
    };
    return TreeMirrorClient;
  }();

  /*** EXPORTS FROM exports-loader ***/
  exports["TreeMirrorClient"] = TreeMirrorClient;
  exports["TreeMirror"] = TreeMirror;

  /***/
}, /* 182 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MutationSummary = undefined;
  var _mutationSummary = __webpack_require__(183);
  var _mutationSummary2 = _interopRequireDefault(_mutationSummary);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.MutationSummary = _mutationSummary2.default; // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
  // Author: Kuan Huang<kuan.huang@import.io>
  // Created on 2016-12-20

  /***/
}, /* 183 */
/***/function (module, exports) {
  /*** IMPORTS FROM imports-loader ***/
  (function () {
    // Copyright 2011 Google Inc.
    //
    // Licensed under the Apache License, Version 2.0 (the "License");
    // you may not use this file except in compliance with the License.
    // You may obtain a copy of the License at
    //
    //     http://www.apache.org/licenses/LICENSE-2.0
    //
    // Unless required by applicable law or agreed to in writing, software
    // distributed under the License is distributed on an "AS IS" BASIS,
    // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    // See the License for the specific language governing permissions and
    // limitations under the License.
    var __extends = this.__extends || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      function __() {
        this.constructor = d;
      }
      __.prototype = b.prototype;
      d.prototype = new __();
    };
    var MutationObserverCtor;
    if (typeof WebKitMutationObserver !== 'undefined') MutationObserverCtor = WebKitMutationObserver;else MutationObserverCtor = MutationObserver;
    if (MutationObserverCtor === undefined) {
      console.error('DOM Mutation Observers are required.');
      console.error('https://developer.mozilla.org/en-US/docs/DOM/MutationObserver');
      throw Error('DOM Mutation Observers are required');
    }
    var NodeMap = function () {
      function NodeMap() {
        this.nodes = [];
        this.values = [];
      }
      NodeMap.prototype.isIndex = function (s) {
        return +s === s >>> 0;
      };
      NodeMap.prototype.nodeId = function (node) {
        var id = node[NodeMap.ID_PROP];
        if (!id) id = node[NodeMap.ID_PROP] = NodeMap.nextId_++;
        return id;
      };
      NodeMap.prototype.set = function (node, value) {
        var id = this.nodeId(node);
        this.nodes[id] = node;
        this.values[id] = value;
      };
      NodeMap.prototype.get = function (node) {
        var id = this.nodeId(node);
        return this.values[id];
      };
      NodeMap.prototype.has = function (node) {
        return this.nodeId(node) in this.nodes;
      };
      NodeMap.prototype.delete = function (node) {
        var id = this.nodeId(node);
        delete this.nodes[id];
        this.values[id] = undefined;
      };
      NodeMap.prototype.keys = function () {
        var nodes = [];
        for (var id in this.nodes) {
          if (!this.isIndex(id)) continue;
          nodes.push(this.nodes[id]);
        }
        return nodes;
      };
      NodeMap.ID_PROP = '__mutation_summary_node_map_id__';
      NodeMap.nextId_ = 1;
      return NodeMap;
    }();
    /**
     *  var reachableMatchableProduct = [
     *  //  STAYED_OUT,  ENTERED,     STAYED_IN,   EXITED
     *    [ STAYED_OUT,  STAYED_OUT,  STAYED_OUT,  STAYED_OUT ], // STAYED_OUT
     *    [ STAYED_OUT,  ENTERED,     ENTERED,     STAYED_OUT ], // ENTERED
     *    [ STAYED_OUT,  ENTERED,     STAYED_IN,   EXITED     ], // STAYED_IN
     *    [ STAYED_OUT,  STAYED_OUT,  EXITED,      EXITED     ]  // EXITED
     *  ];
     */
    var Movement;
    (function (Movement) {
      Movement[Movement["STAYED_OUT"] = 0] = "STAYED_OUT";
      Movement[Movement["ENTERED"] = 1] = "ENTERED";
      Movement[Movement["STAYED_IN"] = 2] = "STAYED_IN";
      Movement[Movement["REPARENTED"] = 3] = "REPARENTED";
      Movement[Movement["REORDERED"] = 4] = "REORDERED";
      Movement[Movement["EXITED"] = 5] = "EXITED";
    })(Movement || (Movement = {}));
    function enteredOrExited(changeType) {
      return changeType === Movement.ENTERED || changeType === Movement.EXITED;
    }
    var NodeChange = function () {
      function NodeChange(node, childList, attributes, characterData, oldParentNode, added, attributeOldValues, characterDataOldValue) {
        if (childList === void 0) {
          childList = false;
        }
        if (attributes === void 0) {
          attributes = false;
        }
        if (characterData === void 0) {
          characterData = false;
        }
        if (oldParentNode === void 0) {
          oldParentNode = null;
        }
        if (added === void 0) {
          added = false;
        }
        if (attributeOldValues === void 0) {
          attributeOldValues = null;
        }
        if (characterDataOldValue === void 0) {
          characterDataOldValue = null;
        }
        this.node = node;
        this.childList = childList;
        this.attributes = attributes;
        this.characterData = characterData;
        this.oldParentNode = oldParentNode;
        this.added = added;
        this.attributeOldValues = attributeOldValues;
        this.characterDataOldValue = characterDataOldValue;
        this.isCaseInsensitive = this.node.nodeType === Node.ELEMENT_NODE && this.node instanceof HTMLElement && this.node.ownerDocument instanceof HTMLDocument;
      }
      NodeChange.prototype.getAttributeOldValue = function (name) {
        if (!this.attributeOldValues) return undefined;
        if (this.isCaseInsensitive) name = name.toLowerCase();
        return this.attributeOldValues[name];
      };
      NodeChange.prototype.getAttributeNamesMutated = function () {
        var names = [];
        if (!this.attributeOldValues) return names;
        for (var name in this.attributeOldValues) {
          names.push(name);
        }
        return names;
      };
      NodeChange.prototype.attributeMutated = function (name, oldValue) {
        this.attributes = true;
        this.attributeOldValues = this.attributeOldValues || {};
        if (name in this.attributeOldValues) return;
        this.attributeOldValues[name] = oldValue;
      };
      NodeChange.prototype.characterDataMutated = function (oldValue) {
        if (this.characterData) return;
        this.characterData = true;
        this.characterDataOldValue = oldValue;
      };
      // Note: is it possible to receive a removal followed by a removal. This
      // can occur if the removed node is added to an non-observed node, that
      // node is added to the observed area, and then the node removed from
      // it.
      NodeChange.prototype.removedFromParent = function (parent) {
        this.childList = true;
        if (this.added || this.oldParentNode) this.added = false;else this.oldParentNode = parent;
      };
      NodeChange.prototype.insertedIntoParent = function () {
        this.childList = true;
        this.added = true;
      };
      // An node's oldParent is
      //   -its present parent, if its parentNode was not changed.
      //   -null if the first thing that happened to it was an add.
      //   -the node it was removed from if the first thing that happened to it
      //      was a remove.
      NodeChange.prototype.getOldParent = function () {
        if (this.childList) {
          if (this.oldParentNode) return this.oldParentNode;
          if (this.added) return null;
        }
        return this.node.parentNode;
      };
      return NodeChange;
    }();
    var ChildListChange = function () {
      function ChildListChange() {
        this.added = new NodeMap();
        this.removed = new NodeMap();
        this.maybeMoved = new NodeMap();
        this.oldPrevious = new NodeMap();
        this.moved = undefined;
      }
      return ChildListChange;
    }();
    var TreeChanges = function (_super) {
      __extends(TreeChanges, _super);
      function TreeChanges(rootNode, mutations) {
        _super.call(this);
        this.rootNode = rootNode;
        this.reachableCache = undefined;
        this.wasReachableCache = undefined;
        this.anyParentsChanged = false;
        this.anyAttributesChanged = false;
        this.anyCharacterDataChanged = false;
        for (var m = 0; m < mutations.length; m++) {
          var mutation = mutations[m];
          switch (mutation.type) {
            case 'childList':
              this.anyParentsChanged = true;
              for (var i = 0; i < mutation.removedNodes.length; i++) {
                var node = mutation.removedNodes[i];
                this.getChange(node).removedFromParent(mutation.target);
              }
              for (var i = 0; i < mutation.addedNodes.length; i++) {
                var node = mutation.addedNodes[i];
                this.getChange(node).insertedIntoParent();
              }
              break;
            case 'attributes':
              this.anyAttributesChanged = true;
              var change = this.getChange(mutation.target);
              change.attributeMutated(mutation.attributeName, mutation.oldValue);
              break;
            case 'characterData':
              this.anyCharacterDataChanged = true;
              var change = this.getChange(mutation.target);
              change.characterDataMutated(mutation.oldValue);
              break;
          }
        }
      }
      TreeChanges.prototype.getChange = function (node) {
        var change = this.get(node);
        if (!change) {
          change = new NodeChange(node);
          this.set(node, change);
        }
        return change;
      };
      TreeChanges.prototype.getOldParent = function (node) {
        var change = this.get(node);
        return change ? change.getOldParent() : node.parentNode;
      };
      TreeChanges.prototype.getIsReachable = function (node) {
        if (node === this.rootNode) return true;
        if (!node) return false;
        this.reachableCache = this.reachableCache || new NodeMap();
        var isReachable = this.reachableCache.get(node);
        if (isReachable === undefined) {
          isReachable = this.getIsReachable(node.parentNode);
          this.reachableCache.set(node, isReachable);
        }
        return isReachable;
      };
      // A node wasReachable if its oldParent wasReachable.
      TreeChanges.prototype.getWasReachable = function (node) {
        if (node === this.rootNode) return true;
        if (!node) return false;
        this.wasReachableCache = this.wasReachableCache || new NodeMap();
        var wasReachable = this.wasReachableCache.get(node);
        if (wasReachable === undefined) {
          wasReachable = this.getWasReachable(this.getOldParent(node));
          this.wasReachableCache.set(node, wasReachable);
        }
        return wasReachable;
      };
      TreeChanges.prototype.reachabilityChange = function (node) {
        if (this.getIsReachable(node)) {
          return this.getWasReachable(node) ? Movement.STAYED_IN : Movement.ENTERED;
        }
        return this.getWasReachable(node) ? Movement.EXITED : Movement.STAYED_OUT;
      };
      return TreeChanges;
    }(NodeMap);
    var MutationProjection = function () {
      // TOOD(any)
      function MutationProjection(rootNode, mutations, selectors, calcReordered, calcOldPreviousSibling) {
        this.rootNode = rootNode;
        this.mutations = mutations;
        this.selectors = selectors;
        this.calcReordered = calcReordered;
        this.calcOldPreviousSibling = calcOldPreviousSibling;
        this.treeChanges = new TreeChanges(rootNode, mutations);
        this.entered = [];
        this.exited = [];
        this.stayedIn = new NodeMap();
        this.visited = new NodeMap();
        this.childListChangeMap = undefined;
        this.characterDataOnly = undefined;
        this.matchCache = undefined;
        this.processMutations();
      }
      MutationProjection.prototype.processMutations = function () {
        if (!this.treeChanges.anyParentsChanged && !this.treeChanges.anyAttributesChanged) return;
        var changedNodes = this.treeChanges.keys();
        for (var i = 0; i < changedNodes.length; i++) {
          this.visitNode(changedNodes[i], undefined);
        }
      };
      MutationProjection.prototype.visitNode = function (node, parentReachable) {
        if (this.visited.has(node)) return;
        this.visited.set(node, true);
        var change = this.treeChanges.get(node);
        var reachable = parentReachable;
        // node inherits its parent's reachability change unless
        // its parentNode was mutated.
        if (change && change.childList || reachable == undefined) reachable = this.treeChanges.reachabilityChange(node);
        if (reachable === Movement.STAYED_OUT) return;
        // Cache match results for sub-patterns.
        this.matchabilityChange(node);
        if (reachable === Movement.ENTERED) {
          this.entered.push(node);
        } else if (reachable === Movement.EXITED) {
          this.exited.push(node);
          this.ensureHasOldPreviousSiblingIfNeeded(node);
        } else if (reachable === Movement.STAYED_IN) {
          var movement = Movement.STAYED_IN;
          if (change && change.childList) {
            if (change.oldParentNode !== node.parentNode) {
              movement = Movement.REPARENTED;
              this.ensureHasOldPreviousSiblingIfNeeded(node);
            } else if (this.calcReordered && this.wasReordered(node)) {
              movement = Movement.REORDERED;
            }
          }
          this.stayedIn.set(node, movement);
        }
        if (reachable === Movement.STAYED_IN) return;
        // reachable === ENTERED || reachable === EXITED.
        for (var child = node.firstChild; child; child = child.nextSibling) {
          this.visitNode(child, reachable);
        }
      };
      MutationProjection.prototype.ensureHasOldPreviousSiblingIfNeeded = function (node) {
        if (!this.calcOldPreviousSibling) return;
        this.processChildlistChanges();
        var parentNode = node.parentNode;
        var nodeChange = this.treeChanges.get(node);
        if (nodeChange && nodeChange.oldParentNode) parentNode = nodeChange.oldParentNode;
        var change = this.childListChangeMap.get(parentNode);
        if (!change) {
          change = new ChildListChange();
          this.childListChangeMap.set(parentNode, change);
        }
        if (!change.oldPrevious.has(node)) {
          change.oldPrevious.set(node, node.previousSibling);
        }
      };
      MutationProjection.prototype.getChanged = function (summary, selectors, characterDataOnly) {
        this.selectors = selectors;
        this.characterDataOnly = characterDataOnly;
        for (var i = 0; i < this.entered.length; i++) {
          var node = this.entered[i];
          var matchable = this.matchabilityChange(node);
          if (matchable === Movement.ENTERED || matchable === Movement.STAYED_IN) summary.added.push(node);
        }
        var stayedInNodes = this.stayedIn.keys();
        for (var i = 0; i < stayedInNodes.length; i++) {
          var node = stayedInNodes[i];
          var matchable = this.matchabilityChange(node);
          if (matchable === Movement.ENTERED) {
            summary.added.push(node);
          } else if (matchable === Movement.EXITED) {
            summary.removed.push(node);
          } else if (matchable === Movement.STAYED_IN && (summary.reparented || summary.reordered)) {
            var movement = this.stayedIn.get(node);
            if (summary.reparented && movement === Movement.REPARENTED) summary.reparented.push(node);else if (summary.reordered && movement === Movement.REORDERED) summary.reordered.push(node);
          }
        }
        for (var i = 0; i < this.exited.length; i++) {
          var node = this.exited[i];
          var matchable = this.matchabilityChange(node);
          if (matchable === Movement.EXITED || matchable === Movement.STAYED_IN) summary.removed.push(node);
        }
      };
      MutationProjection.prototype.getOldParentNode = function (node) {
        var change = this.treeChanges.get(node);
        if (change && change.childList) return change.oldParentNode ? change.oldParentNode : null;
        var reachabilityChange = this.treeChanges.reachabilityChange(node);
        if (reachabilityChange === Movement.STAYED_OUT || reachabilityChange === Movement.ENTERED) throw Error('getOldParentNode requested on invalid node.');
        return node.parentNode;
      };
      MutationProjection.prototype.getOldPreviousSibling = function (node) {
        var parentNode = node.parentNode;
        var nodeChange = this.treeChanges.get(node);
        if (nodeChange && nodeChange.oldParentNode) parentNode = nodeChange.oldParentNode;
        var change = this.childListChangeMap.get(parentNode);
        if (!change) throw Error('getOldPreviousSibling requested on invalid node.');
        return change.oldPrevious.get(node);
      };
      MutationProjection.prototype.getOldAttribute = function (element, attrName) {
        var change = this.treeChanges.get(element);
        if (!change || !change.attributes) throw Error('getOldAttribute requested on invalid node.');
        var value = change.getAttributeOldValue(attrName);
        if (value === undefined) throw Error('getOldAttribute requested for unchanged attribute name.');
        return value;
      };
      MutationProjection.prototype.attributeChangedNodes = function (includeAttributes) {
        if (!this.treeChanges.anyAttributesChanged) return {}; // No attributes mutations occurred.
        var attributeFilter;
        var caseInsensitiveFilter;
        if (includeAttributes) {
          attributeFilter = {};
          caseInsensitiveFilter = {};
          for (var i = 0; i < includeAttributes.length; i++) {
            var attrName = includeAttributes[i];
            attributeFilter[attrName] = true;
            caseInsensitiveFilter[attrName.toLowerCase()] = attrName;
          }
        }
        var result = {};
        var nodes = this.treeChanges.keys();
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          var change = this.treeChanges.get(node);
          if (!change.attributes) continue;
          if (Movement.STAYED_IN !== this.treeChanges.reachabilityChange(node) || Movement.STAYED_IN !== this.matchabilityChange(node)) {
            continue;
          }
          var element = node;
          var changedAttrNames = change.getAttributeNamesMutated();
          for (var j = 0; j < changedAttrNames.length; j++) {
            var attrName = changedAttrNames[j];
            if (attributeFilter && !attributeFilter[attrName] && !(change.isCaseInsensitive && caseInsensitiveFilter[attrName])) {
              continue;
            }
            var oldValue = change.getAttributeOldValue(attrName);
            if (oldValue === element.getAttribute(attrName)) continue;
            if (caseInsensitiveFilter && change.isCaseInsensitive) attrName = caseInsensitiveFilter[attrName];
            result[attrName] = result[attrName] || [];
            result[attrName].push(element);
          }
        }
        return result;
      };
      MutationProjection.prototype.getOldCharacterData = function (node) {
        var change = this.treeChanges.get(node);
        if (!change || !change.characterData) throw Error('getOldCharacterData requested on invalid node.');
        return change.characterDataOldValue;
      };
      MutationProjection.prototype.getCharacterDataChanged = function () {
        if (!this.treeChanges.anyCharacterDataChanged) return []; // No characterData mutations occurred.
        var nodes = this.treeChanges.keys();
        var result = [];
        for (var i = 0; i < nodes.length; i++) {
          var target = nodes[i];
          if (Movement.STAYED_IN !== this.treeChanges.reachabilityChange(target)) continue;
          var change = this.treeChanges.get(target);
          if (!change.characterData || target.textContent == change.characterDataOldValue) continue;
          result.push(target);
        }
        return result;
      };
      MutationProjection.prototype.computeMatchabilityChange = function (selector, el) {
        if (!this.matchCache) this.matchCache = [];
        if (!this.matchCache[selector.uid]) this.matchCache[selector.uid] = new NodeMap();
        var cache = this.matchCache[selector.uid];
        var result = cache.get(el);
        if (result === undefined) {
          result = selector.matchabilityChange(el, this.treeChanges.get(el));
          cache.set(el, result);
        }
        return result;
      };
      MutationProjection.prototype.matchabilityChange = function (node) {
        var _this = this;
        // TODO(rafaelw): Include PI, CDATA?
        // Only include text nodes.
        if (this.characterDataOnly) {
          switch (node.nodeType) {
            case Node.COMMENT_NODE:
            case Node.TEXT_NODE:
              return Movement.STAYED_IN;
            default:
              return Movement.STAYED_OUT;
          }
        }
        // No element filter. Include all nodes.
        if (!this.selectors) return Movement.STAYED_IN;
        // Element filter. Exclude non-elements.
        if (node.nodeType !== Node.ELEMENT_NODE) return Movement.STAYED_OUT;
        var el = node;
        var matchChanges = this.selectors.map(function (selector) {
          return _this.computeMatchabilityChange(selector, el);
        });
        var accum = Movement.STAYED_OUT;
        var i = 0;
        while (accum !== Movement.STAYED_IN && i < matchChanges.length) {
          switch (matchChanges[i]) {
            case Movement.STAYED_IN:
              accum = Movement.STAYED_IN;
              break;
            case Movement.ENTERED:
              if (accum === Movement.EXITED) accum = Movement.STAYED_IN;else accum = Movement.ENTERED;
              break;
            case Movement.EXITED:
              if (accum === Movement.ENTERED) accum = Movement.STAYED_IN;else accum = Movement.EXITED;
              break;
          }
          i++;
        }
        return accum;
      };
      MutationProjection.prototype.getChildlistChange = function (el) {
        var change = this.childListChangeMap.get(el);
        if (!change) {
          change = new ChildListChange();
          this.childListChangeMap.set(el, change);
        }
        return change;
      };
      MutationProjection.prototype.processChildlistChanges = function () {
        var _this19 = this;
        if (this.childListChangeMap) return;
        this.childListChangeMap = new NodeMap();
        var _loop6 = function _loop6() {
          mutation = _this19.mutations[i];
          if (mutation.type != 'childList') return "continue";
          if (_this19.treeChanges.reachabilityChange(mutation.target) !== Movement.STAYED_IN && !_this19.calcOldPreviousSibling) return "continue";
          change = _this19.getChildlistChange(mutation.target);
          oldPrevious = mutation.previousSibling;
          function recordOldPrevious(node, previous) {
            if (!node || change.oldPrevious.has(node) || change.added.has(node) || change.maybeMoved.has(node)) return;
            if (previous && (change.added.has(previous) || change.maybeMoved.has(previous))) return;
            change.oldPrevious.set(node, previous);
          }
          for (j = 0; j < mutation.removedNodes.length; j++) {
            node = mutation.removedNodes[j];
            recordOldPrevious(node, oldPrevious);
            if (change.added.has(node)) {
              change.added.delete(node);
            } else {
              change.removed.set(node, true);
              change.maybeMoved.delete(node);
            }
            oldPrevious = node;
          }
          recordOldPrevious(mutation.nextSibling, oldPrevious);
          for (j = 0; j < mutation.addedNodes.length; j++) {
            node = mutation.addedNodes[j];
            if (change.removed.has(node)) {
              change.removed.delete(node);
              change.maybeMoved.set(node, true);
            } else {
              change.added.set(node, true);
            }
          }
        };
        for (var i = 0; i < this.mutations.length; i++) {
          var mutation, change, oldPrevious, j, node, j, node;
          var _ret4 = _loop6();
          if (_ret4 === "continue") continue;
        }
      };
      MutationProjection.prototype.wasReordered = function (node) {
        if (!this.treeChanges.anyParentsChanged) return false;
        this.processChildlistChanges();
        var parentNode = node.parentNode;
        var nodeChange = this.treeChanges.get(node);
        if (nodeChange && nodeChange.oldParentNode) parentNode = nodeChange.oldParentNode;
        var change = this.childListChangeMap.get(parentNode);
        if (!change) return false;
        if (change.moved) return change.moved.get(node);
        change.moved = new NodeMap();
        var pendingMoveDecision = new NodeMap();
        function isMoved(node) {
          if (!node) return false;
          if (!change.maybeMoved.has(node)) return false;
          var didMove = change.moved.get(node);
          if (didMove !== undefined) return didMove;
          if (pendingMoveDecision.has(node)) {
            didMove = true;
          } else {
            pendingMoveDecision.set(node, true);
            didMove = getPrevious(node) !== getOldPrevious(node);
          }
          if (pendingMoveDecision.has(node)) {
            pendingMoveDecision.delete(node);
            change.moved.set(node, didMove);
          } else {
            didMove = change.moved.get(node);
          }
          return didMove;
        }
        var oldPreviousCache = new NodeMap();
        function getOldPrevious(node) {
          var oldPrevious = oldPreviousCache.get(node);
          if (oldPrevious !== undefined) return oldPrevious;
          oldPrevious = change.oldPrevious.get(node);
          while (oldPrevious && (change.removed.has(oldPrevious) || isMoved(oldPrevious))) {
            oldPrevious = getOldPrevious(oldPrevious);
          }
          if (oldPrevious === undefined) oldPrevious = node.previousSibling;
          oldPreviousCache.set(node, oldPrevious);
          return oldPrevious;
        }
        var previousCache = new NodeMap();
        function getPrevious(node) {
          if (previousCache.has(node)) return previousCache.get(node);
          var previous = node.previousSibling;
          while (previous && (change.added.has(previous) || isMoved(previous))) previous = previous.previousSibling;
          previousCache.set(node, previous);
          return previous;
        }
        change.maybeMoved.keys().forEach(isMoved);
        return change.moved.get(node);
      };
      return MutationProjection;
    }();
    var Summary = function () {
      function Summary(projection, query) {
        var _this = this;
        this.projection = projection;
        this.added = [];
        this.removed = [];
        this.reparented = query.all || query.element || query.characterData ? [] : undefined;
        this.reordered = query.all ? [] : undefined;
        projection.getChanged(this, query.elementFilter, query.characterData);
        if (query.all || query.attribute || query.attributeList) {
          var filter = query.attribute ? [query.attribute] : query.attributeList;
          var attributeChanged = projection.attributeChangedNodes(filter);
          if (query.attribute) {
            this.valueChanged = attributeChanged[query.attribute] || [];
          } else {
            this.attributeChanged = attributeChanged;
            if (query.attributeList) {
              query.attributeList.forEach(function (attrName) {
                if (!_this.attributeChanged.hasOwnProperty(attrName)) _this.attributeChanged[attrName] = [];
              });
            }
          }
        }
        if (query.all || query.characterData) {
          var characterDataChanged = projection.getCharacterDataChanged();
          if (query.characterData) this.valueChanged = characterDataChanged;else this.characterDataChanged = characterDataChanged;
        }
        if (this.reordered) this.getOldPreviousSibling = projection.getOldPreviousSibling.bind(projection);
      }
      Summary.prototype.getOldParentNode = function (node) {
        return this.projection.getOldParentNode(node);
      };
      Summary.prototype.getOldAttribute = function (node, name) {
        return this.projection.getOldAttribute(node, name);
      };
      Summary.prototype.getOldCharacterData = function (node) {
        return this.projection.getOldCharacterData(node);
      };
      Summary.prototype.getOldPreviousSibling = function (node) {
        return this.projection.getOldPreviousSibling(node);
      };
      return Summary;
    }();
    // TODO(rafaelw): Allow ':' and '.' as valid name characters.
    var validNameInitialChar = /[a-zA-Z_]+/;
    var validNameNonInitialChar = /[a-zA-Z0-9_\-]+/;
    // TODO(rafaelw): Consider allowing backslash in the attrValue.
    // TODO(rafaelw): There's got a to be way to represent this state machine
    // more compactly???
    function escapeQuotes(value) {
      return '"' + value.replace(/"/, '\\\"') + '"';
    }
    var Qualifier = function () {
      function Qualifier() {}
      Qualifier.prototype.matches = function (oldValue) {
        if (oldValue === null) return false;
        if (this.attrValue === undefined) return true;
        if (!this.contains) return this.attrValue == oldValue;
        var tokens = oldValue.split(' ');
        for (var i = 0; i < tokens.length; i++) {
          if (this.attrValue === tokens[i]) return true;
        }
        return false;
      };
      Qualifier.prototype.toString = function () {
        if (this.attrName === 'class' && this.contains) return '.' + this.attrValue;
        if (this.attrName === 'id' && !this.contains) return '#' + this.attrValue;
        if (this.contains) return '[' + this.attrName + '~=' + escapeQuotes(this.attrValue) + ']';
        if ('attrValue' in this) return '[' + this.attrName + '=' + escapeQuotes(this.attrValue) + ']';
        return '[' + this.attrName + ']';
      };
      return Qualifier;
    }();
    var Selector = function () {
      function Selector() {
        this.uid = Selector.nextUid++;
        this.qualifiers = [];
      }
      Object.defineProperty(Selector.prototype, "caseInsensitiveTagName", {
        get: function get() {
          return this.tagName.toUpperCase();
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(Selector.prototype, "selectorString", {
        get: function get() {
          return this.tagName + this.qualifiers.join('');
        },
        enumerable: true,
        configurable: true
      });
      Selector.prototype.isMatching = function (el) {
        return el[Selector.matchesSelector](this.selectorString);
      };
      Selector.prototype.wasMatching = function (el, change, isMatching) {
        if (!change || !change.attributes) return isMatching;
        var tagName = change.isCaseInsensitive ? this.caseInsensitiveTagName : this.tagName;
        if (tagName !== '*' && tagName !== el.tagName) return false;
        var attributeOldValues = [];
        var anyChanged = false;
        for (var i = 0; i < this.qualifiers.length; i++) {
          var qualifier = this.qualifiers[i];
          var oldValue = change.getAttributeOldValue(qualifier.attrName);
          attributeOldValues.push(oldValue);
          anyChanged = anyChanged || oldValue !== undefined;
        }
        if (!anyChanged) return isMatching;
        for (var i = 0; i < this.qualifiers.length; i++) {
          var qualifier = this.qualifiers[i];
          var oldValue = attributeOldValues[i];
          if (oldValue === undefined) oldValue = el.getAttribute(qualifier.attrName);
          if (!qualifier.matches(oldValue)) return false;
        }
        return true;
      };
      Selector.prototype.matchabilityChange = function (el, change) {
        var isMatching = this.isMatching(el);
        if (isMatching) return this.wasMatching(el, change, isMatching) ? Movement.STAYED_IN : Movement.ENTERED;else return this.wasMatching(el, change, isMatching) ? Movement.EXITED : Movement.STAYED_OUT;
      };
      Selector.parseSelectors = function (input) {
        var selectors = [];
        var currentSelector;
        var currentQualifier;
        function newSelector() {
          if (currentSelector) {
            if (currentQualifier) {
              currentSelector.qualifiers.push(currentQualifier);
              currentQualifier = undefined;
            }
            selectors.push(currentSelector);
          }
          currentSelector = new Selector();
        }
        function newQualifier() {
          if (currentQualifier) currentSelector.qualifiers.push(currentQualifier);
          currentQualifier = new Qualifier();
        }
        var WHITESPACE = /\s/;
        var valueQuoteChar;
        var SYNTAX_ERROR = 'Invalid or unsupported selector syntax.';
        var SELECTOR = 1;
        var TAG_NAME = 2;
        var QUALIFIER = 3;
        var QUALIFIER_NAME_FIRST_CHAR = 4;
        var QUALIFIER_NAME = 5;
        var ATTR_NAME_FIRST_CHAR = 6;
        var ATTR_NAME = 7;
        var EQUIV_OR_ATTR_QUAL_END = 8;
        var EQUAL = 9;
        var ATTR_QUAL_END = 10;
        var VALUE_FIRST_CHAR = 11;
        var VALUE = 12;
        var QUOTED_VALUE = 13;
        var SELECTOR_SEPARATOR = 14;
        var state = SELECTOR;
        var i = 0;
        while (i < input.length) {
          var c = input[i++];
          switch (state) {
            case SELECTOR:
              if (c.match(validNameInitialChar)) {
                newSelector();
                currentSelector.tagName = c;
                state = TAG_NAME;
                break;
              }
              if (c == '*') {
                newSelector();
                currentSelector.tagName = '*';
                state = QUALIFIER;
                break;
              }
              if (c == '.') {
                newSelector();
                newQualifier();
                currentSelector.tagName = '*';
                currentQualifier.attrName = 'class';
                currentQualifier.contains = true;
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '#') {
                newSelector();
                newQualifier();
                currentSelector.tagName = '*';
                currentQualifier.attrName = 'id';
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '[') {
                newSelector();
                newQualifier();
                currentSelector.tagName = '*';
                currentQualifier.attrName = '';
                state = ATTR_NAME_FIRST_CHAR;
                break;
              }
              if (c.match(WHITESPACE)) break;
              throw Error(SYNTAX_ERROR);
            case TAG_NAME:
              if (c.match(validNameNonInitialChar)) {
                currentSelector.tagName += c;
                break;
              }
              if (c == '.') {
                newQualifier();
                currentQualifier.attrName = 'class';
                currentQualifier.contains = true;
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '#') {
                newQualifier();
                currentQualifier.attrName = 'id';
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '[') {
                newQualifier();
                currentQualifier.attrName = '';
                state = ATTR_NAME_FIRST_CHAR;
                break;
              }
              if (c.match(WHITESPACE)) {
                state = SELECTOR_SEPARATOR;
                break;
              }
              if (c == ',') {
                state = SELECTOR;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case QUALIFIER:
              if (c == '.') {
                newQualifier();
                currentQualifier.attrName = 'class';
                currentQualifier.contains = true;
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '#') {
                newQualifier();
                currentQualifier.attrName = 'id';
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '[') {
                newQualifier();
                currentQualifier.attrName = '';
                state = ATTR_NAME_FIRST_CHAR;
                break;
              }
              if (c.match(WHITESPACE)) {
                state = SELECTOR_SEPARATOR;
                break;
              }
              if (c == ',') {
                state = SELECTOR;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case QUALIFIER_NAME_FIRST_CHAR:
              if (c.match(validNameInitialChar)) {
                currentQualifier.attrValue = c;
                state = QUALIFIER_NAME;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case QUALIFIER_NAME:
              if (c.match(validNameNonInitialChar)) {
                currentQualifier.attrValue += c;
                break;
              }
              if (c == '.') {
                newQualifier();
                currentQualifier.attrName = 'class';
                currentQualifier.contains = true;
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '#') {
                newQualifier();
                currentQualifier.attrName = 'id';
                state = QUALIFIER_NAME_FIRST_CHAR;
                break;
              }
              if (c == '[') {
                newQualifier();
                state = ATTR_NAME_FIRST_CHAR;
                break;
              }
              if (c.match(WHITESPACE)) {
                state = SELECTOR_SEPARATOR;
                break;
              }
              if (c == ',') {
                state = SELECTOR;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case ATTR_NAME_FIRST_CHAR:
              if (c.match(validNameInitialChar)) {
                currentQualifier.attrName = c;
                state = ATTR_NAME;
                break;
              }
              if (c.match(WHITESPACE)) break;
              throw Error(SYNTAX_ERROR);
            case ATTR_NAME:
              if (c.match(validNameNonInitialChar)) {
                currentQualifier.attrName += c;
                break;
              }
              if (c.match(WHITESPACE)) {
                state = EQUIV_OR_ATTR_QUAL_END;
                break;
              }
              if (c == '~') {
                currentQualifier.contains = true;
                state = EQUAL;
                break;
              }
              if (c == '=') {
                currentQualifier.attrValue = '';
                state = VALUE_FIRST_CHAR;
                break;
              }
              if (c == ']') {
                state = QUALIFIER;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case EQUIV_OR_ATTR_QUAL_END:
              if (c == '~') {
                currentQualifier.contains = true;
                state = EQUAL;
                break;
              }
              if (c == '=') {
                currentQualifier.attrValue = '';
                state = VALUE_FIRST_CHAR;
                break;
              }
              if (c == ']') {
                state = QUALIFIER;
                break;
              }
              if (c.match(WHITESPACE)) break;
              throw Error(SYNTAX_ERROR);
            case EQUAL:
              if (c == '=') {
                currentQualifier.attrValue = '';
                state = VALUE_FIRST_CHAR;
                break;
              }
              throw Error(SYNTAX_ERROR);
            case ATTR_QUAL_END:
              if (c == ']') {
                state = QUALIFIER;
                break;
              }
              if (c.match(WHITESPACE)) break;
              throw Error(SYNTAX_ERROR);
            case VALUE_FIRST_CHAR:
              if (c.match(WHITESPACE)) break;
              if (c == '"' || c == "'") {
                valueQuoteChar = c;
                state = QUOTED_VALUE;
                break;
              }
              currentQualifier.attrValue += c;
              state = VALUE;
              break;
            case VALUE:
              if (c.match(WHITESPACE)) {
                state = ATTR_QUAL_END;
                break;
              }
              if (c == ']') {
                state = QUALIFIER;
                break;
              }
              if (c == "'" || c == '"') throw Error(SYNTAX_ERROR);
              currentQualifier.attrValue += c;
              break;
            case QUOTED_VALUE:
              if (c == valueQuoteChar) {
                state = ATTR_QUAL_END;
                break;
              }
              currentQualifier.attrValue += c;
              break;
            case SELECTOR_SEPARATOR:
              if (c.match(WHITESPACE)) break;
              if (c == ',') {
                state = SELECTOR;
                break;
              }
              throw Error(SYNTAX_ERROR);
          }
        }
        switch (state) {
          case SELECTOR:
          case TAG_NAME:
          case QUALIFIER:
          case QUALIFIER_NAME:
          case SELECTOR_SEPARATOR:
            // Valid end states.
            newSelector();
            break;
          default:
            throw Error(SYNTAX_ERROR);
        }
        if (!selectors.length) throw Error(SYNTAX_ERROR);
        return selectors;
      };
      Selector.nextUid = 1;
      Selector.matchesSelector = function () {
        var element = document.createElement('div');
        if (typeof element['webkitMatchesSelector'] === 'function') return 'webkitMatchesSelector';
        if (typeof element['mozMatchesSelector'] === 'function') return 'mozMatchesSelector';
        if (typeof element['msMatchesSelector'] === 'function') return 'msMatchesSelector';
        return 'matchesSelector';
      }();
      return Selector;
    }();
    var attributeFilterPattern = /^([a-zA-Z:_]+[a-zA-Z0-9_\-:\.]*)$/;
    function validateAttribute(attribute) {
      if (typeof attribute != 'string') throw Error('Invalid request opion. attribute must be a non-zero length string.');
      attribute = attribute.trim();
      if (!attribute) throw Error('Invalid request opion. attribute must be a non-zero length string.');
      if (!attribute.match(attributeFilterPattern)) throw Error('Invalid request option. invalid attribute name: ' + attribute);
      return attribute;
    }
    function validateElementAttributes(attribs) {
      if (!attribs.trim().length) throw Error('Invalid request option: elementAttributes must contain at least one attribute.');
      var lowerAttributes = {};
      var attributes = {};
      var tokens = attribs.split(/\s+/);
      for (var i = 0; i < tokens.length; i++) {
        var name = tokens[i];
        if (!name) continue;
        var name = validateAttribute(name);
        var nameLower = name.toLowerCase();
        if (lowerAttributes[nameLower]) throw Error('Invalid request option: observing multiple case variations of the same attribute is not supported.');
        attributes[name] = true;
        lowerAttributes[nameLower] = true;
      }
      return Object.keys(attributes);
    }
    function elementFilterAttributes(selectors) {
      var attributes = {};
      selectors.forEach(function (selector) {
        selector.qualifiers.forEach(function (qualifier) {
          attributes[qualifier.attrName] = true;
        });
      });
      return Object.keys(attributes);
    }
    var MutationSummary = function () {
      function MutationSummary(opts) {
        var _this = this;
        this.connected = false;
        this.options = MutationSummary.validateOptions(opts);
        this.observerOptions = MutationSummary.createObserverOptions(this.options.queries);
        this.root = this.options.rootNode;
        this.callback = this.options.callback;
        this.elementFilter = Array.prototype.concat.apply([], this.options.queries.map(function (query) {
          return query.elementFilter ? query.elementFilter : [];
        }));
        if (!this.elementFilter.length) this.elementFilter = undefined;
        this.calcReordered = this.options.queries.some(function (query) {
          return query.all;
        });
        this.queryValidators = []; // TODO(rafaelw): Shouldn't always define this.
        if (MutationSummary.createQueryValidator) {
          this.queryValidators = this.options.queries.map(function (query) {
            return MutationSummary.createQueryValidator(_this.root, query);
          });
        }
        this.observer = new MutationObserverCtor(function (mutations) {
          _this.observerCallback(mutations);
        });
        this.reconnect();
      }
      MutationSummary.createObserverOptions = function (queries) {
        var observerOptions = {
          childList: true,
          subtree: true
        };
        var attributeFilter;
        function observeAttributes(attributes) {
          if (observerOptions.attributes && !attributeFilter) return; // already observing all.
          observerOptions.attributes = true;
          observerOptions.attributeOldValue = true;
          if (!attributes) {
            // observe all.
            attributeFilter = undefined;
            return;
          }
          // add to observed.
          attributeFilter = attributeFilter || {};
          attributes.forEach(function (attribute) {
            attributeFilter[attribute] = true;
            attributeFilter[attribute.toLowerCase()] = true;
          });
        }
        queries.forEach(function (query) {
          if (query.characterData) {
            observerOptions.characterData = true;
            observerOptions.characterDataOldValue = true;
            return;
          }
          if (query.all) {
            observeAttributes();
            observerOptions.characterData = true;
            observerOptions.characterDataOldValue = true;
            return;
          }
          if (query.attribute) {
            observeAttributes([query.attribute.trim()]);
            return;
          }
          var attributes = elementFilterAttributes(query.elementFilter).concat(query.attributeList || []);
          if (attributes.length) observeAttributes(attributes);
        });
        if (attributeFilter) observerOptions.attributeFilter = Object.keys(attributeFilter);
        return observerOptions;
      };
      MutationSummary.validateOptions = function (options) {
        for (var prop in options) {
          if (!(prop in MutationSummary.optionKeys)) throw Error('Invalid option: ' + prop);
        }
        if (typeof options.callback !== 'function') throw Error('Invalid options: callback is required and must be a function');
        if (!options.queries || !options.queries.length) throw Error('Invalid options: queries must contain at least one query request object.');
        var opts = {
          callback: options.callback,
          rootNode: options.rootNode || document,
          observeOwnChanges: !!options.observeOwnChanges,
          oldPreviousSibling: !!options.oldPreviousSibling,
          queries: []
        };
        for (var i = 0; i < options.queries.length; i++) {
          var request = options.queries[i];
          // all
          if (request.all) {
            if (Object.keys(request).length > 1) throw Error('Invalid request option. all has no options.');
            opts.queries.push({
              all: true
            });
            continue;
          }
          // attribute
          if ('attribute' in request) {
            var query = {
              attribute: validateAttribute(request.attribute)
            };
            query.elementFilter = Selector.parseSelectors('*[' + query.attribute + ']');
            if (Object.keys(request).length > 1) throw Error('Invalid request option. attribute has no options.');
            opts.queries.push(query);
            continue;
          }
          // element
          if ('element' in request) {
            var requestOptionCount = Object.keys(request).length;
            var query = {
              element: request.element,
              elementFilter: Selector.parseSelectors(request.element)
            };
            if (request.hasOwnProperty('elementAttributes')) {
              query.attributeList = validateElementAttributes(request.elementAttributes);
              requestOptionCount--;
            }
            if (requestOptionCount > 1) throw Error('Invalid request option. element only allows elementAttributes option.');
            opts.queries.push(query);
            continue;
          }
          // characterData
          if (request.characterData) {
            if (Object.keys(request).length > 1) throw Error('Invalid request option. characterData has no options.');
            opts.queries.push({
              characterData: true
            });
            continue;
          }
          throw Error('Invalid request option. Unknown query request.');
        }
        return opts;
      };
      MutationSummary.prototype.createSummaries = function (mutations) {
        if (!mutations || !mutations.length) return [];
        var projection = new MutationProjection(this.root, mutations, this.elementFilter, this.calcReordered, this.options.oldPreviousSibling);
        var summaries = [];
        for (var i = 0; i < this.options.queries.length; i++) {
          summaries.push(new Summary(projection, this.options.queries[i]));
        }
        return summaries;
      };
      MutationSummary.prototype.checkpointQueryValidators = function () {
        this.queryValidators.forEach(function (validator) {
          if (validator) validator.recordPreviousState();
        });
      };
      MutationSummary.prototype.runQueryValidators = function (summaries) {
        this.queryValidators.forEach(function (validator, index) {
          if (validator) validator.validate(summaries[index]);
        });
      };
      MutationSummary.prototype.changesToReport = function (summaries) {
        return summaries.some(function (summary) {
          var summaryProps = ['added', 'removed', 'reordered', 'reparented', 'valueChanged', 'characterDataChanged'];
          if (summaryProps.some(function (prop) {
            return summary[prop] && summary[prop].length;
          })) return true;
          if (summary.attributeChanged) {
            var attrNames = Object.keys(summary.attributeChanged);
            var attrsChanged = attrNames.some(function (attrName) {
              return !!summary.attributeChanged[attrName].length;
            });
            if (attrsChanged) return true;
          }
          return false;
        });
      };
      MutationSummary.prototype.observerCallback = function (mutations) {
        if (!this.options.observeOwnChanges) this.observer.disconnect();
        var summaries = this.createSummaries(mutations);
        this.runQueryValidators(summaries);
        if (this.options.observeOwnChanges) this.checkpointQueryValidators();
        if (this.changesToReport(summaries)) this.callback(summaries);
        // disconnect() may have been called during the callback.
        if (!this.options.observeOwnChanges && this.connected) {
          this.checkpointQueryValidators();
          this.observer.observe(this.root, this.observerOptions);
        }
      };
      MutationSummary.prototype.reconnect = function () {
        if (this.connected) throw Error('Already connected');
        this.observer.observe(this.root, this.observerOptions);
        this.connected = true;
        this.checkpointQueryValidators();
      };
      MutationSummary.prototype.takeSummaries = function () {
        if (!this.connected) throw Error('Not connected');
        var summaries = this.createSummaries(this.observer.takeRecords());
        return this.changesToReport(summaries) ? summaries : undefined;
      };
      MutationSummary.prototype.disconnect = function () {
        var summaries = this.takeSummaries();
        this.observer.disconnect();
        this.connected = false;
        return summaries;
      };
      MutationSummary.NodeMap = NodeMap; // exposed for use in TreeMirror.
      MutationSummary.parseElementFilter = Selector.parseSelectors; // exposed for testing.
      MutationSummary.optionKeys = {
        'callback': true,
        'queries': true,
        'rootNode': true,
        'oldPreviousSibling': true,
        'observeOwnChanges': true
      };
      return MutationSummary;
    }();

    /*** EXPORTS FROM exports-loader ***/
    module.exports = MutationSummary;
  }).call({});

  /***/
}, /* 184 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _events = __webpack_require__(44);
  var _events2 = _interopRequireDefault(_events);
  var _urijs = __webpack_require__(185);
  var _urijs2 = _interopRequireDefault(_urijs);
  var _jsMd = __webpack_require__(189);
  var _jsMd2 = _interopRequireDefault(_jsMd);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _asyncToGenerator(fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            return Promise.resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }
        return step("next");
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var AssetProxy = function (_EventEmitter) {
    _inherits(AssetProxy, _EventEmitter);
    function AssetProxy(iframe, parent) {
      _classCallCheck(this, AssetProxy);
      var _this = _possibleConstructorReturn(this, (AssetProxy.__proto__ || Object.getPrototypeOf(AssetProxy)).call(this));
      _initialiseProps.call(_this);
      _this.iframe = iframe;
      _this.parent = parent;
      _this.requestsToProxy = 0;
      _this.disabled = false;
      return _this;
    }
    _createClass(AssetProxy, [{
      key: 'disable',
      value: function disable() {
        this.disabled = true;
      }
    }, {
      key: 'enable',
      value: function enable() {
        this.disabled = false;
      }
    }, {
      key: 'b64toBlob',
      value: function b64toBlob(b64Data, b64Encoded, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = b64Encoded ? atob(b64Data) : b64Data;

        // `charCodeAt` used below can we wonky with special characters in CSS,
        // so let's just convert CSS files to blob directly.
        if (contentType === 'text/css') {
          return new Blob([byteCharacters], {
            type: contentType
          });
        }
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {
          type: contentType
        });
        return blob;
      }
    }, {
      key: 'insertAsObjectUrl',
      value: function insertAsObjectUrl(node, attr, blob) {
        node[attr] = window.URL.createObjectURL(blob);
        node.onload = function () {
          window.URL.revokeObjectURL(this[attr]);
        };
      }
    }, {
      key: 'getCacheKey',
      value: function getCacheKey(key) {
        return (0, _jsMd2.default)(key);
      }
    }, {
      key: 'checkCache',
      value: function checkCache(key) {
        return AssetProxy.assetsCache[key];
      }
    }, {
      key: 'cacheAsset',
      value: function cacheAsset(key, value) {
        AssetProxy.assetsCache[key] = value;
      }
    }, {
      key: 'requiresProxying',
      value: function requiresProxying(cssString) {
        return cssString.includes('url(') || cssString.includes('import ');
      }
    }]);
    return AssetProxy;
  }(_events2.default);
  AssetProxy.assetsCache = {};
  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.proxyCssString = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseUrl, cssString) {
        var cacheKey, cachedAsset;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cacheKey = _this2.getCacheKey(cssString);
                cachedAsset = _this2.checkCache(cacheKey);
                if (!cachedAsset) {
                  cachedAsset = _this2.updateAssetProxyCounter(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this2.parent.send({
                              method: 'proxyCssString',
                              params: [baseUrl, cssString]
                            });
                          case 2:
                            return _context.abrupt('return', _context.sent);
                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  })));
                  _this2.cacheAsset(cacheKey, cachedAsset);
                }
                _context2.next = 5;
                return cachedAsset;
              case 5:
                return _context2.abrupt('return', _context2.sent);
              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    this.updateAssetProxyCounter = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(handler) {
        var val;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _this2.requestsToProxy += 1;
                _this2.emit('asset-proxying-counter', _this2.requestsToProxy);
                _context3.next = 5;
                return handler();
              case 5:
                val = _context3.sent;
                _this2.requestsToProxy -= 1;
                _this2.emit('asset-proxying-counter', _this2.requestsToProxy);
                return _context3.abrupt('return', val);
              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);
                _this2.requestsToProxy -= 1;
                _this2.emit('asset-proxying-counter', _this2.requestsToProxy);
                throw _context3.t0;
              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 11]]);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    this.registerUrlHandler = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(node, name, value) {
        var url, cacheKey, cachedAsset, blob;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                if (!value.startsWith('data:')) {
                  _context5.next = 3;
                  break;
                }
                return _context5.abrupt('return');
              case 3:
                if (!(value == '')) {
                  _context5.next = 5;
                  break;
                }
                return _context5.abrupt('return');
              case 5:
                if (!_this2.disabled) {
                  _context5.next = 8;
                  break;
                }

                // LINK.href will get link removed before registered
                node.setAttribute(name, value);
                return _context5.abrupt('return');
              case 8:
                node.setAttribute('_' + name, value);
                node.removeAttribute(name);
                url = (0, _urijs2.default)(value).absoluteTo(node.ownerDocument.baseURI);
                cacheKey = _this2.getCacheKey(value);
                cachedAsset = _this2.checkCache(cacheKey);
                if (!cachedAsset) {
                  cachedAsset = _this2.updateAssetProxyCounter(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                    var response;
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this2.parent.send({
                              method: 'requestAsset',
                              params: [url.toString()]
                            });
                          case 2:
                            response = _context4.sent;
                            return _context4.abrupt('return', _this2.b64toBlob(response.body.body, response.body.base64Encoded, response.mime));
                          case 4:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this2);
                  })));
                  _this2.cacheAsset(cacheKey, cachedAsset);
                }
                _context5.next = 16;
                return cachedAsset;
              case 16:
                blob = _context5.sent;
                _this2.insertAsObjectUrl(node, name, blob);
                _context5.next = 23;
                break;
              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5['catch'](0);
                console.log('GOT AN ERROR WHILE GETTING RESPONSE: ', _context5.t0);
              case 23:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2, [[0, 20]]);
      }));
      return function (_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }();
    this.registerStyleAttributeHandler = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(node, name, value) {
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                if (!_this2.disabled) {
                  _context6.next = 3;
                  break;
                }
                return _context6.abrupt('return');
              case 3:
                if (!_this2.requiresProxying(value)) {
                  _context6.next = 10;
                  break;
                }
                node.setAttribute('_' + name, value);
                node.removeAttribute(name);
                _context6.next = 8;
                return _this2.proxyCssString(node.ownerDocument.baseURI, value);
              case 8:
                response = _context6.sent;
                node.setAttribute(name, response);
              case 10:
                _context6.next = 15;
                break;
              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](0);
                console.log('GOT AN ERROR WHILE GETTING RESPONSE: ', _context6.t0);
              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this2, [[0, 12]]);
      }));
      return function (_x7, _x8, _x9) {
        return _ref6.apply(this, arguments);
      };
    }();
    this.registerStyleElementHandler = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(parent, nodeData) {
        var cssString, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                if (!_this2.disabled) {
                  _context7.next = 3;
                  break;
                }
                return _context7.abrupt('return');
              case 3:
                cssString = nodeData.textContent;
                if (!_this2.requiresProxying(cssString)) {
                  _context7.next = 10;
                  break;
                }
                nodeData.textContent = '';
                _context7.next = 8;
                return _this2.proxyCssString(parent.ownerDocument.baseURI, cssString);
              case 8:
                response = _context7.sent;
                parent.textContent = response;
              case 10:
                _context7.next = 15;
                break;
              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](0);
                console.log('GOT AN ERROR WHILE GETTING RESPONSE: ', _context7.t0);
              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[0, 12]]);
      }));
      return function (_x10, _x11) {
        return _ref7.apply(this, arguments);
      };
    }();
  };
  exports.default = AssetProxy;

  /***/
}, /* 185 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                                                   * URI.js - Mutating URLs
                                                                                                   *
                                                                                                   * Version: 1.19.1
                                                                                                   *
                                                                                                   * Author: Rodney Rehm
                                                                                                   * Web: http://medialize.github.io/URI.js/
                                                                                                   *
                                                                                                   * Licensed under
                                                                                                   *   MIT License http://www.opensource.org/licenses/mit-license
                                                                                                   *
                                                                                                   */
  (function (root, factory) {
    'use strict';

    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (typeof module === 'object' && module.exports) {
      // Node
      module.exports = factory(__webpack_require__(186), __webpack_require__(187), __webpack_require__(188));
    } else if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(186), __webpack_require__(187), __webpack_require__(188)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      // Browser globals (root is window)
      root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
    }
  })(this, function (punycode, IPv6, SLD, root) {
    'use strict';

    /*global location, escape, unescape */
    // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */

    // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
      var _urlSupplied = arguments.length >= 1;
      var _baseSupplied = arguments.length >= 2;

      // Allow instantiation without the 'new' keyword
      if (!(this instanceof URI)) {
        if (_urlSupplied) {
          if (_baseSupplied) {
            return new URI(url, base);
          }
          return new URI(url);
        }
        return new URI();
      }
      if (url === undefined) {
        if (_urlSupplied) {
          throw new TypeError('undefined is not a valid argument for URI');
        }
        if (typeof location !== 'undefined') {
          url = location.href + '';
        } else {
          url = '';
        }
      }
      if (url === null) {
        if (_urlSupplied) {
          throw new TypeError('null is not a valid argument for URI');
        }
      }
      this.href(url);

      // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
      if (base !== undefined) {
        return this.absoluteTo(base);
      }
      return this;
    }
    function isInteger(value) {
      return /^[0-9]+$/.test(value);
    }
    URI.version = '1.19.1';
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
      // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
      return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    }
    function getType(value) {
      // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
      if (value === undefined) {
        return 'Undefined';
      }
      return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
      return getType(obj) === 'Array';
    }
    function filterArrayValues(data, value) {
      var lookup = {};
      var i, length;
      if (getType(value) === 'RegExp') {
        lookup = null;
      } else if (isArray(value)) {
        for (i = 0, length = value.length; i < length; i++) {
          lookup[value[i]] = true;
        }
      } else {
        lookup[value] = true;
      }
      for (i = 0, length = data.length; i < length; i++) {
        /*jshint laxbreak: true */
        var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
        /*jshint laxbreak: false */
        if (_match) {
          data.splice(i, 1);
          length--;
          i--;
        }
      }
      return data;
    }
    function arrayContains(list, value) {
      var i, length;

      // value may be string, number, array, regexp
      if (isArray(value)) {
        // Note: this can be optimized to O(n) (instead of current O(m * n))
        for (i = 0, length = value.length; i < length; i++) {
          if (!arrayContains(list, value[i])) {
            return false;
          }
        }
        return true;
      }
      var _type = getType(value);
      for (i = 0, length = list.length; i < length; i++) {
        if (_type === 'RegExp') {
          if (typeof list[i] === 'string' && list[i].match(value)) {
            return true;
          }
        } else if (list[i] === value) {
          return true;
        }
      }
      return false;
    }
    function arraysEqual(one, two) {
      if (!isArray(one) || !isArray(two)) {
        return false;
      }

      // arrays can't be equal if they have different amount of content
      if (one.length !== two.length) {
        return false;
      }
      one.sort();
      two.sort();
      for (var i = 0, l = one.length; i < l; i++) {
        if (one[i] !== two[i]) {
          return false;
        }
      }
      return true;
    }
    function trimSlashes(text) {
      var trim_expression = /^\/+|\/+$/g;
      return text.replace(trim_expression, '');
    }
    URI._parts = function () {
      return {
        protocol: null,
        username: null,
        password: null,
        hostname: null,
        urn: null,
        port: null,
        path: null,
        query: null,
        fragment: null,
        // state
        preventInvalidHostname: URI.preventInvalidHostname,
        duplicateQueryParameters: URI.duplicateQueryParameters,
        escapeQuerySpace: URI.escapeQuerySpace
      };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
      // valid "scheme://" or "www."
      start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
      // everything up to the next whitespace
      end: /[\s\r\n]|$/,
      // trim trailing punctuation captured by end RegExp
      trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
      // balanced parens inclusion (), [], {}, <>
      parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
      http: '80',
      https: '443',
      ftp: '21',
      gopher: '70',
      ws: '80',
      wss: '443'
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = ['http', 'https'];

    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
      'a': 'href',
      'blockquote': 'cite',
      'link': 'href',
      'base': 'href',
      'script': 'src',
      'form': 'action',
      'img': 'src',
      'area': 'href',
      'iframe': 'src',
      'embed': 'src',
      'source': 'src',
      'track': 'src',
      'input': 'src',
      // but only if type="image"
      'audio': 'src',
      'video': 'src'
    };
    URI.getDomAttribute = function (node) {
      if (!node || !node.nodeName) {
        return undefined;
      }
      var nodeName = node.nodeName.toLowerCase();
      // <input> should only expose src for type="image"
      if (nodeName === 'input' && node.type !== 'image') {
        return undefined;
      }
      return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
      // https://github.com/medialize/URI.js/issues/91
      return escape(value);
    }

    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
      // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
      return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, '%2A');
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function () {
      URI.encode = escape;
      URI.decode = unescape;
    };
    URI.unicode = function () {
      URI.encode = strictEncodeURIComponent;
      URI.decode = decodeURIComponent;
    };
    URI.characters = {
      pathname: {
        encode: {
          // RFC3986 2.1: For consistency, URI producers and normalizers should
          // use uppercase hexadecimal digits for all percent-encodings.
          expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
          map: {
            // -._~!'()*
            '%24': '$',
            '%26': '&',
            '%2B': '+',
            '%2C': ',',
            '%3B': ';',
            '%3D': '=',
            '%3A': ':',
            '%40': '@'
          }
        },
        decode: {
          expression: /[\/\?#]/g,
          map: {
            '/': '%2F',
            '?': '%3F',
            '#': '%23'
          }
        }
      },
      reserved: {
        encode: {
          // RFC3986 2.1: For consistency, URI producers and normalizers should
          // use uppercase hexadecimal digits for all percent-encodings.
          expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
          map: {
            // gen-delims
            '%3A': ':',
            '%2F': '/',
            '%3F': '?',
            '%23': '#',
            '%5B': '[',
            '%5D': ']',
            '%40': '@',
            // sub-delims
            '%21': '!',
            '%24': '$',
            '%26': '&',
            '%27': '\'',
            '%28': '(',
            '%29': ')',
            '%2A': '*',
            '%2B': '+',
            '%2C': ',',
            '%3B': ';',
            '%3D': '='
          }
        }
      },
      urnpath: {
        // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
        // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
        // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
        // note that the colon character is not featured in the encoding map; this is because URI.js
        // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
        // should not appear unencoded in a segment itself.
        // See also the note above about RFC3986 and capitalalized hex digits.
        encode: {
          expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
          map: {
            '%21': '!',
            '%24': '$',
            '%27': '\'',
            '%28': '(',
            '%29': ')',
            '%2A': '*',
            '%2B': '+',
            '%2C': ',',
            '%3B': ';',
            '%3D': '=',
            '%40': '@'
          }
        },
        // These characters are the characters called out by RFC2141 as "reserved" characters that
        // should never appear in a URN, plus the colon character (see note above).
        decode: {
          expression: /[\/\?#:]/g,
          map: {
            '/': '%2F',
            '?': '%3F',
            '#': '%23',
            ':': '%3A'
          }
        }
      }
    };
    URI.encodeQuery = function (string, escapeQuerySpace) {
      var escaped = URI.encode(string + '');
      if (escapeQuerySpace === undefined) {
        escapeQuerySpace = URI.escapeQuerySpace;
      }
      return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
    };
    URI.decodeQuery = function (string, escapeQuerySpace) {
      string += '';
      if (escapeQuerySpace === undefined) {
        escapeQuerySpace = URI.escapeQuerySpace;
      }
      try {
        return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
    // generate encode/decode path functions
    var _parts = {
      'encode': 'encode',
      'decode': 'decode'
    };
    var _part;
    var generateAccessor = function generateAccessor(_group, _part) {
      return function (string) {
        try {
          return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function (c) {
            return URI.characters[_group][_part].map[c];
          });
        } catch (e) {
          // we're not going to mess with weird encodings,
          // give up and return the undecoded original string
          // see https://github.com/medialize/URI.js/issues/87
          // see https://github.com/medialize/URI.js/issues/92
          return string;
        }
      };
    };
    for (_part in _parts) {
      URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
      URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
    }
    var generateSegmentedPathFunction = function generateSegmentedPathFunction(_sep, _codingFuncName, _innerCodingFuncName) {
      return function (string) {
        // Why pass in names of functions, rather than the function objects themselves? The
        // definitions of some functions (but in particular, URI.decode) will occasionally change due
        // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
        // that the functions we use here are "fresh".
        var actualCodingFunc;
        if (!_innerCodingFuncName) {
          actualCodingFunc = URI[_codingFuncName];
        } else {
          actualCodingFunc = function actualCodingFunc(string) {
            return URI[_codingFuncName](URI[_innerCodingFuncName](string));
          };
        }
        var segments = (string + '').split(_sep);
        for (var i = 0, length = segments.length; i < length; i++) {
          segments[i] = actualCodingFunc(segments[i]);
        }
        return segments.join(_sep);
      };
    };

    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
    URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
    URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
    URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
    URI.encodeReserved = generateAccessor('reserved', 'encode');
    URI.parse = function (string, parts) {
      var pos;
      if (!parts) {
        parts = {
          preventInvalidHostname: URI.preventInvalidHostname
        };
      }
      // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

      // extract fragment
      pos = string.indexOf('#');
      if (pos > -1) {
        // escaping?
        parts.fragment = string.substring(pos + 1) || null;
        string = string.substring(0, pos);
      }

      // extract query
      pos = string.indexOf('?');
      if (pos > -1) {
        // escaping?
        parts.query = string.substring(pos + 1) || null;
        string = string.substring(0, pos);
      }

      // extract protocol
      if (string.substring(0, 2) === '//') {
        // relative-scheme
        parts.protocol = null;
        string = string.substring(2);
        // extract "user:pass@host:port"
        string = URI.parseAuthority(string, parts);
      } else {
        pos = string.indexOf(':');
        if (pos > -1) {
          parts.protocol = string.substring(0, pos) || null;
          if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
            // : may be within the path
            parts.protocol = undefined;
          } else if (string.substring(pos + 1, pos + 3) === '//') {
            string = string.substring(pos + 3);

            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
          } else {
            string = string.substring(pos + 1);
            parts.urn = true;
          }
        }
      }

      // what's left must be the path
      parts.path = string;

      // and we're done
      return parts;
    };
    URI.parseHost = function (string, parts) {
      if (!string) {
        string = '';
      }

      // Copy chrome, IE, opera backslash-handling behavior.
      // Back slashes before the query string get converted to forward slashes
      // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
      // See: https://code.google.com/p/chromium/issues/detail?id=25916
      // https://github.com/medialize/URI.js/pull/233
      string = string.replace(/\\/g, '/');

      // extract host:port
      var pos = string.indexOf('/');
      var bracketPos;
      var t;
      if (pos === -1) {
        pos = string.length;
      }
      if (string.charAt(0) === '[') {
        // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
        // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
        // IPv6+port in the format [2001:db8::1]:80 (for the time being)
        bracketPos = string.indexOf(']');
        parts.hostname = string.substring(1, bracketPos) || null;
        parts.port = string.substring(bracketPos + 2, pos) || null;
        if (parts.port === '/') {
          parts.port = null;
        }
      } else {
        var firstColon = string.indexOf(':');
        var firstSlash = string.indexOf('/');
        var nextColon = string.indexOf(':', firstColon + 1);
        if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
          // IPv6 host contains multiple colons - but no port
          // this notation is actually not allowed by RFC 3986, but we're a liberal parser
          parts.hostname = string.substring(0, pos) || null;
          parts.port = null;
        } else {
          t = string.substring(0, pos).split(':');
          parts.hostname = t[0] || null;
          parts.port = t[1] || null;
        }
      }
      if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
        pos++;
        string = '/' + string;
      }
      if (parts.preventInvalidHostname) {
        URI.ensureValidHostname(parts.hostname, parts.protocol);
      }
      if (parts.port) {
        URI.ensureValidPort(parts.port);
      }
      return string.substring(pos) || '/';
    };
    URI.parseAuthority = function (string, parts) {
      string = URI.parseUserinfo(string, parts);
      return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function (string, parts) {
      // extract username:password
      var firstSlash = string.indexOf('/');
      var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
      var t;

      // authority@ must come before /path
      if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
        t = string.substring(0, pos).split(':');
        parts.username = t[0] ? URI.decode(t[0]) : null;
        t.shift();
        parts.password = t[0] ? URI.decode(t.join(':')) : null;
        string = string.substring(pos + 1);
      } else {
        parts.username = null;
        parts.password = null;
      }
      return string;
    };
    URI.parseQuery = function (string, escapeQuerySpace) {
      if (!string) {
        return {};
      }

      // throw out the funky business - "?"[name"="value"&"]+
      string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
      if (!string) {
        return {};
      }
      var items = {};
      var splits = string.split('&');
      var length = splits.length;
      var v, name, value;
      for (var i = 0; i < length; i++) {
        v = splits[i].split('=');
        name = URI.decodeQuery(v.shift(), escapeQuerySpace);
        // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
        value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
        if (hasOwn.call(items, name)) {
          if (typeof items[name] === 'string' || items[name] === null) {
            items[name] = [items[name]];
          }
          items[name].push(value);
        } else {
          items[name] = value;
        }
      }
      return items;
    };
    URI.build = function (parts) {
      var t = '';
      if (parts.protocol) {
        t += parts.protocol + ':';
      }
      if (!parts.urn && (t || parts.hostname)) {
        t += '//';
      }
      t += URI.buildAuthority(parts) || '';
      if (typeof parts.path === 'string') {
        if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
          t += '/';
        }
        t += parts.path;
      }
      if (typeof parts.query === 'string' && parts.query) {
        t += '?' + parts.query;
      }
      if (typeof parts.fragment === 'string' && parts.fragment) {
        t += '#' + parts.fragment;
      }
      return t;
    };
    URI.buildHost = function (parts) {
      var t = '';
      if (!parts.hostname) {
        return '';
      } else if (URI.ip6_expression.test(parts.hostname)) {
        t += '[' + parts.hostname + ']';
      } else {
        t += parts.hostname;
      }
      if (parts.port) {
        t += ':' + parts.port;
      }
      return t;
    };
    URI.buildAuthority = function (parts) {
      return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function (parts) {
      var t = '';
      if (parts.username) {
        t += URI.encode(parts.username);
      }
      if (parts.password) {
        t += ':' + URI.encode(parts.password);
      }
      if (t) {
        t += '@';
      }
      return t;
    };
    URI.buildQuery = function (data, duplicateQueryParameters, escapeQuerySpace) {
      // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
      // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
      // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
      // URI.js treats the query string as being application/x-www-form-urlencoded
      // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

      var t = '';
      var unique, key, i, length;
      for (key in data) {
        if (hasOwn.call(data, key) && key) {
          if (isArray(data[key])) {
            unique = {};
            for (i = 0, length = data[key].length; i < length; i++) {
              if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
                t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                if (duplicateQueryParameters !== true) {
                  unique[data[key][i] + ''] = true;
                }
              }
            }
          } else if (data[key] !== undefined) {
            t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
          }
        }
      }
      return t.substring(1);
    };
    URI.buildQueryParameter = function (name, value, escapeQuerySpace) {
      // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
      // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
      return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
    };
    URI.addQuery = function (data, name, value) {
      if (typeof name === 'object') {
        for (var key in name) {
          if (hasOwn.call(name, key)) {
            URI.addQuery(data, key, name[key]);
          }
        }
      } else if (typeof name === 'string') {
        if (data[name] === undefined) {
          data[name] = value;
          return;
        } else if (typeof data[name] === 'string') {
          data[name] = [data[name]];
        }
        if (!isArray(value)) {
          value = [value];
        }
        data[name] = (data[name] || []).concat(value);
      } else {
        throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
      }
    };
    URI.setQuery = function (data, name, value) {
      if (typeof name === 'object') {
        for (var key in name) {
          if (hasOwn.call(name, key)) {
            URI.setQuery(data, key, name[key]);
          }
        }
      } else if (typeof name === 'string') {
        data[name] = value === undefined ? null : value;
      } else {
        throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
      }
    };
    URI.removeQuery = function (data, name, value) {
      var i, length, key;
      if (isArray(name)) {
        for (i = 0, length = name.length; i < length; i++) {
          data[name[i]] = undefined;
        }
      } else if (getType(name) === 'RegExp') {
        for (key in data) {
          if (name.test(key)) {
            data[key] = undefined;
          }
        }
      } else if (typeof name === 'object') {
        for (key in name) {
          if (hasOwn.call(name, key)) {
            URI.removeQuery(data, key, name[key]);
          }
        }
      } else if (typeof name === 'string') {
        if (value !== undefined) {
          if (getType(value) === 'RegExp') {
            if (!isArray(data[name]) && value.test(data[name])) {
              data[name] = undefined;
            } else {
              data[name] = filterArrayValues(data[name], value);
            }
          } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
            data[name] = undefined;
          } else if (isArray(data[name])) {
            data[name] = filterArrayValues(data[name], value);
          }
        } else {
          data[name] = undefined;
        }
      } else {
        throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
      }
    };
    URI.hasQuery = function (data, name, value, withinArray) {
      switch (getType(name)) {
        case 'String':
          // Nothing to do here
          break;
        case 'RegExp':
          for (var key in data) {
            if (hasOwn.call(data, key)) {
              if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
                return true;
              }
            }
          }
          return false;
        case 'Object':
          for (var _key in name) {
            if (hasOwn.call(name, _key)) {
              if (!URI.hasQuery(data, _key, name[_key])) {
                return false;
              }
            }
          }
          return true;
        default:
          throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
      }
      switch (getType(value)) {
        case 'Undefined':
          // true if exists (but may be empty)
          return name in data;
        // data[name] !== undefined;

        case 'Boolean':
          // true if exists and non-empty
          var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
          return value === _booly;
        case 'Function':
          // allow complex comparison
          return !!value(data[name], name, data);
        case 'Array':
          if (!isArray(data[name])) {
            return false;
          }
          var op = withinArray ? arrayContains : arraysEqual;
          return op(data[name], value);
        case 'RegExp':
          if (!isArray(data[name])) {
            return Boolean(data[name] && data[name].match(value));
          }
          if (!withinArray) {
            return false;
          }
          return arrayContains(data[name], value);
        case 'Number':
          value = String(value);
        /* falls through */
        case 'String':
          if (!isArray(data[name])) {
            return data[name] === value;
          }
          if (!withinArray) {
            return false;
          }
          return arrayContains(data[name], value);
        default:
          throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
      }
    };
    URI.joinPaths = function () {
      var input = [];
      var segments = [];
      var nonEmptySegments = 0;
      for (var i = 0; i < arguments.length; i++) {
        var url = new URI(arguments[i]);
        input.push(url);
        var _segments = url.segment();
        for (var s = 0; s < _segments.length; s++) {
          if (typeof _segments[s] === 'string') {
            segments.push(_segments[s]);
          }
          if (_segments[s]) {
            nonEmptySegments++;
          }
        }
      }
      if (!segments.length || !nonEmptySegments) {
        return new URI('');
      }
      var uri = new URI('').segment(segments);
      if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
        uri.path('/' + uri.path());
      }
      return uri.normalize();
    };
    URI.commonPath = function (one, two) {
      var length = Math.min(one.length, two.length);
      var pos;

      // find first non-matching character
      for (pos = 0; pos < length; pos++) {
        if (one.charAt(pos) !== two.charAt(pos)) {
          pos--;
          break;
        }
      }
      if (pos < 1) {
        return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
      }

      // revert to last /
      if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
        pos = one.substring(0, pos).lastIndexOf('/');
      }
      return one.substring(0, pos + 1);
    };
    URI.withinString = function (string, callback, options) {
      options || (options = {});
      var _start = options.start || URI.findUri.start;
      var _end = options.end || URI.findUri.end;
      var _trim = options.trim || URI.findUri.trim;
      var _parens = options.parens || URI.findUri.parens;
      var _attributeOpen = /[a-z0-9-]=["']?$/i;
      _start.lastIndex = 0;
      while (true) {
        var match = _start.exec(string);
        if (!match) {
          break;
        }
        var start = match.index;
        if (options.ignoreHtml) {
          // attribut(e=["']?$)
          var attributeOpen = string.slice(Math.max(start - 3, 0), start);
          if (attributeOpen && _attributeOpen.test(attributeOpen)) {
            continue;
          }
        }
        var end = start + string.slice(start).search(_end);
        var slice = string.slice(start, end);
        // make sure we include well balanced parens
        var parensEnd = -1;
        while (true) {
          var parensMatch = _parens.exec(slice);
          if (!parensMatch) {
            break;
          }
          var parensMatchEnd = parensMatch.index + parensMatch[0].length;
          parensEnd = Math.max(parensEnd, parensMatchEnd);
        }
        if (parensEnd > -1) {
          slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
        } else {
          slice = slice.replace(_trim, '');
        }
        if (slice.length <= match[0].length) {
          // the extract only contains the starting marker of a URI,
          // e.g. "www" or "http://"
          continue;
        }
        if (options.ignore && options.ignore.test(slice)) {
          continue;
        }
        end = start + slice.length;
        var result = callback(slice, start, end, string);
        if (result === undefined) {
          _start.lastIndex = end;
          continue;
        }
        result = String(result);
        string = string.slice(0, start) + result + string.slice(end);
        _start.lastIndex = start + result.length;
      }
      _start.lastIndex = 0;
      return string;
    };
    URI.ensureValidHostname = function (v, protocol) {
      // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
      // they are not part of DNS and therefore ignored by URI.js

      var hasHostname = !!v; // not null and not an empty string
      var hasProtocol = !!protocol;
      var rejectEmptyHostname = false;
      if (hasProtocol) {
        rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
      }
      if (rejectEmptyHostname && !hasHostname) {
        throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
      } else if (v && v.match(URI.invalid_hostname_characters)) {
        // test punycode
        if (!punycode) {
          throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
        }
        if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
          throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
      }
    };
    URI.ensureValidPort = function (v) {
      if (!v) {
        return;
      }
      var port = Number(v);
      if (isInteger(port) && port > 0 && port < 65536) {
        return;
      }
      throw new TypeError('Port "' + v + '" is not a valid port');
    };

    // noConflict
    URI.noConflict = function (removeAll) {
      if (removeAll) {
        var unconflicted = {
          URI: this.noConflict()
        };
        if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
          unconflicted.URITemplate = root.URITemplate.noConflict();
        }
        if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
          unconflicted.IPv6 = root.IPv6.noConflict();
        }
        if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
          unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
        }
        return unconflicted;
      } else if (root.URI === this) {
        root.URI = _URI;
      }
      return this;
    };
    p.build = function (deferBuild) {
      if (deferBuild === true) {
        this._deferred_build = true;
      } else if (deferBuild === undefined || this._deferred_build) {
        this._string = URI.build(this._parts);
        this._deferred_build = false;
      }
      return this;
    };
    p.clone = function () {
      return new URI(this);
    };
    p.valueOf = p.toString = function () {
      return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
      return function (v, build) {
        if (v === undefined) {
          return this._parts[_part] || '';
        } else {
          this._parts[_part] = v || null;
          this.build(!build);
          return this;
        }
      };
    }
    function generatePrefixAccessor(_part, _key) {
      return function (v, build) {
        if (v === undefined) {
          return this._parts[_part] || '';
        } else {
          if (v !== null) {
            v = v + '';
            if (v.charAt(0) === _key) {
              v = v.substring(1);
            }
          }
          this._parts[_part] = v;
          this.build(!build);
          return this;
        }
      };
    }
    p.protocol = generateSimpleAccessor('protocol');
    p.username = generateSimpleAccessor('username');
    p.password = generateSimpleAccessor('password');
    p.hostname = generateSimpleAccessor('hostname');
    p.port = generateSimpleAccessor('port');
    p.query = generatePrefixAccessor('query', '?');
    p.fragment = generatePrefixAccessor('fragment', '#');
    p.search = function (v, build) {
      var t = this.query(v, build);
      return typeof t === 'string' && t.length ? '?' + t : t;
    };
    p.hash = function (v, build) {
      var t = this.fragment(v, build);
      return typeof t === 'string' && t.length ? '#' + t : t;
    };
    p.pathname = function (v, build) {
      if (v === undefined || v === true) {
        var res = this._parts.path || (this._parts.hostname ? '/' : '');
        return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
      } else {
        if (this._parts.urn) {
          this._parts.path = v ? URI.recodeUrnPath(v) : '';
        } else {
          this._parts.path = v ? URI.recodePath(v) : '/';
        }
        this.build(!build);
        return this;
      }
    };
    p.path = p.pathname;
    p.href = function (href, build) {
      var key;
      if (href === undefined) {
        return this.toString();
      }
      this._string = '';
      this._parts = URI._parts();
      var _URI = href instanceof URI;
      var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
      if (href.nodeName) {
        var attribute = URI.getDomAttribute(href);
        href = href[attribute] || '';
        _object = false;
      }

      // window.location is reported to be an object, but it's not the sort
      // of object we're looking for:
      // * location.protocol ends with a colon
      // * location.query != object.search
      // * location.hash != object.fragment
      // simply serializing the unknown object should do the trick
      // (for location, not for everything...)
      if (!_URI && _object && href.pathname !== undefined) {
        href = href.toString();
      }
      if (typeof href === 'string' || href instanceof String) {
        this._parts = URI.parse(String(href), this._parts);
      } else if (_URI || _object) {
        var src = _URI ? href._parts : href;
        for (key in src) {
          if (key === 'query') {
            continue;
          }
          if (hasOwn.call(this._parts, key)) {
            this._parts[key] = src[key];
          }
        }
        if (src.query) {
          this.query(src.query, false);
        }
      } else {
        throw new TypeError('invalid input');
      }
      this.build(!build);
      return this;
    };

    // identification accessors
    p.is = function (what) {
      var ip = false;
      var ip4 = false;
      var ip6 = false;
      var name = false;
      var sld = false;
      var idn = false;
      var punycode = false;
      var relative = !this._parts.urn;
      if (this._parts.hostname) {
        relative = false;
        ip4 = URI.ip4_expression.test(this._parts.hostname);
        ip6 = URI.ip6_expression.test(this._parts.hostname);
        ip = ip4 || ip6;
        name = !ip;
        sld = name && SLD && SLD.has(this._parts.hostname);
        idn = name && URI.idn_expression.test(this._parts.hostname);
        punycode = name && URI.punycode_expression.test(this._parts.hostname);
      }
      switch (what.toLowerCase()) {
        case 'relative':
          return relative;
        case 'absolute':
          return !relative;

        // hostname identification
        case 'domain':
        case 'name':
          return name;
        case 'sld':
          return sld;
        case 'ip':
          return ip;
        case 'ip4':
        case 'ipv4':
        case 'inet4':
          return ip4;
        case 'ip6':
        case 'ipv6':
        case 'inet6':
          return ip6;
        case 'idn':
          return idn;
        case 'url':
          return !this._parts.urn;
        case 'urn':
          return !!this._parts.urn;
        case 'punycode':
          return punycode;
      }
      return null;
    };

    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function (v, build) {
      if (v) {
        // accept trailing ://
        v = v.replace(/:(\/\/)?$/, '');
        if (!v.match(URI.protocol_expression)) {
          throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
        }
      }
      return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v !== undefined) {
        if (v === 0) {
          v = null;
        }
        if (v) {
          v += '';
          if (v.charAt(0) === ':') {
            v = v.substring(1);
          }
          URI.ensureValidPort(v);
        }
      }
      return _port.call(this, v, build);
    };
    p.hostname = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v !== undefined) {
        var x = {
          preventInvalidHostname: this._parts.preventInvalidHostname
        };
        var res = URI.parseHost(v, x);
        if (res !== '/') {
          throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
        }
        v = x.hostname;
        if (this._parts.preventInvalidHostname) {
          URI.ensureValidHostname(v, this._parts.protocol);
        }
      }
      return _hostname.call(this, v, build);
    };

    // compound accessors
    p.origin = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined) {
        var protocol = this.protocol();
        var authority = this.authority();
        if (!authority) {
          return '';
        }
        return (protocol ? protocol + '://' : '') + this.authority();
      } else {
        var origin = URI(v);
        this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
        return this;
      }
    };
    p.host = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined) {
        return this._parts.hostname ? URI.buildHost(this._parts) : '';
      } else {
        var res = URI.parseHost(v, this._parts);
        if (res !== '/') {
          throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
        }
        this.build(!build);
        return this;
      }
    };
    p.authority = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined) {
        return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
      } else {
        var res = URI.parseAuthority(v, this._parts);
        if (res !== '/') {
          throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
        }
        this.build(!build);
        return this;
      }
    };
    p.userinfo = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined) {
        var t = URI.buildUserinfo(this._parts);
        return t ? t.substring(0, t.length - 1) : t;
      } else {
        if (v[v.length - 1] !== '@') {
          v += '@';
        }
        URI.parseUserinfo(v, this._parts);
        this.build(!build);
        return this;
      }
    };
    p.resource = function (v, build) {
      var parts;
      if (v === undefined) {
        return this.path() + this.search() + this.hash();
      }
      parts = URI.parse(v);
      this._parts.path = parts.path;
      this._parts.query = parts.query;
      this._parts.fragment = parts.fragment;
      this.build(!build);
      return this;
    };

    // fraction accessors
    p.subdomain = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }

      // convenience, return "www" from "www.example.org"
      if (v === undefined) {
        if (!this._parts.hostname || this.is('IP')) {
          return '';
        }

        // grab domain and add another segment
        var end = this._parts.hostname.length - this.domain().length - 1;
        return this._parts.hostname.substring(0, end) || '';
      } else {
        var e = this._parts.hostname.length - this.domain().length;
        var sub = this._parts.hostname.substring(0, e);
        var replace = new RegExp('^' + escapeRegEx(sub));
        if (v && v.charAt(v.length - 1) !== '.') {
          v += '.';
        }
        if (v.indexOf(':') !== -1) {
          throw new TypeError('Domains cannot contain colons');
        }
        if (v) {
          URI.ensureValidHostname(v, this._parts.protocol);
        }
        this._parts.hostname = this._parts.hostname.replace(replace, v);
        this.build(!build);
        return this;
      }
    };
    p.domain = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (typeof v === 'boolean') {
        build = v;
        v = undefined;
      }

      // convenience, return "example.org" from "www.example.org"
      if (v === undefined) {
        if (!this._parts.hostname || this.is('IP')) {
          return '';
        }

        // if hostname consists of 1 or 2 segments, it must be the domain
        var t = this._parts.hostname.match(/\./g);
        if (t && t.length < 2) {
          return this._parts.hostname;
        }

        // grab tld and add another segment
        var end = this._parts.hostname.length - this.tld(build).length - 1;
        end = this._parts.hostname.lastIndexOf('.', end - 1) + 1;
        return this._parts.hostname.substring(end) || '';
      } else {
        if (!v) {
          throw new TypeError('cannot set domain empty');
        }
        if (v.indexOf(':') !== -1) {
          throw new TypeError('Domains cannot contain colons');
        }
        URI.ensureValidHostname(v, this._parts.protocol);
        if (!this._parts.hostname || this.is('IP')) {
          this._parts.hostname = v;
        } else {
          var replace = new RegExp(escapeRegEx(this.domain()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        }
        this.build(!build);
        return this;
      }
    };
    p.tld = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (typeof v === 'boolean') {
        build = v;
        v = undefined;
      }

      // return "org" from "www.example.org"
      if (v === undefined) {
        if (!this._parts.hostname || this.is('IP')) {
          return '';
        }
        var pos = this._parts.hostname.lastIndexOf('.');
        var tld = this._parts.hostname.substring(pos + 1);
        if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
          return SLD.get(this._parts.hostname) || tld;
        }
        return tld;
      } else {
        var replace;
        if (!v) {
          throw new TypeError('cannot set TLD empty');
        } else if (v.match(/[^a-zA-Z0-9-]/)) {
          if (SLD && SLD.is(v)) {
            replace = new RegExp(escapeRegEx(this.tld()) + '$');
            this._parts.hostname = this._parts.hostname.replace(replace, v);
          } else {
            throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
          }
        } else if (!this._parts.hostname || this.is('IP')) {
          throw new ReferenceError('cannot set TLD on non-domain host');
        } else {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        }
        this.build(!build);
        return this;
      }
    };
    p.directory = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined || v === true) {
        if (!this._parts.path && !this._parts.hostname) {
          return '';
        }
        if (this._parts.path === '/') {
          return '/';
        }
        var end = this._parts.path.length - this.filename().length - 1;
        var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
        return v ? URI.decodePath(res) : res;
      } else {
        var e = this._parts.path.length - this.filename().length;
        var directory = this._parts.path.substring(0, e);
        var replace = new RegExp('^' + escapeRegEx(directory));

        // fully qualifier directories begin with a slash
        if (!this.is('relative')) {
          if (!v) {
            v = '/';
          }
          if (v.charAt(0) !== '/') {
            v = '/' + v;
          }
        }

        // directories always end with a slash
        if (v && v.charAt(v.length - 1) !== '/') {
          v += '/';
        }
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
        this.build(!build);
        return this;
      }
    };
    p.filename = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (typeof v !== 'string') {
        if (!this._parts.path || this._parts.path === '/') {
          return '';
        }
        var pos = this._parts.path.lastIndexOf('/');
        var res = this._parts.path.substring(pos + 1);
        return v ? URI.decodePathSegment(res) : res;
      } else {
        var mutatedDirectory = false;
        if (v.charAt(0) === '/') {
          v = v.substring(1);
        }
        if (v.match(/\.?\//)) {
          mutatedDirectory = true;
        }
        var replace = new RegExp(escapeRegEx(this.filename()) + '$');
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
        if (mutatedDirectory) {
          this.normalizePath(build);
        } else {
          this.build(!build);
        }
        return this;
      }
    };
    p.suffix = function (v, build) {
      if (this._parts.urn) {
        return v === undefined ? '' : this;
      }
      if (v === undefined || v === true) {
        if (!this._parts.path || this._parts.path === '/') {
          return '';
        }
        var filename = this.filename();
        var pos = filename.lastIndexOf('.');
        var s, res;
        if (pos === -1) {
          return '';
        }

        // suffix may only contain alnum characters (yup, I made this up.)
        s = filename.substring(pos + 1);
        res = /^[a-z0-9%]+$/i.test(s) ? s : '';
        return v ? URI.decodePathSegment(res) : res;
      } else {
        if (v.charAt(0) === '.') {
          v = v.substring(1);
        }
        var suffix = this.suffix();
        var replace;
        if (!suffix) {
          if (!v) {
            return this;
          }
          this._parts.path += '.' + URI.recodePath(v);
        } else if (!v) {
          replace = new RegExp(escapeRegEx('.' + suffix) + '$');
        } else {
          replace = new RegExp(escapeRegEx(suffix) + '$');
        }
        if (replace) {
          v = URI.recodePath(v);
          this._parts.path = this._parts.path.replace(replace, v);
        }
        this.build(!build);
        return this;
      }
    };
    p.segment = function (segment, v, build) {
      var separator = this._parts.urn ? ':' : '/';
      var path = this.path();
      var absolute = path.substring(0, 1) === '/';
      var segments = path.split(separator);
      if (segment !== undefined && typeof segment !== 'number') {
        build = v;
        v = segment;
        segment = undefined;
      }
      if (segment !== undefined && typeof segment !== 'number') {
        throw new Error('Bad segment "' + segment + '", must be 0-based integer');
      }
      if (absolute) {
        segments.shift();
      }
      if (segment < 0) {
        // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
      }
      if (v === undefined) {
        /*jshint laxbreak: true */
        return segment === undefined ? segments : segments[segment];
        /*jshint laxbreak: false */
      } else if (segment === null || segments[segment] === undefined) {
        if (isArray(v)) {
          segments = [];
          // collapse empty elements within array
          for (var i = 0, l = v.length; i < l; i++) {
            if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) {
              continue;
            }
            if (segments.length && !segments[segments.length - 1].length) {
              segments.pop();
            }
            segments.push(trimSlashes(v[i]));
          }
        } else if (v || typeof v === 'string') {
          v = trimSlashes(v);
          if (segments[segments.length - 1] === '') {
            // empty trailing elements have to be overwritten
            // to prevent results such as /foo//bar
            segments[segments.length - 1] = v;
          } else {
            segments.push(v);
          }
        }
      } else {
        if (v) {
          segments[segment] = trimSlashes(v);
        } else {
          segments.splice(segment, 1);
        }
      }
      if (absolute) {
        segments.unshift('');
      }
      return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function (segment, v, build) {
      var segments, i, l;
      if (typeof segment !== 'number') {
        build = v;
        v = segment;
        segment = undefined;
      }
      if (v === undefined) {
        segments = this.segment(segment, v, build);
        if (!isArray(segments)) {
          segments = segments !== undefined ? URI.decode(segments) : undefined;
        } else {
          for (i = 0, l = segments.length; i < l; i++) {
            segments[i] = URI.decode(segments[i]);
          }
        }
        return segments;
      }
      if (!isArray(v)) {
        v = typeof v === 'string' || v instanceof String ? URI.encode(v) : v;
      } else {
        for (i = 0, l = v.length; i < l; i++) {
          v[i] = URI.encode(v[i]);
        }
      }
      return this.segment(segment, v, build);
    };

    // mutating query string
    var q = p.query;
    p.query = function (v, build) {
      if (v === true) {
        return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      } else if (typeof v === 'function') {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        var result = v.call(this, data);
        this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        this.build(!build);
        return this;
      } else if (v !== undefined && typeof v !== 'string') {
        this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        this.build(!build);
        return this;
      } else {
        return q.call(this, v, build);
      }
    };
    p.setQuery = function (name, value, build) {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      if (typeof name === 'string' || name instanceof String) {
        data[name] = value !== undefined ? value : null;
      } else if (typeof name === 'object') {
        for (var key in name) {
          if (hasOwn.call(name, key)) {
            data[key] = name[key];
          }
        }
      } else {
        throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
      }
      this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      if (typeof name !== 'string') {
        build = value;
      }
      this.build(!build);
      return this;
    };
    p.addQuery = function (name, value, build) {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      URI.addQuery(data, name, value === undefined ? null : value);
      this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      if (typeof name !== 'string') {
        build = value;
      }
      this.build(!build);
      return this;
    };
    p.removeQuery = function (name, value, build) {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      URI.removeQuery(data, name, value);
      this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      if (typeof name !== 'string') {
        build = value;
      }
      this.build(!build);
      return this;
    };
    p.hasQuery = function (name, value, withinArray) {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;

    // sanitizing URLs
    p.normalize = function () {
      if (this._parts.urn) {
        return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
      }
      return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function (build) {
      if (typeof this._parts.protocol === 'string') {
        this._parts.protocol = this._parts.protocol.toLowerCase();
        this.build(!build);
      }
      return this;
    };
    p.normalizeHostname = function (build) {
      if (this._parts.hostname) {
        if (this.is('IDN') && punycode) {
          this._parts.hostname = punycode.toASCII(this._parts.hostname);
        } else if (this.is('IPv6') && IPv6) {
          this._parts.hostname = IPv6.best(this._parts.hostname);
        }
        this._parts.hostname = this._parts.hostname.toLowerCase();
        this.build(!build);
      }
      return this;
    };
    p.normalizePort = function (build) {
      // remove port of it's the protocol's default
      if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
        this._parts.port = null;
        this.build(!build);
      }
      return this;
    };
    p.normalizePath = function (build) {
      var _path = this._parts.path;
      if (!_path) {
        return this;
      }
      if (this._parts.urn) {
        this._parts.path = URI.recodeUrnPath(this._parts.path);
        this.build(!build);
        return this;
      }
      if (this._parts.path === '/') {
        return this;
      }
      _path = URI.recodePath(_path);
      var _was_relative;
      var _leadingParents = '';
      var _parent, _pos;

      // handle relative paths
      if (_path.charAt(0) !== '/') {
        _was_relative = true;
        _path = '/' + _path;
      }

      // handle relative files (as opposed to directories)
      if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
        _path += '/';
      }

      // resolve simples
      _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, '/').replace(/\/{2,}/g, '/');

      // remember leading parents
      if (_was_relative) {
        _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
        if (_leadingParents) {
          _leadingParents = _leadingParents[0];
        }
      }

      // resolve parents
      while (true) {
        _parent = _path.search(/\/\.\.(\/|$)/);
        if (_parent === -1) {
          // no more ../ to resolve
          break;
        } else if (_parent === 0) {
          // top level cannot be relative, skip it
          _path = _path.substring(3);
          continue;
        }
        _pos = _path.substring(0, _parent).lastIndexOf('/');
        if (_pos === -1) {
          _pos = _parent;
        }
        _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
      }

      // revert to relative
      if (_was_relative && this.is('relative')) {
        _path = _leadingParents + _path.substring(1);
      }
      this._parts.path = _path;
      this.build(!build);
      return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function (build) {
      if (typeof this._parts.query === 'string') {
        if (!this._parts.query.length) {
          this._parts.query = null;
        } else {
          this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
        }
        this.build(!build);
      }
      return this;
    };
    p.normalizeFragment = function (build) {
      if (!this._parts.fragment) {
        this._parts.fragment = null;
        this.build(!build);
      }
      return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function () {
      // expect unicode input, iso8859 output
      var e = URI.encode;
      var d = URI.decode;
      URI.encode = escape;
      URI.decode = decodeURIComponent;
      try {
        this.normalize();
      } finally {
        URI.encode = e;
        URI.decode = d;
      }
      return this;
    };
    p.unicode = function () {
      // expect iso8859 input, unicode output
      var e = URI.encode;
      var d = URI.decode;
      URI.encode = strictEncodeURIComponent;
      URI.decode = unescape;
      try {
        this.normalize();
      } finally {
        URI.encode = e;
        URI.decode = d;
      }
      return this;
    };
    p.readable = function () {
      var uri = this.clone();
      // removing username, password, because they shouldn't be displayed according to RFC 3986
      uri.username('').password('').normalize();
      var t = '';
      if (uri._parts.protocol) {
        t += uri._parts.protocol + '://';
      }
      if (uri._parts.hostname) {
        if (uri.is('punycode') && punycode) {
          t += punycode.toUnicode(uri._parts.hostname);
          if (uri._parts.port) {
            t += ':' + uri._parts.port;
          }
        } else {
          t += uri.host();
        }
      }
      if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
        t += '/';
      }
      t += uri.path(true);
      if (uri._parts.query) {
        var q = '';
        for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
          var kv = (qp[i] || '').split('=');
          q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, '%26');
          if (kv[1] !== undefined) {
            q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, '%26');
          }
        }
        t += '?' + q.substring(1);
      }
      t += URI.decodeQuery(uri.hash(), true);
      return t;
    };

    // resolving relative and absolute URLs
    p.absoluteTo = function (base) {
      var resolved = this.clone();
      var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
      var basedir, i, p;
      if (this._parts.urn) {
        throw new Error('URNs do not have any generally defined hierarchical components');
      }
      if (!(base instanceof URI)) {
        base = new URI(base);
      }
      if (resolved._parts.protocol) {
        // Directly returns even if this._parts.hostname is empty.
        return resolved;
      } else {
        resolved._parts.protocol = base._parts.protocol;
      }
      if (this._parts.hostname) {
        return resolved;
      }
      for (i = 0; p = properties[i]; i++) {
        resolved._parts[p] = base._parts[p];
      }
      if (!resolved._parts.path) {
        resolved._parts.path = base._parts.path;
        if (!resolved._parts.query) {
          resolved._parts.query = base._parts.query;
        }
      } else {
        if (resolved._parts.path.substring(-2) === '..') {
          resolved._parts.path += '/';
        }
        if (resolved.path().charAt(0) !== '/') {
          basedir = base.directory();
          basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
          resolved._parts.path = (basedir ? basedir + '/' : '') + resolved._parts.path;
          resolved.normalizePath();
        }
      }
      resolved.build();
      return resolved;
    };
    p.relativeTo = function (base) {
      var relative = this.clone().normalize();
      var relativeParts, baseParts, common, relativePath, basePath;
      if (relative._parts.urn) {
        throw new Error('URNs do not have any generally defined hierarchical components');
      }
      base = new URI(base).normalize();
      relativeParts = relative._parts;
      baseParts = base._parts;
      relativePath = relative.path();
      basePath = base.path();
      if (relativePath.charAt(0) !== '/') {
        throw new Error('URI is already relative');
      }
      if (basePath.charAt(0) !== '/') {
        throw new Error('Cannot calculate a URI relative to another relative URI');
      }
      if (relativeParts.protocol === baseParts.protocol) {
        relativeParts.protocol = null;
      }
      if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
        return relative.build();
      }
      if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
        return relative.build();
      }
      if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
        relativeParts.hostname = null;
        relativeParts.port = null;
      } else {
        return relative.build();
      }
      if (relativePath === basePath) {
        relativeParts.path = '';
        return relative.build();
      }

      // determine common sub path
      common = URI.commonPath(relativePath, basePath);

      // If the paths have nothing in common, return a relative URL with the absolute path.
      if (!common) {
        return relative.build();
      }
      var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, '').replace(/.*?\//g, '../');
      relativeParts.path = parents + relativeParts.path.substring(common.length) || './';
      return relative.build();
    };

    // comparing URIs
    p.equals = function (uri) {
      var one = this.clone();
      var two = new URI(uri);
      var one_map = {};
      var two_map = {};
      var checked = {};
      var one_query, two_query, key;
      one.normalize();
      two.normalize();

      // exact match
      if (one.toString() === two.toString()) {
        return true;
      }

      // extract query string
      one_query = one.query();
      two_query = two.query();
      one.query('');
      two.query('');

      // definitely not equal if not even non-query parts match
      if (one.toString() !== two.toString()) {
        return false;
      }

      // query parameters have the same length, even if they're permuted
      if (one_query.length !== two_query.length) {
        return false;
      }
      one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
      two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
      for (key in one_map) {
        if (hasOwn.call(one_map, key)) {
          if (!isArray(one_map[key])) {
            if (one_map[key] !== two_map[key]) {
              return false;
            }
          } else if (!arraysEqual(one_map[key], two_map[key])) {
            return false;
          }
          checked[key] = true;
        }
      }
      for (key in two_map) {
        if (hasOwn.call(two_map, key)) {
          if (!checked[key]) {
            // two contains a parameter not present in one
            return false;
          }
        }
      }
      return true;
    };

    // state
    p.preventInvalidHostname = function (v) {
      this._parts.preventInvalidHostname = !!v;
      return this;
    };
    p.duplicateQueryParameters = function (v) {
      this._parts.duplicateQueryParameters = !!v;
      return this;
    };
    p.escapeQuerySpace = function (v) {
      this._parts.escapeQuerySpace = !!v;
      return this;
    };
    return URI;
  });

  /***/
}, /* 186 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_RESULT__; /* WEBPACK VAR INJECTION */
  (function (module, global) {
    /*! https://mths.be/punycode v1.4.0 by @mathias */
    ;
    (function (root) {
      /** Detect free variables */
      var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
      var freeModule = typeof module == 'object' && module && !module.nodeType && module;
      var freeGlobal = typeof global == 'object' && global;
      if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
        root = freeGlobal;
      }

      /**
       * The `punycode` object.
       * @name punycode
       * @type Object
       */
      var punycode,
        /** Highest positive signed 32-bit float value */
        maxInt = 2147483647,
        // aka. 0x7FFFFFFF or 2^31-1

        /** Bootstring parameters */
        base = 36,
        tMin = 1,
        tMax = 26,
        skew = 38,
        damp = 700,
        initialBias = 72,
        initialN = 128,
        // 0x80
        delimiter = '-',
        // '\x2D'

        /** Regular expressions */
        regexPunycode = /^xn--/,
        regexNonASCII = /[^\x20-\x7E]/,
        // unprintable ASCII chars + non-ASCII chars
        regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
        // RFC 3490 separators

        /** Error messages */
        errors = {
          'overflow': 'Overflow: input needs wider integers to process',
          'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
          'invalid-input': 'Invalid input'
        },
        /** Convenience shortcuts */
        baseMinusTMin = base - tMin,
        floor = Math.floor,
        stringFromCharCode = String.fromCharCode,
        /** Temporary variable */
        key;

      /*--------------------------------------------------------------------------*/

      /**
       * A generic error utility function.
       * @private
       * @param {String} type The error type.
       * @returns {Error} Throws a `RangeError` with the applicable error message.
       */
      function error(type) {
        throw new RangeError(errors[type]);
      }

      /**
       * A generic `Array#map` utility function.
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} callback The function that gets called for every array
       * item.
       * @returns {Array} A new array of values returned by the callback function.
       */
      function map(array, fn) {
        var length = array.length;
        var result = [];
        while (length--) {
          result[length] = fn(array[length]);
        }
        return result;
      }

      /**
       * A simple `Array#map`-like wrapper to work with domain name strings or email
       * addresses.
       * @private
       * @param {String} domain The domain name or email address.
       * @param {Function} callback The function that gets called for every
       * character.
       * @returns {Array} A new string of characters returned by the callback
       * function.
       */
      function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
          // In email addresses, only the domain name should be punycoded. Leave
          // the local part (i.e. everything up to `@`) intact.
          result = parts[0] + '@';
          string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
      }

      /**
       * Creates an array containing the numeric code points of each Unicode
       * character in the string. While JavaScript uses UCS-2 internally,
       * this function will convert a pair of surrogate halves (each of which
       * UCS-2 exposes as separate characters) into a single code point,
       * matching UTF-16.
       * @see `punycode.ucs2.encode`
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode.ucs2
       * @name decode
       * @param {String} string The Unicode input string (UCS-2).
       * @returns {Array} The new array of code points.
       */
      function ucs2decode(string) {
        var output = [],
          counter = 0,
          length = string.length,
          value,
          extra;
        while (counter < length) {
          value = string.charCodeAt(counter++);
          if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) {
              // low surrogate
              output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            } else {
              // unmatched surrogate; only append this code unit, in case the next
              // code unit is the high surrogate of a surrogate pair
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }
        return output;
      }

      /**
       * Creates a string based on an array of numeric code points.
       * @see `punycode.ucs2.decode`
       * @memberOf punycode.ucs2
       * @name encode
       * @param {Array} codePoints The array of numeric code points.
       * @returns {String} The new Unicode string (UCS-2).
       */
      function ucs2encode(array) {
        return map(array, function (value) {
          var output = '';
          if (value > 0xFFFF) {
            value -= 0x10000;
            output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
          }
          output += stringFromCharCode(value);
          return output;
        }).join('');
      }

      /**
       * Converts a basic code point into a digit/integer.
       * @see `digitToBasic()`
       * @private
       * @param {Number} codePoint The basic numeric code point value.
       * @returns {Number} The numeric value of a basic code point (for use in
       * representing integers) in the range `0` to `base - 1`, or `base` if
       * the code point does not represent a value.
       */
      function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }
        return base;
      }

      /**
       * Converts a digit/integer into a basic code point.
       * @see `basicToDigit()`
       * @private
       * @param {Number} digit The numeric value of a basic code point.
       * @returns {Number} The basic code point whose value (when used for
       * representing integers) is `digit`, which needs to be in the range
       * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
       * used; else, the lowercase form is used. The behavior is undefined
       * if `flag` is non-zero and `digit` has no uppercase form.
       */
      function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      }

      /**
       * Bias adaptation function as per section 3.4 of RFC 3492.
       * https://tools.ietf.org/html/rfc3492#section-3.4
       * @private
       */
      function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for /* no initialization */
        (; delta > baseMinusTMin * tMax >> 1; k += base) {
          delta = floor(delta / baseMinusTMin);
        }
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
      }

      /**
       * Converts a Punycode string of ASCII-only symbols to a string of Unicode
       * symbols.
       * @memberOf punycode
       * @param {String} input The Punycode string of ASCII-only symbols.
       * @returns {String} The resulting string of Unicode symbols.
       */
      function decode(input) {
        // Don't use UCS-2
        var output = [],
          inputLength = input.length,
          out,
          i = 0,
          n = initialN,
          bias = initialBias,
          basic,
          j,
          index,
          oldi,
          w,
          k,
          digit,
          t,
          /** Cached calculation results */
          baseMinusT;

        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.

        basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
          basic = 0;
        }
        for (j = 0; j < basic; ++j) {
          // if it's not a basic code point
          if (input.charCodeAt(j) >= 0x80) {
            error('not-basic');
          }
          output.push(input.charCodeAt(j));
        }

        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.

        for /* no final expression */
        (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
          // `index` is the index of the next character to be consumed.
          // Decode a generalized variable-length integer into `delta`,
          // which gets added to `i`. The overflow checking is easier
          // if we increase `i` as we go, then subtract off its starting
          // value at the end to obtain `delta`.
          for /* no condition */
          (oldi = i, w = 1, k = base;; k += base) {
            if (index >= inputLength) {
              error('invalid-input');
            }
            digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base || digit > floor((maxInt - i) / w)) {
              error('overflow');
            }
            i += digit * w;
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) {
              break;
            }
            baseMinusT = base - t;
            if (w > floor(maxInt / baseMinusT)) {
              error('overflow');
            }
            w *= baseMinusT;
          }
          out = output.length + 1;
          bias = adapt(i - oldi, out, oldi == 0);

          // `i` was supposed to wrap around from `out` to `0`,
          // incrementing `n` each time, so we'll fix that now:
          if (floor(i / out) > maxInt - n) {
            error('overflow');
          }
          n += floor(i / out);
          i %= out;

          // Insert `n` at position `i` of the output
          output.splice(i++, 0, n);
        }
        return ucs2encode(output);
      }

      /**
       * Converts a string of Unicode symbols (e.g. a domain name label) to a
       * Punycode string of ASCII-only symbols.
       * @memberOf punycode
       * @param {String} input The string of Unicode symbols.
       * @returns {String} The resulting Punycode string of ASCII-only symbols.
       */
      function encode(input) {
        var n,
          delta,
          handledCPCount,
          basicLength,
          bias,
          j,
          m,
          q,
          k,
          t,
          currentValue,
          output = [],
          /** `inputLength` will hold the number of code points in `input`. */
          inputLength,
          /** Cached calculation results */
          handledCPCountPlusOne,
          baseMinusT,
          qMinusT;

        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);

        // Cache the length
        inputLength = input.length;

        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;

        // Handle the basic code points
        for (j = 0; j < inputLength; ++j) {
          currentValue = input[j];
          if (currentValue < 0x80) {
            output.push(stringFromCharCode(currentValue));
          }
        }
        handledCPCount = basicLength = output.length;

        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.

        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) {
          output.push(delimiter);
        }

        // Main encoding loop:
        while (handledCPCount < inputLength) {
          // All non-basic code points < n have been handled already. Find the next
          // larger one:
          for (m = maxInt, j = 0; j < inputLength; ++j) {
            currentValue = input[j];
            if (currentValue >= n && currentValue < m) {
              m = currentValue;
            }
          }

          // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
          // but guard against overflow
          handledCPCountPlusOne = handledCPCount + 1;
          if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
            error('overflow');
          }
          delta += (m - n) * handledCPCountPlusOne;
          n = m;
          for (j = 0; j < inputLength; ++j) {
            currentValue = input[j];
            if (currentValue < n && ++delta > maxInt) {
              error('overflow');
            }
            if (currentValue == n) {
              // Represent delta as a generalized variable-length integer
              for /* no condition */
              (q = delta, k = base;; k += base) {
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (q < t) {
                  break;
                }
                qMinusT = q - t;
                baseMinusT = base - t;
                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                q = floor(qMinusT / baseMinusT);
              }
              output.push(stringFromCharCode(digitToBasic(q, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }
          ++delta;
          ++n;
        }
        return output.join('');
      }

      /**
       * Converts a Punycode string representing a domain name or an email address
       * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
       * it doesn't matter if you call it on a string that has already been
       * converted to Unicode.
       * @memberOf punycode
       * @param {String} input The Punycoded domain name or email address to
       * convert to Unicode.
       * @returns {String} The Unicode representation of the given Punycode
       * string.
       */
      function toUnicode(input) {
        return mapDomain(input, function (string) {
          return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
      }

      /**
       * Converts a Unicode string representing a domain name or an email address to
       * Punycode. Only the non-ASCII parts of the domain name will be converted,
       * i.e. it doesn't matter if you call it with a domain that's already in
       * ASCII.
       * @memberOf punycode
       * @param {String} input The domain name or email address to convert, as a
       * Unicode string.
       * @returns {String} The Punycode representation of the given domain name or
       * email address.
       */
      function toASCII(input) {
        return mapDomain(input, function (string) {
          return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
      }

      /*--------------------------------------------------------------------------*/

      /** Define the public API */
      punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        'version': '1.3.2',
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        'ucs2': {
          'decode': ucs2decode,
          'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
      };

      /** Expose `punycode` */
      // Some AMD build optimizers, like r.js, check for specific condition patterns
      // like the following:
      if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return punycode;
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else if (freeExports && freeModule) {
        if (module.exports == freeExports) {
          // in Node.js, io.js, or RingoJS v0.8.0+
          freeModule.exports = punycode;
        } else {
          // in Narwhal or RingoJS v0.7.0-
          for (key in punycode) {
            punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
          }
        }
      } else {
        // in Rhino or a web browser
        root.punycode = punycode;
      }
    })(this);

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(132)(module), function () {
    return this;
  }());

  /***/
}, /* 187 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                     * URI.js - Mutating URLs
                                                                     * IPv6 Support
                                                                     *
                                                                     * Version: 1.19.1
                                                                     *
                                                                     * Author: Rodney Rehm
                                                                     * Web: http://medialize.github.io/URI.js/
                                                                     *
                                                                     * Licensed under
                                                                     *   MIT License http://www.opensource.org/licenses/mit-license
                                                                     *
                                                                     */

  (function (root, factory) {
    'use strict';

    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (typeof module === 'object' && module.exports) {
      // Node
      module.exports = factory();
    } else if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      // Browser globals (root is window)
      root.IPv6 = factory(root);
    }
  })(this, function (root) {
    'use strict';

    /*
    var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
    var _out = IPv6.best(_in);
    var _expected = "fe80::204:61ff:fe9d:f156";
      console.log(_in, _out, _expected, _out === _expected);
    */

    // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
      // based on:
      // Javascript to test an IPv6 address for proper format, and to
      // present the "best text representation" according to IETF Draft RFC at
      // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
      // 8 Feb 2010 Rich Brown, Dartware, LLC
      // Please feel free to use this code as long as you provide a link to
      // http://www.intermapper.com
      // http://intermapper.com/support/tools/IPV6-Validator.aspx
      // http://download.dartware.com/thirdparty/ipv6validator.js

      var _address = address.toLowerCase();
      var segments = _address.split(':');
      var length = segments.length;
      var total = 8;

      // trim colons (:: or ::a:b:c… or …a:b:c::)
      if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
        // must have been ::
        // remove first two items
        segments.shift();
        segments.shift();
      } else if (segments[0] === '' && segments[1] === '') {
        // must have been ::xxxx
        // remove the first item
        segments.shift();
      } else if (segments[length - 1] === '' && segments[length - 2] === '') {
        // must have been xxxx::
        segments.pop();
      }
      length = segments.length;

      // adjust total segments for IPv4 trailer
      if (segments[length - 1].indexOf('.') !== -1) {
        // found a "." which means IPv4
        total = 7;
      }

      // fill empty segments them with "0000"
      var pos;
      for (pos = 0; pos < length; pos++) {
        if (segments[pos] === '') {
          break;
        }
      }
      if (pos < total) {
        segments.splice(pos, 1, '0000');
        while (segments.length < total) {
          segments.splice(pos, 0, '0000');
        }
      }

      // strip leading zeros
      var _segments;
      for (var i = 0; i < total; i++) {
        _segments = segments[i].split('');
        for (var j = 0; j < 3; j++) {
          if (_segments[0] === '0' && _segments.length > 1) {
            _segments.splice(0, 1);
          } else {
            break;
          }
        }
        segments[i] = _segments.join('');
      }

      // find longest sequence of zeroes and coalesce them into one segment
      var best = -1;
      var _best = 0;
      var _current = 0;
      var current = -1;
      var inzeroes = false;
      // i; already declared

      for (i = 0; i < total; i++) {
        if (inzeroes) {
          if (segments[i] === '0') {
            _current += 1;
          } else {
            inzeroes = false;
            if (_current > _best) {
              best = current;
              _best = _current;
            }
          }
        } else {
          if (segments[i] === '0') {
            inzeroes = true;
            current = i;
            _current = 1;
          }
        }
      }
      if (_current > _best) {
        best = current;
        _best = _current;
      }
      if (_best > 1) {
        segments.splice(best, _best, '');
      }
      length = segments.length;

      // assemble remaining segments
      var result = '';
      if (segments[0] === '') {
        result = ':';
      }
      for (i = 0; i < length; i++) {
        result += segments[i];
        if (i === length - 1) {
          break;
        }
        result += ':';
      }
      if (segments[length - 1] === '') {
        result += ':';
      }
      return result;
    }
    function noConflict() {
      /*jshint validthis: true */
      if (root.IPv6 === this) {
        root.IPv6 = _IPv6;
      }
      return this;
    }
    return {
      best: bestPresentation,
      noConflict: noConflict
    };
  });

  /***/
}, /* 188 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                     * URI.js - Mutating URLs
                                                                     * Second Level Domain (SLD) Support
                                                                     *
                                                                     * Version: 1.19.1
                                                                     *
                                                                     * Author: Rodney Rehm
                                                                     * Web: http://medialize.github.io/URI.js/
                                                                     *
                                                                     * Licensed under
                                                                     *   MIT License http://www.opensource.org/licenses/mit-license
                                                                     *
                                                                     */

  (function (root, factory) {
    'use strict';

    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (typeof module === 'object' && module.exports) {
      // Node
      module.exports = factory();
    } else if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      // Browser globals (root is window)
      root.SecondLevelDomains = factory(root);
    }
  })(this, function (root) {
    'use strict';

    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
      // list of known Second Level Domains
      // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
      // ----
      // publicsuffix.org is more current and actually used by a couple of browsers internally.
      // downside is it also contains domains like "dyndns.org" - which is fine for the security
      // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
      // ----
      list: {
        'ac': ' com gov mil net org ',
        'ae': ' ac co gov mil name net org pro sch ',
        'af': ' com edu gov net org ',
        'al': ' com edu gov mil net org ',
        'ao': ' co ed gv it og pb ',
        'ar': ' com edu gob gov int mil net org tur ',
        'at': ' ac co gv or ',
        'au': ' asn com csiro edu gov id net org ',
        'ba': ' co com edu gov mil net org rs unbi unmo unsa untz unze ',
        'bb': ' biz co com edu gov info net org store tv ',
        'bh': ' biz cc com edu gov info net org ',
        'bn': ' com edu gov net org ',
        'bo': ' com edu gob gov int mil net org tv ',
        'br': ' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
        'bs': ' com edu gov net org ',
        'bz': ' du et om ov rg ',
        'ca': ' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
        'ck': ' biz co edu gen gov info net org ',
        'cn': ' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
        'co': ' com edu gov mil net nom org ',
        'cr': ' ac c co ed fi go or sa ',
        'cy': ' ac biz com ekloges gov ltd name net org parliament press pro tm ',
        'do': ' art com edu gob gov mil net org sld web ',
        'dz': ' art asso com edu gov net org pol ',
        'ec': ' com edu fin gov info med mil net org pro ',
        'eg': ' com edu eun gov mil name net org sci ',
        'er': ' com edu gov ind mil net org rochest w ',
        'es': ' com edu gob nom org ',
        'et': ' biz com edu gov info name net org ',
        'fj': ' ac biz com info mil name net org pro ',
        'fk': ' ac co gov net nom org ',
        'fr': ' asso com f gouv nom prd presse tm ',
        'gg': ' co net org ',
        'gh': ' com edu gov mil org ',
        'gn': ' ac com gov net org ',
        'gr': ' com edu gov mil net org ',
        'gt': ' com edu gob ind mil net org ',
        'gu': ' com edu gov net org ',
        'hk': ' com edu gov idv net org ',
        'hu': ' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
        'id': ' ac co go mil net or sch web ',
        'il': ' ac co gov idf k12 muni net org ',
        'in': ' ac co edu ernet firm gen gov i ind mil net nic org res ',
        'iq': ' com edu gov i mil net org ',
        'ir': ' ac co dnssec gov i id net org sch ',
        'it': ' edu gov ',
        'je': ' co net org ',
        'jo': ' com edu gov mil name net org sch ',
        'jp': ' ac ad co ed go gr lg ne or ',
        'ke': ' ac co go info me mobi ne or sc ',
        'kh': ' com edu gov mil net org per ',
        'ki': ' biz com de edu gov info mob net org tel ',
        'km': ' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
        'kn': ' edu gov net org ',
        'kr': ' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
        'kw': ' com edu gov net org ',
        'ky': ' com edu gov net org ',
        'kz': ' com edu gov mil net org ',
        'lb': ' com edu gov net org ',
        'lk': ' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
        'lr': ' com edu gov net org ',
        'lv': ' asn com conf edu gov id mil net org ',
        'ly': ' com edu gov id med net org plc sch ',
        'ma': ' ac co gov m net org press ',
        'mc': ' asso tm ',
        'me': ' ac co edu gov its net org priv ',
        'mg': ' com edu gov mil nom org prd tm ',
        'mk': ' com edu gov inf name net org pro ',
        'ml': ' com edu gov net org presse ',
        'mn': ' edu gov org ',
        'mo': ' com edu gov net org ',
        'mt': ' com edu gov net org ',
        'mv': ' aero biz com coop edu gov info int mil museum name net org pro ',
        'mw': ' ac co com coop edu gov int museum net org ',
        'mx': ' com edu gob net org ',
        'my': ' com edu gov mil name net org sch ',
        'nf': ' arts com firm info net other per rec store web ',
        'ng': ' biz com edu gov mil mobi name net org sch ',
        'ni': ' ac co com edu gob mil net nom org ',
        'np': ' com edu gov mil net org ',
        'nr': ' biz com edu gov info net org ',
        'om': ' ac biz co com edu gov med mil museum net org pro sch ',
        'pe': ' com edu gob mil net nom org sld ',
        'ph': ' com edu gov i mil net ngo org ',
        'pk': ' biz com edu fam gob gok gon gop gos gov net org web ',
        'pl': ' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
        'pr': ' ac biz com edu est gov info isla name net org pro prof ',
        'ps': ' com edu gov net org plo sec ',
        'pw': ' belau co ed go ne or ',
        'ro': ' arts com firm info nom nt org rec store tm www ',
        'rs': ' ac co edu gov in org ',
        'sb': ' com edu gov net org ',
        'sc': ' com edu gov net org ',
        'sh': ' co com edu gov net nom org ',
        'sl': ' com edu gov net org ',
        'st': ' co com consulado edu embaixada gov mil net org principe saotome store ',
        'sv': ' com edu gob org red ',
        'sz': ' ac co org ',
        'tr': ' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
        'tt': ' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
        'tw': ' club com ebiz edu game gov idv mil net org ',
        'mu': ' ac co com gov net or org ',
        'mz': ' ac co edu gov org ',
        'na': ' co com ',
        'nz': ' ac co cri geek gen govt health iwi maori mil net org parliament school ',
        'pa': ' abo ac com edu gob ing med net nom org sld ',
        'pt': ' com edu gov int net nome org publ ',
        'py': ' com edu gov mil net org ',
        'qa': ' com edu gov mil net org ',
        're': ' asso com nom ',
        'ru': ' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
        'rw': ' ac co com edu gouv gov int mil net ',
        'sa': ' com edu gov med net org pub sch ',
        'sd': ' com edu gov info med net org tv ',
        'se': ' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
        'sg': ' com edu gov idn net org per ',
        'sn': ' art com edu gouv org perso univ ',
        'sy': ' com edu gov mil net news org ',
        'th': ' ac co go in mi net or ',
        'tj': ' ac biz co com edu go gov info int mil name net nic org test web ',
        'tn': ' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
        'tz': ' ac co go ne or ',
        'ua': ' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
        'ug': ' ac co go ne or org sc ',
        'uk': ' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
        'us': ' dni fed isa kids nsn ',
        'uy': ' com edu gub mil net org ',
        've': ' co com edu gob info mil net org web ',
        'vi': ' co com k12 net org ',
        'vn': ' ac biz com edu gov health info int name net org pro ',
        'ye': ' co com gov ltd me net org plc ',
        'yu': ' ac co edu gov org ',
        'za': ' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
        'zm': ' ac co com edu gov net org sch ',
        // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
        'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
        'net': 'gb jp se uk ',
        'org': 'ae',
        'de': 'com '
      },
      // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
      // in both performance and memory footprint. No initialization required.
      // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
      // Following methods use lastIndexOf() rather than array.split() in order
      // to avoid any memory allocations.
      has: function has(domain) {
        var tldOffset = domain.lastIndexOf('.');
        if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
          return false;
        }
        var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
        if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
          return false;
        }
        var sldList = SLD.list[domain.slice(tldOffset + 1)];
        if (!sldList) {
          return false;
        }
        return sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') >= 0;
      },
      is: function is(domain) {
        var tldOffset = domain.lastIndexOf('.');
        if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
          return false;
        }
        var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
        if (sldOffset >= 0) {
          return false;
        }
        var sldList = SLD.list[domain.slice(tldOffset + 1)];
        if (!sldList) {
          return false;
        }
        return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
      },
      get: function get(domain) {
        var tldOffset = domain.lastIndexOf('.');
        if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
          return null;
        }
        var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
        if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
          return null;
        }
        var sldList = SLD.list[domain.slice(tldOffset + 1)];
        if (!sldList) {
          return null;
        }
        if (sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') < 0) {
          return null;
        }
        return domain.slice(sldOffset + 1);
      },
      noConflict: function noConflict() {
        if (root.SecondLevelDomains === this) {
          root.SecondLevelDomains = _SecondLevelDomains;
        }
        return this;
      }
    };
    return SLD;
  });

  /***/
}, /* 189 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_RESULT__; /* WEBPACK VAR INJECTION */
  (function (process, global) {
    /**
    * [js-md5]{@link https://github.com/emn178/js-md5}
    *
    * @namespace md5
    * @version 0.4.2
    * @author Chen, Yi-Cyuan [emn178@gmail.com]
    * @copyright Chen, Yi-Cyuan 2014-2017
    * @license MIT
    */
    (function () {
      'use strict';

      var root = typeof window === 'object' ? window : {};
      var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
      if (NODE_JS) {
        root = global;
      }
      var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && typeof module === 'object' && module.exports;
      var AMD = "function" === 'function' && __webpack_require__(190);
      var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
      var HEX_CHARS = '0123456789abcdef'.split('');
      var EXTRA = [128, 32768, 8388608, -2147483648];
      var SHIFT = [0, 8, 16, 24];
      var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer'];
      var blocks = [],
        buffer8;
      if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        buffer8 = new Uint8Array(buffer);
        blocks = new Uint32Array(buffer);
      }

      /**
       * @method hex
       * @memberof md5
       * @description Output hash as hex string
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {String} Hex string
       * @example
       * md5.hex('The quick brown fox jumps over the lazy dog');
       * // equal to
       * md5('The quick brown fox jumps over the lazy dog');
       */
      /**
       * @method digest
       * @memberof md5
       * @description Output hash as bytes array
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Array} Bytes array
       * @example
       * md5.digest('The quick brown fox jumps over the lazy dog');
       */
      /**
       * @method array
       * @memberof md5
       * @description Output hash as bytes array
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Array} Bytes array
       * @example
       * md5.array('The quick brown fox jumps over the lazy dog');
       */
      /**
       * @method arrayBuffer
       * @memberof md5
       * @description Output hash as ArrayBuffer
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {ArrayBuffer} ArrayBuffer
       * @example
       * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
       */
      /**
       * @method buffer
       * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
       * @memberof md5
       * @description Output hash as ArrayBuffer
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {ArrayBuffer} ArrayBuffer
       * @example
       * md5.buffer('The quick brown fox jumps over the lazy dog');
       */
      var createOutputMethod = function createOutputMethod(outputType) {
        return function (message) {
          return new Md5(true).update(message)[outputType]();
        };
      };

      /**
       * @method create
       * @memberof md5
       * @description Create Md5 object
       * @returns {Md5} Md5 object.
       * @example
       * var hash = md5.create();
       */
      /**
       * @method update
       * @memberof md5
       * @description Create and update Md5 object
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Md5} Md5 object.
       * @example
       * var hash = md5.update('The quick brown fox jumps over the lazy dog');
       * // equal to
       * var hash = md5.create();
       * hash.update('The quick brown fox jumps over the lazy dog');
       */
      var createMethod = function createMethod() {
        var method = createOutputMethod('hex');
        if (NODE_JS) {
          method = nodeWrap(method);
        }
        method.create = function () {
          return new Md5();
        };
        method.update = function (message) {
          return method.create().update(message);
        };
        for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
          var type = OUTPUT_TYPES[i];
          method[type] = createOutputMethod(type);
        }
        return method;
      };
      var nodeWrap = function nodeWrap(method) {
        var crypto = __webpack_require__(191);
        var Buffer = __webpack_require__(192).Buffer;
        var nodeMethod = function nodeMethod(message) {
          if (typeof message === 'string') {
            return crypto.createHash('md5').update(message, 'utf8').digest('hex');
          } else if (message.constructor === ArrayBuffer) {
            message = new Uint8Array(message);
          } else if (message.length === undefined) {
            return method(message);
          }
          return crypto.createHash('md5').update(new Buffer(message)).digest('hex');
        };
        return nodeMethod;
      };

      /**
       * Md5 class
       * @class Md5
       * @description This is internal class.
       * @see {@link md5.create}
       */
      function Md5(sharedMemory) {
        if (sharedMemory) {
          blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
          this.blocks = blocks;
          this.buffer8 = buffer8;
        } else {
          if (ARRAY_BUFFER) {
            var buffer = new ArrayBuffer(68);
            this.buffer8 = new Uint8Array(buffer);
            this.blocks = new Uint32Array(buffer);
          } else {
            this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          }
        }
        this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
      }

      /**
       * @method update
       * @memberof Md5
       * @instance
       * @description Update hash
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Md5} Md5 object.
       * @see {@link md5.update}
       */
      Md5.prototype.update = function (message) {
        if (this.finalized) {
          return;
        }
        var notString = typeof message != 'string';
        if (notString && message.constructor == root.ArrayBuffer) {
          message = new Uint8Array(message);
        }
        var code,
          index = 0,
          i,
          length = message.length || 0,
          blocks = this.blocks;
        var buffer8 = this.buffer8;
        while (index < length) {
          if (this.hashed) {
            this.hashed = false;
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
          }
          if (notString) {
            if (ARRAY_BUFFER) {
              for (i = this.start; index < length && i < 64; ++index) {
                buffer8[i++] = message[index];
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
              }
            }
          } else {
            if (ARRAY_BUFFER) {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                  buffer8[i++] = code;
                } else if (code < 0x800) {
                  buffer8[i++] = 0xc0 | code >> 6;
                  buffer8[i++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                  buffer8[i++] = 0xe0 | code >> 12;
                  buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                  buffer8[i++] = 0x80 | code & 0x3f;
                } else {
                  code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                  buffer8[i++] = 0xf0 | code >> 18;
                  buffer8[i++] = 0x80 | code >> 12 & 0x3f;
                  buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                  buffer8[i++] = 0x80 | code & 0x3f;
                }
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                  blocks[i >> 2] |= code << SHIFT[i++ & 3];
                } else if (code < 0x800) {
                  blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                  blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                  code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                  blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
              }
            }
          }
          this.lastByteIndex = i;
          this.bytes += i - this.start;
          if (i >= 64) {
            this.start = i - 64;
            this.hash();
            this.hashed = true;
          } else {
            this.start = i;
          }
        }
        return this;
      };
      Md5.prototype.finalize = function () {
        if (this.finalized) {
          return;
        }
        this.finalized = true;
        var blocks = this.blocks,
          i = this.lastByteIndex;
        blocks[i >> 2] |= EXTRA[i & 3];
        if (i >= 56) {
          if (!this.hashed) {
            this.hash();
          }
          blocks[0] = blocks[16];
          blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.bytes << 3;
        this.hash();
      };
      Md5.prototype.hash = function () {
        var a,
          b,
          c,
          d,
          bc,
          da,
          blocks = this.blocks;
        if (this.first) {
          a = blocks[0] - 680876937;
          a = (a << 7 | a >>> 25) - 271733879 << 0;
          d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
          d = (d << 12 | d >>> 20) + a << 0;
          c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
          c = (c << 17 | c >>> 15) + d << 0;
          b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
          b = (b << 22 | b >>> 10) + c << 0;
        } else {
          a = this.h0;
          b = this.h1;
          c = this.h2;
          d = this.h3;
          a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
          a = (a << 7 | a >>> 25) + b << 0;
          d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
          d = (d << 12 | d >>> 20) + a << 0;
          c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
          c = (c << 17 | c >>> 15) + d << 0;
          b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
          b = (b << 22 | b >>> 10) + c << 0;
        }
        a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;
        if (this.first) {
          this.h0 = a + 1732584193 << 0;
          this.h1 = b - 271733879 << 0;
          this.h2 = c - 1732584194 << 0;
          this.h3 = d + 271733878 << 0;
          this.first = false;
        } else {
          this.h0 = this.h0 + a << 0;
          this.h1 = this.h1 + b << 0;
          this.h2 = this.h2 + c << 0;
          this.h3 = this.h3 + d << 0;
        }
      };

      /**
       * @method hex
       * @memberof Md5
       * @instance
       * @description Output hash as hex string
       * @returns {String} Hex string
       * @see {@link md5.hex}
       * @example
       * hash.hex();
       */
      Md5.prototype.hex = function () {
        this.finalize();
        var h0 = this.h0,
          h1 = this.h1,
          h2 = this.h2,
          h3 = this.h3;
        return HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F];
      };

      /**
       * @method toString
       * @memberof Md5
       * @instance
       * @description Output hash as hex string
       * @returns {String} Hex string
       * @see {@link md5.hex}
       * @example
       * hash.toString();
       */
      Md5.prototype.toString = Md5.prototype.hex;

      /**
       * @method digest
       * @memberof Md5
       * @instance
       * @description Output hash as bytes array
       * @returns {Array} Bytes array
       * @see {@link md5.digest}
       * @example
       * hash.digest();
       */
      Md5.prototype.digest = function () {
        this.finalize();
        var h0 = this.h0,
          h1 = this.h1,
          h2 = this.h2,
          h3 = this.h3;
        return [h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >> 24 & 0xFF];
      };

      /**
       * @method array
       * @memberof Md5
       * @instance
       * @description Output hash as bytes array
       * @returns {Array} Bytes array
       * @see {@link md5.array}
       * @example
       * hash.array();
       */
      Md5.prototype.array = Md5.prototype.digest;

      /**
       * @method arrayBuffer
       * @memberof Md5
       * @instance
       * @description Output hash as ArrayBuffer
       * @returns {ArrayBuffer} ArrayBuffer
       * @see {@link md5.arrayBuffer}
       * @example
       * hash.arrayBuffer();
       */
      Md5.prototype.arrayBuffer = function () {
        this.finalize();
        var buffer = new ArrayBuffer(16);
        var blocks = new Uint32Array(buffer);
        blocks[0] = this.h0;
        blocks[1] = this.h1;
        blocks[2] = this.h2;
        blocks[3] = this.h3;
        return buffer;
      };

      /**
       * @method buffer
       * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
       * @memberof Md5
       * @instance
       * @description Output hash as ArrayBuffer
       * @returns {ArrayBuffer} ArrayBuffer
       * @see {@link md5.buffer}
       * @example
       * hash.buffer();
       */
      Md5.prototype.buffer = Md5.prototype.arrayBuffer;
      var exports = createMethod();
      if (COMMON_JS) {
        module.exports = exports;
      } else {
        /**
         * @method md5
         * @description Md5 hash function, export to global in browsers.
         * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
         * @returns {String} md5 hashes
         * @example
         * md5(''); // d41d8cd98f00b204e9800998ecf8427e
         * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
         * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
         *
         * // It also supports UTF-8 encoding
         * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
         *
         * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
         * md5([]); // d41d8cd98f00b204e9800998ecf8427e
         * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
         */
        root.md5 = exports;
        if (AMD) {
          !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return exports;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }
      }
    })();

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2), function () {
    return this;
  }());

  /***/
}, /* 190 */
/***/function (module, exports) {
  /* WEBPACK VAR INJECTION */(function (__webpack_amd_options__) {
    module.exports = __webpack_amd_options__;

    /* WEBPACK VAR INJECTION */
  }).call(exports, {});

  /***/
}, /* 191 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var rng = __webpack_require__(196);
    function error() {
      var m = [].slice.call(arguments).join(' ');
      throw new Error([m, 'we accept pull requests', 'http://github.com/dominictarr/crypto-browserify'].join('\n'));
    }
    exports.createHash = __webpack_require__(198);
    exports.createHmac = __webpack_require__(210);
    exports.randomBytes = function (size, callback) {
      if (callback && callback.call) {
        try {
          callback.call(this, undefined, new Buffer(rng(size)));
        } catch (err) {
          callback(err);
        }
      } else {
        return new Buffer(rng(size));
      }
    };
    function each(a, f) {
      for (var i in a) f(a[i], i);
    }
    exports.getHashes = function () {
      return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160'];
    };
    var p = __webpack_require__(211)(exports);
    exports.pbkdf2 = p.pbkdf2;
    exports.pbkdf2Sync = p.pbkdf2Sync;
    __webpack_require__(213)(exports, module.exports);

    // the least I can do is make error messages for the rest of the node.js/crypto api.
    each(['createCredentials', 'createSign', 'createVerify', 'createDiffieHellman'], function (name) {
      exports[name] = function () {
        error('sorry,', name, 'is not implemented yet');
      };
    });

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 192 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /*!
    * The buffer module from node.js, for the browser.
    *
    * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    * @license  MIT
    */
    /* eslint-disable no-proto */

    'use strict';

    var base64 = __webpack_require__(193);
    var ieee754 = __webpack_require__(194);
    var isArray = __webpack_require__(195);
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;

    /**
     * If `Buffer.TYPED_ARRAY_SUPPORT`:
     *   === true    Use Uint8Array implementation (fastest)
     *   === false   Use Object implementation (most compatible, even IE6)
     *
     * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
     * Opera 11.6+, iOS 4.2+.
     *
     * Due to various browser bugs, sometimes the Object implementation will be used even
     * when the browser supports typed arrays.
     *
     * Note:
     *
     *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
     *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
     *
     *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
     *
     *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
     *     incorrect length in some situations.
    
     * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
     * get the Object implementation, which is slower but behaves correctly.
     */
    Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

    /*
     * Export kMaxLength after typed array support is determined.
     */
    exports.kMaxLength = kMaxLength();
    function typedArraySupport() {
      try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        };
        return arr.foo() === 42 &&
        // typed array instances can be augmented
        typeof arr.subarray === 'function' &&
        // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
      } catch (e) {
        return false;
      }
    }
    function kMaxLength() {
      return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
    }
    function createBuffer(that, length) {
      if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length');
      }
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) {
          that = new Buffer(length);
        }
        that.length = length;
      }
      return that;
    }

    /**
     * The Buffer constructor returns instances of `Uint8Array` that have their
     * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
     * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
     * and the `Uint8Array` methods. Square bracket notation works as expected -- it
     * returns a single octet.
     *
     * The `Uint8Array` prototype remains unmodified.
     */

    function Buffer(arg, encodingOrOffset, length) {
      if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
        return new Buffer(arg, encodingOrOffset, length);
      }

      // Common case.
      if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
          throw new Error('If encoding is specified then the first argument must be a string');
        }
        return allocUnsafe(this, arg);
      }
      return from(this, arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation

    // TODO: Legacy, not needed anymore. Remove in next major version.
    Buffer._augment = function (arr) {
      arr.__proto__ = Buffer.prototype;
      return arr;
    };
    function from(that, value, encodingOrOffset, length) {
      if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number');
      }
      if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length);
      }
      if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset);
      }
      return fromObject(that, value);
    }

    /**
     * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
     * if value is a number.
     * Buffer.from(str[, encoding])
     * Buffer.from(array)
     * Buffer.from(buffer)
     * Buffer.from(arrayBuffer[, byteOffset[, length]])
     **/
    Buffer.from = function (value, encodingOrOffset, length) {
      return from(null, value, encodingOrOffset, length);
    };
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      Buffer.prototype.__proto__ = Uint8Array.prototype;
      Buffer.__proto__ = Uint8Array;
      if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
        // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
        Object.defineProperty(Buffer, Symbol.species, {
          value: null,
          configurable: true
        });
      }
    }
    function assertSize(size) {
      if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number');
      } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative');
      }
    }
    function alloc(that, size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(that, size);
      }
      if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
      }
      return createBuffer(that, size);
    }

    /**
     * Creates a new filled Buffer instance.
     * alloc(size[, fill[, encoding]])
     **/
    Buffer.alloc = function (size, fill, encoding) {
      return alloc(null, size, fill, encoding);
    };
    function allocUnsafe(that, size) {
      assertSize(size);
      that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
      if (!Buffer.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
          that[i] = 0;
        }
      }
      return that;
    }

    /**
     * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
     * */
    Buffer.allocUnsafe = function (size) {
      return allocUnsafe(null, size);
    };
    /**
     * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
     */
    Buffer.allocUnsafeSlow = function (size) {
      return allocUnsafe(null, size);
    };
    function fromString(that, string, encoding) {
      if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
      }
      if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding');
      }
      var length = byteLength(string, encoding) | 0;
      that = createBuffer(that, length);
      var actual = that.write(string, encoding);
      if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
      }
      return that;
    }
    function fromArrayLike(that, array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0;
      that = createBuffer(that, length);
      for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
      }
      return that;
    }
    function fromArrayBuffer(that, array, byteOffset, length) {
      array.byteLength; // this throws if `array` is not a valid ArrayBuffer

      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds');
      }
      if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
      } else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
      } else {
        array = new Uint8Array(array, byteOffset, length);
      }
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
      }
      return that;
    }
    function fromObject(that, obj) {
      if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) {
          return that;
        }
        obj.copy(that, 0, 0, len);
        return that;
      }
      if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
          if (typeof obj.length !== 'number' || isnan(obj.length)) {
            return createBuffer(that, 0);
          }
          return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) {
          return fromArrayLike(that, obj.data);
        }
      }
      throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
    }
    function checked(length) {
      // Note: cannot use `length < kMaxLength()` here because that fails when
      // length is NaN (which is otherwise coerced to zero.)
      if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        // eslint-disable-line eqeqeq
        length = 0;
      }
      return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
      return !!(b != null && b._isBuffer);
    };
    Buffer.compare = function compare(a, b) {
      if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
        throw new TypeError('Arguments must be Buffers');
      }
      if (a === b) return 0;
      var x = a.length;
      var y = b.length;
      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return true;
        default:
          return false;
      }
    };
    Buffer.concat = function concat(list, length) {
      if (!isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer.alloc(0);
      }
      var i;
      if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }
      var buffer = Buffer.allocUnsafe(length);
      var pos = 0;
      for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }
        buf.copy(buffer, pos);
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string, encoding) {
      if (Buffer.isBuffer(string)) {
        return string.length;
      }
      if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength;
      }
      if (typeof string !== 'string') {
        string = '' + string;
      }
      var len = string.length;
      if (len === 0) return 0;

      // Use a for loop to avoid recursion
      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return len;
          case 'utf8':
          case 'utf-8':
          case undefined:
            return utf8ToBytes(string).length;
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return len * 2;
          case 'hex':
            return len >>> 1;
          case 'base64':
            return base64ToBytes(string).length;
          default:
            if (loweredCase) return utf8ToBytes(string).length; // assume utf8
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      var loweredCase = false;

      // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
      // property of a typed array.

      // This behaves neither like String nor Uint8Array in that we set start/end
      // to their upper/lower bounds if the value passed is out of range.
      // undefined is handled specially as per ECMA-262 6th Edition,
      // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
      if (start === undefined || start < 0) {
        start = 0;
      }
      // Return early if start > this.length. Done here to prevent potential uint32
      // coercion fail below.
      if (start > this.length) {
        return '';
      }
      if (end === undefined || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return '';
      }

      // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return '';
      }
      if (!encoding) encoding = 'utf8';
      while (true) {
        switch (encoding) {
          case 'hex':
            return hexSlice(this, start, end);
          case 'utf8':
          case 'utf-8':
            return utf8Slice(this, start, end);
          case 'ascii':
            return asciiSlice(this, start, end);
          case 'latin1':
          case 'binary':
            return latin1Slice(this, start, end);
          case 'base64':
            return base64Slice(this, start, end);
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
      }
    }

    // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    // Buffer instances.
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
      var i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
      var len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits');
      }
      for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer.prototype.swap32 = function swap32() {
      var len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits');
      }
      for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer.prototype.swap64 = function swap64() {
      var len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits');
      }
      for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer.prototype.toString = function toString() {
      var length = this.length | 0;
      if (length === 0) return '';
      if (arguments.length === 0) return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer.prototype.equals = function equals(b) {
      if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
      if (this === b) return true;
      return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
      var str = '';
      var max = exports.INSPECT_MAX_BYTES;
      if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
      }
      return '<Buffer ' + str + '>';
    };
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (!Buffer.isBuffer(target)) {
        throw new TypeError('Argument must be a Buffer');
      }
      if (start === undefined) {
        start = 0;
      }
      if (end === undefined) {
        end = target ? target.length : 0;
      }
      if (thisStart === undefined) {
        thisStart = 0;
      }
      if (thisEnd === undefined) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index');
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target) return 0;
      var x = thisEnd - thisStart;
      var y = end - start;
      var len = Math.min(x, y);
      var thisCopy = this.slice(thisStart, thisEnd);
      var targetCopy = target.slice(start, end);
      for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };

    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      // Empty buffer means no match
      if (buffer.length === 0) return -1;

      // Normalize byteOffset
      if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff;
      } else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000;
      }
      byteOffset = +byteOffset; // Coerce to Number.
      if (isNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
      }

      // Normalize byteOffset: negative offsets start from the end of the buffer
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir) return -1;else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;else return -1;
      }

      // Normalize val
      if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
      }

      // Finally, search either indexOf (if dir is true) or lastIndexOf
      if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      var indexSize = 1;
      var arrLength = arr.length;
      var valLength = val.length;
      if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i) {
        if (indexSize === 1) {
          return buf[i];
        } else {
          return buf.readUInt16BE(i * indexSize);
        }
      }
      var i;
      if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          var found = true;
          for (var j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found) return i;
        }
      }
      return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
      offset = Number(offset) || 0;
      var remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }

      // must be an even number of digits
      var strLen = string.length;
      if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function latin1Write(buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length);
    }
    function base64Write(buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
      // Buffer#write(string)
      if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
        // Buffer#write(string, encoding)
      } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
      } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
          length = length | 0;
          if (encoding === undefined) encoding = 'utf8';
        } else {
          encoding = length;
          length = undefined;
        }
        // legacy write(string, encoding, offset, length) - remove in v0.13
      } else {
        throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
      }
      var remaining = this.length - offset;
      if (length === undefined || length > remaining) length = remaining;
      if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds');
      }
      if (!encoding) encoding = 'utf8';
      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'hex':
            return hexWrite(this, string, offset, length);
          case 'utf8':
          case 'utf-8':
            return utf8Write(this, string, offset, length);
          case 'ascii':
            return asciiWrite(this, string, offset, length);
          case 'latin1':
          case 'binary':
            return latin1Write(this, string, offset, length);
          case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return ucs2Write(this, string, offset, length);
          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer.prototype.toJSON = function toJSON() {
      return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      var res = [];
      var i = start;
      while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 0x80) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                if (tempCodePoint > 0x7F) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          // we did not generate a valid codePoint so insert a
          // replacement char (U+FFFD) and advance only 1 byte
          codePoint = 0xFFFD;
          bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
          // encode to utf16 (surrogate pair dance)
          codePoint -= 0x10000;
          res.push(codePoint >>> 10 & 0x3FF | 0xD800);
          codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }

    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
      var len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
      }

      // Decode in chunks to avoid "call stack size exceeded".
      var res = '';
      var i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);
      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);
      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      var len = buf.length;
      if (!start || start < 0) start = 0;
      if (!end || end < 0 || end > len) end = len;
      var out = '';
      for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      var bytes = buf.slice(start, end);
      var res = '';
      for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
      var len = this.length;
      start = ~~start;
      end = end === undefined ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0) start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0) end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start) end = start;
      var newBuf;
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
      } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for (var i = 0; i < sliceLen; ++i) {
          newBuf[i] = this[i + start];
        }
      }
      return newBuf;
    };

    /*
     * Need to make sure that buffer isn't trying to write out of bounds.
     */
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
      if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
      }
      var val = this[offset + --byteLength];
      var mul = 1;
      while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul;
      }
      return val;
    };
    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }
      mul *= 0x80;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength);
      return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);
      var i = byteLength;
      var mul = 1;
      var val = this[offset + --i];
      while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul;
      }
      mul *= 0x80;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength);
      return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      if (!(this[offset] & 0x80)) return this[offset];
      return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset] | this[offset + 1] << 8;
      return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset + 1] | this[offset] << 8;
      return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }
      var mul = 1;
      var i = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = value / mul & 0xFF;
      }
      return offset + byteLength;
    };
    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }
      var i = byteLength - 1;
      var mul = 1;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = value / mul & 0xFF;
      }
      return offset + byteLength;
    };
    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      this[offset] = value & 0xff;
      return offset + 1;
    };
    function objectWriteUInt16(buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
      }
    }
    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2;
    };
    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2;
    };
    function objectWriteUInt32(buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffffffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
      }
    }
    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4;
    };
    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }
      var i = 0;
      var mul = 1;
      var sub = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
      }
      return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }
      var i = byteLength - 1;
      var mul = 1;
      var sub = 0;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
      }
      return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      if (value < 0) value = 0xff + value + 1;
      this[offset] = value & 0xff;
      return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (value < 0) value = 0xffffffff + value + 1;
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length) throw new RangeError('Index out of range');
      if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };

    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
      if (!start) start = 0;
      if (!end && end !== 0) end = this.length;
      if (targetStart >= target.length) targetStart = target.length;
      if (!targetStart) targetStart = 0;
      if (end > 0 && end < start) end = start;

      // Copy 0 bytes; we're done
      if (end === start) return 0;
      if (target.length === 0 || this.length === 0) return 0;

      // Fatal error conditions
      if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds');
      }
      if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
      if (end < 0) throw new RangeError('sourceEnd out of bounds');

      // Are we oob?
      if (end > this.length) end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      var len = end - start;
      var i;
      if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (i = len - 1; i >= 0; --i) {
          target[i + targetStart] = this[i + start];
        }
      } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
        // ascending copy from start
        for (i = 0; i < len; ++i) {
          target[i + targetStart] = this[i + start];
        }
      } else {
        Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
      }
      return len;
    };

    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
      // Handle string cases:
      if (typeof val === 'string') {
        if (typeof start === 'string') {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === 'string') {
          encoding = end;
          end = this.length;
        }
        if (val.length === 1) {
          var code = val.charCodeAt(0);
          if (code < 256) {
            val = code;
          }
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
          throw new TypeError('encoding must be a string');
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
          throw new TypeError('Unknown encoding: ' + encoding);
        }
      } else if (typeof val === 'number') {
        val = val & 255;
      }

      // Invalid ranges are not set to a default, so can range check early.
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index');
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === undefined ? this.length : end >>> 0;
      if (!val) val = 0;
      var i;
      if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };

    // HELPER FUNCTIONS
    // ================

    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
    function base64clean(str) {
      // Node strips out invalid characters like \n and \t from the string, base64-js does not
      str = stringtrim(str).replace(INVALID_BASE64_RE, '');
      // Node converts strings with length < 2 to ''
      if (str.length < 2) return '';
      // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
      while (str.length % 4 !== 0) {
        str = str + '=';
      }
      return str;
    }
    function stringtrim(str) {
      if (str.trim) return str.trim();
      return str.replace(/^\s+|\s+$/g, '');
    }
    function toHex(n) {
      if (n < 16) return '0' + n.toString(16);
      return n.toString(16);
    }
    function utf8ToBytes(string, units) {
      units = units || Infinity;
      var codePoint;
      var length = string.length;
      var leadSurrogate = null;
      var bytes = [];
      for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);

        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
          // last char was a lead
          if (!leadSurrogate) {
            // no lead yet
            if (codePoint > 0xDBFF) {
              // unexpected trail
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue;
            } else if (i + 1 === length) {
              // unpaired lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue;
            }

            // valid lead
            leadSurrogate = codePoint;
            continue;
          }

          // 2 leads in a row
          if (codePoint < 0xDC00) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            leadSurrogate = codePoint;
            continue;
          }

          // valid surrogate pair
          codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) {
          // valid bmp char, but last char was a lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;

        // encode utf8
        if (codePoint < 0x80) {
          if ((units -= 1) < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 0x800) {
          if ((units -= 2) < 0) break;
          bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
          if ((units -= 3) < 0) break;
          bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
          if ((units -= 4) < 0) break;
          bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else {
          throw new Error('Invalid code point');
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      var c, hi, lo;
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      for (var i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isnan(val) {
      return val !== val; // eslint-disable-line no-self-compare
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }());

  /***/
}, /* 193 */
/***/function (module, exports) {
  'use strict';

  exports.byteLength = byteLength;
  exports.toByteArray = toByteArray;
  exports.fromByteArray = fromByteArray;
  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  // Support decoding URL-safe base64 strings, as Node.js does.
  // See: https://en.wikipedia.org/wiki/Base64#URL_applications
  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
  function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4');
    }

    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [validLen, placeHoldersLen];
  }

  // base64 is 4/3 + up to two characters of the original data
  function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }
  function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }
  function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;

    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for (var i = 0; i < len; i += 4) {
      tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
      arr[curByte++] = tmp >> 16 & 0xFF;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
      tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
      arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
      tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
      arr[curByte++] = tmp >> 8 & 0xFF;
      arr[curByte++] = tmp & 0xFF;
    }
    return arr;
  }
  function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
  }
  function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
      output.push(tripletToBase64(tmp));
    }
    return output.join('');
  }
  function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3

    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    }

    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1];
      parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
  }

  /***/
}, /* 194 */
/***/function (module, exports) {
  exports.read = function (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  };
  exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }
      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }
    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
    e = e << mLen | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
    buffer[offset + i - d] |= s * 128;
  };

  /***/
}, /* 195 */
/***/function (module, exports) {
  var toString = {}.toString;
  module.exports = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };

  /***/
}, /* 196 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, Buffer) {
    (function () {
      var g = ('undefined' === typeof window ? global : window) || {};
      _crypto = g.crypto || g.msCrypto || __webpack_require__(197);
      module.exports = function (size) {
        // Modern Browsers
        if (_crypto.getRandomValues) {
          var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
          /* This will not work in older browsers.
           * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
           */

          _crypto.getRandomValues(bytes);
          return bytes;
        } else if (_crypto.randomBytes) {
          return _crypto.randomBytes(size);
        } else throw new Error('secure random number generation not supported by this browser\n' + 'use chrome, FireFox or Internet Explorer 11');
      };
    })();

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(192).Buffer);

  /***/
}, /* 197 */
/***/function (module, exports) {

  /* (ignored) */

  /***/}, /* 198 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var createHash = __webpack_require__(199);
    var md5 = toConstructor(__webpack_require__(207));
    var rmd160 = toConstructor(__webpack_require__(209));
    function toConstructor(fn) {
      return function () {
        var buffers = [];
        var m = {
          update: function update(data, enc) {
            if (!Buffer.isBuffer(data)) data = new Buffer(data, enc);
            buffers.push(data);
            return this;
          },
          digest: function digest(enc) {
            var buf = Buffer.concat(buffers);
            var r = fn(buf);
            buffers = null;
            return enc ? r.toString(enc) : r;
          }
        };
        return m;
      };
    }
    module.exports = function (alg) {
      if ('md5' === alg) return new md5();
      if ('rmd160' === alg) return new rmd160();
      return createHash(alg);
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 199 */
/***/function (module, exports, __webpack_require__) {
  var exports = module.exports = function (alg) {
    var Alg = exports[alg];
    if (!Alg) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Alg();
  };
  var Buffer = __webpack_require__(192).Buffer;
  var Hash = __webpack_require__(200)(Buffer);
  exports.sha1 = __webpack_require__(201)(Buffer, Hash);
  exports.sha256 = __webpack_require__(205)(Buffer, Hash);
  exports.sha512 = __webpack_require__(206)(Buffer, Hash);

  /***/
}, /* 200 */
/***/function (module, exports) {
  module.exports = function (Buffer) {
    //prototype class for hash functions
    function Hash(blockSize, finalSize) {
      this._block = new Buffer(blockSize); //new Uint32Array(blockSize/4)
      this._finalSize = finalSize;
      this._blockSize = blockSize;
      this._len = 0;
      this._s = 0;
    }
    Hash.prototype.init = function () {
      this._s = 0;
      this._len = 0;
    };
    Hash.prototype.update = function (data, enc) {
      if ("string" === typeof data) {
        enc = enc || "utf8";
        data = new Buffer(data, enc);
      }
      var l = this._len += data.length;
      var s = this._s = this._s || 0;
      var f = 0;
      var buffer = this._block;
      while (s < l) {
        var t = Math.min(data.length, f + this._blockSize - s % this._blockSize);
        var ch = t - f;
        for (var i = 0; i < ch; i++) {
          buffer[s % this._blockSize + i] = data[i + f];
        }
        s += ch;
        f += ch;
        if (s % this._blockSize === 0) {
          this._update(buffer);
        }
      }
      this._s = s;
      return this;
    };
    Hash.prototype.digest = function (enc) {
      // Suppose the length of the message M, in bits, is l
      var l = this._len * 8;

      // Append the bit 1 to the end of the message
      this._block[this._len % this._blockSize] = 0x80;

      // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
      this._block.fill(0, this._len % this._blockSize + 1);
      if (l % (this._blockSize * 8) >= this._finalSize * 8) {
        this._update(this._block);
        this._block.fill(0);
      }

      // to this append the block which is equal to the number l written in binary
      // TODO: handle case where l is > Math.pow(2, 29)
      this._block.writeInt32BE(l, this._blockSize - 4);
      var hash = this._update(this._block) || this._hash();
      return enc ? hash.toString(enc) : hash;
    };
    Hash.prototype._update = function () {
      throw new Error('_update must be implemented by subclass');
    };
    return Hash;
  };

  /***/
}, /* 201 */
/***/function (module, exports, __webpack_require__) {
  /*
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
   * in FIPS PUB 180-1
   * Version 2.1a Copyright Paul Johnston 2000 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for details.
   */

  var inherits = __webpack_require__(202).inherits;
  module.exports = function (Buffer, Hash) {
    var A = 0 | 0;
    var B = 4 | 0;
    var C = 8 | 0;
    var D = 12 | 0;
    var E = 16 | 0;
    var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80);
    var POOL = [];
    function Sha1() {
      if (POOL.length) return POOL.pop().init();
      if (!(this instanceof Sha1)) return new Sha1();
      this._w = W;
      Hash.call(this, 16 * 4, 14 * 4);
      this._h = null;
      this.init();
    }
    inherits(Sha1, Hash);
    Sha1.prototype.init = function () {
      this._a = 0x67452301;
      this._b = 0xefcdab89;
      this._c = 0x98badcfe;
      this._d = 0x10325476;
      this._e = 0xc3d2e1f0;
      Hash.prototype.init.call(this);
      return this;
    };
    Sha1.prototype._POOL = POOL;
    Sha1.prototype._update = function (X) {
      var a, b, c, d, e, _a, _b, _c, _d, _e;
      a = _a = this._a;
      b = _b = this._b;
      c = _c = this._c;
      d = _d = this._d;
      e = _e = this._e;
      var w = this._w;
      for (var j = 0; j < 80; j++) {
        var W = w[j] = j < 16 ? X.readInt32BE(j * 4) : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
        var t = add(add(rol(a, 5), sha1_ft(j, b, c, d)), add(add(e, W), sha1_kt(j)));
        e = d;
        d = c;
        c = rol(b, 30);
        b = a;
        a = t;
      }
      this._a = add(a, _a);
      this._b = add(b, _b);
      this._c = add(c, _c);
      this._d = add(d, _d);
      this._e = add(e, _e);
    };
    Sha1.prototype._hash = function () {
      if (POOL.length < 100) POOL.push(this);
      var H = new Buffer(20);
      //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
      H.writeInt32BE(this._a | 0, A);
      H.writeInt32BE(this._b | 0, B);
      H.writeInt32BE(this._c | 0, C);
      H.writeInt32BE(this._d | 0, D);
      H.writeInt32BE(this._e | 0, E);
      return H;
    };

    /*
     * Perform the appropriate triplet combination function for the current
     * iteration
     */
    function sha1_ft(t, b, c, d) {
      if (t < 20) return b & c | ~b & d;
      if (t < 40) return b ^ c ^ d;
      if (t < 60) return b & c | b & d | c & d;
      return b ^ c ^ d;
    }

    /*
     * Determine the appropriate additive constant for the current iteration
     */
    function sha1_kt(t) {
      return t < 20 ? 1518500249 : t < 40 ? 1859775393 : t < 60 ? -1894007588 : -899497514;
    }

    /*
     * Add integers, wrapping at 2^32. This uses 16-bit operations internally
     * to work around bugs in some JS interpreters.
     * //dominictarr: this is 10 years old, so maybe this can be dropped?)
     *
     */
    function add(x, y) {
      return x + y | 0;
      //lets see how this goes on testling.
      //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
      //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      //  return (msw << 16) | (lsw & 0xFFFF);
    }

    /*
     * Bitwise rotate a 32-bit number to the left.
     */
    function rol(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }
    return Sha1;
  };

  /***/
}, /* 202 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
      var keys = Object.keys(obj);
      var descriptors = {};
      for (var i = 0; i < keys.length; i++) {
        descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
      }
      return descriptors;
    };
    var formatRegExp = /%[sdj%]/g;
    exports.format = function (f) {
      if (!isString(f)) {
        var objects = [];
        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect(arguments[i]));
        }
        return objects.join(' ');
      }
      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function (x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch (x) {
          case '%s':
            return String(args[i++]);
          case '%d':
            return Number(args[i++]);
          case '%j':
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return '[Circular]';
            }
          default:
            return x;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject(x)) {
          str += ' ' + x;
        } else {
          str += ' ' + inspect(x);
        }
      }
      return str;
    };

    // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    exports.deprecate = function (fn, msg) {
      if (typeof process !== 'undefined' && process.noDeprecation === true) {
        return fn;
      }

      // Allow for deprecating things in the process of starting up.
      if (typeof process === 'undefined') {
        return function () {
          return exports.deprecate(fn, msg).apply(this, arguments);
        };
      }
      var warned = false;
      function deprecated() {
        if (!warned) {
          if (process.throwDeprecation) {
            throw new Error(msg);
          } else if (process.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }
      return deprecated;
    };
    var debugs = {};
    var debugEnviron;
    exports.debuglog = function (set) {
      if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
      set = set.toUpperCase();
      if (!debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
          var pid = process.pid;
          debugs[set] = function () {
            var msg = exports.format.apply(exports, arguments);
            console.error('%s %d: %s', set, pid, msg);
          };
        } else {
          debugs[set] = function () {};
        }
      }
      return debugs[set];
    };

    /**
     * Echos the value of a value. Trys to print the value out
     * in the best way possible given the different types.
     *
     * @param {Object} obj The object to print out.
     * @param {Object} opts Optional options object that alters the output.
     */
    /* legacy: obj, showHidden, depth, colors*/
    function inspect(obj, opts) {
      // default options
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      // legacy...
      if (arguments.length >= 3) ctx.depth = arguments[2];
      if (arguments.length >= 4) ctx.colors = arguments[3];
      if (isBoolean(opts)) {
        // legacy...
        ctx.showHidden = opts;
      } else if (opts) {
        // got an "options" object
        exports._extend(ctx, opts);
      }
      // set default options
      if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
      if (isUndefined(ctx.depth)) ctx.depth = 2;
      if (isUndefined(ctx.colors)) ctx.colors = false;
      if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
      if (ctx.colors) ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }
    exports.inspect = inspect;

    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect.colors = {
      'bold': [1, 22],
      'italic': [3, 23],
      'underline': [4, 24],
      'inverse': [7, 27],
      'white': [37, 39],
      'grey': [90, 39],
      'black': [30, 39],
      'blue': [34, 39],
      'cyan': [36, 39],
      'green': [32, 39],
      'magenta': [35, 39],
      'red': [31, 39],
      'yellow': [33, 39]
    };

    // Don't use 'blue' not visible on cmd.exe
    inspect.styles = {
      'special': 'cyan',
      'number': 'yellow',
      'boolean': 'yellow',
      'undefined': 'grey',
      'null': 'bold',
      'string': 'green',
      'date': 'magenta',
      // "name": intentionally not styling
      'regexp': 'red'
    };
    function stylizeWithColor(str, styleType) {
      var style = inspect.styles[styleType];
      if (style) {
        return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
      } else {
        return str;
      }
    }
    function stylizeNoColor(str, styleType) {
      return str;
    }
    function arrayToHash(array) {
      var hash = {};
      array.forEach(function (val, idx) {
        hash[val] = true;
      });
      return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
      // Provide a hook for user-specified inspect functions.
      // Check that value is an object with an inspect function on it
      if (ctx.customInspect && value && isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }

      // Primitive types cannot have properties
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }

      // Look up the keys of the object.
      var keys = Object.keys(value);
      var visibleKeys = arrayToHash(keys);
      if (ctx.showHidden) {
        keys = Object.getOwnPropertyNames(value);
      }

      // IE doesn't make error fields non-enumerable
      // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
      if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
        return formatError(value);
      }

      // Some type of object without properties can be shortcutted.
      if (keys.length === 0) {
        if (isFunction(value)) {
          var name = value.name ? ': ' + value.name : '';
          return ctx.stylize('[Function' + name + ']', 'special');
        }
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        }
        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), 'date');
        }
        if (isError(value)) {
          return formatError(value);
        }
      }
      var base = '',
        array = false,
        braces = ['{', '}'];

      // Make Array say that they are Array
      if (isArray(value)) {
        array = true;
        braces = ['[', ']'];
      }

      // Make functions say that they are functions
      if (isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
      }

      // Make RegExps say that they are RegExps
      if (isRegExp(value)) {
        base = ' ' + RegExp.prototype.toString.call(value);
      }

      // Make dates with properties first say the date
      if (isDate(value)) {
        base = ' ' + Date.prototype.toUTCString.call(value);
      }

      // Make error with message first say the error
      if (isError(value)) {
        base = ' ' + formatError(value);
      }
      if (keys.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }
      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        } else {
          return ctx.stylize('[Object]', 'special');
        }
      }
      ctx.seen.push(value);
      var output;
      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
      } else {
        output = keys.map(function (key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }
      ctx.seen.pop();
      return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
      if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
      if (isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
      }
      if (isNumber(value)) return ctx.stylize('' + value, 'number');
      if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
      // For some reason typeof null is "object", so special case here.
      if (isNull(value)) return ctx.stylize('null', 'null');
    }
    function formatError(value) {
      return '[' + Error.prototype.toString.call(value) + ']';
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        } else {
          output.push('');
        }
      }
      keys.forEach(function (key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        }
      });
      return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
      };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize('[Getter/Setter]', 'special');
        } else {
          str = ctx.stylize('[Getter]', 'special');
        }
      } else {
        if (desc.set) {
          str = ctx.stylize('[Setter]', 'special');
        }
      }
      if (!hasOwnProperty(visibleKeys, key)) {
        name = '[' + key + ']';
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf('\n') > -1) {
            if (array) {
              str = str.split('\n').map(function (line) {
                return '  ' + line;
              }).join('\n').substr(2);
            } else {
              str = '\n' + str.split('\n').map(function (line) {
                return '   ' + line;
              }).join('\n');
            }
          }
        } else {
          str = ctx.stylize('[Circular]', 'special');
        }
      }
      if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, 'name');
        } else {
          name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, 'string');
        }
      }
      return name + ': ' + str;
    }
    function reduceToSingleString(output, base, braces) {
      var numLinesEst = 0;
      var length = output.reduce(function (prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
      }, 0);
      if (length > 60) {
        return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
      }
      return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }

    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    function isArray(ar) {
      return Array.isArray(ar);
    }
    exports.isArray = isArray;
    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }
    exports.isBoolean = isBoolean;
    function isNull(arg) {
      return arg === null;
    }
    exports.isNull = isNull;
    function isNullOrUndefined(arg) {
      return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
      return typeof arg === 'number';
    }
    exports.isNumber = isNumber;
    function isString(arg) {
      return typeof arg === 'string';
    }
    exports.isString = isString;
    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }
    exports.isSymbol = isSymbol;
    function isUndefined(arg) {
      return arg === void 0;
    }
    exports.isUndefined = isUndefined;
    function isRegExp(re) {
      return isObject(re) && objectToString(re) === '[object RegExp]';
    }
    exports.isRegExp = isRegExp;
    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }
    exports.isObject = isObject;
    function isDate(d) {
      return isObject(d) && objectToString(d) === '[object Date]';
    }
    exports.isDate = isDate;
    function isError(e) {
      return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
    }
    exports.isError = isError;
    function isFunction(arg) {
      return typeof arg === 'function';
    }
    exports.isFunction = isFunction;
    function isPrimitive(arg) {
      return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' ||
      // ES6 symbol
      typeof arg === 'undefined';
    }
    exports.isPrimitive = isPrimitive;
    exports.isBuffer = __webpack_require__(203);
    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }
    function pad(n) {
      return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // 26 Feb 16:19:34
    function timestamp() {
      var d = new Date();
      var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
      return [d.getDate(), months[d.getMonth()], time].join(' ');
    }

    // log is just a thin wrapper to console.log that prepends a timestamp
    exports.log = function () {
      console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
    };

    /**
     * Inherit the prototype methods from one constructor into another.
     *
     * The Function.prototype.inherits from lang.js rewritten as a standalone
     * function (not on Function.prototype). NOTE: If this file is to be loaded
     * during bootstrapping this function needs to be rewritten using some native
     * functions as prototype setup using normal JavaScript does not work as
     * expected during bootstrapping (see mirror.js in r114903).
     *
     * @param {function} ctor Constructor function which needs to inherit the
     *     prototype.
     * @param {function} superCtor Constructor function to inherit prototype from.
     */
    exports.inherits = __webpack_require__(204);
    exports._extend = function (origin, add) {
      // Don't do anything if add isn't an object
      if (!add || !isObject(add)) return origin;
      var keys = Object.keys(add);
      var i = keys.length;
      while (i--) {
        origin[keys[i]] = add[keys[i]];
      }
      return origin;
    };
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
    exports.promisify = function promisify(original) {
      if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
      if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') {
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        }
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn,
          enumerable: false,
          writable: false,
          configurable: true
        });
        return fn;
      }
      function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function (resolve, reject) {
          promiseResolve = resolve;
          promiseReject = reject;
        });
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        args.push(function (err, value) {
          if (err) {
            promiseReject(err);
          } else {
            promiseResolve(value);
          }
        });
        try {
          original.apply(this, args);
        } catch (err) {
          promiseReject(err);
        }
        return promise;
      }
      Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
      if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
      });
      return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
    };
    exports.promisify.custom = kCustomPromisifiedSymbol;
    function callbackifyOnRejected(reason, cb) {
      // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
      // Because `null` is a special error value in callbacks which means "no error
      // occurred", we error-wrap so the callback consumer can distinguish between
      // "the promise rejected with null" or "the promise fulfilled with undefined".
      if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
      }
      return cb(reason);
    }
    function callbackify(original) {
      if (typeof original !== 'function') {
        throw new TypeError('The "original" argument must be of type Function');
      }

      // We DO NOT return the promise as it gives the user a false sense that
      // the promise is actually somehow related to the callback's execution
      // and that the callback throwing will reject the promise.
      function callbackified() {
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') {
          throw new TypeError('The last argument must be of type Function');
        }
        var self = this;
        var cb = function cb() {
          return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function (ret) {
          process.nextTick(cb, null, ret);
        }, function (rej) {
          process.nextTick(callbackifyOnRejected, rej, cb);
        });
      }
      Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
      Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
      return callbackified;
    }
    exports.callbackify = callbackify;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 203 */
/***/function (module, exports) {
  module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
  };

  /***/
}, /* 204 */
/***/function (module, exports) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function TempCtor() {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }

  /***/
}, /* 205 */
/***/function (module, exports, __webpack_require__) {
  /**
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
   * in FIPS 180-2
   * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   *
   */

  var inherits = __webpack_require__(202).inherits;
  module.exports = function (Buffer, Hash) {
    var K = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];
    var W = new Array(64);
    function Sha256() {
      this.init();
      this._w = W; //new Array(64)

      Hash.call(this, 16 * 4, 14 * 4);
    }
    inherits(Sha256, Hash);
    Sha256.prototype.init = function () {
      this._a = 0x6a09e667 | 0;
      this._b = 0xbb67ae85 | 0;
      this._c = 0x3c6ef372 | 0;
      this._d = 0xa54ff53a | 0;
      this._e = 0x510e527f | 0;
      this._f = 0x9b05688c | 0;
      this._g = 0x1f83d9ab | 0;
      this._h = 0x5be0cd19 | 0;
      this._len = this._s = 0;
      return this;
    };
    function S(X, n) {
      return X >>> n | X << 32 - n;
    }
    function R(X, n) {
      return X >>> n;
    }
    function Ch(x, y, z) {
      return x & y ^ ~x & z;
    }
    function Maj(x, y, z) {
      return x & y ^ x & z ^ y & z;
    }
    function Sigma0256(x) {
      return S(x, 2) ^ S(x, 13) ^ S(x, 22);
    }
    function Sigma1256(x) {
      return S(x, 6) ^ S(x, 11) ^ S(x, 25);
    }
    function Gamma0256(x) {
      return S(x, 7) ^ S(x, 18) ^ R(x, 3);
    }
    function Gamma1256(x) {
      return S(x, 17) ^ S(x, 19) ^ R(x, 10);
    }
    Sha256.prototype._update = function (M) {
      var W = this._w;
      var a, b, c, d, e, f, g, h;
      var T1, T2;
      a = this._a | 0;
      b = this._b | 0;
      c = this._c | 0;
      d = this._d | 0;
      e = this._e | 0;
      f = this._f | 0;
      g = this._g | 0;
      h = this._h | 0;
      for (var j = 0; j < 64; j++) {
        var w = W[j] = j < 16 ? M.readInt32BE(j * 4) : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16];
        T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w;
        T2 = Sigma0256(a) + Maj(a, b, c);
        h = g;
        g = f;
        f = e;
        e = d + T1;
        d = c;
        c = b;
        b = a;
        a = T1 + T2;
      }
      this._a = a + this._a | 0;
      this._b = b + this._b | 0;
      this._c = c + this._c | 0;
      this._d = d + this._d | 0;
      this._e = e + this._e | 0;
      this._f = f + this._f | 0;
      this._g = g + this._g | 0;
      this._h = h + this._h | 0;
    };
    Sha256.prototype._hash = function () {
      var H = new Buffer(32);
      H.writeInt32BE(this._a, 0);
      H.writeInt32BE(this._b, 4);
      H.writeInt32BE(this._c, 8);
      H.writeInt32BE(this._d, 12);
      H.writeInt32BE(this._e, 16);
      H.writeInt32BE(this._f, 20);
      H.writeInt32BE(this._g, 24);
      H.writeInt32BE(this._h, 28);
      return H;
    };
    return Sha256;
  };

  /***/
}, /* 206 */
/***/function (module, exports, __webpack_require__) {
  var inherits = __webpack_require__(202).inherits;
  module.exports = function (Buffer, Hash) {
    var K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
    var W = new Array(160);
    function Sha512() {
      this.init();
      this._w = W;
      Hash.call(this, 128, 112);
    }
    inherits(Sha512, Hash);
    Sha512.prototype.init = function () {
      this._a = 0x6a09e667 | 0;
      this._b = 0xbb67ae85 | 0;
      this._c = 0x3c6ef372 | 0;
      this._d = 0xa54ff53a | 0;
      this._e = 0x510e527f | 0;
      this._f = 0x9b05688c | 0;
      this._g = 0x1f83d9ab | 0;
      this._h = 0x5be0cd19 | 0;
      this._al = 0xf3bcc908 | 0;
      this._bl = 0x84caa73b | 0;
      this._cl = 0xfe94f82b | 0;
      this._dl = 0x5f1d36f1 | 0;
      this._el = 0xade682d1 | 0;
      this._fl = 0x2b3e6c1f | 0;
      this._gl = 0xfb41bd6b | 0;
      this._hl = 0x137e2179 | 0;
      this._len = this._s = 0;
      return this;
    };
    function S(X, Xl, n) {
      return X >>> n | Xl << 32 - n;
    }
    function Ch(x, y, z) {
      return x & y ^ ~x & z;
    }
    function Maj(x, y, z) {
      return x & y ^ x & z ^ y & z;
    }
    Sha512.prototype._update = function (M) {
      var W = this._w;
      var a, b, c, d, e, f, g, h;
      var al, bl, cl, dl, el, fl, gl, hl;
      a = this._a | 0;
      b = this._b | 0;
      c = this._c | 0;
      d = this._d | 0;
      e = this._e | 0;
      f = this._f | 0;
      g = this._g | 0;
      h = this._h | 0;
      al = this._al | 0;
      bl = this._bl | 0;
      cl = this._cl | 0;
      dl = this._dl | 0;
      el = this._el | 0;
      fl = this._fl | 0;
      gl = this._gl | 0;
      hl = this._hl | 0;
      for (var i = 0; i < 80; i++) {
        var j = i * 2;
        var Wi, Wil;
        if (i < 16) {
          Wi = W[j] = M.readInt32BE(j * 4);
          Wil = W[j + 1] = M.readInt32BE(j * 4 + 4);
        } else {
          var x = W[j - 15 * 2];
          var xl = W[j - 15 * 2 + 1];
          var gamma0 = S(x, xl, 1) ^ S(x, xl, 8) ^ x >>> 7;
          var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7);
          x = W[j - 2 * 2];
          xl = W[j - 2 * 2 + 1];
          var gamma1 = S(x, xl, 19) ^ S(xl, x, 29) ^ x >>> 6;
          var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6);

          // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
          var Wi7 = W[j - 7 * 2];
          var Wi7l = W[j - 7 * 2 + 1];
          var Wi16 = W[j - 16 * 2];
          var Wi16l = W[j - 16 * 2 + 1];
          Wil = gamma0l + Wi7l;
          Wi = gamma0 + Wi7 + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
          Wil = Wil + gamma1l;
          Wi = Wi + gamma1 + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
          Wil = Wil + Wi16l;
          Wi = Wi + Wi16 + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
          W[j] = Wi;
          W[j + 1] = Wil;
        }
        var maj = Maj(a, b, c);
        var majl = Maj(al, bl, cl);
        var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7);
        var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7);
        var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9);
        var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9);

        // t1 = h + sigma1 + ch + K[i] + W[i]
        var Ki = K[j];
        var Kil = K[j + 1];
        var ch = Ch(e, f, g);
        var chl = Ch(el, fl, gl);
        var t1l = hl + sigma1l;
        var t1 = h + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
        t1l = t1l + chl;
        t1 = t1 + ch + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
        t1l = t1l + Kil;
        t1 = t1 + Ki + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
        t1l = t1l + Wil;
        t1 = t1 + Wi + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);

        // t2 = sigma0 + maj
        var t2l = sigma0l + majl;
        var t2 = sigma0h + maj + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
        h = g;
        hl = gl;
        g = f;
        gl = fl;
        f = e;
        fl = el;
        el = dl + t1l | 0;
        e = d + t1 + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
        d = c;
        dl = cl;
        c = b;
        cl = bl;
        b = a;
        bl = al;
        al = t1l + t2l | 0;
        a = t1 + t2 + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
      }
      this._al = this._al + al | 0;
      this._bl = this._bl + bl | 0;
      this._cl = this._cl + cl | 0;
      this._dl = this._dl + dl | 0;
      this._el = this._el + el | 0;
      this._fl = this._fl + fl | 0;
      this._gl = this._gl + gl | 0;
      this._hl = this._hl + hl | 0;
      this._a = this._a + a + (this._al >>> 0 < al >>> 0 ? 1 : 0) | 0;
      this._b = this._b + b + (this._bl >>> 0 < bl >>> 0 ? 1 : 0) | 0;
      this._c = this._c + c + (this._cl >>> 0 < cl >>> 0 ? 1 : 0) | 0;
      this._d = this._d + d + (this._dl >>> 0 < dl >>> 0 ? 1 : 0) | 0;
      this._e = this._e + e + (this._el >>> 0 < el >>> 0 ? 1 : 0) | 0;
      this._f = this._f + f + (this._fl >>> 0 < fl >>> 0 ? 1 : 0) | 0;
      this._g = this._g + g + (this._gl >>> 0 < gl >>> 0 ? 1 : 0) | 0;
      this._h = this._h + h + (this._hl >>> 0 < hl >>> 0 ? 1 : 0) | 0;
    };
    Sha512.prototype._hash = function () {
      var H = new Buffer(64);
      function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
      }
      writeInt64BE(this._a, this._al, 0);
      writeInt64BE(this._b, this._bl, 8);
      writeInt64BE(this._c, this._cl, 16);
      writeInt64BE(this._d, this._dl, 24);
      writeInt64BE(this._e, this._el, 32);
      writeInt64BE(this._f, this._fl, 40);
      writeInt64BE(this._g, this._gl, 48);
      writeInt64BE(this._h, this._hl, 56);
      return H;
    };
    return Sha512;
  };

  /***/
}, /* 207 */
/***/function (module, exports, __webpack_require__) {
  /*
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for more info.
   */

  var helpers = __webpack_require__(208);

  /*
   * Calculate the MD5 of an array of little-endian words, and a bit length
   */
  function core_md5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for (var i = 0; i < x.length; i += 16) {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;
      a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
      a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
      a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
      a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }
    return Array(a, b, c, d);
  }

  /*
   * These functions implement the four basic operations the algorithm uses.
   */
  function md5_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
  }
  function md5_ff(a, b, c, d, x, s, t) {
    return md5_cmn(b & c | ~b & d, a, b, x, s, t);
  }
  function md5_gg(a, b, c, d, x, s, t) {
    return md5_cmn(b & d | c & ~d, a, b, x, s, t);
  }
  function md5_hh(a, b, c, d, x, s, t) {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
  }
  function md5_ii(a, b, c, d, x, s, t) {
    return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */
  function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  }

  /*
   * Bitwise rotate a 32-bit number to the left.
   */
  function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }
  module.exports = function md5(buf) {
    return helpers.hash(buf, core_md5, 16);
  };

  /***/
}, /* 208 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var intSize = 4;
    var zeroBuffer = new Buffer(intSize);
    zeroBuffer.fill(0);
    var chrsz = 8;
    function toArray(buf, bigEndian) {
      if (buf.length % intSize !== 0) {
        var len = buf.length + (intSize - buf.length % intSize);
        buf = Buffer.concat([buf, zeroBuffer], len);
      }
      var arr = [];
      var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
      for (var i = 0; i < buf.length; i += intSize) {
        arr.push(fn.call(buf, i));
      }
      return arr;
    }
    function toBuffer(arr, size, bigEndian) {
      var buf = new Buffer(size);
      var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
      for (var i = 0; i < arr.length; i++) {
        fn.call(buf, arr[i], i * 4, true);
      }
      return buf;
    }
    function hash(buf, fn, hashSize, bigEndian) {
      if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
      var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
      return toBuffer(arr, hashSize, bigEndian);
    }
    module.exports = {
      hash: hash
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 209 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    module.exports = ripemd160;

    /*
    CryptoJS v3.1.2
    code.google.com/p/crypto-js
    (c) 2009-2013 by Jeff Mott. All rights reserved.
    code.google.com/p/crypto-js/wiki/License
    */
    /** @preserve
    (c) 2012 by Cédric Mesnil. All rights reserved.
    
    Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
    
        - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
        - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
    
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
    */

    // Constants table
    var zl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
    var zr = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
    var sl = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
    var sr = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
    var hl = [0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
    var hr = [0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
    var bytesToWords = function bytesToWords(bytes) {
      var words = [];
      for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
        words[b >>> 5] |= bytes[i] << 24 - b % 32;
      }
      return words;
    };
    var wordsToBytes = function wordsToBytes(words) {
      var bytes = [];
      for (var b = 0; b < words.length * 32; b += 8) {
        bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
      }
      return bytes;
    };
    var processBlock = function processBlock(H, M, offset) {
      // Swap endian
      for (var i = 0; i < 16; i++) {
        var offset_i = offset + i;
        var M_offset_i = M[offset_i];

        // Swap
        M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
      }

      // Working variables
      var al, bl, cl, dl, el;
      var ar, br, cr, dr, er;
      ar = al = H[0];
      br = bl = H[1];
      cr = cl = H[2];
      dr = dl = H[3];
      er = el = H[4];
      // Computation
      var t;
      for (var i = 0; i < 80; i += 1) {
        t = al + M[offset + zl[i]] | 0;
        if (i < 16) {
          t += f1(bl, cl, dl) + hl[0];
        } else if (i < 32) {
          t += f2(bl, cl, dl) + hl[1];
        } else if (i < 48) {
          t += f3(bl, cl, dl) + hl[2];
        } else if (i < 64) {
          t += f4(bl, cl, dl) + hl[3];
        } else {
          // if (i<80) {
          t += f5(bl, cl, dl) + hl[4];
        }
        t = t | 0;
        t = rotl(t, sl[i]);
        t = t + el | 0;
        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = t;
        t = ar + M[offset + zr[i]] | 0;
        if (i < 16) {
          t += f5(br, cr, dr) + hr[0];
        } else if (i < 32) {
          t += f4(br, cr, dr) + hr[1];
        } else if (i < 48) {
          t += f3(br, cr, dr) + hr[2];
        } else if (i < 64) {
          t += f2(br, cr, dr) + hr[3];
        } else {
          // if (i<80) {
          t += f1(br, cr, dr) + hr[4];
        }
        t = t | 0;
        t = rotl(t, sr[i]);
        t = t + er | 0;
        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = t;
      }
      // Intermediate hash value
      t = H[1] + cl + dr | 0;
      H[1] = H[2] + dl + er | 0;
      H[2] = H[3] + el + ar | 0;
      H[3] = H[4] + al + br | 0;
      H[4] = H[0] + bl + cr | 0;
      H[0] = t;
    };
    function f1(x, y, z) {
      return x ^ y ^ z;
    }
    function f2(x, y, z) {
      return x & y | ~x & z;
    }
    function f3(x, y, z) {
      return (x | ~y) ^ z;
    }
    function f4(x, y, z) {
      return x & z | y & ~z;
    }
    function f5(x, y, z) {
      return x ^ (y | ~z);
    }
    function rotl(x, n) {
      return x << n | x >>> 32 - n;
    }
    function ripemd160(message) {
      var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
      if (typeof message == 'string') message = new Buffer(message, 'utf8');
      var m = bytesToWords(message);
      var nBitsLeft = message.length * 8;
      var nBitsTotal = message.length * 8;

      // Add padding
      m[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
      m[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
      for (var i = 0; i < m.length; i += 16) {
        processBlock(H, m, i);
      }

      // Swap endian
      for (var i = 0; i < 5; i++) {
        // Shortcut
        var H_i = H[i];

        // Swap
        H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
      }
      var digestbytes = wordsToBytes(H);
      return new Buffer(digestbytes);
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 210 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var createHash = __webpack_require__(198);
    var zeroBuffer = new Buffer(128);
    zeroBuffer.fill(0);
    module.exports = Hmac;
    function Hmac(alg, key) {
      if (!(this instanceof Hmac)) return new Hmac(alg, key);
      this._opad = opad;
      this._alg = alg;
      var blocksize = alg === 'sha512' ? 128 : 64;
      key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key;
      if (key.length > blocksize) {
        key = createHash(alg).update(key).digest();
      } else if (key.length < blocksize) {
        key = Buffer.concat([key, zeroBuffer], blocksize);
      }
      var ipad = this._ipad = new Buffer(blocksize);
      var opad = this._opad = new Buffer(blocksize);
      for (var i = 0; i < blocksize; i++) {
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
      }
      this._hash = createHash(alg).update(ipad);
    }
    Hmac.prototype.update = function (data, enc) {
      this._hash.update(data, enc);
      return this;
    };
    Hmac.prototype.digest = function (enc) {
      var h = this._hash.digest();
      return createHash(this._alg).update(this._opad).update(h).digest(enc);
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 211 */
/***/function (module, exports, __webpack_require__) {
  var pbkdf2Export = __webpack_require__(212);
  module.exports = function (crypto, exports) {
    exports = exports || {};
    var exported = pbkdf2Export(crypto);
    exports.pbkdf2 = exported.pbkdf2;
    exports.pbkdf2Sync = exported.pbkdf2Sync;
    return exports;
  };

  /***/
}, /* 212 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    module.exports = function (crypto) {
      function pbkdf2(password, salt, iterations, keylen, digest, callback) {
        if ('function' === typeof digest) {
          callback = digest;
          digest = undefined;
        }
        if ('function' !== typeof callback) throw new Error('No callback provided to pbkdf2');
        setTimeout(function () {
          var result;
          try {
            result = pbkdf2Sync(password, salt, iterations, keylen, digest);
          } catch (e) {
            return callback(e);
          }
          callback(undefined, result);
        });
      }
      function pbkdf2Sync(password, salt, iterations, keylen, digest) {
        if ('number' !== typeof iterations) throw new TypeError('Iterations not a number');
        if (iterations < 0) throw new TypeError('Bad iterations');
        if ('number' !== typeof keylen) throw new TypeError('Key length not a number');
        if (keylen < 0) throw new TypeError('Bad key length');
        digest = digest || 'sha1';
        if (!Buffer.isBuffer(password)) password = new Buffer(password);
        if (!Buffer.isBuffer(salt)) salt = new Buffer(salt);
        var hLen,
          l = 1,
          r,
          T;
        var DK = new Buffer(keylen);
        var block1 = new Buffer(salt.length + 4);
        salt.copy(block1, 0, 0, salt.length);
        for (var i = 1; i <= l; i++) {
          block1.writeUInt32BE(i, salt.length);
          var U = crypto.createHmac(digest, password).update(block1).digest();
          if (!hLen) {
            hLen = U.length;
            T = new Buffer(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
            if (keylen > (Math.pow(2, 32) - 1) * hLen) throw new TypeError('keylen exceeds maximum length');
          }
          U.copy(T, 0, 0, hLen);
          for (var j = 1; j < iterations; j++) {
            U = crypto.createHmac(digest, password).update(U).digest();
            for (var k = 0; k < hLen; k++) {
              T[k] ^= U[k];
            }
          }
          var destPos = (i - 1) * hLen;
          var len = i == l ? r : hLen;
          T.copy(DK, destPos, 0, len);
        }
        return DK;
      }
      return {
        pbkdf2: pbkdf2,
        pbkdf2Sync: pbkdf2Sync
      };
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 213 */
/***/function (module, exports, __webpack_require__) {
  module.exports = function (crypto, exports) {
    exports = exports || {};
    var ciphers = __webpack_require__(214)(crypto);
    exports.createCipher = ciphers.createCipher;
    exports.createCipheriv = ciphers.createCipheriv;
    var deciphers = __webpack_require__(247)(crypto);
    exports.createDecipher = deciphers.createDecipher;
    exports.createDecipheriv = deciphers.createDecipheriv;
    var modes = __webpack_require__(238);
    function listCiphers() {
      return Object.keys(modes);
    }
    exports.listCiphers = listCiphers;
  };

  /***/
}, /* 214 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var aes = __webpack_require__(215);
    var Transform = __webpack_require__(216);
    var inherits = __webpack_require__(204);
    var modes = __webpack_require__(238);
    var ebtk = __webpack_require__(239);
    var StreamCipher = __webpack_require__(240);
    inherits(Cipher, Transform);
    function Cipher(mode, key, iv) {
      if (!(this instanceof Cipher)) {
        return new Cipher(mode, key, iv);
      }
      Transform.call(this);
      this._cache = new Splitter();
      this._cipher = new aes.AES(key);
      this._prev = new Buffer(iv.length);
      iv.copy(this._prev);
      this._mode = mode;
    }
    Cipher.prototype._transform = function (data, _, next) {
      this._cache.add(data);
      var chunk;
      var thing;
      while (chunk = this._cache.get()) {
        thing = this._mode.encrypt(this, chunk);
        this.push(thing);
      }
      next();
    };
    Cipher.prototype._flush = function (next) {
      var chunk = this._cache.flush();
      this.push(this._mode.encrypt(this, chunk));
      this._cipher.scrub();
      next();
    };
    function Splitter() {
      if (!(this instanceof Splitter)) {
        return new Splitter();
      }
      this.cache = new Buffer('');
    }
    Splitter.prototype.add = function (data) {
      this.cache = Buffer.concat([this.cache, data]);
    };
    Splitter.prototype.get = function () {
      if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
      }
      return null;
    };
    Splitter.prototype.flush = function () {
      var len = 16 - this.cache.length;
      var padBuff = new Buffer(len);
      var i = -1;
      while (++i < len) {
        padBuff.writeUInt8(len, i);
      }
      var out = Buffer.concat([this.cache, padBuff]);
      return out;
    };
    var modelist = {
      ECB: __webpack_require__(241),
      CBC: __webpack_require__(242),
      CFB: __webpack_require__(244),
      OFB: __webpack_require__(245),
      CTR: __webpack_require__(246)
    };
    module.exports = function (crypto) {
      function createCipheriv(suite, password, iv) {
        var config = modes[suite];
        if (!config) {
          throw new TypeError('invalid suite type');
        }
        if (typeof iv === 'string') {
          iv = new Buffer(iv);
        }
        if (typeof password === 'string') {
          password = new Buffer(password);
        }
        if (password.length !== config.key / 8) {
          throw new TypeError('invalid key length ' + password.length);
        }
        if (iv.length !== config.iv) {
          throw new TypeError('invalid iv length ' + iv.length);
        }
        if (config.type === 'stream') {
          return new StreamCipher(modelist[config.mode], password, iv);
        }
        return new Cipher(modelist[config.mode], password, iv);
      }
      function createCipher(suite, password) {
        var config = modes[suite];
        if (!config) {
          throw new TypeError('invalid suite type');
        }
        var keys = ebtk(crypto, password, config.key, config.iv);
        return createCipheriv(suite, keys.key, keys.iv);
      }
      return {
        createCipher: createCipher,
        createCipheriv: createCipheriv
      };
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 215 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var uint_max = Math.pow(2, 32);
    function fixup_uint32(x) {
      var ret, x_pos;
      ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
      return ret;
    }
    function scrub_vec(v) {
      var i, _i, _ref;
      for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
        v[i] = 0;
      }
      return false;
    }
    function Global() {
      var i;
      this.SBOX = [];
      this.INV_SBOX = [];
      this.SUB_MIX = function () {
        var _i, _results;
        _results = [];
        for (i = _i = 0; _i < 4; i = ++_i) {
          _results.push([]);
        }
        return _results;
      }();
      this.INV_SUB_MIX = function () {
        var _i, _results;
        _results = [];
        for (i = _i = 0; _i < 4; i = ++_i) {
          _results.push([]);
        }
        return _results;
      }();
      this.init();
      this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    }
    Global.prototype.init = function () {
      var d, i, sx, t, x, x2, x4, x8, xi, _i;
      d = function () {
        var _i, _results;
        _results = [];
        for (i = _i = 0; _i < 256; i = ++_i) {
          if (i < 128) {
            _results.push(i << 1);
          } else {
            _results.push(i << 1 ^ 0x11b);
          }
        }
        return _results;
      }();
      x = 0;
      xi = 0;
      for (i = _i = 0; _i < 256; i = ++_i) {
        sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        this.SBOX[x] = sx;
        this.INV_SBOX[sx] = x;
        x2 = d[x];
        x4 = d[x2];
        x8 = d[x4];
        t = d[sx] * 0x101 ^ sx * 0x1010100;
        this.SUB_MIX[0][x] = t << 24 | t >>> 8;
        this.SUB_MIX[1][x] = t << 16 | t >>> 16;
        this.SUB_MIX[2][x] = t << 8 | t >>> 24;
        this.SUB_MIX[3][x] = t;
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        this.INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        this.INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        this.INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        this.INV_SUB_MIX[3][sx] = t;
        if (x === 0) {
          x = xi = 1;
        } else {
          x = x2 ^ d[d[d[x8 ^ x2]]];
          xi ^= d[d[xi]];
        }
      }
      return true;
    };
    var G = new Global();
    AES.blockSize = 4 * 4;
    AES.prototype.blockSize = AES.blockSize;
    AES.keySize = 256 / 8;
    AES.prototype.keySize = AES.keySize;
    AES.ivSize = AES.blockSize;
    AES.prototype.ivSize = AES.ivSize;
    function bufferToArray(buf) {
      var len = buf.length / 4;
      var out = new Array(len);
      var i = -1;
      while (++i < len) {
        out[i] = buf.readUInt32BE(i * 4);
      }
      return out;
    }
    function AES(key) {
      this._key = bufferToArray(key);
      this._doReset();
    }
    AES.prototype._doReset = function () {
      var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
      keyWords = this._key;
      keySize = keyWords.length;
      this._nRounds = keySize + 6;
      ksRows = (this._nRounds + 1) * 4;
      this._keySchedule = [];
      for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
        this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], ksRow % keySize === 0 ? (t = t << 8 | t >>> 24, t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff], t ^= G.RCON[ksRow / keySize | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
      }
      this._invKeySchedule = [];
      for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
        ksRow = ksRows - invKsRow;
        t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
        this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[t >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[t >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
      }
      return true;
    };
    AES.prototype.encryptBlock = function (M) {
      M = bufferToArray(new Buffer(M));
      var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
      var buf = new Buffer(16);
      buf.writeUInt32BE(out[0], 0);
      buf.writeUInt32BE(out[1], 4);
      buf.writeUInt32BE(out[2], 8);
      buf.writeUInt32BE(out[3], 12);
      return buf;
    };
    AES.prototype.decryptBlock = function (M) {
      M = bufferToArray(new Buffer(M));
      var temp = [M[3], M[1]];
      M[1] = temp[0];
      M[3] = temp[1];
      var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
      var buf = new Buffer(16);
      buf.writeUInt32BE(out[0], 0);
      buf.writeUInt32BE(out[3], 4);
      buf.writeUInt32BE(out[2], 8);
      buf.writeUInt32BE(out[1], 12);
      return buf;
    };
    AES.prototype.scrub = function () {
      scrub_vec(this._keySchedule);
      scrub_vec(this._invKeySchedule);
      scrub_vec(this._key);
    };
    AES.prototype._doCryptBlock = function (M, keySchedule, SUB_MIX, SBOX) {
      var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
      s0 = M[0] ^ keySchedule[0];
      s1 = M[1] ^ keySchedule[1];
      s2 = M[2] ^ keySchedule[2];
      s3 = M[3] ^ keySchedule[3];
      ksRow = 4;
      for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
        t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][s1 >>> 16 & 0xff] ^ SUB_MIX[2][s2 >>> 8 & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][s2 >>> 16 & 0xff] ^ SUB_MIX[2][s3 >>> 8 & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][s3 >>> 16 & 0xff] ^ SUB_MIX[2][s0 >>> 8 & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][s0 >>> 16 & 0xff] ^ SUB_MIX[2][s1 >>> 8 & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
      }
      t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
      t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
      t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
      t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
      return [fixup_uint32(t0), fixup_uint32(t1), fixup_uint32(t2), fixup_uint32(t3)];
    };
    exports.AES = AES;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 216 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var Transform = __webpack_require__(217).Transform;
    var inherits = __webpack_require__(204);
    module.exports = CipherBase;
    inherits(CipherBase, Transform);
    function CipherBase() {
      Transform.call(this);
    }
    CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
      this.write(data, inputEnd);
      var outData = new Buffer('');
      var chunk;
      while (chunk = this.read()) {
        outData = Buffer.concat([outData, chunk]);
      }
      if (outputEnc) {
        outData = outData.toString(outputEnc);
      }
      return outData;
    };
    CipherBase.prototype.final = function (outputEnc) {
      this.end();
      var outData = new Buffer('');
      var chunk;
      while (chunk = this.read()) {
        outData = Buffer.concat([outData, chunk]);
      }
      if (outputEnc) {
        outData = outData.toString(outputEnc);
      }
      return outData;
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 217 */
/***/function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  module.exports = Stream;
  var EE = __webpack_require__(44).EventEmitter;
  var inherits = __webpack_require__(204);
  inherits(Stream, EE);
  Stream.Readable = __webpack_require__(218);
  Stream.Writable = __webpack_require__(234);
  Stream.Duplex = __webpack_require__(235);
  Stream.Transform = __webpack_require__(236);
  Stream.PassThrough = __webpack_require__(237);

  // Backwards-compat with node 0.4.x
  Stream.Stream = Stream;

  // old-style streams.  Note that the pipe method (the only relevant
  // part of this class) is overridden in the Readable class.

  function Stream() {
    EE.call(this);
  }
  Stream.prototype.pipe = function (dest, options) {
    var source = this;
    function ondata(chunk) {
      if (dest.writable) {
        if (false === dest.write(chunk) && source.pause) {
          source.pause();
        }
      }
    }
    source.on('data', ondata);
    function ondrain() {
      if (source.readable && source.resume) {
        source.resume();
      }
    }
    dest.on('drain', ondrain);

    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
      source.on('end', onend);
      source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
      if (didOnEnd) return;
      didOnEnd = true;
      dest.end();
    }
    function onclose() {
      if (didOnEnd) return;
      didOnEnd = true;
      if (typeof dest.destroy === 'function') dest.destroy();
    }

    // don't leave dangling pipes when there are errors.
    function onerror(er) {
      cleanup();
      if (EE.listenerCount(this, 'error') === 0) {
        throw er; // Unhandled stream error in pipe.
      }
    }

    source.on('error', onerror);
    dest.on('error', onerror);

    // remove all the event listeners that were added.
    function cleanup() {
      source.removeListener('data', ondata);
      dest.removeListener('drain', ondrain);
      source.removeListener('end', onend);
      source.removeListener('close', onclose);
      source.removeListener('error', onerror);
      dest.removeListener('error', onerror);
      source.removeListener('end', cleanup);
      source.removeListener('close', cleanup);
      dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);

    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
  };

  /***/
}, /* 218 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(219);
  exports.Stream = exports;
  exports.Readable = exports;
  exports.Writable = __webpack_require__(229);
  exports.Duplex = __webpack_require__(228);
  exports.Transform = __webpack_require__(232);
  exports.PassThrough = __webpack_require__(233);

  /***/
}, /* 219 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, process) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    'use strict';

    /*<replacement>*/
    var pna = __webpack_require__(220);
    /*</replacement>*/

    module.exports = Readable;

    /*<replacement>*/
    var isArray = __webpack_require__(195);
    /*</replacement>*/

    /*<replacement>*/
    var Duplex;
    /*</replacement>*/

    Readable.ReadableState = ReadableState;

    /*<replacement>*/
    var EE = __webpack_require__(44).EventEmitter;
    var EElistenerCount = function EElistenerCount(emitter, type) {
      return emitter.listeners(type).length;
    };
    /*</replacement>*/

    /*<replacement>*/
    var Stream = __webpack_require__(221);
    /*</replacement>*/

    /*<replacement>*/

    var Buffer = __webpack_require__(222).Buffer;
    var OurUint8Array = global.Uint8Array || function () {};
    function _uint8ArrayToBuffer(chunk) {
      return Buffer.from(chunk);
    }
    function _isUint8Array(obj) {
      return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    }

    /*</replacement>*/

    /*<replacement>*/
    var util = __webpack_require__(223);
    util.inherits = __webpack_require__(204);
    /*</replacement>*/

    /*<replacement>*/
    var debugUtil = __webpack_require__(224);
    var debug = void 0;
    if (debugUtil && debugUtil.debuglog) {
      debug = debugUtil.debuglog('stream');
    } else {
      debug = function debug() {};
    }
    /*</replacement>*/

    var BufferList = __webpack_require__(225);
    var destroyImpl = __webpack_require__(227);
    var StringDecoder;
    util.inherits(Readable, Stream);
    var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
    function prependListener(emitter, event, fn) {
      // Sadly this is not cacheable as some libraries bundle their own
      // event emitter implementation with them.
      if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

      // This is a hack to make sure that our error handler is attached before any
      // userland ones.  NEVER DO THIS. This is here only because this code needs
      // to continue to work with older versions of Node.js that do not include
      // the prependListener() method. The goal is to eventually remove this hack.
      if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
    }
    function ReadableState(options, stream) {
      Duplex = Duplex || __webpack_require__(228);
      options = options || {};

      // Duplex streams are both readable and writable, but share
      // the same options object.
      // However, some cases require setting options to different
      // values for the readable and the writable sides of the duplex stream.
      // These options can be provided separately as readableXXX and writableXXX.
      var isDuplex = stream instanceof Duplex;

      // object stream flag. Used to make read(n) ignore n and to
      // make all the buffer merging and length checks go away
      this.objectMode = !!options.objectMode;
      if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

      // the point at which it stops calling _read() to fill the buffer
      // Note: 0 is a valid value, means "don't call _read preemptively ever"
      var hwm = options.highWaterMark;
      var readableHwm = options.readableHighWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

      // cast to ints.
      this.highWaterMark = Math.floor(this.highWaterMark);

      // A linked list is used to store data chunks instead of an array because the
      // linked list can remove elements from the beginning faster than
      // array.shift()
      this.buffer = new BufferList();
      this.length = 0;
      this.pipes = null;
      this.pipesCount = 0;
      this.flowing = null;
      this.ended = false;
      this.endEmitted = false;
      this.reading = false;

      // a flag to be able to tell if the event 'readable'/'data' is emitted
      // immediately, or on a later tick.  We set this to true at first, because
      // any actions that shouldn't happen until "later" should generally also
      // not happen before the first read call.
      this.sync = true;

      // whenever we return null, then we set a flag to say
      // that we're awaiting a 'readable' event emission.
      this.needReadable = false;
      this.emittedReadable = false;
      this.readableListening = false;
      this.resumeScheduled = false;

      // has it been destroyed
      this.destroyed = false;

      // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.
      this.defaultEncoding = options.defaultEncoding || 'utf8';

      // the number of writers that are awaiting a drain event in .pipe()s
      this.awaitDrain = 0;

      // if true, a maybeReadMore has been scheduled
      this.readingMore = false;
      this.decoder = null;
      this.encoding = null;
      if (options.encoding) {
        if (!StringDecoder) StringDecoder = __webpack_require__(231).StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
      }
    }
    function Readable(options) {
      Duplex = Duplex || __webpack_require__(228);
      if (!(this instanceof Readable)) return new Readable(options);
      this._readableState = new ReadableState(options, this);

      // legacy
      this.readable = true;
      if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
      }
      Stream.call(this);
    }
    Object.defineProperty(Readable.prototype, 'destroyed', {
      get: function get() {
        if (this._readableState === undefined) {
          return false;
        }
        return this._readableState.destroyed;
      },
      set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) {
          return;
        }

        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
      }
    });
    Readable.prototype.destroy = destroyImpl.destroy;
    Readable.prototype._undestroy = destroyImpl.undestroy;
    Readable.prototype._destroy = function (err, cb) {
      this.push(null);
      cb(err);
    };

    // Manually shove something into the read() buffer.
    // This returns true if the highWaterMark has not been hit yet,
    // similar to how Writable.write() returns true if you should
    // write() some more.
    Readable.prototype.push = function (chunk, encoding) {
      var state = this._readableState;
      var skipChunkCheck;
      if (!state.objectMode) {
        if (typeof chunk === 'string') {
          encoding = encoding || state.defaultEncoding;
          if (encoding !== state.encoding) {
            chunk = Buffer.from(chunk, encoding);
            encoding = '';
          }
          skipChunkCheck = true;
        }
      } else {
        skipChunkCheck = true;
      }
      return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };

    // Unshift should *always* be something directly out of read()
    Readable.prototype.unshift = function (chunk) {
      return readableAddChunk(this, chunk, null, true, false);
    };
    function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
      var state = stream._readableState;
      if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
      } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) {
          stream.emit('error', er);
        } else if (state.objectMode || chunk && chunk.length > 0) {
          if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
            chunk = _uint8ArrayToBuffer(chunk);
          }
          if (addToFront) {
            if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
          } else if (state.ended) {
            stream.emit('error', new Error('stream.push() after EOF'));
          } else {
            state.reading = false;
            if (state.decoder && !encoding) {
              chunk = state.decoder.write(chunk);
              if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
            } else {
              addChunk(stream, state, chunk, false);
            }
          }
        } else if (!addToFront) {
          state.reading = false;
        }
      }
      return needMoreData(state);
    }
    function addChunk(stream, state, chunk, addToFront) {
      if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
      } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
      }
      maybeReadMore(stream, state);
    }
    function chunkInvalid(state, chunk) {
      var er;
      if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }
      return er;
    }

    // if it's past the high water mark, we can push in some more.
    // Also, if we have no data yet, we can stand some
    // more bytes.  This is to work around cases where hwm=0,
    // such as the repl.  Also, if the push() triggered a
    // readable event, and the user called read(largeNumber) such that
    // needReadable was set, then we ought to push more, so that another
    // 'readable' event will be triggered.
    function needMoreData(state) {
      return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }
    Readable.prototype.isPaused = function () {
      return this._readableState.flowing === false;
    };

    // backwards compatibility.
    Readable.prototype.setEncoding = function (enc) {
      if (!StringDecoder) StringDecoder = __webpack_require__(231).StringDecoder;
      this._readableState.decoder = new StringDecoder(enc);
      this._readableState.encoding = enc;
      return this;
    };

    // Don't raise the hwm > 8MB
    var MAX_HWM = 0x800000;
    function computeNewHighWaterMark(n) {
      if (n >= MAX_HWM) {
        n = MAX_HWM;
      } else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
      }
      return n;
    }

    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function howMuchToRead(n, state) {
      if (n <= 0 || state.length === 0 && state.ended) return 0;
      if (state.objectMode) return 1;
      if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
      }
      // If we're asking for more than the current hwm, then raise the hwm.
      if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
      if (n <= state.length) return n;
      // Don't have enough
      if (!state.ended) {
        state.needReadable = true;
        return 0;
      }
      return state.length;
    }

    // you can override either this method, or the async _read(n) below.
    Readable.prototype.read = function (n) {
      debug('read', n);
      n = parseInt(n, 10);
      var state = this._readableState;
      var nOrig = n;
      if (n !== 0) state.emittedReadable = false;

      // if we're doing read(0) to trigger a readable event, but we
      // already have a bunch of data in the buffer, then just trigger
      // the 'readable' event and move on.
      if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
        return null;
      }
      n = howMuchToRead(n, state);

      // if we've ended, and we're now clear, then finish it up.
      if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
      }

      // All the actual chunk generation logic needs to be
      // *below* the call to _read.  The reason is that in certain
      // synthetic stream cases, such as passthrough streams, _read
      // may be a completely synchronous operation which may change
      // the state of the read buffer, providing enough data when
      // before there was *not* enough.
      //
      // So, the steps are:
      // 1. Figure out what the state of things will be after we do
      // a read from the buffer.
      //
      // 2. If that resulting state will trigger a _read, then call _read.
      // Note that this may be asynchronous, or synchronous.  Yes, it is
      // deeply ugly to write APIs this way, but that still doesn't mean
      // that the Readable class should behave improperly, as streams are
      // designed to be sync/async agnostic.
      // Take note if the _read call is sync or async (ie, if the read call
      // has returned yet), so that we know whether or not it's safe to emit
      // 'readable' etc.
      //
      // 3. Actually pull the requested chunks out of the buffer and return.

      // if we need a readable event, then we need to do some reading.
      var doRead = state.needReadable;
      debug('need readable', doRead);

      // if we currently have less than the highWaterMark, then also read some
      if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
      }

      // however, if we've ended, then there's no point, and if we're already
      // reading, then it's unnecessary.
      if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
      } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
      }
      var ret;
      if (n > 0) ret = fromList(n, state);else ret = null;
      if (ret === null) {
        state.needReadable = true;
        n = 0;
      } else {
        state.length -= n;
      }
      if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;

        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
      }
      if (ret !== null) this.emit('data', ret);
      return ret;
    };
    function onEofChunk(stream, state) {
      if (state.ended) return;
      if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
          state.buffer.push(chunk);
          state.length += state.objectMode ? 1 : chunk.length;
        }
      }
      state.ended = true;

      // emit 'readable' now to make sure it gets picked up.
      emitReadable(stream);
    }

    // Don't emit readable right away in sync mode, because this can trigger
    // another read() call => stack overflow.  This way, it might trigger
    // a nextTick recursion warning, but that's not so bad.
    function emitReadable(stream) {
      var state = stream._readableState;
      state.needReadable = false;
      if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
      }
    }
    function emitReadable_(stream) {
      debug('emit readable');
      stream.emit('readable');
      flow(stream);
    }

    // at this point, the user has presumably seen the 'readable' event,
    // and called read() to consume some data.  that may have triggered
    // in turn another _read(n) call, in which case reading = true if
    // it's in progress.
    // However, if we're not ended, or reading, and the length < hwm,
    // then go ahead and try to read some more preemptively.
    function maybeReadMore(stream, state) {
      if (!state.readingMore) {
        state.readingMore = true;
        pna.nextTick(maybeReadMore_, stream, state);
      }
    }
    function maybeReadMore_(stream, state) {
      var len = state.length;
      while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length)
          // didn't get any data, stop spinning.
          break;else len = state.length;
      }
      state.readingMore = false;
    }

    // abstract method.  to be overridden in specific implementation classes.
    // call cb(er, data) where data is <= n in length.
    // for virtual (non-string, non-buffer) streams, "length" is somewhat
    // arbitrary, and perhaps not very meaningful.
    Readable.prototype._read = function (n) {
      this.emit('error', new Error('_read() is not implemented'));
    };
    Readable.prototype.pipe = function (dest, pipeOpts) {
      var src = this;
      var state = this._readableState;
      switch (state.pipesCount) {
        case 0:
          state.pipes = dest;
          break;
        case 1:
          state.pipes = [state.pipes, dest];
          break;
        default:
          state.pipes.push(dest);
          break;
      }
      state.pipesCount += 1;
      debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
      var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
      var endFn = doEnd ? onend : unpipe;
      if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
      dest.on('unpipe', onunpipe);
      function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');
        if (readable === src) {
          if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
            unpipeInfo.hasUnpiped = true;
            cleanup();
          }
        }
      }
      function onend() {
        debug('onend');
        dest.end();
      }

      // when the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.
      var ondrain = pipeOnDrain(src);
      dest.on('drain', ondrain);
      var cleanedUp = false;
      function cleanup() {
        debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;

        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
      }

      // If the user pushes more data while we're writing to dest then we'll end up
      // in ondata again. However, we only want to increase awaitDrain once because
      // dest will only emit one 'drain' event for the multiple writes.
      // => Introduce a guard on increasing awaitDrain.
      var increasedAwaitDrain = false;
      src.on('data', ondata);
      function ondata(chunk) {
        debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
          // If the user unpiped during `dest.write()`, it is possible
          // to get stuck in a permanently paused state if that write
          // also returned false.
          // => Check whether `dest` is still a piping destination.
          if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
            debug('false write response, pause', src._readableState.awaitDrain);
            src._readableState.awaitDrain++;
            increasedAwaitDrain = true;
          }
          src.pause();
        }
      }

      // if the dest has an error, then stop piping into it.
      // however, don't suppress the throwing behavior for this.
      function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
      }

      // Make sure our error handler is attached before userland ones.
      prependListener(dest, 'error', onerror);

      // Both close and finish should trigger unpipe, but only once.
      function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
      }
      dest.once('close', onclose);
      function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
      }
      dest.once('finish', onfinish);
      function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
      }

      // tell the dest that it's being piped to
      dest.emit('pipe', src);

      // start the flow if it hasn't been started already.
      if (!state.flowing) {
        debug('pipe resume');
        src.resume();
      }
      return dest;
    };
    function pipeOnDrain(src) {
      return function () {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
          state.flowing = true;
          flow(src);
        }
      };
    }
    Readable.prototype.unpipe = function (dest) {
      var state = this._readableState;
      var unpipeInfo = {
        hasUnpiped: false
      };

      // if we're not piping anywhere, then do nothing.
      if (state.pipesCount === 0) return this;

      // just one destination.  most common case.
      if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;

        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
      }

      // slow case. multiple pipe destinations.

      if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for (var i = 0; i < len; i++) {
          dests[i].emit('unpipe', this, unpipeInfo);
        }
        return this;
      }

      // try to find the right one.
      var index = indexOf(state.pipes, dest);
      if (index === -1) return this;
      state.pipes.splice(index, 1);
      state.pipesCount -= 1;
      if (state.pipesCount === 1) state.pipes = state.pipes[0];
      dest.emit('unpipe', this, unpipeInfo);
      return this;
    };

    // set up data events if they are asked for
    // Ensure readable listeners eventually get something
    Readable.prototype.on = function (ev, fn) {
      var res = Stream.prototype.on.call(this, ev, fn);
      if (ev === 'data') {
        // Start flowing on next tick if stream isn't explicitly paused
        if (this._readableState.flowing !== false) this.resume();
      } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
          state.readableListening = state.needReadable = true;
          state.emittedReadable = false;
          if (!state.reading) {
            pna.nextTick(nReadingNextTick, this);
          } else if (state.length) {
            emitReadable(this);
          }
        }
      }
      return res;
    };
    Readable.prototype.addListener = Readable.prototype.on;
    function nReadingNextTick(self) {
      debug('readable nexttick read 0');
      self.read(0);
    }

    // pause() and resume() are remnants of the legacy readable stream API
    // If the user uses them, then switch into old mode.
    Readable.prototype.resume = function () {
      var state = this._readableState;
      if (!state.flowing) {
        debug('resume');
        state.flowing = true;
        resume(this, state);
      }
      return this;
    };
    function resume(stream, state) {
      if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        pna.nextTick(resume_, stream, state);
      }
    }
    function resume_(stream, state) {
      if (!state.reading) {
        debug('resume read 0');
        stream.read(0);
      }
      state.resumeScheduled = false;
      state.awaitDrain = 0;
      stream.emit('resume');
      flow(stream);
      if (state.flowing && !state.reading) stream.read(0);
    }
    Readable.prototype.pause = function () {
      debug('call pause flowing=%j', this._readableState.flowing);
      if (false !== this._readableState.flowing) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
      }
      return this;
    };
    function flow(stream) {
      var state = stream._readableState;
      debug('flow', state.flowing);
      while (state.flowing && stream.read() !== null) {}
    }

    // wrap an old-style stream as the async data source.
    // This is *not* part of the readable stream interface.
    // It is an ugly unfortunate mess of history.
    Readable.prototype.wrap = function (stream) {
      var _this = this;
      var state = this._readableState;
      var paused = false;
      stream.on('end', function () {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
          var chunk = state.decoder.end();
          if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
      });
      stream.on('data', function (chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);

        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
          paused = true;
          stream.pause();
        }
      });

      // proxy all the other methods.
      // important when wrapping filters and duplexes.
      for (var i in stream) {
        if (this[i] === undefined && typeof stream[i] === 'function') {
          this[i] = function (method) {
            return function () {
              return stream[method].apply(stream, arguments);
            };
          }(i);
        }
      }

      // proxy certain important events.
      for (var n = 0; n < kProxyEvents.length; n++) {
        stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
      }

      // when we try to consume some more bytes, simply unpause the
      // underlying stream.
      this._read = function (n) {
        debug('wrapped _read', n);
        if (paused) {
          paused = false;
          stream.resume();
        }
      };
      return this;
    };
    Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: false,
      get: function get() {
        return this._readableState.highWaterMark;
      }
    });

    // exposed for testing purposes only.
    Readable._fromList = fromList;

    // Pluck off n bytes from an array of buffers.
    // Length is the combined lengths of all the buffers in the list.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromList(n, state) {
      // nothing buffered
      if (state.length === 0) return null;
      var ret;
      if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
        state.buffer.clear();
      } else {
        // read part of list
        ret = fromListPartial(n, state.buffer, state.decoder);
      }
      return ret;
    }

    // Extracts only enough buffered data to satisfy the amount requested.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromListPartial(n, list, hasStrings) {
      var ret;
      if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
      } else if (n === list.head.data.length) {
        // first chunk is a perfect match
        ret = list.shift();
      } else {
        // result spans more than one buffer
        ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
      }
      return ret;
    }

    // Copies a specified amount of characters from the list of buffered data
    // chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBufferString(n, list) {
      var p = list.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      list.length -= c;
      return ret;
    }

    // Copies a specified amount of bytes from the list of buffered data chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBuffer(n, list) {
      var ret = Buffer.allocUnsafe(n);
      var p = list.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      list.length -= c;
      return ret;
    }
    function endReadable(stream) {
      var state = stream._readableState;

      // If we get here before consuming all the bytes, then that is a
      // bug in node.  Should never happen.
      if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
      if (!state.endEmitted) {
        state.ended = true;
        pna.nextTick(endReadableNT, state, stream);
      }
    }
    function endReadableNT(state, stream) {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    }
    function indexOf(xs, x) {
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) return i;
      }
      return -1;
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }(), __webpack_require__(2));

  /***/
}, /* 220 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    'use strict';

    if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
      module.exports = {
        nextTick: nextTick
      };
    } else {
      module.exports = process;
    }
    function nextTick(fn, arg1, arg2, arg3) {
      if (typeof fn !== 'function') {
        throw new TypeError('"callback" argument must be a function');
      }
      var len = arguments.length;
      var args, i;
      switch (len) {
        case 0:
        case 1:
          return process.nextTick(fn);
        case 2:
          return process.nextTick(function afterTickOne() {
            fn.call(null, arg1);
          });
        case 3:
          return process.nextTick(function afterTickTwo() {
            fn.call(null, arg1, arg2);
          });
        case 4:
          return process.nextTick(function afterTickThree() {
            fn.call(null, arg1, arg2, arg3);
          });
        default:
          args = new Array(len - 1);
          i = 0;
          while (i < args.length) {
            args[i++] = arguments[i];
          }
          return process.nextTick(function afterTick() {
            fn.apply(null, args);
          });
      }
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2));

  /***/
}, /* 221 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(44).EventEmitter;

  /***/
}, /* 222 */
/***/function (module, exports, __webpack_require__) {
  /* eslint-disable node/no-deprecated-api */
  var buffer = __webpack_require__(192);
  var Buffer = buffer.Buffer;

  // alternative to using Object.keys for old browsers
  function copyProps(src, dst) {
    for (var key in src) {
      dst[key] = src[key];
    }
  }
  if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
    module.exports = buffer;
  } else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
  }
  function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
  }

  // Copy static methods from Buffer
  copyProps(Buffer, SafeBuffer);
  SafeBuffer.from = function (arg, encodingOrOffset, length) {
    if (typeof arg === 'number') {
      throw new TypeError('Argument must not be a number');
    }
    return Buffer(arg, encodingOrOffset, length);
  };
  SafeBuffer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }
    var buf = Buffer(size);
    if (fill !== undefined) {
      if (typeof encoding === 'string') {
        buf.fill(fill, encoding);
      } else {
        buf.fill(fill);
      }
    } else {
      buf.fill(0);
    }
    return buf;
  };
  SafeBuffer.allocUnsafe = function (size) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }
    return Buffer(size);
  };
  SafeBuffer.allocUnsafeSlow = function (size) {
    if (typeof size !== 'number') {
      throw new TypeError('Argument must be a number');
    }
    return buffer.SlowBuffer(size);
  };

  /***/
}, /* 223 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.

    function isArray(arg) {
      if (Array.isArray) {
        return Array.isArray(arg);
      }
      return objectToString(arg) === '[object Array]';
    }
    exports.isArray = isArray;
    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }
    exports.isBoolean = isBoolean;
    function isNull(arg) {
      return arg === null;
    }
    exports.isNull = isNull;
    function isNullOrUndefined(arg) {
      return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
      return typeof arg === 'number';
    }
    exports.isNumber = isNumber;
    function isString(arg) {
      return typeof arg === 'string';
    }
    exports.isString = isString;
    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }
    exports.isSymbol = isSymbol;
    function isUndefined(arg) {
      return arg === void 0;
    }
    exports.isUndefined = isUndefined;
    function isRegExp(re) {
      return objectToString(re) === '[object RegExp]';
    }
    exports.isRegExp = isRegExp;
    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }
    exports.isObject = isObject;
    function isDate(d) {
      return objectToString(d) === '[object Date]';
    }
    exports.isDate = isDate;
    function isError(e) {
      return objectToString(e) === '[object Error]' || e instanceof Error;
    }
    exports.isError = isError;
    function isFunction(arg) {
      return typeof arg === 'function';
    }
    exports.isFunction = isFunction;
    function isPrimitive(arg) {
      return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' ||
      // ES6 symbol
      typeof arg === 'undefined';
    }
    exports.isPrimitive = isPrimitive;
    exports.isBuffer = Buffer.isBuffer;
    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 224 */
/***/function (module, exports) {

  /* (ignored) */

  /***/}, /* 225 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Buffer = __webpack_require__(222).Buffer;
  var util = __webpack_require__(226);
  function copyBuffer(src, target, offset) {
    src.copy(target, offset);
  }
  module.exports = function () {
    function BufferList() {
      _classCallCheck(this, BufferList);
      this.head = null;
      this.tail = null;
      this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    };
    BufferList.prototype.shift = function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    };
    BufferList.prototype.clear = function clear() {
      this.head = this.tail = null;
      this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) {
        ret += s + p.data;
      }
      return ret;
    };
    BufferList.prototype.concat = function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      if (this.length === 1) return this.head.data;
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    };
    return BufferList;
  }();
  if (util && util.inspect && util.inspect.custom) {
    module.exports.prototype[util.inspect.custom] = function () {
      var obj = util.inspect({
        length: this.length
      });
      return this.constructor.name + ' ' + obj;
    };
  }

  /***/
}, /* 226 */
/***/function (module, exports) {

  /* (ignored) */

  /***/}, /* 227 */
/***/function (module, exports, __webpack_require__) {
  'use strict';

  /*<replacement>*/
  var pna = __webpack_require__(220);
  /*</replacement>*/

  // undocumented cb() API, needed for core, not for public API
  function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
      if (cb) {
        cb(err);
      } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
        pna.nextTick(emitErrorNT, this, err);
      }
      return this;
    }

    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks

    if (this._readableState) {
      this._readableState.destroyed = true;
    }

    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) {
      this._writableState.destroyed = true;
    }
    this._destroy(err || null, function (err) {
      if (!cb && err) {
        pna.nextTick(emitErrorNT, _this, err);
        if (_this._writableState) {
          _this._writableState.errorEmitted = true;
        }
      } else if (cb) {
        cb(err);
      }
    });
    return this;
  }
  function undestroy() {
    if (this._readableState) {
      this._readableState.destroyed = false;
      this._readableState.reading = false;
      this._readableState.ended = false;
      this._readableState.endEmitted = false;
    }
    if (this._writableState) {
      this._writableState.destroyed = false;
      this._writableState.ended = false;
      this._writableState.ending = false;
      this._writableState.finished = false;
      this._writableState.errorEmitted = false;
    }
  }
  function emitErrorNT(self, err) {
    self.emit('error', err);
  }
  module.exports = {
    destroy: destroy,
    undestroy: undestroy
  };

  /***/
}, /* 228 */
/***/function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  // a duplex stream is just a stream that is both readable and writable.
  // Since JS doesn't have multiple prototypal inheritance, this class
  // prototypally inherits from Readable, and then parasitically from
  // Writable.

  'use strict';

  /*<replacement>*/
  var pna = __webpack_require__(220);
  /*</replacement>*/

  /*<replacement>*/
  var objectKeys = Object.keys || function (obj) {
    var keys = [];
    for (var key in obj) {
      keys.push(key);
    }
    return keys;
  };
  /*</replacement>*/

  module.exports = Duplex;

  /*<replacement>*/
  var util = __webpack_require__(223);
  util.inherits = __webpack_require__(204);
  /*</replacement>*/

  var Readable = __webpack_require__(219);
  var Writable = __webpack_require__(229);
  util.inherits(Duplex, Readable);
  {
    // avoid scope creep, the keys array can then be collected
    var keys = objectKeys(Writable.prototype);
    for (var v = 0; v < keys.length; v++) {
      var method = keys[v];
      if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
  }
  function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', onend);
  }
  Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.highWaterMark;
    }
  });

  // the no-half-open enforcer
  function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;

    // no more data can be written.
    // But allow more writes to happen in this tick.
    pna.nextTick(onEndNT, this);
  }
  function onEndNT(self) {
    self.end();
  }
  Object.defineProperty(Duplex.prototype, 'destroyed', {
    get: function get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false;
      }
      return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
      // we ignore the value if the stream
      // has not been initialized yet
      if (this._readableState === undefined || this._writableState === undefined) {
        return;
      }

      // backward compatibility, the user is explicitly
      // managing destroyed
      this._readableState.destroyed = value;
      this._writableState.destroyed = value;
    }
  });
  Duplex.prototype._destroy = function (err, cb) {
    this.push(null);
    this.end();
    pna.nextTick(cb, err);
  };

  /***/
}, /* 229 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process, setImmediate, global) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    // A bit simpler than readable streams.
    // Implement an async ._write(chunk, encoding, cb), and it'll handle all
    // the drain event emission and buffering.

    'use strict';

    /*<replacement>*/
    var pna = __webpack_require__(220);
    /*</replacement>*/

    module.exports = Writable;

    /* <replacement> */
    function WriteReq(chunk, encoding, cb) {
      this.chunk = chunk;
      this.encoding = encoding;
      this.callback = cb;
      this.next = null;
    }

    // It seems a linked list but it is not
    // there will be only 2 of these for each stream
    function CorkedRequest(state) {
      var _this = this;
      this.next = null;
      this.entry = null;
      this.finish = function () {
        onCorkedFinish(_this, state);
      };
    }
    /* </replacement> */

    /*<replacement>*/
    var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
    /*</replacement>*/

    /*<replacement>*/
    var Duplex;
    /*</replacement>*/

    Writable.WritableState = WritableState;

    /*<replacement>*/
    var util = __webpack_require__(223);
    util.inherits = __webpack_require__(204);
    /*</replacement>*/

    /*<replacement>*/
    var internalUtil = {
      deprecate: __webpack_require__(230)
    };
    /*</replacement>*/

    /*<replacement>*/
    var Stream = __webpack_require__(221);
    /*</replacement>*/

    /*<replacement>*/

    var Buffer = __webpack_require__(222).Buffer;
    var OurUint8Array = global.Uint8Array || function () {};
    function _uint8ArrayToBuffer(chunk) {
      return Buffer.from(chunk);
    }
    function _isUint8Array(obj) {
      return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    }

    /*</replacement>*/

    var destroyImpl = __webpack_require__(227);
    util.inherits(Writable, Stream);
    function nop() {}
    function WritableState(options, stream) {
      Duplex = Duplex || __webpack_require__(228);
      options = options || {};

      // Duplex streams are both readable and writable, but share
      // the same options object.
      // However, some cases require setting options to different
      // values for the readable and the writable sides of the duplex stream.
      // These options can be provided separately as readableXXX and writableXXX.
      var isDuplex = stream instanceof Duplex;

      // object stream flag to indicate whether or not this stream
      // contains buffers or objects.
      this.objectMode = !!options.objectMode;
      if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

      // the point at which write() starts returning false
      // Note: 0 is a valid value, means that we always return false if
      // the entire buffer is not flushed immediately on write()
      var hwm = options.highWaterMark;
      var writableHwm = options.writableHighWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

      // cast to ints.
      this.highWaterMark = Math.floor(this.highWaterMark);

      // if _final has been called
      this.finalCalled = false;

      // drain event flag.
      this.needDrain = false;
      // at the start of calling end()
      this.ending = false;
      // when end() has been called, and returned
      this.ended = false;
      // when 'finish' is emitted
      this.finished = false;

      // has it been destroyed
      this.destroyed = false;

      // should we decode strings into buffers before passing to _write?
      // this is here so that some node-core streams can optimize string
      // handling at a lower level.
      var noDecode = options.decodeStrings === false;
      this.decodeStrings = !noDecode;

      // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.
      this.defaultEncoding = options.defaultEncoding || 'utf8';

      // not an actual buffer we keep track of, but a measurement
      // of how much we're waiting to get pushed to some underlying
      // socket or file.
      this.length = 0;

      // a flag to see when we're in the middle of a write.
      this.writing = false;

      // when true all writes will be buffered until .uncork() call
      this.corked = 0;

      // a flag to be able to tell if the onwrite cb is called immediately,
      // or on a later tick.  We set this to true at first, because any
      // actions that shouldn't happen until "later" should generally also
      // not happen before the first write call.
      this.sync = true;

      // a flag to know if we're processing previously buffered items, which
      // may call the _write() callback in the same tick, so that we don't
      // end up in an overlapped onwrite situation.
      this.bufferProcessing = false;

      // the callback that's passed to _write(chunk,cb)
      this.onwrite = function (er) {
        onwrite(stream, er);
      };

      // the callback that the user supplies to write(chunk,encoding,cb)
      this.writecb = null;

      // the amount that is being written when _write is called.
      this.writelen = 0;
      this.bufferedRequest = null;
      this.lastBufferedRequest = null;

      // number of pending user-supplied write callbacks
      // this must be 0 before 'finish' can be emitted
      this.pendingcb = 0;

      // emit prefinish if the only thing we're waiting for is _write cbs
      // This is relevant for synchronous Transform streams
      this.prefinished = false;

      // True if the error was already emitted and should not be thrown again
      this.errorEmitted = false;

      // count buffered requests
      this.bufferedRequestCount = 0;

      // allocate the first CorkedRequest, there is always
      // one allocated and free to use, and we maintain at most two
      this.corkedRequestsFree = new CorkedRequest(this);
    }
    WritableState.prototype.getBuffer = function getBuffer() {
      var current = this.bufferedRequest;
      var out = [];
      while (current) {
        out.push(current);
        current = current.next;
      }
      return out;
    };
    (function () {
      try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
          get: internalUtil.deprecate(function () {
            return this.getBuffer();
          }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
        });
      } catch (_) {}
    })();

    // Test _writableState for inheritance to account for Duplex streams,
    // whose prototype chain only points to Readable.
    var realHasInstance;
    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
      realHasInstance = Function.prototype[Symbol.hasInstance];
      Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
          if (realHasInstance.call(this, object)) return true;
          if (this !== Writable) return false;
          return object && object._writableState instanceof WritableState;
        }
      });
    } else {
      realHasInstance = function realHasInstance(object) {
        return object instanceof this;
      };
    }
    function Writable(options) {
      Duplex = Duplex || __webpack_require__(228);

      // Writable ctor is applied to Duplexes, too.
      // `realHasInstance` is necessary because using plain `instanceof`
      // would return false, as no `_writableState` property is attached.

      // Trying to use the custom `instanceof` for Writable here will also break the
      // Node.js LazyTransform implementation, which has a non-trivial getter for
      // `_writableState` that would lead to infinite recursion.
      if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
        return new Writable(options);
      }
      this._writableState = new WritableState(options, this);

      // legacy.
      this.writable = true;
      if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
      }
      Stream.call(this);
    }

    // Otherwise people can pipe Writable streams, which is just wrong.
    Writable.prototype.pipe = function () {
      this.emit('error', new Error('Cannot pipe, not readable'));
    };
    function writeAfterEnd(stream, cb) {
      var er = new Error('write after end');
      // TODO: defer error events consistently everywhere, not just the cb
      stream.emit('error', er);
      pna.nextTick(cb, er);
    }

    // Checks that a user-supplied chunk is valid, especially for the particular
    // mode the stream is in. Currently this means that `null` is never accepted
    // and undefined/non-string values are only allowed in object mode.
    function validChunk(stream, state, chunk, cb) {
      var valid = true;
      var er = false;
      if (chunk === null) {
        er = new TypeError('May not write null values to stream');
      } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }
      if (er) {
        stream.emit('error', er);
        pna.nextTick(cb, er);
        valid = false;
      }
      return valid;
    }
    Writable.prototype.write = function (chunk, encoding, cb) {
      var state = this._writableState;
      var ret = false;
      var isBuf = !state.objectMode && _isUint8Array(chunk);
      if (isBuf && !Buffer.isBuffer(chunk)) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }
      if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
      if (typeof cb !== 'function') cb = nop;
      if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
      }
      return ret;
    };
    Writable.prototype.cork = function () {
      var state = this._writableState;
      state.corked++;
    };
    Writable.prototype.uncork = function () {
      var state = this._writableState;
      if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
      }
    };
    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
      // node::ParseEncoding() requires lower case.
      if (typeof encoding === 'string') encoding = encoding.toLowerCase();
      if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
      this._writableState.defaultEncoding = encoding;
      return this;
    };
    function decodeChunk(state, chunk, encoding) {
      if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
        chunk = Buffer.from(chunk, encoding);
      }
      return chunk;
    }
    Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: false,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    });

    // if we're already writing something, then just put this
    // in the queue, and wait our turn.  Otherwise, call _write
    // If we return false, then we need a drain event, so set that flag.
    function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
      if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
          isBuf = true;
          encoding = 'buffer';
          chunk = newChunk;
        }
      }
      var len = state.objectMode ? 1 : chunk.length;
      state.length += len;
      var ret = state.length < state.highWaterMark;
      // we must ensure that previous needDrain will not be reset to false.
      if (!ret) state.needDrain = true;
      if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
          chunk: chunk,
          encoding: encoding,
          isBuf: isBuf,
          callback: cb,
          next: null
        };
        if (last) {
          last.next = state.lastBufferedRequest;
        } else {
          state.bufferedRequest = state.lastBufferedRequest;
        }
        state.bufferedRequestCount += 1;
      } else {
        doWrite(stream, state, false, len, chunk, encoding, cb);
      }
      return ret;
    }
    function doWrite(stream, state, writev, len, chunk, encoding, cb) {
      state.writelen = len;
      state.writecb = cb;
      state.writing = true;
      state.sync = true;
      if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
      state.sync = false;
    }
    function onwriteError(stream, state, sync, er, cb) {
      --state.pendingcb;
      if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        pna.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        pna.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
      } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
      }
    }
    function onwriteStateUpdate(state) {
      state.writing = false;
      state.writecb = null;
      state.length -= state.writelen;
      state.writelen = 0;
    }
    function onwrite(stream, er) {
      var state = stream._writableState;
      var sync = state.sync;
      var cb = state.writecb;
      onwriteStateUpdate(state);
      if (er) onwriteError(stream, state, sync, er, cb);else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
          clearBuffer(stream, state);
        }
        if (sync) {
          /*<replacement>*/
          asyncWrite(afterWrite, stream, state, finished, cb);
          /*</replacement>*/
        } else {
          afterWrite(stream, state, finished, cb);
        }
      }
    }
    function afterWrite(stream, state, finished, cb) {
      if (!finished) onwriteDrain(stream, state);
      state.pendingcb--;
      cb();
      finishMaybe(stream, state);
    }

    // Must force callback to be called on nextTick, so that we don't
    // emit 'drain' before the write() consumer gets the 'false' return
    // value, and has a chance to attach a 'drain' listener.
    function onwriteDrain(stream, state) {
      if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
      }
    }

    // if there's something in the buffer waiting, then process it
    function clearBuffer(stream, state) {
      state.bufferProcessing = true;
      var entry = state.bufferedRequest;
      if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while (entry) {
          buffer[count] = entry;
          if (!entry.isBuf) allBuffers = false;
          entry = entry.next;
          count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish);

        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
          state.corkedRequestsFree = holder.next;
          holder.next = null;
        } else {
          state.corkedRequestsFree = new CorkedRequest(state);
        }
        state.bufferedRequestCount = 0;
      } else {
        // Slow case, write chunks one-by-one
        while (entry) {
          var chunk = entry.chunk;
          var encoding = entry.encoding;
          var cb = entry.callback;
          var len = state.objectMode ? 1 : chunk.length;
          doWrite(stream, state, false, len, chunk, encoding, cb);
          entry = entry.next;
          state.bufferedRequestCount--;
          // if we didn't call the onwrite immediately, then
          // it means that we need to wait until it does.
          // also, that means that the chunk and cb are currently
          // being processed, so move the buffer counter past them.
          if (state.writing) {
            break;
          }
        }
        if (entry === null) state.lastBufferedRequest = null;
      }
      state.bufferedRequest = entry;
      state.bufferProcessing = false;
    }
    Writable.prototype._write = function (chunk, encoding, cb) {
      cb(new Error('_write() is not implemented'));
    };
    Writable.prototype._writev = null;
    Writable.prototype.end = function (chunk, encoding, cb) {
      var state = this._writableState;
      if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
      } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }
      if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

      // .end() fully uncorks
      if (state.corked) {
        state.corked = 1;
        this.uncork();
      }

      // ignore unnecessary end() calls.
      if (!state.ending && !state.finished) endWritable(this, state, cb);
    };
    function needFinish(state) {
      return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function callFinal(stream, state) {
      stream._final(function (err) {
        state.pendingcb--;
        if (err) {
          stream.emit('error', err);
        }
        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
      });
    }
    function prefinish(stream, state) {
      if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
          state.pendingcb++;
          state.finalCalled = true;
          pna.nextTick(callFinal, stream, state);
        } else {
          state.prefinished = true;
          stream.emit('prefinish');
        }
      }
    }
    function finishMaybe(stream, state) {
      var need = needFinish(state);
      if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
          state.finished = true;
          stream.emit('finish');
        }
      }
      return need;
    }
    function endWritable(stream, state, cb) {
      state.ending = true;
      finishMaybe(stream, state);
      if (cb) {
        if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
      }
      state.ended = true;
      stream.writable = false;
    }
    function onCorkedFinish(corkReq, state, err) {
      var entry = corkReq.entry;
      corkReq.entry = null;
      while (entry) {
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
      }
      if (state.corkedRequestsFree) {
        state.corkedRequestsFree.next = corkReq;
      } else {
        state.corkedRequestsFree = corkReq;
      }
    }
    Object.defineProperty(Writable.prototype, 'destroyed', {
      get: function get() {
        if (this._writableState === undefined) {
          return false;
        }
        return this._writableState.destroyed;
      },
      set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) {
          return;
        }

        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
      }
    });
    Writable.prototype.destroy = destroyImpl.destroy;
    Writable.prototype._undestroy = destroyImpl.undestroy;
    Writable.prototype._destroy = function (err, cb) {
      this.end();
      cb(err);
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(2), __webpack_require__(11).setImmediate, function () {
    return this;
  }());

  /***/
}, /* 230 */
/***/function (module, exports) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /**
     * Module exports.
     */

    module.exports = deprecate;

    /**
     * Mark that a method should not be used.
     * Returns a modified function which warns once by default.
     *
     * If `localStorage.noDeprecation = true` is set, then it is a no-op.
     *
     * If `localStorage.throwDeprecation = true` is set, then deprecated functions
     * will throw an Error when invoked.
     *
     * If `localStorage.traceDeprecation = true` is set, then deprecated functions
     * will invoke `console.trace()` instead of `console.error()`.
     *
     * @param {Function} fn - the function to deprecate
     * @param {String} msg - the string to print to the console when `fn` is invoked
     * @returns {Function} a new "deprecated" version of `fn`
     * @api public
     */

    function deprecate(fn, msg) {
      if (config('noDeprecation')) {
        return fn;
      }
      var warned = false;
      function deprecated() {
        if (!warned) {
          if (config('throwDeprecation')) {
            throw new Error(msg);
          } else if (config('traceDeprecation')) {
            console.trace(msg);
          } else {
            console.warn(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }
      return deprecated;
    }

    /**
     * Checks `localStorage` for boolean values for the given `name`.
     *
     * @param {String} name
     * @returns {Boolean}
     * @api private
     */

    function config(name) {
      // accessing global.localStorage can trigger a DOMException in sandboxed iframes
      try {
        if (!global.localStorage) return false;
      } catch (_) {
        return false;
      }
      var val = global.localStorage[name];
      if (null == val) return false;
      return String(val).toLowerCase() === 'true';
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, function () {
    return this;
  }());

  /***/
}, /* 231 */
/***/function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  'use strict';

  /*<replacement>*/
  var Buffer = __webpack_require__(222).Buffer;
  /*</replacement>*/

  var isEncoding = Buffer.isEncoding || function (encoding) {
    encoding = '' + encoding;
    switch (encoding && encoding.toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
      case 'raw':
        return true;
      default:
        return false;
    }
  };
  function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while (true) {
      switch (enc) {
        case 'utf8':
        case 'utf-8':
          return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return 'utf16le';
        case 'latin1':
        case 'binary':
          return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
          return enc;
        default:
          if (retried) return; // undefined
          enc = ('' + enc).toLowerCase();
          retried = true;
      }
    }
  }
  ;

  // Do not cache `Buffer.isEncoding` when checking encoding names as some
  // modules monkey-patch it to support additional encodings
  function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
  }

  // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters.
  exports.StringDecoder = StringDecoder;
  function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch (this.encoding) {
      case 'utf16le':
        this.text = utf16Text;
        this.end = utf16End;
        nb = 4;
        break;
      case 'utf8':
        this.fillLast = utf8FillLast;
        nb = 4;
        break;
      case 'base64':
        this.text = base64Text;
        this.end = base64End;
        nb = 3;
        break;
      default:
        this.write = simpleWrite;
        this.end = simpleEnd;
        return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
  }
  StringDecoder.prototype.write = function (buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
      r = this.fillLast(buf);
      if (r === undefined) return '';
      i = this.lastNeed;
      this.lastNeed = 0;
    } else {
      i = 0;
    }
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
  };
  StringDecoder.prototype.end = utf8End;

  // Returns only complete characters in a Buffer
  StringDecoder.prototype.text = utf8Text;

  // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
  StringDecoder.prototype.fillLast = function (buf) {
    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
  };

  // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
  // continuation byte. If an invalid byte is detected, -2 is returned.
  function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
  }

  // Checks at most 3 bytes at the end of a Buffer in order to detect an
  // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
  // needed to complete the UTF-8 character (if applicable) are returned.
  function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 1;
      return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 2;
      return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
      if (nb > 0) {
        if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
      }
      return nb;
    }
    return 0;
  }

  // Validates as many continuation bytes for a multi-byte UTF-8 character as
  // needed or are available. If we see a non-continuation byte where we expect
  // one, we "replace" the validated continuation bytes we've seen so far with
  // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
  // behavior. The continuation byte check is included three times in the case
  // where all of the continuation bytes for a character exist in the same buffer.
  // It is also done this way as a slight performance increase instead of using a
  // loop.
  function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
      self.lastNeed = 0;
      return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
      if ((buf[1] & 0xC0) !== 0x80) {
        self.lastNeed = 1;
        return "\uFFFD";
      }
      if (self.lastNeed > 2 && buf.length > 2) {
        if ((buf[2] & 0xC0) !== 0x80) {
          self.lastNeed = 2;
          return "\uFFFD";
        }
      }
    }
  }

  // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
  function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, p, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
  }

  // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
  // partial character, the character's bytes are buffered until the required
  // number of bytes are available.
  function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
  }

  // For UTF-8, a replacement character is added when ending on a partial
  // character.
  function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + "\uFFFD";
    return r;
  }

  // UTF-16LE typically needs two bytes per character, but even if we have an even
  // number of bytes available, we need to check if we end on a leading/high
  // surrogate. In that case, we need to wait for the next two bytes in order to
  // decode the last character properly.
  function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
      var r = buf.toString('utf16le', i);
      if (r) {
        var c = r.charCodeAt(r.length - 1);
        if (c >= 0xD800 && c <= 0xDBFF) {
          this.lastNeed = 2;
          this.lastTotal = 4;
          this.lastChar[0] = buf[buf.length - 2];
          this.lastChar[1] = buf[buf.length - 1];
          return r.slice(0, -1);
        }
      }
      return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
  }

  // For UTF-16LE we do not explicitly append special replacement characters if we
  // end on a partial character, we simply let v8 handle that.
  function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
      var end = this.lastTotal - this.lastNeed;
      return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
  }
  function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) {
      this.lastChar[0] = buf[buf.length - 1];
    } else {
      this.lastChar[0] = buf[buf.length - 2];
      this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
  }
  function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
  }

  // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
  function simpleWrite(buf) {
    return buf.toString(this.encoding);
  }
  function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
  }

  /***/
}, /* 232 */
/***/function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  // a transform stream is a readable/writable stream where you do
  // something with the data.  Sometimes it's called a "filter",
  // but that's not a great name for it, since that implies a thing where
  // some bits pass through, and others are simply ignored.  (That would
  // be a valid example of a transform, of course.)
  //
  // While the output is causally related to the input, it's not a
  // necessarily symmetric or synchronous transformation.  For example,
  // a zlib stream might take multiple plain-text writes(), and then
  // emit a single compressed chunk some time in the future.
  //
  // Here's how this works:
  //
  // The Transform stream has all the aspects of the readable and writable
  // stream classes.  When you write(chunk), that calls _write(chunk,cb)
  // internally, and returns false if there's a lot of pending writes
  // buffered up.  When you call read(), that calls _read(n) until
  // there's enough pending readable data buffered up.
  //
  // In a transform stream, the written data is placed in a buffer.  When
  // _read(n) is called, it transforms the queued up data, calling the
  // buffered _write cb's as it consumes chunks.  If consuming a single
  // written chunk would result in multiple output chunks, then the first
  // outputted bit calls the readcb, and subsequent chunks just go into
  // the read buffer, and will cause it to emit 'readable' if necessary.
  //
  // This way, back-pressure is actually determined by the reading side,
  // since _read has to be called to start processing a new chunk.  However,
  // a pathological inflate type of transform can cause excessive buffering
  // here.  For example, imagine a stream where every byte of input is
  // interpreted as an integer from 0-255, and then results in that many
  // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
  // 1kb of data being output.  In this case, you could write a very small
  // amount of input, and end up with a very large amount of output.  In
  // such a pathological inflating mechanism, there'd be no way to tell
  // the system to stop doing the transform.  A single 4MB write could
  // cause the system to run out of memory.
  //
  // However, even in such a pathological case, only a single written chunk
  // would be consumed, and then the rest would wait (un-transformed) until
  // the results of the previous transformed chunk were consumed.

  'use strict';

  module.exports = Transform;
  var Duplex = __webpack_require__(228);

  /*<replacement>*/
  var util = __webpack_require__(223);
  util.inherits = __webpack_require__(204);
  /*</replacement>*/

  util.inherits(Transform, Duplex);
  function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) {
      return this.emit('error', new Error('write callback called multiple times'));
    }
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null)
      // single equals check for both `null` and `undefined`
      this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) {
      this._read(rs.highWaterMark);
    }
  }
  function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
      afterTransform: afterTransform.bind(this),
      needTransform: false,
      transforming: false,
      writecb: null,
      writechunk: null,
      writeencoding: null
    };

    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;

    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;
      if (typeof options.flush === 'function') this._flush = options.flush;
    }

    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', prefinish);
  }
  function prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') {
      this._flush(function (er, data) {
        done(_this, er, data);
      });
    } else {
      done(this, null, null);
    }
  }
  Transform.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
  };

  // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.
  Transform.prototype._transform = function (chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
  };
  Transform.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  };

  // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.
  Transform.prototype._read = function (n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
      ts.transforming = true;
      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };
  Transform.prototype._destroy = function (err, cb) {
    var _this2 = this;
    Duplex.prototype._destroy.call(this, err, function (err2) {
      cb(err2);
      _this2.emit('close');
    });
  };
  function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null)
      // single equals check for both `null` and `undefined`
      stream.push(data);

    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
  }

  /***/
}, /* 233 */
/***/function (module, exports, __webpack_require__) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.

  // a passthrough stream.
  // basically just the most minimal sort of Transform stream.
  // Every written chunk gets output as-is.

  'use strict';

  module.exports = PassThrough;
  var Transform = __webpack_require__(232);

  /*<replacement>*/
  var util = __webpack_require__(223);
  util.inherits = __webpack_require__(204);
  /*</replacement>*/

  util.inherits(PassThrough, Transform);
  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
  }
  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };

  /***/
}, /* 234 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(229);

  /***/
}, /* 235 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(228);

  /***/
}, /* 236 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(218).Transform;

  /***/
}, /* 237 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(218).PassThrough;

  /***/
}, /* 238 */
/***/function (module, exports) {
  exports['aes-128-ecb'] = {
    cipher: 'AES',
    key: 128,
    iv: 0,
    mode: 'ECB',
    type: 'block'
  };
  exports['aes-192-ecb'] = {
    cipher: 'AES',
    key: 192,
    iv: 0,
    mode: 'ECB',
    type: 'block'
  };
  exports['aes-256-ecb'] = {
    cipher: 'AES',
    key: 256,
    iv: 0,
    mode: 'ECB',
    type: 'block'
  };
  exports['aes-128-cbc'] = {
    cipher: 'AES',
    key: 128,
    iv: 16,
    mode: 'CBC',
    type: 'block'
  };
  exports['aes-192-cbc'] = {
    cipher: 'AES',
    key: 192,
    iv: 16,
    mode: 'CBC',
    type: 'block'
  };
  exports['aes-256-cbc'] = {
    cipher: 'AES',
    key: 256,
    iv: 16,
    mode: 'CBC',
    type: 'block'
  };
  exports['aes128'] = exports['aes-128-cbc'];
  exports['aes192'] = exports['aes-192-cbc'];
  exports['aes256'] = exports['aes-256-cbc'];
  exports['aes-128-cfb'] = {
    cipher: 'AES',
    key: 128,
    iv: 16,
    mode: 'CFB',
    type: 'stream'
  };
  exports['aes-192-cfb'] = {
    cipher: 'AES',
    key: 192,
    iv: 16,
    mode: 'CFB',
    type: 'stream'
  };
  exports['aes-256-cfb'] = {
    cipher: 'AES',
    key: 256,
    iv: 16,
    mode: 'CFB',
    type: 'stream'
  };
  exports['aes-128-ofb'] = {
    cipher: 'AES',
    key: 128,
    iv: 16,
    mode: 'OFB',
    type: 'stream'
  };
  exports['aes-192-ofb'] = {
    cipher: 'AES',
    key: 192,
    iv: 16,
    mode: 'OFB',
    type: 'stream'
  };
  exports['aes-256-ofb'] = {
    cipher: 'AES',
    key: 256,
    iv: 16,
    mode: 'OFB',
    type: 'stream'
  };
  exports['aes-128-ctr'] = {
    cipher: 'AES',
    key: 128,
    iv: 16,
    mode: 'CTR',
    type: 'stream'
  };
  exports['aes-192-ctr'] = {
    cipher: 'AES',
    key: 192,
    iv: 16,
    mode: 'CTR',
    type: 'stream'
  };
  exports['aes-256-ctr'] = {
    cipher: 'AES',
    key: 256,
    iv: 16,
    mode: 'CTR',
    type: 'stream'
  };

  /***/
}, /* 239 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    module.exports = function (crypto, password, keyLen, ivLen) {
      keyLen = keyLen / 8;
      ivLen = ivLen || 0;
      var ki = 0;
      var ii = 0;
      var key = new Buffer(keyLen);
      var iv = new Buffer(ivLen);
      var addmd = 0;
      var md, md_buf;
      var i;
      while (true) {
        md = crypto.createHash('md5');
        if (addmd++ > 0) {
          md.update(md_buf);
        }
        md.update(password);
        md_buf = md.digest();
        i = 0;
        if (keyLen > 0) {
          while (true) {
            if (keyLen === 0) {
              break;
            }
            if (i === md_buf.length) {
              break;
            }
            key[ki++] = md_buf[i];
            keyLen--;
            i++;
          }
        }
        if (ivLen > 0 && i !== md_buf.length) {
          while (true) {
            if (ivLen === 0) {
              break;
            }
            if (i === md_buf.length) {
              break;
            }
            iv[ii++] = md_buf[i];
            ivLen--;
            i++;
          }
        }
        if (keyLen === 0 && ivLen === 0) {
          break;
        }
      }
      for (i = 0; i < md_buf.length; i++) {
        md_buf[i] = 0;
      }
      return {
        key: key,
        iv: iv
      };
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 240 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var aes = __webpack_require__(215);
    var Transform = __webpack_require__(216);
    var inherits = __webpack_require__(204);
    inherits(StreamCipher, Transform);
    module.exports = StreamCipher;
    function StreamCipher(mode, key, iv, decrypt) {
      if (!(this instanceof StreamCipher)) {
        return new StreamCipher(mode, key, iv);
      }
      Transform.call(this);
      this._cipher = new aes.AES(key);
      this._prev = new Buffer(iv.length);
      this._cache = new Buffer('');
      this._secCache = new Buffer('');
      this._decrypt = decrypt;
      iv.copy(this._prev);
      this._mode = mode;
    }
    StreamCipher.prototype._transform = function (chunk, _, next) {
      next(null, this._mode.encrypt(this, chunk, this._decrypt));
    };
    StreamCipher.prototype._flush = function (next) {
      this._cipher.scrub();
      next();
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 241 */
/***/function (module, exports) {
  exports.encrypt = function (self, block) {
    return self._cipher.encryptBlock(block);
  };
  exports.decrypt = function (self, block) {
    return self._cipher.decryptBlock(block);
  };

  /***/
}, /* 242 */
/***/function (module, exports, __webpack_require__) {
  var xor = __webpack_require__(243);
  exports.encrypt = function (self, block) {
    var data = xor(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
  };
  exports.decrypt = function (self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return xor(out, pad);
  };

  /***/
}, /* 243 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    module.exports = xor;
    function xor(a, b) {
      var len = Math.min(a.length, b.length);
      var out = new Buffer(len);
      var i = -1;
      while (++i < len) {
        out.writeUInt8(a[i] ^ b[i], i);
      }
      return out;
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 244 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var xor = __webpack_require__(243);
    exports.encrypt = function (self, data, decrypt) {
      var out = new Buffer('');
      var len;
      while (data.length) {
        if (self._cache.length === 0) {
          self._cache = self._cipher.encryptBlock(self._prev);
          self._prev = new Buffer('');
        }
        if (self._cache.length <= data.length) {
          len = self._cache.length;
          out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
          data = data.slice(len);
        } else {
          out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
          break;
        }
      }
      return out;
    };
    function encryptStart(self, data, decrypt) {
      var len = data.length;
      var out = xor(data, self._cache);
      self._cache = self._cache.slice(len);
      self._prev = Buffer.concat([self._prev, decrypt ? data : out]);
      return out;
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 245 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var xor = __webpack_require__(243);
    function getBlock(self) {
      self._prev = self._cipher.encryptBlock(self._prev);
      return self._prev;
    }
    exports.encrypt = function (self, chunk) {
      while (self._cache.length < chunk.length) {
        self._cache = Buffer.concat([self._cache, getBlock(self)]);
      }
      var pad = self._cache.slice(0, chunk.length);
      self._cache = self._cache.slice(chunk.length);
      return xor(chunk, pad);
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 246 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var xor = __webpack_require__(243);
    function getBlock(self) {
      var out = self._cipher.encryptBlock(self._prev);
      incr32(self._prev);
      return out;
    }
    exports.encrypt = function (self, chunk) {
      while (self._cache.length < chunk.length) {
        self._cache = Buffer.concat([self._cache, getBlock(self)]);
      }
      var pad = self._cache.slice(0, chunk.length);
      self._cache = self._cache.slice(chunk.length);
      return xor(chunk, pad);
    };
    function incr32(iv) {
      var len = iv.length;
      var item;
      while (len--) {
        item = iv.readUInt8(len);
        if (item === 255) {
          iv.writeUInt8(0, len);
        } else {
          item++;
          iv.writeUInt8(item, len);
          break;
        }
      }
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 247 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (Buffer) {
    var aes = __webpack_require__(215);
    var Transform = __webpack_require__(216);
    var inherits = __webpack_require__(204);
    var modes = __webpack_require__(238);
    var StreamCipher = __webpack_require__(240);
    var ebtk = __webpack_require__(239);
    inherits(Decipher, Transform);
    function Decipher(mode, key, iv) {
      if (!(this instanceof Decipher)) {
        return new Decipher(mode, key, iv);
      }
      Transform.call(this);
      this._cache = new Splitter();
      this._last = void 0;
      this._cipher = new aes.AES(key);
      this._prev = new Buffer(iv.length);
      iv.copy(this._prev);
      this._mode = mode;
    }
    Decipher.prototype._transform = function (data, _, next) {
      this._cache.add(data);
      var chunk;
      var thing;
      while (chunk = this._cache.get()) {
        thing = this._mode.decrypt(this, chunk);
        this.push(thing);
      }
      next();
    };
    Decipher.prototype._flush = function (next) {
      var chunk = this._cache.flush();
      if (!chunk) {
        return next;
      }
      this.push(unpad(this._mode.decrypt(this, chunk)));
      next();
    };
    function Splitter() {
      if (!(this instanceof Splitter)) {
        return new Splitter();
      }
      this.cache = new Buffer('');
    }
    Splitter.prototype.add = function (data) {
      this.cache = Buffer.concat([this.cache, data]);
    };
    Splitter.prototype.get = function () {
      if (this.cache.length > 16) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
      }
      return null;
    };
    Splitter.prototype.flush = function () {
      if (this.cache.length) {
        return this.cache;
      }
    };
    function unpad(last) {
      var padded = last[15];
      if (padded === 16) {
        return;
      }
      return last.slice(0, 16 - padded);
    }
    var modelist = {
      ECB: __webpack_require__(241),
      CBC: __webpack_require__(242),
      CFB: __webpack_require__(244),
      OFB: __webpack_require__(245),
      CTR: __webpack_require__(246)
    };
    module.exports = function (crypto) {
      function createDecipheriv(suite, password, iv) {
        var config = modes[suite];
        if (!config) {
          throw new TypeError('invalid suite type');
        }
        if (typeof iv === 'string') {
          iv = new Buffer(iv);
        }
        if (typeof password === 'string') {
          password = new Buffer(password);
        }
        if (password.length !== config.key / 8) {
          throw new TypeError('invalid key length ' + password.length);
        }
        if (iv.length !== config.iv) {
          throw new TypeError('invalid iv length ' + iv.length);
        }
        if (config.type === 'stream') {
          return new StreamCipher(modelist[config.mode], password, iv, true);
        }
        return new Decipher(modelist[config.mode], password, iv);
      }
      function createDecipher(suite, password) {
        var config = modes[suite];
        if (!config) {
          throw new TypeError('invalid suite type');
        }
        var keys = ebtk(crypto, password, config.key, config.iv);
        return createDecipheriv(suite, keys.key, keys.iv);
      }
      return {
        createDecipher: createDecipher,
        createDecipheriv: createDecipheriv
      };
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(192).Buffer);

  /***/
}, /* 248 */
/***/function (module, exports, __webpack_require__) {
  var v1 = __webpack_require__(249);
  var v4 = __webpack_require__(252);
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  module.exports = uuid;

  /***/
}, /* 249 */
/***/function (module, exports, __webpack_require__) {
  var rng = __webpack_require__(250);
  var bytesToUuid = __webpack_require__(251);

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  var _nodeId;
  var _clockseq;

  // Previous uuid creation time
  var _lastMSecs = 0;
  var _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
      var seedBytes = rng();
      if (node == null) {
        // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
      }
      if (clockseq == null) {
        // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
      }
    }

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    for (var n = 0; n < 6; ++n) {
      b[i + n] = node[n];
    }
    return buf ? buf : bytesToUuid(b);
  }
  module.exports = v1;

  /***/
}, /* 250 */
/***/function (module, exports) {
  // Unique ID creation requires a high quality random # generator.  In the
  // browser this is a little complicated due to unknown quality of Math.random()
  // and inconsistent support for the `crypto` API.  We do the best we can via
  // feature-detection

  // getRandomValues needs to be invoked in a context where "this" is a Crypto
  // implementation. Also, find the complete implementation of crypto on IE11.
  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
  if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

    module.exports = function whatwgRNG() {
      getRandomValues(rnds8);
      return rnds8;
    };
  } else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }
      return rnds;
    };
  }

  /***/
}, /* 251 */
/***/function (module, exports) {
  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];
  for (var i = 0; i < 256; ++i) {
    byteToHex[i] = (i + 0x100).toString(16).substr(1);
  }
  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
  }
  module.exports = bytesToUuid;

  /***/
}, /* 252 */
/***/function (module, exports, __webpack_require__) {
  var rng = __webpack_require__(250);
  var bytesToUuid = __webpack_require__(251);
  function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
      buf = options === 'binary' ? new Array(16) : null;
      options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i + ii] = rnds[ii];
      }
    }
    return buf || bytesToUuid(rnds);
  }
  module.exports = v4;

  /***/
}
/******/]);